(function () {
  'use strict';

  angular
  .module('intryFrontEnd', [
    'ngMask',
    'ngAnimate',
    'ngMaterial',
    'ngDialog',
    'froala',
    'ngCookies',
    'ngTouch',
    'ngSanitize',
    'ngMessages',
    'ngAria',
    'ui.router',
    'ui.bootstrap',
    'toastr',
    'angular-flash.service',
    'angular-flash.flash-alert-directive',
    'ui.select',
    'ngFileUpload',
    'ui.tinymce',
    'rzModule',
    'validation',
    'validation.rule',
    '720kb.datepicker',
    'ngStorage',
    'smart-table',
    'ui.bootstrap.contextMenu',
    'pascalprecht.translate',
    'ngCroppie',
    'nzTour',
    'angularCroppie',
    angularDragula(angular),
    'moment-picker'
  ]);
})();

(function() {
  'use strict';

  angular
  .module('intryFrontEnd')
  .directive('resumes', ResumesDirective);

  /** @ngInject */
  function ResumesDirective() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/common/directive/widgets/resumes/resumes.html',
    };

    return directive;
  }

})();
(function() {
  'use strict';

  angular
  .module('intryFrontEnd')
  .directive('opportunities', OpportunitiesDirective);

  /** @ngInject */
  function OpportunitiesDirective() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/common/directive/widgets/opportunities/opportunities.html',
    };

    return directive;
  }

})();
(function() {
  'use strict';

  angular
  .module('intryFrontEnd')
  .directive('myProfile', MyProfileDirective);

  /** @ngInject */
  function MyProfileDirective() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/common/directive/widgets/myProfile/myprofile.html',
    };

    return directive;
  }

})();
(function() {
  'use strict';

  angular
  .module('intryFrontEnd')
  .directive('assessments', AssessmentsDirective);

  /** @ngInject */
  function AssessmentsDirective() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/common/directive/widgets/assessments/assessments.html',
    };

    return directive;
  }

})();
(function() {
  'use strict';

  angular
  .module('intryFrontEnd')
  .directive('ad', AssessmentsDirective);

  /** @ngInject */
  function AssessmentsDirective() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/common/directive/widgets/ad/ad.html',
    };

    return directive;
  }

})();
/* global Intercom */
(function () {
    'use strict';

    angular
        .module('intryFrontEnd')
        .controller('PayWallController', PayWallController);

    /** @ngInject */
    function PayWallController($scope, userService,organizationService, $filter, $location, $translate, ngDialog,StripeElements, toastr, $rootScope, $window, $localStorage, $state, constants, billingService) {
        $scope.promoCode = '';
        
        // IMPORTANT: This is an override to force paywall to use the registration form
        // $state.go('register');
        // return;
        $scope.getOrganizationCss2 = function (css, returnEmpty) {
            if (css === "Current Plan") {
                // return 'current-plan';
                return organizationService.getOrganizationCss('current-plan', returnEmpty);
            } else {
                // return 'subscribe-plan-container';
                return organizationService.getOrganizationCss('subscribe-plan-container', returnEmpty);
            }

            
            
        };
        var handleError = function (error) {
            $scope.cardErrorsModal = typeof error !== 'string' ? error.message : error;
            $scope.loadingData = false;
            $scope.loaderModal = false;
            $scope.processingCard = false;
            $rootScope.loadingInProcess = false;
            if(error !== $translate.instant('USER_PROFILE_CARD_NAME_REQUIRED_MESSAGE') && error !== $translate.instant('USER_PROFILE_BILLING_REQUIRED_MESSAGE')){
                if ($scope.error) {
                    $scope.error({error: $scope.cardErrorsModal});
                }
            } else {
                if ($scope.error) {
                    $scope.error({error: $scope.cardErrorsModal});
                }
            }
            buildToastr(error, 'Warning');
        };
        window.scroll(0,0);
        $scope.isPromoApplied = false;
        $scope.isPromoValid = true;
        $scope.isExpired = false;
        $scope.nextCharge = 0;
        $scope.plans = [];
        $scope.bundles = [];
        $scope.copyBundles = [];
        $scope.years = [];
        $scope.months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
        $scope.savings = '';
        $scope.savingsAmount = 0;
        $scope.brand = '';
        $scope.backButtonText ='Take Me to assesment';
        $scope.PayWallController = this;
        var subscriptionActive = false; 
        
        userService.getUser(true).then(function (user) {
            resetSteps();                           
            $scope.user = user;
        }).catch(handleError);

        function getBundles() {
            var user = $localStorage.user;

            if (typeof user !== 'undefined' && user !== null && typeof user.stripe_customerID === 'string' && user.stripe_customerID.length > 0) {
                userService.getAccountByUserId(user.userID).then(function (response) {
                    try {
                        if (typeof response.data !== 'undefined' && response.data !== null) {
                            var stripeAccount = response.data;

                            // console.log("-- (Controller) PayWallController.getBundles() - stripeAccount: ", stripeAccount);

                            var priceID = stripeAccount.subscriptions.data[0].plan.id;
                            var productID = stripeAccount.subscriptions.data[0].plan.product;

                            billingService.getPrices(productID).then(function (getPricesResponse) {
                                prepareBundles(getPricesResponse, priceID);
                            });

                            checkSubscriptionStatus(stripeAccount);
                        }
                    } catch (e) {
                        // console.log("-- (Controller) PayWallController.getBundles() - e: ", e);

                        billingService.getPrices(constants.stripeProductID).then(function (getPricesResponse) {
                            prepareBundles(getPricesResponse);
                        });
                    }
                });
            } else {
                billingService.getPrices(constants.stripeProductID).then(function (getPricesResponse) {
                    prepareBundles(getPricesResponse);
                });
            }
        }

        function checkSubscriptionStatus(stripeAccount) {
            subscriptionActive = false;

            try {
                if (typeof stripeAccount !== 'undefined' && stripeAccount !== null) {
                    subscriptionActive = (stripeAccount.subscriptions.data[0].status === 'active');
                }
            } catch (e) {
                // console.log("-- (Controller) PayWallController.checkSubscriptionStatus() - e: ", e);
            }

            // console.log("-- (Controller) PayWallController.checkSubscriptionStatus() - subscriptionActive: ", subscriptionActive);
        }

        function prepareBundles(prices, priceID) {
            // console.log("-- (Controller) PayWallController.prepareBundles() - prices: ", prices);
            // console.log("-- (Controller) PayWallController.prepareBundles() - priceID: ", priceID);

            if (typeof prices !== 'undefined' && prices !== null && Array.isArray(prices.data) && prices.data.length > 0) {
                var pricesData = prices.data.filter(function (p) {
                    return (p.amount > 0);
                });

                var priceFound = false;

                $scope.bundles = pricesData.map(function (p) {
                    var disable = false;
                    var current = false;
                    var name = p.metadata.description2;

                    if (typeof priceID !== 'undefined' && priceID !== null) {
                        if (priceFound) {
                            disable = false;
                        } else if (p.id === priceID) {
                            priceFound = true;
                            disable = true;
                            current = true;
                            name = 'Current Plan';
                        } else {
                            disable = true;
                        }
                    }

                    return {
                        'id': p.id,
                        'name': name,
                        'description': p.description,
                        'monthDescription': p.monthDescription,
                        'features': p.metadata.features.split(';'),
                        'price': p.amount,
                        'monthPrice': p.monthAmount,
                        'disabled': disable,
                        'downloads': p.metadata.downloadsLabel,
                        'current': current
                    };
                });

                if (!priceFound) {
                    $scope.bundles.forEach(function (b) {
                        b.disabled = false;
                    });
                }

                $scope.copyBundles = angular.copy($scope.bundles);

                // console.log("-- (Controller) PayWallController.prepareBundles() - $scope.bundles: ", $scope.bundles);
            }
        }

        getBundles();

        var width = '18';
        width = width.toString() + "px";
        var lineHeight = screen.width * 0.012 * 1.1;
        lineHeight = lineHeight.toString() + "px";
        if (screen.width > 2600) {
            width = screen.width * 0.01;
            width = width.toString() + "px";
            lineHeight = screen.width * 0.012 * 1.1;
            lineHeight = lineHeight.toString() + "px";
        }
        
        if (screen.availWidth < 767) {
            width = '15px';
        }

        // console.log("kjnhbgv", width, lineHeight, screen.width * 0.04);
        $scope.$ctrl = this;
        var style = {
            base: {
                color: "#515d6a",
                // lineHeight: lineHeight,
                fontFamily: "sans-serif",
                fontSize: width,
                // height: "fit-content",
                "::placeholder": {
                    color: "#ee986a",
                },
            },
            invalid: {
                color: "#fa755a",
                iconColor: "#fa755a",
            },
        };  
        var elements = StripeElements.elements({
            fonts: [
                { cssSrc: 'https://fonts.googleapis.com/css?family=Open+Sans:400' }
            ]
        });

        var cardNumber = elements.create('cardNumber', {
            style: style,
            placeholder: 'E.g. 5555 5555 5555 4444'
        });
        var cardExpiry = elements.create('cardExpiry', {
            style: style,
            placeholder: 'MM/YY'
        });
        var cardCvc = elements.create('cardCvc', {
            style: style,
            placeholder: '3 Digit Code'
        });
        cardNumber.mount('#card-number-stripe');
        cardExpiry.mount('#card-expiry-stripe');
        cardCvc.mount('#card-cvv-stripe');
        $scope.cardNumber = cardNumber;
        $scope.cardExpiry = cardExpiry;
        $scope.cardCvc = cardCvc;

        $scope.promoKeyup = function () {
            resetPlans();
            var v = $('#promo_code_big').val();
            getCoupon(v);
        };
        var resetPlans = function () {
            angular.forEach($scope.plans, function (value, key) {
                var plan = $filter('filter')($scope.copyBundles, { id: value.id });
                value.savings = '';
                $scope.amountToCharge = 0;
                $scope.mainAmountToCharge = 0;
                $scope.nextCharge = 0;
                value.amount = formatDollars(parseFloat(plan[0].amount));
            });
        };
        var formatDollars = function (val) {
            if ((val % 1) === 0) {
                return val;
            }
            else {
                return val.toFixed(2);
            }
        };
        var getCoupon = function (couponId) {
            $rootScope.loadingInProcess = true; 
            userService.getCoupon(couponId).then(function (coupon) {
                var redeemDate = (coupon.data.redeem_by == null) ? null : parseInt(coupon.data.redeem_by) * 1000;
                if (coupon.data.max_redemptions != null && (coupon.data.times_redeemed >= coupon.data.max_redemptions)) {
                    $scope.isExpired = true;
                    $scope.isPromoApplied = false;
                    $scope.couponName = undefined;
                    $scope.savingsAmount = 0;
                    $scope.savings = '';
                    $scope.nextCharge = 0;
                } else if (redeemDate != null && (new Date() > new Date(redeemDate))) {
                    $scope.isExpired = true;
                    $scope.isPromoApplied = false;
                    $scope.couponName = undefined;
                    $scope.savingsAmount = 0;
                    $scope.savings = '';
                    $scope.nextCharge = 0;
                } else if (!coupon.data) {
                    $scope.isPromoValid = false;
                    $scope.isPromoApplied = false;
                    $('#promo_code_big_container').addClass('not-valid-halo');
                    $('.good-code').removeClass('success');
                    $scope.amountToCharge = 0;
                    $scope.mainAmountToCharge = 0;
                    $scope.couponName = undefined;
                    $scope.savingsAmount = 0;
                    $scope.savings = '';
                    $scope.nextCharge = 0;
                    angular.forEach($scope.plans, function (value, key) {
                        value.savings = '';
                        var plan = $filter('filter')($scope.copyBundles, { id: value.id });
                        value.amount = formatDollars(parseFloat(plan[0].amount));
                    });
                } else {
                    $scope.isPromoApplied = true;
                    $scope.isExpired = false;
                    $scope.isPromoValid = true;
                    $('#promo_code_big_container').removeClass('not-valid-halo');
                    $('.good-code').addClass('success');
                    angular.forEach($scope.plans, function (value, key) {
                        if (coupon.data.name === value.name) {
                            var tempAmount;
                            $scope.couponName = coupon.data.name;
                            if (coupon.data.amount_off != null) {
                                tempAmount = value.amount - (coupon.data.amount_off / 100);
                                if (coupon.data.duration === 'once') {
                                    value.savings = '$'+tempAmount+' for first month ($' + formatDollars((coupon.data.amount_off / 100)) + ' savings)<br />'+
                                        '$' + value.amount + ' for subsequent months';
                                    //'$' + formatDollars((coupon.data.amount_off / 100)) + ' savings first month!<br />$' + value.amount + ' every month after';
                                    $scope.savingsAmount = formatDollars((coupon.data.amount_off / 100));
                                }
                                else if (coupon.data.duration === 'forever') {
                                    value.savings = '$' + formatDollars((coupon.data.amount_off / 100)) + ' savings every month!';
                                    $scope.savingsAmount = formatDollars((coupon.data.amount_off / 100));
                                }
                                else if (+coupon.data.duration_in_months === value.term_length) {
                                    value.savings = '$' + formatDollars(((coupon.data.amount_off / 100)) * coupon.data.duration_in_months) + ' total savings!';
                                    $scope.savingsAmount = formatDollars((coupon.data.amount_off / 100));
                                }
                                else if (coupon.data.duration_in_months < value.term_length) {
                                    value.savings = '$' + formatDollars((coupon.data.amount_off / 100)) + ' off for ' + coupon.data.duration_in_months + ' months! ($' + formatDollars(((coupon.data.amount_off / 100) * coupon.data.duration_in_months)) + ' total savings)<br />'+
                                        '$' + value.amount + ' for subsequent months';
                                    $scope.savingsAmount = formatDollars((coupon.data.amount_off / 100));
                                }
                                value.amount = value.amount - (coupon.data.amount_off / 100);
                            }
                            else if (coupon.data.percent_off != null) {
                                tempAmount = value.amount - (value.amount * (coupon.data.percent_off / 100));
                                if (coupon.data.duration === 'once') {
                                    value.savings = '$'+tempAmount+' for first month ($' + formatDollars((value.amount * (coupon.data.percent_off / 100))) + ' savings)<br />'+
                                        '$' + value.amount + ' for subsequent months';
                                    $scope.savingsAmount = formatDollars((value.amount * (coupon.data.percent_off / 100)));
                                }
                                else if (coupon.data.duration === 'forever') {
                                    value.savings = '$' + formatDollars((value.amount * (coupon.data.percent_off / 100))) + ' savings every month!';
                                    $scope.savingsAmount = formatDollars((value.amount * (coupon.data.percent_off / 100)));
                                }
                                else if (+coupon.data.duration_in_months === value.term_length) {
                                    value.savings = '$' + formatDollars(((value.amount * (coupon.data.percent_off / 100)) * coupon.data.duration_in_months)) + ' total savings!';
                                    $scope.savingsAmount = formatDollars((value.amount * (coupon.data.percent_off / 100)));
                                }
                                else if (coupon.data.duration_in_months < value.term_length) {
                                    value.savings = '$' + formatDollars((value.amount * (coupon.data.percent_off / 100))) + ' off for ' + coupon.data.duration_in_months + ' months! ($' + formatDollars(((value.amount * (coupon.data.percent_off / 100)) * coupon.data.duration_in_months)) + ' total savings)<br />'+
                                        '$' + value.amount + ' for subsequent months';
                                    $scope.savingsAmount = formatDollars((value.amount * (coupon.data.percent_off / 100)));
                                }
                                value.amount = value.amount - (value.amount * (coupon.data.percent_off / 100));
                            }
                            value.amount = formatDollars(value.amount);
                            $scope.savingsAmount = formatDollars($scope.savingsAmount);
                        }
                        else {
                            value.savings = '';
                            var plan = $filter('filter')($scope.copyBundles, { id: value.id });
                            $scope.amount = formatDollars(parseFloat(plan[0].amount));
                        }
                    });
                }
                $rootScope.loadingInProcess = false;
            }).catch(function(e){
                $rootScope.loadingInProcess = false;
                $scope.isPromoValid = false;
                $scope.isPromoApplied = false;
            });
        };
        $scope.goBack = function(){
            localStorage.setItem("toSubscriptionFrom", "");
            $window.history.back(-1);
        };
        $scope.gotoStep2 = function(id) {
            var getYears = function() {
                var currentYear = new Date().getFullYear(), years = [];
                var startYear = currentYear+20;
                while ( currentYear <= startYear ) {
                    years.push(currentYear++);
                } 
                return years;
            };
            $scope.years = getYears();
            $scope.step1 = false;
            $scope.step2 = true;
            $scope.step3 = false;
            var bundle = $filter('filter')($scope.bundles, {id: id});
            var copyBundle = $filter('filter')($scope.copyBundles, {id: id});
            $scope.selectedBundle = bundle[0];
            $scope.selectedBundleId = bundle[0].id;
            $scope.amountToCharge = formatDollars(parseFloat(bundle[0].price));
            $scope.mainAmountToCharge = formatDollars(parseFloat(copyBundle[0].price));
            $scope.yourName=$scope.user.first_name + ' ' + $scope.user.last_name;
        };
        $scope.gotoStep1 = function(){
            $scope.step1 = true;
            $scope.step2 = false;
            $scope.step3 = false;
            resetPlans();
            $('#promo_code').val('');
            $('#promo_code_big').val('');
            $scope.couponName = undefined;
            $scope.isPromoApplied = false;
        };
        $scope.getOrganizationCss = function(css, returnEmpty) {
            return organizationService.getOrganizationCss(css, returnEmpty);
        };
        $scope.closeThankYou = function() {
            $scope.closeWaitingDialog(false);
        };
        $scope.closeWaitingDialog = function (closed) {
            if($scope.close === undefined)
            {            
                ngDialog.close();
                if($scope.step3 !== true)
                {
                    resetSteps();
                    $scope.success({updatedUser: null, closed: closed}); 
                }
                else {
                    userService.getUser(true).then(function (user) {     
                        resetSteps();                           
                        $scope.success({updatedUser: user, closed: closed});              
                    }).catch(handleError);
                }
            }
            else {
                $scope.close();
                setTimeout(function() {dialog.close(); }, 250);            
            }
        };
        var resetSteps = function() {
            $scope.step1 = true;
            $scope.step2 = false;
            $scope.step3 = false;   
        };
        
        $scope.processingCard = false;

        $scope.processCard = function (card) {
            var user = $localStorage.user;

            // console.logconsole.log("-- (Controller) PayWallController.prepareBundles() - user: ", user);

            $scope.processingCard = true;

            $scope.selectedPlanId = $scope.selectedBundleId;

            var customerNameOnCard = $('#card_name').val();
            var billingEmail = $('#billing_email').val();
            if (customerNameOnCard === '') {
                handleError($translate.instant('USER_PROFILE_CARD_NAME_REQUIRED_MESSAGE'));
                buildToastr('Customer name is incomplete', 'Warning');
            } else if (billingEmail == '') {
                handleError($translate.instant('USER_PROFILE_BILLING_EMAIL_REQUIRED_MESSAGE'));
                buildToastr('Customer email is incomplete', 'Warning');
            } else {
                StripeElements['createToken'](card, {
                    name: customerNameOnCard
                }).then(function (result) {
                    if (result.error) {
                        handleError(result.error.message);
                        buildToastr(result.error.message, 'Warning');
                    } else {
                        $scope.loadingData = true;
                        $scope.loaderModal = true;
                        $rootScope.loadingInProcess = true;

                        if (subscriptionActive) {
                            billingService.changeUserSubscription(user.userID, $scope.selectedPlanId, result.token).then(function (changeUserSubscriptionResponse) {
                                // console.log("-- (Controller) PayWallController.prepareBundles() - changeUserSubscriptionResponse: ", changeUserSubscriptionResponse);

                                $scope.finishProcessCard(changeUserSubscriptionResponse);
                            });
                        } else {
                            userService.createCustomer(billingEmail).then(function (user) {
                                if (user != null) {
                                    userService.saveCard(result.token).then(function (response) {
                                        $scope.brand = response.data.brand;
                                        if (response != null) {
                                            if (response.data.id) {
                                                userService.updateCardAsDefault(response.data.id).then(function () {
                                                    userService.subscribeCustomer(response.data.id, $scope.selectedPlanId, $scope.promoCode).then(function (subscribeCustomerResponse) {
                                                        // console.log("-- (Controller) PayWallController.prepareBundles() - subscribeCustomerResponse: ", subscribeCustomerResponse);
                                                        $scope.finishProcessCard(subscribeCustomerResponse);
                                                    }).catch(handleError);
                                                }).catch(handleError);
                                            } else {
                                                handleError(response.data.message);
                                            }
                                        } else {
                                            handleError($translate.instant('FAILED_PLEASE_TRY-AGAIN'));
                                        }
                                    });
                                } else {
                                    handleError($translate.instant('FAILED_PLEASE_TRY-AGAIN'));
                                }
                            }).catch(handleError);
                        }
                    }
                }).catch(function (err) {
                    handleError($translate.instant('FAILED_CREDIT_CARD_INVALID'));
                    buildToastr(err, 'Warning');
                });
            }
        };

        $scope.finishProcessCard = function (response, isUser) {
            isUser = isUser || false;

            if (typeof response !== 'undefined' && response !== null && typeof response.status !== 'undefined' && response.status !== null && response.status === 200) {
                userService.getUser(true).then(function (user) {
                    $localStorage.user = user;

                    $scope.step1 = false;
                    $scope.step2 = false;
                    $scope.step3 = true;
                    $scope.loadingData = false;
                    $scope.loaderModal = false;
                    $rootScope.loadingInProcess = false;
                    var r = new Date();
                    var n = new Date(r);
                    $scope.nextPaymentDate = moment(n.setDate(n.getDate() + 30)).format("MM/DD/YYYY");
                }).catch(handleError);
            } else {
                handleError(response.data.message);
            }
        };

        $scope.completePayment = function () {
            // console.log("-- (Controller) PayWallController.$scope.completePayment()");

            var uri = localStorage.getItem("toSubscriptionFrom");
            localStorage.setItem("toSubscriptionFrom", "subscription");

            // console.log("-- (Controller) PayWallController.$scope.completePayment() - uri: ", uri);
            // console.log("-- (Controller) PayWallController.$scope.completePayment() - localStorage.getItem('toSubscriptionFrom'): ", localStorage.getItem("toSubscriptionFrom"));

            $location.path(uri);
        };
        
        if(localStorage.getItem("toSubscriptionFrom") && localStorage.getItem("toSubscriptionFrom").indexOf("resume-profile")>=0){
            $scope.backButtonText ='Take Me to My Resume';    
        } else if(localStorage.getItem("toSubscriptionFrom") && localStorage.getItem("toSubscriptionFrom").indexOf("resume")>=0){
            $scope.backButtonText ='Continue to Download My Resume';
        } else if(localStorage.getItem("toSubscriptionFrom") === "user_profile"){
            $scope.backButtonText = 'Take Me to My Profile';
        }else if(localStorage.getItem("toSubscriptionFrom") === "dashboard") {
            $scope.backButtonText ='Take Me Back to the Dashboard';
        } else {
            $scope.backButtonText ='Take Me to Assessment Test';
        }

        function buildToastr(title, content) {
            $rootScope.toast = toastr.info(title, content, {
                progressBar:true,                                    
                timeOut:13000,
                toastClass: 'toast-teal',
                preventDuplicates: true,
                allowHtml: true,
                positionClass: 'toast-top-center',
                hideDuration: 1000,
                closeButton: true,
                showDuration: 1000,
                extendedTimeOut: 1000        
            });
        }
        var clearReload = function () {
            if (localStorage.getItem("toSubscriptionFrom") !== "subscription") {
                localStorage.setItem("toSubscriptionFrom", "");
            }
            unListener();
        };
        var unListener = $scope.$on("$stateChangeStart", clearReload);
    }
})();

(function () {
  'use strict';

  angular.module('intryFrontEnd').service('unsaveService', unsaveService);

  /** @ngInject */
  function unsaveService(modalService, $translate) {
    var unsave = this;
    unsave.data = {};

    function handleUnloadEvent(event) {
      event.returnValue = $translate.instant('UNSAVE_DATA_MESSAGE');
    }

    unsave.init = function(initFunc) {
      unsave.data = {};
      unsave.isAllowedLeaving = false;
      unsave.checkUnsavedData = initFunc;
    };

    unsave.confirmDownload = function () {
      console.log('avaaa')
       };
    unsave.checkUnsavedData = function () {
      return false;
    };

    unsave.isEqual = function (key, data) {
      return angular.equals(unsave.data[key], data)
    };

    unsave.getData = function(key) {
      return unsave.data[key];
    };

    unsave.updateData = function(key, value) {
      unsave.data[key] = value;
    };

    unsave.isEditorDirty = function(ckeditor) {
      var i,
        isDirty = false;

      if (ckeditor && ckeditor.instances) {
        for (i in ckeditor.instances) {
          isDirty = ckeditor.instances[i].checkDirty();
        }
      }
      return isDirty;
    };

    unsave.addUnloadEvent = function() {
      if (window.addEventListener) {
        window.addEventListener("beforeunload", handleUnloadEvent);
      } else {
        //For IE browsers
        window.attachEvent("onbeforeunload", handleUnloadEvent);
      }
    };

    //Call this when you want to remove the event, example, if a user fills necessary info
    unsave.removeUnloadEvent = function () {
      if (window.removeEventListener) {
        window.removeEventListener("beforeunload", handleUnloadEvent);
      } else {
        window.detachEvent("onbeforeunload", handleUnloadEvent);
      }
    };

    unsave.openConfirmModal = function() {
      return modalService.openModal('app/common/service/unsave.service/unsave-confirm-modal.html',undefined,undefined,undefined,'holaaaa');
    };

  }
})();
(function () {
  'use strict';

  angular
    .module('intryFrontEnd')
    .directive("setFocus", function () {
      return {
        link:  function(scope, element, attrs){
          element.bind('click',function(){
               document.querySelector('#' + attrs.setFocus).focus();
           })
        }
      }
})
})();

(function () {
  'use strict';
  angular.module('intryFrontEnd').directive('resumeUploadDialog', function ($translate, constants, ngDialog) {
    var dialog = null;
    var localThis = null;
    return {
      restrict: 'E',
      scope: {
        upload: '&',
        success: '&',
        active: '=',
        closefunc: '&'
      },
      link: function ($scope) {
        $scope.uploadResume = function () {
            if($scope.upload)
              $scope.upload();
        };
        $scope.$on('$destroy', function() {
          if(document.getElementById("ngdialog1")) document.getElementById("ngdialog1").remove();
        });
        $scope.closeResumeDialog = function () {   
          dialog.close();
          $scope.success();
        };
        localThis = this;
        $scope.$watch('active', function (newVal, oldVal) {
          if (newVal === true && oldVal === false) {
            dialog = ngDialog.open({
              template: 'app/common/directive/resumeUpload/user-profile-resume-upload-dialog.html',
              controller: localThis,
              closeByDocument: false,
              closeByEscape: false,
              showClose: false,
              closeByNavigation: true,
              scope: $scope,
              width: '525px',
              height: '550px'
            });
            $scope.closefunc({func: dialog.close});
          }
        });
      }
    }
  });
})();
(function () {
    'use strict';
    var match_regex = /^(\d{3})(\d{3})(\d{4})$/;
    var replace_regex = /[\.\!\@\$\%\^\(\)\_\+\=\?\{\}\[\]\|\\]/g;     
    function formatPhone (d) {
      var m = d.match(match_regex);
      return (!m) ? null : m[1] + "." + m[2] + "." + m[3];       
    } 
    function keyRange(event) {
      return ((event.which >= 48 && event.which <= 57)); // || event.which == 46 || event.which == 127 || event.which == 8 || event.which == 37 || event.which == 39 || event.which == 36 || event.which == 35 || event.which == 13);7
    }
    function lengthValid(txt, event){
      return  txt.length == 10;
    }
      angular
      .module('intryFrontEnd')
      .directive("phoneformat", function () {
        return {
          restrict: "A",
          link: function (scope, element, attrs) {
            element.bind('focus', function() {
                this.textContent = this.textContent.replace(replace_regex, "");
            });
            element.bind('blur', function() { 
              this.textContent = formatPhone(this.textContent);
            });
            element.bind("keypress", function (event) {    
              console.log(event.which);
              if(keyRange(event)){
                if (event.which == 13) {
                  event.preventDefault();
                  var text = window.getSelection().toString();
                  if(text.length == this.textContent.length){
                    this.textContent = '';
                  }
                }
                else if(lengthValid(this.textContent, event)){
                  event.preventDefault();
                  this.textContent = this.textContent.substring(0, 10);
                }
              }
              else {
                event.preventDefault();
              }
            });     
          }
        };
      });    
      angular
      .module('intryFrontEnd')
      .directive("phoneformatmodel", function () {
        return {
          require:"ngModel",
          restrict: "A",
          link: function (scope, element, attrs, ngModel) {
            function read() {
              var formattedValue = element[0].value;    
              formattedValue = formattedValue.substring(0, 10);        
              ngModel.$setViewValue(formattedValue);
              element[0].value = formattedValue;
            }            
            function format() {
              var formattedValue = element[0].value;
              formattedValue = formatPhone(formattedValue);
              ngModel.$setViewValue(formattedValue);
              element[0].value = formattedValue;
            }         
            element.bind('focus', function() {
                var formattedValue = element[0].value;
                formattedValue = formattedValue.replace(replace_regex, "");
                element[0].value = formattedValue;
            });
            element.bind('blur', function() { 
              scope.$apply(format);              
            });
            element.bind("keypress", function (event) {   
              var formattedValue = element[0].value;
              if(keyRange(event)){
                if (event.which == 13) {
                  event.preventDefault();
                  var text = window.getSelection().toString();
                  if(text.length == formattedValue.length){
                    scope.$apply(read);
                  }
                }
                else if(lengthValid(formattedValue, event)){
                  event.preventDefault();
                  scope.$apply(read);                
                }
              }
              else {
                event.preventDefault();
              }              
            });     
          }
        };
      });          
  })();
  
(function () {
    'use strict';

    function nonEmptyArray(a) {
        return Array.isArray(a) && (a.length > 0);
    }

    function nonNullObject(o) {
        return o !== null && typeof o === 'object';
    }

    angular.module('intryFrontEnd').config(function(toastrConfig){
        angular.extend(toastrConfig, {
            positionClass: 'toast-top-center'
        });
    });

    angular.module('intryFrontEnd').directive('paywallDialog', function ($translate, constants, ngDialog, userService, StripeElements, $sce, toastr, $filter) {
        var localThis = null;
        var dialog = null;
        function buildCtrl(s, t) {
            var style = {
                base: {
                    color: '#32325d',
                    // lineHeight: '18px',
                    fontFamily: '"Open Sans',
                    fontSize: '14px',
                    '::placeholder': {
                        color: '#aab7c4'
                    }
                },
                invalid: {
                    color: '#fa755a',
                    iconColor: '#fa755a'
                }
            };      
            var elementsModal = StripeElements.elements();
            var cardNumber = elementsModal.create('cardNumber', {
                style: style,
                placeholder: 'Card number'
            });
            var cardExpiry = elementsModal.create('cardExpiry', {
                style: style,
                placeholder: 'MM/YY'
            });
            var cardCvc = elementsModal.create('cardCvc', {
                style: style,
                placeholder: 'CVC'
            });      
            var postalCode = elementsModal.create('postalCode', {
                style: style,
                placeholder: 'Postal',
                value: nonEmptyArray(s.user.addresses) ? s.user.addresses[0].postal_code : ''
            });   
            
            s.$ctrl = t;
            s.$ctrl.cardNumber = cardNumber;
            s.$ctrl.cardExpiry = cardExpiry;
            s.$ctrl.cardCvc = cardCvc;
            s.$ctrl.postalCode = postalCode;
        }
        return {
            restrict: 'E',
            scope: {
                success: '&',
                error: '&',
                active: '=',
                close: '=',
                user: '=',
                finishtext: '@'
            },
            link: function ($scope) {
                if ($scope.finishtext === undefined)
                    $scope.finishtext = 'Done';
                // Not sure we need.
                setTimeout(function() { 
                    userService.getPlans()
                        .then(function (plans) {
                            loadAllAddonsandPlans(plans.data.data, $scope.plans, 'plan', 'candidates');
                            $scope.plans = $filter('orderBy')($scope.plans, 'sort_order' );

                            $scope.copyPlans = angular.copy($scope.plans);
                        });
                }, 250);

                var loadAllAddonsandPlans = function (data, out, type, userType) {

                    angular.forEach(data, function (value, key) {
                        
                        if (value.metadata.type === type && value.metadata.user_type === userType) {
                            out.push({
                                'id': value.id,
                                'plan': value.id,
                                'display_name': $sce.trustAsHtml(value.metadata.plan_name),
                                'name': value.name,
                                'statement_descriptor': value.statement_descriptor,
                                'amount': value.amount / 100.00,
                                'sort_order': parseInt(value.metadata.sort_order),
                                'features': $sce.trustAsHtml(value.metadata.features),
                                'terms': value.metadata.terms,
                                'term_length': parseInt(value.metadata.term_length),
                                'savings': '',
                                'nextCharge': 0
                            });
                        }
                    });
                };
                $scope.validateEmail = function(ctl) {
                    var emailIdSelector = $('#billing_email');
                    var emailClassSelector = $('.billing_email');
                    var str = emailIdSelector.val();
                    if (!str.match(constants.EMAIL_PATTERN)) {
                        $scope.cardErrorsModal = "Email not valid!";
                        emailClassSelector.addClass('not-valid-halo');
                        emailIdSelector.focus();
                    }
                    else {
                        emailClassSelector.removeClass('not-valid-halo');
                        $scope.cardErrorsModal = '';
                    }
                };
                $scope.promoEdit = function() {
                    if (notNavigation()) {
                        var v = $('#promo_code_big').val();
                        if (!v || $scope.isPromoValid) {
                            $scope.isPromoValid = true;
                            $scope.isExpired = false;
                            angular.forEach($scope.plans, function (value, key) {
                                var plan = $filter('filter')($scope.copyPlans, {id: value.id});
                                value.savings = '';             
                                $scope.amountToCharge = 0; 
                                $scope.nextCharge = 0;
                                value.amount =  formatDollars(parseFloat(plan[0].amount));
                                $('.good-code').removeClass('success');
                            });              
                        }
                    }
                };
                $scope.promoKeyup = function() {
                    resetPlans();          
                    var v = $('#promo_code_big').val();
                    getCoupon(v);
                };
                $scope.promoBlur = function() {
                    if ($('#promo_code_big').val() === '')
                        $('#promo_code_big_container').removeClass('not-valid-halo'); 
                    
                    if (!$scope.isPromoValid){
                        resetPlans();      
                    }
                };
                var notNavigation = function() {
                    // >>> KSH the "global event" is deprecated.  should use a listener instead
                    if (event.keyCode === 8 || event.keyCode === 46)
                        return true;
                    if (event.keyCode === 16 || event.keyCode === 18 || event.keyCode === 20 || event.keyCode === 27)
                        return false;
                    return !((event.keyCode >= 33 && event.keyCode <= 40) || (event.keyCode >= 112 && event.keyCode <= 123));
                };
                var handleError = function (error) {
                    $scope.cardErrorsModal = typeof error !== 'string' ? error.message : error;            
                    $scope.loadingData = false;
                    $scope.loaderModal = false;
                    if (error !== $translate.instant('USER_PROFILE_CARD_NAME_REQUIRED_MESSAGE') && error !== $translate.instant('USER_PROFILE_BILLING_REQUIRED_MESSAGE')){
                        if ($scope.error) {
                            $scope.error({error: $scope.cardErrorsModal});
                        }
                    } else {
                        if ($scope.error) {
                            $scope.error({error: $scope.cardErrorsModal});
                        }
                    }
                };
                $scope.loadingData = false;
                $scope.loaderModal = false;
                localThis = this;
                $scope.amountToCharge = 0; 
                $scope.nextCharge = 0;
                $scope.cardErrorsModal = '';
                $scope.nextPaymentDate = '';
                $scope.step1 = true;
                $scope.step2 = false;
                $scope.step3 = false;
                $scope.isPromoValid = true;
                $scope.isExpired = false;
                $scope.selectedPlan = '';
                $scope.selectedPlanId = '';
                $scope.plans = [];
                $scope.copyPlans = [];
                $scope.couponName = '';
                $scope.processCard = function (card) {
                    var customerNameOnCard = $('#card_name').val();
                    var billingEmail = $('#billing_email').val();
                    if (!customerNameOnCard) {
                        handleError($translate.instant('USER_PROFILE_CARD_NAME_REQUIRED_MESSAGE'));
                    } 
                    else if (!billingEmail) {
                        handleError($translate.instant('USER_PROFILE_BILLING_EMAIL_REQUIRED_MESSAGE'));          
                    }           
                    else {
                        // $scope.loadingData = true;
                        // $scope.loaderModal = true; 
                        // $scope.step1 = false;
                        // $scope.step2 = false;
                        // $scope.step3 = true;   
                        // $scope.loadingData = false;
                        // $scope.loaderModal = false;      
                        // var r = new Date(); 
                        // var n = new Date(r);
                        // $scope.nextPaymentDate = moment(n.setDate(n.getDate() + 30)).format("MM/DD/YYYY"); 

                        StripeElements['createToken'](card, {name: customerNameOnCard}).then(function (result) {
                            if (result.error) {
                                handleError(result.error.message);
                            } else {
                                $scope.loadingData = true;
                                $scope.loaderModal = true; 
                                userService.createCustomer(billingEmail).then(function (user) {
                                    if (user != null) {
                                        userService.saveCard(result.token).then(function (response) {
                                            if (response != null) {
                                                if (response.data.id) {
                                                    userService.updateCardAsDefault(response.data.id).then(function () {
                                                        userService.subscribeCustomer(response.data.id, $scope.selectedPlanId, $('#promo_code_big').val()).then(function (response) {
                                                            if (response === 'SUCCESS') {
                                                                if ($scope.success) {
                                                                    $scope.step1 = false;
                                                                    $scope.step2 = false;
                                                                    $scope.step3 = true;   
                                                                    $scope.loadingData = false;
                                                                    $scope.loaderModal = false;      
                                                                    var r = new Date(); 
                                                                    var n = new Date(r);
                                                                    $scope.nextPaymentDate = moment(n.setDate(n.getDate() + 30)).format("MM/DD/YYYY");
                                                                }
                                                            } else {
                                                                handleError(response.data.message);
                                                            }
                                                        }).catch(handleError);
                                                    }).catch(handleError);
                                                } else {
                                                    handleError(response.data.message);
                                                }
                                            } else {
                                                handleError($translate.instant('FAILED_PLEASE_TRY-AGAIN'));
                                            }
                                        });
                                    } else {
                                        handleError($translate.instant('FAILED_PLEASE_TRY-AGAIN'));
                                    }
                                }).catch(handleError);
                            }
                        }).catch(function(err) { 
                            handleError($translate.instant('FAILED_CREDIT_CARD_INVALID'));
                        });
                    }
                };
                $scope.closeWaitingDialog = function (closed) {             
                    if (typeof $scope.close !== 'function')
                    {            
                        ngDialog.close();
                        if (!$scope.step3)
                        {
                            resetSteps();
                            $scope.success({updatedUser: null, closed: closed}); 
                        }
                        else {
                            userService.getUser(true).then(function (user) {     
                                resetSteps();                           
                                $scope.success({updatedUser: user, closed: closed});              
                            }).catch(handleError);
                        }
                    }
                    else {
                        $scope.close();
                        setTimeout(function() {dialog.close(); }, 250);            
                    }
                };
                $scope.gotoStep2 = function(id) {
                    $scope.step1 = false;
                    $scope.step2 = true;
                    $scope.step3 = false; 
                    var plan = $filter('filter')($scope.plans, {id: id});
                    if ($scope.couponName != plan[0].name){
                        $('#promo_code').val('');
                    }
                    else {
                        $('#promo_code').val($('#promo_code_big').val());
                    }
                    $scope.selectedPlan = plan[0].name;     
                    $scope.selectedPlanId = plan[0].id;
                    $scope.amountToCharge = formatDollars(parseFloat(plan[0].amount)); 
                    if ($scope.nextCharge == 0)
                        $scope.nextCharge = formatDollars(parseFloat(plan[0].amount));

                    $('#card_name').val($scope.user.first_name + ' ' + $scope.user.last_name);
                };
                var resetSteps = function() {
                    $scope.step1 = true;
                    $scope.step2 = false;
                    $scope.step3 = false;   
                };
                $scope.gotoStep1 = function() {
                    resetSteps();
                };
                $scope.closeThankYou = function() {
                    $scope.closeWaitingDialog(false);
                };
                var getCoupon = function(couponId) {
                    userService.getCoupon(couponId).then(function (coupon) {

                        if (!nonNullObject(coupon.data)) {
                            $scope.isPromoValid = false;
                            $('#promo_code_big_container').addClass('not-valid-halo');
                            $('.good-code').removeClass('success');
                            angular.forEach($scope.plans, function (value, key) {
                                value.savings = '';
                                var plan = $filter('filter')($scope.copyPlans, {id: value.id});
                                $scope.amountToCharge = 0; 
                                $scope.nextCharge = 0;
                                value.amount =  formatDollars(parseFloat(plan[0].amount));
                            });
                            return;
                        }

                        if (coupon.data.max_redemptions != null && (coupon.data.times_redeemed >= coupon.data.max_redemptions)) {
                            $scope.isExpired = true;
                            return;
                        }
                        
                        var redeemDate = !coupon.data.redeem_by ? null : parseInt(coupon.data.redeem_by) * 1000;

                        if (redeemDate != null && (new Date() > new Date(redeemDate))){
                            $scope.isExpired = true;
                            return;
                        }            

                        $scope.isPromoValid = true;
                        $scope.isExpired = false;
                        $('#promo_code_big_container').removeClass('not-valid-halo');
                        $('.good-code').addClass('success');
                        angular.forEach($scope.plans, function (value, key) {
                            if (coupon.data.name === value.name){ 
                                $scope.nextCharge = value.amount;

                                $scope.couponName = coupon.data.name;
                                if (coupon.data.amount_off)
                                {
                                    if (coupon.data.duration == 'once') {
                                        value.savings = '$' + formatDollars((coupon.data.amount_off / 100)) + ' savings first month!<br />$' + value.amount + ' every month after';
                                        $scope.nextCharge = value.amount;
                                    }
                                    else if (coupon.data.duration == 'forever') {
                                        value.savings = '$' + formatDollars((coupon.data.amount_off / 100)) + ' savings every month!';
                                        $scope.nextCharge = value.amount - (coupon.data.amount_off / 100);
                                    }                      
                                    else  if (coupon.data.duration_in_months == value.term_length) {
                                        value.savings = '$' + formatDollars(((coupon.data.amount_off / 100)) * coupon.data.duration_in_months) + ' total savings!';
                                        $scope.nextCharge = value.amount - (coupon.data.amount_off / 100);
                                    }
                                    else  if (coupon.data.duration_in_months < value.term_length) {                      
                                        value.savings = '$' + formatDollars((coupon.data.amount_off / 100)) + ' off for ' + coupon.data.duration_in_months + ' months!<br />$' + value.amount + ' every month after' + formatDollars(((coupon.data.amount_off / 100) * coupon.data.duration_in_months)) + ' total savings!';
                                        $scope.nextCharge = value.amount - (coupon.data.amount_off / 100);
                                    }                  
                                    value.amount = value.amount - (coupon.data.amount_off / 100);
                                }
                                else if (coupon.data.percent_off)
                                {
                                    if (coupon.data.duration === 'once')     {
                                        value.savings = '$' + formatDollars((value.amount * (coupon.data.percent_off / 100))) + ' savings first month!<br />$' + value.amount + ' every month after';
                                        $scope.nextCharge = value.amount;
                                    }
                                    else if (coupon.data.duration === 'forever') {
                                        value.savings = '$' + formatDollars((value.amount * (coupon.data.percent_off / 100))) + ' savings every month!';
                                        $scope.nextCharge =  value.amount - (value.amount * (coupon.data.percent_off / 100));
                                    }                        
                                    else if (coupon.data.duration_in_months == value.term_length) {
                                        value.savings = '$' + formatDollars(((value.amount * (coupon.data.percent_off / 100)) * coupon.data.duration_in_months)) + ' total savings!';
                                        $scope.nextCharge = ((value.amount * (coupon.data.percent_off / 100)) * coupon.data.duration_in_months);
                                    }
                                    else  if (coupon.data.duration_in_months < value.term_length) {
                                        value.savings = '$' +  formatDollars(((value.amount * (coupon.data.percent_off / 100)))) + ' off for ' + coupon.data.duration_in_months + ' months!<br />$' + value.amount + ' every month after<br />' + formatDollars(((value.amount * (coupon.data.percent_off / 100)) * coupon.data.duration_in_months)) + ' total savings!';
                                        $scope.nextCharge = value.amount - (value.amount * (coupon.data.percent_off / 100));
                                    }           
                                    value.amount = value.amount - (value.amount * (coupon.data.percent_off / 100));                    
                                }                  
                                value.amount = formatDollars(value.amount);
                                $scope.nextCharge = formatDollars($scope.nextCharge);
                            }
                            else{
                                value.savings = '';
                                var plan = $filter('filter')($scope.copyPlans, {id: value.id});  
                                $scope.amount =  formatDollars(parseFloat(plan[0].amount));
                            }
                        });
                        
                    });
                };
                var formatDollars = function(val) {
                    if ((val % 1) === 0) {
                        return val;
                    }
                    else {
                        return val.toFixed(2);
                    }
                };
                var resetPlans = function() { 
                    angular.forEach($scope.plans, function (value, key) {
                        var plan = $filter('filter')($scope.copyPlans, {id: value.id});
                        value.savings = '';
                        $scope.amountToCharge = 0; 
                        $scope.nextCharge = 0;
                        value.amount =  formatDollars(parseFloat(plan[0].amount));
                    }); 
                };

                $scope.$watch('active', function (newVal, oldVal) {
                    $scope.cardErrorsModal = '';
                    buildCtrl($scope, localThis);
                    $scope.baseHtml = $sce.trustAsHtml("'" + $translate.instant('USER_PROFILE_BILLING_BASE_MESSAGE_DETAILS') + "'");
                    $scope.monthlyHtml = $sce.trustAsHtml("'" + $translate.instant('USER_PROFILE_BILLING_MONTHLY_MESSAGE_DETAILS') + "'");   
                    $scope.isPromoValid = true;
                    $scope.PromoChecked = false;
                    $scope.isExpired = false;
                    resetPlans();           
                    resetPlans();
                    if (newVal === true && oldVal === false) {
                        dialog = ngDialog.open({
                            template: 'app/common/directive/paywall/paywall.html',
                            controller: localThis,
                            closeByDocument: false,
                            closeByEscape: false,
                            showClose: false,
                            closeByNavigation: true,
                            scope: $scope,
                            width: '455px',
                            height: '670px'
                        });
                    }
                });
            }
        };
    });
})();

(function () {
    'use strict';

    angular
        .module('intryFrontEnd')
        .directive('navBarAdmin', navBarAdmin);

    /** @ngInject */
    function navBarAdmin($rootScope) {

        /** @ngInject */
        function NavbarAdminController($state, $scope, adminService, organizationService, JWTService, $localStorage, $translate) {

            var vm = this;

            var resetStateParams = function () {
                vm.user = null;
                vm.dataLoading = false;
                vm.failLogin = false;
            };

            vm.users = function () {
                $state.go("admin-users");
            };

            vm.addUser = function () {
                $state.go("admin-create-user");
            };

            vm.admins = function () {
                $state.go("admin-admins");
            };

            vm.addAdmin = function () {
                $state.go("admin-create-admin");
            };

            var loadAdmin = function () {
                if (JWTService.getToken()) {
                    adminService.getAdmin().then(function (user) {
                        vm.user = user;
                    });
                }
            };

            vm.createUser = function () {
                $state.go('admin-create-user');
            };

            vm.organizations = function () {
                $state.go("admin-organizations");
            };

            vm.logOut = function () {
                resetStateParams();

                adminService.logOut();

            };

            vm.login = function () {
                resetStateParams();
                JWTService.clearToken();
                vm.dataLoading = true;
                vm.dataLoading = true;
                adminService.login(vm.email, vm.password).then(function (admin) {
                    vm.dataLoading = false;
                    vm.user = admin;
                    $state.go('admin-dashboard');

                }).catch(function (err) {
                    vm.dataLoading = false;
                    vm.failLogin = true;
                });
            };

            vm.toggleMobileMenu = function ($event) {
                $('#top-navbar-collapse').toggle();
                $($event.currentTarget).find('.navbar-toggler-icon').toggleClass('navbar-toggler-close-icon');
            };

            // In case the user lands directly to a page and has
            // previously logged in, try to load user details
            loadAdmin();

            $rootScope.$on('currentUser-updated', function () {
                loadAdmin();
            });

            $scope.checkRole = function (roles) {
                var adminUser = $localStorage.adminUser;
                var adminRole = 'ROLE_ADMIN_USER';

                if (
                    typeof adminUser !== 'undefined' && adminUser !== null &&
                        typeof adminUser.role === 'string' && adminUser.role.length > 0) {
                    adminRole = adminUser.role;
                }

                return (roles.indexOf(adminRole) > -1) ? true : false;
            };

            // #region White Label Code.
            $scope.hasOrganization = function() {
                return organizationService.hasOrganization();
            };

            $scope.getOrganizationCss = function(css, returnEmpty) {
                return organizationService.getOrganizationCss(css, returnEmpty);
            };

            $scope.getOrganizationKey = function() {
                return organizationService.getOrganizationKey();
            };

            $scope.getOrganizationName = function() {
                return organizationService.getOrganizationName();
            };
            // #endregion White Label Code.

            $scope.goToHome = function () {
                $state.go('admin-dashboard');
            };

            $scope.getTitle = function (txt) {
                var title = $translate.instant(txt);

                if ($scope.checkRole('ROLE_APP_ADMIN')) {
                    title = title.replace('#####ADMIN_TITLE#####', 'Administrator');
                } else {
                    title = title.replace('#####ADMIN_TITLE#####', 'Admins / Case Manager');
                }

                return title;
            };
            // #endregion White Label Code.

            vm.viewProfile = function () {
                $state.go('admin-profile', {}, {
                    reload: true
                });
            };
        }

        var directive = {
            restrict: 'E',
            templateUrl: 'app/common/directive/navBarAdmin/navbarAdmin.html',
            scope: {
                student: '=',
                hideSide: '='
            },
            controller: NavbarAdminController,
            controllerAs: 'vm',
            transclude: true,
            bindToController: true
        };

        return directive;
    }
})();

(function () {
    'use strict';

    angular
        .module('intryFrontEnd')
        .directive('navBar', navBar);

    /** @ngInject */
    function navBar($rootScope) {

        /** @ngInject */
        function NavbarController($state, userService, JWTService, modalService, nzTour, unsaveService, utilsService, resumeValidation, $localStorage, $scope, organizationService) {

            var vm = this;

            var resetStateParams = function () {
                vm.user = null;
                vm.dataLoading = false;
                vm.failLogin = false;
            };

            var loadUser = function () {
              
                if (JWTService.getToken()) {
                    userService.getUser().then(function (user) {
                        vm.user = user;
                    });
                }
            };

            vm.logOut = function () {
                var stateName = $state.current.name;
                var logout = function () {
                    resetStateParams();
                    userService.logOut();
                };

                if ((stateName === 'user-profile' || stateName === 'resume-profile') && unsaveService.checkUnsavedData()) {
                    unsaveService.openConfirmModal().then(function () {
                        unsaveService.isAllowedLeaving = true;
                        unsaveService.removeUnloadEvent();
                        logout();
                    });
                } else {
                    logout();
                }
            };

            vm.login = function () {
                $rootScope.loadingInProcess = true;
                resetStateParams();
                JWTService.clearToken();
                vm.dataLoading = true;
                userService.login(vm.email, vm.password).then(function (user) {
                    vm.dataLoading = false;
                    vm.user = user;
                    $rootScope.loadingInProcess = false;
                    $state.go('dashboard');
                }).catch(function (err) {
                    $rootScope.loadingInProcess = false;
                    vm.dataLoading = false;
                    vm.failLogin = true;
                    if (err.data && err.data.disabled) {
                        modalService.openModal(
                            'app/disabled-user/template/disabled-user.html', {
                                closeByEscape: true,
                                closeByNavigation: true,
                                closeByDocument: true
                            }
                        ).then(function () {}, function (err) {});
                    }
                });
            };

            function showResumeInvalid() {
                vm.scrimPageBackground = true;
                modalService.openModal(
                    'app/resumes/template/validation-error-dialog.html',
                    'resumeValidationController'
                ).then(function () {
                    vm.scrimPageBackground = false;

                }, function () {
                    vm.scrimPageBackground = false;
                });
            }

            vm.resetPassword = function () {
                modalService.openModal(
                    'app/reset-password/template/reset-password.html',
                    'ResetPasswordController', {
                        login: function () {
                            return null;
                        },
                        passwordResetToken: function () {
                            return null;
                        }
                    }, {
                        closeByEscape: true,
                        closeByNavigation: true,
                        closeByDocument: true
                    }
                ).then(function () {}, function (err) {});
            };

            vm.conflictAgent = userService.conflictAgent;

            // In case the user lands directly to a page and has
            // previously logged in, try to load user details
            loadUser();

            $rootScope.$on('currentUser-updated', function () {
                loadUser();
            });
            var configForResponsive;
            if ($(window).width() > 767) {
                configForResponsive = [{
                    target: '#home',
                    placementPriority: 'bottom',
                    content: 'Here you can go on home from any where.',
                }, {
                    target: '#profile',
                    placementPriority: 'bottom',
                    content: 'Here you can update your profile.',
                }, {
                    target: '#assesment',
                    content: 'Here you can take a personality assessment.',
                }, {
                    target: '#resume',
                    content: 'Here you can create a resume.',
                }, {
                    target: '#jobsearch',
                    content: 'Here you can search for a job.',
                }];
            } else {
                configForResponsive = [{
                    target: '#home1',
                    placementPriority: 'bottom',
                    content: 'Here you can go on home from any where.',
                }, {
                    target: '#profile1',
                    placementPriority: 'bottom',
                    content: 'Here you can update your profile.',
                }, {
                    target: '#assesment1',
                    content: 'Here you can take a personality assessment.',
                }, {
                    target: '#resume1',
                    content: 'Here you can create a resume.',
                }, {
                    target: '#jobsearch1',
                    content: 'Here you can search for a job',
                }];
            }

            var tourConfig = {
                config: {
                    mask: {
                        visible: true, // Shows the element mask
                        visibleOnNoTarget: false, // Shows a full page mask if no target element has been specified
                        clickThrough: false, // Allows the user to interact with elements beneath the mask
                        clickExit: false, // Exit the tour when the user clicks on the mask
                        scrollThrough: true, // Allows the user to scroll the scrollbox or window through the mask
                        color: 'rgba(0,0,0,.7)' // The mask color
                    },
                    scrollBox: 'body', // The container to scroll when searching for elements
                    previousText: 'Previous',
                    nextText: 'Next',
                    finishText: 'Finish',
                    showPrevious: true, // Setting to false hides the previous button
                    showNext: true, // Setting to false hides the next button
                    animationDuration: 400, // Animation Duration for the box and mask
                    placementPriority: ['bottom', 'right', 'top', 'left'],
                    dark: false, // Dark mode (Works great with `mask.visible = false`)
                    disableInteraction: false, // Disable interaction with the highlighted elements
                    highlightMargin: 0, // Margin of the highglighted area
                    disableEscExit: false, // Disable end of tour when pressing ESC, // see config
                },
                steps: configForResponsive
            };

            $rootScope.startTour = function () {
                nzTour.start(tourConfig).then(function () { //start tour
                })
                    .catch(function () {});
            };

            vm.toggleMobileMenu = function ($event) {
                $('#top-navbar-collapse').toggle();
                $($event.currentTarget).find('.navbar-toggler-icon').toggleClass('navbar-toggler-close-icon');
            };

            vm.checkAdminSession = function () {
                var authToken = localStorage.getItem('auth-token');
                var adminUser = $localStorage.adminUser;
                var adminUserID = $localStorage.adminUserID;

                if (typeof authToken === 'string' && authToken.length > 0 &&
                    typeof adminUser !== 'undefined' && adminUser !== null &&
                    typeof adminUserID === 'string' && adminUserID.length > 0) {
                    return true;
                }
                return false;
            };

            vm.checkSubscription = function () {
                var user = $localStorage.user;

                // console.log('-- (Directive) NavbarController.checkSubscription() - user: ', user);

                if (
                    typeof user !== 'undefined' && user !== null &&
                        typeof user.stripe_customerID === 'string' && user.stripe_customerID.length > 0
                ) {
                    return true;
                }

                return false;
            };

            $scope.showAssessmentsMenu = function () {
                // console.log("(Directive) NavbarController.showAssessmentsMenu() $localStorage.freeUser: ", $localStorage.freeUser);

                if (typeof $localStorage.freeUser === 'boolean' && $localStorage.freeUser) {
                    return false;
                } else {
                    return true;
                }
            };

            // #region White Label Code.
            $scope.hasOrganization = function() {
                return organizationService.hasOrganization();
            };

            $scope.getOrganizationCss = function(css, returnEmpty) {
                return organizationService.getOrganizationCss(css, returnEmpty);
            };

            $scope.getOrganizationKey = function() {
                return organizationService.getOrganizationKey();
            };

            $scope.getOrganizationName = function() {
                return organizationService.getOrganizationName();
            };
            // #endregion White Label Code.

            // #region Resume Download Counter.
            $scope.resumeCounter = -1;

            $scope.getResumeCounter = function () {
                var resumeCounter = '';

                try {
                    if (typeof $localStorage.user.resumeCounter !== 'undefined' &&
                        $localStorage.user.resumeCounter !== null &&
                        $localStorage.user.resumeCounter > -1) {
                        resumeCounter += $localStorage.user.resumeCounter;
                    }
                } catch (e) {
                    // Do nothing...
                }

                return resumeCounter;
            };

            $scope.getResumeCounterTooltip = function () {
                var tooltip = '';

                try {
                    if (typeof $localStorage.user.resumeCounter !== 'undefined' &&
                        $localStorage.user.resumeCounter !== null &&
                        $localStorage.user.resumeCounter > -1) {
                        tooltip = 'You have ' + $localStorage.user.resumeCounter + ' resumes available';
                    }
                } catch (e) {
                    // Do nothing...
                }

                return tooltip;
            };
            // #endregion Resume Download Counter.
        }

        var directive = {
            restrict: 'E',
            templateUrl: 'app/common/directive/navBar/navbar.html',
            scope: {
                student: '=',
                hideSide: '=',
                emailVerificationStatusMessage: '=',
                verificationStatusMessage: '='
            },
            controller: NavbarController,
            controllerAs: 'vm',
            transclude: true,
            bindToController: true
        };

        return directive;
    }
})();

(function() {
  'use strict';

  angular
    .module('intryFrontEnd')
    .directive('footerBar', footerBar);

  /** @ngInject */
  function footerBar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/common/directive/footer/footer.html',
      scope: {
      },
      controller: FooterController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function FooterController() {
      var vm = this;

    }

  }

})();
(function () {
    'use strict';

    // reference: http://fdietz.github.io/recipes-with-angular-js/common-user-interface-patterns/editing-text-in-place-using-html5-content-editable.html
    angular
        .module('intryFrontEnd')
        .directive("editable", function () {
            return {
                restrict: "A",
                require: "ngModel",
                link: function (scope, element, attrs, ngModel) {
                    scope.pasteAction = true;
                    element.on('drop', function name(event) {
                        event.stopPropagation(); event.preventDefault();
                    });
                    element[0].addEventListener("paste", function(e) {
                        if (!element.context.classList.contains('cke_editable')) {
                            e.preventDefault();
                            if(scope.pasteAction){
                                var text = e.clipboardData.getData("text/plain");
                                document.execCommand("insertHTML", false, text);
                                scope.pasteAction = false;
                            }
                            setTimeout(function() {scope.pasteAction = true;}, 1000);
                        }
                    });
                    function read() {
                        // view -> model
                        //var newLine = String.fromCharCode(10);
                        //var formattedValue = element.html().replace(/<br>/ig, newLine).replace(/\r/ig, '');
                        var formattedValue = element.html();            
                        ngModel.$setViewValue(formattedValue);
                        element.html(formattedValue);
                    }
                    // model -> view
                    ngModel.$render = function () {
                        element.html(ngModel.$viewValue || "");
                    };
                    element.bind("blur", function () {
                        scope.$apply(read);
                    });
                    element.on('focus', function(){ 
                        if(this.getAttribute('ckeditor') != null){
                            scope.addCkEditor(this.id);
                        }            
                        if(this.childNodes.length > 0){
                            var range = document.createRange();
                            var sel = window.getSelection();
                            range.setStart(this.childNodes[0], this.innerText.length);
                            sel.removeAllRanges();
                            sel.addRange(range);
                        }
                        this.focus();
                    });    
                    element.bind("keydown keypress", function (event) {
                        if (event.which === 13) {
                            event.preventDefault();
                            var text = window.getSelection().toString();
                            if(text.length == this.innerText.length){
                                this.innerText = '';
                                scope.$apply(read);
                            }
                        }
                    });
                }
            };
        });

    // reference: https://codepen.io/meiriko/pen/zGoKoO   Using reference instead of adding all the comments from original source code.
    angular
        .module('intryFrontEnd')
        .directive("admineditable", function () {
            return {
                restrict: "A",
                require: "ngModel",
                link: function (scope, element, attrs, ngModel) {
                    function read() {
                        var newLine = String.fromCharCode(10);
                        var formattedValue = element.html().replace(/<br>/ig, newLine).replace(/\r/ig, '');
                        ngModel.$setViewValue(formattedValue);
                        element.text(formattedValue);
                    }
                    ngModel.$render = function () {
                        element.html(ngModel.$viewValue || "");
                    };
                    element.bind("blur", function () {
                        scope.$apply(read);
                    });
                    element.bind("paste", function (e) {
                        e.preventDefault();
                        document.execCommand('inserttext', false, e.clipboardData.getData('text/plain'));
                    });
                }
            };
        });


    angular
        .module('intryFrontEnd')
        .directive("dateeditable", function () {
            return {
                restrict: "A",
                link: function (scope, element, attrs) {
                    element.on('focus', function() {
                        window.getSelection().removeAllRanges();
                        $(this)[0].focus(); 
                        $(this)[0].setSelectionRange($(this)[0].value.length,$(this)[0].value.length);
                    });
                    element.bind("keydown keypress", function (event) {
                        if (event.which === 13) {
                            event.preventDefault();
                            var text = window.getSelection().toString();
                            if(text.length == $(this)[0].value.length){
                                this.value = '';
                            }
                        }
                    });     
                }
            };
        });    
})();

(function () {
    'use strict';

    angular
        .module('intryFrontEnd')
        .controller('UtmsController', UtmsController);

    /** @ngInject */
    function UtmsController($scope, constants, $state, utmService, $localStorage, $rootScope, toastr, $translate, organizationService) {
        window.scrollTo(0, 0);

        // #region Custom configurations.
        $scope.paginationTitle = 'ADMIN_SECTION_UTMS_TITLE';
        $scope.addRecordTooltip = 'ADMIN_SECTION_ADD_UTM_TEXT';
        $scope.addRecordCssClass = 'utms-icon';
        $scope.addRecordIcon = 'work';
    
        var recordFilterFields = constants.utmFilterFields;
        var getRawRecordsFn = utmService.getUtms;
        var rawRecordsDatasetName = 'utms';
        var rawRecordsDatasetTotalName = 'total';
        $scope.rawRecordsFields = [
            {key: 'utmID', show: false},
            {key: 'name', show: true, translate: 'ADMIN_SECTION_UTMS_NAME_HEAD_TITLE'},
            {key: 'utmSource', show: true, translate: 'ADMIN_SECTION_UTMS_SOURCE_HEAD_TITLE'},
            {key: 'utmCampaign', show: false},
            {key: 'utmMedium', show: false},
            {key: 'postbackMethod', show: true, translate: 'ADMIN_SECTION_UTMS_POSTBACK_METHOD_HEAD_TITLE'},
            {key: 'postbackPath', show: true, translate: 'ADMIN_SECTION_UTMS_POSTBACK_PATH_HEAD_TITLE'},
            {key: 'status', show: false, translate: 'ADMIN_SECTION_UTMS_STATUS_HEAD_TITLE'},
            {key: 'deleted', show: false}
        ];
        var viewStateName = 'admin-create-utm';
        $scope.recordIDFieldName = 'utmID';
    
        var disableRecordFn = utmService.disableUtm;
        var disableRecordTitle = 'ADMIN_SECTION_UTMS_DISABLE_TITLE';
        var disableRecordMsg = 'ADMIN_SECTION_UTMS_DISABLE_TEXT';
        var disableRecordSuccessMsg = 'ADMIN_SECTION_UTMS_DISABLE_SUCCESS_TEXT';
        var disableRecordErrorMsg = 'ADMIN_SECTION_UTMS_DISABLE_ERROR_TEXT';
    
        var enableRecordFn = utmService.enableUtm;
        var enableRecordTitle = 'ADMIN_SECTION_UTMS_ENABLE_TITLE';
        var enableRecordMsg = 'ADMIN_SECTION_UTMS_ENABLE_TEXT';
        var enableRecordSuccessMsg = 'ADMIN_SECTION_UTMS_ENABLE_SUCCESS_TEXT';
        var enableRecordErrorMsg = 'ADMIN_SECTION_UTMS_ENABLE_ERROR_TEXT';
    
        var deleteRecordFn = utmService.deleteUtm;
        var deleteRecordTitle = 'ADMIN_SECTION_UTMS_DELETE_TITLE';
        var deleteRecordMsg = 'ADMIN_SECTION_UTMS_DELETE_TEXT';
        var deleteRecordSuccessMsg = 'ADMIN_SECTION_UTMS_DELETE_SUCCESS_TEXT';
        var deleteRecordErrorMsg = 'ADMIN_SECTION_UTMS_DELETE_ERROR_TEXT';
    
        var warningTitle = 'ADMIN_SECTION_UTMS_WARNING_TITLE';
        // #endregion Custom configurations.
    
        var recordsPerPage = constants.recordsPerPage;
    
        $scope.recordFilterFields = recordFilterFields;
        $scope.filterField = recordFilterFields[0].key;
        $scope.ftypes = constants.ftypesMultiFields;
        $scope.ftype = $scope.ftypes[0].key;
    
        $scope.paginationFilter = '';
        $scope.currentSkip = 0;
        $scope.currentPage = 1;
        $scope.totalPages = 1;
        $scope.records = [];
        $scope.totalRecords = 0;
        $scope.tableState = {};

        $scope.createRecord = function () {
            $localStorage.recordID = undefined;
            $state.go(viewStateName);
        };

        // #region Pagination Methods.
        $scope.getRecords = function (tableState) {
            $scope.tableState = tableState;
            $scope.isLoading = true;

            var records = [];

            if (angular.isUndefined($scope.currentSkip)) {
                $scope.currentSkip = 0;
            }

            var field = $scope.filterField;
      
            var sort = '';
            var order = '';

            if (typeof tableState !== 'undefined' && typeof tableState.sort.predicate !== 'undefined') {
                sort = tableState.sort.predicate;
                order = (tableState.sort.reverse) ? 1 : -1;
            }
      
            getRawRecordsFn($scope.currentSkip, recordsPerPage, field, $scope.paginationFilter, $scope.ftype, sort, order).then(function (response) {
                if (response.error) {
                    alert("There was an error, administrators could not be loaded");

                    return false;
                }

                // console.log(response.data);
                var rawRecords = response.data[0] /*[rawRecordsDatasetName]*/;
                $scope.totalRecords = response.data[1] /*[rawRecordsDatasetTotalName]*/;

                angular.forEach(rawRecords, function (value, key) {
                    var record = {};
                    for (var i in $scope.rawRecordsFields) {
                        record[$scope.rawRecordsFields[i].key] = value[$scope.rawRecordsFields[i].key];
                    }
                    records.push(record);
                });

                $scope.isLoading = false;
                $scope.records = records;
                $scope.disablePrev = $scope.currentSkip == 0;
                $scope.disableNext = ($scope.currentSkip + recordsPerPage) >= $scope.totalRecords;
                calcPages();
                return true;
            });
        };

        $scope.checkFtypes = function () {
            var field = _.findWhere($scope.recordFilterFields, {
                key: $scope.filterField
            });
            var ftypes = field.ftypes;
            $scope.ftypes = constants[ftypes];
            $scope.ftype = $scope.ftypes[0].key;
        };
    
        $scope.search = function () {
            $scope.currentSkip = 0;
            recordsPerPage = constants.recordsPerPage;
      
            if (typeof $scope.tableState !== 'undefined' && typeof $scope.tableState.sort !== 'undefined') {
                $scope.tableState.sort = {};
            }
      
            $scope.getRecords();
        };

        $scope.viewRecord = function (recordID) {
            $localStorage.recordID = recordID;
            $state.go(viewStateName);
        };

        $scope.disableRecordModal = function (record) {
            var recordID = record[$scope.recordIDFieldName];
            var msg = $translate.instant(disableRecordMsg);
            var result = confirm(msg);

            if (result) {
                $scope.disableRecord(recordID);
            }
        };

        $scope.disableRecord = function (recordID) {
            disableRecordFn(recordID).then(function (response) {
                if (response.status === 200) {
                    $scope.buildDisableToastr($translate.instant(disableRecordSuccessMsg), $translate.instant(disableRecordTitle), 4000);
                } else {
                    var errorMsg = $translate.instant(disableRecordErrorMsg);
                    $scope.buildToastr(errorMsg, $translate.instant(warningTitle), 4000);
                }
            });
        };

        $scope.enableRecordModal = function (record) {
            var recordID = record[$scope.recordIDFieldName];
            var msg = $translate.instant(enableRecordMsg);
            var result = confirm(msg);

            if (result) {
                $scope.enableRecord(recordID);
            }
        };

        $scope.enableRecord = function (recordID) {
            enableRecordFn(recordID).then(function (response) {
                if (response.status === 200) {
                    $scope.buildDisableToastr($translate.instant(enableRecordSuccessMsg), $translate.instant(enableRecordTitle), 4000);
                } else {
                    var errorMsg = $translate.instant(enableRecordErrorMsg);
                    $scope.buildToastr(errorMsg, $translate.instant(warningTitle), 4000);
                }
            });
        };
    
        $scope.deleteRecordModal = function (record) {
            var recordID = record[$scope.recordIDFieldName];
            var msg = $translate.instant(deleteRecordMsg);
            var result = confirm(msg);

            if (result) {
                $scope.deleteRecord(recordID);
            }
        };

        $scope.deleteRecord = function (recordID) {
            deleteRecordFn(recordID).then(function (response) {
                if (response.status === 200) {
                    $scope.buildDisableToastr($translate.instant(deleteRecordSuccessMsg), $translate.instant(deleteRecordTitle), 4000);
                } else {
                    var errorMsg = $translate.instant(deleteRecordErrorMsg);
                    $scope.buildToastr(errorMsg, $translate.instant(warningTitle), 4000);
                }
            });
        };
    
        $scope.getPrevPage = function () {
            $scope.currentSkip = !angular.isUndefined($scope.currentSkip) ? $scope.currentSkip - recordsPerPage : 0;
            $scope.getRecords();
        };

        $scope.getNextPage = function () {
            $scope.currentSkip = !angular.isUndefined($scope.currentSkip) ? $scope.currentSkip + recordsPerPage : 0;
            $scope.getRecords();
        };

        $scope.calcFooterColSpan = function () {
            return $scope.rawRecordsFields.filter(function(r){return r.show;}).length + 1 - 2;
        };
    
        var calcPages = function () {
            $scope.currentPage = ($scope.currentSkip / recordsPerPage) + 1;
            $scope.totalPages = Math.ceil($scope.totalRecords / recordsPerPage);
        };
        // #endregion Pagination Methods.

        // #region Notification Methods.
        $scope.buildToastr = function (content, title, timeout) {
            var t = toastr.info(content, title, {
                progressBar: true,
                timeOut: timeout,
                toastClass: 'toast',
                preventDuplicates: true,
                allowHtml: true,
                positionClass: 'toast-top-full-width',
                hideDuration: timeout,
                closeButton: true,
                showDuration: timeout,
                extendedTimeOut: timeout,
                hideMethod: 'noop'
            });
            $rootScope.toast = t;
        };

        $scope.buildDisableToastr = function (content, title, timeout) {
            var t = toastr.info(content, title, {
                progressBar: true,
                timeOut: timeout,
                toastClass: 'toast',
                preventDuplicates: true,
                allowHtml: true,
                positionClass: 'toast-top-full-width',
                hideDuration: timeout,
                closeButton: true,
                showDuration: timeout,
                extendedTimeOut: timeout,
                hideMethod: 'noop'
            });
            t.scope.options.onHidden = function () {
                $scope.getRecords();
            };
            $rootScope.toast = t;
        };
        // #endregion Notification Methods.
    
        $scope.checkRole = function (roles) {
            var adminUser = $localStorage.adminUser || {};
            var adminRole = 'ROLE_ADMIN_USER';

            if (typeof adminUser.role === 'string' && adminUser.role.length > 0) {
                adminRole = adminUser.role;
            }
            if (typeof roles === 'string') {
                return roles === adminRole;
            }
            else if (Array.isArray(roles)) {
                return (roles.indexOf(adminRole) > -1) ? true : false;
            }
            else {
                return false;
            }
        };
    
        // #region White Label Code.
        $scope.hasOrganization = function() {
            return organizationService.hasOrganization();
        };

        $scope.getOrganizationCss = function(css, returnEmpty) {
            return organizationService.getOrganizationCss(css, returnEmpty);
        };

        $scope.getOrganizationKey = function() {
            return organizationService.getOrganizationKey();
        };

        $scope.getOrganizationName = function() {
            return organizationService.getOrganizationName();
        };
        // #endregion White Label Code.
    }
})();

(function () {
    'use strict';

    angular
        .module('intryFrontEnd')
        .controller('UsersController', UsersController);

    /** @ngInject */
    function UsersController($scope, constants, $state, adminService, userService, $localStorage, $rootScope, toastr, $translate, organizationService, $filter, $timeout, ngDialog, noteService) {
        window.scrollTo(0, 0);

        var recordsPerPage = constants.recordsPerPage;

        $scope.userFilterFields = constants.userFilterFields;
        $scope.filterField = constants.userFilterFields[0].key;
        $scope.ftypes = constants.ftypesMultiFields;
        $scope.ftype = $scope.ftypes[0].key;

        $scope.paginationFilter = '';
        $scope.currentSkip = 0;
        $scope.currentPage = 1;
        $scope.totalPages = 1;
        $scope.users = [];
        $scope.totalUsers = 0;
        $scope.tableState = {};

        $scope.includeInactive = true;
        $scope.inactiveToggleText = "Hide Inactive";
        
        $scope.toggleInactive = function () {
            $scope.includeInactive = !$scope.includeInactive;
            if (!$scope.includeInactive) {
                $scope.inactiveToggleText = "Hide Inactive";
            }
            else {
                $scope.inactiveToggleText = "Show Inactive";
            }
            $scope.search();
        };

        // Make the enter key submit the search
        var searchBar = document.getElementById('admin-search-bar');
        if (searchBar) {
            searchBar.addEventListener("keyup", function(event) {
                if (event.key === "Enter") {
                    $scope.search();
                }
            });
        }
        
        $scope.requestCreate = function () {
            $localStorage.registeredUserID = undefined;
            $state.go('admin-create-user');
        };

        // #region Pagination Methods.
        $scope.resetSkip = false;

        $scope.getUsers = function (tableState) {
            $scope.tableState = tableState;
            $scope.getAdminStats();
            $scope.isLoading = true;
            var userData = [];

            if (angular.isUndefined($scope.currentSkip) || $scope.resetSkip) {
                $scope.currentSkip = 0;
                $scope.resetSkip = false;
            }

            var field = $scope.filterField;

            var sort = '';
            var order = '';

            if (typeof tableState !== 'undefined' && typeof tableState.sort.predicate !== 'undefined') {
                sort = tableState.sort.predicate;
                order = (tableState.sort.reverse) ? 1 : -1;
            }

            userService.getUsers($scope.currentSkip, recordsPerPage, field, $scope.paginationFilter, $scope.ftype, sort, order, $scope.includeInactive).then(function (response) {
                if (response.error) {
                    alert("There was an error, users could not be loaded");

                    return false;
                }

                var users = response.data[0]["users"];
                $scope.totalUsers = response.data[1]["total"];

                // #region Prepare the data.
                angular.forEach(users, function (value, key) {
                    var company = '';

                    try {
                        if (value.experience.length >= 1) {
                            angular.forEach(value.experience, function (value, key) {
                                if (value.is_current == true) {
                                    company = value.company;
                                }
                            });
                        }
                    } catch (e) {
                        // Do nothing...
                    }

                    var subscriptionBegin = '';
                    var subscriptionEnd = '';

                    try {
                        if (typeof value.paid_features !== 'undefined' && typeof value.paid_features.bundle_expires !== 'undefined') {
                            subscriptionBegin = moment(value.paid_features.bundle_expires).format('MM/DD/YYYY');
                        }
                        if (typeof value.paid_features !== 'undefined' && typeof value.paid_features.purchase_date !== 'undefined') {
                            subscriptionEnd = moment(value.paid_features.purchase_date).format('MM/DD/YYYY');
                        }
                    } catch (e) {
                        // Do nothing...
                    }

                    // #region Prepare notes.
                    var htmlNotes = "";

                    try {
                        if (Array.isArray(value.notes) && value.notes.length > 0) {
                            htmlNotes = "<table style='text-align: left !important;'>";
                            htmlNotes += "<tr><th style='text-align: left;'>Notes:</th></tr>";

                            for (var i in value.notes) {
                                htmlNotes += "<tr><th style='text-align: left !important;'>" + $filter('date')((value.notes[i].created), 'yyyy-MM-dd hh:mm a') + "<br/>" + value.notes[i].note + "</th></tr>";
                            }

                            htmlNotes += "</table>";
                        }
                    } catch (e) {
                        // Do nothing...
                    }
                    // #endregion Prepare notes.

                    userData.push({
                        'username': value.username,
                        'full_name': value.full_name,
                        'company': company,
                        'status': value.status,
                        'renewal_date': '',
                        'account_type': '',
                        'userID': value.userID,
                        'email_addresses': value.email_addresses,
                        'numberOfResumes': value.numberOfResumes,
                        'downloadedResumes': value.downloadedResumes,
                        'createdResumes': value.createdResumes,
                        'uploadedResumes': value.uploadedResumes,
                        'organizationKey': value.organizationKey,
                        'belongsTo': value.belongsTo,
                        'belongsToObj': value.belongsToObj,
                        'subscription_begin': subscriptionBegin,
                        'subscription_end': subscriptionEnd,
                        'hired': value.hired,
                        'hiredDate': value.hiredDate,
                        'htmlNotes': htmlNotes,
                        'deleted': value.deleted
                    });
                });
                // #endregion Prepare data.

                $scope.isLoading = false;
                $scope.users = userData;
                $scope.disablePrev = $scope.currentSkip == 0;
                $scope.disableNext = ($scope.currentSkip + recordsPerPage) >= $scope.totalUsers;
                calcPages();
                return true;
            });
        };

        $scope.checkFtypes = function () {
            var field = _.findWhere($scope.userFilterFields, {
                key: $scope.filterField
            });
            var ftypes = field.ftypes;
            $scope.ftypes = constants[ftypes];
            $scope.ftype = $scope.ftypes[0].key;
        };

        $scope.search = function () {
            $scope.currentSkip = 0;
            recordsPerPage = constants.recordsPerPage;

            if (typeof $scope.tableState !== 'undefined' && typeof $scope.tableState.sort !== 'undefined') {
                $scope.tableState.sort = {};
            }

            $scope.getUsers();
        };

        $scope.getPrevPage = function () {
            $scope.currentSkip = !angular.isUndefined($scope.currentSkip) ? $scope.currentSkip - recordsPerPage : 0;
            $scope.getUsers();
        };

        $scope.getNextPage = function () {
            $scope.currentSkip = !angular.isUndefined($scope.currentSkip) ? $scope.currentSkip + recordsPerPage : 0;
            $scope.getUsers();
        };

        var calcPages = function () {
            $scope.currentPage = ($scope.currentSkip / recordsPerPage) + 1;
            $scope.totalPages = Math.ceil($scope.totalUsers / recordsPerPage);
        };

        $scope.setResetSkip = function (val) {
            $scope.resetSkip = val;
        };
        // #endregion Pagination Methods.

        // #region Action Methods.
        $scope.viewUser = function (userID) {
            $localStorage.registeredUserID = userID;
            // $state.go('admin-user-details');
            $state.go('admin-create-user');
        };

        $scope.loginAs = function (userID) {
            $localStorage.registeredUserID = userID;
            userService.loginAs(userID).then(function (response) {
                // window.open(window.location.origin,'_blank');
                $state.go('dashboard');
            });
        };

        $scope.hiredModal = function (user) {
            var username = user.username;
            var userID = user.userID;
            var hired = user.hired;
            var msg = '';

            if (hired) msg = $translate.instant('HAS_NO_JOB_TEXT').replace('#####USERNAME#####', username);
            else msg = $translate.instant('HIRED_TEXT').replace('#####USERNAME#####', username);

            var result = confirm(msg);

            if (result) {
                $scope.hired(userID);
            }
        };

        $scope.hired = function (userID) {
            userService.hired(userID).then(function (response) {
                var errorMsg = '';

                try {
                    if (response.status === 200) {
                        $scope.buildRefreshToastr($translate.instant('ADMIN_HIRED_SUCCESS_USER_TEXT'), $translate.instant('ADMIN_CREATE_SUCCESS_TITLE'), 4000);
                    } else {
                        errorMsg = $translate.instant('ADMIN_HIRED_ERROR_USER_TEXT');
                        $scope.buildToastr(errorMsg, $translate.instant('ADMIN_CREATE_WARNING_TITLE'), 4000);
                    }
                } catch (e) {
                    errorMsg = $translate.instant('ADMIN_HIRED_ERROR_USER_TEXT');
                    $scope.buildToastr(errorMsg, $translate.instant('ADMIN_CREATE_WARNING_TITLE'), 4000);
                }
            });
        };

        $scope.disableUserModal = function (user) {
            var username = user.username;
            var userID = user.userID;
            var msg = $translate.instant('DISABLE_USER_TEXT').replace('#####USERNAME#####', username);
            var result = confirm(msg);

            if (result) {
                $scope.disableUser(userID);
            }
        };

        $scope.disableUser = function (userID) {
            userService.adminDisableUser(userID).then(function (response) {
                var errorMsg = '';

                try {
                    if (response.status === 200) {
                        $scope.buildRefreshToastr($translate.instant('ADMIN_DISABLE_SUCCESS_USER_TEXT'), $translate.instant('ADMIN_CREATE_SUCCESS_TITLE'), 4000);
                    } else {
                        errorMsg = $translate.instant('ADMIN_DISABLE_DISABLED_ERROR_USER_TEXT');
                        $scope.buildToastr(errorMsg, $translate.instant('ADMIN_CREATE_WARNING_TITLE'), 4000);
                    }
                } catch (e) {
                    errorMsg = $translate.instant('ADMIN_DISABLE_DISABLED_ERROR_USER_TEXT');
                    $scope.buildToastr(errorMsg, $translate.instant('ADMIN_CREATE_WARNING_TITLE'), 4000);
                }
            });
        };

        $scope.enableUserModal = function (user) {
            var username = user.username;
            var userID = user.userID;
            var msg = $translate.instant('ENABLE_USER_TEXT').replace('#####USERNAME#####', username);
            var result = confirm(msg);

            if (result) {
                $scope.enableUser(userID);
            }
        };

        $scope.enableUser = function (userID) {
            userService.adminEnableUser(userID).then(function (response) {
                var errorMsg = '';

                try {
                    if (response.status === 200) {
                        $scope.buildRefreshToastr($translate.instant('ADMIN_ENABLE_SUCCESS_USER_TEXT'), $translate.instant('ADMIN_CREATE_SUCCESS_TITLE'), 4000);
                    } else {
                        errorMsg = $translate.instant('ADMIN_ENABLE_ENABLED_ERROR_USER_TEXT');
                        $scope.buildToastr(errorMsg, $translate.instant('ADMIN_CREATE_WARNING_TITLE'), 4000);
                    }
                } catch (e) {
                    errorMsg = $translate.instant('ADMIN_ENABLE_ENABLED_ERROR_USER_TEXT');
                    $scope.buildToastr(errorMsg, $translate.instant('ADMIN_CREATE_WARNING_TITLE'), 4000);
                }
            });
        };

        $scope.deleteUserModal = function (user) {
            var username = user.username;
            var userID = user.userID;
            var msg = $translate.instant('DELETE_USER_TEXT').replace('#####USERNAME#####', username);
            var result = confirm(msg);

            if (result) {
                $scope.deleteUser(userID);
            }
        };

        $scope.deleteUser = function (userID) {
            userService.adminDeleteUser(userID).then(function (response) {
                var errorMsg = "";

                try {
                    if (response.status === 200) {
                        $scope.buildRefreshToastr($translate.instant('ADMIN_DELETE_SUCCESS_USER_TEXT'), $translate.instant('ADMIN_CREATE_SUCCESS_TITLE'), 4000);
                    } else {
                        errorMsg = $translate.instant('ADMIN_DELETE_DELETED_ERROR_USER_TEXT');
                        $scope.buildToastr(errorMsg, $translate.instant('ADMIN_CREATE_WARNING_TITLE'), 4000);
                    }
                } catch (e) {
                    errorMsg = $translate.instant('ADMIN_DELETE_DELETED_ERROR_USER_TEXT');
                    $scope.buildToastr(errorMsg, $translate.instant('ADMIN_CREATE_WARNING_TITLE'), 4000);
                }
            });
        };
        // #endregion Action Methods.

        // #region Notification Methods.
        $scope.buildToastr = function (content, title, timeout) {
            var t = toastr.info(content, title, {
                progressBar: true,
                timeOut: timeout,
                toastClass: 'toast',
                preventDuplicates: true,
                allowHtml: true,
                positionClass: 'toast-top-full-width',
                hideDuration: timeout,
                closeButton: true,
                showDuration: timeout,
                extendedTimeOut: timeout,
                hideMethod: 'noop'
            });
            $rootScope.toast = t;
        };

        $scope.buildRefreshToastr = function (content, title, timeout) {
            var t = toastr.info(content, title, {
                progressBar: true,
                timeOut: timeout,
                toastClass: 'toast',
                preventDuplicates: true,
                allowHtml: true,
                positionClass: 'toast-top-full-width',
                hideDuration: timeout,
                closeButton: true,
                showDuration: timeout,
                extendedTimeOut: timeout,
                hideMethod: 'noop'
            });
            t.scope.options.onHidden = function () {
                $scope.getUsers();
            };
            $rootScope.toast = t;
        };
        // #endregion Notification Methods.

        $scope.checkRole = function (roles) {
            var adminUser = $localStorage.adminUser || {};
            var adminRole = 'ROLE_ADMIN_USER';

            if (typeof adminUser.role === 'string' && adminUser.role.length > 0) {
                adminRole = adminUser.role;
            }
            if (typeof roles === 'string') {
                return roles === adminRole;
            }
            else if (Array.isArray(roles)) {
                return (roles.indexOf(adminRole) > -1) ? true : false;
            }
            else {
                return false;
            }
        };

        // #region White Label Code.
        $scope.userFullName = '';
        $scope.numberOfUsers = '';
        $scope.numberOfResumes = '';
        $scope.numberOfHired = '';

        function getUserFullName() {
            var adminUser = $localStorage.adminUser;

            if (
                typeof adminUser !== 'undefined' && adminUser !== null &&
                    typeof adminUser.first_name === 'string' &&
                    typeof adminUser.last_name === 'string'
            ) {
                $scope.userFullName = adminUser.first_name + ' ' + adminUser.last_name;
            }
        };
        getUserFullName();

        $scope.hasOrganization = function() {
            return organizationService.hasOrganization();
        };

        $scope.getOrganizationCss = function(css, returnEmpty) {
            return organizationService.getOrganizationCss(css, returnEmpty);
        };

        $scope.getOrganizationKey = function() {
            return organizationService.getOrganizationKey();
        };

        $scope.getOrganizationName = function() {
            return organizationService.getOrganizationName();
        };

        $scope.getAdminStats = function () {
            try {
                adminService.getAdminStats().then(function (adminStatsResponse) {
                    try {
                        if (adminStatsResponse) {
                            $scope.numberOfUsers = adminStatsResponse.data.numberOfUsers;
                            $scope.numberOfResumes = adminStatsResponse.data.numberOfResumes;
                            $scope.numberOfHired = adminStatsResponse.data.numberOfHired;
                        }
                    } catch (e) {
                        // Do nothing...
                    }
                });
            } catch (e) {
                // Do nothing...
            }
        };
        // #endregion White Label Code.

        // #region Notes Code.
        $scope.selectedUserID = '';
        $scope.model = {
            userNote: ''
        };

        $scope.openAddNoteModal = function (userID) {
            $scope.selectedUserID = userID;
            $scope.model = {
                userNote: ''
            };

            var dialog = {
                templateUrl: 'app/admin/users/template/add-note.html',
                scope: $scope,
                closeByDocument: false,
                closeByEscape: false,
                showClose: false,
                closeByNavigation: true,
                width: '455px',
                height: '100%',
                className: 'add-note-small-dialog',
                onOpenCallback: function () {
                    var element = $(this);
                    if (element.is('.new-ngdialog')) {
                        $timeout(function () {
                            element.find('.modal-content').scrollTop(0);
                        }, 0);
                    }
                }
            };
            ngDialog.openConfirm(dialog);
        };

        $scope.closeAddNoteModal = function () {
            ngDialog.closeAll();
        };

        $scope.addNote = function () {
            var note = {
                userID: $scope.selectedUserID,
                note: $scope.model.userNote,
                createdBy: $localStorage.adminUserID
            };

            noteService.createNote(note).then(function (response) {
                var errorMsg = '';

                try {
                    if (response.status === 201) {
                        ngDialog.closeAll();
                        $scope.buildRefreshToastr($translate.instant('ADMIN_ADD_NOTE_SUCCESS_USER_TEXT'), $translate.instant('ADMIN_CREATE_SUCCESS_TITLE'), 4000);
                    } else {
                        errorMsg = $translate.instant('ADMIN_ADD_NOTE_ENABLED_ERROR_USER_TEXT');
                        $scope.buildToastr(errorMsg, $translate.instant('ADMIN_CREATE_WARNING_TITLE'), 4000);
                    }
                } catch (e) {
                    errorMsg = $translate.instant('ADMIN_ADD_NOTE_ENABLED_ERROR_USER_TEXT');
                    $scope.buildToastr(errorMsg, $translate.instant('ADMIN_CREATE_WARNING_TITLE'), 4000);
                }
            });
        };
        // #endregion Notes Code.
    }
})();

(function () {
    'use strict';

    angular
        .module('intryFrontEnd')
        .controller('TracksController', TracksController);

    /** @ngInject */
    function TracksController($scope, constants, tracksService, $localStorage, $translate, organizationService, $state) {
        window.scrollTo(0, 0);

        var recordsPerPage = constants.recordsPerPage;

        $scope.tracksFilterFields = constants.tracksFilterFields;
        $scope.filterField = constants.tracksFilterFields[0].key;
        $scope.ftypes = constants.ftypesMultiFields;
        $scope.ftype = $scope.ftypes[0].key;

        $scope.paginationFilter = '';
        $scope.maxDate = moment();
        $scope.paginationFilterFrom = moment().subtract(1, 'years').format("MM/DD/YYYY");
        $scope.paginationFilterTo = moment().format("MM/DD/YYYY");
        $scope.currentSkip = 0;
        $scope.currentPage = 1;
        $scope.totalPages = 1;
        $scope.tracks = [];
        $scope.totalTracks = 0;
        $scope.tableState = {};

        // #region Pagination Methods.
        $scope.resetSkip = false;

        $scope.getTracks = function (tableState) {
            $scope.tableState = tableState;
            $scope.isLoading = true;
            var tracksData = [];

            if (angular.isUndefined($scope.currentSkip) || $scope.resetSkip) {
                $scope.currentSkip = 0;
                $scope.resetSkip = false;
            }

            var field = $scope.filterField;

            var sort = '';
            var order = '';

            if (typeof tableState !== 'undefined' && (typeof tableState.sort.predicate !== 'undefined' || typeof tableState.sort.reverse !== 'undefined')) {
                sort = tableState.sort.predicate;
                order = (tableState.sort.reverse) ? -1 : 1;
            } else {
                tableState = tableState || {};
                tableState.sort = {
                    predicate: 'created',
                    reverse: true
                };
                $scope.tableState = tableState;
                sort = tableState.sort.predicate;
                order = (tableState.sort.reverse) ? -1 : 1;
            }

            var filterFrom = -1;

            if (typeof $scope.paginationFilterFrom === 'string' && $scope.paginationFilterFrom.length > 0) {
                filterFrom = moment($scope.paginationFilterFrom + ' 00:00:00 am', 'MM/DD/YYYY hh:mm a').unix();
            }

            var filterTo = -1;

            if (typeof $scope.paginationFilterTo === 'string' && $scope.paginationFilterTo.length > 0) {
                filterTo = moment($scope.paginationFilterTo + ' 11:59:59 pm', 'MM/DD/YYYY hh:mm a').unix();
            }

            tracksService.getTracks($scope.currentSkip, recordsPerPage, field, $scope.paginationFilter, $scope.ftype, sort, order, 'created', filterFrom, filterTo).then(function (response) {
                if (response.error) {
                    alert("There was an error, notes could not be loaded");

                    return false;
                }

                var tracks = response.data[0]['tracks'];
                $scope.totalTracks = response.data[1]['total'];

                try {
                    prepareStats(response.data[2]['stats']);
                } catch (statsError) {
                    console.error('-- (Controller) TracksController.$scope.getTracks() - statsError: ', statsError);
                }

                angular.forEach(tracks, function (value, key) {
                    var notes = _.sortBy(value.notes, 'noteDate');

                    notes.forEach(function (noteNote) {
                        var momentNoteNoteDate = moment(noteNote.noteDate * 1000);
                        noteNote.noteDate = momentNoteNoteDate.format('MM/DD/YYYY hh:mm a');
                        noteNote.noteDateDate = momentNoteNoteDate.format('MM/DD/YYYY');
                        noteNote.noteDateTime = momentNoteNoteDate.format('hh:mm a');
                    });

                    tracksData.push({
                        'trackID': value.trackID,
                        'userID': value.userID,
                        'organizationKey': value.organizationKey,
                        'actionKey': value.actionKey,
                        'actionName': value.actionName,
                        'msg': value.msg,
                        'error': value.error,
                        'deleted': value.deleted,

                        'username': value.username,
                        'full_name': value.full_name,

                        'created': value.created,
                        'updated': value.updated
                    });
                });

                $scope.isLoading = false;
                $scope.tracks = tracksData;
                $scope.disablePrev = $scope.currentSkip == 0;
                $scope.disableNext = ($scope.currentSkip + recordsPerPage) >= $scope.totalTracks;
                calcPages();
                return true;
            });
        };

        $scope.stats = {};

        var initStats = function () {
            $scope.stats = {
                'user-subscribe': {
                    count: 0
                },
                'user-subscribe-free': {
                    count: 0
                },
                'user-subscribe-invitation': {
                    count: 0
                },
                'user-subscribe-invitation-org': {
                    count: 0
                },
                'user-stripe-subscribed': {
                    count: 0
                },
                'user-login': {
                    count: 0
                },
                'assessment-create': {
                    count: 0
                },
                'user-update': {
                    count: 0
                },
                'resume-parse': {
                    count: 0
                },
                'resume-j2r': {
                    count: 0
                },
                'resume-create': {
                    count: 0
                },
                'resume-downloaded': {
                    count: 0
                },
                'resume-deleted': {
                    count: 0
                },
                'unemployed-note-create': {
                    count: 0
                },
                'unemployed-report-downloaded': {
                    count: 0
                },
                'user-update-email': {
                    count: 0
                },
                'user-update-email-confirm': {
                    count: 0
                },
                'user-change-password': {
                    count: 0
                },
                'stripe-change-card': {
                    count: 0
                },
                'user-forgot-password': {
                    count: 0
                },
                'user-reset-password': {
                    count: 0
                },
                'user-cancel-subscription': {
                    count: 0
                },
                'user-reactivate-subscription': {
                    count: 0
                },
                'errors': {
                    count: 0
                }
            };
        };
        initStats();

        var prepareStats = function (stats) {
            try {
                // console.log('-- (Controller) TracksController.prepareStats() - stats: ', stats);

                if (Array.isArray(stats) && stats.length > 0) {
                    stats.forEach(function (stat) {
                        if (typeof $scope.stats[stat.actionKey] !== 'undefined' && $scope.stats[stat.actionKey] !== null) {
                            $scope.stats[stat.actionKey].actionName = stat.actionName;
                            $scope.stats[stat.actionKey].count = stat.count;
                        }
                    });
                }

                // console.log('-- (Controller) TracksController.prepareStats() - $scope.stats: ', $scope.stats);
            } catch (e) {
                console.error('-- (Controller) TracksController.prepareStats() - e: ', e);
            }
        };

        $scope.setActionKeyFilter = function (actionKey) {
            $scope.currentSkip = 0;
            $scope.filterField = actionKey;
            $scope.getTracks();
        };

        $scope.checkFtypes = function () {
            var field = _.findWhere($scope.tracksFilterFields, {
                key: $scope.filterField
            });
            var ftypes = field.ftypes;
            $scope.ftypes = constants[ftypes];
            $scope.ftype = $scope.ftypes[0].key;
        };

        $scope.checkFilterDate = function (opt) {
            var from = moment($scope.paginationFilterFrom + ' 00:00:00 am', 'MM/DD/YYYY hh:mm a').unix();
            var to = moment($scope.paginationFilterTo + ' 11:59:59 pm', 'MM/DD/YYYY hh:mm a').unix();

            if (opt === 'from' && from > to) {
                $scope.paginationFilterTo = $scope.paginationFilterFrom;
            } else if (opt === 'to' && to < from) {
                $scope.paginationFilterFrom = $scope.paginationFilterTo;
            }
        };

        $scope.download = function () {
            var tableState = $scope.tableState;
            $scope.isLoading = true;
            if (angular.isUndefined($scope.currentSkip) || $scope.resetSkip) {
                $scope.currentSkip = 0;
                $scope.resetSkip = false;
            }

            var field = $scope.filterField;

            var sort = '';
            var order = '';

            if (typeof tableState !== 'undefined' && typeof tableState.sort.predicate !== 'undefined') {
                sort = tableState.sort.predicate;
                order = (tableState.sort.reverse) ? -1 : 1;
            }

            var filterFrom = -1;

            if (typeof $scope.paginationFilterFrom === 'string' && $scope.paginationFilterFrom.length > 0) {
                filterFrom = moment($scope.paginationFilterFrom + ' 00:00:00 am', 'MM/DD/YYYY hh:mm a').unix();
            }

            var filterTo = -1;

            if (typeof $scope.paginationFilterTo === 'string' && $scope.paginationFilterTo.length > 0) {
                filterTo = moment($scope.paginationFilterTo + ' 11:59:59 pm', 'MM/DD/YYYY hh:mm a').unix();
            }

            tracksService.downloadTracks(field, $scope.paginationFilter, $scope.ftype, sort, order, 'created', filterFrom, filterTo).then(function (response) {
                try {
                    // console.log('-- (Controller) TracksController.$scope.download() - response: ', response);

                    if (response.error) {
                        alert("There was an error, notes could not be download");

                        $scope.isLoading = false;

                        return false;
                    }

                    var fileContentBase64 = response.data.fileContentBase64;
                    var blob = tracksService.base64ToBlob(fileContentBase64, 'application/pdf;charset=utf-8;');
                    var fileName = response.data.fileName;

                    var downloadLink = angular.element('<a></a>');
                    downloadLink.attr('href', window.URL.createObjectURL(blob));
                    downloadLink.attr('download', fileName);
                    downloadLink[0].click();

                    $scope.isLoading = false;

                } catch (e) {
                    console.log('-- (Controller) TracksController.$scope.download() - e: ', e);

                    $scope.isLoading = false;
                }
                return $scope.isLoading;
            });
        };

        $scope.search = function () {
            $scope.currentSkip = 0;
            recordsPerPage = constants.recordsPerPage;

            if (typeof $scope.tableState !== 'undefined' && typeof $scope.tableState.sort !== 'undefined') {
                $scope.tableState.sort = {};
            }

            $scope.getTracks();
        };

        $scope.clear = function () {
            $scope.filterField = constants.tracksFilterFields[0].key;
            $scope.ftype = $scope.ftypes[0].key;
            $scope.paginationFilter = '';
            $scope.paginationFilterFrom = '';
            $scope.paginationFilterTo = '';

            $scope.getTracks();
        };

        $scope.getPrevPage = function () {
            $scope.currentSkip = !angular.isUndefined($scope.currentSkip) ? $scope.currentSkip - recordsPerPage : 0;
            $scope.getTracks();
        };

        $scope.getNextPage = function () {
            $scope.currentSkip = !angular.isUndefined($scope.currentSkip) ? $scope.currentSkip + recordsPerPage : 0;
            $scope.getTracks();
        };

        var calcPages = function () {
            $scope.currentPage = ($scope.currentSkip / recordsPerPage) + 1;
            $scope.totalPages = Math.ceil($scope.totalTracks / recordsPerPage);
        };

        $scope.setResetSkip = function (val) {
            $scope.resetSkip = val;
        };
        // #endregion Pagination Methods.

        // #region Action Methods.
        $scope.viewUser = function (userID) {
            $localStorage.registeredUserID = userID;
            $state.go('admin-create-user');
        };
        // #endregion Action Methods.

        $scope.checkRole = function (roles) {
            var adminUser = $localStorage.adminUser || {};
            var adminRole = 'ROLE_ADMIN_USER';

            if (typeof adminUser.role === 'string' && adminUser.role.length > 0) {
                adminRole = adminUser.role;
            }
            if (typeof roles === 'string') {
                return roles === adminRole;
            }
            else if (Array.isArray(roles)) {
                return (roles.indexOf(adminRole) > -1) ? true : false;
            }
            else {
                return false;
            }
        };

        // #region White Label Code.
        $scope.hasOrganization = function() {
            return organizationService.hasOrganization();
        };

        $scope.getOrganizationCss = function(css, returnEmpty) {
            return organizationService.getOrganizationCss(css, returnEmpty);
        };

        $scope.getOrganizationKey = function() {
            return organizationService.getOrganizationKey();
        };

        $scope.getOrganizationName = function() {
            return organizationService.getOrganizationName();
        };
        // #endregion White Label Code.
    }
})();

(function () {
	'use strict';

	angular
		.module('intryFrontEnd')
		.directive('okPassword', okPassword);

	function okPassword(zxcvbn) {
		var directive = {
			restrict: 'AC',
			require: 'ngModel',
			link: function ($scope, $element, $attrs, ngModelCtrl) {
				$element.on('focus change keydown', function (evt) {
					$scope.$evalAsync(function ($scope) {
						// update the $scope.password with the element's value
						var pwd = $scope.password = $element.val();

						// resolve password strength score using zxcvbn service
						$scope.passwordStrength = pwd ? (pwd.length > 7 && zxcvbn.score(pwd) || 0) : null;
						// define the validity criterion for okPassword constraint
						//ngModelCtrl.$setValidity('okPassword', $scope.passwordStrength >= 2);
					});
				});
			}
		}
		return directive;
	}
})();
(function () {
	'use strict';

	angular
		.module('intryFrontEnd')
		.directive('compareTo', compareTo);

	function compareTo() {
		var directive = {
			require: 'ngModel',
			scope: {
				otherModelValue: "=compareTo"
			},
			link: function (scope, element, attributes, ngModel) {
				ngModel.$validators.compareTo = function (modelValue) {
					var txt = modelValue == scope.otherModelValue;
					return modelValue == scope.otherModelValue;
				};

				scope.$watch("otherModelValue", function () {
					ngModel.$validate();
				});
			}
		}
		return directive;
	}
})();
(function () {
    'use strict';

    angular
        .module('intryFrontEnd')
        .controller('RegisterAdminController', RegisterAdminController);

    /** @ngInject */
    function RegisterAdminController(
        $scope,
        $timeout,
        adminService,
        modalService,
        $cookies,
        ngDialog,
        $state,
        constants,
        JWTService,
        $mdToast,
        $log,
        organizationService
    ) {

        window.scrollTo(0, 0);
        
        $scope.newUser = {};
        var vm = this;
        $scope.formSetup = {
            startedToRegister: false,
            alreadyRegistered: false,
            passwordHint: false,
            password2Hint: false,
            validPassword: /^.{8,}$/,
            passStrength: 1
        };


        var last = {
            bottom: true,
            top: false,
            left: true,
            right: false
        };

        // Pick up values from admin trying to login to customer interface
        if (localStorage.getItem('redirect-email') && localStorage.getItem('redirect-pass')) {
            vm.email = localStorage.getItem('redirect-email');
            vm.password = localStorage.getItem('redirect-pass');
            localStorage.removeItem('redirect-email');
            localStorage.removeItem('redirect-pass');
        }
        vm.toastPosition = angular.extend({}, last);

        vm.getToastPosition = function () {
            sanitizePosition();
            return Object.keys(vm.toastPosition)
                .filter(function (pos) {
                    return vm.toastPosition[pos];
                }).join(' ');
        };

        function sanitizePosition() {
            var current = vm.toastPosition;
            if (current.bottom && last.top) {
                current.top = false;
            }
            if (current.top && last.bottom) {
                current.bottom = false;
            }
            if (current.right && last.left) {
                current.left = false;
            }
            if (current.left && last.right) {
                current.right = false;
            }
            last = angular.extend({}, current);
        }

        vm.showSimpleToast = function (message) {
            var pinTo = vm.getToastPosition();
            $mdToast.show(
                $mdToast.simple()
                    .textContent(message)
                    .position(pinTo)
                    .hideDelay(3000))
                .then(function () {
                    $log.log('Toast dismissed.');
                }).catch(function () {
                    $log.log('Toast failed or was forced to close early by another toast.');
                });
        };

        var resetStateParams = function () {
            vm.email = undefined;
            vm.password = undefined;
            vm.dataLoading = false;
            vm.failLogin = false;
        };

        vm.logOut = function () {
            resetStateParams();
            adminService.logOut();
        };

        vm.login = function () {
            if (typeof vm.email == 'undefined' && typeof vm.password == 'undefined') {
                vm.showSimpleToast('You should type your user and password');
            }
            else {
                JWTService.clearToken();
                vm.dataLoading = true;
                vm.dataLoading = true;
                adminService.login(vm.email, vm.password).then(function (admin) {
                    vm.dataLoading = false;
                    vm.user = admin;
                    $state.go('admin-dashboard');
                }).catch(function (err) {
                    vm.dataLoading = false;
                    vm.failLogin = true;
                    vm.showSimpleToast('Sorry, we do not recognize your username or password. Please try again.');
                    resetStateParams();
                });
            }
        };

        function validatePass(pass, checkPass) {
            if (pass !== checkPass) {
                return false;
            }
            return true;
        }

        $scope.requestCreate = function () {
            $scope.formSetup.startedToRegister = true;
            $('.first-name').focus();
            var isFormReady = Object.keys($scope.newUser).length === 5;
            if (!isFormReady) {
                $('[name="registerForm"]').find('.ng-invalid').first().focus();
                return;
            } else {
                register();
            }
        };

        function register() {
            adminService
                .register($scope.newUser)
                .then(function (response) {
                    if (response.status == 500) {
                        $scope.labelText = response.data.message;
                    } else if (response.status == 201) {
                        adminService
                            .login($scope.newUser.emailPhone, $scope.newUser.password)
                            .then(function (data) {
                                $state.go('admin-dashboard');
                            });
                    } else if (response.status == 400) {
                        $scope.labelText = "User not created.";
                        return false;
                    }
                    vm.dataLoading = true;
                    return true;
                })
                .catch(function (err) {
                    if (err.data.message === 'Admin with this username already exists') {
                        $scope.formSetup.alreadyRegistered = true;
                    } else {
                        alert(err.data.message);
                    }
                });
        }

        // #region White Label Code.
        $scope.hasOrganization = function() {
            return organizationService.hasOrganization();
        };

        $scope.getOrganizationCss = function(css, returnEmpty) {
            return organizationService.getOrganizationCss(css, returnEmpty);
        };

        $scope.getOrganizationKey = function() {
            return organizationService.getOrganizationKey();
        };

        $scope.getOrganizationName = function() {
            return organizationService.getOrganizationName();
        };

        $scope.loginPanel1CssClass = function() {
            var css = 'signup-image-wrapper w-col w-col-6';

            // try {
            //     var organizationKey = $scope.getOrganizationKey();
            //     if (organizationKey.length > 0) {
            //         css = ' signup-image-wrapper w-col w-col-12 ' + organizationKey;
            //     }
            // } catch (e) {
            //     // Do nothing...
            // }

            css = ' signup-image-wrapper w-col w-col-12 ' + $scope.getOrganizationKey();

            return css;
        };
        // #endregion White Label Code.
    }
})();

(function () {
    'use strict';

    angular
        .module('intryFrontEnd')
        .controller('OrganizationsController', OrganizationsController);

    /** @ngInject */
    function OrganizationsController($scope, constants, $state, organizationService, $localStorage, $rootScope, toastr, $translate) {
        window.scrollTo(0, 0);

        // #region Custom configurations.
        $scope.paginationTitle = 'ADMIN_SECTION_ORGANIZATIONS_TITLE';
        $scope.addRecordTooltip = 'ADMIN_SECTION_ADD_ORGANIZATION_TEXT';
        $scope.addRecordCssClass = 'organizations-icon';
        $scope.addRecordIcon = 'work';
        
        var recordFilterFields = constants.organizationFilterFields;
        var getRawRecordsFn = organizationService.getOrganizations;
        var rawRecordsDatasetName = 'organizations';
        var rawRecordsDatasetTotalName = 'total';
        $scope.rawRecordsFields = [
            {key: 'organizationID', show: false},
            {key: 'organizationKey', show: true, translate: 'ADMIN_SECTION_ORGANIZATIONS_KEY_HEAD_TITLE'},
            {key: 'name', show: true, translate: 'ADMIN_SECTION_ORGANIZATIONS_NAME_HEAD_TITLE'},
            // {key: 'location', show: true, translate: 'ADMIN_SECTION_ADMINS_LOCATION_KEY_HEAD_TEXT'},
            {key: 'hostname', show: true, translate: 'ADMIN_SECTION_ORGANIZATIONS_HOSTNAME_HEAD_TITLE'},
            {key: 'selfRegistration', show: true, translate: 'ADMIN_SECTION_ORGANIZATIONS_SELF_REGISTRATION_HEAD_TITLE', fn: function (val) {
                if (val) {
                    return 'Yes';
                } else {
                    return 'No';
                }
            }},
            {key: 'status', show: true, translate: 'ADMIN_SECTION_ORGANIZATIONS_STATUS_HEAD_TITLE'},
            {key: 'deleted', show: false}
        ];
        $scope.getVal = function (val, field) {
            return (typeof field.fn === 'function') ? field.fn(val) : val;
        };
        var viewStateName = 'admin-create-organization';
        $scope.recordIDFieldName = 'organizationID';
        
        var disableRecordFn = organizationService.disableOrganization;
        var disableRecordTitle = 'ADMIN_SECTION_ORGANIZATIONS_DISABLE_TITLE';
        var disableRecordMsg = 'ADMIN_SECTION_ORGANIZATIONS_DISABLE_TEXT';
        var disableRecordSuccessMsg = 'ADMIN_SECTION_ORGANIZATIONS_DISABLE_SUCCESS_TEXT';
        var disableRecordErrorMsg = 'ADMIN_SECTION_ORGANIZATIONS_DISABLE_ERROR_TEXT';
        
        var enableRecordFn = organizationService.enableOrganization;
        var enableRecordTitle = 'ADMIN_SECTION_ORGANIZATIONS_ENABLE_TITLE';
        var enableRecordMsg = 'ADMIN_SECTION_ORGANIZATIONS_ENABLE_TEXT';
        var enableRecordSuccessMsg = 'ADMIN_SECTION_ORGANIZATIONS_ENABLE_SUCCESS_TEXT';
        var enableRecordErrorMsg = 'ADMIN_SECTION_ORGANIZATIONS_ENABLE_ERROR_TEXT';
        
        var deleteRecordFn = organizationService.deleteOrganization;
        var deleteRecordTitle = 'ADMIN_SECTION_ORGANIZATIONS_DELETE_TITLE';
        var deleteRecordMsg = 'ADMIN_SECTION_ORGANIZATIONS_DELETE_TEXT';
        var deleteRecordSuccessMsg = 'ADMIN_SECTION_ORGANIZATIONS_DELETE_SUCCESS_TEXT';
        var deleteRecordErrorMsg = 'ADMIN_SECTION_ORGANIZATIONS_DELETE_ERROR_TEXT';
        
        var warningTitle = 'ADMIN_SECTION_ORGANIZATIONS_WARNING_TITLE';
        // #endregion Custom configurations.
        
        var recordsPerPage = constants.recordsPerPage;
        
        $scope.recordFilterFields = recordFilterFields;
        $scope.filterField = recordFilterFields[0].key;
        $scope.ftypes = constants.ftypesMultiFields;
        $scope.ftype = $scope.ftypes[0].key;
        
        $scope.paginationFilter = '';
        $scope.currentSkip = 0;
        $scope.currentPage = 1;
        $scope.totalPages = 1;
        $scope.records = [];
        $scope.totalRecords = 0;
        $scope.tableState = {};

        $scope.createRecord = function () {
            $localStorage.recordID = undefined;
            $state.go(viewStateName);
        };

        // #region Pagination Methods.
        $scope.getRecords = function (tableState) {
            $scope.tableState = tableState;
            $scope.isLoading = true;

            var records = [];

            if (angular.isUndefined($scope.currentSkip)) {
                $scope.currentSkip = 0;
            }

            var field = $scope.filterField;
            
            var sort = '';
            var order = '';

            if (typeof tableState !== 'undefined' && typeof tableState.sort.predicate !== 'undefined') {
                sort = tableState.sort.predicate;
                order = (tableState.sort.reverse) ? 1 : -1;
            }
            
            getRawRecordsFn($scope.currentSkip, recordsPerPage, field, $scope.paginationFilter, $scope.ftype, sort, order).then(function (response) {
                if (response.error) {
                    alert("There was an error, administrators could not be loaded");

                    return false;
                }

                var rawRecords = response.data[0]/*[rawRecordsDatasetName]*/;
                console.log(response.data);
                $scope.totalRecords = response.data[1]/*[rawRecordsDatasetTotalName]*/;

                angular.forEach(rawRecords, function (value, key) {
                    var record = {};
                    for (var i in $scope.rawRecordsFields) {
                        record[$scope.rawRecordsFields[i].key] = value[$scope.rawRecordsFields[i].key];
                      
                      
                    }

                    record['location']="LOCATION"
                    records.push(record);
                });

                $scope.isLoading = false;
                $scope.records = records;
                $scope.disablePrev = $scope.currentSkip == 0;
                $scope.disableNext = ($scope.currentSkip + recordsPerPage) >= $scope.totalRecords;
                calcPages();
                return true;
            });
        };

        $scope.checkFtypes = function () {
            var field = _.findWhere($scope.recordFilterFields, {
                key: $scope.filterField
            });
            var ftypes = field.ftypes;
            $scope.ftypes = constants[ftypes];
            $scope.ftype = $scope.ftypes[0].key;
        };
        
        $scope.search = function () {
            $scope.currentSkip = 0;
            recordsPerPage = constants.recordsPerPage;
            
            if (typeof $scope.tableState !== 'undefined' && typeof $scope.tableState.sort !== 'undefined') {
                $scope.tableState.sort = {};
            }
            
            $scope.getRecords();
        };

        $scope.viewRecord = function (recordID) {
            $localStorage.recordID = recordID;
            $state.go(viewStateName);
        };

        $scope.disableRecordModal = function (record) {
            var recordID = record[$scope.recordIDFieldName];
            var msg = $translate.instant(disableRecordMsg);
            var result = confirm(msg);

            if (result) {
                $scope.disableRecord(recordID);
            }
        };

        $scope.disableRecord = function (recordID) {
            disableRecordFn(recordID).then(function (response) {
                if (response.status === 200) {
                    $scope.buildDisableToastr($translate.instant(disableRecordSuccessMsg), $translate.instant(disableRecordTitle), 4000);
                } else {
                    var errorMsg = $translate.instant(disableRecordErrorMsg);
                    $scope.buildToastr(errorMsg, $translate.instant(warningTitle), 4000);
                }
            });
        };

        $scope.enableRecordModal = function (record) {
            var recordID = record[$scope.recordIDFieldName];
            var msg = $translate.instant(enableRecordMsg);
            var result = confirm(msg);

            if (result) {
                $scope.enableRecord(recordID);
            }
        };

        $scope.enableRecord = function (recordID) {
            enableRecordFn(recordID).then(function (response) {
                if (response.status === 200) {
                    $scope.buildDisableToastr($translate.instant(enableRecordSuccessMsg), $translate.instant(enableRecordTitle), 4000);
                } else {
                    var errorMsg = $translate.instant(enableRecordErrorMsg);
                    $scope.buildToastr(errorMsg, $translate.instant(warningTitle), 4000);
                }
            });
        };
        
        $scope.deleteRecordModal = function (record) {
            var recordID = record[$scope.recordIDFieldName];
            var msg = $translate.instant(deleteRecordMsg);
            var result = confirm(msg);

            if (result) {
                $scope.deleteRecord(recordID);
            }
        };

        $scope.deleteRecord = function (recordID) {
            deleteRecordFn(recordID).then(function (response) {
                if (response.status === 200) {
                    $scope.buildDisableToastr($translate.instant(deleteRecordSuccessMsg), $translate.instant(deleteRecordTitle), 4000);
                } else {
                    var errorMsg = $translate.instant(deleteRecordErrorMsg);
                    $scope.buildToastr(errorMsg, $translate.instant(warningTitle), 4000);
                }
            });
        };
        
        $scope.getPrevPage = function () {
            $scope.currentSkip = !angular.isUndefined($scope.currentSkip) ? $scope.currentSkip - recordsPerPage : 0;
            $scope.getRecords();
        };

        $scope.getNextPage = function () {
            $scope.currentSkip = !angular.isUndefined($scope.currentSkip) ? $scope.currentSkip + recordsPerPage : 0;
            $scope.getRecords();
        };

        $scope.calcFooterColSpan = function () {
            return $scope.rawRecordsFields.filter(function(r){return r.show;}).length + 1 - 4;
        };
        
        var calcPages = function () {
            $scope.currentPage = ($scope.currentSkip / recordsPerPage) + 1;
            $scope.totalPages = Math.ceil($scope.totalRecords / recordsPerPage);
        };
        // #endregion Pagination Methods.

        // #region Notification Methods.
        $scope.buildToastr = function (content, title, timeout) {
            var t = toastr.info(content, title, {
                progressBar: true,
                timeOut: timeout,
                toastClass: 'toast',
                preventDuplicates: true,
                allowHtml: true,
                positionClass: 'toast-top-full-width',
                hideDuration: timeout,
                closeButton: true,
                showDuration: timeout,
                extendedTimeOut: timeout,
                hideMethod: 'noop'
            });
            $rootScope.toast = t;
        };

        $scope.buildDisableToastr = function (content, title, timeout) {
            var t = toastr.info(content, title, {
                progressBar: true,
                timeOut: timeout,
                toastClass: 'toast',
                preventDuplicates: true,
                allowHtml: true,
                positionClass: 'toast-top-full-width',
                hideDuration: timeout,
                closeButton: true,
                showDuration: timeout,
                extendedTimeOut: timeout,
                hideMethod: 'noop'
            });
            t.scope.options.onHidden = function () {
                $scope.getRecords();
            };
            $rootScope.toast = t;
        };
        // #endregion Notification Methods.
        
        $scope.checkRole = function (roles) {
            var adminUser = $localStorage.adminUser || {};
            var adminRole = 'ROLE_ADMIN_USER';

            if (typeof adminUser.role === 'string' && adminUser.role.length > 0) {
                adminRole = adminUser.role;
            }
            if (typeof roles === 'string') {
                return roles === adminRole;
            }
            else if (Array.isArray(roles)) {
                return (roles.indexOf(adminRole) > -1) ? true : false;
            }
            else {
                return false;
            }
        };

        // #region White Label Code.
        $scope.hasOrganization = function() {
            return organizationService.hasOrganization();
        };

        $scope.getOrganizationCss = function(css, returnEmpty) {
            return organizationService.getOrganizationCss(css, returnEmpty);
        };
        
        $scope.getOrganizationKey = function() {
            return organizationService.getOrganizationKey();
        };
        
        $scope.getOrganizationName = function() {
            return organizationService.getOrganizationName();
        };
        // #endregion White Label Code.
    }
})();

(function () {
    'use strict';

    angular
        .module('intryFrontEnd')
        .controller('DetailsController', DetailsController);

    /** @ngInject */
    function DetailsController($scope, $timeout, userService, $cookies, ngDialog, $state, modalService, resumeService, $localStorage, constants, utilsService) {
        var vm = this;
        $scope.model = {};
        $scope.subscription_types = constants.subscription_types_list;
        $scope.user_types = constants.user_types_list;
        $scope.dataSaved = false;
        $scope.controlError = [false, false, false, false]; // First_name, Last_name, Email, Phone 
        window.scrollTo(0, 0);

        var userID = $localStorage.registeredUserID;
        var user_details = [];
        var edit_phoneNumbers = [];
        var edit_emailAddresses = [];
        var subscriptionId = '';
        var currentPlan = '';
        var subscriptionPlanId = '';

        userService
            .getRegisteredUser(userID)
            .then(function (response) {
                vm.user = response.data;
                vm.profilePicture = !angular.isUndefined(vm.user.attachments[0]) ? vm.user.attachments[0].file : null;

                $scope.model.first_name = vm.user.first_name;
                $scope.model.last_name = vm.user.last_name;

                edit_emailAddresses = vm.user.email_addresses;
                if(vm.user.email_addresses.length > 0)
                    $scope.model.email_address = vm.user.email_addresses[0].address;
                else
                    $scope.model.email_address = '';

                edit_phoneNumbers = vm.user.phone_numbers;
                if(vm.user.phone_numbers.length > 0)
                    $scope.model.phone_number = vm.user.phone_numbers[0].number;   
                else
                    $scope.model.phone_number = '';

                vm.user.account_name = '';  // this is a placeholder for future updates
                if ((vm.user.paid_features || {}).free_trial_expire) {
                    $scope.license_expires = utilsService.formatDate(new Date(vm.user.paid_features.free_trial_expire), "MMM D, YYYY");
                }
                else {
                    $scope.license_expires = null;
                }
                $scope.model.source = '';   // This is a placeholdeer for future udpates
                $scope.model.user_type = $scope.user_types[0];  // This is a placeholdeer for future udpates
                userService.getAccountByUserId(vm.user.userID).then(function(customer){
                    populateNextCharge(customer.data.subscriptions.data[0]);
                    populateSubscriptionDetails(customer.data.subscriptions.data[0]);
                    saveSubscriptionID(customer.data.subscriptions.data[0]);
                });
            });

        /** Get all resumes for the selected user */
        resumeService
            .getResumeLinks(userID)
            .then(function (response) {
                vm.resumes = response.data;
            });

        // $scope.updateAccount = function () {
        //     saveAccountType();
        // };

        $scope.toUsers = function () {
            $state.go('admin-users');
        };

        $scope.toDetails = function () {
            $state.go('admin-user-details');
        };

        function validate() {
            var isValid = true;

            if ($scope.model.first_name == '') {
                $scope.controlError[0] = true;
                isValid = false;
            }

            if ($scope.model.last_name == '') {
                $scope.controlError[1] = true;
                isValid = false;
            }

            if($scope.model.phone_number != ''){
                var elem = angular.element(document.querySelector("#phone_number"));
                if($scope.model.phone_number.match(constants.USA_PHONE_PATTERN) == null) {
                    $scope.controlError[3] = true;
                    isValid = false;
                }
            }

            // Need to find a way to share regex across webapp and api layer
            if ($scope.model.email_address != '') {
                var elem = angular.element(document.querySelector("#email_address"));
                if ($scope.model.email_address.match(constants.EMAIL_PATTERN) == null) {
                    isValid = false;
                    $scope.controlError[2] = true;
                }
            }
            return isValid;
        }

        function populateNextCharge(data) {
            $scope.next_billing_date = data.current_period_end;
            $scope.created_date = data.start;
        }

        function saveSubscriptionID(data){
            subscriptionId = data.id;
        }
        
        function populateSubscriptionDetails(data){
            currentPlan = $scope.model.subscription_type = data.items.data[data.items.data.length -1].plan.id;
            subscriptionPlanId = data.items.data[data.items.data.length -1].id;
        }

        $scope.save = function () {
            if (validate()) {
                $scope.controlError = [false, false, false, false]; // Reset the errors

                var full_name = vm.user.full_name;
                if ($scope.model.first_name != vm.user.first_name || $scope.model.last_name != vm.user.last_name)
                    full_name = $scope.model.first_name + ' ' + $scope.model.last_name;  

                if (edit_phoneNumbers.length > 0) {
                    delete edit_phoneNumbers[0].updated;
                    delete edit_phoneNumbers[0].created;
                    edit_phoneNumbers[0].number = $scope.model.phone_number;
                }
                else if ($scope.model.phone_number != ''){
                    edit_phoneNumbers = [{"number": $scope.model.phone_number, "kind": constants.kind_phone_list[0]}];
                }

                if (edit_emailAddresses.length > 0) {
                    delete edit_emailAddresses[0].updated;
                    delete edit_emailAddresses[0].created;
                    edit_emailAddresses[0].address = $scope.model.email_address;
                }
                else if($scope.model.email_address != ''){
                    edit_emailAddresses = [{"address": $scope.model.email_address, "kind": constants.constants.kind_list[2] }];
                }

                // NEED TO ADD 'ACCOUNT TYPE' and 'SOURCE' IN THE FUTURE WHEN IMPLEMENTED 
                var user = { "first_name": $scope.model.first_name, "last_name": $scope.model.last_name, "full_name": full_name};

                if (edit_phoneNumbers.length > 0){
                    user.phone_numbers = edit_phoneNumbers;
                }

                if (edit_emailAddresses.length > 0){
                    user.email_addresses = edit_emailAddresses;
                }

                userService
                    .updateUser(userID, user)
                    .then(function (response) {
                        if (angular.isUndefined(response.data.message)) {
                            $scope.dataSaved = true;
                            vm.user = response.data;
                            // The terms here are wrong. There is subscription type and there is account type which is different
                            // But this is subscription.
                            // $scope.model.subscription_type = vm.user.account.account_type;
                            // there has to be a better way for this
                            var ids=[];
                            if (currentPlan == constants.subscription_types_list[1] && $scope.model.subscription_type == constants.subscription_types_list[0]){
                                ids.push({'id':subscriptionPlanId, 'plan': currentPlan, 'deleted': true });
                                userService
                                    .updateSubscriptions(subscriptionId, ids);
                            }
                            else if (currentPlan != $scope.model.subscription_type) {
                                ids.push({'plan': $scope.model.subscription_type});
                                userService
                                    .updateSubscriptions(subscriptionId, ids);
                            }
                        }
                        else {
                            alert(response.data.message);
                        }
                    });
            }
        };
        
    }
})();

/* global Chart */

(function () {
    "use strict";

    angular
        .module("intryFrontEnd")
        .controller("AdminDashboardController", AdminDashboardController);

    /** @ngInject */
    function AdminDashboardController(
        $scope,
        $localStorage,
        organizationService,
        tracksService
    ) {
        var vm = this;
        $scope.model = {};
        window.scrollTo(0, 0);

        $scope.checkRole = function (roles) {
            var adminUser = $localStorage.adminUser || {};
            var adminRole = "ROLE_ADMIN_USER";

            if (typeof adminUser.role === "string" && adminUser.role.length > 0) {
                adminRole = adminUser.role;
            }
            if (typeof roles === "string") {
                return roles === adminRole;
            } else if (Array.isArray(roles)) {
                return roles.indexOf(adminRole) > -1 ? true : false;
            } else {
                return false;
            }
        };

        var noActivity = {
            labels: new Array(12).fill(""),
            active: new Array(12).fill(0),
            created: new Array(12).fill(0),
            updated: new Array(12).fill(0)
        };
 
        var noAssessments = {
            labels: new Array(12).fill(""),
            assessments: new Array(12).fill(0),
            active: new Array(12).fill(0),
            created: new Array(12).fill(0),
            updated: new Array(12).fill(0)
        };

        // #region White Label Code.
        $scope.getOrganizationCss = function (css, returnEmpty) {
            return organizationService.getOrganizationCss(css, returnEmpty);
        };

        $scope.hasOrganization = function () {
            return organizationService.hasOrganization();
        };
        
        $scope.getOrganizationKey = function () {
            return organizationService.getOrganizationKey();
        };

        $scope.getOrganizationName = function () {
            return organizationService.getOrganizationName();
        };

        // #endregion White Label Code.

        $scope.lastYearActivity = null;
        $scope.last6MonthsActivity = null;
        $scope.last3MonthsActivity = null;
        $scope.lastMonthActivity = null;
        
        function setActivityData(lya, norefresh) {
            if (angular.isObject(lya) && Array.isArray(lya.labels) && (lya.labels.length === 12)) {
                $scope.lastYearActivity = lya;
                var na = 6;
                $scope.last6MonthsActivity = {
                    labels: lya.labels.slice(na),
                    active: lya.active.slice(na),
                    updated: lya.updated.slice(na),
                    created: lya.created.slice(na)
                };
                na = 9;
                $scope.last3MonthsActivity = {
                    labels: lya.labels.slice(na),
                    active: lya.active.slice(na),
                    updated: lya.updated.slice(na),
                    created: lya.created.slice(na)
                };
                na = 11;
                $scope.lastMonthActivity = {
                    labels: lya.labels.slice(na),
                    active: lya.active.slice(na),
                    updated: lya.updated.slice(na),
                    created: lya.created.slice(na)
                };
                if (!norefresh) $scope.changeActivityChart();
            }
            else {
                console.error("activity array is null");
            }
        }
        
        // console.debug("init default empty activity");
        setActivityData(noActivity, true);
        
        $scope.changeActivityChart = function () {
            if ($scope.statActivityChart == $scope.statsCharts.yearly) {
                setActivityChart($scope.lastYearActivity);
            } else if ($scope.statActivityChart == $scope.statsCharts.sixMonths) {
                setActivityChart($scope.last6MonthsActivity);
            } else if ($scope.statActivityChart == $scope.statsCharts.threeMonths) {
                setActivityChart($scope.last3MonthsActivity);
            } else {
                setActivityChart($scope.lastMonthActivity);
            }
        };
        
        var setActivityChart = function (data) {
            if (!data) {
                console.error("activity data is null");
                return;
            }
            var context = document
                .getElementById("activity-mix-chart")
                .getContext("2d");
            var gradient = context.createLinearGradient(229, 229, 229, 0.4);
            gradient.addColorStop(0, "rgba(84, 189, 176, .4)");
            gradient.addColorStop(1, "rgba(84, 189, 176, .4)");
            new Chart(context, {
                type: "bar", // Set the initial type to 'bar' for mixed chart
                data: {
                    labels: data.labels,
                    datasets: [
                        {
                            label: "Active",
                            type: "line", // Use line type for the line dataset
                            data: data.active,
                            backgroundColor: "#494F55", // Set the color for the line
                            borderColor: "#494F55", // Set the border color for the line
                            fill: false, // Disable area fill for the line
                        },
                        {
                            label: "Created",
                            type: "bar", // Use bar type for the first bar dataset
                            data: data.created,
                            backgroundColor: getColors().primary, // Set the color for Bar 1
                            borderRadius: 20,
                        },
                        {
                            label: "Updated",
                            type: "bar", // Use bar type for the second bar dataset
                            data: data.updated,
                            backgroundColor: getColors().secondary, // Set the color for Bar 2
                            borderRadius: 20,
                        },
                    ],
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: true,
                    animation: {
                        duration: 0
                    },
                    legend: {
                        display: true,
                    },
                    tooltips: {
                        enabled: true,
                    },
                    scales: {
                        xAxes: [
                            {
                                gridLines: {
                                    display: false,
                                    color: "rgba(0, 0, 0, 0)",
                                },
                            },
                        ],
                        yAxes: [
                            {
                                ticks: {
                                    beginAtZero: true
                                },
                                gridLines: {
                                    display: false,
                                    color: "rgba(0, 0, 0, 0)",
                                },
                            },
                        ],
                    },
                },
            });
        };

        function setAssessmentData(lya, norefresh) {
            if (angular.isObject(lya) &&
                Array.isArray(lya.labels) && (lya.labels.length === 12) &&
                Array.isArray(lya.active) && (lya.active.length === 12)) {
                // console.debug({assessmentData: lya});
                $scope.lastYearAssessment = lya;
                var na = 6;
                $scope.last6MonthsAssessment = {
                    labels: lya.labels.slice(na),
                    active: lya.active.slice(na),
                    assessments: lya.assessments.slice(na)
                };
                na = 9;
                $scope.last3MonthsAssessment = {
                    labels: lya.labels.slice(na),
                    active: lya.active.slice(na),
                    assessments: lya.assessments.slice(na)
                };
                na = 11;
                $scope.lastMonthAssessment = {
                    labels: lya.labels.slice(na),
                    active: lya.active.slice(na),
                    assessments: lya.assessments.slice(na)
                };
                if (!norefresh) $scope.changeAssessmentChart();
            }
            else {
                console.error("assessment array or activity array is null");
            }
        }

        // console.debug("init default empty assessments");
        setAssessmentData(noAssessments, true);

        $scope.changeAssessmentChart = function () {
            if ($scope.statAssessmentChart == $scope.statsCharts.yearly) {
                setAssessmentChart($scope.lastYearAssessment);
            } else if ($scope.statAssessmentChart == $scope.statsCharts.sixMonths) {
                setAssessmentChart($scope.last6MonthsAssessment);
            } else if ($scope.statAssessmentChart == $scope.statsCharts.threeMonths) {
                setAssessmentChart($scope.last3MonthsAssessment);
            } else {
                setAssessmentChart($scope.lastMonthAssessment);
            }
        };

        var setAssessmentChart = function (data) {
            var context = document
                .getElementById("assessment-mix-chart")
                .getContext("2d");
            var gradient = context.createLinearGradient(229, 229, 229, 0.4);
            gradient.addColorStop(0, "rgba(84, 189, 176, .4)");
            gradient.addColorStop(1, "rgba(84, 189, 176, .4)");
            new Chart(context, {
                type: "bar", // Set the initial type to 'bar' for mixed chart
                data: {
                    labels: data.labels,
                    datasets: [
                        {
                            label: "Active",
                            type: "line", // Use line type for the line dataset
                            data: data.active,
                            backgroundColor: "#494F55", // Set the color for the line
                            borderColor: "#494F55", // Set the border color for the line
                            fill: false, // Disable area fill for the line
                        },
                        {
                            label: "Assessment",
                            type: "bar", // Use bar type for the first bar dataset
                            data: data.assessments,
                            backgroundColor: getColors().primary, // Set the color for Bar 1
                            borderRadius: 20,
                        },
                    ],
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: true,
                    animation: {
                        duration: 0
                    },
                    legend: {
                        display: true,
                    },
                    tooltips: {
                        enabled: true,
                    },
                    scales: {
                        xAxes: [
                            {
                                gridLines: {
                                    display: false,
                                    color: "rgba(0, 0, 0, 0)",
                                },
                            },
                        ],
                        yAxes: [
                            {
                                ticks: {
                                    beginAtZero:true
                                },
                                gridLines: {
                                    display: false,
                                    color: "rgba(0, 0, 0, 0)",
                                },
                            },
                        ],
                    },
                },
            });
        };

// (((NOT YET)))

        // Consider making this a tabular report instead.  If there are many case managers stacked bars will not work.
        
        // $scope.caseManagerActivity = {
        //     january2023: [
        //         {
        //             name: 'John Doe',
        //             jobsPlaced: [5],
        //             assignedCases: [3]
        //         },
        //         // Add more case managers here if needed
        //     ],
        //     february2023: [
        //         {
        //             name: 'John Doe',
        //             jobsPlaced: [5],
        //             assignedCases: [3]
        //         },
        //         // Add more case managers here if needed
        //     ],
        //     march2023: [
        //         {
        //             name: 'John Doe',
        //             jobsPlaced: [5],
        //             assignedCases: [3]
        //         },
        //         {
        //             name: 'John Doe',
        //             jobsPlaced: [5],
        //             assignedCases: [3]
        //         },
        //         // Add more case managers here if needed
        //     ]
        // };
        // $scope.months = Object.keys($scope.caseManagerActivity).map(function(month) {
        //     return month.replace(/[0-9]/g, '') + ' ' + month.match(/[0-9]+/); // Concatenate month name and year
        // });

        
        // $scope.statCaseManagerChart = 'january 2023';
        // var getDataCaseManagerChart = function(month) {
        //     var monthNames = [
        //         "January", "February", "March", "April", "May", "June",
        //         "July", "August", "September", "October", "November", "December"
        //     ];
            
        //     var monthYear = month.slice(0, -4); // Remove the last 4 characters (year) from month
        //     var monthIndex = parseInt(monthYear) - 1; // Subtract 1 to get the month index
        //     var year = month.slice(-4); // Get the last 4 characters (year) from month

        //     var formattedMonth = monthYear + " " + year; // Format month as "January 2023"
            

            
        //     var dataKey = month.toLowerCase(); // Convert month to lowercase to match the data object key
        //     var chartData =  $scope.caseManagerActivity[dataKey];
            
        //     return {
        //         labels: [formattedMonth],
        //         data: chartData
        //     };
        // };

        // var setCaseManagersChart = function (data) {

        //     var context = document
        //         .getElementById("case-managers-chart")
        //         .getContext("2d");
        //     var gradient = context.createLinearGradient(229, 229, 229, 0.4);
        //     gradient.addColorStop(0, "rgba(84, 189, 176, .4)");
        //     gradient.addColorStop(1, "rgba(84, 189, 176, .4)");
            
        //     // Sample data for case managers, jobs placed, and assigned cases
        //     var data = getDataCaseManagerChart('january2023');
            
        //     // Create the chart
            
        //     new Chart(context, {
        //         type: 'bar',
        //         data: {
        //             labels: data.labels,
        //             datasets: data.data.map(function (manager) {
        //                 return {
        //                     label: manager.name,
        //                     data: manager.jobsPlaced,
        //                     backgroundColor: getColors().primary,
        //                 };
        //             })
        //         },
        //         options: {
        //             responsive: true,
        //             maintainAspectRatio: true,
        //             animation: {
        //                 duration: 0
        //             },
        //             scales: {
        //                 x: {
        //                     stacked: true
        //                 },
        //                 y: {
        //                     stacked: true,
        //                     beginAtZero: true
        //                 }
        //             }
        //         }
        //     });
            
        // };
// (((END NOT YET)))

// (((NOT YET)))
// This is doable but we need locations
        // var setPieChart = function (elementId) {
        //     var context = document.getElementById("pie-chart").getContext("2d");
        //     new Chart(context, {
        //         type: "pie",
        //         data: {
        //             labels: ["Albany", "Carrollton", "Columbus","LaGrange","Newnan","Opelika","Phenix City","Valdosta"],
        //             datasets: [
        //                 {
        //                     data: [55, 45, 50,90,70,110,33,34],
        //                     backgroundColor: [
        //                         getColors().primary,
        //                         getColors().secondary,
        //                         getColors().third,
        //                         getColors().primary,
        //                         getColors().secondary,
        //                         getColors().third,
        //                         getColors().primary,
        //                         getColors().secondary,
                                
        //                     ],
        //                 },
        //             ],
        //         },
        //         options: {
        //             legend: {
        //                 display: false,
        //                 responsive: true,
        //                 maintainAspectRatio: true,
        //                 animation: {
        //                     duration: 0
        //                 }                        
        //             },
        //         },
        //     });
        // };

// (((END NOT YET)))

        // #region Stats.
        $scope.stats = {
            daily: {
                order: 0,
                title: "Daily Stats",
                stats: [],
            },
            weekly: {
                order: 1,
                title: "Weekly Stats",
                stats: [],
            },
            monthly: {
                order: 2,
                title: "Monthly Stats",
                stats: [],
            },
            yearly: {
                order: 3,
                title: "Yearly Stats",
                stats: [],
            },
        };

        $scope.statsCharts = {
            yearly: { title: "Last Year" },
            sixMonths: { title: "Last 6 Months" },
            threeMonths: { title: "Last 3 Months" },
            lastMonth: { title: "Last Month" },
        };

        $scope.smallStatSelected = $scope.stats.daily;
        $scope.statActivityChart = $scope.statsCharts.yearly;
        $scope.statAssessmentChart = $scope.statsCharts.yearly;

        $scope.changeSmallStat = function () {
            // console.debug($scope.smallStatSelected);
        };

        var getColors = function () {
            var colors = {
                primary: "#712F9F",
                secondary: "#00A997",
                third: "#EB8F38",
            };
            // console.debug("includes goodwill?", $scope.getOrganizationKey());
            // >>> KSH why is this not in the css?  If it can't be,
            // >>> then it should be an organizaton property
            if ($scope.getOrganizationKey().includes("goodwill")) {
                colors.primary = "#0055A4";
                colors.secondary = "#f04845";
                colors.third = "#e8068e";
            }

            return colors;
        };
        
        var initStats = function () {
            var stats = {
                "user-subscribe": {
                    count: 0,
                    actionName: "subscriptions"
                },
                "user-subscribe-free": {
                    count: 0,
                    actionName: "free subscriptions"
                },
                "user-subscribe-invitation": {
                    count: 0,
                    actionName: "invitations"
                },
                "user-subscribe-invitation-org": {
                    count: 0,
                    actionName: "organization invitations"
                },
                "user-stripe-subscribed": {
                    count: 0,
                    actionName: "paid subscriptions"
                },
                "user-login": {
                    count: 0,
                    actionName: "logins"
                },
                "assessment-create": {
                    count: 0,
                    actionName: "assessments"
                },
                "user-update": {
                    count: 0,
                    actionName: "users updates"
                },
                "resume-parse": {
                    count: 0,
                    actionName:'resumes uploaded'
                },
                "resume-j2r": {
                    count: 0,
                    actionName: "job match"
                },
                "resume-create": {
                    count: 0,
                    actionName: "resumes created"
                },
                "resume-downloaded": {
                    count: 0,
                    actionName: "resume downloads"
                },
                "resume-deleted": {
                    count: 0,
                    actionName: "resumes deleted"
                },
                "unemployed-note-create": {
                    count: 0,
                    actionName: "unemployed notes"
                },
                "unemployed-report-downloaded": {
                    count: 0,
                    actionName: "unemployed reports"
                },
                "user-update-email": {
                    count: 0,
                },
                "user-update-email-confirm": {
                    count: 0,
                },
                "user-change-password": {
                    count: 0,
                },
                "stripe-change-card": {
                    count: 0,
                },
                "user-forgot-password": {
                    count: 0,
                },
                "user-reset-password": {
                    count: 0,
                },
                "user-cancel-subscription": {
                    count: 0,
                },
                "user-reactivate-subscription": {
                    count: 0,
                },
                errors: {
                    count: 0,
                },
            };

            return stats;
        };

        // var getActivity = function() {
        //     return tracksService.reportActivity($scope.getOrganizationKey())
        //         .then(function(lya) {
        //             if (lya && !lya.error) {
        //                 setActivityData(lya);
        //                 return true;
        //             }
        //             else {
        //                 // no activity
        //                 return false;
        //             }
        //         })
        //         .catch(function(e) {
        //             // no activity
        //             return false;
        //         });
        // };

        // var getAssessments = function() {
        //     return tracksService.reportAssessments($scope.getOrganizationKey())
        //         .then(function(lya) {
        //             if (lya && !lya.error) {
        //                 setAssessmentData(lya);
        //                 return true;
        //             }
        //             else {
        //                 // no assessments
        //                 return false;
        //             }
        //         })
        //         .catch(function(e) {
        //             // no assessments
        //             console.error(e);
        //             return false;
        //         });
        // };

        var getChartData = function() {
            return tracksService.reportAssessments($scope.getOrganizationKey())
                .then(function(lya) {
                    if (lya && !lya.error) {
                        setActivityData(lya);
                        setAssessmentData(lya);
                        setBoxScore(lya);
                        return true;
                    }
                    else {
                        // no assessments
                        return false;
                    }
                })
                .catch(function(e) {
                    // no assessments
                    console.error(e);
                    return false;
                });
        };

        var getTracks = function () {
            return tracksService.reportTracks($scope.getOrganizationKey())
                .then (function(data) {
                    if (angular.isObject(data) && !data.error) {
                        $scope.stats.daily.stats = prepareStats(data.dailyStats);
                        $scope.stats.weekly.stats = prepareStats(data.weeklyStats);
                        $scope.stats.monthly.stats = prepareStats(data.monthlyStats);
                        $scope.stats.yearly.stats = prepareStats(data.periodStats);
                    }
                    else {
                        console.error(data.error);
                    }
                }).catch(function (e) {
                    console.error(e);
                });
        };

        
        var prepareStats = function (stats) {
            var template = initStats();
            try {
                // console.debug('-- (Controller) AdminDashboardController.prepareStats() - stats: ', stats);

                var finalStats = {
                    "user-subscribe": {
                        count: 0,
                    },
                    "user-subscribe-free": {
                        count: 0,
                    },
                    "user-subscribe-invitation": {
                        count: 0,
                    },
                    "user-subscribe-invitation-org": {
                        count: 0,
                    },
                    "user-stripe-subscribed": {
                        count: 0,
                    },
                    "user-login": {
                        count: 0,
                    },
                    "assessment-create": {
                        count: 0,
                    },
                    "user-update": {
                        count: 0,
                    },
                    "resume-parse": {
                        count: 0,
                    },
                    "resume-j2r": {
                        count: 0,
                    },
                    "resume-create": {
                        count: 0,
                    },
                    "resume-downloaded": {
                        count: 0,
                    },
                    "resume-deleted": {
                        count: 0,
                    },
                    "unemployed-note-create": {
                        count: 0,
                    },
                    "unemployed-report-downloaded": {
                        count: 0,
                    },
                    "user-update-email": {
                        count: 0,
                    },
                    "user-update-email-confirm": {
                        count: 0,
                    },
                    "user-change-password": {
                        count: 0,
                    },
                    "stripe-change-card": {
                        count: 0,
                    },
                    "user-forgot-password": {
                        count: 0,
                    },
                    "user-reset-password": {
                        count: 0,
                    },
                    "user-cancel-subscription": {
                        count: 0,
                    },
                    "user-reactivate-subscription": {
                        count: 0,
                    },
                    errors: {
                        count: 0,
                    },
                };
                for (var sk in stats) {
                    if (stats.hasOwnProperty(sk)) {
                        var count = stats[sk];
                        if (angular.isObject(finalStats[sk])) {
                            finalStats[sk].count = count;
                        }
                    }
                }
                for (var tk in template) {
                    if (template.hasOwnProperty(tk)) {
                        if (angular.isObject(finalStats[tk])) {
                            if (template[tk].actionName) {
                                finalStats[tk].actionName = template[tk].actionName;
                            }
                            else {
                                finalStats[tk].actionName = tk;
                            }
                        }
                    }
                }
                // console.debug('-- (Controller) AdminDashboardController.prepareStats() - finalStats: ', finalStats);
                return finalStats;
            } catch (e) {
                console.error("-- (Controller) AdminDashboardController.prepareStats() - e: ", e);
                return null;
            }
        };

        var init = function () {
            // console.debug("dashboard init");
            $scope.stats.daily.stats = initStats();
            $scope.stats.weekly.stats = initStats();
            $scope.stats.monthly.stats = initStats();
            $scope.stats.yearly.stats = initStats();
            getTracks();
            // GetCharData does it all
            // getActivity();
            // getAssessments();
            getChartData();
            getColors();
        };

        var oneYearAgo = function() {
            return moment().endOf('day').endOf('month').subtract(12, 'months').add(1, 'day').toDate().toLocaleDateString('en-us', { year:"numeric", month:"long", day:"numeric"});
        };
        
        var trackAssessments = function() {
            try {
                return $scope.stats.yearly.stats["assessment-create"].count;
            }
            catch (e) {
                return 0;
            }
        };

        $scope.boxScore = {
            periodStart: oneYearAgo(),
            totalUsersCreated: 0,
            usersMarkedInactive: 0,
            usersInactiveNow: 0,
            usersActiveNow: 0,
            totalAssessments: 0,
            usersWithAssessments: 0,
            averageAssessmentsPerUser: 0.0,
            averageAssessmentsPerAssessedUser: 0.0,
            averageDaysActive: 0
        };

        var sumArray = function(a) {
            var acc = 0;
            if (Array.isArray(a)) {
                for (var i = 0; i < a.length; i++) acc += a[i];
            }
            return acc;
        };
        
        var setBoxScore = function(lya) {
            try {
                var totalUsersCreated = sumArray(lya.created);
                var totalActiveNow = ((lya.active[11] + lya.active[10] + lya.active[9]) / 3).toFixed();
                var trackedAssessments = trackAssessments();
                var totalAssessments = sumArray(lya.assessments);
                var usersWithAssessments = lya.usersWithAssessments;
                if (trackedAssessments > totalAssessments) totalAssessments = trackedAssessments;
                var boxScore = {
                    periodStart: oneYearAgo(),
                    totalUsersCreated: totalUsersCreated,
                    usersMarkedInactive: 40,
                    usersInactiveNow: totalUsersCreated - totalActiveNow,
                    usersActiveNow: totalActiveNow,
                    totalAssessments: totalAssessments,
                    usersWithAssessments: usersWithAssessments,
                    averageAssessmentsPerUser: (totalAssessments / totalUsersCreated).toFixed(2),
                    averageAssessmentsPerAssessedUser: (totalAssessments / usersWithAssessments).toFixed(2),
                    averageDaysActive: lya.averageDaysActive
                };
                $scope.boxScore = boxScore;
            }
            catch(e) {
            }
        };

        var load = function () {
            // console.debug("dashboard load");
            setActivityChart($scope.lastYearActivity);
            setAssessmentChart($scope.lastYearAssessment);
            setBoxScore();
            // (((NOT YET))
            // setCaseManagersChart($scope.lastYearActivity);
            // setPieChart();
            // (((END NOT YET))
        };

        init();
        load();

        // I have no fucking clue why we have to do the init() load() pair above but also do the window.onload.  The symptoms are
        // when we login and go to dashboard, if the pair above is not there, the charts do not draw.  On the other hand
        // if we refresh the browser and the window.onload is not there the charts do not draw.  The window.onload is not called when we
        // come to this screen via $state.go
        window.onload = function() {
            // console.debug("window load");
            init();
            load();
        };
        
        // Another revolting hack because I don't know how to make this ancient fucking angular do the right thing other than this sledge hammer
        var resizing = false;
        window.addEventListener('resize', function(event) {
            if (!resizing) {
                resizing = true;
                // console.debug("window resize");
                setTimeout(function() {
                    init();
                    load();
                    resizing = false;
                }, 300);
            }
        }, true);
        // #endregion Stats.
    }
})();

(function () {
    'use strict';

    angular
        .module('intryFrontEnd')
        .controller('CreateUtmController', CreateUtmController);

    /** @ngInject */
    function CreateUtmController($scope, constants, $localStorage, $rootScope, toastr, $translate, utmService, organizationService) {
        var vm = this;
        $scope.model = {};
        $scope.errors = [];
        $scope.recordStatus = constants.recordStatus;
        $scope.recordDeleted = constants.recordDeleted;
        window.scrollTo(0, 0);

        // #region Custom configurations.
        $scope.recordIDFieldName = 'utmID';
        var createRecordFn = utmService.createUtm;
        var getRecordFn = utmService.getUtm;
        var updateRecordFn = utmService.updateUtm;

        $scope.saveButtonLabel = 'UTM_CREATE_SAVE_BUTTON_TEXT';
        $scope.sidenavButtonLabel = 'UTM_CREATE_SIDEBAR_BUTTON_TEXT';
        var createRecordWarningTitle = 'UTM_CREATE_WARNING_TITLE';
        var createRecordSuccessTitle = 'ADMIN_CREATE_SUCCESS_TITLE';
        var createRecordSuccessMsg = 'UTM_CREATE_SUCCESS_TEXT';
        var createRecordErrorMsg = 'UTM_CREATE_ERROR_TEXT';
        var updateRecordSuccessTitle = 'UTM_UPDATE_SUCCESS_TITLE';
        var updateRecordSuccessMsg = 'UTM_UPDATE_SUCCESS_TEXT';
        var updateRecordErrorMsg = 'UTM__UPDATE_ERROR_TEXT';

        function validate() {
            $scope.errors.length = 0;

            if (angular.isUndefined($scope.model.name) || $scope.model.name.length == 0) {
                $scope.errors.push('Name cannot be empty');
            }

            if (angular.isUndefined($scope.model.utmSource) || $scope.model.utmSource.length == 0) {
                $scope.errors.push('Source cannot be empty');
            }

            if ($scope.errors.length == 0) {
                return true;
            } else {
                $scope.buildToastr($translate.instant('UTM_CREATE_WARNING_TEXT'), $translate.instant('UTM_CREATE_WARNING_TITLE'), 4000);
                return false;
            }
        }
        // #endregion Custom configurations.

        // #region Action Code.
        $scope.action = 'view';

        $scope.loadRecord = function () {
            var recordID = $localStorage.recordID;

            if (typeof recordID !== 'undefined' && recordID !== null && recordID.length > 0) {
                $scope.disableForm();
                getRecordFn(recordID).then(function (response) {
                    try {
                        $scope.model = response.data;
                        $scope.modelBak = angular.copy(response.data);
                    } catch (e) {
                        console.error(e);
                    }
                });
            } else {
                $scope.action = 'create';
            }
        };

        $scope.disableForm = function () {
            $('#personalDataContainer').addClass('div-disabled');
        };

        $scope.enableForm = function () {
            $('#personalDataContainer').removeClass('div-disabled');
        };

        $scope.loadRecord();
        // #endregion Action Code.

        // #region Submit Methods.
        $scope.save = function () {
            if (validate()) {
                if ($scope.action === 'create') {
                    createRecordFn($scope.model)
                        .then(function (response) {
                            var errorMsg = '';

                            if (response.status == 500) {
                                errorMsg = '';
                                try {
                                    errorMsg = response.data.message;
                                } catch (e) {
                                    // Do nothing...
                                }

                                $scope.buildToastr(errorMsg, $translate.instant(createRecordWarningTitle), 4000);
                            } else if (response.status == 201) {
                                $localStorage.recordID = response.data[$scope.recordIDFieldName];
                                $scope.buildSaveToastr($translate.instant(createRecordSuccessMsg), $translate.instant(createRecordSuccessTitle), 4000);
                            } else if (response.status == 400) {
                                errorMsg = $translate.instant(createRecordErrorMsg);
                                try {
                                    errorMsg = response.data.message;
                                } catch (e) {
                                    // Do nothing...
                                }

                                $scope.buildToastr(errorMsg, $translate.instant(createRecordWarningTitle), 4000);
                                return false;
                            }
                            return true;
                        });
                } else {
                    $scope.updateSave();
                }
            }
        };

        $scope.update = function () {
            $scope.enableForm();
            $scope.action = 'update';
        };
1
        $scope.updateSave = function () {
            updateRecordFn($scope.model).then(function (response) {
                var errorMsg = '';

                if (!(angular.isUndefined(response) || response === null)) {
                    if (response.status == 500) {
                        errorMsg = '';
                        try {
                            errorMsg = response.data.message;
                        } catch (e) {
                            // Do nothing...
                        }

                        $scope.buildToastr(errorMsg, $translate.instant(createRecordWarningTitle), 4000);
                    } else if (response.status == 200) {
                        $localStorage.recordID = response.data[$scope.recordIDFieldName];
                        $scope.buildSaveToastr($translate.instant(updateRecordSuccessMsg), $translate.instant(updateRecordSuccessTitle), 4000);
                    } else if (response.status == 400) {
                        $scope.labelText = updateRecordErrorMsg;

                        errorMsg = $translate.instant(updateRecordErrorMsg);
                        try {
                            errorMsg = response.data.message;
                        } catch (e) {
                            // Do nothing...
                        }

                        $scope.buildToastr(errorMsg, $translate.instant(createRecordWarningTitle), 4000);
                        return false;
                    }
                } else {
                    errorMsg = $translate.instant(updateRecordErrorMsg);
                    try {
                        errorMsg = response.data.message;
                    } catch (e) {
                        // Do nothing...
                    }

                    $scope.buildToastr(errorMsg, $translate.instant(createRecordWarningTitle), 4000);
                    return false;
                }
                window.scrollTo(0, 0);
                vm.dataLoading = true;
                return true;
            });
        };

        $scope.updateCancel = function () {
            $scope.disableForm();
            $scope.action = 'view';
            $scope.model = angular.copy($scope.modelBak);
        };
        // #endregion Submit Methods.

        // #region Notification Methods.
        $scope.buildToastr = function (content, title, timeout) {
            var t = toastr.info(content, title, {
                progressBar: true,
                timeOut: timeout,
                toastClass: 'toast',
                preventDuplicates: true,
                allowHtml: true,
                positionClass: 'toast-top-full-width',
                hideDuration: timeout,
                closeButton: true,
                showDuration: timeout,
                extendedTimeOut: timeout,
                hideMethod: 'noop'
            });
            $rootScope.toast = t;
        };

        $scope.buildSaveToastr = function (content, title, timeout) {
            var t = toastr.info(content, title, {
                progressBar: true,
                timeOut: timeout,
                toastClass: 'toast',
                preventDuplicates: true,
                allowHtml: true,
                positionClass: 'toast-top-full-width',
                hideDuration: timeout,
                closeButton: true,
                showDuration: timeout,
                extendedTimeOut: timeout,
                hideMethod: 'noop'
            });
            t.scope.options.onHidden = function () {
                // $scope.toCreate();
                $scope.action = 'view';
                $scope.loadRecord();
            };
            $rootScope.toast = t;
        };
        // #endregion Notification Methods.

        // #region White Label Code.
        $scope.hasOrganization = function() {
            return organizationService.hasOrganization();
        };

        $scope.getOrganizationCss = function(css, returnEmpty) {
            return organizationService.getOrganizationCss(css, returnEmpty);
        };

        $scope.getOrganizationKey = function() {
            return organizationService.getOrganizationKey();
        };

        $scope.getOrganizationName = function() {
            return organizationService.getOrganizationName();
        };
        // #endregion White Label Code.
        $scope.checkRole = function (roles) {
            var adminUser = $localStorage.adminUser || {};
            var adminRole = 'ROLE_ADMIN_USER';

            if (typeof adminUser.role === 'string' && adminUser.role.length > 0) {
                adminRole = adminUser.role;
            }
            if (typeof roles === 'string') {
                return roles === adminRole;
            }
            else if (Array.isArray(roles)) {
                return (roles.indexOf(adminRole) > -1) ? true : false;
            }
            else {
                return false;
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('intryFrontEnd')
        .controller('CreateOrganizationController', CreateOrganizationController);

    /** @ngInject */
    function CreateOrganizationController($scope, constants, $localStorage, $rootScope, toastr, $translate, organizationService) {
        var vm = this;
        $scope.model = {};
        $scope.errors = [];
        $scope.recordStatus = constants.recordStatus;
        $scope.recordDeleted = constants.recordDeleted;
        window.scrollTo(0, 0);
        // >>> KSH
        console.error("what are these hardcoded location keys?");
        $scope.locationKeys = [{id:1,location:"Albany"},{id:2,location:"Carrollton"},{id:3,location:"Columbus"},{id:3,location:"LaGrange"},{id:5,location:"Newnan"},{id:6,location:"Opelika"},{id:7,location:"Phenix City"},{id:8,location:"Valdosta"},];
        // #region Custom configurations.
        $scope.newLocation = "";
        $scope.addLocation = false;
        $scope.recordIDFieldName = 'organizationID';
        var createRecordFn = organizationService.createOrganization;
        var getRecordFn = organizationService.adminGetOrganization;
        var updateRecordFn = organizationService.updateOrganization;

        $scope.saveButtonLabel = 'ORGANIZATION_CREATE_SAVE_BUTTON_TEXT';
        $scope.sidenavButtonLabel = 'ORGANIZATION_CREATE_SIDEBAR_BUTTON_TEXT';
        var createRecordWarningTitle = 'ORGANIZATION_CREATE_WARNING_TITLE';
        var createRecordSuccessTitle = 'ADMIN_CREATE_SUCCESS_TITLE';
        var createRecordSuccessMsg = 'ORGANIZATION_CREATE_SUCCESS_TEXT';
        var createRecordErrorMsg = 'ORGANIZATION_CREATE_ERROR_TEXT';
        var updateRecordSuccessTitle = 'ORGANIZATION_UPDATE_SUCCESS_TITLE';
        var updateRecordSuccessMsg = 'ORGANIZATION_UPDATE_SUCCESS_TEXT';
        var updateRecordErrorMsg = 'ORGANIZATION__UPDATE_ERROR_TEXT';

        $scope.addNewLocationButton = function() {
            $scope.addLocation = true;
        };
        $scope.closeNewLocationButton = function() {
            $scope.addLocation = false;
        };
        function validate() {
            $scope.errors.length = 0;
            if (angular.isUndefined($scope.model.organizationKey) || $scope.model.organizationKey == 0) {
                $scope.errors.push('Organization Key cannot be empty');
            }

            if (angular.isUndefined($scope.model.name) || $scope.model.name.length == 0) {
                $scope.errors.push('Name cannot be empty');
            }

            if (angular.isUndefined($scope.model.hostname) || $scope.model.hostname.length == 0) {
                $scope.errors.push('Hostname cannot be empty');
            }

            if ($scope.errors.length == 0) {
                return true;
            } else {
                $scope.buildToastr($translate.instant('ORGANIZATION_CREATE_WARNING_TEXT'), $translate.instant('ORGANIZATION_CREATE_WARNING_TITLE'), 4000);
                return false;
            }
        }
        // #endregion Custom configurations.

        // #region Action Code.
        $scope.action = 'view';

        $scope.loadRecord = function () {
            var recordID = $localStorage.recordID;

            if (typeof recordID !== 'undefined' && recordID !== null && recordID.length > 0) {
                $scope.disableForm();
                getRecordFn(recordID).then(function (response) {
                    try {
                        $scope.model = response.data;
                        $scope.modelBak = angular.copy(response.data);
                    } catch (e) {
                        console.error(e);
                    }
                });
            } else {
                $scope.action = 'create';
            }
        };

        $scope.disableForm = function () {
            $('#personalDataContainer').addClass('div-disabled');
        };

        $scope.enableForm = function () {
            $('#personalDataContainer').removeClass('div-disabled');
        };

        $scope.loadRecord();
        // #endregion Action Code.

        // #region Submit Methods.
        $scope.save = function () {
            if (validate()) {
                if ($scope.action === 'create') {
                    createRecordFn($scope.model)
                        .then(function (response) {
                            var errorMsg = '';

                            if (response.status == 500) {
                                errorMsg = '';
                                try {
                                    errorMsg = response.data.message;
                                } catch (e) {
                                    console.error(e);
                                }

                                $scope.buildToastr(errorMsg, $translate.instant(createRecordWarningTitle), 4000);
                            } else if (response.status == 201) {
                                $localStorage.recordID = response.data[$scope.recordIDFieldName];
                                $scope.buildSaveToastr($translate.instant(createRecordSuccessMsg), $translate.instant(createRecordSuccessTitle), 4000);
                            } else if (response.status == 400) {
                                errorMsg = $translate.instant(createRecordErrorMsg);
                                try {
                                    errorMsg = response.data.message;
                                } catch (e) {
                                    console.error(e);
                                }

                                $scope.buildToastr(errorMsg, $translate.instant(createRecordWarningTitle), 4000);
                                return false;
                            }
                            return true;
                            
                        });
                } else {
                    $scope.updateSave();
                }
            }
        };

        $scope.update = function () {
            $scope.enableForm();
            $scope.action = 'update';
        };

        $scope.updateSave = function () {
            updateRecordFn($scope.model).then(function (response) {
                var errorMsg = '';

                if (!(angular.isUndefined(response) || response === null)) {
                    if (response.status == 500) {
                        errorMsg = '';
                        try {
                            errorMsg = response.data.message;
                        } catch (e) {
                            // Do nothing...
                        }

                        $scope.buildToastr(errorMsg, $translate.instant(createRecordWarningTitle), 4000);
                    } else if (response.status == 200) {
                        $localStorage.recordID = response.data[$scope.recordIDFieldName];
                        $scope.buildSaveToastr($translate.instant(updateRecordSuccessMsg), $translate.instant(updateRecordSuccessTitle), 4000);
                    } else if (response.status == 400) {
                        $scope.labelText = updateRecordErrorMsg;

                        errorMsg = $translate.instant(updateRecordErrorMsg);
                        try {
                            errorMsg = response.data.message;
                        } catch (e) {
                            // Do nothing...
                        }

                        $scope.buildToastr(errorMsg, $translate.instant(createRecordWarningTitle), 4000);
                        return false;
                    }
                } else {
                    errorMsg = $translate.instant(updateRecordErrorMsg);
                    try {
                        errorMsg = response.data.message;
                    } catch (e) {
                        // Do nothing...
                    }

                    $scope.buildToastr(errorMsg, $translate.instant(createRecordWarningTitle), 4000);
                    return false;
                }
                window.scrollTo(0, 0);
                vm.dataLoading = true;
                return true;
            });
        };

        $scope.updateCancel = function () {
            $scope.disableForm();
            $scope.action = 'view';
            $scope.model = angular.copy($scope.modelBak);
        };
        // #endregion Submit Methods.

        // #region Notification Methods.
        $scope.buildToastr = function (content, title, timeout) {
            var t = toastr.info(content, title, {
                progressBar: true,
                timeOut: timeout,
                toastClass: 'toast',
                preventDuplicates: true,
                allowHtml: true,
                positionClass: 'toast-top-full-width',
                hideDuration: timeout,
                closeButton: true,
                showDuration: timeout,
                extendedTimeOut: timeout,
                hideMethod: 'noop'
            });
            $rootScope.toast = t;
        };

        $scope.buildSaveToastr = function (content, title, timeout) {
            var t = toastr.info(content, title, {
                progressBar: true,
                timeOut: timeout,
                toastClass: 'toast',
                preventDuplicates: true,
                allowHtml: true,
                positionClass: 'toast-top-full-width',
                hideDuration: timeout,
                closeButton: true,
                showDuration: timeout,
                extendedTimeOut: timeout,
                hideMethod: 'noop'
            });
            t.scope.options.onHidden = function () {
                // $scope.toCreate();
                $scope.action = 'view';
                $scope.loadRecord();
            };
            $rootScope.toast = t;
        };
        // #endregion Notification Methods.

        // #region White Label Code.
        $scope.hasOrganization = function() {
            return organizationService.hasOrganization();
        };

        $scope.getOrganizationCss = function(css, returnEmpty) {
            return organizationService.getOrganizationCss(css, returnEmpty);
        };

        $scope.getOrganizationKey = function() {
            return organizationService.getOrganizationKey();
        };

        $scope.getOrganizationName = function() {
            return organizationService.getOrganizationName();
        };
        // #endregion White Label Code.

        $scope.checkRole = function (roles) {
            var adminUser = $localStorage.adminUser || {};
            var adminRole = 'ROLE_ADMIN_USER';

            if (typeof adminUser.role === 'string' && adminUser.role.length > 0) {
                adminRole = adminUser.role;
            }
            if (typeof roles === 'string') {
                return roles === adminRole;
            }
            else if (Array.isArray(roles)) {
                return (roles.indexOf(adminRole) > -1) ? true : false;
            }
            else {
                return false;
            }
        };

    }
})();

(function () {
    'use strict';

    angular
        .module('intryFrontEnd')
        .controller('AdminCreateController', AdminCreateController);

    /** @ngInject */
    function AdminCreateController($scope, $state, adminService, constants, $stateParams, $localStorage, $rootScope, toastr, $translate, organizationService) {
        var vm = this;
        $scope.isProfile = false;
        $scope.model = {};
        $scope.retypepwd = '';
        $scope.errors = [];
        $scope.locationKeys = [];
        $scope.userStatus = constants.userStatus;
        window.scrollTo(0, 0);

        if ($stateParams.isProfile) {
            $localStorage.registeredUserID = $localStorage.adminUserID;
        }

        $scope.setSelectedRole = function(role) {
            if (!role) {
                role = $scope.model.role;
            }
            if (!role) {
                role = 'ROLE_USER_ADMIN';
            }
            var pos = 0;
            for (var i = 0; i < constants.ADMIN_ROLES.length; i++) {
                if (constants.ADMIN_ROLES[i].role === role) {
                    pos = i;
                    break;
                }
            }
            return $scope.selectedRole = constants.ADMIN_ROLES[pos];
        };

        // console.log('-- (Controller) AdminCreateController() - $scope.isProfile: ', $scope.isProfile);

        // #region Action Code.
        $scope.action = 'view';

        $scope.setSelectedRole();

        $scope.signupInfo = null;
        $scope.showSignupCode = false;
        
        function clearSignupCodeInfo() {
            $scope.showSignupCode = false;
            $scope.signupCodeInfo = {            
                code: '',
                expires: new Date(0),
                show: false,
                expiration: "expired"
            };
            return $scope.signupCodeInfo;
        }

        $scope.loadSignupCodeInfo = function(adminUserID) {
            if (adminUserID === $localStorage.adminUserID) {
                adminService.getAdminSignupCode().then(function(result) {
                    // console.log("I GOT: " + JSON.stringify(result));
                    $scope.showSignupCode = true;
                    var expires = result.signupCodeExpires;
                    var code = result.signupCode;
                    $scope.signupCodeInfo = {
                        code: code,
                        expires: expires,
                        show: true,
                        expiration: expires > new Date() ? "expired" : "expires " + moment(expires).format("MM/DD/YYYY")
                    };
                });
            }
            else {
                // other admins don't get to see each others codes
                clearSignupCodeInfo();
            }
        };

        $scope.loadUser = function () {
            var userID = $localStorage.registeredUserID;

            if (typeof userID !== 'undefined' && userID !== null && userID.length > 0) {
                $scope.disableForm();
                clearSignupCodeInfo();
                // console.log("calling loadUser");
                adminService.adminGetAdmin(userID).then(function (response) {
                    try {
                        // schema should have guaranteed this but old bug would have allowed "select"
                        if (response.data.status !== 'inactive' && response.data.status !== 'active') {
                            response.data.status = 'active'; 
                        }
                        $scope.model = response.data;
                        $scope.model = response.data;
                        $scope.modelBak = angular.copy(response.data);
                        $scope.loadSignupCodeInfo(userID);
                    } catch (e) {
                        clearSignupCodeInfo();
                        console.error(e);
                    }
                });
            } else {
                $scope.action = 'create';
            }
        };

        $scope.disableForm = function () {
            $('#personalDataContainer').addClass('div-disabled');
        };

        $scope.enableForm = function () {
            // $scope.setSelectedRole();
            $('#personalDataContainer').removeClass('div-disabled');
        };

        $scope.loadUser();
        // #endregion Action Code.

        function validate() {
            $scope.errors.length = 0;
            if (angular.isUndefined($scope.model.username)) {
                $scope.errors.push('Email cannot be empty');
            }

            if ($scope.action === 'create') {
                if (angular.isUndefined($scope.model.password)) {
                    $scope.errors.push('Password cannot be empty');
                }

                if ($scope.model.password && $scope.model.password.length < 8) {
                    $scope.errors.push('Password should be at least 8 characters long');
                }

                if ($scope.model.password != $scope.retypepwd) {
                    $scope.errors.push('Passwords should match');
                }
            }

            if ($scope.errors.length == 0) {
                return true;
            } else {
                $scope.buildToastr($translate.instant('ADMIN_CREATE_WARNING_TEXT'), $translate.instant('ADMIN_CREATE_WARNING_TITLE'), 4000);
                return false;
            }
        }

        // #region Submit Methods.
        $scope.save = function () {
            if (validate()) {

                // enforce role semantics
                if ($scope.checkRole(['ROLE_APP_ADMIN', 'ROLE_ORGANIZATION_ADMIN'])) {
                    var role = ($scope.selectedRole || {}).role;
                    if (role && ($scope.model.role !== role)) {
                        $scope.model.role = role;
                    }
                }

                if ($scope.model.role === 'ROLE_APP_ADMIN') {
                    $scope.model.organizationKey = '';
                    $scope.model.belongsTo = '';
                }
                else {
                    $scope.model.belongsTo = vm.adminData.userID;
                    $scope.model.organizationKey = vm.adminData.organizationKey || $scope.organizationKey;
                }

                if ($scope.action === 'create') {
                    adminService
                        .adminCreateAdmin($scope.model)
                        .then(function (response) {
                            var errorMsg = '';

                            if (response.status == 500) {
                                errorMsg = '';
                                try {
                                    errorMsg = response.data.message;
                                } catch (e) {
                                    errorMsg = constants.internalError;
                                }
                                $scope.buildToastr(errorMsg, $translate.instant('ADMIN_CREATE_WARNING_TITLE'), 4000);
                            } else if (response.status == 201) {
                                $localStorage.userId = response.data.userID;
                                $localStorage.registeredUserID = response.data.userID;
                                $scope.buildSaveToastr($translate.instant('ADMIN_CREATE_SUCCESS_ADMIN_TEXT'), $translate.instant('ADMIN_CREATE_SUCCESS_TITLE'), 4000);
                                return true;
                            } else if (response.status == 400) {
                                errorMsg = $translate.instant('ADMIN_CREATE_CREATED_ERROR_ADMIN_TEXT');
                                try {
                                    errorMsg = response.data.message;
                                } catch (e) {
                                    errorMsg = constants.internalError;
                                }

                                $scope.buildToastr(errorMsg, $translate.instant('ADMIN_CREATE_WARNING_TITLE'), 4000);
                            } 
                            return false;
                        });
                } else {
                    $scope.updateSave();
                }
            }
        };

        $scope.update = function () {
            $scope.enableForm();
            $scope.action = 'update';
        };

        $scope.updateSave = function () {
            var userID = $localStorage.registeredUserID;

            adminService.adminUpdateAdmin(userID, $scope.model).then(function (response) {
                var errorMsg = '';

                if (!(angular.isUndefined(response) || response === null)) {
                    if (response.status == 500) {
                        errorMsg = '';
                        try {
                            errorMsg = response.data.message;
                        } catch (e) {
                            errorMsg = constants.internalError;
                        }

                        $scope.buildToastr(errorMsg, $translate.instant('ADMIN_CREATE_WARNING_TITLE'), 4000);
                    } else if (response.status == 200) {
                        $localStorage.userId = response.data.userID;
                        $scope.buildSaveToastr($translate.instant('ADMIN_UPDATE_SUCCESS_ADMIN_TEXT'), $translate.instant('ADMIN_CREATE_SUCCESS_TITLE'), 4000);
                    } else if (response.status == 400) {
                        $scope.labelText = "User not created.";

                        errorMsg = $translate.instant('ADMIN_ADMIN_UPDATE_UPDATED_ERROR_USER_TEXT');
                        try {
                            errorMsg = response.data.message;
                        } catch (e) {
                            errorMsg = constants.internalError;
                        }

                        $scope.buildToastr(errorMsg, $translate.instant('ADMIN_CREATE_WARNING_TITLE'), 4000);
                        return false;
                    }
                } else {
                    errorMsg = $translate.instant('ADMIN_ADMIN_UPDATE_UPDATED_ERROR_USER_TEXT');
                    try {
                        errorMsg = response.data.message;
                    } catch (e) {
                        errorMsg = constants.internalError;
                    }

                    $scope.buildToastr(errorMsg, $translate.instant('ADMIN_CREATE_WARNING_TITLE'), 4000);
                    return false;
                }
                window.scrollTo(0, 0);
                vm.dataLoading = true;
                return true;
            });
        };

        $scope.updateCancel = function () {
            $scope.disableForm();
            $scope.action = 'view';
            $scope.model = angular.copy($scope.modelBak);
        };
        
        $scope.createCancel = function () {
            $state.go("admin-admins");
        };
        // #endregion Submit Methods.

        // #region Notification Methods.
        $scope.buildToastr = function (content, title, timeout) {
            var t = toastr.info(content, title, {
                progressBar: true,
                timeOut: timeout,
                toastClass: 'toast',
                preventDuplicates: true,
                allowHtml: true,
                positionClass: 'toast-top-full-width',
                hideDuration: timeout,
                closeButton: true,
                showDuration: timeout,
                extendedTimeOut: timeout,
                hideMethod: 'noop'
            });
            $rootScope.toast = t;
        };

        $scope.buildSaveToastr = function (content, title, timeout) {
            var t = toastr.info(content, title, {
                progressBar: true,
                timeOut: timeout,
                toastClass: 'toast',
                preventDuplicates: true,
                allowHtml: true,
                positionClass: 'toast-top-full-width',
                hideDuration: timeout,
                closeButton: true,
                showDuration: timeout,
                extendedTimeOut: timeout,
                hideMethod: 'noop'
            });
            t.scope.options.onHidden = function () {
                // $scope.toCreate();
                $scope.action = 'view';
                $scope.loadUser();
            };
            $rootScope.toast = t;
        };
        // #endregion Notification Methods.
        
        // #region Organization Code.
        $scope.organizationKey = organizationService.getOrganizationKey();
        $scope.locationKeys = [{id:1,location:"Albany"},{id:2,location:"Carrollton"},{id:3,location:"Columbus"},{id:3,location:"LaGrange"},{id:5,location:"Newnan"},{id:6,location:"Opelika"},{id:7,location:"Phenix City"},{id:8,location:"Valdosta"},];
        var getOrganizationKeys = function () {
            $scope.organizationKeys = [];
            organizationService.getOrganizationKeys().then(function (response) {
                try {
                    if (response && typeof response === 'object' && Array.isArray(response.data)) {
                        var orgkeys = response.data;
                        for (var i = 0; i < orgkeys.length; i++) {
                            if (!$scope.organizationKeys.includes(orgkeys[i].organizationKey)) {
                                $scope.organizationKeys.push(orgkeys[i].organizationKey);
                            }
                        }
                    }
                } catch (e) {
                    console.error(e);
                }
            });
            // console.log($scope.organizationKeys);
        };
        getOrganizationKeys();
        // #endregion Organization Code.
        
        // #region Get admin data.
        adminService.getAdmin().then(function (user) {
            vm.adminData = user;
        });
        // #endregion Get admin data.

        $scope.canEditRole = function(username) {
            var adminUser = $localStorage.adminUser;
            var result = true;
            if (!username) {
                username = $scope.model.username;
            }
            if (typeof username !== 'string') {
                result = false;
            }
            else if (typeof adminUser !== 'object' || adminUser === null) {
                result = false;
            }
            else if (username === constants.INTRY_ADMIN || adminUser.username === username) {
                result = false;
            }
            else {
                result = (($scope.model.role !== 'ROLE_APP_ADMIN') && (adminUser.role === 'ROLE_ORGANIZATION_ADMIN')) || (adminUser.role === 'ROLE_APP_ADMIN');
            }
            // console.log(username + ' ---> ' + (result ? 'true' : 'false'));
            return result;
        };

        $scope.availableRoles = function (roles) {
            var adminUser = $localStorage.adminUser;
            var adminRole = 'ROLE_ADMIN_USER';

            if (typeof adminUser === 'object' && adminUser !== null &&
                typeof adminUser.role === 'string' && adminUser.role.length > 0) {
                adminRole = adminUser.role;
            }
            var remove = [];
            switch (adminRole) {
            case 'ROLE_APP_ADMIN':
                return constants.ADMIN_ROLES;
            case 'ROLE_USER_ADMIN':
                remove.push('ROLE_ORGANIZATION_ADMIN');
                // fall through
            case 'ROLE_ORGANIZATION_ADMIN':
                remove.push('ROLE_APP_ADMIN');
                break;
            default:
                return [];
            }
            return constants.ADMIN_ROLES.filter(function(r) { return remove.indexOf(r.role) === -1; });
        };

        $scope.selectedRole = constants.ADMIN_ROLES[$scope.model.role || 0];
        $scope.setSelectedRole();

        $scope.checkRole = function (roles) {
            var adminUser = $localStorage.adminUser || {};
            var adminRole = 'ROLE_ADMIN_USER';

            if (typeof adminUser.role === 'string' && adminUser.role.length > 0) {
                adminRole = adminUser.role;
            }
            if (typeof roles === 'string') {
                return roles === adminRole;
            }
            else if (Array.isArray(roles)) {
                return (roles.indexOf(adminRole) > -1) ? true : false;
            }
            else {
                return false;
            }
        };

        // #region White Label Code.
        $scope.hasOrganization = function() {
            return organizationService.hasOrganization();
        };

        $scope.getOrganizationCss = function(css, returnEmpty) {
            return organizationService.getOrganizationCss(css, returnEmpty);
        };

        $scope.getOrganizationKey = function() {
            return organizationService.getOrganizationKey();
        };

        $scope.getOrganizationName = function() {
            return organizationService.getOrganizationName();
        };

        $scope.getTitle = function (txt) {
            var title = $translate.instant(txt);

            if ($scope.checkRole('ROLE_APP_ADMIN')) {
                title = title.replace('#####ADMIN_TITLE#####', 'Administrator');
            } else {
                title = title.replace('#####ADMIN_TITLE#####', 'Admin / Case Manager');
            }

            return title;
        };
        // #endregion White Label Code.
    }
})();

(function () {
    'use strict';

    angular
        .module('intryFrontEnd')
        .controller('CreateController', CreateController)
        .directive('fileReader', fileReader);

    /** @ngInject */
    function CreateController($scope, $timeout, userService, $cookies, ngDialog, $state, modalService, constants, $localStorage, $rootScope, toastr, $translate, organizationService, adminService, utilsService, noteService, unemployedNotesService, tracksService) {
        CKEDITOR.config.customConfig = '/media/ckeditor_config.js';

        var vm = this;
        window.scrollTo(0, 0);

        var inlineCKEditor = function () {
            $timeout(function () {
                for (var name in CKEDITOR.instances) {
                    CKEDITOR.instances[name].destroy(true);
                }
                $('.editable-inline').each(function (i, editableElement) {
                    CKEDITOR.inline(editableElement);
                });
            }, 500);
        };

        $scope.model = {};
        $scope.modelAux = {};
        $scope.retypepwd = '';
        $scope.errors = [];
        $scope.userHiredStatus = constants.userHiredStatus;
        $scope.userStatus = constants.userStatus;
        $scope.kind = constants.kind_list;
        $scope.kind_phone = constants.kind_phone_list;

        $scope.kind_education = constants.kind_education_list;
        $scope.kind_recommendations = constants.kind_recommendations_list;
        $scope.kind_skills = constants.kind_skills_list;
        $scope.subscription_types = constants.subscription_types_list;

        $scope.timePickerDateFormat = constants.timePickerDateFormat;

        // #region Subscription Variables.
        $scope.subscriptionPaused = true;
        $scope.subscriptionCancelAtPeriodEnd = true;
        $scope.plansSubscribed = [];
        $scope.account = {};
        var monthlyRecurringTotalTitle = $translate.instant('USER_PROFILE_MONTHLY_RECURRING_TOTAL_TITLE_TEXT');
        $scope.nextBillingDate = '';
        $scope.discount = {};
        $scope.showDiscount = false;
        $scope.total = 0;

        $scope.invoiceList = [];
        $scope.refundList = [];

        $scope.showRefundModal = false;
        $scope.refundOption = 0;
        $scope.refundAmountCalculated = 0;
        $scope.refundAmount = 0;
        // #endregion Subscription Variables.
        $scope.locationKeys = [{id:1,location:"Albany"},{id:2,location:"Carrollton"},{id:3,location:"Columbus"},{id:3,location:"LaGrange"},{id:5,location:"Newnan"},{id:6,location:"Opelika"},{id:7,location:"Phenix City"},{id:8,location:"Valdosta"},];
        // #region Action Code.
        $scope.action = 'view';

        $scope.signupInfo = null;
        $scope.showSignupCode = false;
        
        function clearSignupCodeInfo() {
            $scope.showSignupCode = false;
            $scope.signupCodeInfo = {            
                code: '',
                expires: new Date(0),
                show: false,
                expiration: "expired"
            };
            return $scope.signupCodeInfo;
        }

        $scope.loadSignupCodeInfo = function() {
       
                adminService.getAdminSignupCode().then(function(result) {
                    // console.log("I GOT: " + JSON.stringify(result));
                    $scope.showSignupCode = true;
                    var expires = result.signupCodeExpires;
                    var code = result.signupCode;
                    $scope.signupCodeInfo = {
                        code: code,
                        expires: expires,
                        show: true,
                        expiration: expires > new Date() ? "expired" : "expires " + moment(expires).format("MM/DD/YYYY")
                    };
                });
          
        };

        $scope.loadUser = function () {
            var userID = $localStorage.registeredUserID;
            $scope.loadSignupCodeInfo(userID);

            if (typeof userID !== 'undefined' && userID !== null && userID.length > 0) {
                $scope.disableForm();
                clearSignupCodeInfo();
                userService.getRegisteredUser(userID).then(function (response) {
            
                    try {
                        var user = response.data[0];
                        $scope.model = user;
                        $scope.modelBak = angular.copy(user);
                        if ((user.paid_features || {}).free_trial_expire) {
                            $scope.license_expires = utilsService.formatDate(new Date(user.paid_features.free_trial_expire), "MMM D, YYYY");
                        }
                        else {
                            $scope.license_expires = null;
                        }
                        console.log($scope.license_expires);
                        $scope.modelAux.city = getLast($scope.model.addresses, 'city');
                        $scope.modelAux.state = getLast($scope.model.addresses, 'state');
                        $scope.modelAux.number = getLast($scope.model.phone_numbers, 'number');
                        $scope.modelAux.email = getLast($scope.model.email_addresses, 'email');

                        prepareExperienceItems();
                        prepareEducationItems();
                        loadNotes();
                        loadUnemployedNotes();
                        loadTracks();
                        prepareJobs();

                        if ($scope.model.disable_request_date || $scope.model.disable_completed_date) {
                            updateSubscriptionPaused();
                        }
                      
                        loadAccount();
                    } catch (e) {
                    
                        console.error(e);
                    }
                });
            } else {
                $scope.action = 'create';
            }
        };

        var getLast = function (list, type) {
            var last = getLastElement(list);

            if (last) {
                switch (type) {
                case 'city':
                    return last.city;
                case 'email':
                    return last.address;
                case 'number':
                    return last.number;
                case 'state':
                    return last.state;
                default:
                    return '';
                }
            } else {
                return '';
            }
        };

        var getLastElement = function (list) {
            if (Array.isArray(list) && list.length > 0) {
                var reverseList = angular.copy(list).slice().reverse();

                return reverseList.find(function (elm) {
                    if (!elm.deleted) {
                        return elm;
                    }
                    return null;
                });
            }
            else {
                return null;
            }
        };

        var prepareExperienceItems = function () {
            $scope.modelAux.experience = $scope.model.experience && $scope.model.experience.length > 0 ? angular.copy($scope.model.experience) : [];
            _.each($scope.modelAux.experience, function (element) {
                prepareDates(element);
            });
        };

        var prepareEducationItems = function () {
            $scope.modelAux.education = $scope.model.education && $scope.model.education.length > 0 ? angular.copy($scope.model.education) : [];
            _.each($scope.modelAux.education, function (element) {
                prepareDates(element);
            });
        };

        var prepareDates = function (element) {
            element.startDateObj = utilsService.formatDate(element.date_start);
            element.endDateObj = utilsService.formatDate(element.date_end);

            element.startMonthObj = utilsService.getMonthObj(element.date_start);
            element.startYearObj = utilsService.getYearObj(element.date_start);
            element.endMonthObj = utilsService.getMonthObj(element.date_end);
            element.endYearObj = utilsService.getYearObj(element.date_end);
        };

        $scope.disableForm = function () {
            $('#personalDataContainer').addClass('div-disabled');
            $('#statsDataContainer').addClass('div-disabled');
            // $('#summaryDataContainer').addClass('div-disabled');
            $('#addressDataContainer').addClass('div-disabled');
            $('#emailAddressDataContainer').addClass('div-disabled');
            $('#phoneNumberDataContainer').addClass('div-disabled');
            // $('#experienceDataContainer').addClass('div-disabled');
            // $('#educationDataContainer').addClass('div-disabled');
            // $('#skillsDataContainer').addClass('div-disabled');
            // $('#jobsDataContainer').addClass('div-disabled');
            // $('#logDataContainer').addClass('div-disabled');
        };

        $scope.enableForm = function () {
            $('#personalDataContainer').removeClass('div-disabled');
            // $('#statsDataContainer').removeClass('div-disabled');
            // $('#summaryDataContainer').removeClass('div-disabled');
            $('#addressDataContainer').removeClass('div-disabled');
            $('#emailAddressDataContainer').removeClass('div-disabled');
            $('#phoneNumberDataContainer').removeClass('div-disabled');
            // $('#experienceDataContainer').removeClass('div-disabled');
            // $('#educationDataContainer').removeClass('div-disabled');
            // $('#skillsDataContainer').removeClass('div-disabled');
            // $('#jobsDataContainer').removeClass('div-disabled');
            // $('#logDataContainer').removeClass('div-disabled');
        };

        $scope.loadUser();
        // #endregion Action Code.

        // #region Items Methods.
        $scope.addNewAddress = function () {
            $scope.model.addresses = $scope.model.addresses || [];

            var address = {};

            address.city = '';
            address.country = '';
            address.kind = '';
            address.postal_code = '';
            address.state = '';
            address.street = '';
            address.street_2 = '';

            $scope.model.addresses.push(address);
        };

        $scope.addNewEmailAddress = function () {
            $scope.model.email_addresses = $scope.model.email_addresses || [];

            var email_address = {};
            email_address.kind = '';
            email_address.address = '';

            $scope.model.email_addresses.push(email_address);
        };

        $scope.addNewPhoneNumber = function () {
            $scope.model.phone_numbers = $scope.model.phone_numbers || [];

            var phone_number = {};
            phone_number.number = '';
            phone_number.kind = '';

            $scope.model.phone_numbers.push(phone_number);
        };

        $scope.addNewSocialAccount = function () {
            $scope.model.social_accounts = $scope.model.social_accounts || [];

            var social_account = {};
            social_account.handle = '';
            social_account.kind = '';

            $scope.model.social_accounts.push(social_account);
        };

        $scope.addNewAssociation = function () {
            $scope.model.associations = $scope.model.associations || [];

            var association = {};
            association.associations = '';

            $scope.model.associations.push(association);
        };

        $scope.addNewEducation = function () {
            $scope.model.education = $scope.model.education || [];

            var education = {};

            education.activities = '';
            education.date_start = '';
            education.date_end = '';
            education.degree = '';
            education.field_of_study = '';
            education.institution = '';
            education.kind = '';
            education.notes = '';
            education.number = '';

            $scope.model.education.push(education);
            inlineCKEditor();
        };

        $scope.addNewExperience = function () {
            $scope.model.experience = $scope.model.experience || [];

            var experience = {};

            experience.company = '';
            experience.date_start = '';
            experience.date_end = '';
            experience.description = '';
            experience.is_current = '';
            experience.summary = '';
            experience.title = '';

            $scope.model.experience.push(experience);
            inlineCKEditor();
        };

        $scope.addNewSocialAccount = function () {
            $scope.model.social_accounts = $scope.model.social_accounts || [];

            var social_account = {};
            social_account.handle = '';
            social_account.kind = '';

            $scope.model.social_accounts.push(social_account);
        };

        $scope.addNewInterest = function () {
            $scope.model.interests = $scope.model.interests || [];

            var interest = {};
            interest.interest = '';

            $scope.model.interests.push(interest);
        };

        $scope.addNewRecommendation = function () {
            $scope.model.recommendations = $scope.model.recommendations || [];

            var recommendation = {};
            recommendation.author = '';
            recommendation.kind = '';
            recommendation.text = '';

            $scope.model.recommendations.push(recommendation);
            inlineCKEditor();
        };

        $scope.addNewSkill = function () {
            $scope.model.skills = $scope.model.skills || [];

            var skill = {};
            skill.kind = '';
            skill.proficiency = '';
            skill.skill = '';
            skill.summary = '';

            $scope.model.skills.push(skill);
            inlineCKEditor();
        };

        $scope.addNewVolunteer = function () {
            $scope.model.volunteer = $scope.model.volunteer || [];

            var volunteer = {};
            volunteer.organization = '';
            volunteer.role = '';

            $scope.model.volunteer.push(volunteer);
        };

        $scope.delete = function (section, index) {
            $scope.model[section].splice(index, 1);
        };
        // #endregion Items Methods.

        // #region Subscription Methods.
        var updateSubscriptionPaused = function () {
            $scope.pauseAccountMessage = $translate.instant('USER_PROFILE_ACCOUNT_PAUSED_SUCCESS_MESSAGE');
            $scope.subscriptionPaused = true;
        };

        var loadAccount = function () {
            $scope.subscriptionPaused = true;
            $scope.subscriptionCancelAtPeriodEnd = true;
            $scope.plansSubscribed = [];
            $scope.account = {};
            $scope.nextBillingDate = '';
            $scope.discount = {};
            $scope.showDiscount = false;
            $scope.total = 0;
            $scope.invoiceList = [];
            $scope.refundList = [];

            var userID = $localStorage.registeredUserID;

            userService.adminGetUserAccount(userID).then(function (response) {
                try {
                    if (
                        (typeof response !== 'undefined') &&
                            (typeof response.data !== 'undefined') &&
                            (typeof response.data.subscriptions !== 'undefined') &&
                            (typeof response.data.subscriptions.data !== 'undefined') &&
                            (response.data.subscriptions.data.length > 0)
                    ) {
                        loadSubscribedAddonsandPlans(response.data.subscriptions.data[0].items.data, $scope.plansSubscribed, 'plan', 'candidates');
                        populateNextCharge(response.data.subscriptions.data[0]);
                        populateDiscounts(response.data.discount);
                        calculateTotals();

                        $scope.subscriptionPaused = false;
                        $scope.subscriptionCancelAtPeriodEnd = response.data.subscriptions.data[0].cancel_at_period_end;
                    }

                    if ((typeof response !== 'undefined') && (typeof response.data !== 'undefined')) {
                        if (typeof response.data.invoiceList !== 'undefined') {
                            $scope.invoiceList = response.data.invoiceList;
                        } else {
                            $scope.invoiceList = [];
                        }
                        if (typeof response.data.refundList !== 'undefined') {
                            $scope.refundList = response.data.refundList;
                        } else {
                            $scope.refundList = [];
                        }
                    } else {
                        $scope.invoiceList = [];
                        $scope.refundList = [];
                    }
                } catch (e) {
                    console.error(e);
                }
            });
        };

        var loadSubscribedAddonsandPlans = function (data, out, type, userType) {
            angular.forEach(data, function (value, key) {
                if (value.plan) {
                    if (value.plan.metadata.type == type && value.plan.metadata.user_type == userType) {
                        out.push({
                            'id': value.id,
                            'plan': value.plan.id,
                            'name': value.plan.name,
                            'statement_descriptor': value.plan.statement_descriptor,
                            'amount': value.plan.amount / 100.00
                        });
                    }
                }
            });
        };

        var populateNextCharge = function (data) {
            if (data) {
                $scope.nextBillingDate = data.current_period_end;
            }
        };

        var populateDiscounts = function (data) {
            $scope.discount = {};
            $scope.showDiscount = false;

            if (data != null) {
                if (data.coupon.metadata.user_type == 'candidates' || data.coupon.metadata.user_type == 'all') {
                    $scope.discount.id = data.coupon.id;
                    $scope.discount.amount = data.coupon.amount_off / 100.00;
                    $scope.showDiscount = true;
                }
            }
        };
        
        var calculateTotals = function () {
            if ($scope.plansSubscribed.length > 0) {
                if (!$scope.discount.amount)
                    $scope.discount.amount = 0;

                $scope.plansSubscribed[0]['subTotal'] = $scope.plansSubscribed[0].amount - $scope.discount.amount;
                angular.forEach($scope.addonsSubscribed, function (value, key) {
                    $scope.total = $scope.total + value.amount;
                });
                $scope.total = $scope.total + $scope.plansSubscribed[0]['subTotal'];
                $scope.lblTotal = monthlyRecurringTotalTitle;
            }
        };

        $scope.cancelSubscriptionModal = function () {
            var userID = $scope.model.userID;

            userService.getRefundAmount(userID).then(function (response) {
                if (
                    (response.status === 200) &&
                        (typeof response.data !== undefined) &&
                        (typeof response.data.amount !== undefined) &&
                        !isNaN(response.data.amount)
                ) {
                    $scope.refundAmountCalculated = response.data.amount / 100;
                    $scope.showRefundModal = true;
                }
            });
        };

        $scope.updateRefundOption = function (opt) {
            $scope.refundOption = opt;
        };

        $scope.validateRefund = function () {
            var result = false;

            if ($scope.refundAmountCalculated > 0) {
                if ($scope.refundOption === 0) {
                    result = true;
                } else if (
                    ($scope.refundOption === 1) &&
                        (!isNaN($scope.refundAmount)) &&
                        ($scope.refundAmount > 0) &&
                        ($scope.refundAmount <= $scope.refundAmountCalculated)
                ) {
                    result = true;
                }
            }

            return result;
        };

        $scope.refundCancel = function (opt) {
            var userID = $scope.model.userID;
            var amount = 0;

            if ((opt === 0) && ($scope.refundOption === 0)) {
                amount = $scope.refundAmountCalculated * 100;
            } else if (opt === 0) {
                amount = $scope.refundAmount * 100;
            }

            $scope.showRefundModal = false;

            userService.refundCancel(userID, opt, amount).then(function (response) {
                var errorMsg = '';

                try {
                    if (
                        (typeof response !== 'undefined') &&
                            (typeof response.data !== 'undefined') &&
                            (typeof response.data.message !== 'undefined')
                    ) {
                        errorMsg = $translate.instant(response.data.message);
                    } else if (response.status === 200) {
                        errorMsg = $translate.instant('ADMIN_CANCEL_SUBSCRIPTION_SUCCESS_TEXT');
                    } else {
                        errorMsg = $translate.instant('ADMIN_CANCEL_SUBSCRIPTION_ERROR_TEXT');
                    }

                    if (response.status === 200) {
                        $scope.buildRefreshToastr(errorMsg, $translate.instant('ADMIN_CREATE_SUCCESS_TITLE'), 4000);
                    } else {
                        $scope.buildToastr(errorMsg, $translate.instant('ADMIN_CREATE_WARNING_TITLE'), 4000);
                    }
                } catch (e) {
                    errorMsg = $translate.instant('ADMIN_CANCEL_SUBSCRIPTION_ERROR_TEXT');
                    $scope.buildToastr(errorMsg, $translate.instant('ADMIN_CREATE_WARNING_TITLE'), 4000);
                }
            });
        };
        // #endregion Subscription Methods.

        // #region Submit Methods.
        function validate() {
            $scope.errors.length = 0;

            // #region Personal Data Validations.
            if (typeof $scope.model.usernames !== 'string' || $scope.model.usernames.length == 0) {
                if (angular.isUndefined($scope.model.first_name)) {
                    $scope.errors.push('First Name cannot be empty');
                }

                if (angular.isUndefined($scope.model.last_name)) {
                    $scope.errors.push('Last Name cannot be empty');
                }

                if ($scope.personalDataForm.username.$error.required) {
                    $scope.errors.push('Email cannot be empty');
                } else if ($scope.personalDataForm.username.$error.email) {
                    $scope.errors.push('Email is not valid');
                }

                // if ($scope.action === 'create') {
                //     if (angular.isUndefined($scope.model.password)) {
                //         $scope.errors.push('Password cannot be empty');
                //     }

                //     if ($scope.model.password && $scope.model.password.length < 8) {
                //         $scope.errors.push('Password should be at least 8 characters long');
                //     }

                //     if ($scope.model.password != $scope.retypepwd) {
                //         $scope.errors.push('Passwords should match');
                //     }
                // }

            }
            // #endregion Personal Data Validations.

            // #region Addresses Validations.
            if ($scope.model.addresses && $scope.model.addresses.length > 0) {
                for (var i = 0; i < $scope.model.addresses.length; i += 1) {
                    if ($scope.model.addresses[i].city == '') {
                        $scope.errors.push('City cannot be empty in Address');
                    }
                    if ($scope.model.addresses[i].country == '') {
                        $scope.errors.push('Country cannot be empty in Address');
                    }
                    if ($scope.model.addresses[i].kind == '') {
                        $scope.errors.push('Kind cannot be empty in Address');
                    }
                    if ($scope.model.addresses[i].state == '') {
                        $scope.errors.push('State cannot be empty in Address');
                    }
                    if ($scope.model.addresses[i].street == '') {
                        $scope.errors.push('Street cannot be empty in Address');
                    }
                }
            }
            // #endregion Addresses Validations.

            // #region Email Addresses Validations.
            if ($scope.model.email_addresses && $scope.model.email_addresses.length > 0) {
                for (var i = 0; i < $scope.model.email_addresses.length; i += 1) {
                    if ($scope.model.email_addresses[i].kind == '') {
                        $scope.errors.push('Kind cannot be empty in Email Address');
                    }
                    if ($scope.model.email_addresses[i].address == '') {
                        $scope.errors.push('Address cannot be empty in Email Address');
                    }
                }
            }

            if ($scope.model.phone_numbers && $scope.model.phone_numbers.length > 0) {
                for (var i = 0; i < $scope.model.phone_numbers.length; i += 1) {
                    if ($scope.model.phone_numbers[i].kind == '') {
                        $scope.errors.push('Kind cannot be empty in Phone Number');
                    }
                    if ($scope.model.phone_numbers[i].number == '') {
                        $scope.errors.push('Number cannot be empty in Phone Number');
                    }
                }
            }
            // #endregion Email Addresses Validations.

            // #region Email Addresses Validations.
            if ($scope.model.phone_numbers && $scope.model.phone_numbers.length > 0) {
                for (var i = 0; i < $scope.model.phone_numbers.length; i += 1) {
                    if ($scope.model.phone_numbers[i].kind == '') {
                        $scope.errors.push('Kind cannot be empty in Phone Number');
                    }
                    if ($scope.model.phone_numbers[i].number == '') {
                        $scope.errors.push('Number cannot be empty in Phone Number');
                    }
                }
            }
            // #endregion Email Addresses Validations.

            if ($scope.model.full_name == '')
                $scope.model.full_name = utilsService.getFullName($scope.model.first_name, $scope.model.last_name);

            if ($scope.errors.length == 0) {
                return true;
            } else {
                $scope.buildToastr($translate.instant('ADMIN_CREATE_WARNING_TEXT'), $translate.instant('ADMIN_CREATE_WARNING_TITLE'), 4000);
                return false;
            }
        }

        $scope.save = function () {
            if (validate()) {
                if ($scope.action === 'create') {
                    $scope.model.belongsTo = vm.adminData.userID;

                    if (!$scope.checkRole('ROLE_APP_ADMIN')) {
                        $scope.model.organizationKey = vm.adminData.organizationKey;
                    }
                    else {
                        $scope.model.organizationKey = organizationService.getOrganizationKey();
                    }

                    var orgKey = $scope.model.organizationKey;
                    var trialExpire = new Date();
                    var trialPeriod = !orgKey || (orgKey === constants.INTRY_ORG) ? constants.INTRY_FREE_TRIAL_DAYS : constants.ORG_FREE_TRIAL_DAYS;

                    trialExpire.setDate(trialExpire.getDate() + trialPeriod);
                    $scope.model.paid_features = {
                        free_trial_expire: trialExpire
                    };

                    var fullName = utilsService.getFullName($scope.model.first_name, $scope.model.last_name);

                    if (fullName) {
                        $scope.model.full_name = fullName;
                    }

                    $scope.model.password = generatePassword(30);

                    $scope.mask();

                    userService.createUser($scope.model, {invited: true}).then(function (response) {
                        var errorMsg = '';

                        if (response.status == 500) {
                            errorMsg = '';
                            try {
                                errorMsg = typeof response.data.error == 'string' && response.data.error.length > 0 ? response.data.error : response.data.message;
                            } catch (e) {
                                errorMsg = "Internal Error";
                            }

                            $scope.unmask();
                            $scope.buildToastr(errorMsg, $translate.instant('ADMIN_CREATE_WARNING_TITLE'), 4000);
                            return true;
                        } else if (response.status == 201) {
                            if (typeof $scope.model.usernames === 'string' && $scope.model.usernames.length > 0) {
                                if (response.error) {
                                    alert("There was an error, please try again");
                                    return false;
                                }

                                var fileName = ('Links ' + moment().format('MM/DD/YYYY hh:mm a') + '.csv').replace(/ /g, '_');
                                var blob = new Blob([response.data], {
                                    type: "application/csv;charset=utf-8;"
                                });
                                var downloadLink = angular.element('<a></a>');
                                downloadLink.attr('href', window.URL.createObjectURL(blob));
                                downloadLink.attr('download', fileName);
                                downloadLink[0].click();

                                $scope.clearUsernames();
                                $scope.unmask();
                                $scope.buildToastr($translate.instant('ADMIN_CREATE_SUCCESS_USERS_TEXT'), $translate.instant('ADMIN_CREATE_SUCCESS_TITLE'), 4000);
                                return true;
                            } else {
                                $localStorage.userId = response.data.userID;
                                $localStorage.registeredUserID = response.data.userID;
                                $scope.unmask();
                                $scope.buildRefreshToastr($translate.instant('ADMIN_CREATE_SUCCESS_USER_TEXT'), $translate.instant('ADMIN_CREATE_SUCCESS_TITLE'), 4000);
                                return true;
                            }
                        } else if (response.status == 400) {
                            errorMsg = $translate.instant('ADMIN_CREATE_CREATED_ERROR_USER_TEXT');
                            try {
                                errorMsg = typeof response.data.error == 'string' && response.data.error.length > 0 ? response.data.error : response.data.message; 
                            } catch (e) {
                                errorMsg = "Internal Error";
                                console.error(e);
                            }

                            $scope.unmask();
                            $scope.buildToastr(errorMsg, $translate.instant('ADMIN_CREATE_WARNING_TITLE'), 4000);
                        }
                        return false;
                    }).catch(function (error) {
                        console.error(error);
                        $scope.unmask();
                    });
                } else {
                    $scope.updateSave();
                }
            }
        };

        var cleanModel = function (modelIn) {
            var modelOut = angular.copy(modelIn);
            delete modelOut.experience;
            delete modelOut.education;
            delete modelOut.notes;

            return modelOut;
        };

        var generatePassword = function (length) {
            var result = '';
            var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;

            for (var i = 0; i < length; i++) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }

            return result;
        };
        
        $scope.update = function () {
            $scope.enableForm();
            $scope.action = 'update';
        };

        $scope.updateSave = function () {
            var userID = $localStorage.registeredUserID;
            var fullName = utilsService.getFullName($scope.model.first_name, $scope.model.last_name);
            if (fullName) {
                $scope.model.full_name = fullName;
            }

            var modelCleaned = cleanModel($scope.model);

            console.log("-- modelCleaned: ", modelCleaned);

            userService.adminUpdateUser(userID, modelCleaned).then(function (response) {
                var errorMsg = '';

                if (!(angular.isUndefined(response) || response === null)) {
                    if (response.status == 500) {
                        errorMsg = '';
                        try {
                            errorMsg = response.data.message;
                        } catch (e) {

                        }

                        $scope.buildToastr(errorMsg, $translate.instant('ADMIN_CREATE_WARNING_TITLE'), 4000);
                    } else if (response.status == 200) {
                        $localStorage.userId = response.data.userID;
                        $scope.buildRefreshToastr($translate.instant('ADMIN_UPDATE_SUCCESS_USER_TEXT'), $translate.instant('ADMIN_CREATE_SUCCESS_TITLE'), 4000);
                    } else if (response.status == 400) {
                        $scope.labelText = "User not created.";

                        errorMsg = $translate.instant('ADMIN_UPDATE_UPDATED_ERROR_USER_TEXT');
                        try {
                            errorMsg = response.data.message;
                        } catch (e) {

                        }

                        $scope.buildToastr(errorMsg, $translate.instant('ADMIN_CREATE_WARNING_TITLE'), 4000);
                        return false;
                    }
                } else {
                    errorMsg = $translate.instant('ADMIN_UPDATE_UPDATED_ERROR_USER_TEXT');
                    try {
                        errorMsg = response.data.message;
                    } catch (e) {

                    }

                    $scope.buildToastr(errorMsg, $translate.instant('ADMIN_CREATE_WARNING_TITLE'), 4000);
                    return false;
                }
                window.scrollTo(0, 0);
                vm.dataLoading = true;
                return true;
            });
        };

        $scope.updateCancel = function () {
            $scope.disableForm();
            $scope.action = 'view';
            $scope.model = angular.copy($scope.modelBak);
        };
        // #endregion Submit Methods.

        // #region User Actions.
        $scope.loginAs = function () {
            userService.loginAs($localStorage.registeredUserID).then(function () {
                // window.open(window.location.origin,'_blank');
                $state.go('dashboard');
            });
        };
        // #endregion User Actions.

        // #region Notification Methods.
        $scope.buildToastr = function (content, title, timeout) {
            var t = toastr.info(content, title, {
                progressBar: true,
                timeOut: timeout,
                toastClass: 'toast',
                preventDuplicates: true,
                allowHtml: true,
                positionClass: 'toast-top-full-width',
                hideDuration: timeout,
                closeButton: true,
                showDuration: timeout,
                extendedTimeOut: timeout,
                hideMethod: 'noop'
            });
            $rootScope.toast = t;
        };

        $scope.buildRefreshToastr = function (content, title, timeout) {
            var t = toastr.info(content, title, {
                progressBar: true,
                timeOut: timeout,
                toastClass: 'toast',
                preventDuplicates: true,
                allowHtml: true,
                positionClass: 'toast-top-full-width',
                hideDuration: timeout,
                closeButton: true,
                showDuration: timeout,
                extendedTimeOut: timeout,
                hideMethod: 'noop'
            });
            t.scope.options.onHidden = function () {
                // $scope.toCreate();
                $scope.action = 'view';
                $scope.loadUser();
                $scope.showRefundModal = false;
            };
            $rootScope.toast = t;
        };
        // #endregion Notification Methods.

        // #region Organization Code.
        $scope.organizationKeys = [];
        var getOrganizationKeys = function () {
            $scope.organizationKeys = [];
            organizationService.getOrganizationKeys().then(function (response) {
                try {
                    if (response && typeof response === 'object' && Array.isArray(response.data)) {
                        var orgkeys = response.data;
                        for (var i = 0; i < orgkeys.length; i++) {
                            $scope.organizationKeys.push(orgkeys[i].organizationKey);
                        }
                    }
                } catch (e) {
                    console.error(e);
                }
            });
        };
        getOrganizationKeys();
        // #endregion Organization Code.

        // #region Get admin data.
        adminService.getAdmin().then(function (user) {
            vm.adminData = user;
        });

        $scope.adminList = [];
        var getAdminList = function () {
            // console.log('-- (Controller) AdminCreateController.getAdminList()');

            $scope.adminList = [];
            adminService.getAdminList().then(function (response) {
                try {
                    $scope.adminList = response.data[0].admins;

                    // console.log('-- (Controller) AdminCreateController.getAdminList() - $scope.adminList: ', $scope.adminList);
                } catch (e) {
                    console.error(e);
                }
            });
        };
        getAdminList();
        // #endregion Get admin data.

        $scope.toUsers = function () {
            $state.go('admin-users');
        };

        $scope.toCreate = function () {
            $state.go('admin-create-user');
        };

        $scope.checkRole = function (roles) {
            var adminUser = $localStorage.adminUser || {};
            var adminRole = 'ROLE_ADMIN_USER';

            if (typeof adminUser.role === 'string' && adminUser.role.length > 0) {
                adminRole = adminUser.role;
            }
            if (typeof roles === 'string') {
                return roles === adminRole;
            }
            else if (Array.isArray(roles)) {
                return (roles.indexOf(adminRole) > -1) ? true : false;
            }
            else {
                return false;
            }
        };

        // #region White Label Code.
        $scope.hasOrganization = function() {
            return organizationService.hasOrganization();
        };

        $scope.getOrganizationCss = function(css, returnEmpty) {
            return organizationService.getOrganizationCss(css, returnEmpty);
        };

        $scope.getOrganizationKey = function() {
            return organizationService.getOrganizationKey();
        };

        $scope.getOrganizationName = function() {
            return organizationService.getOrganizationName();
        };
        // #endregion White Label Code.

        // #region Upload Usernames.
        $scope.enableClearUsernames = function () {
            return (typeof $scope.model.usernames === 'string' && $scope.model.usernames.length > 0) ? true : false;
        };

        $scope.clearUsernames = function () {
            $('#inputFile').val('');
            $('#inputFilenameLabel').html('');
            $scope.model.usernames = '';
        };
        // #endregion Upload Usernames.

        // #region Mask.
        $scope.mask = function () {
            $('#waitDiv')[0].style.display = 'block';
        };

        $scope.unmask = function () {
            $('#waitDiv')[0].style.display = 'none';
        };
        // #endregion Mask.

        // #region Notes.
        $scope.notes = [];

        var loadNotes = function () {
            // console.log("-- (Controller) CreateController.loadNotes()");

            $scope.notes = [];
            var userID = $localStorage.registeredUserID;

            if (typeof userID !== 'undefined' && userID !== null && userID.length > 0) {
                noteService.getNotes(0, 10, 'userID', userID, 'c', 'created', -1).then(function (response) {
                    // console.log("-- (Controller) CreateController.loadNotes() - response: ", response);

                    $scope.notes = response.data[0].notes;
                }).catch(function (error) {
                    // Do Nothing...
                });
            }
        };
        // #endregion Notes.

        // #region Unemployed Notes.
        $scope.unemployedNotes = [];

        var loadUnemployedNotes = function () {
            // console.log("-- (Controller) CreateController.loadUnemployedNotes()");

            $scope.tracks = [];
            var userID = $localStorage.registeredUserID;

            if (typeof userID !== 'undefined' && userID !== null && userID.length > 0) {
                var unemployedNotesData = [];

                unemployedNotesService.getUnemployedNotes(0, 10, 'userID', userID, 'c', 'created', -1).then(function (response) {
                    // console.log("-- (Controller) CreateController.loadUnemployedNotes() - response: ", response);

                    var unemployedNotes = response.data[0].unemployedNotes;

                    angular.forEach(unemployedNotes, function (value, key) {
                        var notes = _.sortBy(value.notes, 'noteDate');

                        notes.forEach(function (noteNote) {
                            var momentNoteNoteDate = moment(noteNote.noteDate * 1000);
                            noteNote.noteDate = momentNoteNoteDate.format('MM/DD/YYYY hh:mm a');
                            noteNote.noteDateDate = momentNoteNoteDate.format('MM/DD/YYYY');
                            noteNote.noteDateTime = momentNoteNoteDate.format('hh:mm a');
                        });

                        unemployedNotesData.push({
                            unemployedNoteID: value.unemployedNoteID,
                            userID: value.userID,
                            createdBy: value.createdBy,
                            resumeID: value.resumeID,
                            resumeTitle: value.resumeTitle,
                            jobUrl: value.jobUrl,
                            sendDate: moment(value.sendDate * 1000).format('MM/DD/YYYY hh:mm a'),
                            jobType: value.jobType,
                            deleted: value.deleted,

                            companyName: value.companyName,
                            companyState: value.companyState,
                            companyCity: value.companyCity,
                            companyAddress: value.companyAddress,

                            companyZipCode: value.companyZipCode,
                            companyPhone: value.companyPhone,

                            contactName: value.contactName,
                            contactEmail: value.contactEmail,
                            contactMailAddress: value.contactMailAddress,
                            contactPhone: value.contactPhone,

                            interviewDate: (value.interviewDate > 0) ? moment(value.interviewDate * 1000).format('MM/DD/YYYY hh:mm a') : '',
                            hired: value.hired,
                            jobStartDate: (value.jobStartDate > 0) ? moment(value.jobStartDate * 1000).format('MM/DD/YYYY') : '',
                            notes: notes,
                            lastNote: '(' + notes[notes.length - 1].noteDate + ') ' + notes[notes.length - 1].note,

                            created: value.created,
                            updated: value.updated
                        });
                    });

                    $scope.unemployedNotes = unemployedNotesData;

                    // console.log("-- (Controller) CreateController.loadUnemployedNotes() - $scope.unemployedNotes: ", $scope.unemployedNotes);
                }).catch(function (error) {
                    console.error(error);
                });
            }
        };
        // #endregion Unemployed Notes.

        // #region Tracks.
        $scope.additionalStats = {
            lastUserLogin: null,
            lastResumeJ2r: null,
            lastResumeCreate: null,
            lastResumeDownloaded: null,
            lastUnemployedNoteCreate: null,
            lastUnemployedReportDownloaded: null
        };
        $scope.tracks = [];

        var loadTracks = function () {
            $scope.tracks = [];
            var userID = $localStorage.registeredUserID;

            if (typeof userID !== 'undefined' && userID !== null && userID.length > 0) {
                tracksService.getTracks(0, 1, 'userID', userID).then(function (response) {
                    $scope.additionalStats.lastUserLogin = response.data[2].stats.lastUserLogin;
                    $scope.additionalStats.lastResumeJ2r = response.data[2].stats.lastResumeJ2r;
                    $scope.additionalStats.lastResumeCreate = response.data[2].stats.lastResumeCreate;
                    $scope.additionalStats.lastResumeDownloaded = response.data[2].stats.lastResumeDownloaded;
                    $scope.additionalStats.lastUnemployedNoteCreate = response.data[2].stats.lastUnemployedNoteCreate;
                    $scope.additionalStats.lastUnemployedReportDownloaded = response.data[2].stats.lastUnemployedReportDownloaded;

                    $scope.tracks = response.data[0].tracks;
                }).catch(function (error) {
                    console.error(error);
                });
            }
        };
        // #endregion Tracks.

        // #region Prepare month and years.
        var date = new Date();
        var months = [];
        var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        var i = 1;
        angular.forEach(monthNames, function (monthName) {
            var month = {
                fullmonthName: monthName,
                monthNumber: i
            };
            i++;
            months.push(month);
        });
        $scope.months = months;

        function getYears() {
            var currentYear = date.getFullYear() - 69;
            $scope.years = [];
            for (var i = 69; i > 0; i--) {
                $scope.years.push(currentYear + i);
            }

            return $scope.years;
        }
        getYears();
        // #endregion Prepare month and years.

        // #region Job Suggestions
        $scope.modelAux.selectedJob = undefined;

        // >>> KSH why is sample data in code?
        var prepareJobs = function () {
            var jobs = (Array.isArray($scope.model.jobs)) ? angular.copy($scope.model.jobs) : [];

            // #region Fake Jobs.
            jobs = [{
                jobID: '01183678-b3ef-4146-b6e1-a410e87b6c32',
                jobExternalID: '5fb7a37e-8a71-48d2-9b10-e00cea5eb1da',
                name: 'Full-Stack Web Developer',
                description: "Full-Stack Web Developer\nIntelliswift Software Inc, Austin, TX  1 day ago\n  Report a poor listing\n" +
                    "company bannercompany banner\n\nIntelliswift Software Inc\nNode.js, ReactJS, React.JS, Accessibility" +
                    "\nContract W2, Contract Independent, 12 Months\nDepends on Experience\nJob Description\nTitle: Full-" +
                    "Stack Web Developer Location: Austin, TX, United States\nDescription:\n\nWeb Dev\nNode.js\nHTML\/CSS" +
                    "\/JavaScript\nReactJS\nAccessibility (Keyboard\/VoiceOver)\n\n\nCompany Information\nIntelliswift So" +
                    "ftware, Inc. is a premier software solutions and services company headquartered in Silicon Valley, w" +
                    "ith offices across the United States and India. The company has a proven track record of delivering " +
                    "results through its global delivery centers and flexible engagement models for over 450 brands rangi" +
                    "ng from Fortune 100 to growing companies. Intelliswift provides a variety of services including Ente" +
                    "rprise Applications, Software Product Development, Mobility & Collaboration, Big Data\/BI, Cloud Sol" +
                    "utions, and Team Augmentation.\n\nContact the job poster\n\nS\nShri\n\nIyangar\n\nRecruiter\n\n\nVie" +
                    "w Profile\nDice Id : 10108150\nPosition Id : AA_20-04858\nOriginally Posted : 3 days ago",
                url: 'https://www.dice.com/jobs/detail/full%26%2345stack-web-developer-intelliswift-software-inc-austin-tx-73301/10108150/AA_20%26%234504858?searchlink=search%2F%3Fq%3Dweb%2520developer%26location%3DAustin%2C%2520TX%2C%2520USA%26latitude%3D30.267153%26longitude%3D-97.7430608%26countryCode%3DUS%26locationPrecision%3DCity%26radius%3D30%26radiusUnit%3Dmi%26page%3D1%26pageSize%3D20%26language%3Den&searchId=5fb7a37e-8a71-48d2-9b10-e00cea5eb1da',
                industryName: '',
                postedDate: '10/21/2020 09:00 AM',
                hiringCompany: {
                    id: '',
                    name: 'Intelliswift Software Inc',
                    description: '',
                    url: ''
                },
                location: {
                    country: 'US',
                    state: 'TX',
                    city: 'Austin'
                },
                salary: {
                    annualMin: 60000,
                    annualMax: -1,
                    min: 5000,
                    max: -1
                },
                percent: 90,
                suggestedSkills: ['Node.js', 'HTML', 'CSS', 'JavaScript', 'ReactJS']
            }, {
                jobID: '3e9789db-8dfe-4d73-8c11-2ceda6d1144a',
                jobExternalID: '5fb7a37e-8a71-48d2-9b10-e00cea5eb1da',
                name: 'Senior Web Developer / Tech Lead',
                description: "Senior Web Developer \/ Tech Lead\nThe Judge Group, Inc., Austin, TX  4 hours ago\n  Report a poor l" +
                    "isting\ncompany bannercompany banner\n\nThe Judge Group, Inc.\n \nWeb, Developer, UX, JavaScript, HT" +
                    "ML, Application, Computer\nFull Time\nJob Description\nLocation: Austin, TX\nDescription: Our client" +
                    " is currently seeking a Senior Web Developer \/ Tech Lead.\n\nFor immediate consideration please for" +
                    "ward a copy of your resume to\n\nSummary:\n\nThe Digital Experience team is responsible solving clie" +
                    "nt experience with new technologies that are often a step beyond the business today. We research, bu" +
                    "ild, test, and iterate on creating an enterprise wide design system that benefit the company as well" +
                    " as longer-term product scalability. Our Client has a long history of questioning the status quo - w" +
                    "hether it be the 24\/7 quotes, or online brokerage, or the start of a mutual fund marketplace.\n\nWh" +
                    "at you\'ll do:\n\nAs a web Developer of the Digital team, you will be a key participant in the Digit" +
                    "al transformation program, helping the company innovate on behalf of clients and investors. You will" +
                    " be part of implementing design system which will be used across all of the company\'s applications." +
                    " You will be responsible for getting safe and resilient production code out the door as quickly as p" +
                    "ossible. You will be producing highly usable and scalable web software solutions. You will be workin" +
                    "g with different web domains, UX teams and Product management teams.\n\nWhat you will contribute to " +
                    "the company:\n\nYou will be responsible for implementing design system components and patterns\nYou " +
                    "will be responsible to create secure, scalable, available and reliable production ready innovative s" +
                    "olutions for all the UI applications across domains, channels and devices.\nYou will plan and drive " +
                    "development and deployment efforts, leading and supporting design system adoption across multiple en" +
                    "gineering domains.\nYou will work with UX, UI, Content researchers, architecture and other delivery " +
                    "teams to help develop right solutions looking from technology and also from client\'s perspective\nY" +
                    "ou will mentor and help with technical issues of the team\n\n\nWhat you will have:\n\nProven experie" +
                    "nce as a technology leader\n10+ Web development experience, with an emphasis on front-end UI\/UX dev" +
                    "elopment\nSkill with native JavaScript, including ECMAScript 6, CSS, HTML and experience with Web Co" +
                    "mponents, Node and Angular, or other similar JS frameworks,\nUnderstanding of Design systems like Go" +
                    "ogle\'s material design\nExperience with unit testing patterns (TDD\/BDD) and methodologies\nApplica" +
                    "tion performance evaluation and tuning skills\nWeb Accessibility experience\nExperience and comfort " +
                    "communicating with senior executives and the ability to gain respect and support of leadership, part" +
                    "ners, and peers\nStrong interpersonal skills and must exemplify the vision and values of the company" +
                    "\nBA\/BS degree in Computer Science OR related practical experience\n7+ years of experience working " +
                    "in cross-functional projects and programs with tight deadlines\n\n\nFor immediate consideration plea" +
                    "se forward a copy of your resume to\n\nContact:\n\nThis job and many more are available through The " +
                    "Judge Group. Find us on the web at www.judge.com",
                url: 'https://www.dice.com/jobs/detail/senior-web-developer-%26%2347-tech-lead-the-judge-group%2C-inc.-austin-tx-73301/cxjudgpa/681143?searchlink=search%2F%3Fq%3Dweb%2520developer%26location%3DAustin%2C%2520TX%2C%2520USA%26latitude%3D30.267153%26longitude%3D-97.7430608%26countryCode%3DUS%26locationPrecision%3DCity%26radius%3D30%26radiusUnit%3Dmi%26page%3D1%26pageSize%3D20%26language%3Den&searchId=5fb7a37e-8a71-48d2-9b10-e00cea5eb1da',
                industryName: '',
                postedDate: '10/21/2020 09:00 AM',
                hiringCompany: {
                    id: '',
                    name: 'The Judge Group, Inc.',
                    description: '',
                    url: ''
                },
                location: {
                    country: 'US',
                    state: 'TX',
                    city: 'Austin'
                },
                salary: {
                    annualMin: 60000,
                    annualMax: -1,
                    min: 5000,
                    max: -1
                },
                percent: 85,
                suggestedSkills: ['Native JavaScript', 'ECMAScript 6', 'CSS', 'HTML', 'Web Components']
            }, {
                jobID: '8d7aa702-b92c-4a5a-8018-15443d0876dd',
                jobExternalID: '5fb7a37e-8a71-48d2-9b10-e00cea5eb1da',
                name: 'Full Stack Web Developer / JavaScript',
                description: "Full Stack Web Developer \/ JavaScript\nRed Oak Technologies, Inc., Austin, TX  21 hours ago\n  Repo" +
                    "rt a poor listing\nSoftware architecture, Writing\nContract W2, Contract Independent, Contract Corp-" +
                    "To-Corp, 12 Months\nDepends on Experience\nTravel not required\nJob Description\nRed Oak Technology " +
                    "is seeking a Full Stack Web Developer - JavaScript for our high tech giant client located in Austin," +
                    " TX for a Contract position.\n\nResponsibilities:\n\nWrite clean, maintainable, modern JavaScript at" +
                    " a senior developer level\nWrite test in JavaScript\nWrite and maintain graphQL code or Rest API\nUs" +
                    "e API to retrieve data and authenticate users\nManage your Agile board\nDebug CI\/CD issues using Je" +
                    "nkins\nMentor junior developers, guide new team members\nCollaborate with UX to achieve approved des" +
                    "igns\nCollaborate with manager to design application architecture and UI\nReview and pull requests\n" +
                    "Attend standups, web hacks, backlog grooming and other meetings\nQualifications:\n\n6+ years’ experi" +
                    "ence in Full Stack Web Development with JavaScript\nFunctional Developer with ability to write clean" +
                    ", elegant, modern code in JavaScript that is plug-in, fixable, maintainable.\nExperience writing cod" +
                    "e for Enterprise Applications\nExperience managing personal Agile Board\nResponsible for writing tes" +
                    "ts in JavaScript\nExperience with GraphQL code preferred, Rest API is okay",
                url: 'https://www.dice.com/jobs/detail/full-stack-web-developer-%26%2347-javascript-red-oak-technologies%2C-inc.-austin-tx-73301/redoak/6727086?searchlink=search%2F%3Fq%3Dweb%2520developer%26location%3DAustin%2C%2520TX%2C%2520USA%26latitude%3D30.267153%26longitude%3D-97.7430608%26countryCode%3DUS%26locationPrecision%3DCity%26radius%3D30%26radiusUnit%3Dmi%26page%3D1%26pageSize%3D20%26language%3Den&searchId=5fb7a37e-8a71-48d2-9b10-e00cea5eb1da',
                industryName: '',
                postedDate: '10/21/2020 09:00 AM',
                hiringCompany: {
                    id: '',
                    name: 'Red Oak Technologies, Inc.',
                    description: '',
                    url: ''
                },
                location: {
                    country: 'US',
                    state: 'TX',
                    city: 'Austin'
                },
                salary: {
                    annualMin: 60000,
                    annualMax: -1,
                    min: 5000,
                    max: -1
                },
                percent: 70,
                suggestedSkills: ['JavaScript', 'GraphQL', 'Rest API']
            }];
            // #endregion Fake Jobs.

            $scope.modelAux.jobs = jobs;
            $scope.selectJob(0);
        };

        $scope.selectJob = function (jobIndex) {
            $scope.modelAux.selectedJob = $scope.modelAux.jobs[jobIndex];

            $scope.modelAux.selectedJob.suggestedSkillsRows = [];
            var skills = ($scope.modelAux.selectedJob.suggestedSkills) ? angular.copy($scope.modelAux.selectedJob.suggestedSkills) : [];
            var rows = [];
            var row = skills.splice(0, 4);

            while (row.length > 0) {
                rows.push(row);
                row = skills.splice(0, 4);
            }

            $scope.modelAux.selectedJob.suggestedSkillsRows = rows;
        };
        // #endregion Job Suggestions
    }

    // Based on: https://stackoverflow.com/a/26354111
    /** @ngInject */
    function fileReader() {
        return {
            scope: {
                fileReader: "="
            },
            link: function (scope, element) {
                $(element).on('change', function (changeEvent) {
                    $('#waitDiv')[0].style.display = 'block';
                    var files = changeEvent.target.files;
                    if (files.length) {
                        var r = new FileReader();
                        r.onload = function (e) {
                            var contents = e.target.result;
                            scope.$apply(function () {
                                scope.fileReader = contents;
                                $('#waitDiv')[0].style.display = 'none';
                            });
                        };

                        r.readAsText(files[0]);
                    }
                });
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('intryFrontEnd')
        .controller('AdminsController', AdminsController);

    /** @ngInject */
    function AdminsController($scope, constants, $state, adminService, $localStorage, $rootScope, toastr, $translate, organizationService) {
        window.scrollTo(0, 0);

        var recordsPerPage = constants.recordsPerPage;
    
        $scope.adminFilterFields = constants.adminFilterFields;
        $scope.filterField = constants.adminFilterFields[0].key;
        $scope.ftypes = constants.ftypesMultiFields;
        $scope.ftype = $scope.ftypes[0].key;
    
        $scope.paginationFilter = '';
        $scope.currentSkip = 0;
        $scope.currentPage = 1;
        $scope.totalPages = 1;
        $scope.admins = [];
        $scope.totalAdmins = 0;
        $scope.tableState = {};
        $scope.username = $localStorage.adminUser.username;
        $scope.requestCreate = function () {
            $localStorage.registeredUserID = undefined;
            $state.go('admin-create-admin');
        };

        // #region Pagination Methods.
        $scope.resetSkip = false;
    
        $scope.getAdmins = function (tableState) {
            $scope.tableState = tableState;
            $scope.isLoading = true;
            var adminData = [];

            if (angular.isUndefined($scope.currentSkip) || $scope.resetSkip) {
                $scope.currentSkip = 0;
                $scope.resetSkip = false;
            }

            var field = $scope.filterField;
      
            var sort = '';
            var order = '';

            if (typeof tableState !== 'undefined' && typeof tableState.sort.predicate !== 'undefined') {
                sort = tableState.sort.predicate;
                order = (tableState.sort.reverse) ? 1 : -1;
            }
      
            adminService.getAdmins($scope.currentSkip, recordsPerPage, field, $scope.paginationFilter, $scope.ftype, sort, order).then(function (response) {
                if (response.error) {
                    alert("There was an error, administrators could not be loaded");

                    return false;
                }

                var admins = response.data[0]["admins"];
                $scope.totalAdmins = response.data[1]["total"];

                angular.forEach(admins, function (value, key) {
                    adminData.push({
                        'username': value.username,
                        'first_name': value.first_name,
                        'last_name': value.last_name,
                        'organizationKey': value.organizationKey,
                        'belongsTo': value.belongsTo,
                        'belongsToObj': value.belongsToObj,
                        'role': value.role,
                        'status': value.status,
                        'userID': value.userID
                    });
                });

                $scope.isLoading = false;
                $scope.admins = adminData;
                $scope.disablePrev = $scope.currentSkip == 0;
                $scope.disableNext = ($scope.currentSkip + recordsPerPage) >= $scope.totalAdmins;
                calcPages();
                return true;
            });
        };

        $scope.checkFtypes = function () {
            var field = _.findWhere($scope.adminFilterFields, {
                key: $scope.filterField
            });
            var ftypes = field.ftypes;
            $scope.ftypes = constants[ftypes];
            $scope.ftype = $scope.ftypes[0].key;
        };
    
        $scope.search = function () {
            $scope.currentSkip = 0;
            recordsPerPage = constants.recordsPerPage;
      
            if (typeof $scope.tableState !== 'undefined' && typeof $scope.tableState.sort !== 'undefined') {
                $scope.tableState.sort = {};
            }
      
            $scope.getAdmins();
        };

        $scope.viewAdmin = function (userID) {
            $localStorage.registeredUserID = userID;
            $state.go('admin-create-admin');
        };

        $scope.canEditAdmin = function (admin) {
            return admin.username.indexOf('_deleted_') === -1
                && admin.username !== $scope.username
                && admin.username !== constants.INTRY_ADMIN
                && ($scope.checkRole('ROLE_APP_ADMIN') || ($scope.checkRole('ROLE_ORGANIZATION_ADMIN') && admin.role !== 'ROLE_APP_ADMIN'));
        };

        $scope.canViewAdmin = function (admin) {
            return admin.username.indexOf('_deleted_') === -1
                && admin.username !== constants.INTRY_ADMIN
                && (($scope.username && (admin.username === $scope.username)) || $scope.checkRole(['ROLE_APP_ADMIN', 'ROLE_ORGANIZATION_ADMIN']));
        };

        $scope.canDisableAdmin = function (admin) {
            return admin.username.indexOf('_deleted_') === -1
                && admin.username !== $scope.username
                && admin.username !== constants.INTRY_ADMIN
                && ($scope.checkRole('ROLE_APP_ADMIN') || ($scope.checkRole('ROLE_ORGANIZATION_ADMIN') && admin.role !== 'ROLE_APP_ADMIN'));
        };

        $scope.canDeleteAdmin = function (rowname) {
            return $scope.checkRole('ROLE_APP_ADMIN')
                && rowname.indexOf('_deleted_') === -1
                && rowname !== $scope.username
                && rowname !== constants.INTRY_ADMIN;
        };

        $scope.disableAdminModal = function (user) {
            var username = user.username;
            var userID = user.userID;
            var msg = $translate.instant('ADMIN_SECTION_ADMINS_DISABLE_TEXT').replace('#####USERNAME#####', username);
            var result = confirm(msg);

            if (result) {
                $scope.disableAdmin(userID);
            }
        };

        $scope.disableAdmin = function (userID) {
            adminService.adminDisableAdmin(userID).then(function (response) {
                if (response.status === 200) {
                    $scope.buildDisableToastr($translate.instant('ADMIN_SECTION_ADMINS_DISABLE_SUCCESS_TEXT'), $translate.instant('ADMIN_CREATE_SUCCESS_TITLE'), 4000);
                } else {
                    var errorMsg = $translate.instant('ADMIN_SECTION_ADMINS_DISABLE_DISABLED_ERROR_TEXT');
                    $scope.buildToastr(errorMsg, $translate.instant('ADMIN_CREATE_WARNING_TITLE'), 4000);
                }
            });
        };

        $scope.enableAdminModal = function (user) {
            var username = user.username;
            var userID = user.userID;
            var msg = $translate.instant('ADMIN_SECTION_ADMINS_ENABLE_TEXT').replace('#####USERNAME#####', username);
            var result = confirm(msg);

            if (result) {
                $scope.enableAdmin(userID);
            }
        };

        $scope.enableAdmin = function (userID) {
            adminService.adminEnableAdmin(userID).then(function (response) {
                if (response.status === 200) {
                    $scope.buildDisableToastr($translate.instant('ADMIN_SECTION_ADMINS_ENABLE_SUCCESS_TEXT'), $translate.instant('ADMIN_CREATE_SUCCESS_TITLE'), 4000);
                } else {
                    var errorMsg = $translate.instant('ADMIN_SECTION_ADMINS_ENABLE_ENABLED_ERROR_TEXT');
                    $scope.buildToastr(errorMsg, $translate.instant('ADMIN_CREATE_WARNING_TITLE'), 4000);
                }
            });
        };
    
        $scope.deleteAdminModal = function (user) {
            var username = user.username;
            var userID = user.userID;
            var msg = $translate.instant('ADMIN_SECTION_ADMINS_DELETE_TEXT').replace('#####USERNAME#####', username);
            var result = confirm(msg);

            if (result) {
                $scope.deleteAdmin(userID);
            }
        };

        $scope.deleteAdmin = function (userID) {
            adminService.adminDeleteAdmin(userID).then(function (response) {
                if (response.status === 200) {
                    $scope.buildDisableToastr($translate.instant('ADMIN_SECTION_ADMINS_DELETE_SUCCESS_TEXT'), $translate.instant('ADMIN_CREATE_SUCCESS_TITLE'), 4000);
                } else {
                    var errorMsg = $translate.instant('ADMIN_SECTION_ADMINS_DELETE_DISABLED_ERROR_TEXT');
                    $scope.buildToastr(errorMsg, $translate.instant('ADMIN_CREATE_WARNING_TITLE'), 4000);
                }
            });
        };
    
        $scope.getPrevPage = function () {
            $scope.currentSkip = !angular.isUndefined($scope.currentSkip) ? $scope.currentSkip - recordsPerPage : 0;
            $scope.getAdmins();
        };

        $scope.getNextPage = function () {
            $scope.currentSkip = !angular.isUndefined($scope.currentSkip) ? $scope.currentSkip + recordsPerPage : 0;
            $scope.getAdmins();
        };

        var calcPages = function () {
            $scope.currentPage = ($scope.currentSkip / recordsPerPage) + 1;
            $scope.totalPages = Math.ceil($scope.totalAdmins / recordsPerPage);
        };
    
        $scope.setResetSkip = function (val) {
            $scope.resetSkip = val;
        };
        // #endregion Pagination Methods.

        // #region Notification Methods.
        $scope.buildToastr = function (content, title, timeout) {
            var t = toastr.info(content, title, {
                progressBar: true,
                timeOut: timeout,
                toastClass: 'toast',
                preventDuplicates: true,
                allowHtml: true,
                positionClass: 'toast-top-full-width',
                hideDuration: timeout,
                closeButton: true,
                showDuration: timeout,
                extendedTimeOut: timeout,
                hideMethod: 'noop'
            });
            $rootScope.toast = t;
        };

        $scope.buildDisableToastr = function (content, title, timeout) {
            var t = toastr.info(content, title, {
                progressBar: true,
                timeOut: timeout,
                toastClass: 'toast',
                preventDuplicates: true,
                allowHtml: true,
                positionClass: 'toast-top-full-width',
                hideDuration: timeout,
                closeButton: true,
                showDuration: timeout,
                extendedTimeOut: timeout,
                hideMethod: 'noop'
            });
            t.scope.options.onHidden = function () {
                $scope.getAdmins();
            };
            $rootScope.toast = t;
        };
        // #endregion Notification Methods.
    
        $scope.checkRole = function (roles) {
            var adminUser = $localStorage.adminUser || {};
            var adminRole = 'ROLE_ADMIN_USER';

            if (typeof adminUser.role === 'string' && adminUser.role.length > 0) {
                adminRole = adminUser.role;
            }
            if (typeof roles === 'string') {
                return roles === adminRole;
            }
            else if (Array.isArray(roles)) {
                return (roles.indexOf(adminRole) > -1) ? true : false;
            }
            else {
                return false;
            }
        };

        // #region White Label Code.
        $scope.userFullName = '';
        $scope.numberOfUsers = '';
        $scope.numberOfResumes = '';
        $scope.numberOfHired = '';
    
        function getUserFullName() {
            var adminUser = $localStorage.adminUser;
      
            if (
                typeof adminUser !== 'undefined' && adminUser !== null &&
                    typeof adminUser.first_name === 'string' &&
                    typeof adminUser.last_name === 'string'
            ) {
                $scope.userFullName = adminUser.first_name + ' ' + adminUser.last_name;
            }
        };
        getUserFullName();
    
        $scope.hasOrganization = function() {
            return organizationService.hasOrganization();
        };

        $scope.getOrganizationCss = function(css, returnEmpty) {
            return organizationService.getOrganizationCss(css, returnEmpty);
        };

        $scope.getOrganizationKey = function() {
            return organizationService.getOrganizationKey();
        };

        $scope.getOrganizationName = function() {
            return organizationService.getOrganizationName();
        };
      
        $scope.getTitle = function (txt) {
            var title = $translate.instant(txt);

            if ($scope.checkRole('ROLE_APP_ADMIN')) {
                title = title.replace('#####ADMIN_TITLE#####', 'Administrator');
            } else {
                title = title.replace('#####ADMIN_TITLE#####', 'Admins / Case Manager');
            }

            return title;
        };
    
        $scope.getAdminStats = function () {
            try {
                adminService.getAdminStats().then(function (adminStatsResponse) {
                    try {
                        if (adminStatsResponse) {
                            $scope.numberOfUsers = adminStatsResponse.data.numberOfUsers;
                            $scope.numberOfResumes = adminStatsResponse.data.numberOfResumes;
                            $scope.numberOfHired = adminStatsResponse.data.numberOfHired;
                        }
                    } catch (e) {
                        // Do nothing...
                    }
                });
            } catch (e) {
                // Do nothing...
            }
        };
        // #endregion White Label Code.
    }
})();

(function () {
  'use strict';

  angular
    .module('intryFrontEnd')
    .controller('WizardController', WizardController);

  /** @ngInject */
  function WizardController($scope, $localStorage, $stateParams, modalService, userService, user, resume, $state, utilsService, resumeValidation) {
    var wizard = this;
    wizard.user = user;
    wizard.resume = resume;

    wizard.isStateChangeStart = false;
    wizard.currentStep = parseInt($stateParams.step);
    wizard.stepsCount = 2;

    wizard.isWizard = true;
    wizard.assessmentStep = 1;
    wizard.assessmentFinished = false;

    wizard.resumeIsDirty = true;
    wizard.isFirstTimeSavedResume = false;
    wizard.isResumeDownloaded = false;

    $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
      wizard.isStateChangeStart = true;
    });

    $scope.$on('$stateChangeError', function () {
      wizard.isStateChangeStart = false;
    });

    wizard.getProgress = function () {
      if (wizard.isResumeDownloaded) {
        return 100;
      } else {
        return (wizard.currentStep - 1) * 100 / wizard.stepsCount;
      }
    };

    wizard.quit = function () {
      if (wizard.isStateChangeStart) {
        return;
      }

      wizard.leavingModal = modalService.openModal(
        'app/wizard/template/leaving-wizard-modal.html',
        'LeavingWizardModal', {}, {
          className: 'new-ngdialog'
        }
      );
    };

    wizard.showFinalModal = function () {
      modalService.openModal(
        'app/wizard/template/wizard-final-modal.html',
        'WizardFinalModal', {
          user: function () {
            return user;
          }
        }, {
          className: 'new-ngdialog wizard-final-modal'
        }
      );
    };

    wizard.isDisabledNextBtn = function () {
      return wizard.currentStep === 1 && wizard.assessmentStep === 1;
    };

    wizard.changeStep = function (step) {
      wizard.currentStep = step;
    };

    wizard.skipJ2R = function () {
      wizard.resumeEditor.goToPage('edit_resume');
    };

    wizard.goToStep = function (step) {
      switch (step) {
        /*
        case 3:
          wizard.isSavingUserAndGoingToNextStep = true;
          wizard.saveUserProfile();

          break;
        */
        case 1:
          $state.go('wizard', {
            step: step
          }, {
            reload: 'wizard'
          });
          window.scroll(0, 0);

          break;
        case 4:
          if (!wizard.isResumeDirty) {
            wizard.changeStep(step);
            wizard.resumeEditor.goToPage('preview_resume');
          } else {
            wizard.resumeEditor.validateTheResume({
              action: 'goToStep4'
            });
          }
          window.scroll(0, 0);

          break;
        default:
          $state.go('wizard', {
            step: step
          });
          window.scroll(0, 0);
      }
    };

    wizard.backToStep = function (step) {
      if (step === 3) {
        wizard.changeStep(step);
        if (wizard.isSkipJ2R) {
          wizard.isSkipJ2R = false;
          wizard.resumeEditor.goToPage('j2r');
        } else {
          wizard.resumeEditor.editData();
        }
      } else {
        $state.go('wizard', {
          step: step
        });
      }
      window.scroll(0, 0);
    };

    wizard.isCurrentStep = function (step) {
      return wizard.currentStep === step;
    };

    wizard.goToAssessmentStep = function (step) {
      if (step === 3) {
        userService.getUser(true).then(function (user) {
          wizard.user = user;
          wizard.assessmentStep = step;
        });
      } else {
        wizard.assessmentStep = step;
      }
      window.scroll(0, 0);
    };

    wizard.saveUserProfile = function (silent) {
      if (typeof silent === 'undefined') silent = false;

      if (wizard.userProfileScope && wizard.userProfileScope.validatePersonalData) {
        wizard.userProfileScope.validatePersonalData(silent);
      }
    };

    wizard.saveAndDownloadResume = function () {
      if (!wizard.isResumeDirty && wizard.isFirstTimeSavedResume) {
        wizard.resumeEditor.downloadResume(null, true);
      } else {
        wizard.resumeEditor.validateTheResume({
          action: 'downloadResume'
        });
      }
    };

    wizard.finishWizard = function () {
      wizard.showFinalModal();
    };

    $scope.$on('initResumeBuilderProfile', function (event, data) {
      wizard.resumeEditor = data;
      wizard.isParseJobDisabled = function () {
        return !data.hasText() || data.hasProcessed;
      };
      wizard.isResumeDirty = true;
    });

    $scope.$on('successUpdateUser', function () {
      if (wizard.isSavingUserAndGoingToNextStep) {
        wizard.isSavingUserAndGoingToNextStep = false;
        if (wizard.currentStep === 2) {
          userService.getUser().then(function (userResponse) {
            var userProfile = utilsService.checkUserProfile(userResponse);
            var error = resumeValidation.isValid(userProfile);
            if (!(error && error.errString.length)) {
              $state.go('wizard', {
                step: wizard.currentStep + 1
              });
            } else {
              showResumeInvalid();
            }
          });
        } else {
          $state.go('wizard', {
            step: wizard.currentStep + 1
          });
        }
      }
    });

    $scope.$on('successUpdateProfile', function (event, data) {
      wizard.isFirstTimeSavedResume = true;
      if (data && typeof data.options === 'object') {
        switch (data.options.action) {
          case 'goToStep4':
            wizard.changeStep(4);
            wizard.resumeEditor.goToPage('preview_resume');
            break;
        }
      }
    });

    $scope.$on('successDownloadResume', function (event) {
      wizard.isResumeDownloaded = true;
      wizard.showFinalModal();
    });

    $scope.$on('isResumeDirty', function (event, data) {
      wizard.isResumeDirty = data.isResumeDirty;
    });

    var showResumeInvalid = function () {
      $scope.scrimPageBackground = true;
      modalService.openModal(
        'app/resumes/template/validation-error-dialog.html',
        'resumeValidationController'
      ).finally(function () {
        $scope.scrimPageBackground = false;
      });
    };

    wizard.showResetModal = function () {
      // console.log('-- (Controller) wizard.showResetModal()');

      modalService.openModal(
        'app/wizard/template/wizard-reset-modal.html',
        'WizardResetModal', {
          user: function () {
            return user;
          }
        }, {
          className: 'new-ngdialog wizard-final-modal'
        }
      );
    };
  }
})();
(function () {
  'use strict';

  angular
    .module('intryFrontEnd')
    .controller('WizardResetModal', WizardResetModal);

  function WizardResetModal($scope, $state, $localStorage, utilsService, resumeValidation, modalService, user, userService, toastr, $rootScope) {
    $scope.goToDashboard = function () {
      $state.go('dashboard');
    };

    $scope.reset = function () {
      // console.log('-- (Controller) WizardResetModal.reset()');

      if (
        typeof $localStorage.backupUser !== 'undefined' &&
        $localStorage.backupUser !== null &&
        typeof $localStorage.backupUser.userID === 'string'
      ) {
        userService.rollbackUser($localStorage.user, $localStorage.backupUser, true).then(function (rollbackUserResponse) {
          // console.log('-- (Controller) WizardResetModal.reset() - rollbackUserResponse: ', rollbackUserResponse);

          if (
            typeof rollbackUserResponse !== 'undefined' &&
            rollbackUserResponse !== null &&
            rollbackUserResponse.userID !== 'undefined'
          ) {
            $state.go('wizard', {
              step: 1
            }, {
              reload: 'wizard'
            });
            window.scroll(0, 0);
          } else {
            $scope.close();
            buildToastr('Failed to reset your account, please try again', 'Warning', 2000);
          }
        });
      }
    };

    $scope.restartAssessments = function () {
      // console.log('-- (Controller) WizardResetModal.restartAssessments()');

      userService.deleteAssessmentsByUserID($localStorage.user.userID).then(function (response) {
        // console.log('-- (Controller) WizardResetModal.restartAssessments() - response: ', response);

        if (
          typeof response !== 'undefined' &&
          response !== null
        ) {
          $state.go('wizard', {
            step: 1
          }, {
            reload: 'wizard'
          });
          window.scroll(0, 0);
        } else {
          $scope.close();
          buildToastr('Failed to restart, please try again', 'Warning', 2000);
        }
      });
    };

    $scope.close = function () {
      modalService.closeModal();
    };

    function buildToastr(content, title, timeout) {
      var t = toastr.info(content, title, {
        progressBar: true,
        timeOut: timeout,
        toastClass: 'toast',
        preventDuplicates: true,
        allowHtml: true,
        positionClass: 'toast-top-full-width',
        hideDuration: timeout,
        closeButton: true,
        showDuration: timeout,
        extendedTimeOut: timeout,
        hideMethod: 'noop'
      });
      $rootScope.toast = t;
    }
  }
})();
(function () {
  'use strict';
  
  angular
  .module('intryFrontEnd')
  .controller('WizardFinalModal', WizardFinalModal);
  
  function WizardFinalModal($scope, $state, $localStorage, utilsService, resumeValidation, modalService, user) {

    $scope.goToDashboard = function() {
      $state.go('dashboard');
    };

    $scope.openCreateResume = function($event) {
      $event.preventDefault();
      var userProfile = utilsService.checkUserProfile(user);
      var error = resumeValidation.isValid(userProfile);
      var stateParams = {};

      if (!(error && error.errString.length)) {
        stateParams.job2resume = true;

        if (utilsService.getResumeId(user.userID)) {
          stateParams.resumeId = utilsService.getResumeId(user.userID);
        } else {
          stateParams.new = true;
        }
        $state.go('resume-profile', stateParams);
      } else {
        modalService.openModal(
          'app/resumes/template/validation-error-dialog.html',
          'resumeValidationController'
        );
      }
    };

  }
})();
(function () {
  'use strict';

  angular
    .module('intryFrontEnd')
    .component('wizardButtons', {
      templateUrl: 'app/wizard/template/wizard-buttons.html',
      bindings: {
        type: '@',
        wizard: '<',
      }
    });

})();
(function () {
  'use strict';

  angular
    .module('intryFrontEnd')
    .component('wizardAssessment', {
      templateUrl: 'app/wizard/template/wizard-assessment.html',
      controller: 'AssessmentSlidesController',
      bindings: {
        wizard: '<'
      }
    });

})();
(function () {
  'use strict';
  
  angular
  .module('intryFrontEnd')
  .controller('LeavingWizardModal', LeavingWizardModal);
  
  function LeavingWizardModal($scope, $state) {

    $scope.goToDashboard = function() {
      $state.go('dashboard');
    }

  }
})();
/* global Chart */
(function () {
  'use strict';

  angular
    .module('intryFrontEnd')
    .config(function (socialProvider, constants) {
      socialProvider.setLinkedInKey(constants.linkedINKey);
      socialProvider.setFbKey({ appId: constants.facebook_Key, apiVersion: constants.facebook_api_ver });
    })
    .controller('UserProfileController', UserProfileController);

  /** @ngInject */
  function UserProfileController($scope, user) {
    $scope.user = user;
  }

})();
(function () {
    'use strict';

    angular
        .module('intryFrontEnd')
        .component('userProfile', {
            templateUrl: 'app/user-profile/template/user-profile.html',
            controller: UserProfileComponentController,
            controllerAs: 'userProfile',
            bindings: {
                wizard: '<',
                user: '='
            }
        });

    /** @ngInject */
    function UserProfileComponentController($scope, $document, $timeout, userService, $state, constants, ngDialog, $translate, utilsService, resumeService, $rootScope, assessmentsService, $parse, toastr, resumeValidation, fixService, $validation, unsaveService, phoneFormatter, dragulaService, organizationService) {
        var user = this.user;
        userService.backupUser(user);

        CKEDITOR.config.customConfig = '/media/ckeditor_config.js';

        window.scrollTo(0, 0);
        $scope.isCancelEdit = false;
        $scope.summary = '';
        $scope.user = user;
        $scope.user.full_name = user.full_name || utilsService.getFullName(user.first_name, user.last_name);
        $scope.skillExists = false;
        $scope.editDatesValid = true;
        $scope.showUploadResume = false;
        $scope.HOST_URL = location.origin;
        $scope.proficiencyList = ['', '(Beginner)', '(Intermediate)', '(Average)', '(Advanced)', '(Expert)'];
        $scope.profileImgModal = false;
        $scope.defaultImage = $scope.user.profile_picture_url ? false : true;
        $scope.cropped = {
            source: $scope.user.profile_picture_url
        };
        $scope.isDisable = false;

        var isToolbox = false;
        var parsingResume = false;
        var messageNotShown = false;

        $scope.$ctrl = this;
        var userProfile = this;
        userProfile.isSubscriber = userService.isPaidFeatureEnabled(user);
        userProfile.allowResume = false;
        userProfile.isEditable = true;

        userProfile.resumeUploadingStatus = '';
        userProfile.isFirstTimeResumeUploading = false;

        if (userProfile.wizard) {
            userProfile.wizard.userProfileScope = $scope;
        }

        $scope.setCurrentItem = function (item) {
            if (item.is_current) {
                item.date_end = '';
                item.endDateObj = '';
                item.endMonthObj = null;
                item.endYearObj = null;
            }
        };

        $scope.$watch('profileImgModal', function (isShowModal) {
            if (isShowModal) {
                $('html, body').addClass('ngdialog-open');
            } else {
                $('html, body').removeClass('ngdialog-open');
            }
        });

        this.phoneFlatten = function () {
            if (userProfile.phoneNumber.number) {
                userProfile.phoneNumber.number = phoneFormatter.flatten(userProfile.phoneNumber.number);
            }
        };

        this.phoneDisplay = function () {
            if (userProfile.phoneNumber.number) {
                userProfile.phoneNumber.number = phoneFormatter.format(userProfile.phoneNumber.number);
            }
        };

        function changeBr(str) {
            return str.replace(/\n/g, '').replace(/<br \/>/g, '<br/>');
        }

        function getPhoneNumber(phones) {
            var phone = {
                number: '',
                kind: ''
            };
            if (Array.isArray(phones)) {
                var filteredPhones = _.filter(phones, {deleted: false});
                var lastPhone;
                
                if (filteredPhones.length) {
                    lastPhone = filteredPhones[filteredPhones.length - 1];
                    phone.number = phoneFormatter.format(lastPhone.number);
                    phone.kind = lastPhone.kind;
                    phone._id = lastPhone._id;
                }
            }
            return phone;
        }

        function getAddress(addresses) {
            var address = {
                city: '',
                state: ''
            };
            if (Array.isArray(addresses)) {
                addresses = _.filter(addresses, {deleted: false});
                if (addresses.length > 0) {
                    address = addresses[addresses.length - 1];
                }
            }
            return address;
        }

        dragulaService.options($scope, 'skills-bag', {
            moves: function (el, source, handle, sibling) {
                return handle.classList.contains('skills-bag-draggable');
            }
        });

        document.getElementById("submit_validation").addEventListener("click", function () {
            angular.element($document[0].querySelector('select.ng-invalid')).focus();
            angular.element($document[0].querySelector('select.ng-empty')).focus();
            angular.element($document[0].querySelector('input.ng-invalid')).focus();
            angular.element($document[0].querySelector('input.ng-empty')).focus();
        });
        document.getElementById("submit_validation_sidebar").addEventListener("click", function () {
            angular.element($document[0].querySelector('select.ng-invalid')).focus();
            angular.element($document[0].querySelector('select.ng-empty')).focus();
            angular.element($document[0].querySelector('input.ng-invalid')).focus();
            angular.element($document[0].querySelector('input.ng-empty')).focus();
        });
    
        $scope.upload_cropped_img = function () {
            $rootScope.loadingInProcess = true;
            var imageBase64 = $scope.cropped.image;
            $scope.user.profile_picture_url = $scope.cropped.image;
            $scope.defaultImage = false;
            var imgdata = imageBase64.split(',')[1];
            var ct = imageBase64.split(":")[1];
            var contenttype = ct.split(";")[0];
            var imgName = Math.floor(Date.now() / 1000) + '.png';
            var img = $scope.b64toBlob(imgdata, imgName, contenttype);
            var attachment = {};
            attachment.file = img;
            attachment.type = 'Profile picture';
            $scope.showImageLoader = true;
            userService.uploadCurrentUserAttachments(attachment).then(function (response) {
                userService.updateCurrentUser({
                    profile_picture_url: response.data.url
                }).then(function (response) {
                    // $timeout(function () {
                    $scope.profilePictureURL = response.profile_picture_url;
                    $scope.showImageLoader = false;
                    $scope.cropped.source = $scope.profilePictureURL;
                    $scope.user.profile_picture_url = $scope.cropped.source;
                    // }, 4000);
                    $scope.profileImgModal = false;
                    $rootScope.$broadcast('currentUser-updated');
                    $rootScope.loadingInProcess = false;
                }, function () {
                    $scope.showImageLoader = false;
                    $rootScope.loadingInProcess = false;
                });
            });

        };
        $scope.b64toBlob = function (b64Data, fileName, contentType, sliceSize) {
            contentType = contentType || '';
            sliceSize = sliceSize || 512;
            fileName = fileName;
            var byteCharacters = atob(b64Data);
            var byteArrays = [];

            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);

                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNumbers);

                byteArrays.push(byteArray);
            }
            // var imgblob = new File(byteArrays, fileName, { type: contentType });
            // var imgblob = new Blob(byteArrays,{type: contentType});
            var imgblob;
            try {
                imgblob = new File(byteArrays, fileName, {
                    type: contentType
                });
            } catch (e) {
                try {
                    imgblob = new Blob(byteArrays, {
                        type: contentType
                    });
                } catch (e2) {
                    // Nothing to do.
                }
            }
            return imgblob;
        };
        var fillRating = function (el, fill) {
            return el.style.backgroundImage = 'linear-gradient(to right, #6e55a7, #5382b1, #487eb0, #3595ae, #2ba1ad, #29a4ad ' + fill + '%, #e7e9eb 1%, #e7e9eb 100%)';
        };

        var getFill = function (event) {
            var pos = event.clientX - event.target.getBoundingClientRect().left;
            var fill = Math.ceil(((pos + 1) / event.target.offsetWidth) * 5) * 20;
            return fill;
        };
        $scope.showCropedModal = function () {
            $scope.profileImgModal = true;
        };

        // userProfile.editPersonalData = function () {
        //     userProfile.skillsTemp = angular.copy(userProfile.skills);
        //     userProfile.educationListTemp = angular.copy(userProfile.educationList);
        //     userProfile.skillsListTemp = angular.copy(userProfile.skillsList);
        //     userProfile.awardListTemp = angular.copy(userProfile.awardList);
        //     userProfile.linkListTemp = angular.copy(userProfile.linkList);
        //     userProfile.transcriptListTemp = angular.copy(userProfile.transcriptList);
        //     userProfile.referenceListTemp = angular.copy(userProfile.referenceList);
        //     userProfile.experienceListTemp = angular.copy(userProfile.experienceList);
        //     userProfile.isEditable = true;

        //     $('.editable-inline').addClass('now-editable');
        //     $('.now-editable').removeClass('editable-inline');
        // };

        // Get education and experience dropdown options.
        $scope.education_kinds = constants.education_kind;
        $scope.employment_kinds = constants.employment_kind;

        // Render User assesments
        var ASSESSMENT_BIG_FIVE_ID = constants.ASSESSMENT_BIG_FIVE_ID;

        var mapType = function (type) {
            return {
                score: type.score,
                name: type['personality_type'].name,
                image: type['personality_type']['badge']['image_small'],
                color: type['personality_type']['badge']['color_1']
            };
        };
        var setRadarChart = function (elementId, data) {
            var context = document.getElementById(elementId).getContext('2d');
            var gradient = context.createLinearGradient(0, 0, 150, 100);
            gradient.addColorStop(0, "rgba(110, 85, 167, .6)");
            gradient.addColorStop(1, "rgba(41, 164, 173, .6)");
            new Chart(context, {
                type: 'radar',
                data: data.reduce(function (obj, item) {
                    obj.labels.push(item.name);
                    obj.datasets[0].data.push(item.score);
                    return obj;
                }, {
                    labels: [],
                    datasets: [{
                        data: [],
                        backgroundColor: gradient
                    }]
                }),
                options: {
                    legend: {
                        display: false
                    },
                    tooltips: {
                        enabled: false
                    },
                    scale: {
                        angleLines: {
                            color: 'rgba(0, 0, 0, 0.05)',
                            lineWidth: 1
                        },
                        pointLabels: {
                            fontColor: 'rgba(0, 0, 0, 0.5)'
                        },
                        ticks: {
                            beginAtZero: true,
                            display: false
                        }
                    }
                }
            });
        };
        var showBig5AssessmentResults = function (id) {
            var big5Required = ['types', 'archetype'];
            var imagePack = 'linear';
            assessmentsService.getResults(id, big5Required, imagePack).then(function (traitifyData) {
                if (traitifyData) {
                    $scope.assessmentData = {
                        archetype: traitifyData.data['archetype']['name'],
                        mainTypes: traitifyData.data['personality_types'].map(mapType)
                    };
                    setRadarChart('assessment-radar-canvas', $scope.assessmentData.mainTypes);
                }
            });
        };

        var getUserAssessment = function (assessmentDeckId) {
            if ($scope.user && $scope.user.assessments) {
                for (var i = 0; i < $scope.user.assessments.length; i += 1) {
                    if ($scope.user.assessments[i].assessmentId && $scope.user.assessments[i].deck_id === assessmentDeckId) {
                        return $scope.user.assessments[i];
                    }
                }
            }
            return null;
        };
        userProfile.assessments = getUserAssessment(ASSESSMENT_BIG_FIVE_ID);
        if (userProfile.assessments) {
            showBig5AssessmentResults(userProfile.assessments.assessmentId);
        }
        // initialise userProfile with skill education experience etc.

        userProfile.summary = $scope.summary;
        userProfile.skillValue = '';
        userProfile.educationList = $scope.user.education && $scope.user.education.length > 0 ? angular.copy($scope.user.education) : [];
        userProfile.skillsList = $scope.user.skills && $scope.user.skills.length > 0 ? angular.copy($scope.user.skills) : [];

        function setListeners(rateControl) {
            rateControl.addEventListener('mousemove', function (event) {
                var fill = getFill(event);
                fillRating(event.currentTarget, fill);
            }, true);

            rateControl.addEventListener('click', function (event) {
                var rating = getFill(event) / 20;
                fillRating(event.currentTarget, rating * 20);
                var lst = userProfile.skillsList.filter(function (i) {
                    return i.deleted == false;
                });
                lst[parseInt(event.currentTarget.getAttribute('ndx'))].proficiency = rating;
                $scope.$apply();
            });

            rateControl.addEventListener('mouseout', function (event) {
                var lst = userProfile.skillsList.filter(function (i) {
                    return i.deleted == false;
                });
                var rating = lst[parseInt(event.currentTarget.getAttribute('ndx'))].proficiency;
                fillRating(event.currentTarget, rating * 20);
            });
        }

        function updateSkillsRatings(withoutWait) {
            withoutWait = withoutWait || false;

            var update = function () {
                try {
                    var ndx = 0;
                    _.each(userProfile.skillsList, function (skill) {
                        var rateControl = document.getElementById('skill_' + ndx); //userProfile.skillsList.indexOf(skill));
                        rateControl.setAttribute('ndx', ndx);
                        ndx = ndx + 1;
                        rateControl.setAttribute('data-rating', skill.proficiency);
                        fillRating(rateControl, skill.proficiency * 20);
                        setListeners(rateControl);
                    });
                } catch (e) {

                }
            };

            if (withoutWait) {
                update();
            } else {
                setTimeout(function () {
                    update();
                }, 750);
            }
        }
        updateSkillsRatings();

        $scope.summary = $scope.user.summary;
        userProfile.linkList = $scope.user.links && $scope.user.links.length > 0 ? angular.copy($scope.user.links) : [];
        userProfile.achievements_awards = $scope.user.achievements_awards && $scope.user.achievements_awards.length > 0 ? angular.copy($scope.user.achievements_awards) : [];

        userProfile.transcriptList = $scope.user.transcripts && $scope.user.transcripts.length > 0 ? angular.copy($scope.user.transcripts) : [];
        userProfile.transcriptListTemp = userProfile.transcriptList;

        userProfile.referenceList = $scope.user.references && $scope.user.references.length > 0 ? angular.copy($scope.user.references) : [];
        userProfile.experienceList = $scope.user.experience && $scope.user.experience.length > 0 ? angular.copy($scope.user.experience) : [];
        userProfile.proficiency = 3;
        userProfile.showAddEducationBar = [];


        // Add personal data
        userProfile.phoneNumber = getPhoneNumber($scope.user.phone_numbers);
        userProfile.address = getAddress($scope.user.addresses);

        var refillDropdownCb = function (element) {
            element.startDateObj = utilsService.formatDate(element.date_start);
            element.endDateObj = utilsService.formatDate(element.date_end);

            element.startMonthObj = utilsService.getMonthObj(element.date_start);
            element.startYearObj = utilsService.getYearObj(element.date_start);
            element.endMonthObj = utilsService.getMonthObj(element.date_end);
            element.endYearObj = utilsService.getYearObj(element.date_end);

            // console.log('-- (Controller) userProfile.refillDropdownCb() - element: ', element);
        };

        var refillDropdown = function () {
            // console.log('-- (Controller) userProfile.refillDropdown()');

            _.each(userProfile.experienceList, function (element, i) {
                refillDropdownCb(element);
                // if (element.date_end != 'Present' && element.date_end != 'Current') {
                //   element.endDateObj = utilsService.formatDate(element.date_end);
                // }
            });

            _.each(userProfile.educationList, function (element, i) {
                refillDropdownCb(element);
            });

            _.each(userProfile.achievements_awards, function (element, i) {
                refillDropdownCb(element);
            });
        };
        refillDropdown();
        // For Month and year
        var date = new Date();
        var months = [];
        var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        var i = 1;
        angular.forEach(monthNames, function (monthName) {
            var month = {
                fullmonthName: monthName,
                monthNumber: i
            };
            i++;
            months.push(month);
        });
        $scope.months = months;

        function getYears() {
            var currentYear = date.getFullYear() - 69;
            $scope.years = [];
            for (var i = 69; i > 0; i--) {
                $scope.years.push(currentYear + i);
            }

            return $scope.years;
        }
        getYears();

        function getYears2() {
            var currentYear = date.getFullYear() + 3 - 69;
            $scope.years2 = [];
            for (var i = 69; i > 0; i--) {
                $scope.years2.push(currentYear + i);
            }

            return $scope.years2;
        }
        getYears2();

        // show profile image
        var populatePersonalData = function () {
            if (user.profile_picture_url) {
                $scope.profilePictureURL = user.profile_picture_url;
            }
        };
        // select proficiency from dropdown.
        userProfile.selectProficiency = function (proficiency) {
            userProfile.proficiency = proficiency;
        };

        function orderIndexSorting(list) {
            list = _.filter(list, {
                deleted: false
            });
            _.each(list, function (item, key) {
                item.order_index = key;
            });
        }
        $scope.setFocusSkill = function () {
            $scope.skillExists = false;
            document.getElementById('newSkill').focus();
        };

        // Remove education
        userProfile.removeEducation = function (element, ind) {
            if (userProfile.educationList && userProfile.educationList.length) {
                var index = _.findIndex(userProfile.educationList, {
                    "_id": element._id
                });
                $scope.removeCkEditor();
                if (index >= 0) {
                    userProfile.educationList[index].deleted = true;
                } else {
                    var idx = userProfile.educationList.indexOf(element);
                    userProfile.educationList.splice(idx, 1);
                }
                if (userProfile.educationListError)
                    userProfile.educationListError = [];
                orderIndexSorting(userProfile.educationList);
            }
        };

        // Remove experience
        userProfile.removeExperience = function (element, ind) {
            if (userProfile.experienceList && userProfile.experienceList.length) {
                var index = _.findIndex(userProfile.experienceList, {
                    "_id": element._id
                });
                $scope.removeCkEditor();
                if (index >= 0) {
                    userProfile.experienceList[index].deleted = true;
                } else {
                    var idx = userProfile.experienceList.indexOf(element);
                    userProfile.experienceList.splice(idx, 1);
                }
                if (userProfile.experienceListError) userProfile.experienceListError = [];
                orderIndexSorting(userProfile.experienceList);
            }
        };

        // Remove skill
        userProfile.removeSkill = function (element) {
            if (userProfile.skillsList && userProfile.skillsList.length) {
                // var index = _.findIndex(userProfile.skillsList,{"_id":element._id})
                var index = userProfile.skillsList.indexOf(element);
                if (index >= 0) {
                    userProfile.skillsList[index].deleted = true;
                } else {
                    var idx = userProfile.skillsList.indexOf(element);
                    userProfile.skillsList.splice(idx, 1);
                }
                if (userProfile.skillsListError)
                    userProfile.skillsListError = [];
                orderIndexSorting(userProfile.skillsList);
            }
        };

        // Remove link
        userProfile.removeLink = function (element) {
            if (userProfile.linkList && userProfile.linkList.length) {
                var index = _.findIndex(userProfile.linkList, {
                    "_id": element._id
                });
                if (index >= 0) {
                    userProfile.linkList[index].deleted = true;
                } else {
                    var idx = userProfile.linkList.indexOf(element);
                    userProfile.linkList.splice(idx, 1);
                }
                if (userProfile.linkListError)
                    userProfile.linkListError = [];
                orderIndexSorting(userProfile.linkList);
            }
        };

        // Remove transcript
        userProfile.removeTranscript = function (element) {
            if (userProfile.transcriptList && userProfile.transcriptList.length) {
                var index = _.findIndex(userProfile.transcriptList, {
                    "_id": element._id
                });
                if (index >= 0) {
                    userProfile.transcriptList[index].deleted = true;
                } else {
                    var idx = userProfile.transcriptList.indexOf(element);
                    userProfile.transcriptList.splice(idx, 1);
                }
                if (userProfile.trasncriptListError)
                    userProfile.trasnceriptListError = [];
                orderIndexSorting(userProfile.transcriptList);
            }
        };

        // Remove reference
        userProfile.removeReference = function (element) {
            if (userProfile.referenceList && userProfile.referenceList.length) {
                var index = _.findIndex(userProfile.referenceList, {
                    "_id": element._id
                });
                if (index >= 0) {
                    userProfile.referenceList[index].deleted = true;
                } else {
                    var idx = userProfile.referenceList.indexOf(element);
                    userProfile.referenceList.splice(idx, 1);
                }
                if (userProfile.referenceListError)
                    userProfile.referenceListError = [];
                orderIndexSorting(userProfile.referenceList);
            }
        };

        // Remove award
        userProfile.removeAward = function (element) {
            if (userProfile.achievements_awards && userProfile.achievements_awards.length) {
                var index = _.findIndex(userProfile.achievements_awards, {
                    "_id": element._id
                });
                if (index >= 0) {
                    userProfile.achievements_awards[index].deleted = true;
                } else {
                    var idx = userProfile.achievements_awards.indexOf(element);
                    userProfile.achievements_awards.splice(idx, 1);
                }
                if (userProfile.awardListError)
                    userProfile.awardListError = [];
                orderIndexSorting(userProfile.achievements_awards);
            }
        };

        // Add new empty education.
        userProfile.addNewEducation = function (index, bottom, certification) {
            certification = certification || false;

            var kind = (certification) ? 'certification' : 'degree';

            if (!userProfile.educationList)
                userProfile.educationList = [];
            var newEducationObj = {
                degree: '',
                major: '',
                date_end: '',
                date_start: '',
                deleted: false,
                field_of_study: "",
                institution: "",
                notes: "",
                kind: kind,
                order_index: userProfile.educationList.length,
                endDateObj: '',
                startDateObj: ''
            };
            if (bottom) {
                userProfile.educationList.push(newEducationObj);
            } else if (index == 0) {
                userProfile.educationList.unshift(newEducationObj);
            } else {
                userProfile.educationList.splice(index, 0, newEducationObj);
            }
            userProfile.educationListError = [];
            // userProfile.showAddEducationBar && userProfile.showAddEducationBar[index] ? userProfile.showAddEducationBar[index] = false : '';
            if (userProfile.showAddEducationBar && userProfile.showAddEducationBar[index]) {
                userProfile.showAddEducationBar[index] = false;
            }
        };

        // Add new empty experience.
        userProfile.addNewExperience = function (index, bottom, military) {
            military = military || false;

            var kind = (military) ? 'Military' : 'Work';

            if (!userProfile.experienceList)
                userProfile.experienceList = [];
            var newExperienceObj = {
                title: '',
                company: '',
                description: '',
                summary: '',
                location: '',
                date_end: '',
                date_start: '',
                is_current: false,
                deleted: false,
                kind: kind,
                order_index: userProfile.experienceList.length,
                startDateObj: '',
                endDateObj: ''
            };
            if (bottom) {
                userProfile.experienceList.push(newExperienceObj);
            } else if (index == 0) {
                userProfile.experienceList.unshift(newExperienceObj);
            } else {
                userProfile.experienceList.splice(index, 0, newExperienceObj);
            }
            userProfile.experienceListError = [];
            // userProfile.showAddExperienceBar && userProfile.showAddExperienceBar[index] ? userProfile.showAddExperienceBar[index] = false : '';
            if (userProfile.showAddExperienceBar && userProfile.showAddExperienceBar[index]) {
                userProfile.showAddExperienceBar[index] = false;
            }
        };

        // Add new empty skill.
        userProfile.addNewSkill = function (index, bottom) {
            var newSkillObj = {
                skill: '',
                proficiency: 3,
                deleted: false,
                order_index: userProfile.skillsList.length,
            };

            if (bottom) {
                userProfile.skillsList.push(newSkillObj);
            } else if (index == 0) {
                userProfile.skillsList.unshift(newSkillObj);
            } else {
                userProfile.skillsList.splice(index, 0, newSkillObj);
            }

            userProfile.skillsListError = [];
            // userProfile.showAddSkillBar && userProfile.showAddSkillBar[index] ? userProfile.showAddSkillBar[index] = false : '';
            if (userProfile.showAddSkillsBar && userProfile.showAddSkillsBar[index]) {
                userProfile.showAddSkillsBar[index] = false;
            }

            // orderIndexSorting(userProfile.skillsList);

            setTimeout(function () {
                var cnt = userProfile.skillsList.filter(function (i) {
                    return i.deleted == true;
                }).length;
                userProfile.skillsList.filter(function (i) {
                    return i.deleted == false;
                });
                var rateControl = document.getElementById('skill_' + (userProfile.skillsList.length - (1 + cnt)));
                rateControl.setAttribute('data-rating', newSkillObj.proficiency);
                fillRating(rateControl, newSkillObj.proficiency * 20);
                setListeners(rateControl);
                var lst = $('.skill-name');
                if (lst.length > 0)
                    lst[lst.length - 1].focus();
            }, 750);
        };

        // Add new empty link.
        userProfile.addNewLink = function (index, bottom) {
            var newLinkObj = {
                name: '',
                url: '',
                deleted: false,
                order_index: userProfile.linkList.length,
            };
            if (bottom) {
                userProfile.linkList.push(newLinkObj);
            } else if (index == 0) {
                userProfile.linkList.unshift(newLinkObj);
            } else {
                userProfile.linkList.splice(index, 0, newLinkObj);
            }
            userProfile.linkListError = [];
            // userProfile.showAddLinkBar && userProfile.showAddLinkBar[index] ? userProfile.showAddLinkBar[index] = false : '';
            if (userProfile.showAddLinkBar && userProfile.showAddLinkBar[index]) {
                userProfile.showAddLinkBar[index] = false;
            }
            // orderIndexSorting(userProfile.linkList);

            setTimeout(function () {
                var lst = $('.link-name');
                if (lst.length > 0)
                    lst[lst.length - 1].focus();
            }, 750);
        };

        $scope.selectTranscriptFile = function (upFile) {
            var ndx = upFile.id.split('_')[1];
            var file = upFile.files[0];
            var ext = file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length);

            var allowedFiles = ["png", "jpg", "jpeg", "svg", "gif", "pdf", "tiff", "bmp"];
            if (allowedFiles.indexOf(ext) < 0) {
                $('#noFile_' + ndx).html("Select File");
                buildToastr("Please upload files having extensions: " + allowedFiles.join(', ') + " only.", "Warning:", 3000);
            } else if (file.size > (constants.MAX_PROFILE_PIC_FILE_SIZE / 2)) {
                buildToastr($translate.instant('USER_PROFILE_PICTURE_SIZE_LIMIT_ERROR', {
                    size_limit: constants.MAX_PROFILE_PIC_FILE_SIZE / 2
                }), "Warning:", 3000);
            } else {
                userProfile.transcriptList[ndx].file = file;
                userProfile.transcriptList[ndx].type = file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length) || 'txt';
                userProfile.transcriptList[ndx].file_name = file.name;
                $('#noFile_' + ndx).html(file.name);
            }
        };

        // Add new empty transcript.
        userProfile.addNewTranscript = function (index, bottom) {
            var newTranscriptObj = {
                name: '',
                url: 'url Not Set',
                type: '',
                file: null,
                file_name: 'Select File',
                deleted: false,
                order_index: userProfile.transcriptList.length
            };
            if (bottom) {
                userProfile.transcriptList.push(newTranscriptObj);
            } else if (index == 0) {
                userProfile.transcriptList.unshift(newTranscriptObj);
            } else {
                userProfile.transcriptList.splice(index, 0, newTranscriptObj);
            }
            userProfile.transcriptListError = [];
            // userProfile.showAddTranscriptBar && userProfile.showAddTranscriptBar[index] ? userProfile.showAddTranscriptBar[index] = false : '';
            if (userProfile.showAddTranscriptBar && userProfile.showAddTranscriptBar[index]) {
                userProfile.showAddTranscriptBar[index] = false;
            }
            
            // orderIndexSorting(userProfile.transcriptList);

            setTimeout(function () {
                var lst = $('.transcript-name');
                if (lst.length > 0)
                    lst[lst.length - 1].focus();
            }, 750);
        };

        // Add new empty reference.
        userProfile.addNewReference = function (index, bottom) {
            var newReferenceObj = {
                name: '',
                relation: '',
                email: '',
                deleted: false,
                order_index: userProfile.referenceList.length,
            };
            if (bottom) {
                userProfile.referenceList.push(newReferenceObj);
            } else if (index == 0) {
                userProfile.referenceList.unshift(newReferenceObj);
            } else {
                userProfile.referenceList.splice(index, 0, newReferenceObj);
            }
            userProfile.referenceListError = [];
            // userProfile.showAddReferenceBar && userProfile.showAddReferenceBar[index] ? userProfile.showAddReferenceBar[index] = false : '';
            if (userProfile.showAddReferenceBar && userProfile.showAddReferenceBar[index]) {
                userProfile.showAddReferenceBar[index] = false;
            }

            // orderIndexSorting(userProfile.referenceList);
            setTimeout(function () {
                var lst = $('.reference-name');
                if (lst.length > 0)
                    lst[lst.length - 1].focus();
            }, 750);
        };

        // Add new empty award.
        userProfile.addNewAward = function (index, bottom) {
            var newAwardObj = {
                summary: '',
                deleted: false,
                order_index: userProfile.achievements_awards.length,

                date_end: '',
                date_start: '',
                startDateObj: '',
                endDateObj: ''
            };
            if (bottom) {
                userProfile.achievements_awards.push(newAwardObj);
            } else if (index == 0) {
                userProfile.achievements_awards.unshift(newAwardObj);
            } else {
                userProfile.achievements_awards.splice(index, 0, newAwardObj);
            }
            userProfile.awardListError = [];
            // userProfile.showAddAwardBar && userProfile.showAddAwardBar[index] ? userProfile.showAddAwardBar[index] = false : '';
            if (userProfile.showAddAwardBar && userProfile.showAddAwardBar[index]) {
                userProfile.showAddAwardBar[index] = false;
            }

            // orderIndexSorting(userProfile.achievements_awards);

            setTimeout(function () {
                var lst = $('.award-name');
                if (lst.length > 0)
                    lst[lst.length - 1].focus();
            }, 750);
        };

        function deepCopy(obj) {
            var clone = {};
            for (var key in obj) {
                if (obj.hasOwnProperty(key)) {
                    clone[key] = obj[key];
                }
            }
            return clone;
        }

        // Save user details also check for empty field.
        userProfile.silent = false;
        $scope.updatePersonalData = function (firstTime) {
            var silent = userProfile.silent;
            userProfile.silent = false;

            if (firstTime)
                parsingResume = true;
            // $scope.isDisable = true;
            $scope.removeCkEditor();
            var isGreter = false;
            // it is assumed that fixservice dealt with missing field values and date ordering.
            // There used to be a lot of code here that dealt with which was refactored into fixservice.
            _.each(userProfile.educationList, function (education, key) {
                education.order_index = key;
            });
            _.each(userProfile.experienceList, function (experience, key) {
                experience.order_index = key;
            });
            _.each(userProfile.skillsList, function (skill, key) {
                skill.order_index = key;
            });
            _.each(userProfile.achievements_awards, function (award, key) {
                award.order_index = key;
            });
            _.each(userProfile.linkList, function (link, key) {
                link.order_index = key;
            });
            _.each(userProfile.transcriptList, function (transcript, key) {
                transcript.order_index = key;
            });
            _.each(userProfile.referenceList, function (reference, key) {
                reference.order_index = key;
            });
            var updateUserProfile = {
                education: userProfile.educationList,
                experience: userProfile.experienceList,
                skills: userProfile.skillsList,
                achievements_awards: userProfile.achievements_awards,
                links: userProfile.linkList,
                transcripts: userProfile.transcriptList,
                references: userProfile.referenceList,
                first_name: $scope.user.first_name,
                last_name: $scope.user.last_name
            };
            var fullName = utilsService.getFullName($scope.user.first_name, $scope.user.last_name);
            if (fullName) {
                updateUserProfile.full_name = fullName;
            }

            if ($scope.summary) {
                updateUserProfile.summary = $scope.summary;
            }

            if (userProfile.address) {
                var addrIdx = 0;
                if (typeof userProfile.user.addresses !== undefined && userProfile.user.addresses.length > 0) {
                    addrIdx = userProfile.user.addresses.length - 1;
                }
                delete userProfile.address.created;
                delete userProfile.address.updated;
                updateUserProfile.addresses = [];
                updateUserProfile.addresses.push(userProfile.address);
            }

            if (userProfile.phoneNumber && userProfile.phoneNumber.number) {
                var phone = {
                    number: userProfile.phoneNumber.number.replace(constants.PHONE_CLEANUP_CHARACTERS, ''),
                    kind: userProfile.phoneNumber.kind ? userProfile.phoneNumber.kind : constants.default_phone_kind
                };
                if (userProfile.phoneNumber._id) {
                    phone._id = userProfile.phoneNumber._id;
                }
                updateUserProfile.phone_numbers = [];
                updateUserProfile.phone_numbers.push(phone);
            }

            if ($scope.user.email) {
                updateUserProfile.email_addresses = [{
                    address: $scope.user.email
                }];
                var lastEmail = getLastEmail();
                if (lastEmail !== null && typeof lastEmail.email_address_id === 'string') {
                    updateUserProfile.email_addresses[0].kind = lastEmail.kind;
                    updateUserProfile.email_addresses[0]._id = lastEmail.email_address_id;
                } else {
                    updateUserProfile.email_addresses[0].kind = constants.default_email_kind;
                    updateUserProfile.email_addresses[0]._id = undefined;
                }
            }

            // console.log('-- (Controller) $scope.updatePersonalData() - $scope.industrySelected: ', $scope.industrySelected);

            if ($scope.industrySelected) {
                updateUserProfile.industry = $scope.industrySelected;
            }

            userService.updateCurrentUser(updateUserProfile, null, firstTime).then(function (response) {
                phoneValidation(true);
                if (response.status === 400) {
                    response.data.message = response.data.message.replace(/,/g, ", ");
                    response.data.message = response.data.message.replace(/"/g, "");
                    buildToastr("There is missing required data. Please fill in all required data.<br />" + response.data.message, "Failed to Save", 2000);
                } else {
                    if (firstTime && resumeValidation.isValid(userProfile).errString != '') {
                        buildSaveToastr("There is missing required data.<br />Please fill in all required data.", "Data saved with Errors", 4000);
                    } else {
                        var sortModified = false;
                        // var experienceList = _.sortBy(response.experience, 'order_index');
                        // var educationList = _.sortBy(response.education, 'order_index');

                        var experienceList = response.experience;
                        var educationList = response.education;

                        experienceList.forEach(function (exp, idx) {
                            if (typeof exp === 'object'
                                && typeof userProfile === 'object'
                                && typeof userProfile.experienceList[idx] === 'object'
                                && exp._id !== userProfile.experienceList[idx]._id) {
                                sortModified = true;
                            }
                        });
                        educationList.forEach(function (edu, idx) {
                            if (typeof edu === 'object'
                                && typeof userProfile === 'object'
                                && typeof userProfile.educationList[idx] === 'object'
                                && edu._id !== userProfile.educationList[idx]._id) {
                                sortModified = true;
                            }
                        });
                        var successString = 'Profile data saved successfully';
                        if (fixServiceFinalMsg.length > 0) successString = fixServiceFinalMsg;
                        if (sortModified) {
                            successString += '<br/><br/>Your experience or education records sorting changed using the dates';
                        }
                        if (userProfile.wizard && userProfile.wizard.isWizard && firstTime) {
                            userProfile.resumeUploadingStatus = 'success';
                            userProfile.isFirstTimeResumeUploading = true;
                        } else {
                            if (!silent) buildSaveToastr(successString, 'Success', 2000);
                        }
                    }

                    $rootScope.$broadcast('currentUser-updated');

                    // userProfile.experienceList = _.sortBy(response.experience, 'order_index');
                    // userProfile.educationList = _.sortBy(response.education, 'order_index');

                    userProfile.experienceList = response.experience;
                    userProfile.educationList = response.education;
                    refillDropdown();
                    userProfile.skillsList = _.sortBy(response.skills, 'order_index');
                    updateSkillsRatings();

                    userProfile.achievements_awards = _.sortBy(response.achievements_awards, 'order_index');

                    _.each(userProfile.achievements_awards, function (element, i) {
                        refillDropdownCb(element);
                    });

                    userProfile.linkList = _.sortBy(response.links, 'order_index');

                    user.summary = response.summary;

                    var tmp = userProfile.transcriptList.filter(function (i) {
                        return i.deleted == false;
                    });
                    userProfile.transcriptListTemp = deepCopy(tmp);
                    userProfile.transcriptList = _.sortBy(response.transcripts, 'order_index');

                    userProfile.referenceList = _.sortBy(response.references, 'order_index');
                    userProfile.allowResume = true;

                    userProfile.phoneNumber = getPhoneNumber(response.phone_numbers);
                    userProfile.address = getAddress(response.addresses);

                    userProfile.user.first_name = response.first_name;
                    userProfile.user.last_name = response.last_name;

                    if (typeof response.email_addresses !== 'undefined') {
                        userProfile.user.email_addresses = response.email_addresses;
                        if (response.email_addresses !== null) {
                            getEmailAddressForProfile(response.email_addresses);
                        }
                    }

                    user.industry = response.industry;

                    checkUnsavedDataUpdate();
                }

                // $timeout(function () {
                //     $scope.isDisable = false;
                // }, 500);

                uploadTranscripFiles();

                window.scrollTo(0, 0);
            });
        };

        // getEmail address of user.
        function getEmailAddressForProfile(emails) {
            var lastEmail = getLastEmail(emails);
            if (lastEmail !== null && typeof lastEmail === 'object') {
                $scope.user.email = lastEmail.email;
                $scope.user.email_type = lastEmail.kind;
                $scope.user.email_used_status = lastEmail.used_status;
                $scope.user.email_id = lastEmail.email_address_id;
                $scope.showEmailConfirmationMessage = !lastEmail.confirmed && lastEmail.email;
                $scope.exisitingEmail = lastEmail.email;
                unsaveService.updateData('personal_data', angular.copy(getPersonalData()));
            } else {
                $scope.showEmailConfirmationMessage = false;
            }
        }
        // Assessments confirm modal
        userProfile.confirmationModal = function () {
            var dialog = {
                templateUrl: 'app/assessments/template/assessmentConfirmation.html',
                scope: $scope,
                showClose: false,
                width: '762px',
                height: '455px'
            };
            ngDialog.openConfirm(dialog);
        };
        // Begin assessments on click of confirm and goto assessments page.
        $scope.beginAssessment = function (assessmentIds) {
            $state.go('assessments', {
                startAssessment: true
            });
        };

        // Profile image selector
        $scope.selectProfileImage = function (files) {
            $scope.profileImgModalDelete = false;
            var reader = new FileReader();

            reader.onload = function (e) {
                // bind new Image to Component
                $scope.$apply(function () {
                    $scope.cropped.source = e.target.result;
                });
            };
            reader.readAsDataURL(files[0]);
            $scope.profileImgModal = true;
            // There used to be a lot of shitty code here that did what the oneline reader does now...
        };
        $scope.openProfileImageSelector = function () {
            $('#file').trigger('click');
        };

        // Action perform on load sort education, experience and skills.
        userProfile.fixServiceInit = function () {
            fixService.setEmptyFieldMsg($translate.instant('FIX_SERVICE_EMPTY_FIELD_MSG'));
            fixService.setSuccessMsg('Profile data saved successfully');
        };

        function onLoad() {
            userProfile.educationList = _.sortBy(userProfile.educationList, 'order_index');
            userProfile.experienceList = _.sortBy(userProfile.experienceList, 'order_index');
            userProfile.skillsList = _.sortBy(userProfile.skillsList, 'order_index');
            userProfile.achievements_awards = _.sortBy(userProfile.achievements_awards, 'order_index');
            userProfile.linkList = _.sortBy(userProfile.linkList, 'order_index');
            userProfile.transcriptList = _.sortBy(userProfile.transcriptList, 'order_index');
            userProfile.referenceList = _.sortBy(userProfile.referenceList, 'order_index');
            getEmailAddressForProfile();
            populatePersonalData();
            userProfile.allowResume = true;
            userProfile.fixServiceInit();
            checkUnsavedDataInit();
        }
        onLoad();

        // Added resume import funcation. This is parse resume data.
        $scope.parseResumeData = function (file) {
            parsingResume = true;
            $scope.showUploadResume = false;
            userProfile.resumeUploadingStatus = '';

            if (file && file.length > 0) {
                var allowedFiles = ["doc", "docx", "pdf", "txt"];
                var allowedFilesRegex = new RegExp("^.*\.+(" + allowedFiles.join('|') + ")$");

                if (!allowedFilesRegex.test(file[0].name.toLowerCase())) {
                    buildToastr($translate.instant('RESUME_UPLOAD_ALLOWED_EXTENSION', {
                        allowed_files: allowedFiles.join(', ')
                    }), "Valid File Types", 4000);
                    return;
                }
                // userProfile.resumeUploadError = "";

                userService.isResumeImportAllowed().then(function (response) {
                    if (response) {
                        userProfile.allowResume = true;
                        userProfile.showModalWarning = false;
                        if (!$scope.loader)
                            $scope.loader = ngDialog.open({
                                template: 'app/user-profile/template/user-profile-resume-upload-dialog-pro-user.html',
                                showClose: false,
                                scope: $scope,
                                closeByDocument: false,
                                closeByEscape: false,
                                className: 'ngdialog-error-default ngdialog-theme-default'
                            });

                        var reader = new FileReader();
                        $('.resume-loading-status').html($translate.instant('ONBOARDING_READING_RESUME_STATUS'));
                        setTimeout(function () {
                            $('.resume-loading-status').html($translate.instant('ONBOARDING_READING_RESUME_CONVERT'));
                        }, 10);

                        reader.onload = function (event) {
                            var base64Text = utilsService.arrayBufferToBase64(event.target.result);
                            if (base64Text) {
                                resumeService.parseResumeData(base64Text).then(function (response) {
                                    userProfile.skillValue = '';
                                    deleteExistingDataBeforeImport();
                                    $scope.dataImport = true;
                                    var parsedResume = response.data;

                                    if ((Array.isArray(parsedResume.experienceList) && parsedResume.experienceList.length > 0)
                                        || (Array.isArray(parsedResume.educationList) && parsedResume.educationList.length > 0)
                                        || (Array.isArray(parsedResume.skills) && parsedResume.skills.length > 0)
                                        || (Array.isArray(parsedResume.achievements_awards) && parsedResume.achievements_awards.length > 0)
                                        || (Array.isArray(parsedResume.linkList) && parsedResume.linkList.length > 0)
                                        || (Array.isArray(parsedResume.transcriptList) && parsedResume.transcriptList.length > 0)
                                        || (Array.isArray(parsedResume.referenceList) && parsedResume.referenceList.length > 0)) {
                                        // BEGIN Check first name, last name and email.

                                        if (typeof parsedResume.user === 'undefined' || parsedResume.user === null)
                                            parsedResume.user = {};
                                        if (typeof parsedResume.user.first_name !== 'string' || parsedResume.user.first_name.length == 0)
                                            parsedResume.user.first_name = $scope.user.first_name;
                                        if (typeof parsedResume.user.last_name !== 'string' || parsedResume.user.last_name.length == 0)
                                            parsedResume.user.last_name = $scope.user.last_name;
                                        parsedResume.user.full_name = utilsService.getFullName(parsedResume.user.first_name, parsedResume.user.last_name);

                                        if (typeof parsedResume.user.email !== 'string' || parsedResume.user.email.length == 0) {
                                            if (typeof $scope.user.email === 'undefined' || $scope.user.email === null || $scope.user.email.length == 0) {
                                                var lastEmail = getLastEmail();
                                                parsedResume.user.email = (lastEmail || {}).email;
                                            } else {
                                                parsedResume.user.email = $scope.user.email;
                                            }
                                        }

                                        $scope.user = parsedResume.user;
                                        parsedResume.email = $scope.user.email;
                                        parsedResume.email_type = (typeof $scope.user.email_type === 'string' && $scope.user.email_type.length > 0) ? $scope.user.email_type : 'Personal';
                                        // END Check first name, last name and email.

                                        // Jennifer wants the phone from the resume if the phone does not exist in account profile
                                        var profilePhone = (userProfile.phoneNumber || {}).number;
                                        if (typeof parsedResume.user.phone !== 'string' || parsedResume.user.phone.length == 0) {
                                            if (profilePhone) {
                                                parsedResume.user.phone = profilePhone;
                                                parsedResume.user.phone_type = 'Home';
                                                parsedResume.user.phones = [{ phone_number: profilePhone, phone_type: 'Home' }];
                                            }
                                        } 
                                        if (!profilePhone && parsedResume.user.phone) {
                                            if (!userProfile.phoneNumber) {
                                                userProfile.phoneNumber = {};
                                            }
                                            userProfile.phoneNumber.number = parsedResume.user.phone;
                                            userProfile.phoneNumber.kind = 'Home';
                                            // >>> KSH do we really care about id, generate one if so (uuid? dbid?)
                                        }

                                        var profileAddress = userProfile.address;
                                        var resumeAddress = parsedResume.user.address;
                                        if (!profileAddress) {
                                            profileAddress = userProfile.address = {};
                                        }
                                        if (!resumeAddress) {
                                            resumeAddress = parsedResume.user.address = {};
                                        }
                                        if ((typeof resumeAddress.city !== 'string' || resumeAddress.city.length === 0) && profileAddress.city) {
                                            parsedResume.user.address.city = profileAddress.city;
                                        }
                                        if ((typeof resumeAddress.state !== 'string' || resumeAddress.state.length === 0) && profileAddress.state) {
                                            parsedResume.user.address.state = profileAddress.state;
                                        }
                                        if (!profileAddress.city && resumeAddress.city) {
                                            userProfile.address.city = resumeAddress.city;
                                        }
                                        if (!profileAddress.state && resumeAddress.state) {
                                            userProfile.address.state = resumeAddress.state;
                                        }

                                        $scope.summary = parsedResume.summary;

                                        _.each(parsedResume.experienceList, function (element) {
                                            refillDropdownCb(element);
                                            userProfile.experienceList.push(element);
                                        });
                                        _.each(parsedResume.educationList, function (element) {
                                            refillDropdownCb(element);
                                            userProfile.educationList.push(element);
                                        });
                                        _.each(parsedResume.skills, function (skill) {
                                            userProfile.skillsList.push(skill);
                                        });
                                        _.each(parsedResume.achievements_awards, function (award) {
                                            userProfile.achievements_awards.push(award);
                                        });
                                        _.each(parsedResume.linkList, function (link) {
                                            userProfile.linkList.push(link);
                                        });
                                        _.each(parsedResume.transcriptList, function (transcript) {
                                            userProfile.transcriptList.push(transcript);
                                        });
                                        _.each(parsedResume.referenceList, function (reference) {
                                            userProfile.referenceList.push(reference);
                                        });
                                        userProfile.dataImportLoader = false;

                                        phoneValidation(false);
                                        // $scope.updatePersonalData(true);
                                        $scope.validatePersonalData(false, true);
                                        $scope.loader.close();
                                        $scope.loader = undefined;
                                        ngDialog.close(); // This is the directive.
                                        // userProfile.allowResume = false;
                                    } else {
                                        var needOCR = new RegExp("^.+OCR is required.+$", "i");
                                        parsingResume = false;
                                        if (needOCR.test(response.data.message || '')) {
                                            buildToastr("This resume does not contain text (for example, a scanned or faxed resume). Please use an original file or OCR this file.",
                                                        "Error Parsing Resume:",
                                                        6000);
                                        }
                                        else {
                                            buildToastr("We were unable to parse your resume.<br/>Please check that your resume is properly formatted.", "Error Parsing Resume:", 4000);
                                        }
                                        $scope.loader.close();
                                        $scope.loader = undefined;
                                        ngDialog.close();
                                    }
                                }, function (error) {
                                    parsingResume = false;
                                    buildToastr("We were unable to parse your resume.<br/>Please check that your resume is properly formatted.", "Error Parsing Resume:", 4000);
                                });
                            }
                        };
                        reader.readAsArrayBuffer(file[0]);
                        // });
                    } else {


                        $timeout(function () {
                            userProfile.showErrorMsg = "Resume import max limit exceed";
                            $timeout(function () {
                                userProfile.showErrorMsg = '';
                            }, 5000);
                        }, 100);
                    }
                });
            }
        };

        $scope.validateDate = function (v, listType, index, dateType, id) {
            var isDateValid;
            if (dateType == 'endDateObj' && !v)
                isDateValid = true;
            else
                isDateValid = utilsService.validateDate(v, id, true);
            if (!isDateValid) {
                if (!userProfile[listType])
                    userProfile[listType] = [];
                var obj = {};
                obj[dateType] = true;
                userProfile[listType][index] = obj;
                $scope.editDatesValid = false;
                userProfile.invalidDateMsg = 'Date: ' + v + ' is not valid.\r\n Format: MMM YYYY \r\n Ex: Jan 1999';
                userProfile.showErrorMsg = userProfile.invalidDateMsg;
                $timeout(function () {
                    userProfile.showErrorMsg = '';
                }, 5000);
            } else {
                $scope.editDatesValid = true;
                if (userProfile[listType] && userProfile[listType][index] && userProfile[listType][index][dateType])
                    userProfile[listType][index] = false;
            }
        };
        $scope.closeLoaderModal = function () {
            $scope.showModalError = false;
            $scope.loader.close();
            $scope.loader = undefined;
        };
        $scope.scrollToError = function (inputId) {
            document.getElementById(inputId).scrollIntoView();
        };

        $scope.uploadResume = function () {
            userProfile.openFileSelector();
        };
        $scope.uploadError = function (error) { };
        $scope.uploadSuccess = function () {
            $scope.showUploadResume = false;
        };

        userProfile.openWarning = function () {
            $scope.showUploadResume = true;
        };

        userProfile.getUploadButtonClasses = function () {
            return this.wizard && this.wizard.isWizard ? this.isFirstTimeResumeUploading ? 'btn btn-green-link upload-resume-link' : 'btn btn-green upload-resume-btn' : 'rbtn';
        };

        userProfile.openFileSelector = function () {
            $('#upload_resume').trigger('click');
        };
        // Delete existing data before import.
        function deleteExistingDataBeforeImport() {
            if (userProfile.educationList.length) {
                _.each(userProfile.educationList, function (education, key) {
                    education.deleted = true;
                });
            }
            if (userProfile.skillsList.length) {
                _.each(userProfile.skillsList, function (skill, key) {
                    skill.deleted = true;
                });
            }
            if (userProfile.achievements_awards.length) {
                _.each(userProfile.achievements_awards, function (award, key) {
                    award.deleted = true;
                });
            }
            if (userProfile.linkList.length) {
                _.each(userProfile.linkList, function (link, key) {
                    link.deleted = true;
                });
            }
            if (userProfile.transcriptList.length) {
                _.each(userProfile.transcriptList, function (transcript, key) {
                    transcript.deleted = true;
                });
            }
            if (userProfile.referenceList.length) {
                _.each(userProfile.referenceList, function (reference, key) {
                    reference.deleted = true;
                });
            }
            if (userProfile.experienceList.length) {
                _.each(userProfile.experienceList, function (experience, key) {
                    experience.deleted = true;
                });
            }
        }
        userProfile.gotoAssessment = function () {
            $state.go('assessments');
        };

        $scope.addCkEditor = function (t) {
            try {
                $scope.removeCkEditor();
            } catch (e) {
                console.error('-- userProfile.$scope.userProfile() - Exception: ', e);
            }

            if (!CKEDITOR.instances[t]) {
                var edt = CKEDITOR.replace(t, {
                    stylesSet: []
                });

                $(document).on('click', '#cke_' + t, function (evt) {
                    if (evt.target.className === "cke_top cke_reset_all")
                        isToolbox = true;
                });

                edt.on('instanceReady', function (evt) {
                    var editor = CKEDITOR.instances[evt.sender.name];
                    editor.focus();
                    var range = editor.createRange();
                    range.moveToElementEditEnd(range.root);
                    editor.getSelection().selectRanges([range]);
                });

                edt.on('blur', function (evt) {
                    if (!isToolbox)
                        $scope.removeCkEditor();
                    else
                        isToolbox = false;
                });

                // The next two force ckeditor to preserve <br> tags
                // https://stackoverflow.com/questions/44501658/how-to-force-ckeditor-to-preserve-br-tags
                edt.on('pluginsLoaded', function (evt) {
                    evt.editor.dataProcessor.dataFilter.addRules({
                        elements: {
                            br: function (element) {
                                // if next element is BR or <!--cke_br_comment-->, ignore it.
                                if (element && element.next && (element.next.name == 'br' || element.next.value == 'cke_br_comment')) {
                                    return;
                                } else {
                                    var comment = new CKEDITOR.htmlParser.comment('cke_br_comment');
                                    comment.insertAfter(element);
                                }
                            }
                        }
                    });

                    evt.editor.dataProcessor.htmlFilter.addRules({
                        comment: function (value, node) {
                            if (value.indexOf('cke_br_comment') >= 0) {
                                return false;
                            }
                            return undefined;
                        }
                    });
                });
            }
        };

        $scope.removeCkEditor = function () {
            for (var idx in CKEDITOR.instances) {
                if (typeof CKEDITOR.instances[idx] === 'object' && typeof CKEDITOR.instances[idx].name === 'string' && CKEDITOR.instances[idx].name.length > 0) {
                    var name = CKEDITOR.instances[idx].name;
                    if (!$scope.isCancelEdit) {
                        var nameSelector = $('#' + name);
                        nameSelector.html(CKEDITOR.instances[name].getData());
                        var md = nameSelector.attr('ng-model');
                        var x = $parse(md);

                        if (x)
                            x.assign($scope, CKEDITOR.instances[name].getData());

                        var split = name.split('_');
                        switch (split[0]) {
                        case 'education':
                            userProfile.educationList[parseInt(split[1])].notes = CKEDITOR.instances[name].getData();
                            break;
                        case 'experience':
                            userProfile.experienceList[parseInt(split[1])].summary = CKEDITOR.instances[name].getData();
                            userProfile.experienceList[parseInt(split[1])].description = CKEDITOR.instances[name].getData();
                            break;
                        }
                    } else
                        $scope.isCancelEdit = false;

                    CKEDITOR.instances[name].destroy(true);
                }
            }
        };

        $scope.isEditable = function (t) {
            if (userProfile.isEditable)
                return $scope.addCkEditor(t);
            else
                return null;
        };

        function buildToastr(content, title, timeout) {
            var t = toastr.info(content, title, {
                progressBar: true,
                timeOut: timeout,
                toastClass: 'toast',
                preventDuplicates: true,
                allowHtml: true,
                positionClass: 'toast-top-full-width',
                hideDuration: timeout,
                closeButton: true,
                showDuration: timeout,
                extendedTimeOut: timeout,
                hideMethod: 'noop'
            });
            $rootScope.toast = t;
        }

        function buildSaveToastr(content, title, timeout) {
            var t = toastr.info(content, title, {
                progressBar: true,
                timeOut: timeout,
                toastClass: 'toast',
                preventDuplicates: true,
                allowHtml: true,
                positionClass: 'toast-top-full-width',
                hideDuration: timeout,
                closeButton: true,
                showDuration: timeout,
                extendedTimeOut: timeout,
                hideMethod: 'noop'
            });
            t.scope.options.onHidden = function () {
                if (resumeValidation.isValid(userProfile).errString == '' && parsingResume == false && !messageNotShown) {
                    if (!userProfile.wizard) {
                        $scope.completedModal();
                        messageNotShown = true;
                    }
                } else if (parsingResume == true && resumeValidation.isValid(userProfile).errString != '') {
                    $('#submit_validation')[0].click();
                }
                parsingResume = false;

                setTimeout(function () {
                    $scope.$emit('successUpdateUser');
                }, 1000);
            };
            $rootScope.toast = t;
        }

        function buildToastrCenter(content, title, timeout) {
            var t = toastr.info(content, title, {
                progressBar: true,
                timeOut: timeout,
                toastClass: 'toast-class-center',
                preventDuplicates: true,
                allowHtml: true,
                positionClass: 'toast-top-full-width',
                hideDuration: timeout,
                closeButton: true,
                showDuration: timeout,
                extendedTimeOut: timeout,
                hideMethod: 'noop',

            });

            $rootScope.toast = t;
        }
        resumeService.getResumes(user.userID).then(function (resumes) {
            // if(userProfile.educationList.length == 0 && userProfile.experienceList.length == 0){
            //     userProfile.isEditable = true;
            //     // don't get initilialize experienceList
            //     // userProfile.addNewExperience(0, true);
            //     buildToastrCenter($translate.instant('USER_PROFILE_NO_DATA') + '<br />' + $translate.instant('ASSESSMENT_TAKE_TEST_NOTIFICATION'), $translate.instant('USER_PROFILE_INFORMATION_TIP'), 20000);
            // }
            // else 
            if ((userProfile.educationList.length > 0 || userProfile.experienceList.length > 0) && $scope.assessmentData != undefined && resumes.length == 0) {
                buildToastrCenter($translate.instant('USER_PROFILE_NO_RESUMES'), $translate.instant('USER_PROFILE_INFORMATION_TIP'), 20000);
            }
            // else if((userProfile.educationList.length > 0 || userProfile.experienceList.length > 0) && $scope.assessmentData == undefined && resumes.length == 0 ){
            //     buildToastrCenter($translate.instant('USER_PROFILE_NO_ASSESSMENT'), $translate.instant('USER_PROFILE_PRO_TIP'), 20000);
            // }
        });
        $scope.test = function () {
            ngDialog.open({
                showClose: false,
                template: 'app/user-profile/template/modal.html',
                controller: ['$scope', function ($scope) {
                    // controller logic
                    $scope.closeModal = function () {
                        ngDialog.closeAll();
                    };
                    $scope.gotoAssesment = function () {
                        ngDialog.closeAll();
                        $state.go('assessments');
                    };
                }]
            });
        };
        $scope.completedModal = function () {
            ngDialog.open({
                showClose: false,
                template: 'app/user-profile/template/assessment-next-step.html',
                scope:$scope,
                controller: ['$scope', function ($scope) {
                    // controller logic
                    $scope.closeModal = function () {
                        ngDialog.closeAll();
                    };
                    $scope.gotoAssesment = function () {
                        ngDialog.closeAll();
                        $state.go('assessments');
                    };
                    $scope.assessments = userProfile.assessments;
                }]
            });
        };

        function uploadTranscripFiles() {
            _.each(userProfile.transcriptListTemp, function (transcript, ndx) {

                if (transcript.file != undefined) {
                    var fileReader = new FileReader();
                    fileReader.onerror = function (e) {
                        alert(e.message);
                    };
                    var attachment = {};
                    attachment.file = transcript.file;
                    attachment.type = 'Transcript';
                    userService.uploadCurrentUserAttachments(attachment).then(function (response) {
                        userProfile.transcriptList[this.idx].url = response.data.url;
                        userService.updateCurrentUser({
                            transcripts: userProfile.transcriptList
                        }).then(function (response) {
                            var i = response;
                            checkUnsavedDataUpdate();
                        });
                    }.bind({
                        idx: ndx
                    })).catch(function (error) {
                        console.error(error);
                    });
                }
            });
        }

        // #region Fix Service Code.
        var fixServiceFinalMsg = '';
        $scope.forms = {};

        $scope.validatePersonalData = function (silent, firstTime) {
            if (typeof silent === 'undefined') silent = false;
            userProfile.silent = silent;
            if (typeof firstTime === 'undefined') firstTime = false;

            $scope.firstTime = firstTime;
            $scope.removeCkEditor(); // Very very very important!!! Run this before try to fix the profile.

            // To enable the debug mode of the fixSevice open the browser console and put the following and press [Enter]:
            // var __FIX_SERVICE__ = '';
            // Then when you click on the save button you should be the log trace in the console.
            try {
                if (typeof __FIX_SERVICE__ === 'string' && __FIX_SERVICE__.length == 0) {
                    __FIX_SERVICE__ = fixService;
                    fixService.debugOn();
                }
            } catch (e) {
                // Do nothing...
            }


            fixServiceFinalMsg = '';
            var fixResult = fixService.fixProfile(userProfile);

            // Check profile data after calling fixProfile
            unsaveService.updateData('educationList', angular.copy(userProfile.educationList));
            unsaveService.updateData('experienceList', angular.copy(userProfile.experienceList));

            if (typeof fixResult !== 'undefined' && typeof fixResult.finalMessage !== 'undefined' && fixResult.finalMessage.length > 0) fixServiceFinalMsg = fixResult.finalMessage;
            setTimeout(function () {
                $validation.validate($scope.forms.userForm).then(function (msg) {
                    // console.log('-- (Controller) userProfile - The form pass the validation!');
                    if (!silent) buildSaveToastr($translate.instant('BEFORE_SAVE_MSG'), '', 2000);
                    $scope.updatePersonalData(firstTime);
                }).catch(function (msg) {
                    // console.log('-- (Controller) userProfile - The form did not pass the validation!');
                    var error = $translate.instant('USER_PROFILE_SAVE_WARNING');
                    buildToastr(error, "Warning:", 10000);
                });
            }, 1000);
        };

        $scope.checkMissingText = function (name, type) {
            return fixService.checkMissingText(name, type);
        };

        $scope.focusBlurMissingText = function (name, focus) {
            return fixService.focusBlurMissingText(name, focus);
        };
        // #endregion Fix Service Code.

        // #region Check Unsave Data.
        function checkUnsavedDataInit() {
            unsaveService.init(checkUnsavedData);
            checkUnsavedDataUpdate();

            $scope.$watch(unsaveService.checkUnsavedData, function (isUnsavedData, isUnsavedDataOld) {
                if (isUnsavedData) {
                    unsaveService.addUnloadEvent();
                } else {
                    unsaveService.removeUnloadEvent();
                }
            });
        }

        function getPersonalData() {
            var phoneNumber = angular.copy(userProfile.phoneNumber);
            if (phoneNumber.number) {
                phoneNumber.number = phoneFormatter.flatten(phoneNumber.number);
            } else if ($scope.forms && $scope.forms.userForm && $scope.forms.userForm.phonenumber) {
                phoneNumber.number = phoneFormatter.flatten($scope.forms.userForm.phonenumber.$viewValue);
            }

            return {
                first_name: userProfile.user.first_name,
                last_name: userProfile.user.last_name,
                email_address: userProfile.user.email ? userProfile.user.email : '',
                phoneNumber: phoneNumber,
                address: angular.copy(userProfile.address)
            };
        }

        function checkUnsavedDataUpdate() {
            unsaveService.updateData('personal_data', angular.copy(getPersonalData()));
            unsaveService.updateData('educationList', angular.copy(userProfile.educationList));
            unsaveService.updateData('experienceList', angular.copy(userProfile.experienceList));
            unsaveService.updateData('skillsList', angular.copy(userProfile.skillsList));
            unsaveService.updateData('achievements_awards', angular.copy(userProfile.achievements_awards));
            unsaveService.updateData('linkList', angular.copy(userProfile.linkList));
            unsaveService.updateData('transcriptList', angular.copy(userProfile.transcriptList));
            unsaveService.updateData('referenceList', angular.copy(userProfile.referenceList));
            unsaveService.updateData('summary', angular.copy(user.summary));
            unsaveService.updateData('industry', angular.copy(user.industry));
        }

        function checkTranscriptList() {
            var isEqual = true;
            _.each(userProfile.transcriptList, function (transcript, key) {
                if (transcript.file && transcript.file instanceof File) {
                    isEqual = false;
                }
            });
            if (isEqual) {
                isEqual = unsaveService.isEqual('transcriptList', userProfile.transcriptList);
            }
            return isEqual;
        }

        function checkUnsavedData() {
            var pdEqual = unsaveService.isEqual('personal_data', getPersonalData());
            var eduEqual = unsaveService.isEqual('educationList', userProfile.educationList);
            var expEqual = unsaveService.isEqual('experienceList', userProfile.experienceList);
            var skiEqual = unsaveService.isEqual('skillsList', userProfile.skillsList);

            var achEqual = unsaveService.isEqual('achievements_awards', userProfile.achievements_awards);
            var linEqual = unsaveService.isEqual('linkList', userProfile.linkList);
            var refEqual = unsaveService.isEqual('referenceList', userProfile.referenceList);

            var summaryEqual = unsaveService.isEqual('summary', $scope.summary) || (!user.summary && !$scope.summary);
            var traEqual = checkTranscriptList();

            var industryEqual = unsaveService.isEqual('industry', $scope.industrySelected) || (!user.industry && !$scope.industrySelected);

            var isCkeditorDirty = unsaveService.isEditorDirty(CKEDITOR);

            return !(eduEqual && expEqual && skiEqual && achEqual && linEqual && traEqual && refEqual && summaryEqual && pdEqual && !isCkeditorDirty && industryEqual);
        }

        $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
            if (unsaveService.checkUnsavedData() && !unsaveService.isAllowedLeaving) {
                event.preventDefault();
                unsaveService.openConfirmModal().then(function () {
                    unsaveService.isAllowedLeaving = true;
                    unsaveService.removeUnloadEvent();
                    $state.go(toState.name, toParams, options);
                    ngDialog.close();
                });
            }
        });
        // #endregion Check Unsave Data.

        // #region Delete Profile Picture.
        $scope.profileImgModalDelete = false;

        $scope.showImageLoaderForDelete = function () {
            $scope.profileImgModal = true;
            $scope.profileImgModalDelete = true;
        };

        $scope.deleteResumePicture = function () {
            var url = '';
            $scope.profilePictureURL = url;
            $scope.cropped.source = url;

            userService.updateCurrentUser({
                profile_picture_url: url
            }).then(function (response) {
                $scope.defaultImage = true;
                $scope.profilePictureURL = response.profile_picture_url;
                $scope.user.profile_picture_url = $scope.profilePictureURL;
                $scope.cropped.source = $scope.profilePictureURL;
                $scope.user.profile_picture_url = $scope.cropped.source;

                $scope.showImageLoader = false;
                $scope.profileImgModal = false;
                $rootScope.loadingInProcess = false;
            }, function () {
                $scope.showImageLoader = false;
                $rootScope.loadingInProcess = false;
            });
        };
        // #endregion Delete Profile Picture.

        function getLastEmail(emails) {
            if (!Array.isArray(emails)) {
                emails = userProfile.user.email_addresses || [];
            }
            var pos = -1;
            for (var i = 0; i < emails.length; i++) {
                if (!emails[i].deleted) {
                    pos = i;
                }
            }
            if (pos > 0) {
                var lastEmail = {
                    email: emails[pos].address,
                    kind: emails[pos].kind,
                    used_status: true
                };
                if (emails.length > 1) lastEmail.email_address_id = emails[pos]._id;
                return lastEmail;
            }
            return null;
        }

        function getFirstEmail(emails) {
            if (!Array.isArray(emails)) {
                emails = userProfile.user.email_addresses || [];
            }
            for (var i = 0; i < emails.length; i++) {
                if (!emails[i].deleted) {
                    var firstEmail = {
                        email: emails[i].address,
                        kind: emails[i].kind,
                        used_status: true
                    };
                    if (emails.length > 1) firstEmail.email_address_id = emails[i]._id;
                    return firstEmail;
                }
            }
            return null;
        }

        $scope.validatePhone = true;
        $scope.phonePattern = constants.USA_PHONE_PATTERN_2;
        $scope.summaryPattern = new RegExp("^(.|[\n\r\t]){0," + constants.MAX_SUMMARY_LENGTH + "}$");
        $scope.summaryMaxLength = constants.MAX_SUMMARY_LENGTH;

        var phoneValidation = function (validate) {
            if (validate) {
                $scope.validatePhone = true;
                $scope.phonePattern = constants.USA_PHONE_PATTERN_2;
            } else {
                $scope.validatePhone = false;
                $scope.phonePattern = '';
            }
        };

        $scope.checkSummary = function () {
            var aux = document.getElementById('short-desc').value.length;
            return aux > constants.MAX_SUMMARY_LENGTH;
        };
        phoneValidation(true);

        // #region White Label Code.
        $scope.hasOrganization = function() {
            return organizationService.hasOrganization();
        };

        $scope.getOrganizationCss = function(css, returnEmpty) {
            return organizationService.getOrganizationCss(css, returnEmpty);
        };

        $scope.getOrganizationKey = function() {
            return organizationService.getOrganizationKey();
        };

        $scope.getOrganizationName = function() {
            return organizationService.getOrganizationName();
        };

        $scope.goToHome = function () {
            $state.go('dashboard');
        };
        // #endregion White Label Code.

        $scope.enableSkillLevel = function (skill) {
            // console.log('-- (Controller) userProfile.$scope.enableSkillLevel() - skill: ', skill);

            if (skill.proficiency > 0) {
                skill.proficiency = 0;
            } else {
                skill.proficiency = 3;
                updateSkillsRatings(true);
            }
        };

        // >>> KSH this should be in a collection and internationalized you idiot
        // #region Industries.
        $scope.industries = [{
            'title': 'Accounting',
            'value': 'Accounting'
        }, {
            'title': 'Airlines/Aviation',
            'value': 'Airlines/Aviation'
        }, {
            'title': 'Alternative Dispute Resolution',
            'value': 'Alternative Dispute Resolution'
        }, {
            'title': 'Alternative Medicine',
            'value': 'Alternative Medicine'
        }, {
            'title': 'Animation',
            'value': 'Animation'
        }, {
            'title': 'Apparel & Fashion',
            'value': 'Apparel & Fashion'
        }, {
            'title': 'Architecture & Planning',
            'value': 'Architecture & Planning'
        }, {
            'title': 'Arts and Crafts',
            'value': 'Arts and Crafts'
        }, {
            'title': 'Automotive',
            'value': 'Automotive'
        }, {
            'title': 'Aviation & Aerospace',
            'value': 'Aviation & Aerospace'
        }, {
            'title': 'Banking',
            'value': 'Banking'
        }, {
            'title': 'Biotechnology',
            'value': 'Biotechnology'
        }, {
            'title': 'Broadcast Media',
            'value': 'Broadcast Media'
        }, {
            'title': 'Building Materials',
            'value': 'Building Materials'
        }, {
            'title': 'Business Supplies and Equipment',
            'value': 'Business Supplies and Equipment'
        }, {
            'title': 'Capital Markets',
            'value': 'Capital Markets'
        }, {
            'title': 'Chemicals',
            'value': 'Chemicals'
        }, {
            'title': 'Civic & Social Organization',
            'value': 'Civic & Social Organization'
        }, {
            'title': 'Civil Engineering',
            'value': 'Civil Engineering'
        }, {
            'title': 'Commercial Real Estate',
            'value': 'Commercial Real Estate'
        }, {
            'title': 'Computer & Network Security',
            'value': 'Computer & Network Security'
        }, {
            'title': 'Computer Games',
            'value': 'Computer Games'
        }, {
            'title': 'Computer Hardware',
            'value': 'Computer Hardware'
        }, {
            'title': 'Computer Networking',
            'value': 'Computer Networking'
        }, {
            'title': 'Computer Software',
            'value': 'Computer Software'
        }, {
            'title': 'Construction',
            'value': 'Construction'
        }, {
            'title': 'Consumer Electronics',
            'value': 'Consumer Electronics'
        }, {
            'title': 'Consumer Goods',
            'value': 'Consumer Goods'
        }, {
            'title': 'Consumer Services',
            'value': 'Consumer Services'
        }, {
            'title': 'Cosmetics',
            'value': 'Cosmetics'
        }, {
            'title': 'Dairy',
            'value': 'Dairy'
        }, {
            'title': 'Defense & Space',
            'value': 'Defense & Space'
        }, {
            'title': 'Design',
            'value': 'Design'
        }, {
            'title': 'Education Management',
            'value': 'Education Management'
        }, {
            'title': 'E-Learning',
            'value': 'E-Learning'
        }, {
            'title': 'Electrical/Electronic Manufacturing',
            'value': 'Electrical/Electronic Manufacturing'
        }, {
            'title': 'Entertainment',
            'value': 'Entertainment'
        }, {
            'title': 'Environmental Services',
            'value': 'Environmental Services'
        }, {
            'title': 'Events Services',
            'value': 'Events Services'
        }, {
            'title': 'Executive Office',
            'value': 'Executive Office'
        }, {
            'title': 'Facilities Services',
            'value': 'Facilities Services'
        }, {
            'title': 'Farming',
            'value': 'Farming'
        }, {
            'title': 'Financial Services',
            'value': 'Financial Services'
        }, {
            'title': 'Fine Art',
            'value': 'Fine Art'
        }, {
            'title': 'Fishery',
            'value': 'Fishery'
        }, {
            'title': 'Food & Beverages',
            'value': 'Food & Beverages'
        }, {
            'title': 'Food Production',
            'value': 'Food Production'
        }, {
            'title': 'Fund-Raising',
            'value': 'Fund-Raising'
        }, {
            'title': 'Furniture',
            'value': 'Furniture'
        }, {
            'title': 'Gambling & Casinos',
            'value': 'Gambling & Casinos'
        }, {
            'title': 'Glass, Ceramics & Concrete',
            'value': 'Glass, Ceramics & Concrete'
        }, {
            'title': 'Government Administration',
            'value': 'Government Administration'
        }, {
            'title': 'Government Relations',
            'value': 'Government Relations'
        }, {
            'title': 'Graphic Design',
            'value': 'Graphic Design'
        }, {
            'title': 'Health, Wellness and Fitness',
            'value': 'Health, Wellness and Fitness'
        }, {
            'title': 'Higher Education',
            'value': 'Higher Education'
        }, {
            'title': 'Hospital & Health Care',
            'value': 'Hospital & Health Care'
        }, {
            'title': 'Hospitality',
            'value': 'Hospitality'
        }, {
            'title': 'Human Resources',
            'value': 'Human Resources'
        }, {
            'title': 'Import and Export',
            'value': 'Import and Export'
        }, {
            'title': 'Individual & Family Services',
            'value': 'Individual & Family Services'
        }, {
            'title': 'Industrial Automation',
            'value': 'Industrial Automation'
        }, {
            'title': 'Information Services',
            'value': 'Information Services'
        }, {
            'title': 'Information Technology and Services',
            'value': 'Information Technology and Services'
        }, {
            'title': 'Insurance',
            'value': 'Insurance'
        }, {
            'title': 'International Affairs',
            'value': 'International Affairs'
        }, {
            'title': 'International Trade and Development',
            'value': 'International Trade and Development'
        }, {
            'title': 'Internet',
            'value': 'Internet'
        }, {
            'title': 'Investment Banking',
            'value': 'Investment Banking'
        }, {
            'title': 'Investment Management',
            'value': 'Investment Management'
        }, {
            'title': 'Judiciary',
            'value': 'Judiciary'
        }, {
            'title': 'Law Enforcement',
            'value': 'Law Enforcement'
        }, {
            'title': 'Law Practice',
            'value': 'Law Practice'
        }, {
            'title': 'Legal Services',
            'value': 'Legal Services'
        }, {
            'title': 'Legislative Office',
            'value': 'Legislative Office'
        }, {
            'title': 'Leisure, Travel & Tourism',
            'value': 'Leisure, Travel & Tourism'
        }, {
            'title': 'Libraries',
            'value': 'Libraries'
        }, {
            'title': 'Logistics and Supply Chain',
            'value': 'Logistics and Supply Chain'
        }, {
            'title': 'Luxury Goods & Jewelry',
            'value': 'Luxury Goods & Jewelry'
        }, {
            'title': 'Machinery',
            'value': 'Machinery'
        }, {
            'title': 'Management Consulting',
            'value': 'Management Consulting'
        }, {
            'title': 'Maritime',
            'value': 'Maritime'
        }, {
            'title': 'Market Research',
            'value': 'Market Research'
        }, {
            'title': 'Marketing and Advertising',
            'value': 'Marketing and Advertising'
        }, {
            'title': 'Mechanical or Industrial Engineering',
            'value': 'Mechanical or Industrial Engineering'
        }, {
            'title': 'Media Production',
            'value': 'Media Production'
        }, {
            'title': 'Medical Devices',
            'value': 'Medical Devices'
        }, {
            'title': 'Medical Practice',
            'value': 'Medical Practice'
        }, {
            'title': 'Mental Health Care',
            'value': 'Mental Health Care'
        }, {
            'title': 'Military',
            'value': 'Military'
        }, {
            'title': 'Mining & Metals',
            'value': 'Mining & Metals'
        }, {
            'title': 'Motion Pictures and Film',
            'value': 'Motion Pictures and Film'
        }, {
            'title': 'Museums and Institutions',
            'value': 'Museums and Institutions'
        }, {
            'title': 'Music',
            'value': 'Music'
        }, {
            'title': 'Nanotechnology',
            'value': 'Nanotechnology'
        }, {
            'title': 'Newspapers',
            'value': 'Newspapers'
        }, {
            'title': 'Non-Profit Organization Management',
            'value': 'Non-Profit Organization Management'
        }, {
            'title': 'Oil & Energy',
            'value': 'Oil & Energy'
        }, {
            'title': 'Online Media',
            'value': 'Online Media'
        }, {
            'title': 'Outsourcing/Offshoring',
            'value': 'Outsourcing/Offshoring'
        }, {
            'title': 'Package/Freight Delivery',
            'value': 'Package/Freight Delivery'
        }, {
            'title': 'Packaging and Containers',
            'value': 'Packaging and Containers'
        }, {
            'title': 'Paper & Forest Products',
            'value': 'Paper & Forest Products'
        }, {
            'title': 'Performing Arts',
            'value': 'Performing Arts'
        }, {
            'title': 'Pharmaceuticals',
            'value': 'Pharmaceuticals'
        }, {
            'title': 'Philanthropy',
            'value': 'Philanthropy'
        }, {
            'title': 'Photography',
            'value': 'Photography'
        }, {
            'title': 'Plastics',
            'value': 'Plastics'
        }, {
            'title': 'Political Organization',
            'value': 'Political Organization'
        }, {
            'title': 'Primary/Secondary Education',
            'value': 'Primary/Secondary Education'
        }, {
            'title': 'Printing',
            'value': 'Printing'
        }, {
            'title': 'Professional Training & Coaching',
            'value': 'Professional Training & Coaching'
        }, {
            'title': 'Program Development',
            'value': 'Program Development'
        }, {
            'title': 'Public Policy',
            'value': 'Public Policy'
        }, {
            'title': 'Public Relations and Communications',
            'value': 'Public Relations and Communications'
        }, {
            'title': 'Public Safety',
            'value': 'Public Safety'
        }, {
            'title': 'Publishing',
            'value': 'Publishing'
        }, {
            'title': 'Railroad Manufacture',
            'value': 'Railroad Manufacture'
        }, {
            'title': 'Ranching',
            'value': 'Ranching'
        }, {
            'title': 'Real Estate',
            'value': 'Real Estate'
        }, {
            'title': 'Recreational Facilities and Services',
            'value': 'Recreational Facilities and Services'
        }, {
            'title': 'Religious Institutions',
            'value': 'Religious Institutions'
        }, {
            'title': 'Renewables & Environment',
            'value': 'Renewables & Environment'
        }, {
            'title': 'Research',
            'value': 'Research'
        }, {
            'title': 'Restaurants',
            'value': 'Restaurants'
        }, {
            'title': 'Retail',
            'value': 'Retail'
        }, {
            'title': 'Security and Investigations',
            'value': 'Security and Investigations'
        }, {
            'title': 'Semiconductors',
            'value': 'Semiconductors'
        }, {
            'title': 'Shipbuilding',
            'value': 'Shipbuilding'
        }, {
            'title': 'Sporting Goods',
            'value': 'Sporting Goods'
        }, {
            'title': 'Sports',
            'value': 'Sports'
        }, {
            'title': 'Staffing and Recruiting',
            'value': 'Staffing and Recruiting'
        }, {
            'title': 'Supermarkets',
            'value': 'Supermarkets'
        }, {
            'title': 'Telecommunications',
            'value': 'Telecommunications'
        }, {
            'title': 'Textiles',
            'value': 'Textiles'
        }, {
            'title': 'Think Tanks',
            'value': 'Think Tanks'
        }, {
            'title': 'Tobacco',
            'value': 'Tobacco'
        }, {
            'title': 'Translation and Localization',
            'value': 'Translation and Localization'
        }, {
            'title': 'Transportation/Trucking/Railroad',
            'value': 'Transportation/Trucking/Railroad'
        }, {
            'title': 'Utilities',
            'value': 'Utilities'
        }, {
            'title': 'Venture Capital & Private Equity',
            'value': 'Venture Capital & Private Equity'
        }, {
            'title': 'Veterinary',
            'value': 'Veterinary'
        }, {
            'title': 'Warehousing',
            'value': 'Warehousing'
        }, {
            'title': 'Wholesale',
            'value': 'Wholesale'
        }, {
            'title': 'Wine and Spirits',
            'value': 'Wine and Spirits'
        }, {
            'title': 'Wireless',
            'value': 'Wireless'
        }, {
            'title': 'Writing and Editing',
            'value': 'Writing and Editing'
        }];
        $scope.industrySearchText = '';
        $scope.industrySelectedTemp = (user.industry) ? user.industry : '';
        $scope.industrySelected = (user.industry) ? user.industry : '';

        $scope.industrySearch = function (query) {
            return $scope.industries.filter(function (industry) {
                return industry.title.toLowerCase().indexOf(query.toLowerCase()) !== -1;
            });
        };

        $scope.saveIndustries = function (industry) {
            $scope.fixOverflow();
            var elem = angular.element('md-autocomplete.form-control-autocomplete');

            if (typeof industry === 'object' && typeof industry.title !== 'undefined' && industry.title !== null) {
                $scope.industrySelected = industry.title;
                elem.removeClass('missing-data');
            } else {
                $scope.industrySelected = $translate.instant('FIX_SERVICE_EMPTY_FIELD_MSG');
                elem.addClass('missing-data');
            }
        };

        $scope.fixOverflow = function () {
            // I don't like use this, but the angular-material autocompleted change the html and body overflow and affect the design of the UI.
            $('html').attr('style', 'overflow-y: inherit;');
            // $('body').attr('style', 'position: relative;');
        };
        // #endregion Industries.
    }
})();

(function () {
    'use strict';

    angular
        .module('intryFrontEnd')
        .controller('UnemployedNotesController', UnemployedNotesController);

    /** @ngInject */
    function UnemployedNotesController($scope, constants, $state, unemployedNotesService, $localStorage, $rootScope, toastr, $translate, organizationService, $timeout, ngDialog, $filter) {
        window.scrollTo(0, 0);

        var recordsPerPage = constants.recordsPerPage;

        $scope.unemployedNotesFilterFields = constants.unemployedNotesFilterFields;
        $scope.filterField = constants.unemployedNotesFilterFields[0].key;
        $scope.ftypes = constants.ftypesMultiFields;
        $scope.ftype = $scope.ftypes[0].key;

        $scope.paginationFilter = '';
        $scope.maxDate = moment();
        $scope.paginationFilterFrom = '';
        $scope.paginationFilterTo = '';
        $scope.currentSkip = 0;
        $scope.currentPage = 1;
        $scope.totalPages = 1;
        $scope.unemployedNotes = [];
        $scope.totalUnemployedNotes = 0;
        $scope.tableState = {};

        $scope.requestCreate = function () {
            $localStorage.registeredUserID = undefined;
            $state.go('admin-create-admin');
        };

        // #region Pagination Methods.
        $scope.resetSkip = false;

        $scope.getUnemployedNotes = function (tableState) {
            $scope.tableState = tableState;
            $scope.isLoading = true;
            var unemployedNotesData = [];

            if (angular.isUndefined($scope.currentSkip) || $scope.resetSkip) {
                $scope.currentSkip = 0;
                $scope.resetSkip = false;
            }

            var field = $scope.filterField;

            var sort = '';
            var order = '';

            if (typeof tableState === 'object' && (typeof tableState.sort.predicate !== 'undefined' || typeof tableState.sort.reverse !== 'undefined')) {
                sort = tableState.sort.predicate;
                order = (tableState.sort.reverse) ? -1 : 1;
            } else {
                tableState = tableState || {};
                tableState.sort = {
                    predicate: 'sendDate',
                    reverse: true
                };
                $scope.tableState = tableState;
                sort = tableState.sort.predicate;
                order = (tableState.sort.reverse) ? -1 : 1;
            }

            var filterFrom = -1;

            if (typeof $scope.paginationFilterFrom === 'string' && $scope.paginationFilterFrom.length > 0) {
                filterFrom = moment($scope.paginationFilterFrom + ' 00:00:00 am', 'MM/DD/YYYY hh:mm a').unix();
            }

            var filterTo = -1;

            if (typeof $scope.paginationFilterTo === 'string' && $scope.paginationFilterTo.length > 0) {
                filterTo = moment($scope.paginationFilterTo + ' 11:59:59 pm', 'MM/DD/YYYY hh:mm a').unix();
            }

            unemployedNotesService.getUnemployedNotes($scope.currentSkip, recordsPerPage, field, $scope.paginationFilter, $scope.ftype, sort, order, 'sendDate', filterFrom, filterTo).then(function (response) {
                if (response.error) {
                    alert("There was an error, notes could not be loaded");

                    return false;
                }

                var unemployedNotes = response.data[0]["unemployedNotes"];
                $scope.totalUnemployedNotes = response.data[1]["total"];

                angular.forEach(unemployedNotes, function (value, key) {
                    var notes = _.sortBy(value.notes, 'noteDate');

                    notes.forEach(function (noteNote) {
                        var momentNoteNoteDate = moment(noteNote.noteDate * 1000);
                        noteNote.noteDate = momentNoteNoteDate.format('MM/DD/YYYY hh:mm a');
                        noteNote.noteDateDate = momentNoteNoteDate.format('MM/DD/YYYY');
                        noteNote.noteDateTime = momentNoteNoteDate.format('hh:mm a');
                    });

                    unemployedNotesData.push({
                        'unemployedNoteID': value.unemployedNoteID,
                        'userID': value.userID,
                        'createdBy': value.createdBy,
                        'resumeID': value.resumeID,
                        'resumeTitle': value.resumeTitle,
                        'jobUrl': value.jobUrl,
                        'sendDate': moment(value.sendDate * 1000).format('MM/DD/YYYY hh:mm a'),
                        'jobType': value.jobType,
                        'deleted': value.deleted,

                        'companyName': value.companyName,
                        'companyState': value.companyState,
                        'companyCity': value.companyCity,
                        'companyAddress': value.companyAddress,

                        'companyZipCode': value.companyZipCode,
                        'companyPhone': value.companyPhone,

                        'contactName': value.contactName,
                        'contactEmail': value.contactEmail,
                        'contactMailAddress': value.contactMailAddress,
                        'contactPhone': value.contactPhone,

                        'interviewDate': (value.interviewDate > 0) ? moment(value.interviewDate * 1000).format('MM/DD/YYYY hh:mm a') : '',
                        'hired': value.hired,
                        'jobStartDate': (value.jobStartDate > 0) ? moment(value.jobStartDate * 1000).format('MM/DD/YYYY') : '',
                        'notes': notes,
                        'lastNote': '(' + notes[notes.length - 1].noteDate + ') ' + notes[notes.length - 1].note,

                        'created': value.created,
                        'updated': value.updated
                    });
                });

                // console.logconsole.log("-- (Controller) UnemployedNotesController.$scope.openUpdateUnemployedNote() - unemployedNotesData: ", unemployedNotesData);

                $scope.isLoading = false;
                $scope.unemployedNotes = unemployedNotesData;
                $scope.disablePrev = $scope.currentSkip == 0;
                $scope.disableNext = ($scope.currentSkip + recordsPerPage) >= $scope.totalUnemployedNotes;
                calcPages();
            });
        };

        $scope.checkFtypes = function () {
            var field = _.findWhere($scope.unemployedNotesFilterFields, {
                key: $scope.filterField
            });
            var ftypes = field.ftypes;
            $scope.ftypes = constants[ftypes];
            $scope.ftype = $scope.ftypes[0].key;
        };

        $scope.checkFilterDate = function (opt) {
            var from = moment($scope.paginationFilterFrom + ' 00:00:00 am', 'MM/DD/YYYY hh:mm a').unix();
            var to = moment($scope.paginationFilterTo + ' 11:59:59 pm', 'MM/DD/YYYY hh:mm a').unix();

            if (opt === 'from' && from > to) {
                $scope.paginationFilterTo = $scope.paginationFilterFrom;
            } else if (opt === 'to' && to < from) {
                $scope.paginationFilterFrom = $scope.paginationFilterTo;
            }
        };

        $scope.download = function () {
            var tableState = $scope.tableState;
            $scope.isLoading = true;
            if (angular.isUndefined($scope.currentSkip) || $scope.resetSkip) {
                $scope.currentSkip = 0;
                $scope.resetSkip = false;
            }

            var field = $scope.filterField;

            var sort = '';
            var order = '';

            if (typeof tableState === 'object' && typeof tableState.sort.predicate !== 'undefined') {
                sort = tableState.sort.predicate;
                order = (tableState.sort.reverse) ? -1 : 1;
            }

            var filterFrom = -1;

            if (typeof $scope.paginationFilterFrom === 'string' && $scope.paginationFilterFrom.length > 0) {
                filterFrom = moment($scope.paginationFilterFrom + ' 00:00:00 am', 'MM/DD/YYYY hh:mm a').unix();
            }

            var filterTo = -1;

            if (typeof $scope.paginationFilterTo === 'string' && $scope.paginationFilterTo.length > 0) {
                filterTo = moment($scope.paginationFilterTo + ' 11:59:59 pm', 'MM/DD/YYYY hh:mm a').unix();
            }

            unemployedNotesService.downloadUnemployedNotes(field, $scope.paginationFilter, $scope.ftype, sort, order, 'sendDate', filterFrom, filterTo).then(function (response) {
                try {
                    // console.logconsole.log('-- (Controller) UnemployedNotesController.$scope.download() - response: ', response);

                    if (response.error) {
                        alert("There was an error, notes could not be download");

                        $scope.isLoading = false;

                        return false;
                    }

                    var fileContentBase64 = response.data.fileContentBase64;
                    var blob = unemployedNotesService.base64ToBlob(fileContentBase64, 'application/pdf;charset=utf-8;');
                    var fileName = response.data.fileName;

                    var downloadLink = angular.element('<a></a>');
                    downloadLink.attr('href', window.URL.createObjectURL(blob));
                    downloadLink.attr('download', fileName);
                    downloadLink[0].click();

                    $scope.isLoading = false;

                } catch (e) {
                    console.log('-- (Controller) UnemployedNotesController.$scope.download() - e: ', e);

                    $scope.isLoading = false;

                    return false;
                }
                return true;
            });
        };

        $scope.search = function () {
            $scope.currentSkip = 0;
            recordsPerPage = constants.recordsPerPage;

            if (typeof $scope.tableState !== 'object' && typeof $scope.tableState.sort !== 'undefined') {
                $scope.tableState.sort = {};
            }

            $scope.getUnemployedNotes();
        };

        $scope.clear = function () {
            $scope.filterField = constants.unemployedNotesFilterFields[0].key;
            $scope.ftype = $scope.ftypes[0].key;
            $scope.paginationFilter = '';
            $scope.paginationFilterFrom = '';
            $scope.paginationFilterTo = '';

            $scope.getUnemployedNotes();
        };

        $scope.deleteNoteModal = function (note) {
            var unemployedNoteID = note.unemployedNoteID;
            var msg = $translate.instant('DELETE_UNEMPLOYED_NOTE_TEXT');
            var result = confirm(msg);

            if (result) {
                $scope.deleteNote(unemployedNoteID);
            }
        };

        $scope.deleteNote = function (unemployedNoteID) {
            unemployedNotesService.deleteUnemployedNote(unemployedNoteID).then(function (response) {
                var errorMsg = "";

                try {
                    if (response.status === 200) {
                        $scope.buildUpdateToastr($translate.instant('DELETE_UNEMPLOYED_NOTE_SUCCESS_TEXT'), $translate.instant('DELETE_UNEMPLOYED_NOTE_SUCCESS_TITLE'), 4000);
                    } else {
                        errorMsg = $translate.instant('DELETE_UNEMPLOYED_NOTE_ERROR_TEXT');
                        $scope.buildToastr(errorMsg, $translate.instant('DELETE_UNEMPLOYED_NOTE_WARNING_TITLE'), 4000);
                    }
                } catch (e) {
                    errorMsg = $translate.instant('DELETE_UNEMPLOYED_NOTE_ERROR_TEXT');
                    $scope.buildToastr(errorMsg, $translate.instant('DELETE_UNEMPLOYED_NOTE_WARNING_TITLE'), 4000);
                }
            });
        };

        $scope.getPrevPage = function () {
            $scope.currentSkip = !angular.isUndefined($scope.currentSkip) ? $scope.currentSkip - recordsPerPage : 0;
            $scope.getUnemployedNotes();
        };

        $scope.getNextPage = function () {
            $scope.currentSkip = !angular.isUndefined($scope.currentSkip) ? $scope.currentSkip + recordsPerPage : 0;
            $scope.getUnemployedNotes();
        };

        var calcPages = function () {
            $scope.currentPage = ($scope.currentSkip / recordsPerPage) + 1;
            $scope.totalPages = Math.ceil($scope.totalUnemployedNotes / recordsPerPage);
        };

        $scope.setResetSkip = function (val) {
            $scope.resetSkip = val;
        }
        // #endregion Pagination Methods.

        // #region Notification Methods.
        $scope.buildToastr = function (content, title, timeout) {
            var t = toastr.info(content, title, {
                progressBar: true,
                timeOut: timeout,
                toastClass: 'toast',
                preventDuplicates: true,
                allowHtml: true,
                positionClass: 'toast-top-full-width',
                hideDuration: timeout,
                closeButton: true,
                showDuration: timeout,
                extendedTimeOut: timeout,
                hideMethod: 'noop'
            });
            $rootScope.toast = t;
        };

        $scope.buildUpdateToastr = function (content, title, timeout) {
            var t = toastr.info(content, title, {
                progressBar: true,
                timeOut: timeout,
                toastClass: 'toast',
                preventDuplicates: true,
                allowHtml: true,
                positionClass: 'toast-top-full-width',
                hideDuration: timeout,
                closeButton: true,
                showDuration: timeout,
                extendedTimeOut: timeout,
                hideMethod: 'noop'
            });
            t.scope.options.onHidden = function () {
                $scope.getUnemployedNotes();
            };
            $rootScope.toast = t;
        };
        // #endregion Notification Methods.

        $scope.checkRole = function (roles) {
            var adminUser = $localStorage.adminUser;
            var adminRole = 'ROLE_ADMIN_USER';

            if (typeof adminUser === 'object' && typeof adminUser.role === 'string' && adminUser.role.length > 0) {
                adminRole = adminUser.role;
            }

            return (roles.indexOf(adminRole) > -1) ? true : false;
        };

        // #region update unemployed note
        $scope.time = constants.notesTimeOptions;

        $scope.resetUnemployedNote = function (resume) {
            $scope.unemployedNote = {
                userID: '',
                createdBy: '',
                resumeID: '',
                jobUrl: '',
                sendDate: 0,
                sendDateDate: moment().format('MM/DD/YYYY'),
                sendDateTime: '12:00 am',
                jobType: '',
                deleted: false,

                companyName: '',
                companyState: '',
                companyCity: '',
                companyAddress: '',
                companyZipCode: '',
                companyPhone: '',

                contactName: '',
                contactEmail: '',
                contactMailAddress: '',
                contactPhone: '',

                interviewDate: 0,
                interviewDateDate: '',
                interviewDateTime: '12:00 am',
                hired: false,
                jobStartDate: 0,
                jobStartDateDate: '',

                notes: []
            };

            if (typeof resume === 'object') {
                if (typeof resume.resumeID === 'string') {
                    $scope.unemployedNote.resumeID = resume.resumeID;
                }
            }

            $scope.unemployedNote.userID = $localStorage.user.userID;
            $scope.unemployedNote.createdBy = $localStorage.user.userID;

            $scope.addNoteNote();
        };

        $scope.openAddUnemployedNote = function () {
            // console.log("-- (Controller) UnemployedNotesController.$scope.openAddUnemployedNote()");

            $scope.resetUnemployedNote();

            var dialog = {
                templateUrl: 'app/resumes/template/add-note.html',
                scope: $scope,
                closeByDocument: false,
                closeByEscape: false,
                showClose: false,
                closeByNavigation: true,
                height: '100%',
                className: 'add-note-dialog',
                onOpenCallback: function () {
                    var element = $(this);
                    if (element.is('.new-ngdialog')) {
                        $timeout(function () {
                            element.find('.modal-content').scrollTop(0);
                        }, 0);
                    }
                }
            };
            ngDialog.openConfirm(dialog);
        };

        $scope.openUpdateUnemployedNote = function (note) {
            // console.log("-- (Controller) UnemployedNotesController.$scope.openUpdateUnemployedNote() - note: ", note);

            // #region Prepare Dates.
            var momentSendDate = moment(note.sendDate, 'MM/DD/YYYY hh:mm a');
            var sendDateDate = momentSendDate.format('MM/DD/YYYY');
            var sendDateTime = momentSendDate.format('hh:mm a');

            var interviewDateDate;
            var interviewDateTime;

            if (note.interviewDate.length > 0) {
                var momentInterviewDate = moment(note.interviewDate, 'MM/DD/YYYY hh:mm a');
                interviewDateDate = momentInterviewDate.format('MM/DD/YYYY');
                interviewDateTime = momentInterviewDate.format('hh:mm a');
            } else {
                interviewDateDate = '';
                interviewDateTime = '12:00 am';
            }

            var jobStartDateDate = note.jobStartDate;
            // #endregion Prepare Dates.

            $scope.unemployedNote = {
                unemployedNoteID: note.unemployedNoteID,

                userID: $localStorage.userId,
                createdBy: $localStorage.userId,
                resumeID: note.resumeID,
                jobUrl: note.jobUrl,
                sendDate: note.sendDate,
                sendDateDate: sendDateDate,
                sendDateTime: sendDateTime,
                jobType: note.jobType,
                deleted: note.deleted,

                companyName: note.companyName,
                companyState: note.companyState,
                companyCity: note.companyCity,
                companyAddress: note.companyAddress,
                companyZipCode: note.companyZipCode,
                companyPhone: note.companyPhone,

                contactName: note.contactName,
                contactEmail: note.contactEmail,
                contactMailAddress: note.contactMailAddress,
                contactPhone: note.contactPhone,

                interviewDate: note.interviewDate,
                interviewDateDate: interviewDateDate,
                interviewDateTime: interviewDateTime,
                hired: note.hired,
                jobStartDate: note.jobStartDate,
                jobStartDateDate: jobStartDateDate,

                notes: note.notes
            };

            // console.log("-- (Controller) UnemployedNotesController.$scope.openUpdateUnemployedNote() - $scope.unemployedNote: ", $scope.unemployedNote);

            var dialog = {
                templateUrl: 'app/resumes/template/add-note.html',
                scope: $scope,
                closeByDocument: false,
                closeByEscape: false,
                showClose: false,
                closeByNavigation: true,
                height: '100%',
                className: 'add-note-dialog',
                onOpenCallback: function () {
                    var element = $(this);
                    if (element.is('.new-ngdialog')) {
                        $timeout(function () {
                            element.find('.modal-content').scrollTop(0);
                        }, 0);
                    }
                }
            };
            ngDialog.openConfirm(dialog);
        };

        $scope.closeAddNoteModal = function () {
            ngDialog.closeAll();
        };

        $scope.updateSendDate = function () {
            var date = $scope.unemployedNote.sendDateDate;
            var time = $scope.unemployedNote.sendDateTime;

            $scope.unemployedNote.sendDate = moment(date + ' ' + time, 'MM/DD/YYYY hh:mm a').unix();
        };

        $scope.updateJobStartDate = function () {
            var date = $scope.unemployedNote.jobStartDateDate;

            if (typeof date !== 'undefined' && date !== null) {
                $scope.unemployedNote.jobStartDate = moment(date, 'MM/DD/YYYY').unix();
            } else {
                $scope.unemployedNote.jobStartDate = '';
            }
        };

        $scope.updateInterviewDate = function () {
            var date = $scope.unemployedNote.interviewDateDate;
            var time = $scope.unemployedNote.interviewDateTime;

            if (
                typeof date !== 'undefined' && date !== null && date.length > 0 &&
                    typeof time !== 'undefined' && time !== null && time.length > 0
            ) {
                $scope.unemployedNote.interviewDate = moment(date + ' ' + time, 'MM/DD/YYYY hh:mm a').unix();
            } else {
                $scope.unemployedNote.interviewDate = 0;
            }
        };

        $scope.showNoteNote = function (note) {
            return ((typeof note === 'object') && !note.deleted);
        };

        $scope.showAddNoteNote = function () {
            var id = $scope.unemployedNote.unemployedNoteID;

            return (typeof id === 'string' && id.length > 0);
        }

        $scope.addNoteNote = function () {
            $scope.unemployedNote.notes.push({
                noteDate: 0,
                noteDateDate: moment().format('MM/DD/YYYY'),
                noteDateTime: '12:00 am',
                note: ''
            });
        };

        $scope.updateNoteNoteDate = function (note) {
            if (
                typeof note === 'object' &&
                    typeof note.noteDateDate !== 'undefined' && note.noteDateDate !== null && note.noteDateDate.length > 0 &&
                    typeof note.noteDateTime !== 'undefined' && note.noteDateTime !== null && note.noteDateTime.length > 0
            ) {
                var date = note.noteDateDate;
                var time = note.noteDateTime;

                note.noteDate = moment(date + ' ' + time, 'MM/DD/YYYY hh:mm a').unix();
            } else {
                note.noteDate = 0;
            }
        };

        $scope.showDeleteNoteNote = function () {
            return ($scope.unemployedNote.notes.length > 1);
        }

        $scope.deleteNoteNote = function (note) {
            if (typeof note._id !== 'undefined' && note._id !== null) {
                note.deleted = true;
            } else {
                var idx = $scope.unemployedNote.notes.indexOf(note);
                $scope.unemployedNote.notes.splice(idx, 1);
            }
        };

        $scope.validateUnemployedNoteFields = function () {
            var result = false;

            try {
                if (
                    $scope.unemployedNote.jobUrl.length > 0 &&
                        $scope.unemployedNote.sendDateDate.length > 0 &&
                        validateNoteNoteFields()
                ) {
                    result = true;
                }
            } catch (e) {
                // Do nothing...
            }

            return result;
        };

        function validateNoteNoteFields() {
            var validated = true;

            try {
                if ($scope.unemployedNote.notes.length > 0) {
                    var found = $scope.unemployedNote.notes.find(function (note) {
                        if (typeof note === 'object' && (note.noteDate === null || note.noteDate === 0 || note.note.length === 0)) {
                            return true;
                        }
                        return false;
                    });
                    validated = (found) ? false : true;
                } else {
                    validated = false;
                }
            } catch (e) {
                validated = false;
            }

            return validated;
        }

        $scope.saveNote = function () {
            if (!$scope.validateUnemployedNoteFields()) {
                return;
            }

            var notes = [];
            $scope.unemployedNote.notes.forEach(function (note) {
                if (typeof note === 'object') {
                    delete note.noteDateDate;
                    delete note.noteDateTime;
                    notes.push(note);
                }
            });
            notes = _.sortBy(notes, 'noteDate');

            // console.log("-- (Controller) UnemployedNotesController.$scope.saveNote() - $scope.unemployedNote: ", $scope.unemployedNote);
            // console.log("-- (Controller) UnemployedNotesController.$scope.saveNote() - notes: ", notes);

            var unemployedNote = {
                // unemployedNoteID: $scope.unemployedNote.unemployedNoteID,

                userID: $scope.unemployedNote.userID,
                createdBy: $scope.unemployedNote.createdBy,
                resumeID: $scope.unemployedNote.resumeID,
                jobUrl: $scope.unemployedNote.jobUrl,
                sendDate: $scope.unemployedNote.sendDate,
                jobType: $scope.unemployedNote.jobType,
                deleted: $scope.unemployedNote.deleted,

                companyName: $scope.unemployedNote.companyName,
                companyState: $scope.unemployedNote.companyState,
                companyCity: $scope.unemployedNote.companyCity,
                companyAddress: $scope.unemployedNote.companyAddress,
                companyZipCode: $scope.unemployedNote.companyZipCode,
                companyPhone: $scope.unemployedNote.companyPhone,

                contactName: $scope.unemployedNote.contactName,
                contactEmail: $scope.unemployedNote.contactEmail,
                contactMailAddress: $scope.unemployedNote.contactMailAddress,
                contactPhone: $scope.unemployedNote.contactPhone,

                interviewDate: $scope.unemployedNote.interviewDate,
                hired: $scope.unemployedNote.hired,
                jobStartDate: $scope.unemployedNote.jobStartDate,

                notes: notes
            };

            if (typeof $scope.unemployedNote.unemployedNoteID === 'string' && $scope.unemployedNote.unemployedNoteID.length > 0) {
                unemployedNote.unemployedNoteID = $scope.unemployedNote.unemployedNoteID;

                unemployedNotesService.updateUnemployedNote(unemployedNote).then(function (response) {
                    var errorMsg = '';

                    try {
                        if (response.status === 200) {
                            ngDialog.closeAll();
                            $scope.buildUpdateToastr($translate.instant('UPDATE_UNEMPLOYED_NOTE_SUCCESS_TEXT'), $translate.instant('ADMIN_CREATE_SUCCESS_TITLE'), 2000);
                        } else {
                            errorMsg = $translate.instant('UPDATE_UNEMPLOYED_NOTE_ERROR_TEXT');
                            $scope.buildToastr(errorMsg, $translate.instant('ADMIN_CREATE_WARNING_TITLE'), 4000);
                        }
                    } catch (e) {
                        errorMsg = $translate.instant('UPDATE_UNEMPLOYED_NOTE_ERROR_TEXT');
                        $scope.buildToastr(errorMsg, $translate.instant('ADMIN_CREATE_WARNING_TITLE'), 4000);
                    }
                });
            } else {
                unemployedNotesService.createUnemployedNote(unemployedNote).then(function (response) {
                    var errorMsg = '';

                    try {
                        if (response.status === 201) {
                            ngDialog.closeAll();
                            $scope.buildUpdateToastr($translate.instant('ADD_UNEMPLOYED_NOTE_SUCCESS_TEXT'), $translate.instant('ADMIN_CREATE_SUCCESS_TITLE'), 2000);
                        } else {
                            errorMsg = $translate.instant('ADD_UNEMPLOYED_NOTE_ENABLED_ERROR_TEXT');
                            $scope.buildToastr(errorMsg, $translate.instant('ADMIN_CREATE_WARNING_TITLE'), 4000);
                        }
                    } catch (e) {
                        errorMsg = $translate.instant('ADD_UNEMPLOYED_NOTE_ENABLED_ERROR_TEXT');
                        $scope.buildToastr(errorMsg, $translate.instant('ADMIN_CREATE_WARNING_TITLE'), 4000);
                    }
                });
            }
        };
        // #endregion update unemployed note

        // #region White Label Code.
        $scope.hasOrganization = function() {
            return organizationService.hasOrganization();
        };

        $scope.getOrganizationCss = function(css, returnEmpty) {
            return organizationService.getOrganizationCss(css, returnEmpty);
        };

        $scope.getOrganizationKey = function() {
            return organizationService.getOrganizationKey();
        };

        $scope.getOrganizationName = function() {
            return organizationService.getOrganizationName();
        };
        // #endregion White Label Code.
    }
})();

angular
.module('intryFrontEnd').directive('onErrorSrc', function() {
  return {
    link: function(scope, element, attrs) {
      element.bind('error', function() {
        if (attrs.src != attrs.onErrorSrc) {
          attrs.onErrorSrc = attrs.onErrorSrc.replace('_', '-');
          attrs.$set('src', "//s3.amazonaws.com/static.intry.careers/images/webapp/resume-template-thumbnail/" + attrs.onErrorSrc + ".png");

          var intV = setTimeout(function(){ 
            clearTimeout(intV);
              attrs.$set('src', attrs.org);
            }, 2000);
          }
      });
    }
  }
});
(function () {
    'use strict';

    angular
        .module('intryFrontEnd')
        .controller('ResumesController', ResumesController);

    /** @ngInject */
    function ResumesController($scope, $timeout, user, resumes, userService, resumeService, $cookies, ngDialog, $state, modalService, resumeValidation, utilsService, $location, organizationService, $translate, unemployedNotesService, toastr, $rootScope, constants, $localStorage) {
        window.scrollTo(0, 0);

        // Disable image cache
        angular.forEach(resumes, function (item) {
            if (item.meta && item.meta.export && item.meta.export.thumbnail) {
                item.meta.export.thumbnail += '?' + new Date().getTime();
            }
        });

        $scope.user = user;
        $scope.resumes = resumes;
        $scope.isPaused = user.disable_request_date !== undefined && user.disable_request_date !== null && userService.isPausedPastBillingDate();
        $scope.toolTip = $scope.isPaused ? "Account paused. Not able to create new resumes at this time" : "Create a new resume";
        $scope.openDeleteResume = function (resume) {
            $scope.scrimPageBackground = true;
            modalService.openModal(
                'app/resume-delete/template/resume-delete.html',
                'ResumeDeleteController', {
                    resume: function () {
                        return resume;
                    }
                }
            ).then(function (resume) {
                $scope.scrimPageBackground = false;
                resumeService.deleteResume(user.userID, resume.resumeID).then(function () {
                    resumeService.getResumes(user.userID).then(function (resumes) {
                        $scope.resumes = resumes;
                    });
                });
            }, function (err) {
                $scope.scrimPageBackground = false;
            });
        };
 

   
        $scope.openDownloadResume = function (resume) {

            function buildMissing(data) {
                $state.go('resume-profile', {
                    resumeId: resume.resumeID,
                    new: false,
                    resumeNotDownloaded:true
                });
            }
            if (resume.usedExport === 'nonats') {
                buildMissing(resume);
            }
            else {
                var resumeFile = resume.usedExport === 'nonats' ? 'resume' : 'hybrid';
                var resumeFilePath = constants.resumeStorage + user.userID + "/" + resume.resumeID + "/" + resumeFile + ".pdf";
                resumeService.downloadResumeFromS3(resumeFilePath, user.first_name + ' ' + user.last_name + ' - ' + (resume.title || resume) + '.pdf', false, buildMissing);
            }
        };

        $scope.showS3Url = function (resume) {
            var resumeFile = resume.usedExport === 'nonats' ? 'resume' : 'hybrid';
            var resumeFilePath = constants.resumeStorage + user.userID + "/" + resume.resumeID + "/" + resumeFile + ".pdf";
            alert(resumeFilePath);
        };
        
        // Intiates the resume creation walkthrough workflow
        $scope.openCreateResume = function () {
            // console.log("-- (Controller) ResumesController.openCreateResume()");

            if (checkResumeDownloadCounter()) {
                var userProfile = {
                    skills: [],
                    educationList: [],
                    experienceList: []
                };

                var copyUser = {};
                angular.copy($scope.user, copyUser);
                userProfile.skills = _.remove(copyUser.skills, function (item) {
                    return item.deleted === false;
                });
                userProfile.educationList = _.remove(copyUser.education, function (item) {
                    return item.deleted === false;
                });
                userProfile.experienceList = _.remove(copyUser.experience, function (item) {
                    return item.deleted === false;
                });
                _.each(userProfile.experienceList, function (element) {
                    element.startDateObj = utilsService.formatDate(element.date_start);
                    element.endDateObj = utilsService.formatDate(element.date_end);
                });
                var error;
                error = resumeValidation.isValid(userProfile);
                if (!(error && error.errString.length)) {
                    $state.go('resume-walkthrough', {
                        new: true
                    });
                } else {
                    showResumeInvalid();
                }
            }
        };

        $scope.openCreateProfileResume = function () {
            // console.log("-- (Controller) ResumesController.openCreateProfileResume()");

            if (checkResumeDownloadCounter()) {
                var userProfile = {
                    skills: [],
                    educationList: [],
                    experienceList: []
                };

                var copyUser = {};
                angular.copy($scope.user, copyUser);

                // console.log("-- (Controller) ResumesController.openCreateProfileResume() - $scope.user: ", $scope.user);

                userProfile.skills = _.remove(copyUser.skills, function (item) {
                    return item.deleted === false;
                });
                userProfile.educationList = _.remove(copyUser.education, function (item) {
                    return item.deleted === false;
                });
                userProfile.experienceList = _.remove(copyUser.experience, function (item) {
                    return item.deleted === false;
                });
                _.each(userProfile.experienceList, function (element) {
                    element.startDateObj = utilsService.formatDate(element.date_start);
                    element.endDateObj = utilsService.formatDate(element.date_end);
                });
                var error;
                error = resumeValidation.isValid(userProfile);

                // console.log("-- (Controller) ResumesController.openCreateProfileResume() - userProfile: ", userProfile);

                if (!(error && error.errString.length)) {
                    $state.go('resume-profile', {
                        new: true
                    });
                } else {
                    showResumeInvalid();
                }
            }
        };


        function showResumeInvalid() {
            $scope.scrimPageBackground = true;
            modalService.openModal(
                'app/resumes/template/validation-error-dialog.html',
                'resumeValidationController'
            ).then(function () {
                $scope.scrimPageBackground = false;

            }, function () {
                $scope.scrimPageBackground = false;
            });
        }

        $scope.menuOptions = [
            ['Edit', function ($itemScope) {
                $state.go('resume-profile', {
                    resumeId: $itemScope.resume.resumeID,
                    new: false
                });
            }]
            , ['Download', function ($itemScope) {
                $scope.openDownloadResume($itemScope.resume);
            }]
            , ['Add to Work Search Log', function ($itemScope) {
                $scope.openAddUnemployedNote($itemScope.resume);
            }]
            , ['Delete', function ($itemScope) {
                $scope.openDeleteResume($itemScope.resume);
            }]
            , ['S3 Url', function ($itemScope) {
                $scope.showS3Url($itemScope.resume);
            }]
            
        ];

        // #region White Label Code.
        $scope.hasOrganization = function() {
            return organizationService.hasOrganization();
        };

        $scope.getOrganizationCss = function(css, returnEmpty) {
            return organizationService.getOrganizationCss(css, returnEmpty);
        };

        $scope.getOrganizationKey = function() {
            return organizationService.getOrganizationKey();
        };

        $scope.getOrganizationName = function() {
            return organizationService.getOrganizationName();
        };
        // #endregion White Label Code.

        // #region Prepare Months/Years vars.
        //For Month and year
        var date = new Date();
        var months = [];
        var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        var i = 1;
        angular.forEach(monthNames, function (monthName) {
            var month = {
                fullmonthName: monthName,
                monthNumber: i
            };
            i++;
            months.push(month);
        });
        $scope.months = months;

        function getYears() {
            var currentYear = date.getFullYear() - 69;
            $scope.years = [];
            for (var i = 69; i > 0; i--) {
                $scope.years.push(currentYear + i);
            }

            return $scope.years;
        }
        getYears();
        // #endregion Prepare Months/Years vars.

        // #region Unemployed Notes.
        $scope.maxDate = moment();
        $scope.time = constants.notesTimeOptions;
        $scope.unemployedNote = {};

        $scope.resetUnemployedNote = function (resume) {
            $scope.unemployedNote = {
                userID: '',
                createdBy: '',
                resumeID: '',
                jobUrl: '',
                sendDate: 0,
                sendDateDate: moment().format('MM/DD/YYYY'),
                sendDateTime: '12:00 am',
                jobType: '',
                deleted: false,

                companyName: '',
                companyState: '',
                companyCity: '',
                companyAddress: '',
                companyZipCode: '',
                companyPhone: '',

                contactName: '',
                contactEmail: '',
                contactMailAddress: '',
                contactPhone: '',

                interviewDate: 0,
                interviewDateDate: '',
                interviewDateTime: '12:00 am',
                hired: false,
                jobStartDate: 0,
                jobStartDateDate: '',

                notes: []
            };

            if (typeof resume !== 'undefined' && resume !== null) {
                if (typeof resume.resumeID === 'string') {
                    $scope.unemployedNote.resumeID = resume.resumeID;
                }

                if (typeof resume.meta !== 'undefined' && resume.meta !== null && typeof resume.meta.userID === 'string') {
                    $scope.unemployedNote.userID = resume.meta.userID;
                    $scope.unemployedNote.createdBy = resume.meta.userID;
                }
            }

            $scope.addNoteNote();
        };

        $scope.openAddUnemployedNote = function (resume) {
            $scope.resetUnemployedNote(resume);
            // $scope.scrimPageBackground = true;

            var dialog = {
                templateUrl: 'app/resumes/template/add-note.html',
                scope: $scope,
                closeByDocument: false,
                closeByEscape: false,
                showClose: false,
                closeByNavigation: true,
                height: '100%',
                className: 'add-note-dialog',
                onOpenCallback: function () {
                    var element = $(this);
                    if (element.is('.new-ngdialog')) {
                        $timeout(function () {
                            element.find('.modal-content').scrollTop(0);
                        }, 0);
                    }
                }
            };
            ngDialog.openConfirm(dialog);
        };

        $scope.closeAddNoteModal = function () {
            ngDialog.closeAll();
        };

        $scope.updateSendDate = function () {
            var date = $scope.unemployedNote.sendDateDate;
            var time = $scope.unemployedNote.sendDateTime;

            $scope.unemployedNote.sendDate = moment(date + ' ' + time, 'MM/DD/YYYY hh:mm a').unix();
        };

        $scope.updateJobStartDate = function () {
            var date = $scope.unemployedNote.jobStartDateDate;

            if (typeof date !== 'undefined' && date !== null) {
                $scope.unemployedNote.jobStartDate = moment(date, 'MM/DD/YYYY').unix();
            } else {
                $scope.unemployedNote.jobStartDate = '';
            }
        };

        $scope.updateInterviewDate = function () {
            var date = $scope.unemployedNote.interviewDateDate;
            var time = $scope.unemployedNote.interviewDateTime;

            if (
                typeof date !== 'undefined' && date !== null && date.length > 0 &&
                    typeof time !== 'undefined' && time !== null && time.length > 0
            ) {
                $scope.unemployedNote.interviewDate = moment(date + ' ' + time, 'MM/DD/YYYY hh:mm a').unix();
            } else {
                $scope.unemployedNote.interviewDate = 0;
            }
        };

        $scope.showNoteNote = function (note) {
            return (typeof note !== 'undefined' && note !== null && !note.deleted);
        };

        $scope.showAddNoteNote = function () {
            var id = $scope.unemployedNote.unemployedNoteID;

            return (typeof id === 'string' && id.length > 0);
        };

        $scope.addNoteNote = function () {
            $scope.unemployedNote.notes.push({
                noteDate: 0,
                noteDateDate: moment().format('MM/DD/YYYY'),
                noteDateTime: '12:00 am',
                note: ''
            });
        };

        $scope.updateNoteNoteDate = function (note) {
            if (
                typeof note !== 'undefined' && note !== null &&
                    typeof note.noteDateDate !== 'undefined' && note.noteDateDate !== null && note.noteDateDate.length > 0 &&
                    typeof note.noteDateTime !== 'undefined' && note.noteDateTime !== null && note.noteDateTime.length > 0
            ) {
                var date = note.noteDateDate;
                var time = note.noteDateTime;

                note.noteDate = moment(date + ' ' + time, 'MM/DD/YYYY hh:mm a').unix();
            } else {
                note.noteDate = 0;
            }
        };

        $scope.showDeleteNoteNote = function () {
            return ($scope.unemployedNote.notes.length > 1);
        };

        $scope.deleteNoteNote = function (note) {
            if (typeof note._id !== 'undefined' && note._id !== null) {
                note.deleted = true;
            } else {
                var idx = $scope.unemployedNote.notes.indexOf(note);
                $scope.unemployedNote.notes.splice(idx, 1);
            }
        };

        $scope.validateUnemployedNoteFields = function () {
            var result = false;

            try {
                if (
                    $scope.unemployedNote.jobUrl.length > 0 &&
                        $scope.unemployedNote.sendDateDate.length > 0 &&
                        validateNoteNoteFields()
                ) {
                    result = true;
                }
            } catch (e) {
                // Do nothing...
            }

            return result;
        };

        function validateNoteNoteFields() {
            var validated = true;

            try {
                if ($scope.unemployedNote.notes.length > 0) {
                    var found = $scope.unemployedNote.notes.find(function (note) {
                        if (typeof note !== 'undefined' && note !== null && (note.noteDate === null || note.noteDate === 0 || note.note.length === 0)) {
                            return note;
                        }
                        return null;
                    });
                    validated = (found) ? false : true;
                } else {
                    validated = false;
                }
            } catch (e) {
                validated = false;
            }

            return validated;
        }

        $scope.saveNote = function () {
            if (!$scope.validateUnemployedNoteFields()) {
                return;
            }

            var notes = [];
            $scope.unemployedNote.notes.forEach(function (note) {
                if (typeof note !== 'undefined' && note !== null) {
                    delete note.noteDateDate;
                    delete note.noteDateTime;
                    notes.push(note);
                }
            });
            notes = _.sortBy(notes, 'noteDate');

            var unemployedNote = {
                userID: $scope.unemployedNote.userID,
                createdBy: $scope.unemployedNote.createdBy,
                resumeID: $scope.unemployedNote.resumeID,
                jobUrl: $scope.unemployedNote.jobUrl,
                sendDate: $scope.unemployedNote.sendDate,
                jobType: $scope.unemployedNote.jobType,
                deleted: $scope.unemployedNote.deleted,

                companyName: $scope.unemployedNote.companyName,
                companyState: $scope.unemployedNote.companyState,
                companyCity: $scope.unemployedNote.companyCity,
                companyAddress: $scope.unemployedNote.companyAddress,
                companyZipCode: $scope.unemployedNote.companyZipCode,
                companyPhone: $scope.unemployedNote.companyPhone,

                contactName: $scope.unemployedNote.contactName,
                contactEmail: $scope.unemployedNote.contactEmail,
                contactMailAddress: $scope.unemployedNote.contactMailAddress,
                contactPhone: $scope.unemployedNote.contactPhone,

                interviewDate: $scope.unemployedNote.interviewDate,
                hired: $scope.unemployedNote.hired,
                jobStartDate: $scope.unemployedNote.jobStartDate,

                notes: notes
            };

            unemployedNotesService.createUnemployedNote(unemployedNote).then(function (response) {
                var errorMsg = '';

                try {
                    if (response.status === 201) {
                        ngDialog.closeAll();
                        $scope.buildToastr($translate.instant('ADD_UNEMPLOYED_NOTE_SUCCESS_TEXT'), $translate.instant('ADMIN_CREATE_SUCCESS_TITLE'), 4000);
                    } else {
                        errorMsg = $translate.instant('ADD_UNEMPLOYED_NOTE_ENABLED_ERROR_TEXT');
                        $scope.buildToastr(errorMsg, $translate.instant('ADMIN_CREATE_WARNING_TITLE'), 4000);
                    }
                } catch (e) {
                    errorMsg = $translate.instant('ADD_UNEMPLOYED_NOTE_ENABLED_ERROR_TEXT');
                    $scope.buildToastr(errorMsg, $translate.instant('ADMIN_CREATE_WARNING_TITLE'), 4000);
                }
            });
        };
        // #endregion Unemployed Notes.

        // #region Notification Methods.
        $scope.buildToastr = function (content, title, timeout) {
            var t = toastr.info(content, title, {
                progressBar: true,
                timeOut: timeout,
                toastClass: 'toast',
                preventDuplicates: true,
                allowHtml: true,
                positionClass: 'toast-top-full-width',
                hideDuration: timeout,
                closeButton: true,
                showDuration: timeout,
                extendedTimeOut: timeout,
                hideMethod: 'noop'
            });
            $rootScope.toast = t;
        };
        // #endregion Notification Methods.

        // #region White Label Code.
        $scope.hasOrganization = function() {
            return organizationService.hasOrganization();
        };

        $scope.getOrganizationCss = function(css, returnEmpty) {
            return organizationService.getOrganizationCss(css, returnEmpty);
        };

        $scope.getOrganizationKey = function() {
            return organizationService.getOrganizationKey();
        };

        $scope.getOrganizationName = function() {
            return organizationService.getOrganizationName();
        };

        $scope.goToHome = function () {
            $state.go('dashboard');
        };
        // #endregion White Label Code.

        // #region Resume Download Counter.
        var checkResumeDownloadCounter = function () {
            var cv = getCounterVars();

            if (cv.resumeCounter === 0) {
                showUnavailableResumesDialog();

                return false;
            } else {
                return true;
            }
        };

        var getCounterVars = function () {
            var resumeCounter = 0;

            if (
                typeof $localStorage.user !== 'undefined' && $localStorage.user !== null &&
                    typeof $localStorage.user.resumeCounter !== 'undefined' && $localStorage.user.resumeCounter !== null
            ) {
                resumeCounter = $localStorage.user.resumeCounter;
            }

            var cv = {
                resumeCounter: resumeCounter
            };

            return cv;
        };

        var showUnavailableResumesDialog = function () {
            var dialog = {
                template: 'app/resume-builder/template/unavailable-resumes-dialog.html',
                controller: this,
                closeByDocument: false,
                closeByEscape: true,
                showClose: false,
                closeByNavigation: true,
                scope: $scope,
                width: '425px',
                height: '255px'
            };
            ngDialog.openConfirm(dialog);
        };

        $scope.closeConfirmSaveDialog = function () {
            ngDialog.close();
        };

        $scope.showPaywall = function () {
            localStorage.setItem("toSubscriptionFrom", "resumes");
            $state.go('subscription');
        };
        // #endregion Resume Download Counter.
    }
})();

(function () {
	'use strict';
  
    angular
    .module('intryFrontEnd')
    .controller('resumeValidationController', ResumeValidationController);


  function ResumeValidationController($scope, ngDialog, $state) {

    $scope.gotoProfile = function () {
      if ($state.current.name !== 'wizard' && $state.current.name !== 'user-profile') {
        $state.go('user-profile');
      } else {
        ngDialog.close();
      }
    }
  }
})();
(function () {
  'use strict';
  
  angular
    .module('intryFrontEnd')
    .controller('ResumeWalkthroughController', ResumeWalkthroughController);
  
  function ResumeWalkthroughController ($scope, $state,$timeout, user, resumeService, $window) {
    CKEDITOR.config.customConfig = '/media/ckeditor_config.js';

    var inActiveAllSections = function () {
      $scope.isResumeTemplateSectionSelected = false;
      $("*[class*='section-active']").removeClass('section-active');
    };
    
    var activateSection = function (sectionCSSSelector) {
      $(sectionCSSSelector).addClass("section-active");
    };
    $scope.currentPage = 0;
    $scope.totalPages = 4;
    $scope.user = user;
    $scope.model = {
      industry: '',
      title: '',
      resumeTemplate: 'default'
    };
    
    $scope.step1 = true;
    $scope.step2 = false;
    $scope.step4 = false;
    $scope.step3 = false;
    $scope.selectedIndustry='';
    $scope.selectedTemplate = {};
    
    $scope.withProfileData = (
      $scope.user.education.length > 0 ||
      $scope.user.experience.length > 0 ||
      $scope.user.skills.length > 0
    );
    $scope.THUMBNAIL_STATIC_URL = "//s3.amazonaws.com/static.intry.careers/images/webapp/resume-template-thumbnail/";

    $scope.getProgress = function (inverse) {
      var progress = Math.floor(($scope.currentPage * 100) / $scope.totalPages);
      if (inverse) {
        return (100 - progress) + '%';
      } else {
        return progress + '%';
      }
    };

    // Takes the user back to the starting experience
    $scope.goBackToStart = function () {
      $scope.step1 = true;
      $scope.step2 = false;
      $scope.currentPage = 0;
      inActiveAllSections();
      activateSection(".section-start");
    };
    
    // Takes the user to experience to select resume layout
    $scope.goToSelectResumeLayout = function () {
      if (!$scope.model.title) {
        // $scope.title_required_error = true;
      } else {
        $scope.currentPage = 1;
        $scope.title_required_error = false;
        inActiveAllSections();
        activateSection(".section-resume-layout");
        $scope.step1 = false;
        $scope.step2 = true;
        $scope.step3 = false;
        $scope.step4 = false;
        }
    };
    
    $scope.goBackToSelectResumeLayout = function () {
      $scope.step1 = false;
      $scope.step2 = true;
      $scope.step3 = false;
      $scope.step4 = false;
      $scope.currentPage = 1;
      inActiveAllSections();
      activateSection(".section-resume-layout");
    };
    
    // Takes the user to resume template options to let user choose resume template
    $scope.goToChooseResumeTemplate = function () {      
      if ($scope.selectedIndustry=='') {
        $scope.industry_required_error = true;
      } else {
        $scope.step1 = false;
        $scope.step2 = false;
        $scope.step3 = true;
        $scope.step4 = false;
        $scope.currentPage = 2;
        $scope.industry_required_error = false;
        inActiveAllSections();
        $scope.isResumeTemplateSectionSelected = true;
        activateSection(".section-resume-design-options");
      }
    };
    
    $scope.goBackToChooseResumeTemplate = function () {
      $scope.step1 = false;
      $scope.step2 = false;
      $scope.step3 = true;
      $scope.step4 = false;
      $scope.currentPage = 2;
      inActiveAllSections();
      $scope.isResumeTemplateSectionSelected = true;
      activateSection(".section-resume-design-options");
    };
    
    $scope.goToResumeTitle = function () {
        $scope.TemplateSelected_error = false;
        $scope.step3 = false;
        $scope.step4 = true;
        $scope.currentPage = 3;
        inActiveAllSections();
        activateSection(".section-resume-title");
        setTimeout(function(){
          var editor = CKEDITOR.instances['walkthrough-about'];
          if (!editor.getData()) {
            if($scope.user.summary != undefined && $scope.user.summary != null) editor.insertText($scope.user.summary);
          }
        }, 500);
    };
    
    $scope.createResume = function () {
      if(!CKEDITOR.instances['walkthrough-about'].getData()){
        $scope.aboutme_required_error = true;
      } else {
        $scope.currentPage = 4;
        var about = CKEDITOR.instances['walkthrough-about'].getData();
        var title = $scope.model.title;
        var industry = $scope.selectedIndustry;
        var resume_layout = $scope.selectedTemplate.value;

        // This is really bad form but for now we need to do it quick
        // The real fix is to change how both the walkthrough and profile
        // share this data
        _.each(user.experience, function(element){
          delete element.endYearObj;
          delete element.endMonthObj;
          delete element.startYearObj;
          delete element.startMonthObj;

        });
        _.each(user.education, function(element){
          delete element.endYearObj;
          delete element.endMonthObj;
          delete element.startYearObj;
          delete element.startMonthObj;
        });  

        resumeService.createResume(
          user,
          about,
          title,
          industry,
          resume_layout
        ).then(function (response) {
          CKEDITOR.instances['walkthrough-about'].destroy(true);
          $state.go('resume', {
            resumeId: response.data.resumeID,
            new: false
          });
        });
      }
    };

    $scope.goBack = function(){
      $window.history.back(-1);
    }

    $scope.dismiss = function () {
      CKEDITOR.instances['walkthrough-about'].destroy(true);
      $scope.closeThisDialog();
      $state.go('resumes');
    };
    
    $scope.setIndustry = function(industry){
      $scope.selectedIndustry = industry;
    }

    $scope.industries = [{'title':'Accounting','value':'Accounting'},{'title':'Airlines/Aviation','value':'Airlines/Aviation'},{'title':'Alternative Dispute Resolution','value':'Alternative Dispute Resolution'},{'title':'Alternative Medicine','value':'Alternative Medicine'},{'title':'Animation','value':'Animation'},{'title':'Apparel & Fashion','value':'Apparel & Fashion'},{'title':'Architecture & Planning','value':'Architecture & Planning'},{'title':'Arts and Crafts','value':'Arts and Crafts'},{'title':'Automotive','value':'Automotive'},{'title':'Aviation & Aerospace','value':'Aviation & Aerospace'},{'title':'Banking','value':'Banking'},{'title':'Biotechnology','value':'Biotechnology'},{'title':'Broadcast Media','value':'Broadcast Media'},{'title':'Building Materials','value':'Building Materials'},{'title':'Business Supplies and Equipment','value':'Business Supplies and Equipment'},{'title':'Capital Markets','value':'Capital Markets'},{'title':'Chemicals','value':'Chemicals'},{'title':'Civic & Social Organization','value':'Civic & Social Organization'},{'title':'Civil Engineering','value':'Civil Engineering'},{'title':'Commercial Real Estate','value':'Commercial Real Estate'},{'title':'Computer & Network Security','value':'Computer & Network Security'},{'title':'Computer Games','value':'Computer Games'},{'title':'Computer Hardware','value':'Computer Hardware'},{'title':'Computer Networking','value':'Computer Networking'},{'title':'Computer Software','value':'Computer Software'},{'title':'Construction','value':'Construction'},{'title':'Consumer Electronics','value':'Consumer Electronics'},{'title':'Consumer Goods','value':'Consumer Goods'},{'title':'Consumer Services','value':'Consumer Services'},{'title':'Cosmetics','value':'Cosmetics'},{'title':'Dairy','value':'Dairy'},{'title':'Defense & Space','value':'Defense & Space'},{'title':'Design','value':'Design'},{'title':'Education Management','value':'Education Management'},{'title':'E-Learning','value':'E-Learning'},{'title':'Electrical/Electronic Manufacturing','value':'Electrical/Electronic Manufacturing'},{'title':'Entertainment','value':'Entertainment'},{'title':'Environmental Services','value':'Environmental Services'},{'title':'Events Services','value':'Events Services'},{'title':'Executive Office','value':'Executive Office'},{'title':'Facilities Services','value':'Facilities Services'},{'title':'Farming','value':'Farming'},{'title':'Financial Services','value':'Financial Services'},{'title':'Fine Art','value':'Fine Art'},{'title':'Fishery','value':'Fishery'},{'title':'Food & Beverages','value':'Food & Beverages'},{'title':'Food Production','value':'Food Production'},{'title':'Fund-Raising','value':'Fund-Raising'},{'title':'Furniture','value':'Furniture'},{'title':'Gambling & Casinos','value':'Gambling & Casinos'},{'title':'Glass, Ceramics & Concrete','value':'Glass, Ceramics & Concrete'},{'title':'Government Administration','value':'Government Administration'},{'title':'Government Relations','value':'Government Relations'},{'title':'Graphic Design','value':'Graphic Design'},{'title':'Health, Wellness and Fitness','value':'Health, Wellness and Fitness'},{'title':'Higher Education','value':'Higher Education'},{'title':'Hospital & Health Care','value':'Hospital & Health Care'},{'title':'Hospitality','value':'Hospitality'},{'title':'Human Resources','value':'Human Resources'},{'title':'Import and Export','value':'Import and Export'},{'title':'Individual & Family Services','value':'Individual & Family Services'},{'title':'Industrial Automation','value':'Industrial Automation'},{'title':'Information Services','value':'Information Services'},{'title':'Information Technology and Services','value':'Information Technology and Services'},{'title':'Insurance','value':'Insurance'},{'title':'International Affairs','value':'International Affairs'},{'title':'International Trade and Development','value':'International Trade and Development'},{'title':'Internet','value':'Internet'},{'title':'Investment Banking','value':'Investment Banking'},{'title':'Investment Management','value':'Investment Management'},{'title':'Judiciary','value':'Judiciary'},{'title':'Law Enforcement','value':'Law Enforcement'},{'title':'Law Practice','value':'Law Practice'},{'title':'Legal Services','value':'Legal Services'},{'title':'Legislative Office','value':'Legislative Office'},{'title':'Leisure, Travel & Tourism','value':'Leisure, Travel & Tourism'},{'title':'Libraries','value':'Libraries'},{'title':'Logistics and Supply Chain','value':'Logistics and Supply Chain'},{'title':'Luxury Goods & Jewelry','value':'Luxury Goods & Jewelry'},{'title':'Machinery','value':'Machinery'},{'title':'Management Consulting','value':'Management Consulting'},{'title':'Maritime','value':'Maritime'},{'title':'Market Research','value':'Market Research'},{'title':'Marketing and Advertising','value':'Marketing and Advertising'},{'title':'Mechanical or Industrial Engineering','value':'Mechanical or Industrial Engineering'},{'title':'Media Production','value':'Media Production'},{'title':'Medical Devices','value':'Medical Devices'},{'title':'Medical Practice','value':'Medical Practice'},{'title':'Mental Health Care','value':'Mental Health Care'},{'title':'Military','value':'Military'},{'title':'Mining & Metals','value':'Mining & Metals'},{'title':'Motion Pictures and Film','value':'Motion Pictures and Film'},{'title':'Museums and Institutions','value':'Museums and Institutions'},{'title':'Music','value':'Music'},{'title':'Nanotechnology','value':'Nanotechnology'},{'title':'Newspapers','value':'Newspapers'},{'title':'Non-Profit Organization Management','value':'Non-Profit Organization Management'},{'title':'Oil & Energy','value':'Oil & Energy'},{'title':'Online Media','value':'Online Media'},{'title':'Outsourcing/Offshoring','value':'Outsourcing/Offshoring'},{'title':'Package/Freight Delivery','value':'Package/Freight Delivery'},{'title':'Packaging and Containers','value':'Packaging and Containers'},{'title':'Paper & Forest Products','value':'Paper & Forest Products'},{'title':'Performing Arts','value':'Performing Arts'},{'title':'Pharmaceuticals','value':'Pharmaceuticals'},{'title':'Philanthropy','value':'Philanthropy'},{'title':'Photography','value':'Photography'},{'title':'Plastics','value':'Plastics'},{'title':'Political Organization','value':'Political Organization'},{'title':'Primary/Secondary Education','value':'Primary/Secondary Education'},{'title':'Printing','value':'Printing'},{'title':'Professional Training & Coaching','value':'Professional Training & Coaching'},{'title':'Program Development','value':'Program Development'},{'title':'Public Policy','value':'Public Policy'},{'title':'Public Relations and Communications','value':'Public Relations and Communications'},{'title':'Public Safety','value':'Public Safety'},{'title':'Publishing','value':'Publishing'},{'title':'Railroad Manufacture','value':'Railroad Manufacture'},{'title':'Ranching','value':'Ranching'},{'title':'Real Estate','value':'Real Estate'},{'title':'Recreational Facilities and Services','value':'Recreational Facilities and Services'},{'title':'Religious Institutions','value':'Religious Institutions'},{'title':'Renewables & Environment','value':'Renewables & Environment'},{'title':'Research','value':'Research'},{'title':'Restaurants','value':'Restaurants'},{'title':'Retail','value':'Retail'},{'title':'Security and Investigations','value':'Security and Investigations'},{'title':'Semiconductors','value':'Semiconductors'},{'title':'Shipbuilding','value':'Shipbuilding'},{'title':'Sporting Goods','value':'Sporting Goods'},{'title':'Sports','value':'Sports'},{'title':'Staffing and Recruiting','value':'Staffing and Recruiting'},{'title':'Supermarkets','value':'Supermarkets'},{'title':'Telecommunications','value':'Telecommunications'},{'title':'Textiles','value':'Textiles'},{'title':'Think Tanks','value':'Think Tanks'},{'title':'Tobacco','value':'Tobacco'},{'title':'Translation and Localization','value':'Translation and Localization'},{'title':'Transportation/Trucking/Railroad','value':'Transportation/Trucking/Railroad'},{'title':'Utilities','value':'Utilities'},{'title':'Venture Capital & Private Equity','value':'Venture Capital & Private Equity'},{'title':'Veterinary','value':'Veterinary'},{'title':'Warehousing','value':'Warehousing'},{'title':'Wholesale','value':'Wholesale'},{'title':'Wine and Spirits','value':'Wine and Spirits'},{'title':'Wireless','value':'Wireless'},{'title':'Writing and Editing','value':'Writing and Editing'}];
    $scope.industriesFilter="";
    
    $scope.filterIndustries = function(){
      var ulElementsCount=0;
      $scope.industriesEdited=[];
      var tempIndustriesEdited=[];
      var filteredResults = $scope.industries.filter(
        function(o){
          return typeof(o.title.toLowerCase().split(/[\/, ]+/).find(function(item) {return item.startsWith($scope.industriesFilter.toLowerCase());})) !== "undefined"
        })
      angular.forEach(filteredResults, function (value, key) {
        ulElementsCount++;
        tempIndustriesEdited.push(value);
        if(ulElementsCount==Math.ceil(filteredResults.length/4)){ $scope.industriesEdited.push(tempIndustriesEdited); tempIndustriesEdited=[]; ulElementsCount=0;}
        if(filteredResults.length-1==filteredResults.indexOf(value)){ $scope.industriesEdited.push(tempIndustriesEdited); tempIndustriesEdited=[]; ulElementsCount=0;}
      });
    }

    $scope.filterIndustries();

    $scope.resume_template_options = [      
      {'title':'Intry','value':'default','image_url':'default.png', 'isSelected':true },
      {'title':'Student','value':'student','image_url':'student.png', 'isSelected':false },
      {'title':'Black Tie','value':'black_tie','image_url':'black-tie.png', 'isSelected':false },
      {'title':'Pairin','value':'pairin','image_url':'pairin.png', 'isSelected':false },
      {'title':'Traditional','value':'traditional','image_url':'traditional.png', 'isSelected':false },
      {'title':'Teal','value':'teal','image_url':'teal.png', 'isSelected':false },
      // {'title':'Traditional Sidebar','value':'traditional_sidebar','image_url':'traditional-sidebar.png', 'isSelected':false },
      {'title':'Tech Sidebar','value':'tech_sidebar','image_url':'tech-sidebar.png', 'isSelected':false },
      // {'title':'Two Tone Blues','value':'two_tone_blues','image_url':'two-tone-blues.png', 'isSelected':false }
      {'title':'Awards Circle','value':'awards_circle','image_url':'awards-circle.png', 'isSelected':false },
      {'title':'Teal Titles','value':'teal_titles','image_url':'teal-titles.png', 'isSelected':false },
      //{'title':'True You','value':'true_you','image_url':'true-you.png', 'isSelected':false },
      {'title':'Column Wind','value':'column_wind','image_url':'column-wind.png', 'isSelected':false },
      {'title':'Green Topper','value':'green_topper','image_url':'green-topper.png', 'isSelected':false },
    ];

    $scope.selectedTemplate = $scope.resume_template_options[0];

    $scope.setResumeTemplate = function(position){
      $scope.resume_template_options.map(function(obj){obj.isSelected = false; return obj;})
      $scope.resume_template_options[position].isSelected = true;
      $scope.selectedTemplate = $scope.resume_template_options[position];
    }

    $scope.getTemplatePageCount = function (template) {
      if ($scope.pageCount) {
        var found = $scope.pageCount.find(function (el) {
          return el[template];
        });
        if (found && found[template]) {
          return '(' + (found[template] + (found[template] > 1 ? ' pages' : ' page')) + ')';
        }
      }
    };

    $timeout(function() { 
      CKEDITOR.replace('walkthrough-about', {
        stylesSet: []
      });
    }, 500);

    resumeService.getResumePageCount().then(function(pageCount) {
      $scope.pageCount = pageCount.data.pageCount;
    });
  }
})();
(function () {
  'use strict';
  
  angular
    .module('intryFrontEnd')
    .controller('ResumeDeleteController', ResumeDeleteController);
  
  function ResumeDeleteController($scope, $state, resume) {
    $scope.resume = resume;
  }
})();
(function () {
	'use strict';

	angular
		.module('intryFrontEnd')
		.directive('uiSection', uiSection);

	/** @ngInject */
	function uiSection() {
		var directive = {
			restrict: 'E',
			templateUrl: 'app/resume-builder/directive/ui-section.html',
			scope: {
				vmp: '=',
				section: '='
			},
			controller: FooterController,
			controllerAs: 'vm',
			bindToController: true
		};

		return directive;

		/** @ngInject */
		function FooterController($scope) {
			var vm = this;
			$scope.vmp = this.vmp;

			vm.proficiencyNames = [
				"Elementary proficiency",
				"",
				"Limited working",
				"Professional working",
				"Full professional",
				"Native proficiency"
			]
		}
	}

})();
(function() {
  'use strict';

  angular
    .module('intryFrontEnd')
    .directive('resumeBuilderProfileButtons', resumeBuilderProfileButtons);

  function resumeBuilderProfileButtons() {
    var directive = {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/resume-builder/directive/resume-builder-profile-buttons.html',
      scope: {
        resumeEditor: '=',
        buttonClass: '@',
        isBottom: '@'
      },
      link: function (scope, element) {
        element.find('.js-submit-validation').on('click', scope.resumeEditor.setFocus);
      }
    };
    return directive;
  }

})();
(function() {
  'use strict';

  angular
    .module('intryFrontEnd')
    .directive('resizeResumePreview', resizeResumePreview);

  function resizeResumePreview($timeout) {
    var directive = {
      restrict: 'A',
      scope: {
        resumeTemplate: '=resizeResumePreview',
        isShow: '=',
        isTemplateLoaded: '='
      },
      link: function (scope, element) {

        function scalePreview() {
          var resumeContainer = $('.resume-container'),
            resumeTemplateWidth,
            resumeTemplateHeight,
            resumeContainerWidth,
            scale;

          $timeout(function () {
            if (!scope.isShow) {
              if (element.width() > 0) {
                element.data('width', element.width());
              }
              if (resumeContainer.height() > 0) {
                resumeContainer.data('height', resumeContainer.height());
              }
            } else {
              resumeTemplateWidth = element.width() > 0 ? element.width() : element.data('width') ? element.data('width') : 0;
              resumeContainerWidth = scope.resumeTemplate && scope.resumeTemplate.value === 'tech_sidebar' ? resumeContainer.width() + 10 : resumeContainer.width();
              scale = ((resumeTemplateWidth * 100) / resumeContainerWidth) / 100;

              if (scale > 0 && scale < 1) {
                resumeContainer.css('transform', 'scale(' + scale + ')');
                resumeTemplateHeight = resumeContainer.height() > 0 ? resumeContainer.height() : resumeContainer.data('height') ? resumeContainer.data('height') : 0;

                if (resumeTemplateHeight > 0) {
                  element.height(scale * resumeTemplateHeight);
                }
              }
            }
          }, 0);
        }

        scope.$watch('isShow', function () {
          scalePreview();
        });

        scope.$watch('isTemplateLoaded', function (isLoaded) {
          if (isLoaded) {
            scalePreview();
          }
        });

        $(window).resize(function () {
          if (scope.isShow) {
            scalePreview();
          }
        });

      }
    };
    return directive;
  }

})();
'use strict';
(function () {
    angular
        .module('intryFrontEnd')
        .controller('ResumeBuilderController', ResumeBuilderController);

    /** @ngInject */
    function ResumeBuilderController($scope, $stateParams, $timeout, organizationService, modalService, userService, resumeService, resume, user, $q, $http, $compile, $state, utilsService, constants, ngDialog, dragulaService, $translate, $parse, phoneFormatter, toastr, $rootScope, $location, assessmentsService, fixService) {
        console.log('jnjncjdncjdn',$stateParams)
        CKEDITOR.config.customConfig = '/media/ckeditor_config.js';
        // Date time format used by the time picker
        $scope.timePickerDateFormat = 'MMM d, y';
        $scope.loadingData = true;
        $scope.editResume = false;
        $scope.pageCount = 0;
        $scope.hidePageCount = false;
        $scope.editDatesValid = true;
        $scope.isPaused = user.disable_request_date !== undefined && user.disable_request_date !== null  && userService.isPausedPastBillingDate();
        userService.getAccount().then(function (account) {
            $scope.validSubscription = false;
            if (account && account.data && account.data.subscriptions) {
                $scope.validSubscription = user.userID && !user.disable_completed_date && account.data.subscriptions.total_count > 0;
            }
        });
        $scope.toolTip = $scope.isPaused ? "Account currently cancelled. You're not able to edit resumes at this time" : "Edit resume";
        $scope.resumeDownloading = false;
        $scope.noZoom = true;
        $scope.allPlans = [];
        $scope.skills = [];
        $scope.delExecuted = false; // Cheesy flag to keep from cascading deletes
        $scope.user = user; // for directive
        // When we render the date first time to the user
        // we use moment to format the date.
        $scope.momentDateFormat = 'MMM YYYY';
        $scope.currentlyDownloadingResume = false;

        //set this if resume not saved
        $scope.isResumeDirty = false;
        //Return to /resumes if resumeID is invalid
        if (angular.isUndefined(resume)) {
            $state.go('resumes');
            return;
        }
        $scope.resume = resume;

        if ($scope.resume && $scope.resume.resumeID) {
            resumeService.getResumePageCount($scope.resume.resumeID).then(function(pageCount) {
                $scope.pageCount = pageCount.data.pageCount;
            }).catch(function(err) {
                $scope.hidePageCount = true;
            });
        }
        var errorMessage = false;
        $scope.proficiencies = [1,2,3,4,5];

       

        var getSampleResume = function () {
            return {
                title: 'Veterinary assistant',
                about: 'Aenean justo urna, euismod id velit ut, commodo sagittis turpis. Aenean vel nibh condimentum, suscipit felis id, finibus purus. Proin est justo, iaculis id viverra et, porttitor ut urna. Cras quis fermentum nibh. Cras iaculis purus purus, id posuere diam elementum a. Vivamus id lorem ut urna scelerisque interdum. Maecenas dictum tristique sapien, in imperdiet ipsum sagittis vitae. Nullam ut sapien dui. Nullam tempor turpis eget dignissim elementum. Interdum et malesuada fames ac ante ipsum primis in faucibus. Etiam varius sed est nec ultrices. Suspendisse gravida porttitor justo.',
                contact: {
                    addresses: [{
                        street: '',
                        street2: '',
                        city: 'Highlands Ranch',
                        state: 'CO',
                        country: '',
                        postalCode: '',
                        kind: 'Home'
                    }],
                    emailAddresses: [{
                        address: 'email@company.com',
                        kind: 'Home'
                    }],
                    phoneNumbers: [{
                        number: '5555555555',
                        kind: 'Home'
                    }]
                },
                profile: {
                    experience: [{
                        company: 'US Army',
                        description: '1Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam eu iaculis nulla. Fusce id scelerisque felis. Maecenas imperdiet cursus justo quis consectetur. Sed et pulvinar dolor.',
                        summary: 'Sample summary',
                        isCurrent: true,
                        location: 'Location',
                        title: 'Infanctryman 11b',
                        startDate: 915148800000,
                        endDate: 0
                    }, {
                        company: 'Walmart',
                        description: '2Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam eu iaculis nulla. Fusce id scelerisque felis. Maecenas imperdiet cursus justo quis consectetur. Sed et pulvinar dolor.',
                        summary: 'Sample summary',
                        isCurrent: true,
                        location: 'Highlands Ranch, Colorado',
                        title: 'Leader Cashier',
                        startDate: 1420070400000,
                        endDate: 0
                    }],
                    education: [{
                        activities: 'Hockey',
                        degree: 'BA',
                        fieldOfStudy: 'Peace, War and Defense',
                        institution: 'United States Naval Academy',
                        notes: '4/4',
                        startDate: 915148800000,
                        endDate: 1041379200000
                    }],
                    skills: [{
                        skill: 'X-Ray Technician',
                        proficiency: 3
                    }, {
                        skill: 'Medical Coding',
                        proficiency: 3
                    }, {
                        skill: 'Accounting',
                        proficiency: 3
                    }],
                    achievement: '2Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam eu iaculis nulla. Fusce id scelerisque felis. Maecenas imperdiet cursus justo quis consectetur. Sed et pulvinar dolor.',
                    references: [{
                        name: 'Jane Doe',
                        relation: 'Manager',
                        email: 'JaneDoe@nowhere.com'
                    }, {
                        name: 'John Doe',
                        relation: 'Co-worker',
                        email: 'johndoe@nowhere.net'
                    }],          
                }
            };
        };
        var getResumePayloadProperty = function (property) {
            if ($scope.resume && $scope.resume.content) {
                return $scope.resume.content[property];
            }
            return undefined;
        };

        $scope.$watch('model', function (newValue, oldValue, scope) {
            
            if($scope.editResume) {
                $scope.isResumeDirty = true;
            }
        }, true);

        $scope.$watch('skills', function (newValue, oldValue, scope) {
            if($scope.editResume) {
                $scope.isResumeDirty = true;
            } 
        }, true);

        //  Check duplicates in skills
        function hasDuplicates(list) {
            list = _.filter(list, {deleted: false});
            _.each(list, function(value, key) {
                value.skill = value.skill.toLowerCase().trim();
            });
            return _.uniq(list, 'skill').length !== list.length; 
        }
        function emptySkills(list){
            var empty = false;
            _.each(list,function(element){
                if(!element.deleted){
                    element.skill = element.skill.replace(/&nbsp;/g," ").trim();
                    if(!element.skill.length)
                        empty = true;
                }
            });
            return empty;
        }

        $scope.saveResume = function () {
            if(!utilsService.hasDateError()){
                saveTheResume();
            }
        };
        $scope.continueToSaveResume = function() {
            if(!utilsService.hasDateError()){
                saveTheResume();
                ngDialog.close();
            }
        };
        $scope.toggleAts = function () {
            if ($scope.resume) {
                $scope.resume.usedExport = $scope.resume.usedExport === 'nonats' ? 'ats' : 'nonats';
            }
        };
        $scope.getAtsButtonLabel = function () {
            if ($scope.resume) {
                return $scope.resume.usedExport === 'nonats' ? 'Simple Export' : 'Full Export';
            }
            return undefined;
        };
        $scope.getPageCount = function () {
            return $scope.pageCount > 0 ? $scope.pageCount + ($scope.pageCount > 1 ? ' pages' : ' page') : 'Counting...';
        };

        function saveTheResume() {
            var aux=$scope.model;
            $scope.removeCkEditor();
            var isDuplicateSkills = hasDuplicates(angular.copy($scope.skills));
            var isEmptySkills = emptySkills(angular.copy($scope.skills));
            var isEmptyEmail = (typeof $scope.model.email_address === 'object' && typeof $scope.model.email_address.address === 'string' && $scope.model.email_address.address.length > 0) ? false : true;
            if (
                $scope.resume &&
                    $scope.resume.resumeID &&
                    $scope.editDatesValid &&
                    !isDuplicateSkills &&
                    !isEmptySkills &&
                    !isEmptyEmail
            ) {
                $scope.pageCount = 0;
                $scope.hidePageCount = false;
                resumeService.updateResume($scope.resume.resumeID, {
                    first_name: $scope.model.firstName,
                    last_name: $scope.model.lastName,
                    title: $scope.model.title,
                    about: $scope.model.about,
                    education: $scope.model.educations,
                    experience: $scope.model.experiences,
                    skills: $scope.skills,
                    address: $scope.model.address,
                    phone_number: $scope.model.phone_number,
                    email_address: $scope.model.email_address,
                    website: $scope.model.website,
                    achievement: $scope.model.achievement,
                    achievements_awards: $scope.resume.content.achievements_awards,
                    usedExport: $scope.resume.usedExport || 'ats',
                    industry: $scope.model.industry,
                    references: $scope.model.references
                }).then(function (response) {
                    var successString = 'You\'re data has been saved, but you\'ll need to wait a minute before downloading';
                    if (fixServiceFinalMsg.length > 0) successString = fixServiceFinalMsg;
                    buildSaveToastr(successString, 'Success', 2000);
                    resumeService.getResume(user.userID, $scope.resume.resumeID).then(function(resume) {
                        $scope.resume = resume;
                        $scope.model.experiences = $scope.resume.content.experience;
                        $scope.model.educations = $scope.resume.content.education;
                        $scope.model.references = $scope.resume.content.references;
                        $scope.skills = $scope.resume.content.skills;
                        $scope.isResumeDirty = false;
                        bindResumeTemplateData();
                        resumeService.getResumePageCount($scope.resume.resumeID).then(function(pageCount) {
                            $scope.pageCount = pageCount.data.pageCount;
                        }).catch(function(err) {
                            $scope.hidePageCount = true;
                        });
                    });
                    
                    $scope.editResume = false;
                    if (errorMessage) {
                        /*             $('.error-message-container').css('visibility', 'hidden');
                                       $('#errorMessage').html(''); */
                        errorMessage = false;
                    }
                }).catch(function (err) {
                    err.data.message = err.data.message.replace(/,/g, ", ");
                    err.data.message = err.data.message.replace(/"/g, "");
                    if (err.data.message.indexOf("pattern:") !== -1 && err.data.message.indexOf("number") !== -1) {
                        err.data.message = 'Please Enter a Valid Phone Number';
                    }
                    if (err.data.message.indexOf("pattern:") !== -1 && err.data.message.indexOf("postal_code") !== -1) {
                        err.data.message = 'Please Enter a Valid Postal Code';
                    }
                    showErrorMessage(err.data.message);
                });
            } else if(isDuplicateSkills) {
                showErrorMessage($translate.instant('RESUME_BUILDER_DUPLICATE_SKILL_ERROR'));
            } else if(isEmptySkills) {
                showErrorMessage($translate.instant('RESUME_BUILDER_EMPTY_SKILL_ERROR'));
            }  else if (isEmptyEmail) {
                showErrorMessage($translate.instant('USER_PROFILE_INVALID_EMAIL_PERSONAL'));
            }
        }
        
        $scope.addCkEditor = function(t) {
            for (var name in CKEDITOR.instances) {
                if (CKEDITOR.instances.hasOwnProperty(name)) {
                    $('#' + name).html(CKEDITOR.instances[name].getData());
                    CKEDITOR.instances[name].destroy(true);
                }
            }

            if(!CKEDITOR.instances[t]){
                var edt = CKEDITOR.replace(t, {
                    stylesSet: []
                });
                edt.on('instanceReady', 
                       function(evt) {
                           //Set the focus to your editor
                           var editor = CKEDITOR.instances[evt.sender.name];
                           editor.focus();
                           var range = editor.createRange();
                           range.moveToElementEditEnd( range.root );
                           editor.getSelection().selectRanges( [ range ] );

                       }      
                      );
                edt.on('blur', function(evt) { 
                    $scope.removeCkEditor();});

                edt.on( 'pluginsLoaded', function( evt ){
                    evt.editor.dataProcessor.dataFilter.addRules({
                        elements :{
                            br : function( element ) {			
                                //if next element is BR or <!--cke_br_comment-->, ignore it.
                                if( element && element.next && ( element.next.name === 'br' || element.next.value === 'cke_br_comment' ) ){

                                }else {
                                    var comment = new CKEDITOR.htmlParser.comment( 'cke_br_comment' );
                                    comment.insertAfter( element );	
                                }
                            }
                        }
                    });
                    
                    evt.editor.dataProcessor.htmlFilter.addRules({
                        comment : function( value, node ) {
                            if (value.indexOf('cke_br_comment') >= 0) {
                                return false;
                            }
                            return undefined;
                        }
                    });
                    
                });
            }
        };
        $scope.removeCkEditor = function() {
            for (var name in CKEDITOR.instances) {
                if (CKEDITOR.instances.hasOwnProperty(name)) {
                    var nameSelector = $('#' + name);
                    nameSelector.html(CKEDITOR.instances[name].getData());
                    var md = nameSelector.attr('ng-model');
                    var x = $parse(md);
                    if (x) {
                        x.assign($scope, CKEDITOR.instances[name].getData());
                    }
                    CKEDITOR.instances[name].destroy(true);
                }
            }
        };
        $scope.model = {};

        $scope.model.pictureURL = '';
        var profile_picture_url = getResumePayloadProperty("profile_picture_url");
        if (profile_picture_url) {
            $scope.model.pictureURL = profile_picture_url;
        }

        $scope.model.firstName = $scope.resume ? getResumePayloadProperty("first_name") : user.first_name;
        $scope.model.lastName = $scope.resume ? getResumePayloadProperty("last_name") : user.last_name;
        $scope.model.title = $scope.resume ? $scope.resume.title : getSampleResume().title;
        $scope.model.about =  $scope.resume ? getResumePayloadProperty("about") : getSampleResume().about;
        $scope.model.address = $scope.resume ? getResumePayloadProperty("address") : getSampleResume().contact.addresses;
        $scope.model.email_address = $scope.resume ? getResumePayloadProperty("email_address") : getSampleResume().contact.emailAddresses[0];
        $scope.model.phone_number = $scope.resume ? getResumePayloadProperty("phone_number") : getSampleResume().contact.phoneNumbers[0];
        $scope.model.website = $scope.resume ? getResumePayloadProperty("website") : '';
        $scope.model.experiences = $scope.resume ? getResumePayloadProperty("experience") : getSampleResume().profile.experience;
        $scope.model.educations = $scope.resume ? getResumePayloadProperty("education") : getSampleResume().profile.education;
        $scope.model.achievement = $scope.resume ? getResumePayloadProperty("achievement") : getSampleResume().profile.achievement;
        $scope.model.references = $scope.resume ? getResumePayloadProperty("references") : getSampleResume().profile.references;
        $scope.model.industry = $scope.resume.content.industry;

        var convertProficiencyToArray = function(index) {
            var skill = $scope.skills[index];
            skill.fullBullets = [];
            // passing index value in fullBullets and emptyBullets array, in place of empty value array
            var j=1;
            for (j; j <= skill.proficiency; j += 1) {
                skill.fullBullets.push(j);
            }
            skill.emptyBullets = [];
            if (j <= 5) {
                for (j; j <= 5; j += 1) {
                    skill.emptyBullets.push(j);
                }
            }
        };

        $scope.skills = $scope.resume ? getResumePayloadProperty("skills") : getSampleResume().profile.skills;
        orderSkills();

        function orderReferences() {
            if ($scope.model.references) {
                $scope.model.references = _.sortBy($scope.model.references, 'order_index');
                for (var i = 0; i < $scope.model.references.length; i += 1) {
                    var reference = $scope.model.references[i];
                    reference.index = i;
                    reference.order_index = reference.order_index !== undefined ? reference.order_index : i;
                }
            }
        }
        function orderExperiences() {
            if ($scope.model.experiences) {
                $scope.model.experiences = _.sortBy($scope.model.experiences, 'order_index');
                for (var i = 0; i < $scope.model.experiences.length; i += 1) {
                    var experience = $scope.model.experiences[i];
                    //experience.summary = experience.summary || experience.title;
                    if (experience.date_start && moment(experience.date_start).isValid()) {
                        experience.startDateObj = moment(experience.date_start, 'YYYY-MM-DD').format($scope.momentDateFormat);
                    }
                    if (experience.date_end && moment(experience.date_end).isValid()) {
                        experience.endDateObj = moment(experience.date_end, 'YYYY-MM-DD').format($scope.momentDateFormat);
                    }
                    experience.index = i;
                    experience.order_index = experience.order_index !== undefined ? experience.order_index : i;
                    experience.kind = (experience.kind) ? experience.kind : constants.default_employment_kind;
                    experience.isVolunteer = experience.kind && experience.kind === constants.volunteer;
                    experience.isMilitary = experience.kind && experience.kind === constants.military;
                }
            }
        }

        function orderEducations() {
            if ($scope.model.educations) {
                $scope.model.educations = _.sortBy($scope.model.educations, 'order_index');
                for (var i = 0; i < $scope.model.educations.length; i += 1) {
                    var education = $scope.model.educations[i];
                    if (education.date_start && moment(education.date_start).isValid()) {
                        education.startDateObj = moment(education.date_start, 'YYYY-MM-DD').format($scope.momentDateFormat);
                    }
                    if (education.date_end && moment(education.date_end).isValid()) {
                        education.endDateObj = moment(education.date_end, 'YYYY-MM-DD').format($scope.momentDateFormat);
                    }
                    education.index = i;
                    education.order_index = education.order_index !== undefined ? education.order_index : i;
                    education.isCertification = education.kind && education.kind === constants.certification;
                }
            }
        }

        function orderSkills() {
            if ($scope.skills) {
                $scope.skills = _.sortBy($scope.skills, 'order_index');
                var skillOrderIndex = 0;
                for (var i = 0; i < $scope.skills.length; i += 1) {
                    var skill = $scope.skills[i];
                    skill.index = i;
                    if (!skill.deleted) {
                        skill.order_index = skillOrderIndex;
                        skillOrderIndex += 1;
                    }
                    convertProficiencyToArray(i);
                }
            }
        }

        $scope.addNewEduction = function (kind) {
            kind = kind ? kind : constants.default_education_kind;
            $scope.model.educations = $scope.model.educations || [];

            var education = {};
            education.activities = '';
            education.degree = '';
            education.field_of_study = '';
            education.institution = '';
            education.notes = '';
            education.number = '';
            education.is_current = false;
            education.index = $scope.model.educations.length;
            education.order_index = educationFilter(kind).length;
            education.deleted = false;
            //generated temp_id to stop duplication
            education.temp_id = utilsService.guid();
            education.kind = kind;
            education.isCertification = education.kind === constants.certification;

            $scope.model.educations.push(education);
            bindResumeTemplateData();
            $scope.resumeEditable();
        };

        $scope.deleteEducation = function (index) {
            if (!$scope.model.educations[index] || $scope.delExecuted) {
                $scope.delExecuted = false;
                return;
            }

            $scope.delExecuted = true;
            if ($scope.model.educations[index]._id) {
                $scope.model.educations[index].deleted = true;
            } else {
                $scope.model.educations.splice(index, 1);
                // Change index of all items after that
                for (var i = index; i < $scope.model.educations.length; i += 1) {
                    $scope.model.educations[i].index = i;
                }
            }
            //Filter education according kind and update order_index on delete.
            var degreeEdu = educationFilter('degree');
            var courseEdu = educationFilter('course');
            var certificationEdu = educationFilter('certification');
            _.each(degreeEdu, function(education, key){
                education.order_index = key;
                _.each($scope.model.educations, function(main, key) {
                    if (!main.deleted && education.index === main.index) {
                        main = education;
                    }
                });
            });
            _.each(courseEdu, function(education, key){
                education.order_index = key;
                _.each($scope.model.educations, function(main, key) {
                    if (!main.deleted && education.index === main.index) {
                        main = education;
                    }
                });
            });
            _.each(certificationEdu, function(education, key){
                education.order_index = key;
                _.each($scope.model.educations, function(main, key) {
                    if(!main.deleted && education.index === main.index) {
                        main = education;
                    }
                });
            });
            bindResumeTemplateData();
            $scope.resumeEditable();
        };

        $scope.addNewExperience = function (kind) {
            kind = kind ? kind : constants.default_employment_kind;
            $scope.model.experiences = $scope.model.experiences || [];

            var experience = {};
            experience.company = '';
            //experience.description = '';
            experience.is_current = false;
            experience.title = '';
            experience.location = '';
            experience.summary = '';
            experience.index = $scope.model.experiences.length;
            experience.order_index = experienceFilter(kind).length;
            experience.deleted = false;
            experience.kind = kind;
            //generated temp_id to stop duplication
            experience.temp_id = utilsService.guid();
            experience.isVolunteer = experience.kind === constants.volunteer;
            experience.isMilitary = experience.kind === constants.military;

            $scope.model.experiences.push(experience);
            bindResumeTemplateData();
            $scope.resumeEditable();
        };

        function educationFilter(kind) {
            var filteredArray = [];
            switch (kind) {
            case 'degree' : {
                filteredArray = (_.filter($scope.model.educations, {kind : 'degree', deleted: false}));
                break;
            }
            case 'course' : {
                filteredArray = (_.filter($scope.model.educations, {kind : 'course', deleted: false}));
                break;
            }
            case 'certification' : {
                filteredArray = (_.filter($scope.model.educations, {kind : 'certification', deleted: false}));
                break;
            }
            }
            return filteredArray;
        }

        function experienceFilter(kind) {
            var filteredArray = [];
            switch (kind) {
            case 'Work' : {
                filteredArray = (_.filter($scope.model.experiences, {kind : 'Work', deleted: false}));
                break;
            }
            case 'Volunteer' : {
                filteredArray = (_.filter($scope.model.experiences, {kind : 'Volunteer', deleted: false}));
                break;
            }
            case 'Military' : {
                filteredArray = (_.filter($scope.model.experiences, {kind : 'Military', deleted: false}));
                break;
            }
            }
            return filteredArray;
        }

        $scope.deleteExperience = function (index) {
            
            if (!$scope.model.experiences[index]) {
                $scope.delExecuted = false;
                return;
            }
            $scope.delExecuted = true;
            if ($scope.model.experiences[index]._id) {
                $scope.model.experiences[index].deleted = true;
            } else {
                $scope.model.experiences.splice(index, 1);
                // Change index of all items after that
                for (var i = index; i < $scope.model.experiences.length; i += 1) {
                    $scope.model.experiences[i].index = i;
                }
            }
            //Filter experience according kind and update order_index on delete.
            var workEpx = experienceFilter('Work');
            var volunteerExp = experienceFilter('Volunteer');
            var militaryArray = experienceFilter('Military');
            _.each(workEpx, function(experience, key){
                experience.order_index = key;
                _.each($scope.model.experiences, function(main, key) {
                    if(!main.deleted && experience.index === main.index) {
                        main = experience;
                    }
                });
            });
            _.each(volunteerExp, function(experience, key){
                experience.order_index = key;
                _.each($scope.model.experiences, function(main, key) {
                    if(!main.deleted && experience.index === main.index) {
                        main = experience;
                    }
                });
            });
            _.each(militaryArray, function(experience, key){
                experience.order_index = key;
                _.each($scope.model.experiences, function(main, key) {
                    if(!main.deleted && experience.index === main.index) {
                        main = experience;
                    }
                });
            });
            bindResumeTemplateData();
            $scope.resumeEditable();
        };

        // Launch creating resume walkthrough
        if ($stateParams.new) {
            $scope.scrimPageBackground = true;
            modalService.openModal(
                'app/resume-walkthrough/template/resume-walkthrough.html',
                'ResumeWalkthroughController', {
                    user: function () {
                        return userService.getUser();
                    }
                }, {
                    width: '675px'
                }
            );
        } else {
            if ($stateParams.resumeId) {
                $scope.scrimPageBackground = false;
            } else {
                $state.go('resumes');
                return;
            }
        }
        //Update order_index on drop of element and update list.
        $scope.$on('education-bag.drop', function (e, target, source, sibling) {
            var filteredArray = educationFilter('degree');
            var educationUpdatedIndexArray = [];
            if(source.context) {
                angular.forEach(source.context.children, function (item, key) {
                    educationUpdatedIndexArray.push(item.id);
                });
                onDragDropEducationAction(educationUpdatedIndexArray, filteredArray);
            }
        });
        $scope.$on('reference-bag.drop', function (e, target, source, sibling) {
            var filteredArray = _.filter($scope.model.references, {deleted: false});
            var referenceUpdatedIndexArray = [];
            if(source.context) {
                angular.forEach(source.context.children, function (item, key) {
                    referenceUpdatedIndexArray.push(item.id);
                });
                onDragDropReferenceAction(referenceUpdatedIndexArray, filteredArray);
            }
        });

        $scope.$on('certification-bag.drop', function (e, target, source, sibling) {
            var filteredArray = educationFilter('certification');
            var educationUpdatedIndexArray = [];
            if(source.context) {
                angular.forEach(source.context.children, function (item, key) {
                    educationUpdatedIndexArray.push(item.id);
                });
                onDragDropEducationAction(educationUpdatedIndexArray, filteredArray);
            }
        });

        function onDragDropEducationAction(educationUpdatedIndexArray, filteredArray) {
            var updatedEducationArray = [];
            angular.forEach(educationUpdatedIndexArray, function (updatedIndex, key) {
                if(updatedIndex) {
                    updatedEducationArray[key] = filteredArray[parseInt(updatedIndex)];
                    updatedEducationArray[key].index = key;
                    updatedEducationArray[key].order_index = key;
                }
            });
            angular.forEach(updatedEducationArray, function(experience, key){
                filteredArray[key] = experience;
            });
            _.each(filteredArray, function(filtered, key){
                _.each($scope.model.educations, function(main, key) {
                    if(!main.deleted && filtered.index === main.index) {
                        main = filtered;
                    }
                });
            });
            bindResumeTemplateData();
            $scope.resumeEditable();
        }

        //Listen drop event and get updated order_index and update experience list according to updated order_index.
        $scope.$on('experience-bag.drop', function (e, target, source, sibling) {
            var filteredArray = experienceFilter('Work');
            var experienceUpdatedIndexArray = [];
            if(source.context) {
                angular.forEach(source.context.children, function (item, key) {
                    experienceUpdatedIndexArray.push(item.id);
                });
                onDragDropAction(experienceUpdatedIndexArray, filteredArray);
            }
        });
        //Listen drop event and get updated order_index and update experience list according to updated order_index.
        $scope.$on('involvement-bag.drop', function (e, target, source, sibling) {
            var filteredArray = experienceFilter('Volunteer');
            var experienceUpdatedIndexArray = [];
            if(source.context) {
                angular.forEach(source.context.children, function (item, key) {
                    experienceUpdatedIndexArray.push(item.id);
                });
                onDragDropAction(experienceUpdatedIndexArray, filteredArray);
            }
        });
        //Listen drop event and get updated order_index and update experience list according to updated order_index.
        $scope.$on('military-bag.drop', function (e, target, source, sibling) {
            var filteredArray = experienceFilter('Military');
            var experienceUpdatedIndexArray = [];
            if(source.context) {
                angular.forEach(source.context.children, function (item, key) {
                    experienceUpdatedIndexArray.push(item.id);
                });
                onDragDropAction(experienceUpdatedIndexArray, filteredArray);
            }
        });

        $scope.$on('skills-bag.drop', function (e, target, source, sibling) {
            //Get update index of skills and update skills according to updated order_index.
            var filteredArray = _.filter($scope.skills, {deleted: false});
            var skillsUpdatedIndexArray = [];
            if(source.context) {
                angular.forEach(source.context.children, function (item, key) {
                    skillsUpdatedIndexArray.push(item.id);
                });
                var updatedSkillsArray = [];
                angular.forEach(skillsUpdatedIndexArray, function (updatedIndex, key) {
                    if(updatedIndex) {
                        updatedSkillsArray[key] = filteredArray[parseInt(updatedIndex)];
                        updatedSkillsArray[key].index = key;
                        updatedSkillsArray[key].order_index = key;
                    }
                });
                angular.forEach(updatedSkillsArray, function(skill, key){
                    filteredArray[key] = skill;
                });
                _.each(filteredArray, function(filtered, key) {
                    _.each($scope.skills, function(main, key) {
                        if(!main.deleted && filtered.index === main.index) {
                            main = filtered;
                        }
                    });
                });
                $scope.skills = _.sortBy($scope.skills,"order_index");
                bindResumeTemplateData();
                $scope.resumeEditable();
            }
        });

        function onDragDropAction(experienceUpdatedIndexArray, filteredArray) {
            var updatedExperienceArray = [];
            angular.forEach(experienceUpdatedIndexArray, function (updatedIndex, key) {
                if(updatedIndex) {
                    updatedExperienceArray[key] = filteredArray[parseInt(updatedIndex)];
                    updatedExperienceArray[key].index = key;
                    updatedExperienceArray[key].order_index = key;
                }
            });
            angular.forEach(updatedExperienceArray, function(experience, key){
                filteredArray[key] = experience;
            });
            _.each(filteredArray, function(filtered, key){
                _.each($scope.model.experiences, function(main, key) {
                    if(!main.deleted && filtered.index === main.index) {
                        main = filtered;
                    }
                });
            });
            bindResumeTemplateData();
            $scope.resumeEditable();
        }

        // Drag handle on dots clicks
        dragulaService.options($scope, 'experience-bag', {
            removeOnSpill: false,
            moves: function (el, container, target) {
                if(!target.classList.contains('cke_toolbar') && !target.classList.contains('cke_button_icon'))
                    $scope.removeCkEditor();

                if (target.classList) {
                    return target.classList.contains('experience-bag-draggable');
                }
                return false;
            }
        });
        dragulaService.options($scope, 'education-bag', {
            removeOnSpill: false,
            moves: function (el, container, target) {
                if(!target.classList.contains('cke_toolbar') && !target.classList.contains('cke_button_icon'))
                    $scope.removeCkEditor();

                if (target.classList) {
                    return target.classList.contains('education-bag-draggable');
                }
                return false;
            }
        });
        dragulaService.options($scope, 'reference-bag', {
            removeOnSpill: false,
            moves: function (el, container, target) {
                if(!target.classList.contains('cke_toolbar') && !target.classList.contains('cke_button_icon'))
                    $scope.removeCkEditor();

                if (target.classList) {
                    return target.classList.contains('reference-bag-draggable');
                }
                return false;
            }
        });    
        dragulaService.options($scope, 'involvement-bag', {
            removeOnSpill: false,
            moves: function (el, container, target) {
                if(!target.classList.contains('cke_toolbar') && !target.classList.contains('cke_button_icon'))
                    $scope.removeCkEditor();

                if (target.classList) {
                    return target.classList.contains('involvement-bag-draggable');
                }
                return false;
            }
        });
        dragulaService.options($scope, 'military-bag', {
            removeOnSpill: false,
            moves: function (el, container, target) {
                if(!target.classList.contains('cke_toolbar') && !target.classList.contains('cke_button_icon'))
                    $scope.removeCkEditor();

                if (target.classList) {
                    return target.classList.contains('military-bag-draggable');
                }
                return false;
            }
        });
        dragulaService.options($scope, 'certification-bag', {
            removeOnSpill: false,
            moves: function (el, container, target) {
                if(!target.classList.contains('cke_toolbar') && !target.classList.contains('cke_button_icon'))
                    $scope.removeCkEditor();

                if (target.classList) {
                    return target.classList.contains('certification-bag-draggable');
                }
                return false;
            }
        });
        dragulaService.options($scope, 'skills-bag', {
            removeOnSpill: false,
            moves: function (el, container, target) {
                if(!target.classList.contains('cke_toolbar')  && !target.classList.contains('cke_button_icon'))
                    $scope.removeCkEditor();

                if (target.classList) {
                    return target.classList.contains('skills-bag-draggable');
                }
                return false;
            }
        });    

        if (
            $scope.resume &&
                $scope.resume.meta &&
                $scope.resume.meta.export &&
                (
                    $scope.resume.meta.export.ats ||
                        $scope.resume.meta.export.nonats
                )
        ) {
            if ($scope.resume.usedExport) {
                $scope.downloadResumeLink = $scope.resume.meta.export[$scope.resume.usedExport];
            } else {
                $scope.downloadResumeLink = $scope.resume.meta.export.ats;
            }
        }

        var layout = $scope.resume ? getResumePayloadProperty("resume_layout") : 'default';
        $scope.apiCssUrl = constants.apiCssUrl + layout + '.css'; 
        var fileLocation = constants.resumeBucketUrl+layout+'.ejs';
        // Leave for local testing
        //var fileLocation = 'http://localhost:3000/templates/'+layout+'.ejs';
        
        $http.get(fileLocation).then(function(template) {
            $scope.templateData = template.data;
        });

        $scope.$watch('templateData', function (newVal, oldVal) {
            $timeout(function() { bindResumeTemplateData(); setRadarChart('assessment-radar-canvas', $scope.assessmentData.mainTypes);}, 2000);
        }, true);

        var objectToStylesString = function (object) {
            var string = '';
            Object.keys(object).forEach(function (key) {
                string += key + ':' + object[key] + '; '
            });
            return string;
        };
        var buildAssessmentData = function() {
            if($scope.assessmentData && $scope.assessmentData.types) {
                return $scope.assessmentData.types.map(function(a){
                    a.styles = 'style="' + objectToStylesString(getTypeBarStyle(a)) + '"';
                    return a;
                });
            }
            return {};
        };
        var bindResumeTemplateData = function () {
            orderReferences();
            orderExperiences();
            orderEducations();
            orderSkills();
            if( $scope.model.phone_number)
                $scope.model.phone_number.number = phoneFormatter.format($scope.model.phone_number.number);
            if ($scope.templateData) {
                var contactInfo = {
                    address: $scope.model.address,
                    phone: $scope.model.phone_number ? $scope.model.phone_number.number : '',
                    about: $scope.model.about,
                    email: $scope.model.email_address ? $scope.model.email_address.address : '',
                    website: $scope.model.website ? $scope.model.website : ''
                };
                user.title = $scope.model.title;
                $scope.user = angular.copy(user);
                $scope.user.first_name = $scope.model.firstName;
                $scope.user.last_name = $scope.model.lastName;

                // Seems the date_ values don't get update on a save???
                $.each($scope.model.experiences, function(n, v){
                    v.endDateObj = (v.endDateObj && v.endDateObj !== 'Present') ? utilsService.formatDate(v.endDateObj) : 'Present';
                    v.startDateObj = (v.startDateObj && v.startDateObj !== '') ? utilsService.formatDate(v.startDateObj) : '';
                });

                $.each($scope.model.educations, function(n, v){
                    v.endDateObj = (v.endDateObj && v.endDateObj !== 'Present') ? utilsService.formatDate(v.endDateObj) : 'Present';
                    v.startDateObj = (v.startDateObj && v.startDateObj !== '') ? utilsService.formatDate(v.startDateObj) : '';
                });        

                if(localStorage.getItem("toSubscriptionFrom") && localStorage.getItem("toSubscriptionFrom") === "subscription"){
                    localStorage.setItem("toSubscriptionFrom", "");
                    continueDownload();
                }

                $('.preview-resume-container').html(Mustache.render($scope.templateData, {
                    user:  $scope.user,
                    education: $scope.model.educations,
                    experience: $scope.model.experiences,
                    hasExperience: !!$scope.model.experiences,
                    hasEducation: true,
                    contactInfo: contactInfo,
                    skills: $scope.skills,
                    hasSkills: $scope.skills != null,
                    hasUserAvatar: !!$scope.model.pictureURL,          
                    pictureURL: (typeof $scope.model.pictureURL === 'string') ? $scope.model.pictureURL : '',
                    nameInitials: utilsService.getNameInitials($scope.user.first_name, $scope.user.last_name),
                    firstInitial: $scope.user.first_name.substring(0,1),
                    lastInitial: $scope.user.last_name.substring(0,1),
                    hasMilitaryExperience: true,
                    hasCertificationEducation: true,
                    hasAchievement: true,
                    achievement: $scope.model.achievement,
                    hasState: true,
                    hasCity: true,
                    hasCityOrState: true,
                    hasPhone: true,
                    hasEmail: true,
                    hasWebsite: true,
                    hasContactInfo: true,
                    hasStudyOrDegree: true,
                    hasReferences: true,
                    hasAssessment: true,
                    references: $scope.model.references,
                    assessmentData: buildAssessmentData(),
                    showDatesDash: function () {
                        return function (text, render) {
                            return (render('{{{startDateObj}}}').length > 0 && render('{{{endDateObj}}}').length > 0) ? '-' : '';
                        };
                    },
                    showDegreeDash: function () {
                        return function (text, render) {
                            if (render('{{{field_of_study}}}').length > 0) return '-';
                            else return '';
                        };
                    },
                    showFieldOfStudy: function () {
                        return function (text, render) {
                            if (render('{{{field_of_study}}}').length > 0) return '';
                            else return 'display: none;';
                        };
                    }
                }));
                $scope.loadingData = false;
            }
        };
        $scope.resumeEditable = function() {
            appendAttributes();
        };

        $scope.deleteReference = function (index) {
            if (!$scope.model.references[index] || $scope.delExecuted) {
                $scope.delExecuted = false;
                return;
            }
            $scope.delExecuted = true;
            for (var i = 0; i < $scope.model.references.length; i += 1) {
                var reference = $scope.model.references[i];
                if (reference.index === index){
                    if (reference && reference._id) {
                        reference.deleted = true;
                    } else {
                        $scope.model.references.splice(i, 1);
                    }
                }
            }
            for (var j = 0; j < $scope.model.references.length; j += 1) {
                $scope.model.references[j].index = j;
            }
            $scope.model.references = _.sortBy($scope.model.references,"order_index");
            bindResumeTemplateData();
            $scope.resumeEditable();
        };

        $scope.addNewReference = function () {
            $scope.model.references = $scope.model.references || [];
            
            var reference = {};
            reference.name = '';
            reference.relation = '';
            reference.index = $scope.model.references.length;
            reference.order_index = _.filter($scope.model.references, {deleted: false}).length;
            reference.deleted = false;
            $scope.model.references.push(reference);
            bindResumeTemplateData();
            $scope.resumeEditable();
        };

        $scope.addNewSkills = function () {
            $scope.skills = $scope.skills || [];
            
            var skill = {};
            skill.skill = '';
            skill.proficiency = parseInt(constants.default_proficiency);
            skill.index = $scope.skills.length;
            skill.order_index = _.filter($scope.skills, {deleted: false}).length;
            skill.deleted = false;
            $scope.skills.push(skill);
            convertProficiencyToArray(skill.index);
            bindResumeTemplateData();
            $scope.resumeEditable();
            $compile($('#updateProficiency_' + skill.index + '_' + skill.proficiency).attr('ng-focus', 'removeCkEditor()').addClass('selected-skill'))($scope);
        };
        
        $scope.deleteSkill = function (index) {

            if (!$scope.skills[index] || $scope.delExecuted) {
                $scope.delExecuted = false;
                return;
            }
            $scope.delExecuted = true;
            for (var i = 0; i < $scope.skills.length; i += 1) {
                var skill = $scope.skills[i];
                if (skill.index === index){
                    if (skill && skill._id) {
                        skill.deleted = true;
                    } else {
                        $scope.skills.splice(i, 1);
                    }
                }
            }
            for (var j = 0; j < $scope.skills.length; j += 1) {
                $scope.skills[j].index = j;
            }
            $scope.skills = _.sortBy($scope.skills,"order_index");
            bindResumeTemplateData();
            $scope.resumeEditable();
        };
        
        $scope.updateSkillProficiency = function(index, value) {
            var previousSkillProficiency = $scope.skills[index].proficiency;
            $scope.skills[index].proficiency = value;
            convertProficiencyToArray(index);
        };

        $scope.resumeEditingEnabled = function () {
            if(!$scope.isPaused){

                $('*').css('cursor','wait');
                setTimeout(function() { // Need this so the cursor has time to set
                    $scope.modelCopy = angular.copy($scope.model);
                    $scope.skillsCopy = angular.copy($scope.skills);
                    $scope.resumeEditable();
                    $('*').css('cursor','');
                }, 100);
            }

        };
        $scope.cancelResumeEditing = function() {
            $scope.removeCkEditor();
            $scope.model = angular.copy($scope.modelCopy);
            $scope.skills = angular.copy($scope.skillsCopy);
            $scope.editResume = false;
            $scope.isResumeDirty = false;
            bindResumeTemplateData();
        };

        var appendAttributes = function () {
            $compile($('#firstName').attr('ng-model', 'model.firstName').attr('contenteditable', true).attr('ng-focus', 'removeCkEditor()'))($scope);
            $compile($('#lastName').attr('ng-model', 'model.lastName').attr('contenteditable', true).attr('ng-focus', 'removeCkEditor()'))($scope);
            $compile($('#title').attr('ng-model', 'model.title').attr('contenteditable', true).attr('ng-focus', 'removeCkEditor()'))($scope);
            $compile($('#street').attr('ng-model', 'model.address.street').attr('contenteditable', true).attr('ng-focus', 'removeCkEditor()'))($scope);
            $compile($('#street2').attr('ng-model', 'model.address.street_2').attr('contenteditable', true).attr('ng-focus', 'removeCkEditor()'))($scope);
            $compile($('#city').attr('ng-model', 'model.address.city').attr('contenteditable', true).attr('ng-focus', 'removeCkEditor()'))($scope);
            $compile($('#state').attr('ng-model', 'model.address.state').attr('contenteditable', true).attr('ng-focus', 'removeCkEditor()'))($scope);
            $compile($('#country').attr('ng-model', 'model.address.country').attr('contenteditable', true).attr('ng-focus', 'removeCkEditor()'))($scope);
            $compile($('#postalCode').attr('ng-model', 'model.address.postal_code').attr('contenteditable', true).attr('ng-focus', 'removeCkEditor()'))($scope);
            $compile($('#email').attr('ng-model', 'model.email_address.address').attr('contenteditable', true).attr('ng-focus', 'removeCkEditor()'))($scope);
            $compile($('#phone').attr('ng-model', 'model.phone_number.number').attr('contenteditable', true).attr('ng-focus', 'removeCkEditor()'))($scope);
            $compile($('#about').attr('ng-model', 'model.about').attr('ng-click', 'addCkEditor("about")').attr('ckEditor', ''))($scope);
            $compile($('#website').attr('ng-model', 'model.website').attr('contenteditable', true).attr('ng-focus', 'removeCkEditor()'))($scope);
            if (
                $scope.skills &&
                    (
                        layout === 'black_tie' ||
                            layout === 'tech_sidebar' ||
                            layout === 'traditional_sidebar' ||
                            layout === 'two_tone_blues' ||
                            layout === 'student' ||
                            layout === 'pairin' ||
                            layout === 'awards_circle' ||
                            layout === 'teal_titles'
                    )
            ) {
                $compile($('#achievement').attr('ng-model', 'model.achievement').attr('ng-click', 'addCkEditor("achievement")').attr('ckEditor', ''))($scope);
            }


            if ($scope.model && $scope.model.experiences) {
                for (var i = 0; i < $scope.model.experiences.length; i += 1) {
                    var experienceIndexName = 'model.experiences[' + i + '].';
                    $compile($('#title_' + i).attr('ng-model', experienceIndexName + 'title').attr('contenteditable', true).attr('ng-focus', 'removeCkEditor()'))($scope);
                    $compile($('#summary_' + i).attr('ng-model', experienceIndexName + 'summary').attr('ng-click', 'addCkEditor("summary_' + i + '")').attr('ckEditor', ''))($scope);
                    $compile($('#company_' + i).attr('ng-model', experienceIndexName + 'company').attr('contenteditable', true).attr('ng-focus', 'removeCkEditor()'))($scope);
                    $compile($('#location_' + i).attr('ng-model', experienceIndexName + 'location').attr('contenteditable', true).attr('ng-focus', 'removeCkEditor()'))($scope);
                    $compile($('#description_' + i).attr('ng-model', experienceIndexName + 'summary').attr('ng-click', 'addCkEditor("description_' + i + '")').attr('ckEditor', ''))($scope);
                    $compile($('#deleteExperience_' + i).attr('ng-click', 'deleteExperience(' + i + ')').css('display', 'inline-block').attr('ng-focus', 'removeCkEditor()'))($scope);      
                    $compile($('#experienceStartDate_' + i).html("<input dateeditable ondrop='event.dataTransfer.dropEffect='none';event.stopPropagation(); event.preventDefault();' type='text' class='subtitle' data-control-type='date' placeholder='Start Date' ng-model='model.experiences[" + i + "].startDateObj' date-set='' contenteditable='true' ng-blur='validateDate(model.experiences[" + i + "].startDateObj, " + "\"experienceStartDate_" + i + "\")' title='Format: MMM YYYY Ex: Jan 1999' ng-focus='removeCkEditor()'  />"))($scope);
                    $compile($('#experienceEndDate_' + i).html("<input dateeditable ondrop='event.dataTransfer.dropEffect='none';event.stopPropagation(); event.preventDefault();' type='text' class='subtitle' data-control-type='date' placeholder='End Date' ng-model='model.experiences[" + i + "].endDateObj' date-set='' contenteditable='true' ng-blur='validateDate(model.experiences[" + i + "].endDateObj, " + "\"experienceEndDate_" + i + "\")' title='Format: MMM YYYY Ex: Jan 1999' ng-focus='removeCkEditor()' />"))($scope);        
                    $('#drag_exp_' + i).attr('ng-click', 'removeCkEditor()').css('display', 'inline-block');       
                }
            }
            if ($scope.model && $scope.model.educations) {
                for (var i = 0; i < $scope.model.educations.length; i += 1) {
                    var arrayIndexName = 'model.educations[' + i + '].';
                    $compile($('#institution_' + i).attr('ng-model', arrayIndexName + 'institution').attr('contenteditable', true).attr('ng-focus', 'removeCkEditor()'))($scope);
                    $compile($('#degree_' + i).attr('ng-model', arrayIndexName + 'degree').attr('contenteditable', true).attr('ng-focus', 'removeCkEditor()'))($scope);
                    $compile($('#fieldOfStudy_' + i).attr('ng-model', arrayIndexName + 'field_of_study').attr('contenteditable', true).attr('ng-focus', 'removeCkEditor()'))($scope);
                    $compile($('#notes_' + i).attr('ng-model', arrayIndexName + 'notes').attr('ng-click', 'addCkEditor("notes_' + i + '")').attr('ckEditor', ''))($scope);
                    $compile($('#deleteEducation_' + i).attr('ng-click', 'deleteEducation(' + i + ')').css('display', 'inline-block').attr('ng-focus', 'removeCkEditor()'))($scope);          
                    $compile($('#educationStartDate_' + i).html("<input dateeditable ondrop='event.dataTransfer.dropEffect='none';event.stopPropagation(); event.preventDefault();' type='text' data-control-type='date' placeholder='Start Date' class='subtitle' date-set='' ng-model='model.educations[" + i + "].startDateObj' style='width: auto;' contenteditable='true' ng-blur='validateDate(model.educations[" + i + "].startDateObj, " + "\"educationStartDate_" + i + "\")' title='Format: MMM YYYY Ex: Jan 1999' ng-focus='removeCkEditor()' />"))($scope);
                    $compile($('#educationEndDate_' + i).html("<input dateeditable ondrop='event.dataTransfer.dropEffect='none';event.stopPropagation(); event.preventDefault();' type='text' data-control-type='date' placeholder='End Date' class='subtitle' date-set='' ng-model='model.educations[" + i + "].endDateObj' style='width: auto;' contenteditable='true' ng-blur='validateDate(model.educations[" + i + "].endDateObj, " + "\"educationEndDate_" + i + "\")' title='Format: MMM YYYY Ex: Jan 1999' ng-focus='removeCkEditor()' />"))($scope);
                    $('#drag_edu_' + i).attr('ng-click', 'removeCkEditor()').css('display', 'inline-block');    
                }
            }
            if ($scope.model && $scope.model.references) {
                for (var i = 0; i < $scope.model.references.length; i += 1) {
                    var referencesIndexName = 'model.references[' + i + '].';
                    $compile($('#name_' + i).attr('ng-model', referencesIndexName + 'name').attr('contenteditable', true).attr('ng-focus', 'removeCkEditor()'))($scope);
                    $compile($('#relation_' + i).attr('ng-model', referencesIndexName + 'relation').attr('contenteditable', true).attr('ng-focus', 'removeCkEditor()'))($scope);
                    $compile($('#email_' + i).attr('ng-model', referencesIndexName + 'email').attr('contenteditable', true).attr('ng-focus', 'removeCkEditor()'))($scope);
                    $compile($('#deleteReference_' + i).attr('ng-click', 'deleteReference(' + i + ')').css('display', 'inline-block').attr('ng-focus', 'removeCkEditor()'))($scope);                
                    $('#drag_ref_' + i).attr('ng-click', 'removeCkEditor()').css('display', 'inline-block');       
                }
            }      
            $compile($('#addNewReference').attr('ng-click', 'addNewReference()').css('display', 'inline-block').attr('ng-focus', 'removeCkEditor()'))($scope);
            $compile($('#addNewEducation').attr('ng-click', 'addNewEduction()').css('display', 'inline-block').attr('ng-focus', 'removeCkEditor()'))($scope);
            $compile($('#addNewCertificationEducation').attr('ng-click', "addNewEduction('"+constants.certification+"')").css('display', 'inline-block').attr('ng-focus', 'removeCkEditor()'))($scope);
            $compile($('#addNewExperience').attr('ng-click', 'addNewExperience()').css('display', 'inline-block').attr('ng-focus', 'removeCkEditor()').attr('ng-focus', 'removeCkEditor()'))($scope);
            $compile($('#addNewVolunteerExperience').attr('ng-click', "addNewExperience('" +constants.volunteer+"')").css('display', 'inline-block').attr('ng-focus', 'removeCkEditor()'))($scope);
            $compile($('#addNewMilitaryExperience').attr('ng-click', "addNewExperience('" +constants.military+"')").css('display', 'inline-block').attr('ng-focus', 'removeCkEditor()'))($scope);

            if ($scope.skills) {
                for (var i = 0; i < $scope.skills.length; i += 1) {
                    var skillIndexName = 'skills[' + i + '].';
                    if(layout === 'student' || layout === 'default' || layout === 'black_tie' || layout === 'traditional'){
                        var skillSelector = $('#skillProficiency_' + i);
                        $compile(skillSelector.removeClass('bullet-' + skillIndexName.proficiency))($scope);
                        $compile(skillSelector.attr('ng-click', 'removeCkEditor()').attr('ng-class','{"bullet-1": skills[' + i + '].proficiency == 1, "bullet-2": skills[' + i + '].proficiency == 2, "bullet-3": skills[' + i + '].proficiency == 3, "bullet-4": skills[' + i + '].proficiency == 4, "bullet-5": skills[' + i + '].proficiency == 5}'))($scope);
                    }

                    $compile($('#skill_' + i).attr('ng-model', skillIndexName + 'skill').attr('ng-focus', 'removeCkEditor()').attr('contenteditable', true).addClass('skill-name'))($scope);
                    for (var j = 1; j <=5; j += 1) {
                        var updateProficiencySelector = $('#updateProficiency_' + i + '_' + j);
                        $compile(updateProficiencySelector.attr('ng-focus', 'removeCkEditor()').attr('ng-click', 'updateSkillProficiency(' + i + ', ' + j + ')'))($scope);
                        if(layout === 'pairin' || 
                           layout === 'teal' || 
                           layout === 'tech_sidebar' || 
                           layout === 'two_tone_blues' || 
                           layout === 'awards_circle' || 
                           layout === 'teal_titles' ||
                           layout === 'column_wind' ||
                           layout === 'green_topper'){
                            $compile(updateProficiencySelector.removeClass('full'))($scope);
                            $compile(updateProficiencySelector.attr('ng-focus', 'removeCkEditor()').attr('ng-class', '{"full": skills[' + i + '].proficiency >= '+ j+ '}'))($scope);
                        } else {
                            $compile(updateProficiencySelector.attr('ng-class', '{"selected-skill": skills[' + i + '].proficiency == '+ j+ '}'))($scope);
                        }
                    }

                    if (layout === 'black_tie' || layout === 'traditional_sidebar' || layout === 'pairin') {
                        $compile($('#skillContainer_' + i).attr('ng-focus', 'removeCkEditor()').addClass('skill-editable'))($scope);
                    }
                    else{
                        $compile($('#skillProficiency_' + i).attr('ng-focus', 'removeCkEditor()').addClass('skill-tooltip'))($scope);
                        $compile($('#skillContainer_' + i).attr('ng-focus', 'removeCkEditor()').addClass('skill-editable'))($scope);
                    }

                    $compile($('#deleteSkill_' + i).attr('ng-click', 'deleteSkill(' + i + ')').attr('ng-focus', 'removeCkEditor()').css('display', 'inline-block'))($scope);
                    $('#drag_skills_' + i).attr('ng-click', 'removeCkEditor()').css('display', 'inline-block');
                }
            }

            $compile($('#education_table'))($scope);
            $compile($('#certification_table'))($scope);
            $compile($('#experience_table'))($scope);
            $compile($('#involvement_table'))($scope);
            $compile($('#military_table'))($scope);
            $compile($('#reference_table'))($scope);
            $compile($('#skill_list'))($scope);
            $compile($('#addNewSkill').attr('ng-focus', 'removeCkEditor()').attr('ng-click', 'addNewSkills()').css('display', 'inline-block'))($scope);

            if ($scope.skills && (layout === 'black_tie' || layout === 'traditional_sidebar' || layout === 'pairin')) {
                for (var i = 0; i < $scope.skills.length; i += 1) {
                    $compile($('#skillProficiency_' + i).html('<select ng-model="skills[' + i + '].proficiency" class="skill-proficiency" id="skill_select'+ i +'" ng-options="x for x in proficiencies"></select>').attr('ng-focus', 'removeCkEditor()'))($scope);
                }
            }
            $scope.loadingData = false;
            $scope.editResume = true;
        };

        $scope.downloadResume = function ($event) {
            if($scope.isResumeDirty) {
                showConfirmSaveDialog();
            } else {
                $event.preventDefault();
                continueDownload();
            }
        };

        // function checkHeightValid() {
        //     if ($('.intry-resume').height() > $('.body').height()){
        //         return false;
        //     }
        //     return true;
        // }
        // 
        // function showResumeDownloadValidation() {
        //     var self = this;
        //     var dialog = {
        //         template: 'app/resume-builder/template/resume-download-validation-dialog.html',
        //         controller: this,
        //         closeByDocument: false,
        //         closeByEscape: true,
        //         showClose: false,
        //         closeByNavigation: true,
        //         scope: $scope,
        //         width: '350px',
        //         height: '160px'
        //     };
        //     ngDialog.openConfirm(dialog);
        // }
        // 
        // function showResumeSaveValidation() {
        //     var self = this;
        //     var dialog = {
        //         template: 'app/resume-builder/template/resume-save-validation-dialog.html',
        //         controller: this,
        //         closeByDocument: false,
        //         closeByEscape: true,
        //         showClose: false,
        //         closeByNavigation: true,
        //         scope: $scope,
        //         width: '350px',
        //         height: '160px'
        //     };
        //     ngDialog.openConfirm(dialog);
        // }

        function continueDownload() {
            $scope.currentlyDownloadingResume = false;
            $scope.downloadAvailable = false;
            $scope.resumeDownloading = true;
            showWaitingDialog();
            var rlink = $scope.downloadResumeLink.substring($scope.downloadResumeLink.lastIndexOf('/') + 1);
            var rtype = $scope.resume.usedExport || 'ats';
            resumeService.downloadResume(rlink, rtype, JSON.stringify($scope.assessmentData)).then(function () {
                var loaderContainer  = angular.element(document.querySelector('.loader-container'));
                loaderContainer.css('animation', 'none');
                var opacityDiv = angular.element(document.querySelector('.loader-img-progress'));
                opacityDiv.css('animation', 'none');
                var resumeFile = $scope.resume.usedExport === 'nonats' ? 'resume' : 'hybrid';
                if ($scope.resumeDownloading) {
                    $scope.resumeFilePath = constants.resumeStorage + user.userID + "/" + $stateParams.resumeId + "/" + resumeFile + ".pdf";
                    $scope.resumeDownloading = false;
                    $scope.downloadAvailable = true;
                    $scope.downloadResumeFromS3();
                }
            }).catch(function (error) {
                $scope.resumeDownloading = false;
                $scope.closeWaitingDialog();
                console.error(error);
                if (error.status === 403) {
                    // $scope.paymentRequired = true;
                    localStorage.setItem("toSubscriptionFrom", "resume/" + $stateParams.resumeId);
                    $location.path("subscription");
                } else {
                    if(error.data != undefined)
                        showErrorMessage(error.data.message);
                    else
                        showErrorMessage("Unexpected error occured");
                }
            });
        }

        $scope.downloadResumeFromS3 = function () {
            $scope.currentlyDownloadingResume = true;
            resumeService.downloadResumeFromS3($scope.resumeFilePath, user.first_name + ' ' + user.last_name + ' - ' + $scope.model.title + '.pdf');
        };

        $scope.paymentRequired = false;
        $scope.paymentSuccess = function (updatedUser, closed) {
            $scope.paymentRequired = false;
            if(updatedUser != null){
                $scope.user = updatedUser;
                $scope.validSubscription = true;
                if(!closed)
                    continueDownload();
            }
        };
        $scope.paymentError = function (error) {
            console.error(error);
        };

        function showWaitingDialog() {      
            var dialog = {
                template: 'app/resume-builder/template/resume-generation-waiting-dialog.html',
                controller: this,
                closeByDocument: false,
                closeByEscape: true,
                showClose: false,
                closeByNavigation: true,
                scope: $scope,
                width: '455px',
                height: '547px'
            };
            ngDialog.openConfirm(dialog);
        }
        
        function showConfirmSaveDialog() {
            var self = this;
            var dialog = {
                template: 'app/resume-builder/template/resume-save-confirm-dialog.html',
                controller: this,
                closeByDocument: false,
                closeByEscape: true,
                showClose: false,
                closeByNavigation: true,
                scope: $scope,
                width: '425px',
                height: '200px'
            };
            ngDialog.openConfirm(dialog);
        }
        
        $scope.closeWaitingDialog = function (cancel) {
            if (cancel) {
                $scope.resumeDownloading = false;
            }
            ngDialog.close();
        };
        
        $scope.closeConfirmSaveDialog = function () {
            ngDialog.close();
        };
        $scope.cancelAndDownload = function () {
            $scope.editResume = false;
            this.cancelResumeEditing();
            $scope.isResumeDirty = false;
            ngDialog.close();
            continueDownload();
        };
        $scope.getOrganizationCss = function(css, returnEmpty) {
            return organizationService.getOrganizationCss(css, returnEmpty);
        };
        $scope.validateDate = function(v, c){
            // The fixService fix the date.
            /*
              var isDateValid = utilsService.validateDate(v, c);
              if(isDateValid){
              $scope.editDatesValid = true;
              }
              else{
              $scope.editDatesValid = false;
              showErrorMessage('Date: ' + v + ' is not valid.<br />Format: MMM YYYY<br />Ex: Jan 1999');
              }
            */
        };
        function buildToastr(title, content) {
            $rootScope.toast = toastr.info(content, title, {
                progressBar:true,
                timeOut:3500,
                toastClass: 'toast-error',
                preventDuplicates: true,
                allowHtml: true,
                positionClass: 'toast-top-center',
                hideDuration: 1000,
                closeButton: true,
                showDuration: 1000,
                extendedTimeOut: 1000
            });
        }
        function showErrorMessage(msg) {
            if(!errorMessage) {
                buildToastr("Error! Progress not saved.", msg);
                errorMessage = true;
                $timeout(function(){
                    errorMessage = false;
                }, 4000);          
            } 
        }
        $scope.showTips = function() {
            toastr.optons = null;
            var txt = $('#tipshints').html();
            $rootScope.toast = toastr.success(txt, "Resume Tips", {
                progressBar:false,
                timeOut:0,
                toastClass: 'toast-info-hints',
                preventDuplicates: true,
                allowHtml: true,
                positionClass: 'toast-top-center',
                closeButton: true,
                extendedTimeOut: 0,
                iconClasses: {
                    error: 'toast-error',
                    info: 'toast-info',
                    success: 'toast-info',
                    warning: 'toast-warning'
                }
            });
        };
        $scope.profileEditor = function() {
            $state.go('resume-profile', {
                resumeId: $scope.resume.resumeID,
                new: false
            });
        };
        // ckeditor by default adds a line break inside the editable div
        // that's why placeholder is not visible need to remove line break
        CKEDITOR.on('instanceReady', function() {
            $('.cke_editable').find('br').remove();
        });
        CKEDITOR.on('paste', function() {
            $('.cke_editable').preventDefault();
            // console.log("cke paste");
        });


        var ASSESSMENT_CAREER_ID = 'career-deck';
        var ASSESSMENT_BIG_FIVE_ID = 'big-five';
        $scope.assessmentsStatus = {};
        $scope.assessmentData = {
            archetype: '',
            description: '',
            details: {
                complement: '',
                conflict: '',
                environments: []
            },
            mainTypes: [],
            types: [
                {score: 100, name: 'Inventor', image: 'https://cdn.traitify.com/badges/44b2f6e8-62de-40cf-8510-648b49ccc210_small', color: ''},
                {score: 100, name: 'Mentor', image: 'https://cdn.traitify.com/badges/bd5e1c4f-5e26-4489-b657-684773ffa718_small', color: ''},
                {score: 100, name: 'Planner', image: 'https://cdn.traitify.com/badges/a022262f-1f57-4cf4-ad18-f181ef13e639_small', color: ''},
                {score: 100, name: 'Visionary', image: 'https://cdn.traitify.com/badges/af0ffccd-5f78-4f7a-aa4b-e630425d51cd_small', color: ''},
                {score: 100, name: 'Analyser', image: 'https://cdn.traitify.com/badges/ad738189-7a37-4e7d-a684-4bcfaa9632ea_small', color: ''},
                {score: 100, name: 'Naturalist', image: 'https://cdn.traitify.com/badges/71c77fb8-262a-4df0-a5fa-fdf95f152268_small', color: ''},
                {score: 100, name: 'Action-Taker', image: 'https://cdn.traitify.com/badges/e6a1ac7b-9576-419b-a06d-4af2b8054b70_small', color: ''}
            ],
            traits: []
        };
        var getTypeBarStyle = function (type) {
            var styles = {
                width: type.score + '%'
            };
            if ($scope.assessmentsStatus.hasUserTakenBothAssessments) {
                if (!!navigator.userAgent.match(/Trident\/7\./)) {
                    styles.background = 'linear-gradient(90deg, #6b59a8 100%, hsla(0, 0%, 100%, 0) 0);';
                    styles.filter = 'filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\'rgba(255, 255, 255, .5)\', endColorstr=\'rgba(0, 0, 0, .2)\',GradientType=0 );';
                } else {
                    styles.background = 'linear-gradient(90deg, #6b59a8 100%, hsla(0, 0%, 100%, 0) 0);';
                }
            } else {
                styles.border = '#eee 1px solid';
            }
            return styles;
        };
        var mapType = function (type) {
            return {
                score: type.score,
                name: type['personality_type'].name,
                image: type['personality_type']['badge']['image_small'],
                color: type['personality_type']['badge']['color_1']
            };
        };
        var mapTraits = function (trait) {
            return {
                score: trait.score,
                name: trait['personality_trait'].name
            };
        };
        var setRadarChart = function (elementId, data) {
            var context = document.getElementById(elementId).getContext('2d');
            var gradient = context.createLinearGradient(229, 229, 229, .4);
            gradient.addColorStop(0, "rgba(84, 189, 176, .4)");
            gradient.addColorStop(1, "rgba(84, 189, 176, .4)");
            new Chart(context, {
                type: 'radar',
                data: data.reduce(function (obj, item) {
                    obj.labels.push(item.name);
                    obj.datasets[0].data.push(item.score);
                    return obj;
                }, {
                    labels: [],
                    datasets: [{
                        data: [],
                        backgroundColor: gradient,
                        radius: 0
                    }]
                }),
                options: {
                    legend: {
                        display: false
                    },
                    tooltips: {
                        enabled: false
                    },
                    scale: {
                        angleLines: {
                            color: 'rgba(0, 0, 0, 0.10)',
                            lineWidth: 1,
                        },
                        pointLabels: {
                            fontColor: 'rgba(0, 0, 0, 0.5)',
                            fontFamily: '"Open Sans", sans-serif',
                        },
                        ticks: {
                            beginAtZero: true,
                            display: false,
                            maxTicksLimit: 5,
                        }
                    }
                }
            });
        };
        
        var showAssessmentResultsToUser = function () {
            
            $scope.assessmentData = {};
            var big5Id = getUserAssessment(ASSESSMENT_BIG_FIVE_ID).assessmentId;
            var careerId = getUserAssessment(ASSESSMENT_CAREER_ID).assessmentId;
            var big5Required = ['types', 'archetype'];
            var careerRequired = ['blend', 'types', 'traits', 'career_matches'];
            var imagePack = 'linear';
            $q.all([
                assessmentsService.getResults(big5Id, big5Required, imagePack),
                assessmentsService.getResults(careerId, careerRequired, imagePack)
            ]).then(function (traitifyData) {
                if (traitifyData[0] && traitifyData[1]) {
                    $scope.assessmentData = {
                        archetype: traitifyData[0].data['archetype']['name'],
                        description: traitifyData[1].data['personality_blend']['description'],
                        details: {
                            complement: (
                                traitifyData[0].data['archetype']['details']
                                    .find(function (el) { return el.title === 'Complement'; }) || {}
                            ).body,
                            conflict: (
                                traitifyData[0].data['archetype']['details']
                                    .find(function (el) { return el.title === 'Conflict'; }) || {}
                            ).body,
                            environments: traitifyData[0].data['archetype']['environments']
                                .map(function (el) { return el.name; })
                        },
                        mainTypes: traitifyData[0].data['personality_types'].map(mapType),
                        types: traitifyData[1].data['personality_types'].map(mapType),
                        traits: traitifyData[1].data['personality_traits'].slice(0, 20).map(mapTraits)
                    };      
                }
            }).catch(function (error) {
                console.error(error);
            });
        };

        var getUserAssessment = function (assessmentDeckId) {
            if ($scope.user && $scope.user.assessments) {
                for (var i = 0; i < $scope.user.assessments.length; i += 1) {
                    if ($scope.user.assessments[i].assessmentId && $scope.user.assessments[i].deck_id === assessmentDeckId) {
                        return $scope.user.assessments[i];
                    }
                }
            }
            return null;
        };

        var setScopeAssessmentsStatusProperties = function () {
            $scope.assessmentsStatus.hasUserTakenCareerAssessment = getUserAssessment(ASSESSMENT_CAREER_ID) !== null;
            $scope.assessmentsStatus.hasUserTakenBig5Assessment = getUserAssessment(ASSESSMENT_BIG_FIVE_ID) !== null;
            $scope.assessmentsStatus.hasUserTakenBothAssessments = ($scope.assessmentsStatus.hasUserTakenCareerAssessment && $scope.assessmentsStatus.hasUserTakenBig5Assessment);
        };

        setScopeAssessmentsStatusProperties();
        if ($scope.assessmentsStatus.hasUserTakenBothAssessments) {
            showAssessmentResultsToUser();
        }
        
        // #region Fix Service Code.
        var fixServiceFinalMsg = '';
        $scope.validateTheResume = function() {
            // console.log('-- (Controller) - resumeEditor.$scope.validateTheResume()');
            $scope.removeCkEditor(); // Very very very important!!! Run this before try to fix the profile.
            $scope.editResume = false;
        
            var achievements = parseAchievements($scope.model.achievement, $scope.resume.content.achievements_awards);
            $scope.resume.content.achievements_awards = achievements;
            
            // #region fixService.
            // To enable the debug mode of the fixSevice open the browser console and put the following and press [Enter]:
            // var __FIX_SERVICE__ = '';
            // Then when you click on the save button you should be the log trace in the console.
            try {
                if (typeof __FIX_SERVICE__ === 'string' && __FIX_SERVICE__.length == 0) {
                    __FIX_SERVICE__ = fixService;
                    fixService.debugOn();
                }
            }
            catch(e) {
                // Do nothing...
            }
            
            fixService.setEmptyFieldMsg($translate.instant('FIX_SERVICE_EMPTY_FIELD_MSG'));
            fixService.setSuccessMsg('You\'re data has been saved, but you\'ll need to wait a minute before downloading');
            fixService.setSaveWithMissingDataMsg($translate.instant('FIX_SERVICE_SAVE_WITH_MISSING_DATA_MSG'));
            
            // I make an object to group all of elements to validate and fix:
            var obj = {
                educations: angular.copy($scope.model.educations),
                experiences: angular.copy($scope.model.experiences),
                skills: angular.copy($scope.skills),
                achievements_awards: angular.copy($scope.resume.content.achievements_awards)
            }
            fixServiceFinalMsg = '';
            var fixResult = fixService.fixPreviewEditorResume(obj);
            if (typeof fixResult !== 'undefined' && typeof fixResult.finalMessage !== 'undefined' && fixResult.finalMessage.length > 0) fixServiceFinalMsg = fixResult.finalMessage;
            
            // #region This is for render the resume after the validation and fixing.
            $scope.model.educations = angular.copy(obj.educations);
            $scope.model.experiences = angular.copy(obj.experiences);
            $scope.skills = angular.copy(obj.skills);
            $scope.resume.content.achievements_awards = angular.copy(obj.achievements_awards);
            $scope.model.achievement = buildAchievements($scope.resume.content.achievements_awards); // Rebuild the html string of achievements after the fix of the achievements.
            bindResumeTemplateData();
            // #endregion This is for render the resume after the validation and fixing.
            // #endregion fixService.
            
            setTimeout(function() {
                buildSaveToastr($translate.instant('BEFORE_SAVE_MSG'), '', 2000);
                $scope.saveResume();
            }, 1000);
        }
        
        /**
         * Method to convert an html string of achievements in a javascript array of achievement objects.
         * 
         * @param {*} html Html string with the current achievements.
         * @param {*} list Javascript array with the saved achievement objects.
         */
        function parseAchievements(html, list) {
            try {
                // #region Parse html list of achievements to js array.
                var liList = html
                    .replace(/\n/g, '') // Remove the line breaks.
                    .replace(/\t+/g, '') // Remove the tabs.
                    .replace(/<ul>|<\/ul>/g, '') // Remove the ul tags.
                    .replace(/<\/li><li>/g, ',') // Remove the li tags.
                    .replace(/<li>|<\/li>/g, '') // Remove the li tags.
                    .replace(/&nbsp;+/g, '') // Remove html spaces.
                    .trim() // Remove empty spaces.
                    .split(',');
                // Remove repeated items:
                liList = liList.filter(function(item, index) {
                    return liList.indexOf(item) >= index;
                });
                // #endregion Parse html list of achievements to js array.
                
                // #region Prepare the array of current achievements.
                var tmpList = [];
                _.each(liList, function (eachElm, idx, eachList) {
                    var foundElm = _.find(list, function (findElm) {
                        return ((typeof findElm.deleted === 'undefined' || !findElm.deleted) && findElm.summary.trim().toLowerCase() === eachElm.trim().toLowerCase()) ? true : false;
                    });
                    tmpList.push((typeof foundElm === 'object') ? foundElm : {summary: eachElm, deleted: false});
                });
                // #enregion Prepare the array of current achievements.
                
                // #region Add removed achievements as deleted items to the array of current achievements.
                var finalList = angular.copy(tmpList);
                _.each(list, function (eachElm, idx, eachList) {
                    if (typeof eachElm.deleted !== 'undefined' && eachElm.deleted) {
                        finalList.push(eachElm);
                    } else {
                        var foundElm = _.find(tmpList, function (findElm) {
                            return (findElm.summary.trim().toLowerCase() === eachElm.summary.trim().toLowerCase()) ? true : false;
                        });
                        if (typeof foundElm === 'undefined') {
                            eachElm.deleted = true;
                            finalList.push(eachElm);
                        }
                    }
                });
                // #endregion Add removed achievements as deleted items to the array of current achievements.
                
                return finalList;
            } catch (e) {
                return undefined;
            }
        }
        
        function buildAchievements(achievements) {
            var achievement = "";
            if(achievements && achievements.length){
                achievements.forEach(function(a, n) {
                    try {
                        if (typeof a.deleted === 'undefined' || !a.deleted) {
                            achievement += "<li>" + a.summary + "</li>";
                        }
                    } catch (e) {
                        console.error(e);
                    }
                });
                achievement = "<ul>"+achievement+"</ul>";
            }
            return achievement;
        }
        // #endregion Fix Service Code.
        
        function buildSaveToastr(content, title, timeout) {
            var t = toastr.info(content, title, {
                progressBar:true,                                    
                timeOut:timeout,
                toastClass: 'toast-success',
                preventDuplicates: true,
                allowHtml: true,
                positionClass: 'toast-top-full-width',
                hideDuration: timeout,
                closeButton: true,
                showDuration: timeout, 
                extendedTimeOut: timeout,
                hideMethod: 'noop'
            });
            
            $rootScope.toast = t;
        }
    }
})();

'use strict';
(function () {
  angular
    .module('intryFrontEnd')
    .controller('ResumeBuilderProfileController', ResumeBuilderProfileController);

  /** @ngInject */

  function ResumeBuilderProfileController($scope, user, resume) {
    $scope.user = user;
    $scope.resume = resume;

  
  }

})();
"use strict";
(function () {
  angular.module("intryFrontEnd").component("resumeBuilderProfile", {
    templateUrl: "app/resume-builder/template/resume-builder-profile.html",
    controller: ResumeBuilderProfileComponentController,
    controllerAs: "resumeEditor",
    bindings: {
      wizard: "<",
      resume: "=",
      user: "=",
    },
  });

  function nonNullObject(o) {
    return o !== null && typeof o === "object";
  }

  function nonEmptyArray(a) {
    return Array.isArray(a) && a.length > 0;
  }

  function nonEmptyString(s) {
    return typeof s === "string" && s.length > 0;
  }

  /** @ngInject */
  function ResumeBuilderProfileComponentController(
    utilsService,
    modalService,
    resumeService,
    phoneFormatter,
    constants,
    toastr,
    ngDialog,
    assessmentsService,
    $q,
    $location,
    $scope,
    $document,
    $parse,
    $state,
    $stateParams,
    $http,
    $timeout,
    $rootScope,
    $translate,
    userService,
    $localStorage,
    jobSearchService,
    fixService,
    $validation,
    $compile,
    unsaveService,
    dragulaService,
    organizationService
  ) {
    var resumeEditor = this;
    var stateParams = {};

    var user = this.user;
    var resume = this.resume;


    this.$onInit = function () {
      checkUnsavedDataInit();

      $scope.$emit("initResumeBuilderProfile", {
        downloadResume: resumeEditor.downloadResume,
        editData: resumeEditor.editData,
        goToPage: resumeEditor.goToPage,
        isCurrentPage: resumeEditor.isCurrentPage,
        parseJob: resumeEditor.parseJob,
        hasText: resumeEditor.hasText,
        hasProcessed: resumeEditor.hasProcessed,
        validateTheResume: resumeEditor.validateTheResume,
        getIsResumeDirty: resumeEditor.getIsResumeDirty,
        setIsResumeDirty: resumeEditor.setIsResumeDirty,
      });
    };

    $scope.$on("successUpdateProfile", function (event, data) {
      if (data && data.options) {
        switch (data.options.action) {
          case "goToPreview":
            resumeEditor.goToPage("preview_resume");
            break;
          case "downloadResume":
            continueDownload();
            break;
        }
      }
    });

    if (resumeEditor.wizard) {
      stateParams.job2resume = true;
      stateParams.jobLink = null;
      stateParams.processJob = false;

      if (utilsService.getResumeId(user.userID)) {
        stateParams.resumeId = utilsService.getResumeId(user.userID);
        stateParams.new = false;
      } else {
        stateParams.resumeId = "";
        stateParams.new = true;
      }
    } else {
      stateParams = $stateParams;
      if (!stateParams.resumeId) {
        if (utilsService.getResumeId(user.userID)) {
          stateParams.resumeId = utilsService.getResumeId(user.userID);
          stateParams.new = false;
        } else {
          stateParams.resumeId = "";
          stateParams.new = true;
        }
      }
    }

    window.scroll(0, 0);
    CKEDITOR.config.customConfig = "/media/ckeditor_config.js";

    var errorMessage = false;
    var justSaved = false;
    var jobParseData = null;

    $scope.user = user;
    $scope.jobHTML = "";
    $scope.paymentRequired = false;
    $scope.validSubscription = false;
    $scope.paymentRequired = false;
    $scope.edNotValid = false;
    $scope.expNotValid = false;
    $scope.infoNotValid = false;
    $scope.summary = "";
    $scope.summaryNotValid = false;
    $scope.skillsNotValid = false;
    $scope.awardsNotValid = false;
    $scope.certNotValid = false;
    $scope.miliNotValid = false;
    $scope.showIndustry = false;
    $scope.selectedIndustry = "";
    $scope.isResumeDirty = false;
    $scope.prevDisabled = false;
    $scope.nextDisabled = false;
    $scope.currentlyDownloadingResume = false;
    $scope.downloadAvailable = false;
    $scope.resumeDownloading = false;
    $scope.matchList = [];
    $scope.reqMatchList = [];
    $scope.skillsList = [];
    $scope.missingSkills = [];
    $scope.summaryCompare = [];
    $scope.summaryMissing = "";
    $scope.summaryFound = "";
    $scope.paste = false;

    $scope.validatePhone = true;
    $scope.phonePattern = constants.USA_PHONE_PATTERN_2;
    $scope.summaryPattern = new RegExp(
      "^(.|[\n\r\t]){0," + constants.MAX_SUMMARY_LENGTH + "}$"
    );
    $scope.summaryMaxLength = constants.MAX_SUMMARY_LENGTH;
    resumeEditor.isFirstTimeSaved = false;
    resumeEditor.hasProcessed = false;
    resumeEditor.jobDesc = "";
    resumeEditor.numExpUpdates = 0;
    resumeEditor.numSkillsUpdates = 0;
    resumeEditor.numSumUpdates = 0;
    resumeEditor.numSumMatch = 0;
    resumeEditor.hasJobDesc = false;
    resumeEditor.hasDegreesListed = false;
    resumeEditor.missingAllSkills = 0;
    resumeEditor.downloadAttempts = constants.defaultDownloadAttempts;
    $scope.checkSummary = function () {
      var aux = ((document.getElementById("summary") || {}).value || {}).length;
      return aux > constants.MAX_SUMMARY_LENGTH;
    };

    resumeEditor.user = deepCopy(user);

    resumeEditor.hasText = function () {
      return !!resumeEditor.jobDesc;
    };

    resumeEditor.pages = {
      edit_resume: {
        buttons: {
          j2r: true,
          preview: true,
          save: true,
        },
      },
      preview_resume: {
        buttons: {
          edit: true,
          preview_edit: true,
          print: true,
          save: true,
          download: true,
        },
      },
      j2r: {
        buttons: {
          back: true,
          process: true,
        },
      },
    };
    $scope.experienceKeywordsAdded = [];
    $scope.experienceKeywordsAddedCount = [];

    if (nonEmptyArray(resumeEditor.user.experience)) {
      for (var i = 0; i < resumeEditor.user.experience.length; i++) {
        $scope.experienceKeywordsAdded.push({});
        $scope.experienceKeywordsAddedCount.push(0);
      }
    }
    var aux = $scope.experienceKeywordsAdded;

    resumeEditor.isCurrentPage = function (page) {
      return resumeEditor.currentPage === page;
    };

    resumeEditor.goToPage = function (page) {
      // console.log("-- (Controller) resumeEditor.goToPage() - $scope.isResumeDirty: ", $scope.isResumeDirty);

      if (
        !resumeEditor.wizard &&
        page === "preview_resume" &&
        ($scope.isResumeDirty || !resumeEditor.isFirstTimeSaved)
      ) {
        var options = {
          action: "goToPreview",
        };

        if ($scope.isResumeDirty) {
          options.downloaded = false;
        }

        resumeEditor.validateTheResume(options);

        return;
      }

      resumeEditor.currentPage = page;
      $scope.showJobDesc = page === "j2r";

      if (resumeEditor.wizard && page !== "preview_resume") {
        resumeEditor.wizard.changeStep(3);
      }

      if (page === "j2r") {
        if (!$("#jobDesc").text() && resumeEditor.jobDesc) {
          resumeEditor.jobDesc = "";
        }
      }
    };

    resumeEditor.currentPage = "edit_resume";
    if ($stateParams.resumeNotDownloaded) {
        resumeEditor.currentPage = "preview_resume";  
        modalService.openModal(
          "app/notDownloaded/template/notDownloaded.html",
          "NotDownloadedController",
          {
        
            resumeEditor: function () {
               
              return resumeEditor
            }
          },
          {
            closeByEscape: true,
            closeByNavigation: true,
            closeByDocument: true,
          }
        );
      }
    resumeEditor.showButton = function (button) {
      var buttons = resumeEditor.pages[resumeEditor.currentPage].buttons;
      return button in buttons;
    };

    resumeEditor.setCurrentItem = function (item) {
      if (item.is_current) {
        item.date_end = "";
        item.endDateObj = "";
        item.endMonthObj = null;
        item.endYearObj = null;
      }
    };

    dragulaService.options($scope, "skills-bag", {
      moves: function (el, source, handle) {
        return handle.classList.contains("skills-bag-draggable");
      },
    });

    var buildDefaultAssessment = function () {
      resumeEditor.assessmentData = {
        archetype: "",
        description: "",
        details: {
          complement: "",
          conflict: "",
          environments: [],
        },
        mainTypes: [],
        types: [
          {
            score: 100,
            name: "Inventor",
            image:
              "https://cdn.traitify.com/badges/44b2f6e8-62de-40cf-8510-648b49ccc210_small",
            color: "",
          },
          {
            score: 100,
            name: "Mentor",
            image:
              "https://cdn.traitify.com/badges/bd5e1c4f-5e26-4489-b657-684773ffa718_small",
            color: "",
          },
          {
            score: 100,
            name: "Planner",
            image:
              "https://cdn.traitify.com/badges/a022262f-1f57-4cf4-ad18-f181ef13e639_small",
            color: "",
          },
          {
            score: 100,
            name: "Visionary",
            image:
              "https://cdn.traitify.com/badges/af0ffccd-5f78-4f7a-aa4b-e630425d51cd_small",
            color: "",
          },
          {
            score: 100,
            name: "Analyser",
            image:
              "https://cdn.traitify.com/badges/ad738189-7a37-4e7d-a684-4bcfaa9632ea_small",
            color: "",
          },
          {
            score: 100,
            name: "Naturalist",
            image:
              "https://cdn.traitify.com/badges/71c77fb8-262a-4df0-a5fa-fdf95f152268_small",
            color: "",
          },
          {
            score: 100,
            name: "Action-Taker",
            image:
              "https://cdn.traitify.com/badges/e6a1ac7b-9576-419b-a06d-4af2b8054b70_small",
            color: "",
          },
        ],
        traits: [],
      };
    };

    if (!stateParams.new && resume) {
      // console.log("-- (Controller) resumeEditor (!stateParams.new && resume) resume: ", resume);
      // console.log("-- (Controller) resumeEditor (!stateParams.new && resume) user: ", user);

      $scope.summary = resume.content.about;
      resumeEditor.user.summary = $scope.summary;
      resumeEditor.user.first_name = resume.content.first_name;
      resumeEditor.user.last_name = resume.content.last_name;
      resumeEditor.user.profile_picture_url =
        resume.content.profile_picture_url;
      resumeEditor.website = resume.content.website;
      resumeEditor.user.email_address = resume.content.email_address;
      resumeEditor.title = resume.title === "no" ? null : resume.title;
      resumeEditor.address = resume.content.address;
      resumeEditor.phonenumber = resume.content.phone_number;
      resumeEditor.industry =
        resume.content.industry === " " ? null : resume.content.industry;
      resumeEditor.assessmentData =
        user.assessments.types === undefined
          ? buildDefaultAssessment()
          : user.assessments;
      resumeEditor.user.experience = resume.content.experience;
      resumeEditor.user.education = resume.content.education;
      resumeEditor.user.skills = resume.content.skills;
      resumeEditor.user.achievements_awards = nonEmptyArray(
        resume.content.achievements_awards
      )
        ? resume.content.achievements_awards
        : user.achievements_awards;
      resumeEditor.user.achievement = buildAchievements(
        resumeEditor.user.achievements_awards
      );
      resumeEditor.user.references = nonEmptyArray(resume.content.references)
        ? resume.content.references
        : [];
      resumeEditor.resumeID = resume.resumeID;
      resumeEditor.usedExport = resume.usedExport;
      resumeEditor.fullSkillsList = [];
      try {
        $scope.selectedIndustry = resume.content.industry.trim();
      } catch (e) {
        // Do nothing...
      }

      if (
        typeof resume.meta.jobDescriptionLink === "string" &&
        resume.meta.jobDescriptionLink.length > 0
      ) {
        // Not use yet!
      }

      if (
        typeof resume.meta.jobDescription === "string" &&
        resume.meta.jobDescription.length > 0
      ) {
        resumeEditor.jobDesc = resume.meta.jobDescription;
        $("#jobDesc").html(resumeEditor.jobDesc);
      }

      if (
        typeof resume.meta.jobDescriptionParsed === "string" &&
        resume.meta.jobDescriptionParsed.length > 0
      ) {
        try {
          jobParseData = JSON.parse(resume.meta.jobDescriptionParsed);
        } catch (e) {
          console.error(
            "-- (Controller) resumeEditor (!stateParams.new && resume) e: ",
            e
          );
        }
      }
    } else {
      // console.log("-- (Controller) resumeEditor !(!stateParams.new && resume) resume: ", resume);
      // console.log("-- (Controller) resumeEditor !(!stateParams.new && resume) user: ", user);

      resumeEditor.user.email_address = buildEmail(
        resumeEditor.user.email_addresses
      );
      resumeEditor.address = buildAddress(resumeEditor.user.addresses);
      resumeEditor.phonenumber = buildPhoneNumber(user.phone_numbers);

      if (typeof user.industry === "string" && user.industry.length) {
        resumeEditor.industry = user.industry;
      }

      resumeEditor.user.achievement = buildAchievements(
        resumeEditor.user.achievements
      );
      resumeEditor.resumeID = "";
      resumeEditor.usedExport = "ats";
      resumeEditor.user.education = nonEmptyArray(user.education)
        ? angular.copy(user.education)
        : [];
      resumeEditor.user.skills = nonEmptyArray(user.skills)
        ? angular.copy(user.skills)
        : [];
      resumeEditor.user.experience = nonEmptyArray(user.experience)
        ? angular.copy(user.experience)
        : [];
      resumeEditor.user.achievements_awards = nonEmptyArray(
        user.achievements_awards
      )
        ? angular.copy(user.achievements_awards)
        : [];
      resumeEditor.user.references = nonEmptyArray(user.references)
        ? angular.copy(user.references)
        : [];
      resumeEditor.user.assessmentData = user.assessments;
      resumeEditor.fullSkillsList = [];
    }

    var isToolbox = false;
    $scope.proficiencyList = [
      "",
      "(Beginner)",
      "(Intermediate)",
      "(Average)",
      "(Advanced)",
      "(Expert)",
    ];
    $scope.momentDateFormat = "MMM YYYY";
    resumeEditor.isSubscriber = !!user.stripe_customerID;
    resumeEditor.proficiency = 3;
    resumeEditor.showAddEducationBar = [];

    resumeEditor.setFocus = function () {
      angular.element($document[0].querySelector("select.ng-invalid")).focus();
      angular.element($document[0].querySelector("select.ng-empty")).focus();
      angular.element($document[0].querySelector("input.ng-invalid")).focus();
      angular.element($document[0].querySelector("input.ng-empty")).focus();
      // resumeEditor.validateFormData();
    };

    document
      .getElementById("submit_validation")
      .addEventListener("click", resumeEditor.setFocus);

    var date = new Date();
    var months = [];
    var monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    var shortMonths = [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
    ];

    // #region Get Resume Templates.
    var resume_template_options = [
      {
        title: "Social",
        value: "social",
        image_url: "social.png",
        isSelected: true,
      },
    ];
    var selectedResume = 0;
    var layout = resume_template_options[selectedResume].value;
    $scope.resumeselected = resume_template_options[selectedResume];
    // #endregion Get Resume Templates.

    var i = 1;
    angular.forEach(monthNames, function (monthName) {
      var month = {
        fullmonthName: monthName,
        monthNumber: i,
      };
      i++;
      months.push(month);
    });
    $scope.months = months;

    function getDownloadResumeLink() {
      if (
        resume &&
        resume.meta &&
        resume.meta.export &&
        (resume.meta.export.ats || resume.meta.export.nonats)
      ) {
        if (resume.usedExport) {
          return resume.meta.export[resume.usedExport];
        } else {
          return resume.meta.export.ats;
        }
      }
      return null;
    }

    $scope.downloadResumeLink = getDownloadResumeLink();

    function deepCopy(obj) {
      var clone = {};
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          clone[key] = angular.copy(obj[key]);
        }
      }
      return clone;
    }

    function buildAddress(addr) {
      var address = {
          street: "",
          city: "",
          state: "",
          kind: "Personal",
        },
        addressItem,
        addy;
      if (nonEmptyArray(addr)) {
        addy = addr.filter(function (el) {
          return el.deleted == false;
        });
        if (addy.length > 0) {
          addressItem = addy[addy.length - 1];
          address.street = addressItem.street;
          address.city = addressItem.city;
          address.state = addressItem.state;
        }
      }
      return address;
    }

    function buildPhoneNumber(phones) {
      var phonenumber = {
          number: "",
          kind: "",
        },
        phoneItem,
        phn;
      if (nonEmptyArray(phones)) {
        phn = phones.filter(function (el, ndx) {
          return el.deleted == false;
        });
        if (phn.length > 0) {
          phoneItem = phn[phn.length - 1];
          phonenumber.number = phoneFormatter.format(phoneItem.number);
          phonenumber.kind = phoneItem.kind;
        }
      }
      return phonenumber;
    }

    function buildEmail(emailAddresses) {
      var email = {
          address: "",
          kind: "",
        },
        emailItem,
        filteredEmailAddresses;

      if (nonEmptyArray(emailAddresses)) {
        filteredEmailAddresses = emailAddresses.filter(function (el) {
          return !el.deleted;
        });
        if (filteredEmailAddresses.length) {
          emailItem = filteredEmailAddresses[filteredEmailAddresses.length - 1];
          email.address = emailItem.address;
          email.kind = emailItem.kind;
        }
      }
      return email;
    }

    function buildAchievements(achievements) {
      var achievement = "";
      if (nonEmptyArray(achievements)) {
        achievements.forEach(function (a, n) {
          if (typeof a.date_start !== undefined && a.date_start !== null) {
            a.startDateObj = utilsService.formatDate(a.date_start);
          } else {
            a.startDateObj = "";
          }

          // console.log("-- (Controller) resumeEditor.buildAchievements() a: ", a);

          try {
            if (typeof a.deleted === "undefined" || !a.deleted) {
              achievement +=
                "<li>" +
                a.summary +
                (a.startDateObj.length > 0 ? ", " + a.startDateObj : "") +
                "</li>";
            }
          } catch (e) {
            console.error(e);
          }
        });
        achievement = "<ul>" + achievement + "</ul>";
      }
      return achievement;
    }

    function createNewResume() {
      // console.log("-- (Controller) resumeEditor.createNewResume()");
      // console.log("-- (Controller) resumeEditor.createNewResume() - resumeEditor.user: ", resumeEditor.user);

      resumeEditor.industry = " ";

      if (
        user.industry !== null &&
        typeof user.industry === "string" &&
        user.industry.length
      ) {
        resumeEditor.industry = user.industry;
      }

      var resume_layout = resume_template_options[selectedResume].value;
      // var sortModified = false;
      resumeEditor.title = " ";

      removeDateObj(resumeEditor);
      resumeEditor.user.achievement = buildAchievements(
        resumeEditor.user.achievements_awards
      );

      resumeService
        .createResume(
          resumeEditor.user,
          resumeEditor.user.summary,
          resumeEditor.title,
          resumeEditor.industry,
          resume_layout
        )
        .then(function (response) {
          resumeEditor.resumeID = response.data.resumeID;
          resumeService
            .getResume(user.userID, response.data.resumeID)
            .then(function (resumeData) {
              resumeEditor.resume = resumeData;
              resumeEditor.resumeID = resumeData.resumeID;
              resume = resumeEditor.resume;

              resumeEditor.user.skills = resume.content.skills;
              resumeEditor.user.achievements_awards =
                resume.content.achievements_awards;
              resumeEditor.user.references = resume.content.references;
              $scope.isResumeDirty = false;
              $scope.$emit("isResumeDirty", {
                isResumeDirty: $scope.isResumeDirty,
              });

              var experienceList = _.sortBy(resume.experience, "order_index");
              var educationList = _.sortBy(resume.education, "order_index");
              //
              // You don't need these if you are going to comment the definition of var sortModified above
              //
              // experienceList.forEach(function (exp, idx) {
              //     if (exp._id !== resumeEditor.experience[idx]._id) {
              //         sortModified = true;
              //     }
              // });
              // educationList.forEach(function (edu, idx) {
              //     if (edu._id !== resumeEditor.education[idx]._id) {
              //         sortModified = true;
              //     }
              // });
              //
              resumeEditor.user.experience = resume.content.experience;
              resumeEditor.user.education = resume.content.education;
              refillDropdown();

              if (stateParams.job2resume) {
                utilsService.saveResumeId(user.userID, resumeEditor.resumeID);
              }

              $rootScope.emptyCreation = true;

              if (!resumeEditor.wizard) {
                $state.transitionTo("resume-profile", {
                  resumeId: resumeEditor.resumeID,
                  job2resume: stateParams.job2resume,
                  jobLink: stateParams.jobLink,
                  processJob: stateParams.jobLink == null ? false : true,
                  firstLoad: true,
                });
              } else {
                updateSkillsRatings();
              }
            });

          resumeEditor.title = null;
          resumeEditor.industry = null;
        })
        .catch(function (err) {
          console.error(err);
        });
    }

    function removeDateObj(editor) {
      var removeDateItems = function (list) {
        _.each(list, function (element) {
          if (element.endYearObj && element.endMonthObj) {
            element.date_end = moment(
              element.endYearObj +
                "/" +
                shortMonths[element.endMonthObj - 1] +
                "/15",
              "YYYY/MM/DD"
            ).format("YYYY-MM-DD");
          }
          if (element.startYearObj && element.startMonthObj) {
            element.date_start = moment(
              element.startYearObj +
                "/" +
                shortMonths[element.startMonthObj - 1] +
                "/15",
              "YYYY/MM/DD"
            ).format("YYYY-MM-DD");
          }
          delete element.endYearObj;
          delete element.endMonthObj;
          delete element.endDateObj;
          delete element.endShortDateObj;
          delete element.startYearObj;
          delete element.startMonthObj;
          delete element.startDateObj;
          delete element.startShortDateObj;
        });
      };

      removeDateItems(editor.user.experience);
      removeDateItems(editor.user.education);
    }

    function hasDuplicates(list) {
      list = _.filter(list, {
        deleted: false,
      });
      _.each(list, function (value, key) {
        value.skill = value.skill.toLowerCase().trim();
      });
      return _.uniq(list, "skill").length !== list.length;
    }

    function emptySkills(list) {
      var empty = false;
      _.each(list, function (element) {
        if (!element.deleted) {
          element.skill = element.skill.replace(/&nbsp;/g, " ").trim();
          if (!element.skill.length) empty = true;
        }
      });
      return empty;
    }

    function fillRating(el, fill) {
      return (el.style.backgroundImage =
        "linear-gradient(to right, #6e55a7, #5382b1, #487eb0, #3595ae, #2ba1ad, #29a4ad " +
        fill +
        "%, #e7e9eb 1%, #e7e9eb 100%)");
    }

    function getFill(event) {
      var pos = event.clientX - event.target.getBoundingClientRect().left;
      var fill = Math.ceil(((pos + 1) / event.target.offsetWidth) * 5) * 20;
      return fill;
    }

    function setListeners(rateControl) {
      rateControl.addEventListener(
        "mousemove",
        function (event) {
          var fill = getFill(event);
          fillRating(event.currentTarget, fill);
        },
        true
      );

      rateControl.addEventListener("click", function (event) {
        var rating = getFill(event) / 20;
        fillRating(event.currentTarget, rating * 20);
        var lst = resumeEditor.user.skills.filter(function (i) {
          return i.deleted == false;
        });
        lst[parseInt(event.currentTarget.getAttribute("ndx"))].proficiency =
          rating;
        $scope.$apply();
      });

      rateControl.addEventListener("mouseout", function (event) {
        var lst = resumeEditor.user.skills.filter(function (i) {
          return i.deleted == false;
        });
        var rating =
          lst[parseInt(event.currentTarget.getAttribute("ndx"))].proficiency;
        fillRating(event.currentTarget, rating * 20);
      });
    }

    function updateSkillsRatings() {
      $timeout(function () {
        var ndx = 0;
        _.each(resumeEditor.user.skills, function (skill) {
          if (skill.deleted == false) {
            var rateControl = document.getElementById("skill_" + ndx);
            rateControl.setAttribute("ndx", ndx);
            ndx = ndx + 1;
            rateControl.setAttribute("data-rating", skill.proficiency);
            fillRating(rateControl, skill.proficiency * 20);
            setListeners(rateControl);
          }
        });
      }, 750);
    }
    updateSkillsRatings();

    function refillDropdown() {
      var refill = function (element) {
        element.startDateObj = utilsService.formatDate(element.date_start);
        element.endDateObj = utilsService.formatDate(element.date_end);

        element.startMonthObj = utilsService.getMonthObj(element.date_start);
        element.startYearObj = utilsService.getYearObj(element.date_start);
        element.endMonthObj = utilsService.getMonthObj(element.date_end);
        element.endYearObj = utilsService.getYearObj(element.date_end);
      };

      _.each(resumeEditor.user.experience, function (element) {
        refill(element);
      });

      _.each(resumeEditor.user.education, function (element) {
        refill(element);
      });

      _.each(resumeEditor.user.achievements_awards, function (element) {
        refill(element);
      });
    }

    function getYears() {
      var currentYear = date.getFullYear() - 69;
      $scope.years = [];
      for (var i = 69; i > 0; i--) {
        $scope.years.push(currentYear + i);
      }

      return $scope.years;
    }
    getYears();

    function getYears2() {
      var currentYear = date.getFullYear() + 3 - 69;
      $scope.years2 = [];
      for (var i = 69; i > 0; i--) {
        $scope.years2.push(currentYear + i);
      }

      return $scope.years2;
    }
    getYears2();

    function orderIndexSorting(list, field) {
      //list = _.filter(list, {deleted: false});
      _.each(list, function (item, key) {
        item.order_index = key;
      });
      unsaveService.updateData(field, angular.copy(resumeEditor.user[field]));
    }

    function orderExperiences() {
      if (nonEmptyArray(resumeEditor.user.experience)) {
        resumeEditor.user.experience = _.sortBy(
          resumeEditor.user.experience,
          "order_index"
        );

        for (var i = 0; i < resumeEditor.user.experience.length; i += 1) {
          var experience = resumeEditor.user.experience[i];
          //experience.summary = experience.summary || experience.title;

          if (constants.YEAR_VALIDATION.test(experience.date_start)) {
            experience.startDateObj = experience.date_start;
          } else if (
            experience.date_start &&
            moment(experience.date_start).isValid()
          ) {
            experience.startDateObj = moment(
              experience.date_start,
              "YYYY-MM-DD"
            ).format($scope.momentDateFormat);
          }

          if (constants.YEAR_VALIDATION.test(experience.date_end)) {
            experience.endDateObj = experience.date_end;
          } else if (
            experience.date_end &&
            moment(experience.date_end).isValid()
          ) {
            experience.endDateObj = moment(
              experience.date_end,
              "YYYY-MM-DD"
            ).format($scope.momentDateFormat);
          }

          experience.index = i;
          experience.order_index =
            experience.order_index !== undefined ? experience.order_index : i;
          experience.kind = experience.kind
            ? experience.kind
            : constants.default_employment_kind;
          experience.isVolunteer =
            experience.kind && experience.kind === constants.volunteer;
          experience.isMilitary =
            experience.kind && experience.kind === constants.military;
        }
      }
    }

    function orderEducations() {
      if (nonEmptyArray(resumeEditor.user.education)) {
        resumeEditor.user.education = _.sortBy(
          resumeEditor.user.education,
          "order_index"
        );
        for (var i = 0; i < resumeEditor.user.education.length; i += 1) {
          var education = resumeEditor.user.education[i];

          if (constants.YEAR_VALIDATION.test(education.date_start)) {
            education.startDateObj = education.date_start;
          } else if (
            education.date_start &&
            moment(education.date_start).isValid()
          ) {
            education.startDateObj = moment(
              education.date_start,
              "YYYY-MM-DD"
            ).format($scope.momentDateFormat);
          }

          if (constants.YEAR_VALIDATION.test(education.date_end)) {
            education.endDateObj = education.date_end;
          } else if (
            education.date_end &&
            moment(education.date_end).isValid()
          ) {
            education.endDateObj = moment(
              education.date_end,
              "YYYY-MM-DD"
            ).format($scope.momentDateFormat);
          }

          education.index = i;
          education.order_index =
            education.order_index !== undefined ? education.order_index : i;
          education.isCertification =
            education.kind && education.kind === constants.certification;
        }
      }
    }

    function orderSkills() {
      if (nonEmptyArray(resumeEditor.user.skills)) {
        resumeEditor.user.skills = _.sortBy(
          resumeEditor.user.skills,
          "order_index"
        );
        var skillOrderIndex = 0;
        for (var i = 0; i < resumeEditor.user.skills.length; i += 1) {
          var skill = resumeEditor.user.skills[i];
          skill.index = i;
          if (!skill.deleted) {
            skill.order_index = skillOrderIndex;
            skillOrderIndex += 1;
          }
          convertProficiencyToArray(i);
        }
      }
    }

    // Remove education
    resumeEditor.removeEducation = function (element, ind) {
      if (nonEmptyArray(resumeEditor.user.education)) {
        var index = _.findIndex(resumeEditor.user.education, {
          _id: element._id,
        });
        $scope.removeCkEditor();
        if (index >= 0) {
          resumeEditor.user.education[index].deleted = true;
        } else {
          var idx = resumeEditor.user.education.indexOf(element);
          resumeEditor.user.education.splice(idx, 1);
        }
        if (resumeEditor.user.educationError)
          resumeEditor.user.educationError = [];
        orderIndexSorting(resumeEditor.user.education, "education");
      }
    };

    // Remove experience
    resumeEditor.removeExperience = function (element, ind) {
      if (nonEmptyArray(resumeEditor.user.experience)) {
        var index = _.findIndex(resumeEditor.user.experience, {
          _id: element._id,
        });
        $scope.removeCkEditor();
        if (index >= 0) {
          resumeEditor.user.experience[index].deleted = true;
        } else {
          var idx = resumeEditor.user.experience.indexOf(element);
          resumeEditor.user.experience.splice(idx, 1);
        }
        if (resumeEditor.user.experienceError)
          resumeEditor.user.experienceError = [];
        orderIndexSorting(resumeEditor.user.experience, "experience");
      }
    };

    // Remove skill
    resumeEditor.removeSkill = function (element) {
      if (nonEmptyArray(resumeEditor.user.skills)) {
        // var index = _.findIndex(resumeEditor.user.skills, { "_id": element._id });
        // var index = _.findIndex(resumeEditor.user.skills, {"skill": element.skill, deleted: false});
        var index = resumeEditor.user.skills.indexOf(element);

        if (index >= 0) {
          resumeEditor.user.skills[index].deleted = true;
        } else {
          var idx = resumeEditor.user.skills.indexOf(element);
          resumeEditor.user.skills.splice(idx, 1);
        }
        if (resumeEditor.user.skillsError) resumeEditor.user.skillsError = [];
        orderIndexSorting(resumeEditor.user.skills, "skills");
      }
    };

    // Remove award
    resumeEditor.removeAward = function (element) {
      if (nonEmptyArray(resumeEditor.user.achievements_awards)) {
        var index = _.findIndex(resumeEditor.user.achievements_awards, {
          _id: element._id,
        });
        if (index >= 0) {
          resumeEditor.user.achievements_awards[index].deleted = true;
        } else {
          var idx = resumeEditor.user.achievements_awards.indexOf(element);
          resumeEditor.user.achievements_awards.splice(idx, 1);
        }
        if (resumeEditor.awardListError) resumeEditor.awardListError = [];
        orderIndexSorting(
          resumeEditor.user.achievements_awards,
          "achievements_awards"
        );
        resumeEditor.user.achievement = buildAchievements(
          resumeEditor.user.achievements_awards
        );
      }
    };

    // Add new empty education.
    resumeEditor.addNewEducation = function (index, bottom, knd) {
      if (!Array.isArray(resumeEditor.user.education)) {
        resumeEditor.user.education = [];
      }
      var newEducationObj = {
        degree: "",
        major: "",
        date_end: "",
        date_start: "",
        deleted: false,
        field_of_study: "",
        institution: "",
        notes: "",
        kind: knd,
        order_index: resumeEditor.user.education.length,
        endDateObj: "",
        startDateObj: "",
      };
      if (bottom) {
        resumeEditor.user.education.push(newEducationObj);
      } else if (index == 0) {
        resumeEditor.user.education.unshift(newEducationObj);
      } else {
        resumeEditor.user.education.splice(index, 0, newEducationObj);
      }
      resumeEditor.user.educationError = [];
      if (
        Array.isArray(resumeEditor.showAddEducationBar) &&
        resumeEditor.showAddEducationBar[index]
      ) {
        resumeEditor.showAddEducationBar[index] = false;
      }
    };

    // Add new empty experience.
    resumeEditor.addNewExperience = function (index, bottom, knd) {
      if (!Array.isArray(resumeEditor.user.experience)) {
        resumeEditor.user.experience = [];
      }
      var newExperienceObj = {
        title: "",
        company: "",
        description: "",
        summary: "",
        location: "",
        date_end: "",
        date_start: "",
        deleted: false,
        kind: knd,
        order_index: resumeEditor.user.experience.length,
        startDateObj: "",
        endDateObj: "",
      };
      if (bottom) {
        resumeEditor.user.experience.push(newExperienceObj);
      } else if (index == 0) {
        resumeEditor.user.experience.unshift(newExperienceObj);
      } else {
        resumeEditor.user.experience.splice(index, 0, newExperienceObj);
      }
      resumeEditor.user.experienceError = [];
      if (
        Array.isArray(resumeEditor.showAddExperienceBar) &&
        resumeEditor.showAddExperienceBar[index]
      ) {
        resumeEditor.showAddExperienceBar[index] = false;
      }
    };

    // Add new empty skill.
    resumeEditor.addNewSkill = function (index, bottom) {
      var newSkillObj = {
        skill: "",
        proficiency: 3,
        deleted: false,
        order_index: resumeEditor.user.skills.length,
      };

      if (bottom) {
        resumeEditor.user.skills.push(newSkillObj);
      } else if (index == 0) {
        resumeEditor.user.skills.unshift(newSkillObj);
      } else {
        resumeEditor.user.skills.splice(index, 0, newSkillObj);
      }

      resumeEditor.user.skillsError = [];
      if (resumeEditor.showAddSkillBar && resumeEditor.showAddSkillBar[index]) {
        resumeEditor.showAddSkillBar[index] = false;
      }

      $timeout(function () {
        var cnt = resumeEditor.user.skills.filter(function (i) {
          return i.deleted == true;
        }).length;
        resumeEditor.user.skills.filter(function (i) {
          return i.deleted == false;
        });
        var rateControl = document.getElementById(
          "skill_" + (resumeEditor.user.skills.length - (1 + cnt))
        );
        rateControl.setAttribute("data-rating", newSkillObj.proficiency);
        fillRating(rateControl, newSkillObj.proficiency * 20);
        setListeners(rateControl);
        var lst = $(".skill-name");
        if (lst.length > 0) lst[lst.length - 1].focus();
      }, 250);
    };

    // Add new empty award.
    resumeEditor.addNewAward = function (index, bottom) {
      var newAwardObj = {
        summary: "",
        deleted: false,
        order_index: resumeEditor.user.achievements_awards.length,

        date_end: "",
        date_start: "",
        startDateObj: "",
        endDateObj: "",
      };
      if (bottom) {
        resumeEditor.user.achievements_awards.push(newAwardObj);
      } else if (index == 0) {
        resumeEditor.user.achievements_awards.unshift(newAwardObj);
      } else {
        resumeEditor.user.achievements_awards.splice(index, 0, newAwardObj);
      }
      resumeEditor.awardListError = [];
      if (
        Array.isArray(resumeEditor.showAddAwardBar) &&
        resumeEditor.showAddAwardBar[index]
      ) {
        resumeEditor.showAddAwardBar[index] = false;
      }

      $timeout(function () {
        var lst = $(".award-name");
        if (lst.length > 0) lst[lst.length - 1].focus();
      }, 250);
    };

    resumeEditor.fixServiceInit = function () {
      fixService.setEmptyFieldMsg(
        $translate.instant("FIX_SERVICE_EMPTY_FIELD_MSG")
      );
      fixService.setSuccessMsg(
        "You're data has been saved, but you'll need to wait a minute before downloading"
      );
      fixService.setSaveWithMissingDataMsg(
        $translate.instant("FIX_SERVICE_SAVE_WITH_MISSING_DATA_MSG")
      );
    };

    function onLoad() {
      resumeEditor.user.education = _.sortBy(
        resumeEditor.user.education,
        "order_index"
      );
      resumeEditor.user.experience = _.sortBy(
        resumeEditor.user.experience,
        "order_index"
      );
      resumeEditor.user.skills = _.sortBy(
        resumeEditor.user.skills,
        "order_index"
      );
      resumeEditor.user.achievements_awards = _.sortBy(
        resumeEditor.user.achievements_awards,
        "order_index"
      );
      resumeEditor.user.references = _.sortBy(
        resumeEditor.user.references,
        "order_index"
      );
      // getEmailAddressForProfile();
      resumeEditor.allowResume = true;
      resumeEditor.fixServiceInit();
      if (!$scope.selectedIndustry) {
        angular
          .element("md-autocomplete.form-control-autocomplete")
          .addClass("missing-data");
      }
    }
    onLoad();

    // $scope.validateDate = function(v, listType, index, dateType, id){
    //     var isDateValid;
    //     if(dateType == 'EndDateObj' && !v)
    //         isDateValid = true;
    //     else
    //         isDateValid = utilsService.validateDate(v, id, true);
    //     if(!isDateValid){
    //         if(!resumeEditor[listType])
    //             resumeEditor[listType] = [];
    //         var obj = {};
    //         obj[dateType] = true;
    //         resumeEditor[listType][index] = obj;
    //         $scope.editDatesValid = false;
    //         resumeEditor.invalidDateMsg = 'Date: ' + v + ' is not valid.\r\n Format: MMM YYYY \r\n Ex: Jan 1999';
    //         resumeEditor.showErrorMsg = resumeEditor.invalidDateMsg;
    //         $timeout(function () {
    //             resumeEditor.showErrorMsg = '';
    //         }, 5000);
    //     } else {
    //         $scope.editDatesValid = true;
    //         if(resumeEditor[listType] && resumeEditor[listType][index] && resumeEditor[listType][index][dateType])
    //             resumeEditor[listType][index] = false;
    //     }
    // };

    $scope.addCkEditor = function (t) {
      try {
        $scope.removeCkEditor();
      } catch (e) {
        console.error("-- resumeEditor.$scope.addCkEditor() - Exception: ", e);
      }

      if (!CKEDITOR.instances[t]) {
        var edt = CKEDITOR.replace(t, {
          stylesSet: [],
        });

        $(document).on("click", "#cke_" + t, function (evt) {
          // It's a hack but only way to know toolbox was clicked
          if (evt.target.className === "cke_top cke_reset_all")
            isToolbox = true;
        });

        edt.on("instanceReady", function (evt) {
          var editor = CKEDITOR.instances[evt.sender.name];
          editor.focus();
          var range = editor.createRange();
          range.moveToElementEditEnd(range.root);
          editor.getSelection().selectRanges([range]);
        });

        edt.on("blur", function (evt) {
          if (!isToolbox) $scope.removeCkEditor();
          else isToolbox = false;
        });

        // The next two force ckeditor to preserve <br> tags
        // https://stackoverflow.com/questions/44501658/how-to-force-ckeditor-to-preserve-br-ta

        edt.on("pluginsLoaded", function (evt) {
          evt.editor.dataProcessor.dataFilter.addRules({
            elements: {
              br: function (element) {
                // if next element is BR or <!--cke_br_comment-->, ignore it.
                if (
                  element &&
                  element.next &&
                  (element.next.name == "br" ||
                    element.next.value == "cke_br_comment")
                ) {
                  return;
                } else {
                  var comment = new CKEDITOR.htmlParser.comment(
                    "cke_br_comment"
                  );
                  comment.insertAfter(element);
                }
              },
            },
          });

          evt.editor.dataProcessor.htmlFilter.addRules({
            comment: function (value, node) {
              if (value.indexOf("cke_br_comment") >= 0) {
                return false;
              }
              return undefined;
            },
          });
        });
      }
    };

    $scope.removeCkEditor = function () {
      for (var idx in CKEDITOR.instances) {
        if (
          typeof CKEDITOR.instances[idx] === "object" &&
          typeof CKEDITOR.instances[idx].name === "string" &&
          CKEDITOR.instances[idx].name.length > 0
        ) {
          var name = CKEDITOR.instances[idx].name;
          var nameSelector = $("#" + name);
          nameSelector.html(CKEDITOR.instances[name].getData());
          var md = nameSelector.attr("ng-model");
          var x = $parse(md);

          if (x) x.assign($scope, CKEDITOR.instances[name].getData());

          var split = name.split("_");

          switch (split[0]) {
            case "education":
              resumeEditor.user.education[parseInt(split[1])].notes =
                CKEDITOR.instances[name].getData();
              break;
            case "experience":
              resumeEditor.user.experience[parseInt(split[1])].summary =
                CKEDITOR.instances[name].getData();
              resumeEditor.user.experience[parseInt(split[1])].description =
                CKEDITOR.instances[name].getData();
              resumeEditor.parseMissingKeywords(parseInt(split[1]));
              break;
          }
        }
        CKEDITOR.instances[name].destroy(true);
      }
    };

    resumeEditor.phoneFlatten = function () {
      if (resumeEditor.phonenumber && resumeEditor.phonenumber.number) {
        resumeEditor.phonenumber.number = phoneFormatter.flatten(
          resumeEditor.phonenumber.number
        );
      }
    };

    resumeEditor.phoneDisplay = function () {
      if (resumeEditor.phonenumber && resumeEditor.phonenumber.number) {
        resumeEditor.phonenumber.number = phoneFormatter.format(
          resumeEditor.phonenumber.number
        );
      }
    };

    resumeEditor.isEditable = function (t) {
      return $scope.addCkEditor(t);
    };

    function checkDates(theList, isEd) {
      var isGreater = false;
      var now = new Date();
      var div = null;
      var area = "";
      var errorType = 0;
      theList
        .filter(function (f) {
          return f.deleted == false;
        })
        .forEach(function (ele, ndx) {
          if (isEd) {
            area = "Education and/or Certificates";
            div = $("#eductionDiv_" + ele.order_index)[0];
          } else {
            area = "Experience and/or Military";
            div = $("#experienceDiv_" + ele.order_index)[0];
          }
          if (typeof div !== "undefined") div.classList.remove("dates-error");

          if (
            (ele.startYearObj && !ele.startMonthObj) ||
            (!ele.startYearObj && ele.startMonthObj)
          ) {
            isGreater = true;
            errorType = 3;
            if (typeof div !== "undefined") div.classList.add("dates-error");
          } else if (
            (ele.endYearObj && !ele.endMonthObj) ||
            (!ele.endYearObj && ele.endMonthObj)
          ) {
            isGreater = true;
            errorType = 4;
            if (typeof div !== "undefined") div.classList.add("dates-error");
          }

          if (errorType == 0) {
            if (ele.startYearObj && ele.startMonthObj) {
              ele.startDateObj = new Date(
                ele.startYearObj,
                ele.startMonthObj - 1,
                2
              ).toLocaleDateString("en", {
                year: "numeric",
                month: "short",
              });
            } else {
              ele.startDateObj = ele.date_start = "";
            }
            if (ele.endYearObj && ele.endMonthObj) {
              ele.endDateObj = new Date(
                ele.endYearObj,
                ele.endMonthObj - 1,
                2
              ).toLocaleDateString("en", {
                year: "numeric",
                month: "short",
              });
            } else {
              ele.endDateObj = ele.date_end = "";
            }

            var startDate = new Date(
              ele.startYearObj,
              ele.startMonthObj - 1,
              2
            );
            var endDate = new Date(ele.endYearObj, ele.endMonthObj - 1, 2);
            if (startDate && endDate && !ele.deleted && startDate > endDate) {
              isGreater = true;
              errorType = 1;
              if (typeof div !== "undefined") div.classList.add("dates-error");
            } else if (startDate > now) {
              isGreater = true;
              errorType = 2;
              if (typeof div !== "undefined") div.classList.add("dates-error");
            }
          }
        });
      if (errorType == 1) {
        buildToastr(
          "Error! Progress not saved.",
          area +
            ": End date should be greater than start date. Items with error will have a red border.",
          4000
        );
      } else if (errorType == 2) {
        buildToastr(
          "Error! Progress not saved.",
          area +
            ": Start date can not be a future date. Items with error will have a red border.",
          4000
        );
      } else if (errorType == 3) {
        buildToastr(
          "Error! Progress not saved.",
          area +
            ": Start date must have both a month and year. Items with error will have a red border.",
          4000
        );
      } else if (errorType == 4) {
        buildToastr(
          "Error! Progress not saved.",
          area +
            ": End date must have both a month and year. Items with error will have a red border.",
          4000
        );
      }
      return !isGreater;
    }

    resumeEditor.diffProfilePicture = function () {
      return (
        $scope.user.profile_picture_url &&
        resumeEditor.user.profile_picture_url !==
          $scope.user.profile_picture_url
      );
    };

    resumeEditor.updateProfilePicture = function () {
      if (resumeEditor.resumeID) {
        resumeService
          .simpleUpdateResume(resumeEditor.resumeID, {
            profile_picture_url: $scope.user.profile_picture_url,
          })
          .then(function () {
            resumeEditor.user.profile_picture_url =
              $scope.user.profile_picture_url;
            bindResumeTemplateData();
            $rootScope.emptyCreation = false;

            utilsService.deleteResumeId(
              user.userID,
              utilsService.getResumeId(user.userID)
            );

            var successString = "Profile picture updated successfully";
            buildSaveToastr(successString, "Success", 2000);
          })
          .catch(function (err) {
            err.data.message = err.data.message.replace(/,/g, ", ");
            err.data.message = err.data.message.replace(/"/g, "");
            showErrorMessage(err.data.message, 4000);
          });
      }
    };

    resumeEditor.saveTheResume = function (options) {
      // console.log("-- (Controller) resumeEditor.saveTheResume()");

      resumeEditor.downloadAttempts = constants.defaultDownloadAttempts;

      $scope.removeCkEditor();
      var isGood = true;
      // isGood = checkDates(resumeEditor.user.experience, false); // Right now the fixService always check and fix the dates.
      if (isGood) {
        // isGood = checkDates(resumeEditor.user.education, true); // Right now the fixService always check and fix the dates.
        if (isGood) {
          resumeEditor.user.achievement = buildAchievements(
            resumeEditor.user.achievements_awards
          ); // Force to update the html of the achievements before save the resume.
          var saveResume = deepCopy(resumeEditor);
          removeDateObj(saveResume);

          var isDuplicateSkills = hasDuplicates(
            angular.copy(saveResume.user.skills)
          );
          var isEmptySkills = emptySkills(angular.copy(saveResume.user.skills));

          // var isEmptyEmail = saveResume.user.email_address.address == '';
          var isEmptyEmail = true;
          if (
            typeof saveResume.user !== "undefined" &&
            typeof saveResume.user.email_address !== "undefined" &&
            typeof saveResume.user.email_address.address === "string" &&
            saveResume.user.email_address.address.length > 0
          ) {
            isEmptyEmail = false;
          }

          if (
            saveResume.resumeID &&
            !isDuplicateSkills &&
            !isEmptySkills &&
            !isEmptyEmail
          ) {
            $scope.pageCount = 0;
            $scope.hidePageCount = false;

            var resumeContent = {
              first_name: saveResume.user.first_name,
              last_name: saveResume.user.last_name,
              title: saveResume.title,
              about: saveResume.user.summary,
              profile_picture_url:
                typeof saveResume.user.profile_picture_url === "string"
                  ? saveResume.user.profile_picture_url
                  : "",
              education: saveResume.user.education,
              experience: saveResume.user.experience,
              skills: saveResume.user.skills,
              address: saveResume.address,
              phone_number: saveResume.phonenumber,
              email_address: saveResume.user.email_address
                ? saveResume.user.email_address
                : "",
              website: saveResume.website,
              achievement: saveResume.user.achievement,
              achievements_awards: saveResume.user.achievements_awards,
              references: saveResume.user.references,
              usedExport: saveResume.usedExport || "ats",
              resume_layout: resume_template_options[selectedResume].value,
              industry: resumeEditor.industry,
            };
            console.log(resumeContent);
            var resumeMeta = undefined;

            if (
              typeof options !== "undefined" &&
              options !== null &&
              typeof options.downloaded === "boolean"
            ) {
              resumeMeta = {
                downloaded: options.downloaded,
              };
            }

            if (
              typeof jobParseData !== "undefined" &&
              jobParseData !== null &&
              typeof JSON.stringify(jobParseData) === "string" &&
              JSON.stringify(jobParseData).length > 0
            ) {
              if (typeof resumeMeta === "undefined" || resumeMeta === null) {
                resumeMeta = {};
              }

              resumeMeta.jobDescriptionLink = "";
              resumeMeta.jobDescription = $("#jobDesc").html();
              resumeMeta.jobDescriptionParsed = JSON.stringify(jobParseData);
            }

            resumeService
              .updateResume(saveResume.resumeID, resumeContent, resumeMeta)
              .then(function (response) {
                $scope.updated = true;

                if (
                  resumeEditor.wizard &&
                  typeof response === "object" &&
                  response !== null &&
                  typeof response.resumeID !== "undefined" &&
                  response.resumeID.length > 0
                ) {
                  stateParams.resumeId = response.resumeID;
                }

                if (
                  response.message != undefined &&
                  response.message.includes("Error")
                ) {
                  if (response.message.includes("email"))
                    showErrorMessage(
                      $translate.instant("USER_PROFILE_INVALID_EMAIL_PERSONAL"),
                      4000
                    );
                  else showErrorMessage(response.message, 4000);
                } else if (
                  !response.content ||
                  typeof response.content !== "object"
                ) {
                  showErrorMessage(response.message, 4000);
                } else if (
                  !response.content ||
                  typeof response.content !== "object"
                ) {
                  showErrorMessage(
                    $translate.instant("RESUME_BUILDER_CHECK_DATA", 4000)
                  );
                } else {
                  var sortModified = false;
                  var experienceList = _.sortBy(
                    response.content.experience,
                    "order_index"
                  );
                  var educationList = _.sortBy(
                    response.content.education,
                    "order_index"
                  );

                  experienceList.forEach(function (exp, idx) {
                    if (
                      typeof exp !== "undefined" &&
                      typeof resumeEditor.user.experience[idx] !==
                        "undefined" &&
                      exp._id !== resumeEditor.user.experience[idx]._id
                    ) {
                      sortModified = true;
                    }
                  });
                  educationList.forEach(function (edu, idx) {
                    if (
                      typeof edu !== "undefined" &&
                      typeof resumeEditor.user.education[idx] !== "undefined" &&
                      edu._id !== resumeEditor.user.education[idx]._id
                    ) {
                      sortModified = true;
                    }
                  });

                  resumeService
                    .getResume(user.userID, saveResume.resumeID)
                    .then(function (resumeData) {
                      resumeEditor.resume = resumeData;
                      resumeEditor.resumeID = resumeData.resumeID;
                      resume = resumeEditor.resume;

                      resumeEditor.user.skills = resume.content.skills;
                      resumeEditor.user.achievements_awards =
                        resume.content.achievements_awards;
                      resumeEditor.user.references = resume.content.references;
                      resumeEditor.user.experience = resume.content.experience;
                      resumeEditor.user.education = resume.content.education;
                      bindResumeTemplateData();
                      updateSkillsRatings();
                      refillDropdown();
                      // var successString = 'Profile data saved successfully';
                      var successString =
                        "Your data has been saved, but you'll need to wait a minute before downloading";
                      if (fixServiceFinalMsg.length > 0)
                        successString = fixServiceFinalMsg;

                      if (sortModified) {
                        successString +=
                          "<br/>Your experience or education records sorting changed using the dates";
                      }
                      $rootScope.emptyCreation = false;

                      utilsService.deleteResumeId(
                        user.userID,
                        utilsService.getResumeId(user.userID)
                      );

                      buildSaveToastr(successString, "Success", 2000);
                      checkUnsavedDataUpdate();

                      if (errorMessage) {
                        errorMessage = false;
                      }
                      justSaved = true;
                      resumeEditor.isFirstTimeSaved = true;

                      $scope.isResumeDirty = false;
                      $scope.$emit("isResumeDirty", {
                        isResumeDirty: $scope.isResumeDirty,
                      });

                      $scope.$emit("successUpdateProfile", {
                        options: options,
                      });
                    });

                  // if (errorMessage) {
                  //     errorMessage = false;
                  // }
                  // justSaved = true;
                  // resumeEditor.isFirstTimeSaved = true;

                  // $scope.isResumeDirty = false;
                  // $scope.$emit('isResumeDirty', {isResumeDirty: $scope.isResumeDirty});

                  // $scope.$emit('successUpdateProfile', {
                  //     options: options
                  // });
                }
              })
              .catch(function (err) {
                err.data.message = err.data.message.replace(/,/g, ", ");
                err.data.message = err.data.message.replace(/"/g, "");
                if (
                  err.data.message.indexOf("pattern:") !== -1 &&
                  err.data.message.indexOf("number") !== -1
                ) {
                  err.data.message = "Please Enter a Valid Phone Number";
                }
                if (
                  err.data.message.indexOf("pattern:") !== -1 &&
                  err.data.message.indexOf("postal_code") !== -1
                ) {
                  err.data.message = "Please Enter a Valid Postal Code";
                }
                showErrorMessage(err.data.message, 4000);
              });
          } else if (isDuplicateSkills) {
            showErrorMessage(
              $translate.instant("RESUME_BUILDER_DUPLICATE_SKILL_ERROR"),
              4000
            );
          } else if (isEmptySkills) {
            showErrorMessage(
              $translate.instant("RESUME_BUILDER_EMPTY_SKILL_ERROR"),
              4000
            );
          } else if (isEmptyEmail) {
            showErrorMessage(
              $translate.instant("USER_PROFILE_INVALID_EMAIL_PERSONAL"),
              4000
            );
          } else {
            createNewResume();
          }
        }
      }
    };

    var objectToStylesString = function (object) {
      var string = "";
      Object.keys(object).forEach(function (key) {
        string += key + ":" + object[key] + "; ";
      });
      return string;
    };
    var buildAssessmentData = function () {
      if (resumeEditor.assessmentData && resumeEditor.assessmentData.types) {
        return resumeEditor.assessmentData.types.map(function (a) {
          a.styles = 'style="' + objectToStylesString(getTypeBarStyle(a)) + '"';
          return a;
        });
      }
      return {};
    };

    var generatePieChart = function (skills) {
      if (!skills) {
        return null;
      }

      var skillGroup = [];
      var skillMatrix = [];
      var skillsPerChart = 5;
      var groupIndex = 0;

      var maxSkillLevel = 5;
      var maxRadius = 24;
      var step = 4;

      var item = {};
      var ii;
      var radius;
      var circleLength;

      for (var i = 0; i < skills.length; i += 1) {
        item = {
          skill: skills[i].skill,
          proficiency: skills[i].proficiency,
          deleted: skills[i].deleted,
          index: i,
        };

        ii = i % skillsPerChart;
        radius = maxRadius - step * ii;
        circleLength = 2 * Math.PI * radius;

        item.svgOptions = {
          path:
            "M" +
            step * ii +
            "," +
            maxRadius +
            " a" +
            radius +
            "," +
            radius +
            " 0 1,1 0,1",
          circleLength: circleLength.toFixed(2),
          skillLength: (
            (item.proficiency / maxSkillLevel) *
            circleLength
          ).toFixed(2),
        };
        skillGroup.push(item);

        if (ii === skillsPerChart - 1) {
          skillMatrix[groupIndex] = skillGroup;
          groupIndex += 1;
          skillGroup = [];
        }
      }

      if (ii !== skillsPerChart - 1) {
        skillMatrix[groupIndex] = skillGroup;
      }
      return skillMatrix;
    };

    // This limits the list to a specified number of active (not deleted) skills
    var limitSkills = function (skillsArray, limit) {
      var skillsLimit = [];
      if (!limit) {
        limit = constants.maximumResumeSkills;
      }
      if (Array.isArray(skillsArray)) {
        var i;
        var j = 0;
        for (i = 0; i < skillsArray.length; i++) {
          if (!skillsArray[i].deleted) skillsLimit.push(skillsArray[j++]);
          if (j >= limit) break;
        }
      }
      return skillsLimit;
    };

    var bindResumeTemplateData = function (action) {
      resumeEditor.user.achievement = buildAchievements(
        resumeEditor.user.achievements_awards
      );

      orderExperiences();
      orderEducations();
      orderSkills();

      if (resumeEditor.phonenumber)
        resumeEditor.phonenumber.number = phoneFormatter.format(
          resumeEditor.phonenumber.number
        );

      if ($scope.templateData) {
        var contactInfo = {
          address: resumeEditor.address,
          phone: resumeEditor.phonenumber
            ? resumeEditor.phonenumber.number
            : "",
          about: resumeEditor.user.summary,
          email: resumeEditor.user.email_address
            ? resumeEditor.user.email_address.address
            : "",
          website: resumeEditor.website ? resumeEditor.website : "",
        };

        // Seems the date_ values don't get update on a save???
        $.each(resumeEditor.user.experience, function (n, v) {
          // v.endDateObj = (v.endDateObj && v.endDateObj !== 'Present') ? utilsService.formatDate(v.endDateObj) : 'Present';
          // v.startDateObj = (v.startDateObj && v.startDateObj !== '') ? utilsService.formatDate(v.startDateObj) : '';

          if (v.endDateObj && v.endDateObj !== "Present") {
            v.endDateObj = utilsService.formatDate(v.endDateObj);
            v.endShortDateObj = utilsService.formatDate(v.endDateObj, "YYYY");
          } else {
            v.endDateObj = "Present";
            v.endShortDateObj = "Present";
          }

          if (v.startDateObj && v.startDateObj !== "") {
            v.startDateObj = utilsService.formatDate(v.startDateObj);
            v.startShortDateObj = utilsService.formatDate(
              v.startDateObj,
              "YYYY"
            );
          } else {
            v.startDateObj = "";
            v.startShortDateObj = "";
          }
        });

        $.each(resumeEditor.user.education, function (n, v) {
          // v.endDateObj = (v.endDateObj && v.endDateObj !== 'Present') ? utilsService.formatDate(v.endDateObj) : 'Present';
          // v.startDateObj = (v.startDateObj && v.startDateObj !== '') ? utilsService.formatDate(v.startDateObj) : '';

          if (v.endDateObj && v.endDateObj !== "Present") {
            v.endDateObj = utilsService.formatDate(v.endDateObj);
            v.endShortDateObj = utilsService.formatDate(v.endDateObj, "YYYY");
          } else {
            v.endDateObj = "Present";
            v.endShortDateObj = "Present";
          }

          if (v.startDateObj && v.startDateObj !== "") {
            v.startDateObj = utilsService.formatDate(v.startDateObj);
            v.startShortDateObj = utilsService.formatDate(
              v.startDateObj,
              "YYYY"
            );
          } else {
            v.startDateObj = "";
            v.startShortDateObj = "";
          }
        });

        checkUnsavedDataUpdate(action);

        var skillsLimit = limitSkills(resumeEditor.user.skills);

        var address = nonNullObject(contactInfo.address)
            ? contactInfo.address
            : {},
          hasState = nonEmptyString(address.state),
          hasCity = nonEmptyString(address.city),
          hasCityOrState = hasCity || hasState,
          hasPhone = nonEmptyString(contactInfo.phone),
          hasEmail = nonEmptyString(contactInfo.email),
          hasWebsite = nonEmptyString(contactInfo.website),
          hasContactInfo = hasCityOrState || hasPhone || hasEmail || hasWebsite;

        var objToRender = {
          user: resumeEditor.user,
          education: prepareEducation(resumeEditor.user.education),
          experience: resumeEditor.user.experience,
          hasExperience: checkEmptyArray(resumeEditor.user.experience),
          hasEducation: checkEmptyArray(resumeEditor.user.education),
          contactInfo: contactInfo,
          skills: skillsLimit,
          references: resumeEditor.user.references,
          hasSkills: checkEmptyArray(skillsLimit),
          hasUserAvatar: !!resumeEditor.user.profile_picture_url,
          pictureURL: resumeEditor.user.profile_picture_url,
          nameInitials: utilsService.getNameInitials(
            resumeEditor.user.first_name,
            resumeEditor.user.last_name
          ),
          firstInitial: resumeEditor.user.first_name.substring(0, 1),
          lastInitial: resumeEditor.user.last_name.substring(0, 1),
          hasMilitaryExperience: _isSpecificSectionPresent(
            resumeEditor.user.experience,
            "Military"
          ),
          hasCertificationEducation: _isSpecificSectionPresent(
            resumeEditor.user.education,
            "certification"
          ),
          hasAchievement: checkEmptyArray(
            resumeEditor.user.achievements_awards
          ),
          hasReferences: checkEmptyArray(resumeEditor.user.references),
          achievement: resumeEditor.user.achievement,
          achievementsAwards: prepareAchievementsAwards(
            resumeEditor.user.achievements_awards
          ),

          hasState: hasState,
          hasCity: hasCity,
          hasCityOrState: hasCityOrState,
          hasPhone: hasPhone,
          hasEmail: hasEmail,
          hasWebsite: hasWebsite,
          hasContactInfo: hasContactInfo,

          hasStudyOrDegree: checkEmptyArray(resumeEditor.user.education),
          hasAssessment: true,
          // hasLinks: true,
          // links: resumeEditor.user.links,
          assessmentData: buildAssessmentData(),
          showDatesDash: function () {
            return function (text, render) {
              return render("{{{startDateObj}}}").length > 0 &&
                render("{{{endDateObj}}}").length > 0
                ? "-"
                : "";
            };
          },
          showDegreeDash: function () {
            return function (text, render) {
              if (render("{{{field_of_study}}}").length > 0) return "-";
              else return "";
            };
          },
          showFieldOfStudy: function () {
            return function (text, render) {
              if (render("{{{field_of_study}}}").length > 0) return "";
              else return "display: none;";
            };
          },
        };

        if (
          $scope.selectedTemplate &&
          $scope.selectedTemplate.value === "infographic"
        ) {
          objToRender.skillsChart = generatePieChart(skillsLimit);
        }
        objToRender.user.title = resumeEditor.title;

        // console.log("-- (Controller) resumeEditor.bindResumeTemplateData() - objToRender: ", objToRender);

        $(".resume-container").html(
          Mustache.render($scope.templateData, objToRender)
        );
        $scope.loadingData = false;
        $compile(
          $(".avatar-button-container").attr("style", "display: inline;")
        )($scope);
        $compile(
          $(".avatar-button-container-delete").attr("style", "display: inline;")
        )($scope);
      }
    };

    // Based on a backend method used for the same:
    var _isSpecificSectionPresent = function (section, kind) {
      if (!_.isEmpty(section) && kind) {
        return _.filter(section, function (data) {
          return data.kind === kind && !data.deleted;
        })[0];
      } else {
        return false;
      }
    };

    var checkEmptyArray = function (arr) {
      if (typeof arr !== "undefined" && arr !== null && arr.length > 0) {
        var hasNonDeleted = arr.find(function (item) {
          return (
            typeof item === "object" &&
            (typeof item.deleted === "undefined" || item.deleted === false)
          );
        });
        if (hasNonDeleted) return true;
      }
      return false;
    };

    var prepareEducation = function (list) {
      if (list.length > 0) {
        var list2 = list.map(function (item) {
          if (typeof item === "object" && item.endDateObj === "Present") {
            item.endDateObj = "";
          }
          if (
            item.isCertification &&
            item.institution === "-- MISSING DATA HERE --"
          ) {
            item.institution = "";
          }
          return item;
        });
        return list2;
      }
      return list;
    };

    var prepareAchievementsAwards = function (list) {
      if (list.length > 0) {
        $.each(list, function (n, v) {
          if (v.startDateObj && v.startDateObj !== "") {
            v.startDateObj = utilsService.formatDate(v.startDateObj);
          } else {
            v.startDateObj = "";
          }
        });
      }
      return list;
    };

    var convertProficiencyToArray = function (index) {
      var skill = resumeEditor.user.skills[index];
      skill.fullBullets = [];
      // passing index value in fullBullets and emptyBullets array, in place of empty value array
      var j = 1;
      for (j; j <= skill.proficiency; j += 1) {
        skill.fullBullets.push(j);
      }
      skill.emptyBullets = [];
      if (j <= 5) {
        for (j; j <= 5; j += 1) {
          skill.emptyBullets.push(j);
        }
      }
    };

    $scope.templateData = "";

    this.movePrev = function () {
      if ($scope.prevDisabled) {
        return;
      }

      var hide = true;
      $scope.isResumeDirty = true;
      $scope.$emit("isResumeDirty", {
        isResumeDirty: $scope.isResumeDirty,
      });
      selectedResume = selectedResume - 1;
      if (selectedResume <= 0) {
        selectedResume = 0;
        $scope.prevDisabled = true;
        $scope.nextDisabled = false;
        hide = false;
      } else {
        $scope.prevDisabled = false;
        $scope.nextDisabled = false;
      }
      layout = resume_template_options[selectedResume].value;
      $scope.selectedTemplate = resume_template_options[selectedResume];
      $scope.selectedTemplateIndex = selectedResume + 1;
      $scope.resumeselected = resume_template_options[selectedResume];
      showTemplateThumb("prevMove");
    };

    this.changeResume = function () {
      var val = resume_template_options.indexOf($scope.resumeselected);
      var otro = val;
      var hide = true;
      $scope.isResumeDirty = true;
      $scope.$emit("isResumeDirty", {
        isResumeDirty: $scope.isResumeDirty,
      });
      selectedResume = resume_template_options.indexOf($scope.resumeselected);

      if (selectedResume >= resume_template_options.length - 1) {
        selectedResume = resume_template_options.length - 1;
        $scope.nextDisabled = true;
        $scope.prevDisabled = false;
        hide = false;
      } else {
        $scope.nextDisabled = false;
        $scope.prevDisabled = false;
      }

      layout = resume_template_options[selectedResume].value;
      $scope.selectedTemplate = resume_template_options[selectedResume];
      $scope.selectedTemplateIndex =
        resume_template_options.indexOf($scope.resumeselected) + 1;
      showTemplateThumb("nextMove");
    };

    this.moveNext = function () {
      if ($scope.nextDisabled) {
        return;
      }

      var hide = true;
      $scope.isResumeDirty = true;
      $scope.$emit("isResumeDirty", {
        isResumeDirty: $scope.isResumeDirty,
      });
      selectedResume = selectedResume + 1;

      if (selectedResume >= resume_template_options.length - 1) {
        selectedResume = resume_template_options.length - 1;
        $scope.nextDisabled = true;
        $scope.prevDisabled = false;
        hide = false;
      } else {
        $scope.nextDisabled = false;
        $scope.prevDisabled = false;
      }

      layout = resume_template_options[selectedResume].value;
      $scope.selectedTemplate = resume_template_options[selectedResume];
      $scope.selectedTemplateIndex = selectedResume + 1;
      $scope.resumeselected = resume_template_options[selectedResume];
      showTemplateThumb("nextMove");
    };

    if (selectedResume === -1) {
      selectedResume = 0;
    }
    // var layout = resume_template_options[selectedResume].value;
    showTemplateThumb();

    function showTemplateThumb(action) {
      resumeEditor.resumeStyleDeferred = $q.defer();

      // $scope.apiCssUrl = constants.apiCssUrl + layout + '.css';
      $scope.apiCssUrl = constants.resumeBucketUrl + layout + ".css";
      var fileLocation = constants.resumeBucketUrl + layout + ".ejs";
      //var fileLocation = 'http://localhost:3000/templates/'+layout+'.ejs';

      var cssLink = $('<link rel="stylesheet" type="text/css">').attr(
        "href",
        $scope.apiCssUrl
      );
      cssLink.on("load", function () {
        resumeEditor.resumeStyleDeferred.resolve();
      });
      $("#resume-styles-wrapper").empty().append(cssLink);

      $scope.isResumeLoading = true;
      $scope.nextDisabled = true;
      $scope.prevDisabled = true;

      $q.all([
        $http.get(fileLocation),
        resumeEditor.resumeStyleDeferred.promise,
      ])
        .then(function (response) {
          $scope.templateData = response[0].data;
          bindResumeTemplateData(action);

          if (resumeEditor.assessmentData) {
            setRadarChart(
              "assessment-radar-canvas",
              resumeEditor.assessmentData.mainTypes
            );
          }
        })
        .finally(function () {
          $scope.isResumeLoading = false;
          $scope.nextDisabled =
            selectedResume >= resume_template_options.length - 1;
          $scope.prevDisabled = selectedResume <= 0;
        });
    }

    resumeEditor.downloadResume = function (
      $event,
      isNotShowConfirmSaveDialog
    ) {
      // console.log("-- (Controller) resumeEditor.downloadResume()");

      if ($scope.isResumeDirty) {
        // console.log("-- (Controller) resumeEditor.downloadResume - Pass 1!");

        if (isNotShowConfirmSaveDialog) {
          // console.log("-- (Controller) resumeEditor.downloadResume - Pass 1.1!");

          resumeEditor.validateTheResume({
            action: "downloadResume",
            downloaded: false,
          });
        } else {
          $scope.isDownload = true;
          showConfirmSaveDialog();
        }
      } else {
        // console.log("-- (Controller) resumeEditor.downloadResume - Pass 2!");

        if ($event) {
          $event.preventDefault();
        }

        continueDownload();
      }
    };

    resumeEditor.downloadAndPrint = false;

    resumeEditor.print = function ($event, isNotShowConfirmSaveDialog) {
      resumeEditor.downloadAndPrint = true;

      if ($scope.isResumeDirty) {
        if (isNotShowConfirmSaveDialog) {
          resumeEditor.validateTheResume({
            action: "downloadResume",
            downloaded: false,
          });
        } else {
          $scope.isDownload = true;
          showConfirmSaveDialog();
        }
      } else {
        if ($event) {
          $event.preventDefault();
        }
        continueDownload();
      }
    };

    resumeEditor.previewEditor = function ($event) {
      if (resumeEditor.wizard) {
        return;
      }

      if ($scope.isResumeDirty) {
        $scope.isDownload = false;
        showConfirmSaveDialog();
      } else {
        if ($event) {
          $event.preventDefault();
        }
        previewEditorGo();
      }
    };
    $scope.getOrganizationCss = function (css, returnEmpty) {
      return organizationService.getOrganizationCss(css, returnEmpty);
    };
    function showWaitingDialog() {
      var dialog = {
        template:
          "app/resume-builder/template/resume-generation-waiting-dialog.html",
        controller: this,
        closeByDocument: false,
        closeByEscape: true,
        showClose: false,
        closeByNavigation: true,
        scope: $scope,
        width: "455px",
        height: "547px",
        className: $scope.getOrganizationCss(""),
      };
      ngDialog.openConfirm(dialog);
    }

    function showConfirmSaveDialog() {
      var dialog = {
        template: "app/resume-builder/template/resume-save-confirm-dialog.html",
        controller: this,
        closeByDocument: false,
        closeByEscape: true,
        showClose: false,
        closeByNavigation: true,
        scope: $scope,
        width: "425px",
        height: "200px",
      };
      ngDialog.openConfirm(dialog);
    }

    $scope.closeConfirmSaveDialog = function () {
      ngDialog.close();
    };

    $scope.cancelAndDownload = function () {
      $scope.isResumeDirty = false;
      $scope.$emit("isResumeDirty", {
        isResumeDirty: $scope.isResumeDirty,
      });
      ngDialog.close();
      if ($scope.isDownload) continueDownload();
      else previewEditorGo();
    };

    function continueDownload() {
      if (resumeEditor.checkResumeDownloadCounter()) {
        $scope.currentlyDownloadingResume = false;
        $scope.downloadAvailable = false;
        $scope.resumeDownloading = true;

        // console.log('-- (Controller) - resumeEditor.downloadResume() - resumeEditor.downloadAttempts: ' + resumeEditor.downloadAttempts);

        if (resumeEditor.downloadAttempts == constants.defaultDownloadAttempts)
          showWaitingDialog();
        resumeEditor.downloadAttempts--;

        if (!$scope.downloadResumeLink) {
          $scope.downloadResumeLink = getDownloadResumeLink();
        }

        var resumeType = resume.usedExport;

        if (resumeEditor.downloadAndPrint) {
          resumeType = "nonats";
        }

        resumeService
          .downloadResume(
            $scope.downloadResumeLink.substring(
              $scope.downloadResumeLink.lastIndexOf("/") + 1
            ),
            resumeType || "ats",
            JSON.stringify($scope.assessmentData)
          )
          .then(function (response) {
            if (
              typeof response !== "undefined" &&
              typeof response.status !== "undefined" &&
              response.status === 200
            ) {
              var loaderContainer = angular.element(
                document.querySelector(".loader-container")
              );
              loaderContainer.css("animation", "none");
              var opacityDiv = angular.element(
                document.querySelector(".loader-img-progress")
              );
              opacityDiv.css("animation", "none");
              var resumeFile = resumeType === "nonats" ? "resume" : "hybrid";

              if ($scope.resumeDownloading) {
                $scope.resumeFilePath =
                  constants.resumeStorage +
                  user.userID +
                  "/" +
                  stateParams.resumeId +
                  "/" +
                  resumeFile +
                  ".pdf";
                $scope.resumeDownloading = false;
                $scope.downloadAvailable = true;
                $scope.downloadResumeFromS3();
              }
            } else {
              if (
                typeof response !== "undefined" &&
                typeof response.status !== "undefined" &&
                response.status === 500 &&
                resumeEditor.downloadAttempts > 0
              ) {
                setTimeout(function () {
                  continueDownload();
                }, constants.defaultMillisecondsBetweenDownloadAttempts);

                return;
              }

              resumeEditor.downloadAttempts = constants.defaultDownloadAttempts;
              $scope.resumeDownloading = false;
              $scope.closeWaitingDialog();

              try {
                if (response.status === 403) {
                  localStorage.setItem(
                    "toSubscriptionFrom",
                    "resume-profile/" + stateParams.resumeId
                  );
                  $location.path("subscription");
                } else {
                  buildSaveToastr(response.data.message, "", 4000);
                }
              } catch (e) {
                console.error(e);
              }
            }
          })
          .catch(function (error) {
            $scope.resumeDownloading = false;
            $scope.closeWaitingDialog();

            if (error.status === 403) {
              localStorage.setItem(
                "toSubscriptionFrom",
                "resume-profile/" + stateParams.resumeId
              );
              $location.path("subscription");
            } else {
              showErrorMessage(error.data.message, 4000);
            }
          });
      }
    }

    $scope.downloadResumeFromS3 = function () {
      var print = resumeEditor.downloadAndPrint;
      resumeEditor.downloadAndPrint = false;

      $scope.currentlyDownloadingResume = true;
      resumeService.downloadResumeFromS3(
        $scope.resumeFilePath,
        resumeEditor.user.first_name +
          " " +
          resumeEditor.user.last_name +
          " - " +
          resumeEditor.title +
          ".pdf",
        print
      );
      resumeEditor.downloadAttempts = constants.defaultDownloadAttempts;

      var cv = resumeEditor.getCounterVars();

      if (
        (cv.firstLoad && !$scope.downloaded) ||
        (!cv.firstLoad && !resumeEditor.resume.meta.downloaded)
      ) {
        // console.log("-- (Controller) resumeEditor.$scope.downloadResumeFromS3() - $localStorage.user: ", $localStorage.user);

        try {
          if (
            typeof $localStorage.user === "object" &&
            $localStorage.user.resumeCounter > -1
          ) {
            userService
              .decreaseResumeCounter(
                $localStorage.user.userID,
                resumeEditor.resumeID
              )
              .then(function (response) {
                try {
                  if (
                    typeof response.data === "object" &&
                    response.data.downloaded
                  ) {
                    resumeEditor.resume.meta.downloaded = true;
                  }
                } catch (e) {
                  console.error(
                    "-- (Controller) resumeEditor.$scope.downloadResumeFromS3() - e: ",
                    e
                  );
                }
              });
          }
        } catch (e) {
          console.error(
            "-- (Controller) resumeEditor.$scope.downloadResumeFromS3() - e: ",
            e
          );
        }
      } else {
        resumeService.updateDownloaded(resumeEditor.resumeID);
      }

      $scope.downloaded = true;
    };

    $scope.closeWaitingDialog = function ($event) {
      var status = null;
      if ($event) {
        status = $($event.currentTarget).attr("data-status");
        if (status === "cancel") {
          $scope.resumeDownloading = false;
        } else if (status === "finish") {
          $scope.$emit("successDownloadResume");
        }
      }
      ngDialog.close();
    };

    function buildToastr(title, content, to) {
      $rootScope.toast = toastr.info(content, title, {
        progressBar: true,
        timeOut: to,
        toastClass: "toast",
        preventDuplicates: true,
        allowHtml: true,
        positionClass: "toast-top-full-width",
        hideDuration: to,
        closeButton: true,
        showDuration: to,
        extendedTimeOut: to,
        hideMethod: "noop",
      });
    }

    function buildSaveToastr(content, title, timeout) {
      var t = toastr.info(content, title, {
        progressBar: true,
        timeOut: timeout,
        toastClass: "toast-success",
        preventDuplicates: true,
        allowHtml: true,
        positionClass: "toast-top-full-width",
        hideDuration: timeout,
        closeButton: true,
        showDuration: timeout,
        extendedTimeOut: timeout,
        hideMethod: "noop",
      });

      $rootScope.toast = t;
    }

    function showErrorMessage(msg, to) {
      if (!errorMessage) {
        buildToastr("Error! Progress not saved.", msg, to);
        errorMessage = true;
        $timeout(function () {
          errorMessage = false;
        }, to);
      }
    }

    $scope.paymentSuccess = function (updatedUser, closed) {
      $scope.paymentRequired = false;
      if (updatedUser != null) {
        $scope.user = updatedUser;
        resumeEditor.user = updatedUser;
        $scope.validSubscription = true;
        if (!closed) continueDownload();
      }
    };
    $scope.paymentError = function (error) {
      console.error(error);
    };

    resumeEditor.editData = function () {
      $scope.showJobDesc = false;
      resumeEditor.hasJobDesc = true;
      resumeEditor.goToPage("edit_resume");
    };

    function checkUserPayment() {
      return userService.isPaidFeatureEnabled($scope.user, "job2resume");
    }

    resumeEditor.showJobDesc = function () {
      if (checkUserPayment()) {
        $scope.showJobDesc = true;
        resumeEditor.goToPage("j2r");
      } else {
        localStorage.setItem(
          "toSubscriptionFrom",
          "resume-profile/" + resumeEditor.resumeID
        );
        $location.path("subscription");
      }
    };

    function resetJobDesc() {
      $scope.matchList = [];
      $scope.reqMatchList = [];
      $scope.skillsList = [];
      $scope.missingSkills = [];
      //$scope.categories = [];
      //$scope.subCagetories = [];
      $scope.summaryCompare = [];
      $scope.summaryMissing = "";
      $scope.summaryFound = "";
      $scope.jobHTML = "";
      resumeEditor.requiredSkillsList = [];
      resumeEditor.matchingSkillsList = [];
      resumeEditor.matchedDegrees = [];
      resumeEditor.employersName = "";
      resumeEditor.jobTitle = "";
      resumeEditor.location = "";
      resumeEditor.minimumYears = null;
      resumeEditor.maximumYears = null;
      $scope.summaryKeywordsAdded = [];
      $scope.summaryKeywordsAddedStr = " ";
      $scope.experienceKeywordsAdded = [];
      $scope.experienceKeywordsAddedCount = [];

      for (var i = 0; i < resumeEditor.user.experience.length; i++) {
        $scope.experienceKeywordsAdded.push({});
        $scope.experienceKeywordsAddedCount.push(0);
      }
      var aux = $scope.experienceKeywordsAdded;
      $("#jobDesc").html("");
      resumeEditor.jobDesc = "";
    }

    resumeEditor.closeJobDesc = function () {
      resumeEditor.goToPage("edit_resume");
      $scope.showJobDesc = false;
      resetJobDesc();
    };

    $scope.showSummaryMissingModal = false;

    resumeEditor.openSummaryMissingModal = function () {
      window.scroll(0, 0);
      $scope.showSummaryMissingModal = true;
      resumeEditor.resetModalScroll();
    };

    resumeEditor.addSummaryMissingKeyword = function (keyword) {
      $scope.summaryKeywordsAddedStr += " " + keyword;
      $scope.summaryKeywordsAdded.push({ show: true, keyword: keyword });
      resumeEditor.parseSummaryKeyWords();
    };

    resumeEditor.closeSummaryMissingModal = function () {
      $scope.showSummaryMissingModal = false;
    };

    resumeEditor.showRequiredSkills = function () {
      window.scroll(0, 0);
      $scope.showSkillsReq = true;
      resumeEditor.resetModalScroll();
    };

    resumeEditor.experienceRequiredSkillsSelected = -1;

    resumeEditor.showExperienceRequiredSkills = function (idx) {
      // console.log('-- (Controller) - resumeEditor.showExperienceRequiredSkills() - idx: ' + idx);

      try {
        resumeEditor.updateExperienceMissingSkillList(idx);
        resumeEditor.experienceRequiredSkillsSelected = idx;
        window.scroll(0, 0);
        $scope.showExpSkills = true;
        resumeEditor.resetModalScroll();
      } catch (e) {
        console.error(
          "-- (Controller) - resumeEditor.showExperienceRequiredSkills(): ",
          e
        );
      }
    };

    resumeEditor.addExperienceMissingSkill = function (idx, skill) {
      // console.log('-- (Controller) - resumeEditor.addExperienceMissingSkill() - idx: ' + idx);
      // console.log('-- (Controller) - resumeEditor.addExperienceMissingSkill() - skill: ' + skill);

      try {
        $scope.experienceKeywordsAdded[idx][skill] = true;
        $scope.experienceKeywordsAddedCount[idx]++;
        resumeEditor.experienceRequiredSkillsSelected = idx;
        resumeEditor.updateExperienceMissingSkillList(
          resumeEditor.experienceRequiredSkillsSelected
        );
      } catch (e) {
        console.error(
          "-- (Controller) - resumeEditor.addExperienceMissingSkill(): ",
          e
        );
      }
    };

    resumeEditor.remExperienceMissingSkill = function (idx, skill) {
      // console.log('-- (Controller) - resumeEditor.addExperienceMissingSkill() - idx: ' + idx);
      // console.log('-- (Controller) - resumeEditor.addExperienceMissingSkill() - skill: ' + skill);

      try {
        delete $scope.experienceKeywordsAdded[idx][skill];
        $scope.experienceKeywordsAddedCount[idx]--;
        resumeEditor.experienceRequiredSkillsSelected = idx;
        resumeEditor.updateExperienceMissingSkillList(
          resumeEditor.experienceRequiredSkillsSelected
        );
      } catch (e) {
        console.error(
          "-- (Controller) - resumeEditor.remExperienceMissingSkill(): ",
          e
        );
      }
    };

    resumeEditor.closeExperienceRequiredSkills = function () {
      $scope.showExpSkills = false;

      resumeEditor.isEditable(
        "experience_" + resumeEditor.experienceRequiredSkillsSelected
      );
      resumeEditor.experienceRequiredSkillsSelected = -1;
    };

    resumeEditor.resetModalScroll = function () {
      try {
        var arr = $(".designation-blocks");

        setTimeout(function () {
          arr.each(function (idx) {
            if (typeof arr[idx] !== "undefined" && arr[idx] !== null) {
              arr[idx].scroll(0, 0);
            }
          });
        }, 100);
      } catch (e) {
        console.error("-- (Controller) - resumeEditor.resetModalScroll(): ", e);
      }
    };

    resumeEditor.closeRequiredSkills = function () {
      $scope.showSkillsReq = false;
    };

    resumeEditor.showExperienceSkills = function () {
      window.scroll(0, 0);
      $scope.showExpSkills = true;
      resumeEditor.resetModalScroll();
    };

    resumeEditor.closeExperienceSkills = function () {
      $scope.showExpSkills = false;
    };

    resumeEditor.showIndustries = function () {
      if (resumeEditor.industry) {
        $("#searchIndustries").val(resumeEditor.industry);
        $scope.industriesFilter = resumeEditor.industry;
        $scope.filterIndustries();
      }
      $scope.showIndustry = true;
    };

    resumeEditor.closeIndustries = function () {
      $scope.showIndustry = false;
      $scope.industriesFilter = "";
      $scope.filterIndustries();
    };

    resumeEditor.saveIndustries = function () {
      resumeEditor.industry = $scope.selectedIndustry;
      resumeEditor.closeIndustries();
    };

    resumeEditor.setIndustry = function (industry) {
      $scope.selectedIndustry = industry;
    };

    // >>> KSH this shit should be in a db or loaded resource file
    $scope.industries = [
      {
        title: "Accounting",
        value: "Accounting",
      },
      {
        title: "Airlines/Aviation",
        value: "Airlines/Aviation",
      },
      {
        title: "Alternative Dispute Resolution",
        value: "Alternative Dispute Resolution",
      },
      {
        title: "Alternative Medicine",
        value: "Alternative Medicine",
      },
      {
        title: "Animation",
        value: "Animation",
      },
      {
        title: "Apparel & Fashion",
        value: "Apparel & Fashion",
      },
      {
        title: "Architecture & Planning",
        value: "Architecture & Planning",
      },
      {
        title: "Arts and Crafts",
        value: "Arts and Crafts",
      },
      {
        title: "Automotive",
        value: "Automotive",
      },
      {
        title: "Aviation & Aerospace",
        value: "Aviation & Aerospace",
      },
      {
        title: "Banking",
        value: "Banking",
      },
      {
        title: "Biotechnology",
        value: "Biotechnology",
      },
      {
        title: "Broadcast Media",
        value: "Broadcast Media",
      },
      {
        title: "Building Materials",
        value: "Building Materials",
      },
      {
        title: "Business Supplies and Equipment",
        value: "Business Supplies and Equipment",
      },
      {
        title: "Capital Markets",
        value: "Capital Markets",
      },
      {
        title: "Chemicals",
        value: "Chemicals",
      },
      {
        title: "Civic & Social Organization",
        value: "Civic & Social Organization",
      },
      {
        title: "Civil Engineering",
        value: "Civil Engineering",
      },
      {
        title: "Commercial Real Estate",
        value: "Commercial Real Estate",
      },
      {
        title: "Computer & Network Security",
        value: "Computer & Network Security",
      },
      {
        title: "Computer Games",
        value: "Computer Games",
      },
      {
        title: "Computer Hardware",
        value: "Computer Hardware",
      },
      {
        title: "Computer Networking",
        value: "Computer Networking",
      },
      {
        title: "Computer Software",
        value: "Computer Software",
      },
      {
        title: "Construction",
        value: "Construction",
      },
      {
        title: "Consumer Electronics",
        value: "Consumer Electronics",
      },
      {
        title: "Consumer Goods",
        value: "Consumer Goods",
      },
      {
        title: "Consumer Services",
        value: "Consumer Services",
      },
      {
        title: "Cosmetics",
        value: "Cosmetics",
      },
      {
        title: "Dairy",
        value: "Dairy",
      },
      {
        title: "Defense & Space",
        value: "Defense & Space",
      },
      {
        title: "Design",
        value: "Design",
      },
      {
        title: "Education Management",
        value: "Education Management",
      },
      {
        title: "E-Learning",
        value: "E-Learning",
      },
      {
        title: "Electrical/Electronic Manufacturing",
        value: "Electrical/Electronic Manufacturing",
      },
      {
        title: "Entertainment",
        value: "Entertainment",
      },
      {
        title: "Environmental Services",
        value: "Environmental Services",
      },
      {
        title: "Events Services",
        value: "Events Services",
      },
      {
        title: "Executive Office",
        value: "Executive Office",
      },
      {
        title: "Facilities Services",
        value: "Facilities Services",
      },
      {
        title: "Farming",
        value: "Farming",
      },
      {
        title: "Financial Services",
        value: "Financial Services",
      },
      {
        title: "Fine Art",
        value: "Fine Art",
      },
      {
        title: "Fishery",
        value: "Fishery",
      },
      {
        title: "Food & Beverages",
        value: "Food & Beverages",
      },
      {
        title: "Food Production",
        value: "Food Production",
      },
      {
        title: "Fund-Raising",
        value: "Fund-Raising",
      },
      {
        title: "Furniture",
        value: "Furniture",
      },
      {
        title: "Gambling & Casinos",
        value: "Gambling & Casinos",
      },
      {
        title: "Glass, Ceramics & Concrete",
        value: "Glass, Ceramics & Concrete",
      },
      {
        title: "Government Administration",
        value: "Government Administration",
      },
      {
        title: "Government Relations",
        value: "Government Relations",
      },
      {
        title: "Graphic Design",
        value: "Graphic Design",
      },
      {
        title: "Health, Wellness and Fitness",
        value: "Health, Wellness and Fitness",
      },
      {
        title: "Higher Education",
        value: "Higher Education",
      },
      {
        title: "Hospital & Health Care",
        value: "Hospital & Health Care",
      },
      {
        title: "Hospitality",
        value: "Hospitality",
      },
      {
        title: "Human Resources",
        value: "Human Resources",
      },
      {
        title: "Import and Export",
        value: "Import and Export",
      },
      {
        title: "Individual & Family Services",
        value: "Individual & Family Services",
      },
      {
        title: "Industrial Automation",
        value: "Industrial Automation",
      },
      {
        title: "Information Services",
        value: "Information Services",
      },
      {
        title: "Information Technology and Services",
        value: "Information Technology and Services",
      },
      {
        title: "Insurance",
        value: "Insurance",
      },
      {
        title: "International Affairs",
        value: "International Affairs",
      },
      {
        title: "International Trade and Development",
        value: "International Trade and Development",
      },
      {
        title: "Internet",
        value: "Internet",
      },
      {
        title: "Investment Banking",
        value: "Investment Banking",
      },
      {
        title: "Investment Management",
        value: "Investment Management",
      },
      {
        title: "Judiciary",
        value: "Judiciary",
      },
      {
        title: "Law Enforcement",
        value: "Law Enforcement",
      },
      {
        title: "Law Practice",
        value: "Law Practice",
      },
      {
        title: "Legal Services",
        value: "Legal Services",
      },
      {
        title: "Legislative Office",
        value: "Legislative Office",
      },
      {
        title: "Leisure, Travel & Tourism",
        value: "Leisure, Travel & Tourism",
      },
      {
        title: "Libraries",
        value: "Libraries",
      },
      {
        title: "Logistics and Supply Chain",
        value: "Logistics and Supply Chain",
      },
      {
        title: "Luxury Goods & Jewelry",
        value: "Luxury Goods & Jewelry",
      },
      {
        title: "Machinery",
        value: "Machinery",
      },
      {
        title: "Management Consulting",
        value: "Management Consulting",
      },
      {
        title: "Maritime",
        value: "Maritime",
      },
      {
        title: "Market Research",
        value: "Market Research",
      },
      {
        title: "Marketing and Advertising",
        value: "Marketing and Advertising",
      },
      {
        title: "Mechanical or Industrial Engineering",
        value: "Mechanical or Industrial Engineering",
      },
      {
        title: "Media Production",
        value: "Media Production",
      },
      {
        title: "Medical Devices",
        value: "Medical Devices",
      },
      {
        title: "Medical Practice",
        value: "Medical Practice",
      },
      {
        title: "Mental Health Care",
        value: "Mental Health Care",
      },
      {
        title: "Military",
        value: "Military",
      },
      {
        title: "Mining & Metals",
        value: "Mining & Metals",
      },
      {
        title: "Motion Pictures and Film",
        value: "Motion Pictures and Film",
      },
      {
        title: "Museums and Institutions",
        value: "Museums and Institutions",
      },
      {
        title: "Music",
        value: "Music",
      },
      {
        title: "Nanotechnology",
        value: "Nanotechnology",
      },
      {
        title: "Newspapers",
        value: "Newspapers",
      },
      {
        title: "Non-Profit Organization Management",
        value: "Non-Profit Organization Management",
      },
      {
        title: "Oil & Energy",
        value: "Oil & Energy",
      },
      {
        title: "Online Media",
        value: "Online Media",
      },
      {
        title: "Outsourcing/Offshoring",
        value: "Outsourcing/Offshoring",
      },
      {
        title: "Package/Freight Delivery",
        value: "Package/Freight Delivery",
      },
      {
        title: "Packaging and Containers",
        value: "Packaging and Containers",
      },
      {
        title: "Paper & Forest Products",
        value: "Paper & Forest Products",
      },
      {
        title: "Performing Arts",
        value: "Performing Arts",
      },
      {
        title: "Pharmaceuticals",
        value: "Pharmaceuticals",
      },
      {
        title: "Philanthropy",
        value: "Philanthropy",
      },
      {
        title: "Photography",
        value: "Photography",
      },
      {
        title: "Plastics",
        value: "Plastics",
      },
      {
        title: "Political Organization",
        value: "Political Organization",
      },
      {
        title: "Primary/Secondary Education",
        value: "Primary/Secondary Education",
      },
      {
        title: "Printing",
        value: "Printing",
      },
      {
        title: "Professional Training & Coaching",
        value: "Professional Training & Coaching",
      },
      {
        title: "Program Development",
        value: "Program Development",
      },
      {
        title: "Public Policy",
        value: "Public Policy",
      },
      {
        title: "Public Relations and Communications",
        value: "Public Relations and Communications",
      },
      {
        title: "Public Safety",
        value: "Public Safety",
      },
      {
        title: "Publishing",
        value: "Publishing",
      },
      {
        title: "Railroad Manufacture",
        value: "Railroad Manufacture",
      },
      {
        title: "Ranching",
        value: "Ranching",
      },
      {
        title: "Real Estate",
        value: "Real Estate",
      },
      {
        title: "Recreational Facilities and Services",
        value: "Recreational Facilities and Services",
      },
      {
        title: "Religious Institutions",
        value: "Religious Institutions",
      },
      {
        title: "Renewables & Environment",
        value: "Renewables & Environment",
      },
      {
        title: "Research",
        value: "Research",
      },
      {
        title: "Restaurants",
        value: "Restaurants",
      },
      {
        title: "Retail",
        value: "Retail",
      },
      {
        title: "Security and Investigations",
        value: "Security and Investigations",
      },
      {
        title: "Semiconductors",
        value: "Semiconductors",
      },
      {
        title: "Shipbuilding",
        value: "Shipbuilding",
      },
      {
        title: "Sporting Goods",
        value: "Sporting Goods",
      },
      {
        title: "Sports",
        value: "Sports",
      },
      {
        title: "Staffing and Recruiting",
        value: "Staffing and Recruiting",
      },
      {
        title: "Supermarkets",
        value: "Supermarkets",
      },
      {
        title: "Telecommunications",
        value: "Telecommunications",
      },
      {
        title: "Textiles",
        value: "Textiles",
      },
      {
        title: "Think Tanks",
        value: "Think Tanks",
      },
      {
        title: "Tobacco",
        value: "Tobacco",
      },
      {
        title: "Translation and Localization",
        value: "Translation and Localization",
      },
      {
        title: "Transportation/Trucking/Railroad",
        value: "Transportation/Trucking/Railroad",
      },
      {
        title: "Utilities",
        value: "Utilities",
      },
      {
        title: "Venture Capital & Private Equity",
        value: "Venture Capital & Private Equity",
      },
      {
        title: "Veterinary",
        value: "Veterinary",
      },
      {
        title: "Warehousing",
        value: "Warehousing",
      },
      {
        title: "Wholesale",
        value: "Wholesale",
      },
      {
        title: "Wine and Spirits",
        value: "Wine and Spirits",
      },
      {
        title: "Wireless",
        value: "Wireless",
      },
      {
        title: "Writing and Editing",
        value: "Writing and Editing",
      },
    ];
    $scope.industriesFilter = "";
    $scope.filterIndustries = function () {
      var ulElementsCount = 0;
      $scope.industriesEdited = [];
      var tempIndustriesEdited = [];
      var filteredResults = $scope.industries.filter(function (o) {
        return (
          typeof o.title
            .toLowerCase()
            .split(/[\/, ]+/)
            .find(function (item) {
              return item.startsWith($scope.industriesFilter.toLowerCase());
            }) !== "undefined"
        );
      });
      angular.forEach(filteredResults, function (value, key) {
        ulElementsCount++;
        tempIndustriesEdited.push(value);
        if (ulElementsCount == Math.ceil(filteredResults.length / 4)) {
          $scope.industriesEdited.push(tempIndustriesEdited);
          tempIndustriesEdited = [];
          ulElementsCount = 0;
        }
        if (filteredResults.length - 1 == filteredResults.indexOf(value)) {
          $scope.industriesEdited.push(tempIndustriesEdited);
          tempIndustriesEdited = [];
          ulElementsCount = 0;
        }
      });
    };
    $scope.filterIndustries();

    function previewEditorGo() {
      $state.go("resume", {
        resumeId: resume.resumeID,
        new: false,
      });
    }

    if (stateParams.new) {
      createNewResume();
    } else {
      refillDropdown();
    }

    resumeEditor.validateFormData = function () {
      $timeout(function () {
        $scope.edNotValid =
          $('input[name^="degree"]').filter(".ng-invalid").length > 0 ||
          $('input[name^="university"]').filter(".ng-invalid").length > 0;
        $scope.certNotValid =
          $('input[name^="cert"]').filter(".ng-invalid").length > 0 ||
          $('input[name^="school"]').filter(".ng-invalid").length > 0 ||
          $('select[name^="cert_start_mon"]').filter(".ng-invalid").length >
            0 ||
          $('select[name^="cert_start_year"]').filter(".ng-invalid").length > 0;
        $scope.expNotValid =
          $('input[name^="company"]').filter(".ng-invalid").length > 0 ||
          $('input[name^="title"]').filter(".ng-invalid").length > 0 ||
          $('select[name^="exp_start_mon"]').filter(".ng-invalid").length > 0 ||
          $('select[name^="exp_start_year"]').filter(".ng-invalid").length > 0;
        $scope.miliNotValid =
          $('input[name^="position"]').filter(".ng-invalid").length > 0 ||
          $('input[name^="branch"]').filter(".ng-invalid").length > 0 ||
          $('select[name^="mili_start_mon"]').filter(".ng-invalid").length >
            0 ||
          $('select[name^="mili_start_year"]').filter(".ng-invalid").length > 0;
        $scope.infoNotValid =
          $("#phonenumber").filter(".ng-invalid").length > 0 ||
          $("#firstname").filter(".ng-invalid").length > 0 ||
          $("#lastname").filter(".ng-invalid").length > 0 ||
          $("#email").filter(".ng-invalid").length > 0;
        $scope.summaryNotValid = $("#summary").filter(".ng-invalid").length > 0;
        $scope.skillsNotValid =
          $('input[name^="skillName"]').filter(".ng-invalid").length > 0;
        $scope.awardsNotValid =
          $('input[name^="award"]').filter(".ng-invalid").length > 0;

        if (
          $scope.summaryNotValid ||
          $scope.infoNotValid ||
          // || resumeEditor.title == ''
          // || resumeEditor.title == undefined
          resumeEditor.industry == "" ||
          resumeEditor.industry == undefined ||
          $scope.edNotValid ||
          $scope.certNotValid ||
          $scope.expNotValid ||
          $scope.miliNotValid ||
          $scope.skillsNotValid ||
          $scope.awardsNotValid
        ) {
          showErrorMessage(
            $translate.instant("USER_PROFILE_SAVE_WARNING"),
            10000
          );
        }
      }, 100);
    };
    resumeEditor.validateFormData2 = function () {
      $scope.edNotValid =
        $('input[name^="degree"]').filter(".ng-invalid").length > 0 ||
        $('input[name^="university"]').filter(".ng-invalid").length > 0;
      $scope.certNotValid =
        $('input[name^="cert"]').filter(".ng-invalid").length > 0 ||
        $('input[name^="school"]').filter(".ng-invalid").length > 0 ||
        $('select[name^="cert_start_mon"]').filter(".ng-invalid").length > 0 ||
        $('select[name^="cert_start_year"]').filter(".ng-invalid").length > 0;
      $scope.expNotValid =
        $('input[name^="company"]').filter(".ng-invalid").length > 0 ||
        $('input[name^="title"]').filter(".ng-invalid").length > 0 ||
        $('select[name^="exp_start_mon"]').filter(".ng-invalid").length > 0 ||
        $('select[name^="exp_start_year"]').filter(".ng-invalid").length > 0;
      $scope.miliNotValid =
        $('input[name^="position"]').filter(".ng-invalid").length > 0 ||
        $('input[name^="branch"]').filter(".ng-invalid").length > 0 ||
        $('select[name^="mili_start_mon"]').filter(".ng-invalid").length > 0 ||
        $('select[name^="mili_start_year"]').filter(".ng-invalid").length > 0;
      $scope.infoNotValid =
        $("#phonenumber").filter(".ng-invalid").length > 0 ||
        $("#firstname").filter(".ng-invalid").length > 0 ||
        $("#lastname").filter(".ng-invalid").length > 0 ||
        $("#email").filter(".ng-invalid").length > 0;
      $scope.summaryNotValid = $("#summary").filter(".ng-invalid").length > 0;
      $scope.skillsNotValid =
        $('input[name^="skillName"]').filter(".ng-invalid").length > 0;
      $scope.awardsNotValid =
        $('input[name^="award"]').filter(".ng-invalid").length > 0;

      if (
        $scope.summaryNotValid ||
        $scope.infoNotValid ||
        // || resumeEditor.title == ''
        // || resumeEditor.title == undefined
        resumeEditor.industry == "" ||
        resumeEditor.industry == undefined ||
        $scope.edNotValid ||
        $scope.certNotValid ||
        $scope.expNotValid ||
        $scope.miliNotValid ||
        $scope.skillsNotValid ||
        $scope.awardsNotValid
      ) {
        var error = $translate.instant("USER_PROFILE_SAVE_WARNING");
        showErrorMessage(error, 10000);
        return false;
      } else {
        return true;
      }
    };
    var parseTmrId = null;
    resumeEditor.setParseDelay = function (evt) {
      if (parseTmrId) clearTimeout(parseTmrId);
      parseTmrId = $timeout(function () {
        resumeEditor.parseSummaryKeyWords();
      }, 1000);
    };
    $scope.summaryMissingArr = [];
    $scope.summaryKeywordsAdded = [];
    resumeEditor.parseSummaryKeyWords = function () {
      if (
        jobParseData &&
        jobParseData.ParsedTaxonomy &&
        jobParseData.ParsedTaxonomy.length
      ) {
        $scope.summaryCompare = [];
        //$scope.subCagetories = [];
        $scope.summaryMissing = "";
        $scope.summaryMissingArr = [];
        $scope.summaryFound = "";
        var summary = "";
        if (resumeEditor.user.summary)
          summary = resumeEditor.user.summary.toUpperCase();

        resumeEditor.numSumMatch = 0;
        var matchstr2 = $scope.summaryKeywordsAddedStr
          ? $scope.summaryKeywordsAddedStr.trim().toUpperCase()
          : "";

        jobParseData.SkillsTopics.forEach(function (c, i) {
          c = c.trim();
          var matchstr = c.toUpperCase();

          if (matchstr != "") {
            if (summary.indexOf(matchstr) == -1) {
              // if we did not find it in the current summary text, add it to the comma separated string of missing skills
              $scope.summaryMissing = $scope.summaryMissing + ", " + c;
              // We don't do this here because we may added it to the todo list but its not yet in the description
              // $scope.summaryMissingArr.push(c);
            } else {
              // we found a matching skill, so maintain the counter and found string
              resumeEditor.numSumMatch += 1;
              $scope.summaryFound = $scope.summaryFound + ", " + c;
              // We are done here, no need to add it to the todo list
              return;
            }
          }

          // If we have't added it to the todo list, it is still missing
          if (
            matchstr2.indexOf(matchstr) == -1 &&
            !$scope.summaryMissingArr.includes(c)
          ) {
            // If it was not in the list of skills added to the todo list then add it
            $scope.summaryMissingArr.push(c);
          }
        });

        $scope.summaryKeywordsAdded.forEach(function (c, i) {
          var matchstr = c.keyword.toUpperCase().trim();
          if (matchstr != "") {
            if (summary.indexOf(matchstr) != -1) {
              $scope.summaryKeywordsAdded[i].show = false;
            } else {
              $scope.summaryKeywordsAdded[i].show = true;
            }
          }
        });

        // Remove the leading ", " from our strings
        if ($scope.summaryMissing)
          $scope.summaryMissing = $scope.summaryMissing.substr(2);
        if ($scope.summaryFound)
          $scope.summaryFound = $scope.summaryFound.substr(2);

        if (summary) {
          $scope.summaryNeedsAttent = false;
          $scope.summaryNeedsReview = false;

          resumeEditor.numSumUpdates =
            jobParseData.SummaryLevel2 - resumeEditor.numSumMatch;
          if (resumeEditor.numSumUpdates <= 0) {
            $scope.summaryNeedsAttent = false;
            $scope.summaryNeedsReview = false;
            $scope.summaryNotValid = false;
            resumeEditor.numSumUpdates = 0;
          } else if (resumeEditor.numSumMatch <= jobParseData.SummaryLevel1) {
            $scope.summaryNeedsAttent = true;
          } else if (resumeEditor.numSumMatch <= jobParseData.SummaryLevel2) {
            $scope.summaryNeedsReview = true;
          }
        } else {
          $scope.summaryNotValid = true;
        }
      }
      // $scope.focusBlurMissingText('summary');
    };

    resumeEditor.parseMissingKeywords = function (ndx) {
      if (resumeEditor.fullSkillsList.length > 0) {
        var txt = $("#experience_" + ndx)
          .html()
          .toUpperCase();
        var found = false;

        // $scope.expNeedsReview = false;
        // $scope.expNeedsAttent = false;
        var keywords = Object.keys($scope.experienceKeywordsAdded[ndx]);
        resumeEditor.fullSkillsList.forEach(function (v, i) {
          if (txt.indexOf(v.toUpperCase()) > -1) {
            $("#experience_" + ndx).removeClass("backgroundNonMatch");
            found = true;
          }
        });
        keywords.forEach(function (v, i) {
          if (txt.indexOf(v.toUpperCase()) > -1) {
            $scope.experienceKeywordsAdded[ndx][v] = false;
          } else {
            $scope.experienceKeywordsAdded[ndx][v] = true;
          }
        });
        var a = $scope.experienceKeywordsAdded;
        if (!found) {
          $("#experience_" + ndx).addClass("backgroundNonMatch");
          if (jobParseData.KeywordlessExperiences.indexOf(ndx) == -1)
            jobParseData.KeywordlessExperiences.push(ndx);
        } else {
          $("#experience_" + ndx).addClass("backgroundMatch");
          jobParseData.KeywordlessExperiences =
            jobParseData.KeywordlessExperiences.filter(function (el, x) {
              return el != ndx;
            });
        }

        resumeEditor.numExpUpdates = jobParseData.KeywordlessExperiences.length;
        if (resumeEditor.numExpUpdates == 0) {
          $scope.expNeedsReview = true;
          $scope.expNeedsAttent = false;
        }
      }
    };

    resumeEditor.experienceMissingSkillList = [];

    resumeEditor.updateExperienceMissingSkillList = function (ndx) {
      try {
        resumeEditor.experienceMissingSkillList = [];

        if (resumeEditor.fullSkillsList.length > 0) {
          var txt = $("#experience_" + ndx)
            .html()
            .toUpperCase();
          var temp = [];
          resumeEditor.fullSkillsList.forEach(function (v) {
            // if its not in the text of the experience description
            if (txt.indexOf(v.toUpperCase()) < 0) {
              // and its not been added
              if (
                !($scope.experienceKeywordsAdded[ndx] || {}).hasOwnProperty(v)
              ) {
                temp.push(v);
              }
            }
          });
          resumeEditor.experienceMissingSkillList = temp;
        }
      } catch (e) {
        console.log(
          "-- (Controller) - resumeEditor.updateExperienceMissingSkillList() - e: ",
          e
        );
      }
    };

    resumeEditor.hasDegree = function () {
      resumeEditor.hasDegreesListed = jobParseData.HasDegreesListed;
      resumeEditor.matchedDegrees = jobParseData.MatchedDegrees;
      $scope.eduNeedsReview = false;
      $scope.eduNeedsAttent = false;
      if (
        resumeEditor.matchedDegrees != null &&
        resumeEditor.matchedDegrees != undefined
      ) {
        resumeEditor.matchedDegrees.forEach(function (i, n) {
          $("#degree_" + i).addClass("backgroundMatch");
          $scope.eduNeedsReview = true;
        });
      }

      if (
        resumeEditor.matchedDegrees != null &&
        resumeEditor.matchedDegrees != undefined &&
        resumeEditor.matchedDegrees.length > 0 &&
        resumeEditor.user.education.length == 0
      ) {
        $scope.eduNeedsAttent = true;
      }
    };

    resumeEditor.missingKeywords = function () {
      var exp = resumeEditor.user.experience.filter(function (el, ndx) {
        return el.deleted == false;
      });
      if (exp.length == 0) {
        $scope.expNotValid = true;
      } else {
        resumeEditor.keywordlessExperiences =
          jobParseData.KeywordlessExperiences;
        $scope.expNeedsReview = false;
        $scope.expNeedsAttent = false;

        resumeEditor.numExpUpdates = 0;
        if (
          jobParseData.ExperienceLevel2 > 0 &&
          jobParseData.ExperienceLevel1 > 0 &&
          jobParseData.KeywordlessExperiences.length > 0
        ) {
          jobParseData.KeywordlessExperiences.forEach(function (i, n) {
            $("#experience_" + i).addClass("backgroundNonMatch");
            resumeEditor.numExpUpdates += 1;
          });
          exp.forEach(function (i, n) {
            if (jobParseData.KeywordlessExperiences.indexOf(i) < 0)
              $("#experience_" + i.order_index).addClass("backgroundMatch");
          });
          if (resumeEditor.numExpUpdates == 0)
            resumeEditor.numExpUpdates = jobParseData.ExperienceLevel2;
          if (resumeEditor.numExpUpdates <= jobParseData.ExperienceLevel1) {
            $scope.expNeedsAttent = true;
          } else if (
            resumeEditor.numExpUpdates <= jobParseData.ExperienceLevel2
          ) {
            $scope.expNeedsReview = true;
          } else if (
            jobParseData.ExperienceLevel1 == jobParseData.ExperienceLevel2
          ) {
            $scope.expNeedsAttent = true;
          } else if (jobParseData.KeywordlessExperiences.length > 0) {
            $scope.expNeedsAttent = true;
          }
        } else {
          $scope.expNeedsReview = true;
          exp.forEach(function (i, n) {
            $("#experience_" + i.order_index).addClass("backgroundMatch");
          });
        }
      }
    };

    resumeEditor.missingReqSkills = function () {
      var userSkills = resumeEditor.user.skills.filter(function (el, ndx) {
        return el.deleted == false;
      });
      resumeEditor.requiredSkillsList = jobParseData.ParseSkills.RequiredSkills;
      resumeEditor.otherSkillsList = jobParseData.ParseSkills.OtherSkills;

      resumeEditor.matchingSkillsList = jobParseData.MatchedRequiredSkills;
      resumeEditor.matchingSkillsList = resumeEditor.matchingSkillsList.concat(
        jobParseData.MatchedOtherSkills
      );

      resumeEditor.fullSkillsList = angular.copy(
        jobParseData.ParseSkills.RequiredSkills
      );
      resumeEditor.fullSkillsList = resumeEditor.fullSkillsList.concat(
        jobParseData.ParseSkills.OtherSkills
      );
      // if(resumeEditor.matchingSkillsList.length > 0) {
      if (resumeEditor.matchingSkillsList.length > -1) {
        resumeEditor.missingSkillsList = jobParseData.MissingSkills;
        resumeEditor.hasMissingSkills = jobParseData.MissingSkills.length > 0;
        $scope.skillNeedsAttent = false;
        $scope.skillNeedsReview = false;

        if (
          userSkills.length == 0 &&
          jobParseData.ParseSkills.RequiredSkills.length > 0
        ) {
          resumeEditor.numSkillsUpdates =
            jobParseData.ParseSkills.RequiredSkills.length;
          $scope.skillNeedsAttent = true;
        } else {
          $scope.skillNeedsAttent = true;

          if (userSkills.length > 0) {
            var msl = "";
            var sk = "";
            var ndx = -1;
            var newMatch = [];
            var reqSkills = resumeEditor.requiredSkillsList.map(function (v) {
              return v.toUpperCase();
            });
            var othSkills = resumeEditor.otherSkillsList.map(function (v) {
              return v.toUpperCase();
            });
            resumeEditor.matchingSkillsList.forEach(function (i, n) {
              // msl = i.toUpperCase();
              msl = i.toUpperCase().trim();
              resumeEditor.user.skills
                .filter(function (el, ndx) {
                  return el.deleted == false;
                })
                .forEach(function (s, x) {
                  // sk = s.skill.toUpperCase();
                  sk = s.skill.toUpperCase().trim();
                  if (msl == sk) {
                    $("#skillName_" + s.order_index).addClass(
                      "backgroundMatch"
                    );
                    ndx = reqSkills.indexOf(sk);
                    if (ndx >= 0) {
                      ndx = resumeEditor.requiredSkillsList.indexOf(sk);
                      resumeEditor.requiredSkillsList.splice(ndx, 1);
                    }
                    ndx = othSkills.indexOf(sk);
                    if (ndx >= 0) {
                      ndx = resumeEditor.otherSkillsList.indexOf(sk);
                      resumeEditor.otherSkillsList.splice(ndx, 1);
                    }
                    newMatch.push(s.skill);
                  }
                });
            });
            resumeEditor.matchingSkillsList = newMatch;
            resumeEditor.numSkillsUpdates =
              jobParseData.SkillsLevel2 -
              resumeEditor.matchingSkillsList.length;
          }

          if (userSkills.length == 0) {
            resumeEditor.numSkillsUpdates =
              jobParseData.ParseSkills.RequiredSkills.length +
              jobParseData.ParseSkills.OtherSkills.length;
          } else if (
            resumeEditor.matchingSkillsList.length > jobParseData.SkillsLevel1
          ) {
            $scope.skillNeedsAttent = false;
            $scope.skillNeedsReview = true;
          } else if (
            resumeEditor.matchingSkillsList.length > jobParseData.SkillsLevel2
          ) {
            $scope.skillNeedsAttent = false;
            $scope.skillNeedsReview = false;
          }
        }
        resumeEditor.missingAllSkills =
          resumeEditor.requiredSkillsList.length +
          resumeEditor.otherSkillsList.length -
          resumeEditor.matchingSkillsList.length;
        if (resumeEditor.missingAllSkills < 0)
          resumeEditor.missingAllSkills = 0;
      } else {
        resumeEditor.missingSkillsList = [];
      }
    };

    resumeEditor.parseJob = function (tv) {
      var str = resumeEditor.jobDesc; //$('#jobDesc').html();

      if (str.trim() != "") {
        resumeEditor.hasProcessed = true;
        $("*").css("cursor", "wait");
        $("#waitDiv")[0].style.display = "block";

        $timeout(function () {
          if (resumeEditor.hasProcessed) {
            $("*").css("cursor", "");
            $("#waitDiv")[0].style.display = "none";
            buildToastr(
              "SORRY ABOUT THIS",
              "Processing your job description is taking longer than expected.<br/>Please try again later.<br /><br/>If this continues to occur, click the close button, save any data not yet saved in the editor and refresh the page to try again.",
              10000
            );
          }
        }, tv);

        resumeService
          .parseJobDescription(str, resumeEditor.resumeID)
          .then(function (parseData) {
            if (parseData.data != null && parseData.data != undefined) {
              resumeEditor.parseJobVariablesReset();

              jobParseData = parseData.data;
              resumeEditor.skillsLevel1 = jobParseData.SkillsLevel1;
              resumeEditor.skillsLevel2 = jobParseData.SkillsLevel2;
              resumeEditor.ExperienceLevel1 = jobParseData.ExperienceLevel1;
              resumeEditor.ExperienceLevel2 = jobParseData.ExperienceLevel2;
              resumeEditor.summaryLevel1 = jobParseData.SummaryLevel1;
              resumeEditor.summaryLevel2 = jobParseData.SummaryLevel2;

              resumeEditor.parseSummaryKeyWords();
              resumeEditor.hasDegree();
              resumeEditor.missingKeywords();
              resumeEditor.missingReqSkills();

              resumeEditor.minimumYears =
                jobParseData.MetaData.MinimumYears != undefined
                  ? jobParseData.MetaData.MinimumYears
                  : "0";
              resumeEditor.maximumYears =
                jobParseData.MetaData.MaximumYears != undefined
                  ? jobParseData.MetaData.MaximumYears
                  : "0";
              resumeEditor.employersName =
                jobParseData.MetaData.MainEmployerName != undefined
                  ? jobParseData.MetaData.MainEmployerName
                  : undefined; // 'Unknown';
              resumeEditor.jobTitle =
                jobParseData.MetaData.MainJobTitle != undefined
                  ? jobParseData.MetaData.MainJobTitle
                  : undefined; // 'Unknown';
              resumeEditor.location =
                jobParseData.MetaData.Location != undefined
                  ? jobParseData.MetaData.Location
                  : undefined; // 'Unknown';
              resumeEditor.yearsExperience = jobParseData.YearsExperience;
              $("#numMatches").html(jobParseData.MetaData.MatchedCount);
            }

            resumeEditor.title = resumeEditor.jobTitle;
            resumeEditor.editData();
          })
          .finally(function () {
            resumeEditor.hasProcessed = false;
            $("*").css("cursor", "");
            $("#waitDiv")[0].style.display = "none";
          });
      }
    };

    resumeEditor.parseJobVariablesReset = function () {
      resumeEditor.numSkillsUpdates = 0;
      resumeEditor.missingAllSkills = 0;
      $scope.skillNeedsAttent = false;
    };

    resumeEditor.moveSkill = function (index, x) {
      var skill = "";
      var matchSkill = null;
      if (x == 1) {
        skill = resumeEditor.requiredSkillsList[index].toUpperCase();
        var missSkills = resumeEditor.missingSkillsList.map(function (v) {
          return v.toUpperCase();
        });
        var ndx = missSkills.indexOf(skill);
        if (ndx >= 0) resumeEditor.missingSkillsList.splice(ndx, 1);
        matchSkill = {
          skill: resumeEditor.requiredSkillsList[index],
          proficiency: 3,
          order_index: resumeEditor.user.skills.length,
          deleted: false,
          _id: null,
        };
        resumeEditor.user.skills.push(matchSkill);
        resumeEditor.matchingSkillsList.push(matchSkill);
        resumeEditor.requiredSkillsList.splice(index, 1);
      } else if (x == 2) {
        skill = resumeEditor.otherSkillsList[index];
        var ndx = resumeEditor.missingSkillsList.indexOf(skill);
        if (ndx >= 0) resumeEditor.missingSkillsList.splice(ndx, 1);

        matchSkill = {
          skill: resumeEditor.otherSkillsList[index],
          proficiency: 3,
          order_index: resumeEditor.user.skills.length,
          deleted: false,
          _id: null,
        };
        resumeEditor.user.skills.push(matchSkill);
        resumeEditor.matchingSkillsList.push(matchSkill.skill);
        resumeEditor.otherSkillsList.splice(index, 1);
      }

      // resumeEditor.numSkillsUpdates = jobParseData.ParsedTaxonomy.SkillsLevel2 - resumeEditor.matchingSkillsList.length;
      resumeEditor.numSkillsUpdates =
        jobParseData.SkillsLevel2 - resumeEditor.matchingSkillsList.length;
      // if(resumeEditor.matchingSkillsList.length > jobParseData.ParsedTaxonomy.SkillsLevel2) {
      if (resumeEditor.matchingSkillsList.length > jobParseData.SkillsLevel2) {
        $scope.skillNeedsAttent = false;
        $scope.skillNeedsReview = false;
      } else if (
        resumeEditor.matchingSkillsList.length > jobParseData.SkillsLevel1
      ) {
        $scope.skillNeedsAttent = false;
        $scope.skillNeedsReview = true;
      } else {
        $scope.skillNeedsAttent = true;
        $scope.skillNeedsReview = false;
      }

      updateSkillsRatings();
      $timeout(function () {
        $("#skillName_" + (resumeEditor.user.skills.length - 1)).addClass(
          "backgroundMatch"
        );
      }, 750);
    };

    //NEED TO ADD VARIABLE FOR HODING THE DATA NOT HTML ELEMENT

    $scope.descChanged = function (hmtl) {
      var reg = /(<([^>]+)>)|(&nbsp;)/gi;

      resumeEditor.jobDesc = hmtl ? hmtl : $("#jobDesc")[0].innerHTML;
      resumeEditor.jobDesc = resumeEditor.jobDesc.replace(reg, "");

      var reg2 = /<\s*script.*?>.*?(<\s*\/script.*?>|$)/gi;
      resumeEditor.jobDesc = resumeEditor.jobDesc.replace(reg2, "");
      var reg3 = /<\s*link.*?>.*?/gi;
      resumeEditor.jobDesc = resumeEditor.jobDesc.replace(reg3, "");
    };

    $scope.getPaste = function (e) {
      var clipboardData, pastedData;

      // Stop data actually being pasted into div
      /*       e.stopPropagation();
                     e.preventDefault(); */

      // Get pasted data via clipboard API
      clipboardData = e.clipboardData || window.clipboardData;
      pastedData = clipboardData.getData("Text");

      var reg = /(<([^>]+)>)|(&nbsp;)/gi;
      var str = pastedData.replace(reg, "");
      var pasted = !!str;
      if (pasted) {
        $timeout(function () {
          $scope.descChanged();
        }, 500);
      }
    };

    var job = $("#jobDesc")[0];
    job.onpaste = $scope.getPaste;

    Object.equals = function (x, y) {
      if (x === y) return true;
      // if both x and y are null or undefined and exactly the same

      if (!(x instanceof Object) || !(y instanceof Object)) return false;
      // if they are not strictly equal, they both need to be Objects

      if (x.constructor !== y.constructor) return false;
      // they must have the exact same prototype chain, the closest we can do is
      // test there constructor.

      for (var p in x) {
        if (!x.hasOwnProperty(p)) continue;
        // other properties were tested using x.constructor === y.constructor

        if (!y.hasOwnProperty(p)) return false;
        // allows to compare x[ p ] and y[ p ] when set to undefined

        if (x[p] === y[p]) continue;
        // if they have the same strict value or identity then they are equal

        if (typeof x[p] !== "object") return false;
        // Numbers, Strings, Functions, Booleans must be strictly equal

        if (!Object.equals(x[p], y[p])) return false;
        // Objects and Arrays must be tested recursively
      }

      for (p in y) {
        if (y.hasOwnProperty(p) && !x.hasOwnProperty(p)) return false;
        // allows x[ p ] to be set to undefined
      }
      return true;
    };

    // ****************************************************************************************
    // ****************************************************************************************
    // ****************************************************************************************

    var ASSESSMENT_CAREER_ID = "career-deck";
    var ASSESSMENT_BIG_FIVE_ID = "big-five";
    $scope.assessmentsStatus = {};
    var getTypeBarStyle = function (type) {
      var styles = {
        width: type.score + "%",
      };
      if ($scope.assessmentsStatus.hasUserTakenBothAssessments) {
        if (!!navigator.userAgent.match(/Trident\/7\./)) {
          styles.background =
            "linear-gradient(90deg, #6b59a8 100%, hsla(0, 0%, 100%, 0) 0);";
          styles.filter =
            "filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='rgba(255, 255, 255, .5)', endColorstr='rgba(0, 0, 0, .2)',GradientType=0 );";
        } else {
          styles.background =
            "linear-gradient(90deg, #6b59a8 100%, hsla(0, 0%, 100%, 0) 0);";
        }
      } else {
        styles.border = "#eee 1px solid";
      }
      return styles;
    };
    var mapType = function (type) {
      return {
        score: type.score,
        name: type["personality_type"].name,
        image: type["personality_type"]["badge"]["image_small"],
        color: type["personality_type"]["badge"]["color_1"],
      };
    };
    var mapTraits = function (trait) {
      return {
        score: trait.score,
        name: trait["personality_trait"].name,
      };
    };
    var setRadarChart = function (elementId, data) {
      var dtext = document.getElementById(elementId);
      if (dtext != null && dtext != undefined) {
        var context = dtext.getContext("2d");
        var gradient = context.createLinearGradient(229, 229, 229, 0.4);
        gradient.addColorStop(0, "rgba(84, 189, 176, .4)");
        gradient.addColorStop(1, "rgba(84, 189, 176, .4)");
        new Chart(context, {
          type: "radar",
          data: data.reduce(
            function (obj, item) {
              obj.labels.push(item.name);
              obj.datasets[0].data.push(item.score);
              return obj;
            },
            {
              labels: [],
              datasets: [
                {
                  data: [],
                  backgroundColor: gradient,
                  radius: 0,
                },
              ],
            }
          ),
          options: {
            legend: {
              display: false,
            },
            tooltips: {
              enabled: false,
            },
            scale: {
              angleLines: {
                color: "rgba(0, 0, 0, 0.10)",
                lineWidth: 1,
              },
              pointLabels: {
                fontColor: "rgba(0, 0, 0, 0.5)",
                fontFamily: '"Open Sans", sans-serif',
              },
              ticks: {
                beginAtZero: true,
                display: false,
                maxTicksLimit: 5,
              },
            },
          },
        });
      }
    };

    var saveDates = function (experiences) {
      var updatedExperiences = [];
      experiences.map(function (experience) {
        var aux = Object.assign({}, experience); // Create a new object for each experience

        if (experience.startMonthObj && experience.startYearObj) {
          var startDate = new Date();
          startDate.setMonth(experience.startMonthObj - 1);
          startDate.setFullYear(experience.startYearObj);

          aux.startDateObj =
            startDate.toLocaleString("default", { month: "short" }) +
            " " +
            String(experience.startYearObj);
          aux.startShortDateObj = String(experience.startYearObj);
          aux.date_start = startDate.toLocaleString("default", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          });
        }

        if (experience.endMonthObj && experience.endYearObj) {
          var endDate = new Date();
          endDate.setMonth(experience.endMonthObj - 1);
          endDate.setFullYear(experience.endYearObj);

          aux.endDateObj =
            endDate.toLocaleString("default", { month: "short" }) +
            " " +
            String(experience.endYearObj);

          aux.endShortDateObj = String(experience.endYearObj);

          aux.date_end = endDate.toLocaleString("default", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          });
        } else if (experience.endDateObj === "Present") {
          aux.date_end = "";
        }

        updatedExperiences.push(aux);
        return aux;
      });

      return updatedExperiences;
    };

    var showAssessmentResultsToUser = function () {
      buildDefaultAssessment();
      var big5Id = getUserAssessment(ASSESSMENT_BIG_FIVE_ID).assessmentId;
      var careerId = getUserAssessment(ASSESSMENT_CAREER_ID).assessmentId;
      var big5Required = ["types", "archetype"];
      var careerRequired = ["blend", "types", "traits", "career_matches"];
      var imagePack = "linear";
      $q.all([
        assessmentsService.getResults(big5Id, big5Required, imagePack),
        assessmentsService.getResults(careerId, careerRequired, imagePack),
      ])
        .then(function (traitifyData) {
          if (traitifyData[0] && traitifyData[1]) {
            resumeEditor.assessmentData = {
              archetype: traitifyData[0].data["archetype"]["name"],
              description: traitifyData[1].data["personality_blend"]
                ? traitifyData[1].data["personality_blend"]["description"]
                : "",
              details: {
                complement: (
                  traitifyData[0].data["archetype"]["details"].find(function (
                    el
                  ) {
                    return el.title === "Complement";
                  }) || {}
                ).body,
                conflict: (
                  traitifyData[0].data["archetype"]["details"].find(function (
                    el
                  ) {
                    return el.title === "Conflict";
                  }) || {}
                ).body,
                environments: traitifyData[0].data["archetype"][
                  "environments"
                ].map(function (el) {
                  return el.name;
                }),
              },
              mainTypes: traitifyData[0].data["personality_types"].map(mapType),
              types: traitifyData[1].data["personality_types"].map(mapType),
              traits: traitifyData[1].data["personality_traits"]
                .slice(0, 20)
                .map(mapTraits),
            };
          }
        })
        .catch(function (error) {
          console.error(error);
        });
    };

    var getUserAssessment = function (assessmentDeckId) {
      if ($scope.user && $scope.user.assessments) {
        for (var i = 0; i < $scope.user.assessments.length; i += 1) {
          if (
            $scope.user.assessments[i].assessmentId &&
            $scope.user.assessments[i].deck_id === assessmentDeckId
          ) {
            return $scope.user.assessments[i];
          }
        }
      }
      return null;
    };

    var setScopeAssessmentsStatusProperties = function () {
      $scope.assessmentsStatus.hasUserTakenCareerAssessment =
        getUserAssessment(ASSESSMENT_CAREER_ID) !== null;
      $scope.assessmentsStatus.hasUserTakenBig5Assessment =
        getUserAssessment(ASSESSMENT_BIG_FIVE_ID) !== null;
      $scope.assessmentsStatus.hasUserTakenBothAssessments =
        $scope.assessmentsStatus.hasUserTakenCareerAssessment &&
        $scope.assessmentsStatus.hasUserTakenBig5Assessment;
    };

    setScopeAssessmentsStatusProperties();
    if ($scope.assessmentsStatus.hasUserTakenBothAssessments) {
      showAssessmentResultsToUser();
    }

    if (stateParams.job2resume && stateParams.jobLink == null) {
      resumeEditor.showJobDesc();
    }

    if (stateParams.processJob == true) {
      // $('*').css('cursor','wait');
      // $('#waitDiv')[0].style.display = 'block';

      jobSearchService
        .getJobDescription(stateParams.jobLink)
        .then(function (response) {
          if (!response.hasError) {
            $scope.descChanged(response.responseBody);
            resumeEditor.parseJob(20000);
            $rootScope.emptyCreation = false;
          }
        });
    }

    $scope.changeDateEndEducation = function (type, index, value) {
      if (type == "education") {
        resumeEditor.user.education[index].endShortDateObj = String(value);
        resumeEditor.user.education[index].endDateObj = String(value);
        resumeEditor.user.education[index].date_end = String(value);

        // else if (experience.endDateObj === "Present") {
        //     aux.date_end = "";
        // }
      }

      console.log("lkmjnhbgvbhnjmk", resumeEditor.user.education);
    };
    // #region Fix Service Code.
    var fixServiceFinalMsg = "";
    $scope.forms = {};

    resumeEditor.validateTheResume = function (options) {
      // console.log('-- (Controller) - resumeEditor.$scope.validateTheResume()');
      $scope.removeCkEditor(); // Very very very important!!! Run this before try to fix the profile.

      // To enable the debug mode of the fixService open the browser console and put the following and press [Enter]:
      // var __FIX_SERVICE__ = '';
      // Then when you click on the save button you should be the log trace in the console.

      try {
        if (
          typeof __FIX_SERVICE__ === "string" &&
          __FIX_SERVICE__.length == 0
        ) {
          __FIX_SERVICE__ = fixService;
          fixService.debugOn();
        }
      } catch (e) {
        // Do nothing...
      }
      resumeEditor.user.summary = document.getElementById("summary").value;
      var aux = resumeEditor.user;
      resumeEditor.user.experience = saveDates(resumeEditor.user.experience);
      resumeEditor.user.education = saveDates(resumeEditor.user.education);

      fixServiceFinalMsg = "";
      var fixResult = fixService.fixInlineEditorResume(resumeEditor.user, {
        resumeEditor: resumeEditor,
      });
      // if (typeof fixResult !== 'undefined' && typeof fixResult.finalMessage !== 'undefined' && fixResult.finalMessage.length > 0) fixServiceFinalMsg = fixResult.finalMessage;

      setTimeout(function () {
        if (resumeEditor.validateFormData2()) {
          // console.log('-- (Controller) resumeEditor - The form pass the validation!');
          buildSaveToastr($translate.instant("BEFORE_SAVE_MSG"), "", 2000);
          resumeEditor.saveTheResume(options);
        } else {
          resumeEditor.goToPage("edit_resume");
          // console.log('-- (Controller) resumeEditor - The form did not pass the validation!');
        }
      }, 1000);
    };

    $scope.checkMissingText = function (name, type) {
      return fixService.checkMissingText(name, type);
    };

    $scope.focusBlurMissingText = function (name, focus) {
      return fixService.focusBlurMissingText(name, focus);
    };
    // #endregion Fix Service Code.

    // #region Industry Autocomplete Code.
    $scope.industrySearchText = "";
    $scope.fixOverflow = function () {
      // I don't like use this, but the angular-material autocompleted change the html and body overflow and affect the design of the UI.
      $("html").attr("style", "overflow-y: inherit;");
      $("body").attr("style", "position: relative;");
    };
    $scope.industrySearch = function (query) {
      return $scope.industries.filter(function (industry) {
        return industry.title.toLowerCase().indexOf(query.toLowerCase()) !== -1;
      });
    };
    $scope.saveIndustries = function (industry) {
      $scope.fixOverflow();
      var elem = angular.element("md-autocomplete.form-control-autocomplete");

      if (
        typeof industry === "object" &&
        typeof industry.title !== "undefined" &&
        industry.title !== null
      ) {
        resumeEditor.industry = industry.title;
        elem.removeClass("missing-data");
      } else {
        resumeEditor.industry = $translate.instant(
          "FIX_SERVICE_EMPTY_FIELD_MSG"
        );
        elem.addClass("missing-data");
      }
    };
    // #endregion Industry Autocomplete Code.

    // #region Update Profile Picture.
    $scope.profileImgModalDelete = false;

    $scope.cropped = {
      source: $scope.user.profile_picture_url,
    };

    $scope.profileImgModal = false;

    $scope.updateProfilePicture = false;

    $scope.selectResumeImage = function (files) {
      $scope.profileImgModalDelete = false;
      var reader = new FileReader();
      reader.onload = function (e) {
        // Bind new image to component:
        $scope.$apply(function () {
          $scope.cropped.source = e.target.result;
        });
      };
      reader.readAsDataURL(files[0]);
      $scope.profileImgModal = true;

      return;
    };

    $scope.uploadCroppedImg = function () {
      $rootScope.loadingInProcess = true;
      var imageBase64 = $scope.cropped.image;
      $scope.user.profile_picture_url = $scope.cropped.image;
      $scope.defaultImage = false;
      var imgdata = imageBase64.split(",")[1];
      var ct = imageBase64.split(":")[1];
      var contenttype = ct.split(";")[0];
      var imgName = Math.floor(Date.now() / 1000) + ".png";
      var img = $scope.b64toBlob(imgdata, imgName, contenttype);
      var attachment = {};
      attachment.file = img;
      attachment.type = "Profile picture";
      $scope.showImageLoader = true;
      userService
        .uploadCurrentUserAttachments(attachment)
        .then(function (response) {
          $scope.profilePictureURL = response.data.url;
          $scope.cropped.source = $scope.profilePictureURL;

          if ($scope.updateProfilePicture) {
            userService
              .updateCurrentUser({
                profile_picture_url: response.data.url,
              })
              .then(
                function (response) {
                  $scope.showImageLoader = false;
                  $scope.profileImgModal = false;
                  $rootScope.loadingInProcess = false;
                  resumeEditor.updateResumePicture($scope.cropped.source);
                },
                function () {
                  $scope.showImageLoader = false;
                  $rootScope.loadingInProcess = false;
                }
              );
          } else {
            $scope.showImageLoader = false;
            $scope.profileImgModal = false;
            $rootScope.loadingInProcess = false;
            resumeEditor.updateResumePicture($scope.cropped.source);
          }
        });
    };

    $scope.b64toBlob = function (b64Data, fileName, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;
      fileName = fileName;
      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }
      var imgblob;
      try {
        imgblob = new File(byteArrays, fileName, {
          type: contentType,
        });
      } catch (e) {
        try {
          imgblob = new Blob(byteArrays, {
            type: contentType,
          });
        } catch (e2) {
          // Nothing to do.
        }
      }
      return imgblob;
    };

    resumeEditor.updateResumePicture = function (url) {
      if (resumeEditor.resumeID) {
        resumeService
          .simpleUpdateResume(resumeEditor.resumeID, {
            profile_picture_url: url,
          })
          .then(function () {
            resumeEditor.user.profile_picture_url = url;
            bindResumeTemplateData();
            $rootScope.emptyCreation = false;
            utilsService.deleteResumeId(
              user.userID,
              utilsService.getResumeId(user.userID)
            );
            var successString = "Profile picture updated successfully";
            buildSaveToastr(successString, "Success", 2000);
          })
          .catch(function (err) {
            err.data.message = err.data.message.replace(/,/g, ", ");
            err.data.message = err.data.message.replace(/"/g, "");
            showErrorMessage(err.data.message, 4000);
          });
      }
    };

    $scope.showImageLoaderForDelete = function () {
      $scope.profileImgModal = true;
      $scope.profileImgModalDelete = true;
    };

    $scope.deleteResumePicture = function () {
      var url = "";
      $scope.profilePictureURL = url;
      $scope.cropped.source = url;

      if ($scope.updateProfilePicture) {
        userService
          .updateCurrentUser({
            profile_picture_url: url,
          })
          .then(
            function (response) {
              $scope.showImageLoader = false;
              $scope.profileImgModal = false;
              $rootScope.loadingInProcess = false;
              resumeEditor.updateResumePicture(url);
            },
            function () {
              $scope.showImageLoader = false;
              $rootScope.loadingInProcess = false;
            }
          );
      } else {
        $scope.showImageLoader = false;
        $scope.profileImgModal = false;
        $rootScope.loadingInProcess = false;
        resumeEditor.updateResumePicture(url);
      }
    };

    $scope.$watch("profileImgModal", function (isShowModal) {
      if (isShowModal) {
        $("html, body").addClass("ngdialog-open");
      } else {
        $("html, body").removeClass("ngdialog-open");
      }
    });
    // #endregion Update Profile Picture.

    var unListener;
    var removeIfEmpty = function (
      event,
      toState,
      toParams,
      fromState,
      fromParams
    ) {
      if (fromParams.resumeId && fromParams.resumeId !== "") {
        if ($rootScope.emptyCreation && stateParams.job2resume) {
          $rootScope.emptyCreation = false;
          resumeService.deleteResume(
            resumeEditor.user.userID,
            resumeEditor.resumeID
          );
        }
        unListener();
      }
    };
    unListener = $rootScope.$on("$stateChangeStart", removeIfEmpty);

    $timeout(function () {
      $scope.$watch(
        function () {
          var resumeData = Object.assign({}, resumeEditor.user, {
            website: resumeEditor.website,
            title: resumeEditor.title,
            address: resumeEditor.address,
            phonenumber: resumeEditor.phonenumber,
            industry: resumeEditor.industry,
          });
          return resumeData;
        },
        function (newValue, oldValue, scope) {
          if (!justSaved) {
            $scope.isResumeDirty = !Object.equals(newValue, oldValue);
            $scope.$emit("isResumeDirty", {
              isResumeDirty: $scope.isResumeDirty,
            });
          } else {
            justSaved = false;
          }
        },
        true
      );
    }, 3000);

    // #region Check Unsave Data.
    function checkUnsavedDataInit() {
      unsaveService.init(checkUnsavedData);
      checkUnsavedDataUpdate();

      $scope.$watch(
        unsaveService.checkUnsavedData,
        function (isUnsavedData, isUnsavedDataOld) {
          if (!resumeEditor.isCurrentPage("j2r")) {
            if (isUnsavedData) {
              unsaveService.addUnloadEvent();
            } else {
              unsaveService.removeUnloadEvent();
            }
          }
        }
      );
    }

    function getPersonalData() {
      var phoneNumber = {};

      if (resumeEditor.phonenumber) {
        phoneNumber = angular.copy(resumeEditor.phonenumber);
        if (phoneNumber.number) {
          phoneNumber.number = phoneFormatter.flatten(phoneNumber.number);
        }
      } else if (
        $scope.forms &&
        $scope.forms.userForm &&
        $scope.forms.userForm.phonenumber
      ) {
        phoneNumber.number = phoneFormatter.flatten(
          $scope.forms.userForm.phonenumber.$viewValue || ""
        );
      }

      return {
        first_name: resumeEditor.user.first_name,
        last_name: resumeEditor.user.last_name,
        email_address:
          resumeEditor.user.email_address &&
          resumeEditor.user.email_address.address
            ? resumeEditor.user.email_address.address
            : "",
        phoneNumber: phoneNumber,
        website: resumeEditor.website ? resumeEditor.website : "",
        title: resumeEditor.title ? resumeEditor.title : "",
        industry: resumeEditor.industry,
        city:
          resumeEditor.address && resumeEditor.address.city
            ? resumeEditor.address.city
            : "",
        state:
          resumeEditor.address && resumeEditor.address.state
            ? resumeEditor.address.state
            : "",
      };
    }

    function checkUnsavedDataUpdate(action) {
      unsaveService.updateData(
        "personal_data",
        angular.copy(getPersonalData())
      );
      unsaveService.updateData(
        "education",
        angular.copy(resumeEditor.user.education)
      );
      unsaveService.updateData(
        "experience",
        angular.copy(resumeEditor.user.experience)
      );
      unsaveService.updateData(
        "skills",
        angular.copy(resumeEditor.user.skills)
      );
      unsaveService.updateData(
        "achievements_awards",
        angular.copy(resumeEditor.user.achievements_awards)
      );
      unsaveService.updateData(
        "summary",
        angular.copy(resumeEditor.user.summary)
      );

      if (action !== "prevMove" && action !== "nextMove") {
        unsaveService.updateData(
          "resume_template",
          angular.copy($scope.selectedTemplate)
        );
      }
    }

    function checkUnsavedData() {
      var pdEqual = unsaveService.isEqual("personal_data", getPersonalData());
      var eduEqual = unsaveService.isEqual(
        "education",
        resumeEditor.user.education
      );
      var expEqual = unsaveService.isEqual(
        "experience",
        resumeEditor.user.experience
      );
      var skiEqual = unsaveService.isEqual("skills", resumeEditor.user.skills);
      var achEqual = unsaveService.isEqual(
        "achievements_awards",
        resumeEditor.user.achievements_awards
      );
      var summaryEqual = unsaveService.isEqual(
        "summary",
        resumeEditor.user.summary
      );
      var resumeTemplateEqual = unsaveService.isEqual(
        "resume_template",
        $scope.selectedTemplate
      );
      var isCkeditorDirty = unsaveService.isEditorDirty(CKEDITOR);

      return !(
        eduEqual &&
        expEqual &&
        skiEqual &&
        achEqual &&
        summaryEqual &&
        pdEqual &&
        resumeTemplateEqual &&
        !isCkeditorDirty
      );
    }

    $scope.$on(
      "$stateChangeStart",
      function (event, toState, toParams, fromState, fromParams, options) {
        if (
          toState.name !== fromState.name &&
          unsaveService.checkUnsavedData() &&
          !unsaveService.isAllowedLeaving
        ) {
          event.preventDefault();
          unsaveService.openConfirmModal().then(function () {
            unsaveService.isAllowedLeaving = true;
            unsaveService.removeUnloadEvent();
            $state.go(toState.name, toParams, options);
            ngDialog.close();
          });
        }
      }
    );
    // #endregion Check Unsave Data.

    // #region White Label Code.
    $scope.hasOrganization = function () {
      return organizationService.hasOrganization();
    };

    $scope.getOrganizationKey = function () {
      return organizationService.getOrganizationKey();
    };

    $scope.getOrganizationName = function () {
      return organizationService.getOrganizationName();
    };

    $scope.goToHome = function () {
      $state.go("dashboard");
    };

    resumeEditor.getResumeTemplates = function () {
      var organizationKey = organizationService.getOrganizationKey();

      resumeService
        .getTemplates(organizationKey)
        .then(function (templates) {
          // console.log("-- (Controller) resumeEditor.getResumeTemplates() - templates: ", templates);

          resume_template_options = templates;
          $scope.resume_template_options = templates;
          if (resume)
            selectedResume = resume_template_options.findIndex(function (i) {
              return i.value == resume.content.resume_layout;
            });

          $scope.selectedTemplate = resume_template_options[selectedResume];
          $scope.selectedTemplateIndex = selectedResume + 1;
          $scope.resumeselected = resume_template_options[selectedResume];
          $scope.templatesCount = resume_template_options.length;

          layout = resume_template_options[selectedResume].value;
          showTemplateThumb();

          if (selectedResume == 0) {
            $scope.prevDisabled = true;
          } else if (selectedResume == resume_template_options.length - 1) {
            $scope.nextDisabled = true;
          }

          // console.log("-- (Controller) resumeEditor.getResumeTemplates() - resume_template_options: ", resume_template_options);
        })
        .catch(function (e) {
          showErrorMessage(e, 2000);
        });
    };

    resumeEditor.getResumeTemplates();
    // #endregion White Label Code.

    // #region Resume Download Counter.
    $scope.downloaded = false;
    $scope.updated = false;

    resumeEditor.checkResumeDownloadCounter = function () {
      var cv = resumeEditor.getCounterVars();
      var passed = false;

      if (cv.resumeCounter < 0) {
        // console.log("-- (Controller) resumeEditor.checkResumeDownloadCounter() - Pass 1!");

        passed = true;
      } else if (cv.firstLoad && cv.resumeCounter > 0) {
        // console.log("-- (Controller) resumeEditor.checkResumeDownloadCounter() - Pass 2!");

        passed = true;
      } else if (cv.downloaded && !cv.isResumeDirty) {
        // console.log("-- (Controller) resumeEditor.checkResumeDownloadCounter() - Pass 3!");

        passed = true;
      } else if ((!cv.downloaded || cv.isResumeDirty) && cv.resumeCounter > 0) {
        // console.log("-- (Controller) resumeEditor.checkResumeDownloadCounter() - Pass 4!");

        $scope.downloaded = false;
        passed = true;
      } else {
        // console.log("-- (Controller) resumeEditor.checkResumeDownloadCounter() - Pass 5!");

        resumeEditor.showUnavailableResumesDialog();
      }

      // console.log("-- (Controller) resumeEditor.checkResumeDownloadCounter() - passed: ", passed);

      return passed;
    };

    resumeEditor.getCounterVars = function () {
      var resumeCounter = 0;
      var firstLoad = false;
      var downloaded = resumeEditor.resume.meta.downloaded;
      var isResumeDirty = $scope.isResumeDirty;

      if (
        typeof $localStorage.user !== "undefined" &&
        $localStorage.user !== null &&
        typeof $localStorage.user.resumeCounter !== "undefined" &&
        $localStorage.user.resumeCounter !== null
      ) {
        resumeCounter = $localStorage.user.resumeCounter;
      }

      if (
        typeof $stateParams.firstLoad === "boolean" &&
        $stateParams.firstLoad
      ) {
        firstLoad = $stateParams.firstLoad;
      }

      var cv = {
        resumeCounter: resumeCounter,
        firstLoad: firstLoad,
        downloaded: downloaded,
        isResumeDirty: isResumeDirty,
      };

      // console.log("-- (Controller) resumeEditor.getCounterVars() - cv: ", cv);

      return cv;
    };

    resumeEditor.showUnavailableResumesDialog = function () {
      var dialog = {
        template: "app/resume-builder/template/unavailable-resumes-dialog.html",
        controller: this,
        closeByDocument: false,
        closeByEscape: true,
        showClose: false,
        closeByNavigation: true,
        scope: $scope,
        width: "425px",
        height: "255px",
      };
      ngDialog.openConfirm(dialog);
    };

    $scope.showPaywall = function () {
      localStorage.setItem("toSubscriptionFrom", "resumes");
      $state.go("subscription");
    };
    // #endregion Resume Download Counter.

    $scope.enableSkillLevel = function (skill) {
      // console.log('-- (Controller) resumeEditor.$scope.enableSkillLevel() - skill: ', skill);

      if (skill.proficiency > 0) {
        skill.proficiency = 0;
      } else {
        skill.proficiency = 3;
        updateSkillsRatings(true);
      }
    };
  }
})();

(function () {
    'use strict';

    angular
        .module('intryFrontEnd')
        .controller('ResetPasswordController', ResetPasswordController);

    function ResetPasswordController($scope, $state, $stateParams, userService, login, passwordResetToken, constants, $translate, $rootScope, toastr) {

        var STATE_IDLE = 'idle';
        var STATE_PENDING = 'pending';
        var STATE_COMPLETE = 'complete';

        $scope.STATE_IDLE = STATE_IDLE;
        $scope.STATE_PENDING = STATE_PENDING;
        $scope.STATE_COMPLETE = STATE_COMPLETE;

        $scope.forgotPasswordForm = {};
        $scope.forgotPasswordForm.state = STATE_IDLE;
        $scope.forgotPasswordForm.login = login || '';
        $scope.forgotPasswordForm.phone = '';

        $scope.forgotPasswordForm.isValid = true;

        $scope.forgotPasswordLogin = $stateParams.login || '';
        $scope.changePasswordTitle =
            $stateParams.invitation ? "Welcome to Intry"
            : passwordResetToken ? "Reset Password"
            : "Change Password";

        $scope.resetPasswordForm = {};
        $scope.resetPasswordForm.state = STATE_IDLE;
        $scope.resetPasswordForm.securityCode = passwordResetToken || '';
        $scope.resetPasswordForm.password = '';
        $scope.resetPasswordForm.confirmPassword = '';
        $scope.resetPasswordForm.firstName = $stateParams.firstName || '';
        $scope.resetPasswordForm.lastName = $stateParams.lastName || '';
        
        // Click handler when user clicks on 'retrieve my password'
        $scope.forgotPassword = function () {

            // $scope.forgotPasswordForm.isValid = constants.EMAIL_PATTERN.test($scope.forgotPasswordForm.login) || constants.USA_PHONE_PATTERN.test($scope.forgotPasswordForm.login);
            // if (!$scope.forgotPasswordForm.isValid) {
            //     return;
            // }
            
            $scope.forgotPasswordForm.error = null;
            $scope.forgotPasswordForm.state = STATE_PENDING;
            userService.forgotPassword($scope.forgotPasswordForm.login, $scope.forgotPasswordForm.phone).then(function success(response) {
                if (response.status !== 200 && response.status !== 404) {
                    showResponseErrorMsg(response);
                } else {
                    $scope.forgotPasswordForm.state = STATE_COMPLETE;

                    if (response.data.resetPasswordBySecurityCode) {
                        // show screen that allows user to enter security code
                        $("*[class*='section-active']").removeClass('section-active');
                        $('.section-reset-password').addClass('section-active');
                    }
                }
            }, function error(response) {
                showResponseErrorMsg(response);
            });
        };

        // Click handler when user clicks on 'update password'
        $scope.resetPassword = function () {
            $scope.resetPasswordForm.state = STATE_PENDING;
            if ($scope.resetPasswordForm.password !== $scope.resetPasswordForm.confirmPassword) {
                $scope.resetPasswordForm.state = STATE_IDLE;
                // TODO: Localize string
                $scope.resetPasswordForm.error = 'Please ensure confirm password matches entered password';
                return;
            }

            userService.resetPassword(
                $scope.forgotPasswordForm.login,    // why does it not use resetPasswordForm.login?
                $scope.resetPasswordForm.password,
                $scope.resetPasswordForm.securityCode,
                $scope.resetPasswordForm.firstName,
                $scope.resetPasswordForm.lastName,
                $scope.isAnInvitation()
            ).then(function success(response) {
                var login = $scope.forgotPasswordForm.login;
                var password = $scope.resetPasswordForm.password;
                $scope.resetPasswordForm.state = STATE_COMPLETE;
                $scope.closeThisDialog();
                if (response.status === 200) {
                    buildToastrSuccess($translate.instant('RESET_PASSWORD_SUCCESS'), '', 4000);
                    userService.login(login, password).then(function success() {
                        $state.go('dashboard');                            
                    });
                } else {
                    var msg = '';
                    if (typeof response !== 'undefined' && typeof response.statusText !== 'undefined' && response.statusText.length > 0) {
                        msg = response.statusText;
                    } else {
                        msg = $translate.instant('RESET_PASSWORD_ERROR');
                    }
                    buildToastrError(msg, '', 4000);
                }
            }, function error(response) {
                $scope.resetPasswordForm.state = STATE_IDLE;
                var msg = '';
                if (typeof response !== 'undefined' && typeof response.statusText !== 'undefined' && response.statusText.length > 0) {
                    msg = response.statusText;
                } else {
                    msg = $translate.instant('RESET_PASSWORD_ERROR');
                }
                if (msg) {
                    $scope.resetPasswordForm.error = msg;
                } else {
                    $scope.resetPasswordForm.error = response.data.message;
                }
                buildToastrError(msg, '', 4000);
            });
        };

        // #region Password Methods.
        $scope.validatePass = function (pass, checkPass) {
            if (pass != undefined && checkPass != undefined) {
                if (pass !== checkPass || pass.length < 8 || checkPass.length < 8) {
                    return false;
                }
                return validatePassAux();
            }
            return false;
        };

        var validatePassAux = function () {
            if ($scope.isAnInvitation()) {
                var form = $scope.resetPasswordForm;
                return (typeof form.firstName === 'string' && form.firstName.trim().length > 0 && typeof form.lastName === 'string' && form.lastName.trim().length > 0);
            }
            else {
                return true;
            }
        };

        $scope.formSetup = {
            passwordHint: false,
            passwordMissMatch: $scope.validatePass($scope.resetPasswordForm.password, $scope.resetPasswordForm.confirmPassword),
            passStrength: 0,
            tooShort: false
        };

        $scope.passwordFocused = false;

        $scope.passwordStrengthString = function () {
            switch ($scope.formSetup.passStrength) {
            case 0:
                return 'Too short';
            case 1:
                return 'Poor';
            case 2:
                return 'Good';
            case 3:
                return 'Excellent';
            default:
                return '';
            }
        };

        $scope.testPass = function (pass) {
            var score = 0;
            
            if (pass) {
                if (pass.length >= 8) {
                    // award every unique letter until 5 repetitions
                    var letters = new Object();
                    for (var i = 0; i < pass.length; i++) {
                        letters[pass[i]] = (letters[pass[i]] || 0) + 1;
                        score += 5.0 / letters[pass[i]];
                    }

                    // bonus points for mixing it up
                    var variations = {
                        digits: /\d/.test(pass),
                        /* lower: /[a-z]/.test(pass), */
                        upper: /[A-Z]/.test(pass),
                        nonWords: /\W/.test(pass),
                    };
                    var variationCount = 0;
                    for (var check in variations) {
                        variationCount += (variations[check] === true) ? 1 : 0;
                    }
                    score += variationCount;
                }
            }
            $scope.formSetup.passStrength = score;
            return score;
        };
        // #endregion Password Methods.

        // #region Message Methods.
        var showResponseErrorMsg = function (response) {
            $scope.forgotPasswordForm.state = STATE_IDLE;
            if (response.statusText) {
                $scope.forgotPasswordForm.error = response.statusText;
            } else {
                $scope.forgotPasswordForm.error = (response.data || {}).message || constants.internalError;
            }
        };

        var buildToastrSuccess = function (content, title, timeout) {
            var t = toastr.info(content, title, {
                progressBar: true,
                timeOut: timeout,
                toastClass: 'toast',
                preventDuplicates: true,
                allowHtml: true,
                positionClass: 'toast-top-full-width',
                hideDuration: timeout,
                closeButton: true,
                showDuration: timeout,
                extendedTimeOut: timeout,
                hideMethod: 'noop'
            });
            $rootScope.toast = t;
        };

        var buildToastrError = function (content, title, timeout) {
            var t = toastr.info(content, title, {
                progressBar: true,
                timeOut: timeout,
                toastClass: 'toast-error',
                preventDuplicates: true,
                allowHtml: true,
                positionClass: 'toast-top-full-width',
                hideDuration: timeout,
                closeButton: true,
                showDuration: timeout,
                extendedTimeOut: timeout,
                hideMethod: 'noop'
            });
            $rootScope.toast = t;
        };
        // #endregion Message Methods.

        // #region Invitations.
        $scope.isAnInvitation = function () {
            return typeof $stateParams.invitation === 'string' && $stateParams.invitation === 'true';
        };

        $scope.invitationHasName = function () {
            const hasName =
                  typeof $stateParams.firstName === 'string' && $stateParams.firstName.length > 0
                  && typeof $stateParams.lastName === 'string' && $stateParams.lastName.length > 0;
            return hasName;
        };
        // #endregion Invitations.
    }
})();

/* global Intercom */
(function () {
    "use strict";

    angular

        .module("intryFrontEnd")

        .config(function (socialProvider, constants) {
            socialProvider.setLinkedInKey(constants.linkedINKey);
            socialProvider.setFbKey({
                appId: constants.facebook_Key,
                apiVersion: constants.facebook_api_ver,
            });
        })

        .factory("zxcvbn", [
            function () {
                return {
                    score: function () {
                        var compute = zxcvbn.apply(null, arguments);
                        return compute && compute.score;
                    },
                };
            },
        ])

        .factory('debounce', ['$timeout', '$q', function ($timeout, $q) {
            // The service is actually this function, which we call with the func
            // that should be debounced and how long to wait in between calls
            return function debounce(func, wait, immediate) {
                var timeout;
                // Create a deferred object that will be resolved when we need to
                // actually call the func
                var deferred = $q.defer();
                return function () {
                    var context = this, args = arguments;
                    var later = function () {
                        timeout = null;
                        if (!immediate) {
                            deferred.resolve(func.apply(context, args));
                            deferred = $q.defer();
                        }
                    };
                    var callNow = immediate && !timeout;
                    if (timeout) {
                        $timeout.cancel(timeout);
                    }
                    timeout = $timeout(later, wait);
                    if (callNow) {
                        deferred.resolve(func.apply(context, args));
                        deferred = $q.defer();
                    }
                    return deferred.promise;
                };
            };
        }])
    
        .controller("RegisterController", RegisterController);

    /** @ngInject */
    function RegisterController(
        $scope,
        $state,
        $stateParams,
        userService,
        JWTService,
        $location,
        $cookies,
        $rootScope,
        socialLoginService,
        modalService,
        $localStorage,
        StripeElements,
        $translate,
        toastr,
        constants,
        billingService,
        organizationService,
        debounce
    ) {

        // #region White Label Code.
        $scope.organization = null;
        $scope.organizationName = "";
        $scope.organizationKey = "";

        $scope.promoCodeNote = "";
        $scope.giftCodeNote = "";
        $scope.coupon = { valid: false };

        organizationService
            .getOrganizationByHostname(location.hostname)
            .then(function (organization) {
                // console.log('kjihujnkml,',organization)
                try {
                    if ((organization || {}).organizationKey.length > 0) {
                        $scope.organization = organization;
                        $scope.organizationName = organization.name;
                        $scope.organizationKey = organization.organizationKey;
                    } else {
                        console.error("unknown organization");
                        $scope.organization = null;
                        $scope.organizationName = '';
                        $scope.organizationKey = '';
                    }
                    if ($scope.showPaidSignup()) {
                        // You can register with a credit card
                        $scope.showStripeFields = true;
                        getPrices();
                    } else if ($scope.showCodeSignup()) {
                        // You can register if you have a "proctor" invitation code
                        $scope.showStripeFields = false;
                    } else {
                        // if its not paid registration and not code registration, then it is invitation only
                        // we are outa here
                        $location.path("/");
                    }
                } catch (e) {
                    // when in doubt, make them pay
                    $scope.showStripeFields = true;
                    getPrices();
                }
            });

        $scope.hasOrganization = function () {
            return organizationService.hasOrganization();
        };

        $scope.getOrganizationCss = function (css, returnEmpty) {
            return organizationService.getOrganizationCss(css, returnEmpty);
        };

        // If neither of these returns true then you can only sign up with
        // an invitation link

        $scope.showCodeSignup = function () {
            return organizationService.isCodeRegistration($scope.organization);
        };

        $scope.showPaidSignup = function () {
            return organizationService.isPaidRegistration($scope.organization);
        };

        $scope.getOrganizationKey = function () {
            return $scope.organizationKey || organizationService.getOrganizationKey();
        };

        $scope.getOrganizationName = function () {
            return $scope.organizationName || organizationService.getOrganizationName();
        };
        // #endregion White Label Code.


        $scope.verificationStatus = $stateParams.accountVerificationStatus;
        window.scrollTo(0, 0);
        $scope.emailVerificationStatus = $stateParams.changeEmailVerificationStatus;
        $scope.newUser = {
            currentStep: 1,
        };
        $scope.hasError = false;
        $scope.captions = [
            [
                "Increase your odds of getting the job of your dreams.",
                "Stop being invisible. Be relentless.",
                $localStorage.userId ? "Subscribe" : "Complete Registration",
            ],
            ["Complete your account setup to get hired fast!", "", "Finish"],
        ];
        if (
            $localStorage.userId &&
                !$localStorage.freeTrial &&
                !$localStorage.premiumAccess
        ) {
            var firstName = $localStorage.user.first_name;
            $scope.captions[0] = [
                firstName + ", your trial period has expired!",
                "Subscribe and get the job you truly deserve!",
                "Subscribe",
            ];
        }
        if ($localStorage.user) {
            $scope.newUser.firstname = $localStorage.user.first_name;
            $scope.newUser.lastname = $localStorage.user.last_name;
            if (
                $localStorage.user.email_addresses &&
                    $localStorage.user.email_addresses[0] &&
                    $localStorage.user.email_addresses[0].address
            ) {
                $scope.newUser.emailPhone =
                    $localStorage.user.email_addresses[0].address;
            }
        }
        $scope.getCaption = function (position) {
            return $scope.captions[$scope.newUser.currentStep - 1][position];
        };
        $scope.userExists = function () {
            return !!$localStorage.userId;
        };
        $scope.logOut = userService.logOut;

        var width = screen.width * 0.01;
        width = width.toString() + "px";
        var lineHeight = screen.width * 0.012 * 1.1;
        lineHeight = lineHeight.toString() + "px";
        if (screen.width > 2600) {
            width = screen.width * 0.01;
            width = width.toString() + "px";
            lineHeight = screen.width * 0.012 * 1.1;
            lineHeight = lineHeight.toString() + "px";
        }

        if (screen.width < 767) {
            width = "14px";
            lineHeight = (14 * 1.428571429).toString() + "px";
        }
        if (screen.width < 479) {
            width = screen.width * 0.04;
            width = width.toString() + "px";
            lineHeight = screen.width * 0.04 * 1.1;
            lineHeight = lineHeight.toString() + "px";
        }
        if (
            screen.availHeight < screen.availWidth &&
                screen.width <= 1500 &&
                screen.height <= 1400
        ) {
            // console.log('1')'
            width = screen.width * 0.0098;
            width = width.toString() + "px";
            lineHeight = screen.width * 0.0098 * 1.1;
            lineHeight = lineHeight.toString() + "px";
        }
        if (
            screen.availHeight < screen.availWidth &&
                screen.width <= 1000 &&
                screen.height <= 600
        ) {
            // console.log('2');
            width = screen.width * 0.0122;
            width = width.toString() + "px";
            lineHeight = screen.width * 0.0122 * 1.1;
            lineHeight = lineHeight.toString() + "px";
        }
        if (
            screen.availHeight < screen.availWidth &&
                screen.height <= 500 &&
                screen.width <= 800
        ) {
            // console.log('3');
            width = screen.width * 0.022;
            width = width.toString() + "px";
            lineHeight = screen.width * 0.022 * 1.1;
            lineHeight = lineHeight.toString() + "px";
        }

        // console.log("kjnhbgv", width, lineHeight, screen.width * 0.04);
        $scope.$ctrl = this;
        var style = {
            base: {
                color: "#333333",
                lineHeight: lineHeight,
                fontFamily: "sans-serif",
                fontSize: width,
                height: "fit-content",
                "::placeholder": {
                    color: "#d8d8d8",
                },
            },
            invalid: {
                color: "#fa755a",
                iconColor: "#fa755a",
            },
        };
        var elements = StripeElements.elements();
        var cardNumber = elements.create("cardNumber", {
            style: style,
            placeholder: "5555 5555 5555 4444",
        });
        var cardExpiry = elements.create("cardExpiry", {
            style: style,
            placeholder: "MM/YY",
        });
        var cardCvc = elements.create("cardCvc", {
            style: style,
            placeholder: "3 or 4 Digit Code",
        });
        cardNumber.mount("#card-number-stripe");
        cardExpiry.mount("#card-expiry-stripe");
        cardCvc.mount("#card-cvv-stripe");
        $scope.cardNumber = cardNumber;
        $scope.cardExpiry = cardExpiry;
        $scope.cardCvc = cardCvc;

        function promoCodeChanged() {
            if ($scope.newUser.promoCode !== $scope.coupon.id) {
                billingService.getCoupon($scope.newUser.promoCode).then(handleCouponResponse);
            }
        }
        $scope.$watch('newUser.promoCode', debounce(promoCodeChanged, 1000, false));

        function buildToastr(title, content) {
            $rootScope.toast = toastr.info(content, title, {
                progressBar: true,
                timeOut: 3500,
                toastClass: "toast-error",
                preventDuplicates: true,
                allowHtml: true,
                positionClass: "toast-top-center",
                hideDuration: 1000,
                closeButton: true,
                showDuration: 1000,
                extendedTimeOut: 1000,
            });
        }

        var handleError = function (error, step) {
            if (angular.isObject(error)) {
                if (angular.isObject(error.data)) {
                    if (typeof error.data.userID === "string") {
                        $scope.existingUserID = error.data.userID;
                    }
                    if (
                        typeof error.data.error === "string" &&
                            error.data.error.length > 0
                    ) {
                        error = error.data.error;
                    } else if (error.data.error instanceof Error) {
                        error = error.data.error.toString();
                    } else if (
                        typeof error.data.message === "string" &&
                            error.data.message.length > 0
                    ) {
                        error = error.data.message;
                    }
                } else if (
                    typeof error.message === "string" &&
                        error.message.length > 0
                ) {
                    error = error.message;
                } else {
                    error = "";
                }
            }

            if (typeof error !== "string" || error.length === 0) {
                error = $translate.instant("FAILED_PLEASE_TRY-AGAIN");
            }
            $scope.processing = false;
            $scope.foundError = error;
            buildToastr("Error", $scope.foundError);
            step = step || 1;
            if ($scope.newUser.currentStep !== step) {
                $scope.goToStep(step);
            }
        };

        $scope.goToStep = function (step) {
            $scope.newUser.currentStep = step ? step : $scope.newUser.currentStep + 1;
            setTimeout(function () {
                $scope.$apply();
            }, 0);
        };

        $scope.isCurrentStep = function (step) {
            return $scope.newUser.currentStep === step;
        };

        $scope.validateStep = function () {
            // console.log('-- (Controller) RegisterController.$scope.validateStep() - $scope.newUser: ', $scope.newUser);

            $scope.processing = true;
            switch ($scope.newUser.currentStep) {
            case 1:
                if (!$scope.newUser.firstname || !$scope.newUser.lastname) {
                    handleError(
                        $translate.instant("USER_PROFILE_CARD_NAME_REQUIRED_MESSAGE")
                    );
                } else if (!$scope.newUser.emailPhone) {
                    handleError(
                        $translate.instant("USER_PROFILE_BILLING_EMAIL_REQUIRED_MESSAGE")
                    );
                } else {
                    if ($scope.showStripeFields) {
                        var customerNameOnCard =
                            $scope.newUser.firstname + " " + $scope.newUser.lastname;
                        StripeElements["createToken"](cardNumber, {
                            name: customerNameOnCard,
                        })
                            .then(function (result) {
                                if (result.error) {
                                    handleError(result.error.message);
                                } else {
                                    $scope.newUser.cardToken = result.token;
                                    $scope.processing = false;
                                    if ($localStorage.userId) {
                                        $scope.subscribeExistingUser();
                                    } else {
                                        $scope.newUser.username = $scope.newUser.emailPhone;
                                        $scope.goToStep();
                                    }
                                }
                            })
                            .catch(function (err) {
                                handleError($translate.instant("FAILED_CREDIT_CARD_INVALID"));
                            });
                    } else {
                        if (!$scope.newUser.code) {
                            handleError(
                                $translate.instant("USER_PROFILE_CODE_REQUIRED_MESSAGE")
                            );
                        } else {
                            $scope.newUser.username = $scope.newUser.emailPhone;
                            $scope.processing = false;
                            $scope.goToStep();
                        }
                    }
                }
                break;
            case 2:
                // if (!$scope.newUser.username) {
                //     handleError($translate.instant('USER_PROFILE_USERNAME_REQUIRED_MESSAGE'), 2);
                // } else
                if (!$scope.newUser.password || $scope.formSetup.tooShort) {
                    handleError(
                        $translate.instant("USER_PROFILE_PASSWORD_REQUIRED_MESSAGE"),
                        2
                    );
                } else if (
                    $scope.newUser.password !== $scope.newUser.confirmPassword
                ) {
                    handleError(
                        $translate.instant(
                            "USER_PROFILE_PASSWORD_CONFIRM_REQUIRED_MESSAGE"
                        ),
                        2
                    );
                } else {
                    if ($scope.showStripeFields) {
                        $scope.subscribeNewUser();
                    } else {
                        $scope.registerNewUserWithCode();
                    }
                }
                break;
            default:
                $scope.newUser = {
                    currentStep: 1,
                };
                $scope.processing = false;
                break;
            }
        };

        $scope.subscribeExistingUser = function () {
            userService
                .subscribeExistingUser(
                    $localStorage.userId,
                    $scope.newUser.emailPhone,
                    $scope.newUser.cardToken,
                    constants.stripePlanID,
                    $scope.newUser.promoCode,
                    $scope.newUser.giftCardCode
                )
                .then(function (subscriberData) {
                    if (
                        subscriberData &&
                            subscriberData.data &&
                            subscriberData.data.status === "SUCCESS"
                    ) {
                        // Intercom('update', {
                        //     'User ID': subscriberData.data.userID,
                        //     'email': $scope.newUser.emailPhone,
                        //     'Full name': $scope.newUser.firstname + ' ' + $scope.newUser.lastname,
                        //     'First Name': $scope.newUser.firstname,
                        //     'Last Name': $scope.newUser.lastname,
                        //     'Username': $scope.newUser.emailPhone,
                        //     'Status': 'Subscribed'
                        // });
                        $state.go("subscribed");
                    } else {
                        handleError(subscriberData);
                    }
                })
                .catch(handleError);
        };

        $scope.subscribeNewUser = function () {
            // console.log('-- (Controller) RegisterController.$scope.subscribeNewUser()');

            var newUser = {
                username: $scope.newUser.username,
                password: $scope.newUser.password,
                firstName: $scope.newUser.firstname,
                lastName: $scope.newUser.lastname,
                billingEmail: $scope.newUser.emailPhone,
                token: $scope.newUser.cardToken,
                planId: $scope.newUser.planId,
                couponId: validCouponId(),
                giftCardCode: $scope.newUser.giftCardCode,
                // >>> KSH how can a method called subscribeNewUser have an existing user id?
                // it seems they think the method this calls can resume create afer error.  it cannot.
                existingUserID:
                typeof $scope.existingUserID === "string" &&
                    $scope.existingUserID.length > 0
                    ? $scope.existingUserID
                    : "",
                hostname: location.hostname,
                utm: getUtmParams(),
                resumeCounter: $scope.newUser.resumeCounter,
                freeUser: !$scope.showStripeFields,
            };

            userService
                .subscribeNewUser(newUser)
                .then(function (subscriberData) {
                    if (
                        subscriberData &&
                            subscriberData.data &&
                            subscriberData.data.status === "SUCCESS"
                    ) {
                        userService.welcomeUser(subscriberData.data.userID, {
                            email: newUser.billingEmail,
                            hostname: location.hostname,
                            utm: getUtmParams(),
                            newuser: true,
                        });
                        // Intercom('update', {
                        //     'User ID': subscriberData.data.userID,
                        //     'email': $scope.newUser.emailPhone,
                        //     'Full name': $scope.newUser.firstname + ' ' + $scope.newUser.lastname,
                        //     'First Name': $scope.newUser.firstname,
                        //     'Last Name': $scope.newUser.lastname,
                        //     'Username': $scope.newUser.emailPhone,
                        //     'Status': 'Subscribed'
                        // });
                        if (!$localStorage.showOnBoarding) {
                            $localStorage.showOnBoarding = {};
                        }
                        $localStorage.showOnBoarding[subscriberData.data.userID] = true;
                        // console.log("-- (Controller) RegisterController.$scope.subscribeNewUser() - newUser: ", newUser);
                        var pricePlan = ($scope.newUser || {}).price || 0;
                        var pricePaid = subscriberData.data.pricePaid;
                        $localStorage.freeUser = pricePlan == 0;

                        // >>> SHAREASALE <<<
                        if ($stateParams.shareASale) {
                            var img = document.createElement("img");
                            img.src =
                                " https://www.shareasale.com/sale.cfm?tracking=" +
                                subscriberData.data.userID +
                                "&amount=" +
                                pricePaid +
                                "&merchantID=142585&transtype=sale";
                            img.width = 1;
                            img.height = 1;
                            var script = document.createElement("script");
                            script.src = "https://www.dwin1.com/54467.js";
                            script.type = "text/javascript";
                            script.defer = "defer";
                            document.getElementsByTagName("head")[0].appendChild(img);
                            document.getElementsByTagName("head")[0].appendChild(script);
                        }
                        // >>> REWARDFUL <<<
                        else if (typeof window.rewardful === 'function') {
                            window.rewardful('convert', { email: newUser.billingEmail });
                        }
                        $state.go("subscribed");
                    } else if (subscriberData.data.status === "SUBSCRIPTION_ERROR") {
                        handleError(subscriberData);
                    } else {
                        handleError(subscriberData);
                    }
                })
                .catch(handleError);
        };

        $scope.registerNewUserWithCode = function () {
            // console.log('-- (Controller) RegisterController.$scope.subscribeNewUser()');

            var options = {
                invited: true,
                signupCode: $scope.newUser.code,
                defaultOrganization: $scope.organizationKey,
                emailPhone: $scope.newUser.emailPhone,
                utm: getUtmParams(),
            };
            var template = {
                username: $scope.newUser.username,
                password: $scope.newUser.password,
                first_name: $scope.newUser.firstname,
                last_name: $scope.newUser.lastname,
            };
            userService
                .createUser(template, options)
                .then(function (response) {
                    if (angular.isObject(response) && response.status === 201) {
                        $localStorage.showOnBoarding = {};
                        $localStorage.showOnBoarding[response.data.userID] = true;
                        userService
                            .login(template.username, template.password)
                            .then(function (user) {
                                $state.go("subscribed");
                            });
                    } else {
                        handleError(response);
                    }
                })
                .catch(handleError);
        };

        $scope.validatePass = function (pass, checkPass) {
            if (pass != undefined && checkPass != undefined) {
                if (pass !== checkPass || pass.length < 8 || checkPass.length < 8) {
                    return false;
                }
                return true;
            }
            return true;
        };

        $scope.formSetup = {
            startedToRegister: false,
            alreadyRegistered: false,
            passwordHint: false,
            passwordMissMatch: $scope.validatePass(
                $scope.newUser.password,
                $scope.newUser.passwordConfirm
            ),
            passStrength: 0,
            isUsernameFieldBlur: false,
            tooShort: false,
        };

        // var qs = $location.search();
        // for(var element in qs){
        //     if(qs.hasOwnProperty(element) && element === 'email') {
        //         $scope.newUser.emailPhone = qs[element];
        //         break;
        //     }
        //   }

        $scope.$on("event:social-sign-in-success", function (event, userDetails) {
            $scope.result = userDetails;

            userService
                .socialLogin(
                    userDetails.uid,
                    userDetails.email,
                    userDetails.name,
                    userDetails.provider
                )
                .then(function (data) {
                    if (!$localStorage.showOnBoarding) {
                        $localStorage.showOnBoarding = {};
                    }
                    if ($localStorage.showOnBoarding[data.userID] == undefined)
                        $localStorage.showOnBoarding[data.userID] = true;
                    $state.go("subscribed");
                });
        });

        $rootScope.$on(
            "event:social-sign-out-success",
            function (event, userDetails, $timeout) {
                $state.go("login");
            }
        );

        $scope.requestCreate = function () {
            if (!$scope.formSetup.alreadyRegistered) {
                $scope.formSetup.startedToRegister = true;
                //$('.first-name').focus();
                var isFormReady =
                    Object.keys($scope.newUser).length === 6 &&
                    $scope.newUser.emailPhone.trim().length > 0 &&
                    $scope.newUser.username.trim().length > 0 &&
                    $scope.validatePass(
                        $scope.newUser.password,
                        $scope.newUser.password2
                    );
                if (!isFormReady) {
                    return;
                } else {
                    $rootScope.loadingInProcess = true;
                    register();
                }
            }
        };

        $scope.conflictAgent = userService.conflictAgent;

        function register() {
            $scope.hasError = false;
            $scope.newUser["email_addresses"] = [];
            $scope.newUser.email_addresses.push({
                kind: "Other",
                address: $scope.newUser.emailPhone,
            });
            var queryString =
                $location.$$url.indexOf("?") !== -1
                ? $location.$$url.split("?")[1]
                : "";
            userService
                .registerUser($scope.newUser, queryString)
                .then(function (response) {
                    // Intercom('update', {
                    //     "User ID": response.data.userID,
                    //     "email": $scope.newUser.emailPhone,
                    //     "Full name": $scope.newUser.firstname + ' ' + $scope.newUser.lastname,
                    //     "First Name": $scope.newUser.firstname,
                    //     "Last Name": $scope.newUser.lastname,
                    //     "Username": $scope.newUser.emailPhone,
                    //     "Status": 'Registered'
                    // });

                    if (response.data.userID) {
                        if (!$localStorage.showOnBoarding) {
                            $localStorage.showOnBoarding = {};
                        }
                        $localStorage.showOnBoarding[response.data.userID] = true;
                    }
                    userService
                        .login($scope.newUser.username, $scope.newUser.password)
                        .then(function (data) {
                            $rootScope.loadingInProcess = false;
                            //userService.createCustomer();
                            $state.go("subscribed");
                        });
                })
                .catch(function (err) {
                    $rootScope.loadingInProcess = false;
                    if (err.data.message === "A user with this username already exists") {
                        $scope.formSetup.alreadyRegistered = true;
                    } else {
                        delete $scope.newUser.email_addresses;
                        alert(err.data.message);
                    }
                });
        }

        $scope.passwordStrengthString = function () {
            switch ($scope.formSetup.passStrength) {
            case 0:
                return "Too short";
            case 1:
                return "Poor";
            case 2:
                return "Good";
            case 3:
                return "Excellent";
            default:
                return "";
            }
        };

        $scope.testPass = function (pass) {
            var score = 0;
            if (!pass) {
                $scope.formSetup.passStrength = score;
                return score;
            }

            // award every unique letter until 5 repetitions
            var letters = new Object();
            for (var i = 0; i < pass.length; i++) {
                letters[pass[i]] = (letters[pass[i]] || 0) + 1;
                score += 5.0 / letters[pass[i]];
            }

            // bonus points for mixing it up
            var variations = {
                digits: /\d/.test(pass),
                /*           lower: /[a-z]/.test(pass), */
                upper: /[A-Z]/.test(pass),
                nonWords: /\W/.test(pass),
            };

            var variationCount = 0;
            for (var check in variations) {
                variationCount += variations[check] == true ? 1 : 0;
            }
            if (pass.length >= 8) $scope.formSetup.passStrength = variationCount;
            else $scope.formSetup.passStrength = 0;
            return score;
        };

        $scope.isUserAlreadyRegistered = function () {
            if ($scope.newUser.username) {
                userService
                    .isUserAlreadyRegistered($scope.newUser.username)
                    .then(function (response) {
                        $scope.formSetup.alreadyRegistered = !!response;
                        $scope.hasError = !!response;
                        $scope.errorMessage = "Username is not valid";
                    })
                    .catch(function () {
                        $scope.formSetup.alreadyRegistered = false;
                    });
            }
        };
        $scope.ieBrowser = detectIE();

        function detectIE() {
            var ua = window.navigator.userAgent;
            var msie = ua.indexOf("MSIE ");
            var trident = ua.indexOf("Trident/");
            var edge = ua.indexOf("Edge/");
            if (msie > 0 || trident > 0 || edge > 0) {
                return true;
            }
            // other browser
            return false;
        }

        // #region Init Code.
        function init() {
            // console.log('-- RegisterController.init()');

            var utm = getUtmParams();

            try {
                var utmSource = utm.utmSource;

                // This is for handling "Urchin Tracking Modules" - marketing campaigns managed by tags specified in urls.

                if (typeof utmSource === "string" && utmSource === "propel") {
                    // console.log('-- RegisterController.init() - Load scripts');
                    // $.getScript('https://tracking.propelmedia.com/?id=1GB2ADG9E72GE21A4CBF&fetch=0&value=0');
                    // $.get('https://tracking.propelmedia.com/?id=1GB2ADG9E72GE21A4CBF&fetch=1&value=0');
                    // An example of a UTM which we have not used in years.
                    // var script = document.createElement("script");
                    // script.src =
                    //     "https://tracking.propelmedia.com/?id=1GB2ADG9E72GE21A4CBF&fetch=0&value=0";
                    // document.getElementsByTagName("head")[0].appendChild(script);
                    // var img = document.createElement("img");
                    // img.src =
                    //     "https://tracking.propelmedia.com/?id=1GB2ADG9E72GE21A4CBF&fetch=1&value=0";
                    // document.getElementsByTagName("head")[0].appendChild(img);
                }
            } catch (e) {
                // console.log('-- RegisterController.init() Load tracking.propelmedia.com scripts exception: ', e)
            }

            checkPersonalData();
        }

        function checkPersonalData() {
            var emailKey = "email";
            var fnameKey = "fname";
            var lnameKey = "lname";

            try {
                var params = $location.search();
                var email = "";
                var fname = "";
                var lname = "";

                if (
                    typeof params[emailKey] === "string" &&
                        params[emailKey].length > 0
                ) {
                    email = params[emailKey];
                    $scope.newUser.emailPhone = email;
                }

                if (
                    typeof params[fnameKey] === "string" &&
                        params[fnameKey].length > 0
                ) {
                    fname = params[fnameKey];
                    $scope.newUser.firstname = fname;
                }

                if (
                    typeof params[lnameKey] === "string" &&
                        params[lnameKey].length > 0
                ) {
                    lname = params[lnameKey];
                    $scope.newUser.lastname = lname;
                }

                if (email.length > 0 && fname.length && lname.length) {
                    // console.log('-- RegisterController.checkPersonalData() - Pass the autocomplete validation!');
                    $scope.validateStep();
                } else {
                    // console.log('-- RegisterController.checkPersonalData() - Not pass the autocomplete validation!');
                }
            } catch (e) {
                // console.log('-- RegisterController.checkPersonalData() - Exception: ', e);
            }
        }

        init();
        // #endregion Init Code.

        // #region UTM.
        function getUtmParams() {
            var utm = {
                utmSource: "",
                utmMedium: "",
                utmCampaign: "",
                utmTerm: "",
                utmContent: "",
                utmPostbackSuccess: false,
            };

            if (
                typeof $location.search().utm_source === "string" &&
                    $location.search().utm_source.length > 0
            ) {
                utm.utmSource = $location.search().utm_source;
            } else {
                return utm;
            }

            if (
                typeof $location.search().utm_medium === "string" &&
                    $location.search().utm_medium.length > 0
            ) {
                utm.utmMedium = $location.search().utm_medium;
            }

            if (
                typeof $location.search().utm_campaign === "string" &&
                    $location.search().utm_campaign.length > 0
            ) {
                utm.utmCampaign = $location.search().utm_campaign;
            }

            if (
                typeof $location.search().utm_term === "string" &&
                    $location.search().utm_term.length > 0
            ) {
                utm.utmTerm = $location.search().utm_term;
            }

            if (
                typeof $location.search().utm_content === "string" &&
                    $location.search().utm_content.length > 0
            ) {
                utm.utmContent = $location.search().utm_content;
            }

            return utm;
        }
        // #endregion UTM.

        // #region Subscription Code.
        $scope.showStripeFields = true;

        function setCoupon(pc) {
            if (pc) {
                $scope.coupon = pc;
                if ($scope.newUser.promoCode !== pc.id) {
                    $scope.newUser.promoCode = pc.id;
                }
            }
            else {
                $scope.coupon = { valid: false, id: $scope.newUser.promoCode };
            }
            pc = $scope.coupon;
            $scope.couponPriceId = pc.valid && pc.metadata && pc.metadata.priceId ? pc.metadata.priceId : '';
            $scope.couponPriceName = pc.valid && pc.metadata && pc.metadata.priceName ? pc.metadata.priceName : '';
            updatePromoCodeNote();
            // console.log("coupon>>>>>>>>>>>>>", validCouponId());
        }

        function resetPrices() {
            $scope.pricesLoaded = false;
            $scope.prices = [];
            $scope.showOnePrice = false;
            $scope.subscriptionAmount = "";
            $scope.subscriptionDescription = "";
            $scope.priceDownloadsLabel = "";
            $scope.priceFeatures = [];
        }

        setCoupon();
        resetPrices();

        function handleCouponResponse(response) {
            if (response !== null && typeof response === 'object') {
                if (response.status === 200) {
                    setCoupon(response.data);
                    return true;
                }
            }
            setCoupon();
            return false;
        }

        function getPrices(useDefault) {
            billingService
                .getCoupon(!useDefault ? $scope.newUser.promoCode || $location.search().promo : '')
                .then(function (couponResponse) {

                    handleCouponResponse(couponResponse);

                    var productID = useDefault
                        ? constants.stripeProductID
                        : $location.search().pp; // at the moment there is only one product id
                    var planID = $scope.couponPriceId ? $scope.couponPriceId : $location.search().ppp; // so pp does nothing and ppp has to be one of the

                    useDefault = useDefault || false;
                    resetPrices();

                    if (constants.stripeProductIDs.indexOf(productID) < 0 || useDefault) {
                        // If we did not find productID or useDefault is set, then set defaultProduct
                        // In fact there is only one product ATM, so its always useDefault in practice
                        productID = constants.stripeProductID;
                        useDefault = constants.stripeProductID === productID;
                    }
                    if (constants.stripePlanIDs.indexOf(planID) < 0 && useDefault) {
                        // if the plan id we got from search does not belong to the default product
                        // then ignore it and set the default plan
                        planID = constants.stripePlanID;
                    }
                    billingService
                        .getPrices(productID)
                        .then(function (response) {
                            try {
                                var prices = [];
                                var price = null;
                                if (Array.isArray(response.data) && response.data.length > 0) {
                                    prices = response.data.filter(function (p) {
                                        return p.amount > 0;
                                    });
                                } else {
                                    var data = response.data || {};
                                    if (
                                        data.description &&
                                            data.amount &&
                                            data.id &&
                                            data.amount > 0
                                    ) {
                                        prices = [response.data];
                                    }
                                }
                                if (prices.length > 0) {
                                    price = prices.find(function (p) {
                                        // find the planID we selected above
                                        return p.id === planID;
                                    });
                                    if (!price) {
                                        // if we don't find it, then arbitrarily choose the first price
                                        price = prices[0];
                                    }
                                }
                                if (price) {
                                    // set the select price plan for the scope
                                    planID = price.id;
                                    $scope.subscriptionDescription = price.description;
                                    $scope.subscriptionAmount = price.amount;
                                    $scope.prices = prices;
                                    $scope.pricesLoaded = true;
                                    $scope.planID = planID;
                                    $scope.newUser.planId = planID;
                                    $scope.updatePlanId(planID, price.amount);
                                    $scope.showOnePrice = prices.length === 1;
                                    setTimeout(function () {
                                        $("#" + $scope.planID).trigger("click");
                                    });
                                } else if (!useDefault) {
                                    // if that shit did not work, then try default (in fact we already did but there used to be more products)
                                    getPrices(true);
                                }
                            } catch (e) {
                                if (!useDefault) {
                                    // if that shit did not work, then try default (in fact we already did but there used to be more products)
                                    getPrices(true);
                                }
                            }
                        })
                        .catch(function (error) {
                            if (!useDefault) {
                                getPrices(true);
                            }
                        });
                });
        }

        
        if (typeof window.rewardful === 'function') {
            window.rewardful('ready', function () {
                console.debug("rewardful affiliate program ready!");
                if (angular.isObject(window.Rewardful) && window.Rewardful.referral) {
                    // The current website visitor is a referral from an affiliate.
                    console.debug('rewardful referral from affiliate:', window.Rewardful.affiliate);
                }
            });
        }
        else {
            console.debug("rewardful affiliate program NOT installed");
        }
        
        function updatePromoCodeNote() {
            $scope.promoCodeClass = "";
            $scope.promoCodeNote = "";
            if ($scope.couponPriceId) {
                if ($scope.couponPriceId !== $scope.newUser.planId && $scope.newUser.planId !== undefined) {
                    $scope.promoCodeNote = "This code can only be used with the " + $scope.couponPriceName + " plan";
                    $scope.promoCodeClass = "red";
                }
                else if (!$scope.coupon.valid) {
                    $scope.promoCodeNote = $scope.coupon.text || "This code is expired or has been used already";
                    $scope.promoCodeClass = "red";
                }
                else {
                    $scope.promoCodeNote = $scope.coupon.text || "valid code";
                }
            }
            else if ($scope.newUser.promoCode) {
                if (!$scope.coupon.valid) {
                    $scope.promoCodeNote = $scope.coupon.text || "invalid code";
                    $scope.promoCodeClass = "red";
                }
                else {
                    $scope.promoCodeNote = $scope.coupon.text || "valid code";
                }
            }
        }

        function validCouponId() {
            var couponId = '';
            var coupon = $scope.coupon !== null && typeof $scope.coupon === 'object' ? $scope.coupon : { valid: false, id: '' };

            if ($scope.newUser.promoCode === coupon.id) {
                if ($scope.couponPriceId && $scope.newUser.planId && ($scope.newUser.planId !== $scope.couponPriceId)) {
                    couponId = '';
                }
                else if (coupon.valid) {
                    couponId = coupon.id;
                }
            } else if (!coupon.id && $scope.newUser.promoCode) {
                couponId = $scope.newUser.promoCode;
            }
            return couponId;
        }

        $scope.updatePlanId = function (planId, price) {
            // console.log("-- (Controller) RegisterController.$scope.updatePlanId() - planId: ", planId);
            // console.log("-- (Controller) RegisterController.$scope.updatePlanId() - price: ", price);

            try {
                $scope.newUser.planId = planId;
                $scope.newUser.price = price;

                if (typeof price === "undefined" || price === null) {
                    price = $scope.prices.find(function (p) {
                        return p.id === planId;
                    });
                }

                if (parseFloat(price.amount) == 0) {
                    $scope.showStripeFields = false;
                }

                $scope.subscriptionAmount = price.amount;
                $scope.newUser.resumeCounter = price.metadata.downloads;
                $scope.priceDownloadsLabel = price.metadata.downloadsLabel;

                var featuresNumber = parseInt(price.metadata.featuresNumber);
                if (!isNaN(featuresNumber)) {
                    $scope.priceFeatures = [];
                    for (var i = 0; i < featuresNumber; i++) {
                        $scope.priceFeatures.push(price.metadata["feature" + i]);
                    }
                } else {
                    $scope.priceFeatures = price.metadata.features.split(";");
                }
                updatePromoCodeNote();
            } catch (e) {
                // Do nothing...
            }
        };

        $scope.showPlanFeatures = function () {
            return (
                typeof $scope.newUser.planId === "string" &&
                    $scope.newUser.planId.length > 0
            );
        };

        $scope.getOrderClassPanel = function (panel) {
            if (
                ($scope.isCurrentStep(1) && panel == 1) ||
                    ($scope.isCurrentStep(2) && panel == 1)
            ) {
                return "signup-content-wrapper w-col w-col-6 order-md-12";
            } else if (
                ($scope.isCurrentStep(1) && panel == 2) ||
                    ($scope.isCurrentStep(2) && panel == 2)
            ) {
                return "signup-image-wrapper w-col w-col-6 order-md-1";
            }
            return "";
        };
        // #endregion Subscription Code.
    }
})();

(function () {
  'use strict';

  angular
    .module('intryFrontEnd')
    .controller('ProfileDisableController', ProfileDisableController);

  function ProfileDisableController($scope, subscriptionId, user, userService, constants, $translate) {

    $scope.user = user;
    $scope.disableInProcess = false;
    $scope.selectedReasonForDisableProfile =  $translate.instant('USER_PROFILE_DISABLE_REASON_1');
    $scope.moreDetailsForDisable;
    $scope.showMoreDetailsForDisable = false;

    $scope.disableReasons = [
      $translate.instant('USER_PROFILE_DISABLE_REASON_1'),
      $translate.instant('USER_PROFILE_DISABLE_REASON_2'),
      $translate.instant('USER_PROFILE_DISABLE_REASON_3'),
      $translate.instant('USER_PROFILE_DISABLE_REASON_4'),
      $translate.instant('USER_PROFILE_DISABLE_REASON_5'),
      $translate.instant('USER_PROFILE_DISABLE_REASON_6'),
      $translate.instant('USER_PROFILE_DISABLE_REASON_7'),
    ]
       
    $scope.disableReasonSelected = function (reason){
      $scope.selectedReasonForDisableProfile = reason;
      if(reason !=  $translate.instant('USER_PROFILE_DISABLE_REASON_7')) {
        $scope.moreDetailsForDisable = '';
        $scope.showMoreDetailsForDisable = false;
      }
      else {
        $scope.showMoreDetailsForDisable = true;
      }
    }


    //Soft deletes the user after cancelling Stripe subscription for a given user
    $scope.disableUserProfile = function () {
      $scope.disableInProcess = true;
      if(subscriptionId && user.status != constants.user_statuses.PAUSED) {
        userService.pauseSubscription(subscriptionId).then(function (response) {
          if (response != constants.codes.ERROR) {
            disableUser();
          } else {
            $scope.disableInProcess = false;
            $scope.error = $translate.instant('USER_PROFILE_ACCOUNT_PAUSED_FAILURE_MESSAGE');
          }
        })
      } else {
        disableUser();
      }
    };

    //Soft deletes the user
    function disableUser(userID) {
      userService.disableUserAccount($scope.selectedReasonForDisableProfile, $scope.moreDetailsForDisable).then(function (response) {
        if(response === constants.codes.SUCCESS) {
        $scope.disableInProcess = false;
        userService.logOut();
        }
        else {
          $scope.disableInProcess = false;
         $scope.error = $translate.instant('USER_PROFILE_ACCOUNT_DISABLE_FAILURE_MESSAGE');
        }
      }).catch(function(err){
        $scope.disableInProcess = false;
        $scope.error = $translate.instant('USER_PROFILE_ACCOUNT_DISABLE_FAILURE_MESSAGE');
      });
    }
  }
})();
(function () {
    'use strict';

    angular
        .module('intryFrontEnd')

        .config(function(socialProvider,constants){
            socialProvider.setLinkedInKey(constants.linkedINKey);
            socialProvider.setFbKey({appId: constants.facebook_Key, apiVersion: constants.facebook_api_ver});
        })

        .controller('ProfileController', ProfileController);

    /** @ngInject */
    function ProfileController($scope, $timeout, user, userService, modalService, $state, constants) {

        window.scrollTo(0, 0);
        $scope.user = user;
        $scope.user.full_name = user.full_name || (user.first_name + ' ' + user.last_name);
        $scope.disablePaswordChange = true;
        $scope.disableEmailChange = true;
        $scope.allowAccountDisable = userService.isPaidFeatureEnabled(user);

        if (!angular.isUndefined(user.phone_numbers[0])) {
            $scope.user.phone_number = user.phone_numbers[0].number;
            $scope.user.phone_type = user.phone_numbers[0].kind;
            $scope.user.phone_id = user.phone_numbers[0]._id;
        }
        if (!angular.isUndefined(user.addresses[0])) {
            $scope.user.street = user.addresses[0].street;
            $scope.user.street_2 = user.addresses[0].street_2;
            $scope.user.city = user.addresses[0].city;
            $scope.user.state = user.addresses[0].state;
            $scope.user.country = user.addresses[0].country;
            $scope.user.postal_code = user.addresses[0].postal_code;
            $scope.user.address_type = user.addresses[0].kind;
            $scope.user.address_id = user.addresses[0]._id;
        }
        getEmailAddressForProfile();
        isDisconnectEnabled('facebook');
        isDisconnectEnabled('linkedIN');

        $scope.$on('event:social-sign-in-success', function(event, userDetails){

            var userData = {
                id: userDetails.uid,
                email: userDetails.email,
                name: userDetails.name,
                provider: userDetails.provider
            };

            userService.connectSocialAccount(userData).then(function (response){
                if(response === 'Connected'){
                    isDisconnectEnabled(userDetails.provider)
                }

            });
        });
        $scope.updatePersonalInfo = function () {
            var u = {
                full_name: $scope.user.full_name
            };
            if ($scope.user.phone_number) {
                u.phone_numbers = [{
                    number: $scope.user.phone_number,
                    kind: $scope.user.phone_type ? $scope.user.phone_type : constants.default_phone_kind,

                }];
                if ($scope.user.phone_id) {
                    u.phone_numbers[0]._id = $scope.user.phone_id;
                }
            }
            if ($scope.user.street) {
                u.addresses = [{
                    street: $scope.user.street,
                    street_2: $scope.user.street_2,
                    city: $scope.user.city,
                    state: $scope.user.state,
                    country: $scope.user.country,
                    postal_code: $scope.user.postal_code,
                    kind: $scope.user.address_type ? $scope.user.address_type : constants.default_address_kind,
                }];
                if ($scope.user.address_id) {
                    u.addresses[0]._id = $scope.user.address_id;
                }
            }
            userService.updateCurrentUser(u).then(function (response) {

            });
        };
        $scope.showDisableProfileModal = function() {
            modalService.openModal(
                'app/profile-disable/template/profile-disable.html' ,
                'ProfileDisableController',{
                    user: function () {
                        return userService.getUser();
                    }
                }
            );
        };

        $scope.changeEmail = function () {
            getEmailAddressForProfile();
            $scope.disableEmailChange = false;
        };

        $scope.cancelChangeEmail = function () {
            $scope.disableEmailChange = true;
            $scope.user.email =  $scope.exisitingEmail;
        };

        $scope.saveEmail = function () {
            //Save new email address
            var u = {};
            if ($scope.user.email) {
                u.email_change = {
                    address: $scope.user.email,
                    kind: $scope.user.email_type ? $scope.user.email_type : constants.default_email_kind,

                };
                if ($scope.user.email_id) {
                    u.email_change.email_address_id = $scope.user.email_id;
                }
                userService.changeEmail(u).then(function (response) {
                    $scope.disableEmailChange = true;
                });
            }
        };

        $scope.changePassword = function () {
            $scope.disablePaswordChange = false;
        };

        $scope.cancelChangePassword = function () {
            $scope.disablePaswordChange = true;
        };

        $scope.savePassword = function () {
            //Save new password to user
            if(user.password) {
                userService.changePassword(user.username, user.password).then(function (response) {
                    $scope.changePasswordMessage = response.message;
                });
            }
            $scope.disablePaswordChange = true;
        };

        $scope.pauseUserAccount = function () {
            userService.pauseUserAccount(user.username).then(function (response) {
                $scope.pauseAccountMessage = response.message;
            });
        };

        $scope.disconnectSocialAccount = function(provider) {
            userService.disconnectSocialAccount(provider).then(function (response){
                if(response === 'Disconnected'){
                    isDisconnectEnabled(provider)
                }
            });
        };
        //Sreejith : Neeed to rewrite the logic here
        function isDisconnectEnabled(provider) {
            userService.getSocialAccountConnectedStatus(provider)
                .then(function (response) {
                    if(response === "Disconnected") {
                        if(provider === 'facebook') {
                            $scope.showDisconnectForFacebook = false;
                        } else {
                            $scope.showDisconnectForLinkedIN = false;
                        }
                    } else {
                        if(provider === 'facebook') {
                            $scope.showDisconnectForFacebook = true;
                        } else {
                            $scope.showDisconnectForLinkedIN = true;
                        }
                    }
                });
        }

        function getEmailAddressForProfile() {
            userService.getEmailAddressForProfile().then(function (response) {
                if(!angular.isUndefined(response)) {
                    $scope.user.email = response.email;
                    $scope.user.email_type = response.kind;
                    $scope.user.email_used_status = response.used_status;
                    $scope.user.email_id = response.email_address_id;
                    $scope.showEmailConfirmationMessage =  !response.confirmed && response.email;
                    $scope.exisitingEmail = response.email;
                } else {
                    $scope.showEmailConfirmationMessage = false;
                }
            });
        }
    }
})();

(function () {
    'use strict';
    
    angular
        .module('intryFrontEnd')
        .controller('OnboardingController', OnboardingController);
    
    function OnboardingController($scope, $rootScope, $filter, user, $timeout, userService, communitiesService, resumeService, utilsService, constants, $translate, $state, $location, $localStorage) {
        
        $scope.timePickerDateFormat = 'MMM d, y';
        $scope.momentTimePickerDateFormat = 'MMM D, YYYY';
        $scope.showUploadResume = false;
        $scope.uploadDialog = null;
        $scope.user = {};
        $scope.user.first_name = user.first_name;
        $scope.user.last_name = user.last_name;
        $scope.user.addresses = [];
        $scope.closeUploadDialog = null;

        $scope.closeModal = function() {
            $scope.closeThisDialog();
        };

        var getDateTimeValue = function (dateTime) {
            if (dateTime && moment(new Date(dateTime)).isValid()) {
                return new Date(dateTime).toISOString();
            } else {
                return null;
            }
        };
        
        var inActiveAllSections = function () {
            $("*[class*='section-active']").removeClass('section-active');
        };

        var activateSection = function (sectionCSSSelector) {
            $(sectionCSSSelector).addClass("section-active");
        };
        $scope.setCloseFunc = function(func){
            $scope.closeUploadDialog = func;
        };
        $scope.goToResumeLoaderSection = function () {
            if($scope.closeUploadDialog)
                $scope.closeUploadDialog();

            inActiveAllSections();
            activateSection(".section-resume-loader");
        };
        function parseDate(dateString) {
            var dateStrArray = [];
            dateStrArray = dateString.split('-');
            var monthIndex = dateStrArray[1] ? parseInt(dateStrArray[1]) : '';
            var year = dateStrArray[0] ? dateStrArray[0] : '';
            var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            var finalDate = (monthIndex ? monthNames[monthIndex - 1] : monthNames[0]) + ' ' + year;
            return finalDate;
        }
        
        $scope.finish = function (firstTime) {
            $rootScope.loadingInProcess = true;
            var disableNext = false;
            if (disableNext) {
                $rootScope.loadingInProcess = false;
                return;
            }
            var u = {
                first_name: $scope.user.first_name,
                last_name: $scope.user.last_name,
                full_name: $scope.user.full_name
            };
            
            if ($scope.user.phone_number) {
                u.phone_numbers = [{
                    number: $scope.user.phone_number.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g,'').replace(/\s/g,''),
                    kind: $scope.user.phone_type ? $scope.user.phone_type : constants.default_phone_kind,
                }];
                if ($scope.user.phone_id) {
                    u.phone_numbers[0]._id = $scope.user.phone_id;
                }
            }
            
            if ($scope.user.email) {
                u.email_addresses = [{
                    address: $scope.user.email,
                    kind: $scope.user.email_type ? $scope.user.email_type : constants.default_email_kind
                }];
                if ($scope.user.email_id) {
                    u.email_addresses[0]._id = $scope.user.email_id;
                }
            }
            
            var education = [];
            for (var i = 0 ; i < $scope.educations.length; i += 1) {
                if ($scope.educations[i].institution) {
                    var ed = {
                        institution: $scope.educations[i].institution,
                        is_current: (!$scope.educations[i].date_end),
                    };
                    if ($scope.educations[i]._id) {
                        ed._id = $scope.educations[i]._id;
                        ed.deleted = $scope.educations[i].deleted;
                    }
                    if ($scope.educations[i].degree) {
                        ed.degree = $scope.educations[i].degree;
                    }
                    if ($scope.educations[i].field_of_study) {
                        ed.field_of_study = $scope.educations[i].field_of_study;
                    }
                    
                    ed.date_end = $scope.educations[i].date_end ? $scope.educations[i].date_end : '';
                    ed.date_start = $scope.educations[i].date_start ? $scope.educations[i].date_start : '';
                    ed.startDateObj = $scope.educations[i].startDateObj ? $scope.educations[i].startDateObj : '';
                    ed.endDateObj = $scope.educations[i].endDateObj ? $scope.educations[i].endDateObj : '';
                    ed.kind = ($scope.educations[i].kind) ? $scope.educations[i].kind : constants.default_education_kind;
                    ed.notes = $scope.educations[i].notes ? $scope.educations[i].notes: '';
                    education.push(ed);
                }
            }
            if (education.length > 0) {
                u.education = education;
            }
            
            var skills = [];
            var skillOrderIndex = 0;
            for (var i = 0 ; i < $scope.skills.length; i += 1) {
                var sk = {
                    skill: $scope.skills[i].skill,
                    proficiency: $scope.skills[i].proficiency ? $scope.skills[i].proficiency : constants.default_proficiency,
                };
                if (!$scope.skills[i].deleted) {
                    sk.order_index = skillOrderIndex;
                    skillOrderIndex += 1;
                }
                if ($scope.skills[i]._id) {
                    sk._id = $scope.skills[i]._id;
                    sk.deleted = $scope.skills[i].deleted;
                }
                skills.push(sk);
            }
            if (skills.length > 0) {
                u.skills = skills;
            }
            
            var experience = [];
            for (var i = 0 ; i < $scope.employments.length; i += 1) {
                if ($scope.employments[i].company) {
                    var ex = {
                        company: $scope.employments[i].company,
                        description: $scope.employments[i].description ? $scope.employments[i].description: '',
                        summary: $scope.employments[i].summary ? $scope.employments[i].summary: '',
                        is_current: (!$scope.employments[i].date_end),
                    };
                    
                    if ($scope.employments[i]._id) {
                        ex._id = $scope.employments[i]._id;
                        ex.deleted = $scope.employments[i].deleted;
                    }
                    ex.date_end = $scope.employments[i].date_end ? $scope.employments[i].date_end : '';
                    ex.date_start = $scope.employments[i].date_start ? $scope.employments[i].date_start : '';
                    ex.endDateObj = $scope.employments[i].endDateObj ? $scope.employments[i].endDateObj : '';
                    ex.startDateObj = $scope.employments[i].startDateObj ? $scope.employments[i].startDateObj : '';
                    if ($scope.employments[i].title) {
                        ex.title = $scope.employments[i].title;
                    }
                    if ($scope.employments[i].location) {
                        ex.location = $scope.employments[i].location;
                    }
                    ex.kind = ($scope.employments[i].kind) ? $scope.employments[i].kind : constants.default_employment_kind;
                    
                    experience.push(ex);
                }
            }
            if (experience.length > 0) {
                u.experience = experience;
            }
            if(firstTime){
                userService.updateCurrentUser(u, null, firstTime).then(function(response) {
                    // $scope.employments = response.experience;
                    // $scope.educations = response.education;
                    // $scope.skills = response.skills;
                    userService.incrementSovrenParsedResumeNum().then(function() {
                        userService.isResumeImportAllowed().then(function (response) {
                            $scope.isResumeImportAllowed = response;
                            $scope.confirm(response);
                            $rootScope.loadingInProcess = false;
                            $state.go('user-profile');
                        });
                    });
                });
            }
        };
        userService.isResumeImportAllowed().then(function (response) {
            $scope.isResumeImportAllowed = response;
        });

        $scope.openResumeSelector = function () {
            $('#upload_resume').trigger('click');
        };

        var saveResumeToAttachment = function(uploadedResumeFile) {
            var attachment = {};
            attachment.file = uploadedResumeFile;
            attachment.type = 'Resume';
            userService.uploadCurrentUserAttachments(attachment);
        };

        $scope.parseResumeData = function(file) {
            if (file && file.length > 0) {
                var allowedFiles = ["doc", "docx", "pdf", "txt"];
                var allowedFilesRegex = new RegExp("^.*\.+(" + allowedFiles.join('|') + ")$");
                if (!allowedFilesRegex.test(file[0].name.toLowerCase())) {
                    if($scope.closeUploadDialog)
                        $scope.closeUploadDialog();

                    $('.file_type_error').html($translate.instant('RESUME_UPLOAD_ALLOWED_EXTENSION',{allowed_files : allowedFiles.join(', ')}));
                    return;
                }
                $('.resume-loading-status').html($translate.instant('ONBOARDING_READING_RESUME_STATUS'));
                setTimeout(function() { $('.resume-loading-status').html($translate.instant('ONBOARDING_READING_RESUME_CONVERT'));}, 150);
                var reader = new FileReader();
                reader.onload = function (event) {
                    var base64Text = utilsService.arrayBufferToBase64(event.target.result);
                    if (base64Text) {
                        $scope.resume_loading_error = false;

                        $scope.goToResumeLoaderSection();
                        
                        resumeService.parseResumeData(base64Text).then(function (response) {
                            $scope.skills = [];
                            $scope.skillValue = '';
                            $scope.educations = [];
                            $scope.employments = [];
                            $scope.dataImport = true;
                            saveResumeToAttachment(file[0]);
                            $scope.user = response.data.user;
                            _.each(response.data.experienceList, function(element){
                                // element.date_end = element.date_end ? parseDate(element.date_end) : element.date_end;
                                // element.date_start = element.date_start ? parseDate(element.date_start) : element.date_start;
                                element.startDateObj = utilsService.formatDate(element.date_start);
                                element.endDateObj = utilsService.formatDate(element.date_end);
                            });
                            _.each(response.data.educationList, function(element){
                                // element.date_end = element.date_end ? parseDate(element.date_end) : element.date_end;
                                // element.date_start = element.date_start ? parseDate(element.date_start) : element.date_start;
                                element.startDateObj = utilsService.formatDate(element.date_start);
                                element.endDateObj = utilsService.formatDate(element.date_end);
                            });
                            $scope.employments = response.data.experienceList;
                            $scope.educations = response.data.educationList;
                            $scope.skills = response.data.skills;
                            $scope.finish(true);
                            
                        }).catch(function(err) {
                            $scope.showModalError = true;
                            if (!angular.isUndefined(err) && !angular.isUndefined(err.data) && !angular.isUndefined(err.data.message)) {
                                $('.resume-loading-status').html(err.data.message);
                                $scope.resume_loading_error = true;
                            }
                        });
                    }
                };
                reader.readAsArrayBuffer(file[0]);
            }
        };
        $scope.stopLoader = function() {
            $rootScope.loadingInProcess = false;
        };
        $scope.gotoProfile = function() {
            $state.go('user-profile');
        };
        $scope.gotoAssessment = function() {
            $state.go('assessments');
        };
        $scope.showWarningMsg = function (){
            $('.file_type_error').html('');
            if(userService.isProUser())
                $scope.openResumeSelector();
            else
                $scope.showUploadResume = true;
        };
        $scope.uploadSuccess = function() {
            $scope.showUploadResume = false;
        };
        $scope.uploadResume = function() {
            $timeout(function () {
                $scope.openResumeSelector();
            }, 100);
            $scope.showUploadResume = false;
        };

        $scope.paymentRequired = false;
        $scope.paymentSuccess = function (updatedUser) {
            $scope.paymentRequired = false;
            if(updatedUser != null){
                $scope.user = updatedUser;
                $state.go('dashboard');
            }
        };
        $scope.paymentError = function (error) {
        };
        $scope.showPaywall = function() {
            localStorage.setItem("toSubscriptionFrom", "user_profile");
            $location.path('subscription');
        };
        $scope.showStartWizardBtn = function () {
            if ($localStorage.freeUser) {
                return false;
            } else {
                return true;
            }
        };
        $scope.paywallClose = function() {
            $scope.paymentRequired = false;
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('intryFrontEnd')
        .controller('NotDownloadedController', NotDownloadedController);

    function NotDownloadedController($scope, $state, $stateParams, userService,resumeEditor, constants, $translate, $rootScope, toastr) {



        $scope.confirmDownload=function(   $event,
            isNotShowConfirmSaveDialog){
                resumeEditor.downloadResume($event,
                isNotShowConfirmSaveDialog)
        }

        $scope.isAnInvitation = function () {
            return typeof $stateParams.invitation === 'string' && $stateParams.invitation === 'true';
        };

        $scope.invitationHasName = function () {
            const hasName =
                  typeof $stateParams.firstName === 'string' && $stateParams.firstName.length > 0
                  && typeof $stateParams.lastName === 'string' && $stateParams.lastName.length > 0;
            return hasName;
        };
        // #endregion Invitations.
    }
})();

(function () {
    'use strict';

    angular
        .module('intryFrontEnd')

    // >>> KSH either fix the social login machinery or remove the ancient broekn code

        .config(function(socialProvider,constants) {
            socialProvider.setLinkedInKey(constants.linkedINKey);
            socialProvider.setFbKey({appId: constants.facebook_Key, apiVersion: constants.facebook_api_ver});
        })

        .controller('MyAccountController', MyAccountController);

    function nonNullObject(o) {
        return o !== null && typeof o === 'object';
    }

    function nonEmptyArray(a) {
        return Array.isArray(a) && (a.length > 0);
    }

    function nonEmptyString(s) {
        return typeof s === 'string' && s.length > 0;
    } 

   /** @ngInject */
    function MyAccountController($scope, $timeout, user, userService, modalService, $state, constants, $localStorage, StripeElements, ngDialog, $translate, phoneFormatter, toastr, $rootScope, utilsService, organizationService) {

        $scope.user = user;

        window.scrollTo(0, 0);
        try {
            window.barecancel.params.customer_oid = user.stripe_customerID;
            window.barecancel.params.callback_cancel = cancelTheSubscription;
        }
        catch (e) {
            // no barecancel?
            console.error(e);
        };

        $scope.$ctrl = this;
        $scope.disablePaswordChange = true;
        $scope.disableEmailChange = true;
        $scope.subscriptionPaused = false;
        $scope.pauseAccountMessage = '';
        $scope.showSocialAccountConnectError = '';
        $scope.disableAddressChange = true;
        $scope.profileImgModal = false;
        $scope.defaultImage = $scope.user.profile_picture_url ? false : true;
        $scope.cropped = {
            source: $scope.user.profile_picture_url
        };
        $scope.validatePhone = true;
        $scope.phonePattern = constants.USA_PHONE_PATTERN_2;

        $scope.state = '';
        $scope.showDiscount = false;

        $scope.emailPattern = constants.EMAIL_PATTERN;
        $scope.showPassword = false;

        $scope.allowAccountDisable = userService.isPaidFeatureEnabled(user);
        $scope.freeTrialExpires = userService.freeTrialExpires(user);

        var elements = StripeElements.elements();
        var elementsModal = StripeElements.elements();
        var element = elements.create('card', {});
        var hasACardonFile = false;

        $scope.element = element;
        this.element = element;

        var monthlyRecurringTotalTitle = $translate.instant('USER_PROFILE_MONTHLY_RECURRING_TOTAL_TITLE_TEXT');
        var newMonthlyRecurringTotalTitle = $translate.instant('USER_PROFILE_NEW_MONTHLY_RECURRING_TOTAL_TITLE_TEXT');
        
        $scope.$watch('profileImgModal', function (isShowModal) {
            
            if (isShowModal) {
                $('html, body').addClass('ngdialog-open');
            } else {
                $('html, body').removeClass('ngdialog-open');
            }
        });
        var setProfilePicWidth = function() {
            $timeout(function() {
                $('.row-profile-pic').find('.img').width($('.row-profile-pic').find('.img').height());
            }, 0);
        };

        getAddressForProfile();
        getEmailAddressForProfile();
        isDisconnectEnabled('facebook');
        isDisconnectEnabled('linkedIN');
        setProfilePicWidth();

        $scope.$on('event:social-sign-in-success', function(event, userDetails){

            var userData = {
                id: userDetails.uid,
                email: userDetails.email,
                name: userDetails.name,
                provider: userDetails.provider
            };
            
            userService.connectSocialAccount(userData).then(function (response){
                if(response === constants.codes.SUCCESS){
                    isDisconnectEnabled(userDetails.provider);
                }
                else if(response === constants.codes.USER_EXISTS){
                    $scope.showSocialAccountConnectError = $translate.instant('USER_PROFILE_USER_ID_EXISTS',{provider_name:userDetails.provider});
                }
                else {
                    $scope.showSocialAccountConnectError = $translate.instant('USER_PROFILE_SOCIAL_CONNECT_FAILED_MESSAGE');
                }
            });
        });

        $scope.phoneFlatten = function () {
            if ($scope.user.phone_number.number && !$scope.disableAddressChange)
                $scope.user.phone_number.number = phoneFormatter.flatten($scope.user.phone_number.number);
        };

        $scope.phoneDisplay = function () {
            if ($scope.user.phone_number.number)
                $scope.user.phone_number.number = phoneFormatter.format($scope.user.phone_number.number);
        };

        $scope.changeAddress = function() {
            $scope.disableAddressChange = false;
        };
        $scope.cancelChangeAddress = function () {
            getAddressForProfile();
            getEmailAddressForProfile();
            $scope.disableAddressChange = true;
        };

        function buildPhoneNumber(phone, flat) {
            var phonenumber = {
                number: '',
                kind: ''
            };
            var phn, phoneItem;

            if (Array.isArray(phone) && phone.length) {
                phn = phone.filter(function(el) {
                    return !el.deleted;
                });
                if (phn.length) {
                    phoneItem = phn[phn.length - 1];
                    phonenumber.number = flat ? phoneFormatter.flatten(phoneItem.number) : phoneFormatter.format(phoneItem.number);
                    phonenumber.kind = phoneItem.kind;
                }
            }
            return phonenumber;
        }

        $scope.updatePersonalData = function() {
            
            var phoneValid = true;
            var postalCodeValid = true;
            $scope.errorMessage = '';
            $scope.user.full_name_current = utilsService.getFullName($scope.user.first_name_current, $scope.user.last_name_current);
            var u = {
                first_name: $scope.user.first_name_current,
                last_name: $scope.user.last_name_current
            };

            if ($scope.user.full_name_current) {
                u.full_name = $scope.user.full_name_current;
            }

            if ($scope.user.phone_number.number) {
                $scope.user.phone_number.number = $scope.user.phone_number.number.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g,'');
                $scope.user.phone_number.number = $scope.user.phone_number.number.replace(/\s/g,'');

                $scope.user.phone_number.kind = $scope.user.phone_type ? $scope.user.phone_type : constants.default_phone_kind;
                $scope.user.phone_number.deleted = false;
                $scope.user.phone_numbers.push($scope.user.phone_number);        
                $scope.user.phone_number = buildPhoneNumber($scope.user.phone_numbers, true);

                if ($scope.user.phone_number.number.length === 10) {
                    phoneValid = constants.USA_PHONE_PATTERN_2.test($scope.user.phone_number.number);
                } else {
                    phoneValid = false;
                }
            } else {
                phoneValid = false;
            }

            if ($scope.user.postal_code) {
                postalCodeValid = constants.US_PIN_CODE.test($scope.user.postal_code);
            }

            //Set phone number only if user enters phone number 
            if ($scope.user.phone_number.number) {
                u.phone_numbers  = [{
                    number: $scope.user.phone_number.number,
                    kind: $scope.user.phone_type ? $scope.user.phone_type : constants.default_phone_kind,
                    deleted: false
                }];
            }

            // >>> KSH wtf doe this mean?  Mandatory?  Keep using deleted?  BS
            //
            // If user deletes existing phone number, then mark it as deleted 
            // but still needs to send original phone number as number is mandatory in 
            // api
            //
            else if(nonEmptyString($scope.user.phone_id)) {
                
                u.phone_numbers  = [{
                    number: $scope.user.phone_number_original,
                    kind: $scope.user.phone_type ? $scope.user.phone_type : constants.default_phone_kind,
                    deleted: true
                }];
            }

            if (!phoneValid && !postalCodeValid) $scope.errorMessage = $translate.instant('USER_PROFILE_INVALID_PHONE_POSTAL_CODE');
            else if (!phoneValid) $scope.errorMessage = $translate.instant('USER_PROFILE_INVALID_PHONE');
            else if (!postalCodeValid) $scope.errorMessage = $translate.instant('USER_PROFILE_INVALID_POSTAL_CODE');

            if (!phoneValid || !postalCodeValid) {
                return ;
            }

            u.addresses = [{
                street: $scope.user.street,
                street_2: $scope.user.street_2,
                city: $scope.user.city,
                state: $scope.user.state,
                country: $scope.user.country,
                postal_code: $scope.user.postal_code,
                kind: $scope.user.address_type ? $scope.user.address_type : constants.default_address_kind,
            }];
            if ($scope.user.address_id) {
                u.addresses[0]._id = $scope.user.address_id;
            }
            if (u.phone_numbers && $scope.user.phone_id) {
                u.phone_numbers[0]._id = $scope.user.phone_id;
            }
            userService.updateCurrentUser(u).then(function (response) {
                user = response;
                getAddressForProfile();
                getEmailAddressForProfile();
                $scope.disableAddressChange = true;        
            });      
        };
        $scope.showDisableProfileModal = function() {
            modalService.openModal(
                'app/profile-disable/template/profile-disable.html' , 
                'ProfileDisableController',{
                    subscriptionId: function () {
                        return $scope.subscriptionId;
                    },
                    user: function () {
                        return userService.getUser();
                    }
                }
            );
        };

        $scope.changeEmail = function () { 
            $scope.disableEmailChange = false;
        };
        $scope.cancelChangeEmail = function () {
            $scope.disableEmailChange = true;
            $scope.user.email =  $scope.exisitingEmail;
        };
        // #region Delete Profile Picture.
        $scope.profileImgModalDelete = false;

        $scope.showImageLoaderForDelete = function () {
            $scope.profileImgModal = true;
            $scope.profileImgModalDelete = true;
        };

        $scope.savingEmail = false;
        
        $scope.saveEmail = function (isConfirm) {
            // Save new email address
            var u = {};
            isConfirm = !!isConfirm;
            if ($scope.user.email) {
                if (!$scope.savingEmail) {
                    $scope.savingEmail = true;
                    u.email_change = {
                        address: $scope.user.email,
                        kind: $scope.user.email_type ? $scope.user.email_type : constants.default_email_kind,

                    };
                    if ($scope.user.email_id) {
                        u.email_change.email_address_id = $scope.user.email_id;
                    }
                    u.hostname = location.hostname;
                    userService.changeEmail(u, isConfirm).then(function (response) {
                        try {
                            const data = typeof response === 'object' && typeof response.data === 'object' && response.data !== null ? response.data : {};
                            if (data.status === 'error') {
                                buildToastr(response.data.message, "Warning:", 4000);
                            }
                            else {
                                $scope.disableEmailChange = true;
                                if (data.confirmationEmailSent) {
                                    buildToastr("Confirmation link sent to " + $scope.user.email + ".", "Check Your Email:", 8000);
                                }
                            }
                            getEmailAddressForProfile();
                            $scope.savingEmail = false;
                        }
                        catch (e) {
                            $scope.savingEmail = false;
                        }
                    }).catch(function (error) {
                        $scope.savingEmail = false;
                    });
                }
            }
        }
        ;
        // 'Save' the current email address to force the API to send a confirmation link
        $scope.confirmEmail = function() { $scope.saveEmail(true); };

        // Profile image selector
        $scope.selectProfileImage = function (files) {
            $scope.profileImgModalDelete = false;
            var reader = new FileReader();

            reader.onload = function (e) {
                // bind new Image to Component
                $scope.$apply(function () {
                    $scope.cropped.source = e.target.result;
                });
            };
            reader.readAsDataURL(files[0]);
            $scope.profileImgModal = true;
            // There used to be a lot of shitty code here that did what the oneline reader does now...
        };
        $scope.openProfileImageSelector = function () {
            $('#file').trigger('click');
        };
        $scope.deleteResumePicture = function () {
            var url = '';
            $scope.profilePictureURL = url;
            $scope.cropped.source = url;

            userService.updateCurrentUser({
                profile_picture_url: url
            }).then(function (response) {
                $scope.defaultImage = true;
                $scope.profilePictureURL = response.profile_picture_url;
                $scope.user.profile_picture_url = $scope.profilePictureURL;
                $scope.cropped.source = $scope.profilePictureURL;
                $scope.user.profile_picture_url = $scope.cropped.source;

                $scope.showImageLoader = false;
                $scope.profileImgModal = false;
                $rootScope.loadingInProcess = false;
            }, function () {
                $scope.showImageLoader = false;
                $rootScope.loadingInProcess = false;
            });
        };
        $scope.changePassword = function () {
            $scope.disablePaswordChange = false;
        };
        $scope.cancelChangePassword = function () {
            $scope.disablePaswordChange = true;
        };
        $scope.savePassword = function () {
            //Save new password to user
            if(user.password) {
                userService.changePassword(user.username, user.password).then(function (response) {
                    $scope.changePasswordMessage = response.message;
                });
            }
            $scope.disablePaswordChange = true;
        };

        // $scope.pauseSubscription = function () {
        //     $scope.loadingData = true;
        //     $scope.pauseAccountMessage = '';
        //     userService.pauseSubscription($scope.subscriptionId).then(function (response) {
        //         if (response === constants.codes.ERROR) {
        //             $scope.pauseAccountMessage = $translate.instant('USER_PROFILE_ACCOUNT_PAUSED_FAILURE_MESSAGE');
        //         }
        //         else {
        //             updateSubscriptionPaused();
        //             getAddressForProfile(); 
        //             getEmailAddressForProfile();
        //         }
        //         $scope.loadingData = false;
        //     });
        // };

        $scope.reactivateSubscription = function () {
            $scope.loadingData = true;
            $scope.pauseAccountMessage = '';
            userService.reactivateSubscription().then(function (response){
                if (response.data.message === constants.codes.ERROR) {
                    $scope.pauseAccountMessage =  $translate.instant('USER_PROFILE_SUBSCRIPTION_FAILED_MESSAGE');
                    $scope.loadingData = false;
                }
                else if (response.data.message === constants.codes.SUCCESS) {
                    $scope.subscriptionPaused = false;
                    // ^^^ That's not good enough you moron.
                    //
                    // if the api succeeded the fields below were set to null.
                    // But loadAndPoulate checks them BEFORE reload and will
                    // reset subscriptionPaused to true if either is not null.
                    // So null them before we call loadAndPopulate.
                    // 
                    $scope.user.disable_request_date = null;
                    $scope.user.disable_completed_date = null;
                    getAddressForProfile();
                    getEmailAddressForProfile();
                    loadAndPopulate();
                } else if (response.data.message === 'Re-Register') {
                    $scope.paymentRequired = true;
                }
            });
        };
        $scope.disconnectSocialAccount = function(provider) {
            userService.disconnectSocialAccount(provider).then(function (response){
                if (response === 'Disconnected') {
                    isDisconnectEnabled(provider);
                }
            });
        };
        // >>> Sreejith : Neeed to rewrite the logic here
        function isDisconnectEnabled(provider) {
            userService.getSocialAccountConnectedStatus(provider)
                .then(function (response) {
                    if (response === "Disconnected") {
                        if (provider === 'facebook') {
                            $scope.showDisconnectForFacebook = false;
                        }
                        else {
                            $scope.showDisconnectForLinkedIN = false;
                        }
                    }
                    else {
                        if(provider === 'facebook') {
                            $scope.showDisconnectForFacebook = true;
                        }
                        else {
                            $scope.showDisconnectForLinkedIN = true;
                        }
                    }
                });
        }
        function getAddressForProfile() {

            $scope.user.full_name_current = utilsService.getFullName(user.first_name, user.last_name);
            $scope.user.first_name_current = user.first_name;
            $scope.user.last_name_current = user.last_name;

            if (nonEmptyArray(user.phone_numbers) && !angular.isUndefined(user.phone_numbers[user.phone_numbers.length - 1])) {
                $scope.user.phone_number = buildPhoneNumber(user.phone_numbers, false);
                $scope.user.phone_number_original = user.phone_numbers[user.phone_numbers.length - 1].number;
                $scope.user.phone_type = user.phone_numbers[user.phone_numbers.length - 1].kind;
                $scope.user.phone_id = user.phone_numbers[user.phone_numbers.length - 1]._id;
            }
            else {
                $scope.user.phone_number = '';
                $scope.user.phone_type = '';
                $scope.user.phone_id = '';
            }
            if (nonEmptyArray(user.addresses) && !angular.isUndefined(user.addresses[0])) {
                $scope.user.street = user.addresses[0].street;
                $scope.user.street_2 = user.addresses[0].street_2;
                $scope.user.city = user.addresses[0].city;
                $scope.user.state = user.addresses[0].state;
                $scope.user.country = user.addresses[0].country;
                $scope.user.postal_code = user.addresses[0].postal_code;
                $scope.user.address_type = user.addresses[0].kind;
                $scope.user.address_id = user.addresses[0]._id;
            }
            else {
                $scope.user.street = '';
                $scope.user.street_2 = '';
                $scope.user.city = '';
                $scope.user.state = '';
                $scope.user.country = '';
                $scope.user.postal_code = '';
                $scope.user.address_type = '';
                $scope.user.address_id = '';
            }
        }
        function getEmailAddressForProfile() {
            userService.getEmailAddressForProfile().then(function (response) {
                if (nonNullObject(response) && nonEmptyString(response.email)) {
                    $scope.user.email = response.email;
                    $scope.user.email_type = response.kind;
                    $scope.user.email_used_status = response.used_status;
                    $scope.user.email_id = response.email_address_id;
                    $scope.showEmailConfirmationMessage =  !response.confirmed && response.email;
                    $scope.exisitingEmail = response.email;
                } else {
                    $scope.showEmailConfirmationMessage = false;
                }
            });
        }

        var loadAndPopulate = function () {
            $scope.allPlans = [];
            $scope.allAddons = [];
            $scope.addonsSubscribed = [];
            $scope.plansSubscribed = [];
            $scope.addonsForEdit = [];
            $scope.total = 0;
            $scope.discount = {};
            populatePersonalData();

            //  If user has paused their account, it wont autorenew, but functions until end of billing period
            if( $scope.user.disable_request_date || $scope.user.disable_completed_date ) {
                updateSubscriptionPaused();
            }
            
            $scope.loadingData = true;
            userService.getAccount().then(function (customer) {
                if (nonNullObject(customer)) {
                    populateNextCharge(customer.data.subscriptions.data[0]);
                    populateSubscriptionDetails(customer.data.subscriptions.data[0]);
                    populateCardForm(customer.data);          
                    calculateTotals();
                    populateAllAddons();
                }
                else {
                    $scope.overDue = false;
                    $scope.nextBillingDate = '';
                    $scope.subscriptionEndsDate = '';
                } 
                $scope.loadingData = false;
            });
        };
        var updateSubscriptionPaused = function () {
            $scope.pauseAccountMessage = $translate.instant('USER_PROFILE_ACCOUNT_PAUSED_SUCCESS_MESSAGE');
            $scope.subscriptionPaused = true;
        };

        var populatePersonalData = function () {
            if (user.profile_picture_url) {
                $scope.profilePictureURL = user.profile_picture_url;
            }
        };

        var populateNextCharge = function (data) {
            if (nonNullObject(data)) {
                $scope.nextBillingDate = data.current_period_end;
                $scope.subscriptionEndsDate = data.cancel_at;
                checkForOverdueInvoices(data.status);
            }
        };

        var populateSubscriptionDetails = function (data) {
            // console.log('-- (Controller) MyAccountController.populateSubscriptionDetails() - data: ', data);
            
            if (nonNullObject(data)) {
                loadSubscribedAddonsandPlans(data.items.data, $scope.plansSubscribed, 'plan', 'candidates');
                loadSubscribedAddonsandPlans(data.items.data, $scope.addonsSubscribed, 'add-on', 'candidates');
                populateDiscounts(data.discount);
                saveSubscriptionID(data);
                
                // console.log('-- (Controller) MyAccountController.populateSubscriptionDetails() - $scope.plansSubscribed: ', $scope.plansSubscribed);
                // console.log('-- (Controller) MyAccountController.populateSubscriptionDetails() - $scope.addonsSubscribed: ', $scope.addonsSubscribed);
            }
        };

        var populateCardForm = function (data) {
            if (nonNullObject(data)) {
                //Show/hide CC form
                if (data.sources.data.length > 0) {
                    $scope.showForm = false;
                    hasACardonFile = true;
                    if (data.sources.data[0].brand) {
                        $scope.brand = data.sources.data[0].brand;
                        $scope.last4 = data.sources.data[0].last4;
                    }
                } else {
                    element.clear();
                    $scope.showForm = true;
                    hasACardonFile = false;
                }
            }
        };

        var checkForOverdueInvoices = function (status) {

            if (status === 'past_due') {
                $scope.overDue = true;
            } else {
                $scope.overDue = false;
            }
        };
        $scope.upload_cropped_img = function () {
            $rootScope.loadingInProcess = true;
            var imageBase64 = $scope.cropped.image;
            $scope.user.profile_picture_url = $scope.cropped.image;
            $scope.defaultImage = false;
            var imgdata = imageBase64.split(',')[1];
            var ct = imageBase64.split(":")[1];
            var contenttype = ct.split(";")[0];
            var imgName = Math.floor(Date.now() / 1000) + '.png';
            var img = $scope.b64toBlob(imgdata, imgName, contenttype);
            var attachment = {};
            attachment.file = img;
            attachment.type = 'Profile picture';
            $scope.showImageLoader = true;
            userService.uploadCurrentUserAttachments(attachment).then(function (response) {
                userService.updateCurrentUser({
                    profile_picture_url: response.data.url
                }).then(function (response) {
                    // $timeout(function () {
                    $scope.profilePictureURL = response.profile_picture_url;
                    $scope.showImageLoader = false;
                    $scope.cropped.source = $scope.profilePictureURL;
                    $scope.user.profile_picture_url = $scope.cropped.source;
                    // }, 4000);
                    $scope.profileImgModal = false;
                    $rootScope.$broadcast('currentUser-updated');
                    $rootScope.loadingInProcess = false;
                }, function () {
                    $scope.showImageLoader = false;
                    $rootScope.loadingInProcess = false;
                });
            });

        };
        $scope.b64toBlob = function (b64Data, fileName, contentType, sliceSize) {
            contentType = contentType || '';
            sliceSize = sliceSize || 512;
            fileName = fileName;
            var byteCharacters = atob(b64Data);
            var byteArrays = [];

            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);

                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNumbers);

                byteArrays.push(byteArray);
            }
            // var imgblob = new File(byteArrays, fileName, { type: contentType });
            // var imgblob = new Blob(byteArrays,{type: contentType});
            var imgblob;
            try {
                imgblob = new File(byteArrays, fileName, {
                    type: contentType
                });
            } catch (e) {
                try {
                    imgblob = new Blob(byteArrays, {
                        type: contentType
                    });
                } catch (e2) {
                    // Nothing to do.
                }
            }
            return imgblob;
        };
        var fillRating = function (el, fill) {
            return el.style.backgroundImage = 'linear-gradient(to right, #6e55a7, #5382b1, #487eb0, #3595ae, #2ba1ad, #29a4ad ' + fill + '%, #e7e9eb 1%, #e7e9eb 100%)';
        };

        var getFill = function (event) {
            var pos = event.clientX - event.target.getBoundingClientRect().left;
            var fill = Math.ceil(((pos + 1) / event.target.offsetWidth) * 5) * 20;
            return fill;
        };
        $scope.showCropedModal = function () {
            $scope.profileImgModal = true;
        };

        var calculateTotals = function () {
            if ($scope.plansSubscribed.length > 0) {
                if (!$scope.discount.amount) $scope.discount.amount = 0;

                $scope.plansSubscribed[0]['subTotal'] = $scope.plansSubscribed[0].amount - $scope.discount.amount;
                /*
                  angular.forEach($scope.addonsSubscribed, function (value, key) {
                  $scope.total = $scope.total + value.amount;
                  })
                  $scope.total = $scope.total + $scope.plansSubscribed[0]['subTotal'];
                */
                $scope.total = $scope.plansSubscribed[0]['subTotal'];
                $scope.lblTotal = monthlyRecurringTotalTitle;

                // console.log('-- (Controller) MyAccountController.calculateTotals() - $scope.discount.amount: ', $scope.discount.amount);
                // console.log('-- (Controller) MyAccountController.calculateTotals() - $scope.plansSubscribed[0]: ', $scope.plansSubscribed[0]);
                // console.log('-- (Controller) MyAccountController.calculateTotals() - $scope.discount.amount: ', $scope.discount.amount);
                // console.log('-- (Controller) MyAccountController.calculateTotals() - $scope.discount.amount: ', $scope.discount.amount);
            }
        };

        var loadAllAddonsandPlans = function (data, out, type, userType) {

            angular.forEach(data, function (value, key) {
                
                if (value.metadata.type === type && value.metadata.user_type === userType) {
                    out.push({
                        'id': value.id,
                        'plan': value.id,
                        'name': value.name,
                        'statement_descriptor': value.statement_descriptor,
                        'amount': value.amount / 100.00
                    });
                }
            });
        };

        var loadSubscribedAddonsandPlans = function (data, out, type, userType) {

            angular.forEach(data, function (value, key) {
                if (value.plan) {
                    // console.log('-- (Controller) MyAccountController.loadSubscribedAddonsandPlans() - value: ', value);
                    // console.log('-- (Controller) MyAccountController.loadSubscribedAddonsandPlans() - key: ', key);

                    // if (value.plan.metadata.type === type && value.plan.metadata.user_type === userType) {
                    out.push({
                        'id': value.id,
                        'plan': value.plan.id,
                        'name': value.plan.name,
                        'statement_descriptor': value.plan.metadata.description2,
                        'amount': value.plan.amount / 100.00,
                        'interval': value.plan.metadata.intervalLabel
                    });
                    // }
                };
            });
        };

        var populateDiscounts = function (data) {

            //Handle discounts
            if (data != null) {
                if (data.coupon.metadata.user_type === 'candidates' || data.coupon.metadata.user_type === 'all') {
                    $scope.discount.id = data.coupon.id;
                    if ($scope.discount.times_redeemed == 0)
                        $scope.discount.amount = data.coupon.amount_off / 100.00;
                    else
                        $scope.discount.amount = 0;
                    $scope.showDiscount = true;
                }
            }
        };

        var saveSubscriptionID = function (data) {
            $scope.subscriptionId = data.id;
        };

        var populateAllAddons = function (action) {
            userService.getPlans()
                .then(function (plans) {
                    parsePlanData(plans);
                    populateAddonsForEdit();
                    $scope.loadingData = false;
                    $scope.loaderModal = false;
                });
        };

        $scope.retryPayment = function () {
            userService.retryPayment($scope.user)
                .then(function (response) {
                    if (response != null) {
                    }
                });
        };

        var parsePlanData = function (plans) {

            loadAllAddonsandPlans(plans.data.data, $scope.allPlans, 'plan', 'candidates');
            loadAllAddonsandPlans(plans.data.data, $scope.allAddons, 'add-on', 'candidates');
            if ($scope.allAddons.length >= 1) {
                $scope.showAddonsManage = true;
            } else {
                $scope.showAddonsManage = false;
            }

            if ($scope.allPlans.length > 1) {
                $scope.showPlansManage = true;
            } else {
                $scope.showPlansManage = false;
            }
        };
        
        element.on('change', handleChange);
        function handleChange(e) {
            $scope.cardErrors = e.error ? e.error.message : '';
        }
        
        $scope.processCard = function(card) {
            if ($scope.showForm) {
                $scope.loadingData = true;
                $scope.loaderModal = true;
                var customerNameOnCard = (document.getElementById('card_name') || {}).value;
                if (!customerNameOnCard) {
                    $scope.cardErrors = $translate.instant('USER_PROFILE_CARD_NAME_REQUIRED_MESSAGE');
                    $scope.loadingData = false;
                    $scope.loaderModal = false;
                    return;
                }
                StripeElements.createToken(card, {name:customerNameOnCard})
                    .then(function (result) {
                        if (result.error) {
                            $scope.$apply(function () {
                                $scope.cardErrors = result.error.message;
                                $scope.loadingData = false;
                                $scope.loaderModal = false;
                            });
                        } else {
                            userService.saveCard(result.token)
                                .then(function (response) {
                                    if (response.data) {
                                        if (response.data.id) {
                                            userService.updateCardAsDefault(response.data.id)
                                                .then(function (response) {
                                                    loadAndPopulate();
                                                });
                                        } else {
                                            $scope.cardErrors = response.data.message;
                                            $scope.loadingData = false;
                                            $scope.loaderModal = false;
                                        }
                                    }
                                });
                        }
                    });
            } else {
                element.clear();
                $scope.toggle = false;
                $scope.showForm = true;
            }
        };

        $scope.processReactivateRequest = function(card) {

            $scope.loadingData = true;
            $scope.loaderModal = true;
            var customerNameOnCard = (document.getElementById('card_username') || {}).value;
            if (!customerNameOnCard) {
                $scope.cardErrorsModal = $translate.instant('USER_PROFILE_CARD_NAME_REQUIRED_MESSAGE');
                $scope.cardErrors = $translate.instant('USER_PROFILE_CARD_NAME_REQUIRED_MESSAGE');
                $scope.loadingData = false;
                $scope.loaderModal = false;
                return;
            }
            StripeElements.createToken(card, {name: customerNameOnCard})
                .then(function (result) {
                    if (result.error) {
                        $scope.$apply(function () {
                            $scope.cardErrorsModal = result.error.message;
                            $scope.loadingData = false;
                            $scope.loaderModal = false;
                        });
                    } else {
                        userService.createCustomer()
                            .then(function (user) {
                                if (nonNullObject(user)) {
                                    userService.saveCard(result.token)
                                        .then(function (response) {
                                            if (nonNullObject(response)) {
                                                if ((response.data || {}).id) {
                                                    userService.subscribeCustomer(response.data.id,'base')
                                                        .then(function (response) {
                                                            if(response == 'SUCCESS' ) {
                                                                ngDialog.close();
                                                                var status_to_active = { status: 'active', disable_request_date: null, disable_completed_date: null };
                                                                userService.updateUser($scope.user.userID, status_to_active)
                                                                    .then(function (response) {
                                                                        $scope.user.status = 'active';
                                                                        $scope.subscriptionPaused = false;
                                                                        loadAndPopulate();
                                                                    });
                                                                
                                                            } else {
                                                                $scope.cardErrorsModal = response.data.message;
                                                                $scope.loadingData = false;
                                                                $scope.loaderModal = false;
                                                            }
                                                        });
                                                } else {
                                                    $scope.cardErrorsModal = response.data.message;
                                                    $scope.loadingData = false;
                                                    $scope.loaderModal = false;
                                                }
                                            } else {
                                                $scope.cardErrorsModal = $translate.instant('FAILED_PLEASE_TRY-AGAIN');
                                                $scope.loadingData = false;
                                                $scope.loaderModal = false;
                                            }
                                        });
                                } else {
                                    $scope.cardErrorsModal = $translate.instant('FAILED_PLEASE_TRY-AGAIN');
                                    $scope.loadingData = false;
                                    $scope.loaderModal = false;
                                }
                            });
                    }
                });
        };

        $scope.manageAddons = function () {

            $scope.loadingData = true;
            $scope.addonEdit = !$scope.addonEdit;
            if ($scope.addonEdit) {
                $scope.addonEdit = true;
                populateAddonsForEdit();
            } else {
                processPayment();
            };
        };

        var processPayment = function () {
            
            if (hasACardonFile) {
                //He has a card saved
                if ($scope.total > $scope.totalEdit) {
                    showConfirmationDialog();
                } else {
                    processSubscriptions();
                }
            } else {
                //No card
                if ($scope.total > $scope.totalEdit) {
                    $scope.paymentRequired = true;
                } else {
                    processSubscriptions();
                }
            }
        };

        $scope.updateSubscriptions = function () {
            $scope.loaderModal = true;
            processSubscriptions();
        };

        var processSubscriptions = function () {

            var ids = [];
            var count = 0;
            if ($scope.addonsForEdit.length > 0) {
                angular.forEach($scope.addonsForEdit, function (value, key) {
                    count = $scope.addonsSubscribed.filter(function (val) { return val.plan === value.plan; }).length;
                    if (value.subscribed) {
                        if (count <= 0) {
                            ids.push({ 'plan': value.plan });
                        }
                    } else {
                        if (count > 0) {
                            ids.push({ id: value.id, plan: value.plan, deleted: true });
                        }
                    }
                });
            }

            if (ids.length > 0) {
                userService.updateSubscriptions($scope.subscriptionId, ids)
                    .then(function (response) {
                        loadAndPopulate();
                        $scope.totalEdit = $scope.total;
                        handleHighlight();
                        ngDialog.close();
                    });
            }
        };

        function showConfirmationDialog() {

            var self = this;
            var dialog = {
                template: 'app/my-account/template/card-billing-confirmation-dialog.html',
                controller: this,
                closeByDocument: false,
                closeByEscape: true,
                showClose: false,
                closeByNavigation: true,
                scope: $scope,
                width: '455px',
                height: '547px'
            };
            $scope.amountToCharge = $scope.total - $scope.totalEdit;
            $scope.cardErrors = "";
            ngDialog.openConfirm(dialog);
        }

        $scope.paymentRequired = false;
        $scope.paymentSuccess = function (updatedUser) {
            $scope.paymentRequired = false;
            $scope.user = updatedUser;
            loadAndPopulate();
        };
        $scope.paymentError = function (error) {
            console.error(error);
        };

        $scope.closeWaitingDialog = function () {
            
            $scope.loadingData = true;
            loadAndPopulate();
            $scope.totalEdit = $scope.total;
            populateAddonsForEdit();
            handleHighlight();
            ngDialog.close();
        };

        $scope.handleCheck = function (id) {

            if ($scope.addonsForEdit[id].subscribed) {
                $scope.total = $scope.total + $scope.addonsForEdit[id].amount;
            } else {
                $scope.total = $scope.total - $scope.addonsForEdit[id].amount;
            }
            handleHighlight();
        };

        var handleHighlight = function () {

            var loaderContainer = angular.element(document.querySelector('.highlight'));
            if ($scope.total != $scope.totalEdit) {
                $scope.lblTotal = newMonthlyRecurringTotalTitle;
                loaderContainer.css('background', '#e0278d');
            } else {
                $scope.lblTotal = monthlyRecurringTotalTitle;
                loaderContainer.css('background', '#269f9c');
            }
        };

        var populateAddonsForEdit = function () {

            if ($scope.addonsSubscribed.length <= 0) {
                $scope.addonEdit = true;
            }
            $scope.addonsForEdit = $scope.allAddons.slice();
            $scope.totalEdit = $scope.total;
            angular.forEach($scope.addonsForEdit, function (value, key) {
                angular.forEach($scope.addonsSubscribed, function (val, key) {
                    if (val.plan === value.plan) {
                        value.subscribed = true;
                        value.id = val.id;
                    }
                });
            });
            $scope.loadingData = false;
        };
        $scope.togglePasswordDisplay = function () {
            $scope.showPassword = !$scope.showPassword;
        };
        
        // #region Cancel Subscription.
        $scope.showCancelSubscriptionConfirmationDialog = function () {
            var self = this;
            var dialog = {
                template: 'app/my-account/template/cancel-subscription-confirmation-dialog.html',
                controller: this,
                closeByDocument: false,
                closeByEscape: false,
                showClose: false,
                closeByNavigation: true,
                scope: $scope,
                width: '455px',
                height: '547px'
            };
            ngDialog.openConfirm(dialog);
        };
        $scope.closeDialog = function () {
            $scope.loaderModal = false;
            ngDialog.close();

        };
        $scope.cancelSubscription = function () {
            $scope.loaderModal = true;
            $scope.loadingData = true;
            $scope.pauseAccountMessage = '';
            userService.pauseSubscription($scope.subscriptionId).then(function (response) {
                if (response === constants.codes.ERROR) {
                    $scope.pauseAccountMessage = $translate.instant('USER_PROFILE_ACCOUNT_PAUSED_FAILURE_MESSAGE');
                } else {
                    updateSubscriptionPaused();
                    getAddressForProfile();
                    getEmailAddressForProfile();
                }
                ngDialog.close();
                $scope.loaderModal = true;
                $scope.loadingData = false;

            });
        };

        function cancelTheSubscription() {
            userService.pauseSubscription($scope.subscriptionId).then(function (response) {
                if (response === constants.codes.ERROR) {
                    $scope.pauseAccountMessage = $translate.instant('USER_PROFILE_ACCOUNT_PAUSED_FAILURE_MESSAGE');
                } else {
                    updateSubscriptionPaused();
                    getAddressForProfile();
                    getEmailAddressForProfile();
                }
            });
        }

        // #endregion Cancel Subscription.
        
        function buildToastr(content, title, timeout) {
            var t = toastr.info(content, title, {
                progressBar:true,                                    
                timeOut:timeout,
                toastClass: 'toast',
                preventDuplicates: true,
                allowHtml: true,
                positionClass: 'toast-top-full-width',
                hideDuration: timeout,
                closeButton: true,
                showDuration: timeout, 
                extendedTimeOut: timeout,
                hideMethod: 'noop'
            });    
            $rootScope.toast = t;
        }

        // #region White Label Code.
        $scope.hasOrganization = function() {
            return organizationService.hasOrganization();
        };

        $scope.getOrganizationCss = function(css, returnEmpty) {
            return organizationService.getOrganizationCss(css, returnEmpty);
        };

        $scope.getOrganizationKey = function() {
            return organizationService.getOrganizationKey();
        };

        $scope.getOrganizationName = function() {
            return organizationService.getOrganizationName();
        };

        $scope.goToHome = function() {
            console.log("go dashboard");
            $state.go('dashboard');
        };
        // #endregion White Label Code.

        loadAndPopulate();
    }
})();

(function () {
    'use strict';

    angular
        .module('intryFrontEnd')
        .config(function(socialProvider,constants){
            socialProvider.setLinkedInKey(constants.linkedINKey);
            socialProvider.setFbKey({appId: constants.facebook_Key, apiVersion: constants.facebook_api_ver});
        })

        .factory('zxcvbn', [function () {
            return {
                score: function () {
                    var compute = zxcvbn.apply(null, arguments);
                    return compute && compute.score;
                }
            };
        }])
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController($scope, $state, $stateParams, userService, JWTService, $location, $cookies, $rootScope,socialLoginService, modalService, showPasswordResetModal, $localStorage, constants, ngDialog, $translate, organizationService) {
        window.scrollTo(0, 0);
        $scope.verificationStatus = $stateParams.accountVerificationStatus;
        $scope.emailVerificationStatus = $stateParams.changeEmailVerificationStatus;
        $scope.newUser = {};
        $scope.showRedirectDialog = false;
        $scope.redirectOrg = null;
        $scope.redirectUrl = null;
        $scope.redirectEmail = '';
        $scope.redirectPassword = '';
        var vm = this;
        $scope.formSetup = {
            startedToRegister: false,
            alreadyRegistered: false,
            passwordHint: false,
            passwordMissMatch: validatePass($scope.newUser.password, $scope.newUser.password2),
            passStrength: 1,
            isUsernameFieldBlur: false
        };

        // #region White Label Code.
        $scope.organization = null;
        $scope.organizationName = "";
        $scope.organizationKey = "";

        organizationService
            .getOrganizationByHostname(location.hostname)
            .then(function (organization) {
                if ((organization || {}).organizationKey.length > 0) {
                    $scope.organization = organization;
                    $scope.organizationName = organization.name;
                    $scope.organizationKey = organization.organizationKey;
                } else {
                    console.error("unknown organization");
                    $scope.organization = null;
                    $scope.organizationName = '';
                    $scope.organizationKey = '';
                }
            });
        
        $scope.hasOrganization = function () {
            return organizationService.hasOrganization();
        };

        $scope.getOrganizationCss = function (css, returnEmpty) {
            return organizationService.getOrganizationCss(css, returnEmpty);
        };

        $scope.getOrganizationKey = function () {
            return organizationService.getOrganizationKey();
        };

        $scope.getOrganizationName = function () {
            return organizationService.getOrganizationName();
        };

        // If neither of these returns true then you can only sign up with
        // an invitation link

        $scope.showCodeSignup = function () {
            return organizationService.isCodeRegistration($scope.organization);
        };

        $scope.showPaidSignup = function () {
            return organizationService.isPaidRegistration();
        };

        // #endregion White Label Code.
        function validatePass(pass, checkPass) {
            if (pass !== checkPass) {
                return false;
            }
            return true;
        }  
        
        $scope.$on('event:social-sign-in-success', function(event, userDetails){
            
            $scope.result = userDetails;

            userService
                .socialLogin(userDetails.uid, userDetails.email, userDetails.name, userDetails.provider)
                .then(function (data) {
                    if (!$localStorage.showOnBoarding) {
                        $localStorage.showOnBoarding = {};
                    }
                    if($localStorage.showOnBoarding[data.userID] == undefined)
                        $localStorage.showOnBoarding[data.userID] = true;
                    $state.go('dashboard');
                });       
        });    
        
        $rootScope.$on('event:social-sign-out-success', function(event, userDetails,$timeout){
            $state.go('login');
        });

        var resetStateParams = function () {
            vm.user = null;
            vm.dataLoading = false;
            vm.failLogin = false;
            $scope.redirectOrg = null;
            $scope.redirectUrl = '';
            $scope.showRedirectDialog = false;
            $scope.redirectEmail = '';
            $scope.redirectPassword = '';
        };
        
        vm.login = function () {
            $rootScope.loadingInProcess = true;
            resetStateParams();
            JWTService.clearToken();
            vm.dataLoading = true;
            userService.login(vm.email, vm.password).then(function (user) {
                vm.dataLoading = false;
                vm.user = user;
                $rootScope.loadingInProcess = false;
                $state.go('dashboard');
            }).catch(function (err) {
                $rootScope.loadingInProcess = false;
                vm.dataLoading = false;
                vm.failLogin = true;
                vm.loginError = (err.data || {}).message;
                if (err.data && err.data.adminInfo) {
                    var info = err.data.adminInfo;
                    var org = info.organizationKey || 'Intry'; // Could get the pretty name but why bother
                    var url = info.loginUrl;
                    $scope.redirectOrg = org;
                    $scope.redirectUrl = url;
                    $scope.showRedirectDialog = true;
                    $scope.redirectEmail = vm.email;
                    $scope.redirectPassword = vm.password;
                    // alert("You can login as an admin to the " + org + " organization at:\n" + url);
                    // window.location.href = url;
                }
                else if (err.data && err.data.disabled) {
                    modalService.openModal(
                        'app/disabled-user/template/disabled-user.html',{
                            closeByEscape: true,
                            closeByNavigation: true,
                            closeByDocument: true
                        }
                    ).then(function() {
                    }, function (err) {
                    });
                }
            });
        };
        
        vm.resetPassword = function () {
            modalService.openModal(
                'app/reset-password/template/reset-password.html',
                'ResetPasswordController', {
                    login: function () {
                        return null;
                    },
                    passwordResetToken: function() {
                        return null;
                    }
                }, {
                    closeByEscape: true,
                    closeByNavigation: true,
                    closeByDocument: true
                }
            ).then(function() {
            }, function (err) {
            });
        };

        vm.conflictAgent = userService.conflictAgent;

        if (showPasswordResetModal) {
            if (typeof $stateParams === 'object' && typeof $stateParams.login !== 'undefined' && $stateParams.login.length > 0) {
                vm.email = $stateParams.login;
            }
            
            modalService.openModal(
                'app/reset-password/template/reset-password-email.html',
                'ResetPasswordController', {
                    login: function () {
                        return $stateParams.login;
                    },
                    firstName: function () {
                        return $stateParams.firstname;
                    },
                    lastName: function () {
                        return $stateParams.lastname;
                    },
                    passwordResetToken: function() {
                        return $stateParams.token;
                    },
                    invitation: function() {
                        return $stateParams.invitation;
                    }
                }, {
                    closeByEscape: true,
                    closeByNavigation: true,
                    closeByDocument: true
                }
            ).then(function() {
            }, function (err) {
            });
        };

        $scope.emailConfirmationMessage = function() {
            return $scope.emailVerificationStatus || "";
        };

        $scope.showEmailConfirmationMessage = function() {
            if ($scope.emailVerificationStatus) {
                return 'email-confirmation';
            } else {
                return 'email-confirmation no-show';
            }
        };

        $scope.accountConfirmationMessage = function() {
            var status = $scope.verificationStatus || "";
            switch (status) {
            case "Success":
                return "Your account is now confirmed.";
            case "The token is already used.":
                return "Your account was already confirmed.";
            case "The link has expired.":
                return "The account confirmation link is expired.";
            default:
                return status;
            }
        };

        $scope.showAccountConfirmationMessage = function() {
            if ($scope.verificationStatus) {
                return 'account-confirmation';
            } else {
                return 'account-confirmation no-show';
            }
        };

        $scope.showLoginMessage = function(){
            if ($scope.showRedirectDialog) {
                return 'login-redirect';
            } else {
                return 'login-redirect no-show';
            }
        };
        
        $scope.close = function(){
            $scope.showRedirectDialog = false; 
            $scope.emailVerificationStatus = false;
            $scope.verificationStatus = false;
        };

        $scope.redirectToAdmin = function() {
            var email = $scope.redirectEmail;
            var password = $scope.redirectPassword;
            var redirectUrl = $scope.redirectUrl;
            $scope.redirectEmail = '';
            $scope.redirectPassword = '';
            if (email && password && redirectUrl) {
                // Why localstorage instead of $localStorage?
                // Because it did not work to pass the values
                // to the function in admin/reister-admin-controller
                // with the angular $ version
                localStorage.setItem('redirect-email', email);
                localStorage.setItem('redirect-pass', password);
                window.location.href = $scope.redirectUrl;
            }
        };
        
        $scope.signupButton = function() {
            $state.go("register");
        };

        $scope.isUserAlreadyRegistered = function() {
            if ($scope.newUser.username) {
                userService.isUserAlreadyRegistered($scope.newUser.username).then(function (response) {
                    $scope.formSetup.alreadyRegistered = !!response;
                }).catch(function () {
                    $scope.formSetup.alreadyRegistered = false;
                });
            }
        };
        
        $scope.ieBrowser = detectIE();
        function detectIE() {
            var ua = window.navigator.userAgent;
            var msie = ua.indexOf('MSIE ');
            var trident = ua.indexOf('Trident/');
            var edge = ua.indexOf('Edge/');
            if (msie > 0 || trident > 0 || edge > 0) {
                return true;
            }
            // other browser
            return false;
        }

        $scope.loginPanel1CssClass = function () {
            var css = 'signup-image-wrapper w-col w-col-6';

            try {
                var key = organizationService.getOrganizationKey();
                if (key.length > 0) {
                    css = ' signup-image-wrapper w-col w-col-12 ' + key;
                }
            } catch (e) {
                // Do nothing...
            }

            return css;
        };
        // #endregion White Label Code.
    }
})();

/* global Chart */
(function () {
    'use strict';

    angular
        .module('intryFrontEnd')

        .controller('JobSearchController', JobSearchController);

    /** @ngInject */
    function JobSearchController($scope, jobSearchService, resumeValidation, modalService, JWTService, userService, utilsService, $localStorage, $state, organizationService) {
        var vm = this;
        var pagesPerGroup = 10;
        window.scrollTo(0, 0);

        $scope.searchData = "";
        $scope.locationData = "";
        $scope.radiusData = "1";
        $scope.daysAgoData = "14";
        $scope.numJobs = 0;
        $scope.perPageData = "5";
        $scope.currPage = 0;
        $scope.startCount = 0;
        $scope.endCount = 0;
        $scope.jobPages = [];
        $scope.totalPages = 0;
        $scope.totalGroups = 0;
        $scope.currGroup = 0;

        var loadUser = function () {
            if (JWTService.getToken()) {
                userService.getUser().then(function (user) {
                    vm.user = user;
                });
            }
        };

        $scope.searchJob = function() {
            //if($scope.locationData.length > 0 && $scope.searchData.length > 0){
            $scope.currPage = 0;
            $scope.currGroup = 0;
            var location = $scope.locationData == null || $scope.locationData == '' ? "US" : $scope.locationData;

            jobSearchService.searchZip('search=' + encodeURIComponent($scope.searchData) + '&location=' + encodeURIComponent(location) + '&radius_miles=' + encodeURIComponent($scope.radiusData) + '&days_ago=' + encodeURIComponent($scope.daysAgoData) + '&jobs_per_page=' + $scope.perPageData + '&page=' + ($scope.currPage+1)).then(function(jobs) {
                $scope.jobData = angular.fromJson(jobs);
                $scope.jobData.jobs = _.sortBy($scope.jobData.jobs, 'job_age');
                $scope.numJobs = $scope.jobData.num_paginable_jobs;
                $scope.jobPages = [];

                if ($scope.numJobs > $scope.perPageData) {
                    $scope.totalPages = Math.ceil($scope.numJobs / $scope.perPageData);
                    $scope.totalGroups = $scope.totalPages / pagesPerGroup;
                    $scope.totalGroups = utilsService.isInteger($scope.totalGroups) ? $scope.totalGroups - 1 : Math.floor($scope.totalGroups);
                    var pageCnt = $scope.totalPages < (pagesPerGroup + 1) ? $scope.totalPages : pagesPerGroup;

                    for (var i = 1; i <= pageCnt; i++) {
                        $scope.jobPages.push(i);
                    }
                }
            });
            //}
        };

        $scope.parseDescription = function(id) {
            var jobLink = $scope.jobData.jobs[id].url;
            var userProfile = {
                skills:[],
                educationList: [],
                experienceList: []
            };

            var copyUser = {};
            angular.copy(vm.user, copyUser);
            userProfile.skills = _.remove(copyUser.skills, function(item) { return item.deleted === false;});
            userProfile.educationList = _.remove(copyUser.education, function(item) { return item.deleted === false;});
            userProfile.experienceList = _.remove(copyUser.experience, function(item) { return item.deleted === false;});
            _.each(userProfile.experienceList, function(element){
                element.startDateObj = utilsService.formatDate(element.date_start);
                element.endDateObj = utilsService.formatDate(element.date_end);
            });
            var error;
            error = resumeValidation.isValid(userProfile);
            if(!(error && error.errString.length)){
                var stateParams = {
                    job2resume: true,
                    jobLink: null,
                    resumeId: null,
                    processJob: false
                };
                stateParams.new = true;          
                stateParams.jobLink = jobLink;
                
                $state.go('resume-profile', stateParams);
            } else {
                showResumeInvalid();
            }
        };

        function showResumeInvalid() {
            vm.scrimPageBackground = true;
            modalService.openModal(
                'app/resumes/template/validation-error-dialog.html',
                'resumeValidationController'
            ).then(function () {
                vm.scrimPageBackground = false;

            }, function () {
                vm.scrimPageBackground = false;
            });
        }

        $scope.pageOf = function(page) {
            $scope.currPage = page;
            var location = $scope.locationData == null || $scope.locationData == '' ? "US" : $scope.locationData;

            jobSearchService.searchZip('search=' + encodeURIComponent($scope.searchData) + '&location=' + encodeURIComponent(location) + '&radius_miles=' + encodeURIComponent($scope.radiusData) + '&days_ago=' + encodeURIComponent($scope.daysAgoData) + '&jobs_per_page=' + $scope.perPageData + '&page=' + ($scope.currPage+1)).then(function(jobs) {
                $scope.jobData = angular.fromJson(jobs);
            });
        };

        $scope.firstPage = function() {

        };

        $scope.nextPage = function() {
            if ($scope.currPage < $scope.totalPages - 1) {
                $scope.currPage = $scope.currPage + 1;
                $scope.currGroup = parseInt(($scope.currPage / pagesPerGroup));
                var page = $scope.currPage + 1;
                var location = $scope.locationData == null || $scope.locationData == '' ? "US" : $scope.locationData;

                jobSearchService.searchZip('search=' + encodeURIComponent($scope.searchData) + '&location=' + encodeURIComponent(location) + '&radius_miles=' + encodeURIComponent($scope.radiusData) + '&days_ago=' + encodeURIComponent($scope.daysAgoData) + '&jobs_per_page=' + $scope.perPageData + '&page=' + page).then(function(jobs) {
                    $scope.jobData = angular.fromJson(jobs);
                    $scope.jobPages = [];
                    var pageCnt = ($scope.currGroup + 1) * pagesPerGroup;
                    pageCnt = pageCnt < $scope.totalPages ? pageCnt : $scope.totalPages;

                    for (var i = $scope.currGroup * pagesPerGroup + 1; i <= pageCnt; i++) {
                        $scope.jobPages.push(i);
                    }
                });
            }
        };

        $scope.lastPage = function() {

        };

        $scope.prevPage = function() {
            if ($scope.currPage > 0) {
                $scope.currPage = $scope.currPage - 1;
                $scope.currGroup = parseInt(($scope.currPage / pagesPerGroup));

                var page = $scope.currPage + 1;
                var location = $scope.locationData == null || $scope.locationData == '' ? "US" : $scope.locationData;

                jobSearchService.searchZip('search=' + encodeURIComponent($scope.searchData) + '&location=' + encodeURIComponent(location) + '&radius_miles=' + encodeURIComponent($scope.radiusData) + '&days_ago=' + encodeURIComponent($scope.daysAgoData) + '&jobs_per_page=' + $scope.perPageData + '&page=' + page).then(function(jobs) {
                    $scope.jobData = angular.fromJson(jobs);
                    $scope.jobPages = [];

                    var pageCnt = ($scope.currGroup + 1) * pagesPerGroup;
                    pageCnt = pageCnt < $scope.totalPages ? pageCnt : $scope.totalPages;

                    for (var i = $scope.currGroup * pagesPerGroup + 1; i <= pageCnt; i++) {
                        $scope.jobPages.push(i);
                    }
                });
            }
        };

        $scope.nextGroup = function() {
            $scope.currGroup = $scope.currGroup + 1;      
            $scope.currPage = $scope.currGroup * pagesPerGroup;
            var page = $scope.currPage + 1;
            var location = $scope.locationData == null || $scope.locationData == '' ? "US" : $scope.locationData;

            jobSearchService.searchZip('search=' + encodeURIComponent($scope.searchData) + '&location=' + encodeURIComponent(location) + '&radius_miles=' + encodeURIComponent($scope.radiusData) + '&days_ago=' + encodeURIComponent($scope.daysAgoData) + '&jobs_per_page=' + $scope.perPageData + '&page=' + page).then(function(jobs) {
                $scope.jobData = angular.fromJson(jobs);
                $scope.jobPages = [];
                var pageCnt = (($scope.currGroup + 1) * pagesPerGroup < $scope.totalPages) ? ($scope.currPage + pagesPerGroup) : $scope.totalPages;

                for (var i = $scope.currGroup * pagesPerGroup + 1; i <= pageCnt; i++) {
                    $scope.jobPages.push(i);
                }
            });
        };

        
        $scope.prevGroup = function() {
            $scope.currGroup = $scope.currGroup - 1;      
            $scope.currPage = $scope.currGroup * pagesPerGroup;
            var page = $scope.currPage;
            var location = $scope.locationData == null || $scope.locationData == '' ? "US" : $scope.locationData;

            jobSearchService.searchZip('search=' + encodeURIComponent($scope.searchData) + '&location=' + encodeURIComponent(location) + '&radius_miles=' + encodeURIComponent($scope.radiusData) + '&days_ago=' + encodeURIComponent($scope.daysAgoData) + '&jobs_per_page=' + $scope.perPageData + '&page=' + page).then(function(jobs) {
                $scope.jobData = angular.fromJson(jobs);
                $scope.jobPages = [];
                var pageCnt = (($scope.currGroup + 1) * pagesPerGroup < $scope.totalPages) ? ($scope.currPage + pagesPerGroup) : ($scope.totalPages - $scope.currGroup * pagesPerGroup);

                for (var i = $scope.currGroup * pagesPerGroup + 1; i <= pageCnt; i++) {
                    $scope.jobPages.push(i);
                }
            });
        };

        // #region White Label Code.
        $scope.hasOrganization = function() {
            return organizationService.hasOrganization();
        };

        $scope.getOrganizationCss = function(css, returnEmpty) {
            return organizationService.getOrganizationCss(css, returnEmpty);
        };

        $scope.getOrganizationKey = function() {
            return organizationService.getOrganizationKey();
        };

        $scope.getOrganizationName = function() {
            return organizationService.getOrganizationName();
        };

        $scope.goToHome = function () {
            $state.go('dashboard');
        };
        // #endregion White Label Code.

        loadUser();
    }
})();


(function () {
  'use strict';

  angular.module('intryFrontEnd').service('utmService', utmService);

  /** @ngInject */
  function utmService(constants, JWTService, $http, $q) {
    var baseUrl = constants.baseUrl;

    function getUtms(skip, limit, field, filter, ftype, sort, order) {
      return $http({
        method: 'GET',
        url: baseUrl + '/v2/admin/utm?skip=' + skip + '&limit=' + limit + '&field=' + field + '&filter=' + filter + '&ftype=' + ftype + '&sort=' + sort + '&order=' + order,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + JWTService.getToken()
        }
      }).then(function (response) {
        return response;
      });
    }

    function createUtm(utm) {
      var req = {
        method: 'POST',
        url: baseUrl + '/v2/admin/utm',
        data: utm,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + JWTService.getToken()
        }
      };

      return $http(req)
        .then(function (response) {
          if (angular.isObject(response.data)) {
            if (response) {
              return response;
            } else {
              return $q.reject(response);
            }
          } else {
            return $q.reject(response);
          }
        }, function (response) {
          return (response);
        });
    }

    function getUtm(utmID) {
      var req = {
        method: 'GET',
        url: baseUrl + '/v2/admin/utm/' + utmID,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + JWTService.getToken()
        }
      };
      return $http(req).then(function (response) {
        return response;
      });
    }

    function updateUtm(utm) {
      var req = {
        method: 'PUT',
        url: baseUrl + '/v2/admin/utm',
        data: utm,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + JWTService.getToken()
        }
      };
      return $http(req).then(function (response) {
        return response;
      }, function (response) {
        return response;
      });
    }

    function disableUtm(utmID) {
      return $http({
        method: 'POST',
        url: baseUrl + '/v2/admin/utm/' + utmID + '/disable',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + JWTService.getToken()
        },
        data: {}
      }).then(
        function success(response) {
          return response;
        },
        function error(response) {
          return response;
        });
    }

    function enableUtm(utmID) {
      return $http({
        method: 'POST',
        url: baseUrl + '/v2/admin/utm/' + utmID + '/enable',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + JWTService.getToken()
        },
        data: {}
      }).then(
        function success(response) {
          return response;
        },
        function error(response) {
          return response;
        });
    }

    function deleteUtm(utmID) {
      return $http({
        method: 'DELETE',
        url: baseUrl + '/v2/admin/utm/' + utmID,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + JWTService.getToken()
        },
        data: {}
      }).then(
        function success(response) {
          return response;
        },
        function error(response) {
          return response;
        });
    }

    return {
      getUtms: getUtms,
      createUtm: createUtm,
      getUtm: getUtm,
      updateUtm: updateUtm,
      disableUtm: disableUtm,
      enableUtm: enableUtm,
      deleteUtm: deleteUtm
    };
  }
})();
(function () {
    'use strict';

    angular.module('intryFrontEnd').service('utilsService', utilsService);

    /** @ngInject */
    function utilsService(constants, $localStorage) {
        var dateError = false;

        function arrayBufferToBase64(ab) {
            var dView = new Uint8Array(ab);
            var arr = Array.prototype.slice.call(dView);
            var arr1 = arr.map(function (item) {
                return String.fromCharCode(item);
            });
            return window.btoa(arr1.join(''));
        };

        //generating unique id
        function guid() {
            function s4() {
                return Math.floor((1 + Math.random()) * 0x10000)
                    .toString(16)
                    .substring(1);
            }
            return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
                s4() + '-' + s4() + s4() + s4();
        }

        // generate name initials
        function getNameInitials(first_name, last_name) {
            var first, last;
            first = first_name && first_name !== '' ? first_name[0] : null;
            last = last_name && last_name !== '' ? last_name[0] : null;
            var initial = null;
            if (first && last) {
                initial = first + last;
                return initial.toUpperCase();
            } else if (first) {
                return first.toUpperCase();
            } else if (last) {
                return last.toUpperCase();
            }
            return '';
        }

        // convert names, locations into titlecase when imported via sovren
        function toTitleCase(args) {
            var str = '';
            if (args) {
                str = args.replace(/\s+/g, ' ').trim();
                return str.replace(/\w+/g, function (txt) {
                    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                });
            }
            return str;
        };

        // remove bullets from skills when imported via sovren
        function removeBullets(args) {
            if (args) {
                // javascript - Regular expression to remove all basics bullets
                // https://stackoverflow.com/questions/6505618/regular-expression-to-remove-bullets-from-the-text-is-not-working
                var str = args.replace(/\d\.\s+|[0-9]\)\s+|[a-z]\)\s+|[IVX]\)\s+|•\s+|[A-Z]\.\s+|[IVX]+\.\s+/g, "");
                // store the string after removing of basics bullets
                var updatedString = str;
                // If there is any other bullet exist in the string
                // Store the first character of that string
                var stringFirstAlphabeticCharacter = str.match(/[a-zA-Z]/i);
                for (var j = 0; j <= str.length; j += 1) {
                    // check the first character after the bullets matched with the character of stored string
                    if (updatedString[j] == stringFirstAlphabeticCharacter[0]) {
                        break;
                    }
                    // continue remove the bullets before the first alphabetic character of string
                    str = str.substr(1);
                }
                return str;
            }
            return args;
        };

        function formatDateMMMYYYY(dateTime) {
            // Move Regex to const file.
            var td = dateTime.toUpperCase();
            var nd = '';
            var re = constants.DATE_VALIDATION;
            if (!re.test(td)) {
                var date = dateTime.split(' ');
                if (date[0] < 10 && date[0].length == 1) {
                    date[0] = '0' + date[0];
                }
                var nd = date[1] + '/' + date[0] + '/15';
                return moment(nd, 'YYYY-MM-DD').format('MMM YYYY');
            } else {
                var months = constants.DATE_VALIDATION_MONTHS;
                var date = td.split(' ');
                for (var j = 0; j < months.length; j++) {
                    if (date[0] == months[j]) {
                        date[0] = months.indexOf(months[j]) + 1;
                    }
                }
                if (date[0] < 10 && date[0].length == 1) {
                    date[0] = '0' + date[0];
                }
                dateTime = date[1] + '/' + date[0] + '/15';
            }
            return moment(dateTime, 'YYYY-MM-DD').format('MMM YYYY');
        }

        function formatDate(dateTime, dateFormat) {
            dateFormat = dateFormat || 'MMM YYYY';

            if (constants.YEAR_VALIDATION.test(dateTime)) {
                return dateTime;
            }

            var momentDateFormat = dateFormat;

            if (dateTime instanceof Date) {
                try {
                    return moment(dateTime).format(momentDateFormat);
                }
                catch (e) {
                    return '';
                }
            }

            function firefoxDateMMMYYYY(dateTime) {
                // Move Regex to const file.
                var td = dateTime.toUpperCase();
                var re = constants.DATE_VALIDATION;
                if (dateTime != '' && re.test(td)) {
                    var months = constants.DATE_VALIDATION_MONTHS;
                    var date = td.split(' ');
                    for (var j = 0; j < months.length; j++) {
                        if (date[0] == months[j]) {
                            date[0] = months.indexOf(months[j]) + 1;
                        }
                    }
                    if (date[0] < 10 && date[0].length == 1) {
                        date[0] = '0' + date[0];
                    }
                    dateTime = date[1] + '/' + date[0] + '/15';
                }
                return dateTime;
            }

            if (dateTime && dateTime.toLowerCase() != 'present' && dateTime.toLowerCase() != 'current')
                return moment(firefoxDateMMMYYYY(dateTime), 'YYYY-MM-DD').format(momentDateFormat);
            else
                return dateTime && dateTime.toLowerCase() == 'present' ? dateTime : '';
        }

        function getMonthObj(date) {
            var result = null;
            if (!constants.YEAR_VALIDATION.test(date)) {
                result = Number(new Date(date).toLocaleDateString("en", {
                    month: 'numeric'
                }));
                if (!result || isNaN(result)) {
                    result = null;
                }
            }
            // console.log('getMonthObj', date, result);
            return result;
        }

        function getYearObj(date) {
            var result = null;
            if (constants.YEAR_VALIDATION.test(date)) {
                result = Number(date);
            }
            else {
                result = Number(new Date(date).toLocaleDateString("en", {
                    year: 'numeric'
                }));
                if (!result || isNaN(result)) {
                    result = null;
                }
            }
            // console.log('getYearObj', date, result);
            return result;
        }

        function validateDate(v, c, noInput) {
            var ret = true;
            var x;
            if (noInput)
                x = $('#' + c);
            else
                x = $('#' + c + ' :input');
            var td = v.toUpperCase();
            if (td != 'PRESENT' && td != 'CURRENT') {
                v = $.trim(v);
                td = $.trim(td);
                // Move Regex to const file
                var re = constants.DATE_VALIDATION;
                if (v != '' && !re.test(td)) {
                    x.addClass('dateInvalid');
                    x.focus();
                    dateError = true;
                    ret = false;
                } else if (v != '') {
                    v = formatDateMMMYYYY(v);
                    x.val(v);
                    x.removeClass('dateInvalid');
                    dateError = false;
                    ret = true;
                }
            } else if (td == 'PRESENT') {
                dateError = false;
                ret = true;
            } else {
                x.addClass('dateInvalid');
                x.focus();
                dateError = true;
                ret = false
            }
            if (ret && td != 'PRESENT') {
                var s = v.split(' ');
                if (parseInt(s[1]) < 1900) {
                    x.addClass('dateInvalid');
                    x.focus();
                    dateError = true;
                    ret = false;
                }
            }
            dateError = !ret;
            return ret;
        }

        function dateStringToISOstring(dateTime) {
            dateTime = $.trim(dateTime);

            if (constants.YEAR_VALIDATION.test(dateTime)) {
                return dateTime;
            }

            var td = dateTime.toUpperCase();
            // Firefox issue, this is required
            var re = constants.DATE_VALIDATION;
            if (dateTime != '' && re.test(td)) {
                var months = constants.DATE_VALIDATION_MONTHS;
                var date = td.split(' ');
                for (var j = 0; j < months.length; j++) {
                    if (date[0] == months[j]) {
                        date[0] = months.indexOf(months[j]) + 1;
                    }
                }
                if (date[0] < 10 && date[0].length == 1) {
                    date[0] = '0' + date[0];
                }
                dateTime = date[1] + '/' + date[0] + '/15';
            } else if (dateTime != '') { // This is because of timing issues when a user clicks save on the resume
                var date = dateTime.split(' ');
                if (date[0] < 10 && date[0].length == 1) {
                    date[0] = '0' + date[0];
                }
                dateTime = date[1] + '/' + date[0] + '/15';
            }
            if (dateTime && moment(new Date(dateTime)).isValid()) {
                return new Date(dateTime).toISOString();
            } else {
                return '';
            }
        }

        function hasDateError() {
            return dateError;
        }

        function checkUserProfile(user) {
            var copyUser = {};
            var userProfile = {
                skills: [],
                educationList: [],
                experienceList: []
            };

            angular.copy(user, copyUser);

            userProfile.skills = _.remove(copyUser.skills, function (item) {
                return item.deleted === false;
            });
            userProfile.educationList = _.remove(copyUser.education, function (item) {
                return item.deleted === false;
            });
            userProfile.experienceList = _.remove(copyUser.experience, function (item) {
                return item.deleted === false;
            });

            _.each(userProfile.experienceList, function (element) {
                element.startDateObj = formatDate(element.date_start);
                element.endDateObj = formatDate(element.date_end);
            });

            return userProfile;
        }

        function saveResumeId(userId, resumeId) {
            if (!angular.isObject($localStorage.currentWorkingResume)) {
                $localStorage.currentWorkingResume = {};
            }
            $localStorage.currentWorkingResume[userId] = resumeId;
        }

        function deleteResumeId(userId, resumeId) {
            if ($localStorage.currentWorkingResume && $localStorage.currentWorkingResume[userId] === resumeId) {
                delete $localStorage.currentWorkingResume[userId];
            }
        }

        function getResumeId(userId) {
            if (!angular.isObject($localStorage.currentWorkingResume)) {
                return null;
            }
            return $localStorage.currentWorkingResume[userId];
        }

        function isInteger(value) {
            return typeof value === 'number' && !(value % 1);
        }

        function getFullName(firstName, lastName) {
            firstName = typeof firstName === 'string' ? firstName.trim() : '';
            lastName = typeof lastName === 'string' ? lastName.trim() : '';
            return (firstName + ' ' + lastName).trim();
        }

        return {
            arrayBufferToBase64: arrayBufferToBase64,
            guid: guid,
            getNameInitials: getNameInitials,
            getFullName: getFullName,
            toTitleCase: toTitleCase,
            removeBullets: removeBullets,
            formatDate: formatDate,
            getMonthObj: getMonthObj,
            getYearObj: getYearObj,
            validateDate: validateDate,
            dateStringToISOstring: dateStringToISOstring,
            hasDateError: hasDateError,
            checkUserProfile: checkUserProfile,
            saveResumeId: saveResumeId,
            deleteResumeId: deleteResumeId,
            getResumeId: getResumeId,
            isInteger: isInteger
        };
    }
})();

(function () {
    'use strict';

    angular.module('intryFrontEnd').service('userService', userService);

    /** @ngInject */
    function userService($cookies, JWTService, $state, $rootScope, $http, $q, constants, resumeService, socialLoginService, $localStorage, utilsService, assessmentsService) {

        var baseUrl = constants.baseUrl;

        function registerUser(user, queryString) {
            return $http({
                method: 'POST',
                url: baseUrl + '/v2/users' + (queryString ? '?' + queryString : ''),
                data: {
                    username: user.username,
                    password: user.password,
                    email_addresses: user.email_addresses,
                    first_name: user.firstname,
                    last_name: user.lastname,
                    full_name: user.firstname + ' ' + user.lastname
                },
                headers: {
                    'Content-Type': 'application/json'
                }
            });
        }

        function login(username, password) {
            return $http.post(baseUrl + '/v2/login', {
                username: username,
                password: password
            }).then(function success(response) {
                if (!response.data || !response.data.user || !response.data.user.userID) {
                    var data = response.data || {};
                    var message = data.message || response.statusText;
                    throw {message: message, data: data};
                }
                else {
                    JWTService.setToken(response.data.token);
                    $localStorage.userId = response.data.user.userID;
                    $localStorage.premiumAccess = response.data.premiumAccess;
                    $localStorage.freeTrial = response.data.freeTrial;
                    $localStorage.enabledFreeTrial = response.data.enabledFreeTrial;
                    $localStorage.freeUser = response.data.freeUser;
                    return getUser().$promise;
                }
            });
        }

        function socialLogin(uid, email, name, provider) {
            return $http.post(baseUrl + '/v2/login/' + provider, {
                id: uid,
                email: email,
                name: name
            }).then(function success(response) {
                JWTService.setToken(response.data.token);
                $localStorage.userId = response.data.user.userID;
                return getUser();
            });
        }

        function logOut() {
            JWTService.clearToken();
            socialLoginService.logout();
            delete $localStorage.userId;
            delete $localStorage.user;
            delete $localStorage.premiumAccess;
            delete $localStorage.freeTrial;
            delete $localStorage.enabledFreeTrial;
            $state.go("login");
        }

        function getUser(forceRefresh, allowNoUser) {
            if (typeof $localStorage.userId === 'undefined') {
                logOut();
            } else if (allowNoUser && !$localStorage.userId) {
                return null;
            }
            return getUserById($localStorage.userId, forceRefresh);
        }

        function getUserById(uuid, forceRefresh) {
            var deferred = $q.defer();
            if (forceRefresh || (!forceRefresh && !$localStorage.user)) {
                $http({
                    method: 'GET',
                    url: baseUrl + '/v2/users/' + uuid,
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JWTService.getToken()
                    }
                }).then(function (response) {
                    $localStorage.user = response.data;
                    if (response.data.stripe_customerID) {
                        getAccount().then(function (success) {
                            try {
                                if (Array.isArray((success.data.subscriptions || {}).data) && success.data.subscriptions.data.length > 0) {
                                    var pauseDate = moment(success.data.subscriptions.data[0].current_period_end * 1000).format('YYYY/MM/DD');
                                    var now = moment().format('YYYY/MM/DD');
                                    $localStorage.user.isPausedPastBillingDate = now >= pauseDate;
                                    $localStorage.user.subscriptions = success.data.subscriptions;
                                    // Need to improve the code for performance
                                    var subitems = success.data.subscriptions.data[0].items.data;
                                    $localStorage.user.isProUser = !!subitems.find(function (item) {
                                        return item.plan.id === constants.subscription_types_list[2];
                                    });
                                }
                                else if ($localStorage.user) {
                                    delete $localStorage.user.isProUser;
                                    delete $localStorage.user.subscriptions;
                                    delete $localStorage.user.isPausedPastBillingDate;
                                }
                            }
                            catch (e) {
                                if ($localStorage.user) {
                                    delete $localStorage.user.isProUser;
                                    delete $localStorage.user.stripe_customerID;
                                    delete $localStorage.user.isPausedPastBillingDate;
                                    delete $localStorage.user.subscriptions;
                                }
                            }
                            deferred.resolve($localStorage.user);
                        }).catch(function (error) {
                            console.error(error);
                            if ($localStorage.user) {
                                delete $localStorage.user.isProUser;
                                delete $localStorage.user.stripe_customerID;
                                delete $localStorage.user.isPausedPastBillingDate;
                                delete $localStorage.user.subscriptions;
                            }
                            deferred.resolve($localStorage.user);
                        });
                    } else {
                        deferred.resolve($localStorage.user);
                    }
                }, function (response) {
                    logOut();
                    deferred.reject(response);
                });
            } else {
                deferred.resolve($localStorage.user);
            }
            return deferred.promise;
        }

        function getRegisteredUser(userID) {
            return $http({
                method: 'GET',
                // url: baseUrl + '/v2/users/' + userID,
                url: baseUrl + '/v2/admin/users/' + userID,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            }).then(function (response) {
                return response;
            });
        }

        function getUsers(skip, limit, field, filter, ftype, sort, order, inactive) {
           
            return $http({
                method: 'GET',
                url: baseUrl + '/v2/admin/users?skip=' + skip + '&limit=' + limit + '&field=' + field + '&filter=' + filter + '&ftype=' + ftype + '&sort=' + sort + '&order=' + order + '&inactive=' + !!inactive,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            }).then(function success(response) {
                return response;
            }, function error(response) {
                return response;
            });
        }

        function updateCurrentUser(data, profilePicFile, onImportResume) {
            var updatedUserData = {};
            updatedUserData.first_name = data.first_name;
            updatedUserData.last_name = data.last_name;
            updatedUserData.full_name = data.full_name;
            updatedUserData.email_addresses = data.email_addresses;
            updatedUserData.phone_numbers = data.phone_numbers;
            if (data.addresses) {
                updatedUserData.addresses = data.addresses;
            }
            if (data.attachments) {
                updatedUserData.attachments = data.attachments;
            }
            if (data.summary)
                updatedUserData.summary = data.summary;
            else
                updatedUserData.summary = '';
            if (data.education) {
                updatedUserData.education = angular.copy(data.education);
                _.each(updatedUserData.education, function (element) {
                    element.date_start = utilsService.dateStringToISOstring(element.startDateObj);
                    element.date_end = utilsService.dateStringToISOstring(element.endDateObj);
                    delete element.startDateObj;
                    delete element.endDateObj;
                    delete element.created;
                    delete element.updated;
                    delete element.endDateObj;
                    delete element.startMonthObj;
                    delete element.startYearObj;
                    delete element.endYearObj;
                    delete element.endMonthObj;
                });
            }
            if (data.experience) {
                updatedUserData.experience = angular.copy(data.experience);
                _.each(updatedUserData.experience, function (element) {
                    element.date_start = utilsService.dateStringToISOstring(element.startDateObj);
                    element.date_end = utilsService.dateStringToISOstring(element.endDateObj);
                    delete element.startDateObj;
                    delete element.endDateObj;
                    delete element.created;
                    delete element.updated;
                    delete element.endDateObj;
                    delete element.startMonthObj;
                    delete element.startYearObj;
                    delete element.endYearObj;
                    delete element.endMonthObj;
                });
            }
            if (data.skills) {
                //updatedUserData.skills = data.skills;
                updatedUserData.skills = angular.copy(data.skills);
                _.each(updatedUserData.skills, function (element) {
                    delete element.created;
                    delete element.updated;
                });
            }
            if (data.achievements_awards) {
                //updatedUserData.skills = data.skills;
                updatedUserData.achievements_awards = angular.copy(data.achievements_awards);
                _.each(updatedUserData.achievements_awards, function (element) {
                    element.date_start = utilsService.dateStringToISOstring(element.startDateObj);
                    delete element.date_end;
                    delete element.startDateObj;
                    delete element.endDateObj;
                    delete element.created;
                    delete element.updated;
                    delete element.endDateObj;
                    delete element.startMonthObj;
                    delete element.startYearObj;
                    delete element.endYearObj;
                    delete element.endMonthObj;
                });
            }
            if (data.links) {
                //updatedUserData.skills = data.skills;
                updatedUserData.links = angular.copy(data.links);
                _.each(updatedUserData.links, function (element) {
                    delete element.created;
                    delete element.updated;
                });
            }
            if (data.references) {
                //updatedUserData.skills = data.skills;
                updatedUserData.references = angular.copy(data.references);
                _.each(updatedUserData.references, function (element) {
                    delete element.created;
                    delete element.updated;
                });
            }
            if (data.transcripts) {
                //updatedUserData.skills = data.skills;
                updatedUserData.transcripts = angular.copy(data.transcripts);
                _.each(updatedUserData.transcripts, function (element) {
                    delete element.created;
                    delete element.updated;
                });
            }
            if (typeof data.profile_picture_url === 'string') {
                updatedUserData.profile_picture_url = data.profile_picture_url;
            }
            if (data.industry) {
                updatedUserData.industry = data.industry;
            }
            // >>> KSH the /v2/users/:userId seems to me missing or not functioning.  Workaround with import for now.  Need to fix this
            // var apiUrl = onImportResume ? baseUrl + '/v2/users/' + $localStorage.userId + '/updateUserOnImport' : baseUrl + '/v2/users/' + $localStorage.userId;
            var apiUrl = baseUrl + '/v2/users/' + $localStorage.userId + '/updateUserOnImport';
            var req = {
                method: 'PUT',
                url: apiUrl,
                data: updatedUserData,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            };
            return $http(req).then(function (response) {
                return getUser(true); // do a force refresh
            }, function (error) {
                return error;
            });
        }

        // save email address of the user as non verified email address
        function changeEmail(data, isConfirm) {
            var req = {
                method: 'PUT',
                url: baseUrl + '/v2/users/' + $localStorage.userId + '/save_email',
                data: data,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            };
            return $http(req).then(function (response) {
                return response;
            }, function (response) {
                return response;
            });
        }
        
        // Create a user with  all details entered by Admin/User
        function createUser(user, options) {
            var create_options = {invited: false};
            if (options && (typeof options === 'object')) {
                if (options.hasOwnProperty('invited')) {
                    create_options.invited = !!options.invited;
                }
                if (options.hasOwnProperty('signupCode')) {
                    create_options.signupCode = options.signupCode;
                }
                if (options.hasOwnProperty('defaultOrganization')) {
                    create_options.defaultOrganization = options.defaultOrganization;
                }
                if (options.hasOwnProperty('utm')) {
                    create_options.utm = options.utm;
                }
            }
            user.create_options = create_options;
            user.hostname = location.hostname;
            var req = {
                method: 'POST',
                url: baseUrl + '/v2/users',
                data: user,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            };

            return $http(req).then(function (response) {
                return response;
            }).catch(function (error) {
                return (error);
            });
        }

        function welcomeUser(userID, data) {
            var req = {
                method: 'POST',
                url: baseUrl + '/v2/users/' + userID + '/welcome',
                data: data,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            };
            return $http(req).then(function (response) {
                return response;
            }).catch(function (error) {
                return (error);
            });
        }

        function uploadCurrentUserAttachments(attachment) {
            var fd = new FormData();
            fd.append('upload', attachment.file);
            return $http({
                method: 'POST',
                url: baseUrl + '/v2/users/' + $localStorage.userId + '/upload?type=' + encodeURIComponent(attachment.type),
                data: fd,
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined,
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            });
        }

        function updateUser(userID, user) {
            var req = {
                method: 'PUT',
                url: baseUrl + '/v2/users/' + userID,
                data: user,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            };
            return $http(req).then(function (response) {
                return response;
            }, function (response) {
                return response;
            });
        }

        function adminUpdateUser(userID, user) {
            var req = {
                method: 'PUT',
                url: baseUrl + '/v2/admin/users/' + userID,
                data: user,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            };
            return $http(req).then(function (response) {
                return response;
            }, function (response) {
                return response;
            });
        }

        function deleteUser(userID) {
            return $http({
                method: 'DELETE',
                url: baseUrl + '/v2/users/' + userID,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            }).then(function success(response) {
                return response;
            }, function error(response) {
                return response;
            });
        }

        function forgotPassword(login, phone) {
            return $http.post(baseUrl + '/v2/auth/forgot_password', {
                username: login,
                phone: phone,
                hostname: location.hostname
            });
        }

        function resetPassword(login, newPassword, passwordResetToken, firstName, lastName, invitation) {
            return $http.post(baseUrl + '/v2/auth/reset_password', {
                username: login,
                newPassword: newPassword,
                passwordResetToken: passwordResetToken,
                firstName: firstName,
                lastName: lastName,
                invitation: invitation
            });
        }

        function isResumeImportAllowed() {
            return $http({
                method: 'GET',
                url: baseUrl + '/v2/users/' + $localStorage.userId + '/import_allow',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            }).then(function (response) {
                return response.data;
            });
        }

        function incrementSovrenParsedResumeNum() {
            return $http({
                method: 'PUT',
                url: baseUrl + '/v2/users/' + $localStorage.userId + '/increment_resume_parse_count',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            }).then(function (response) {
                return response.data;
            });
        }

        function addAssessmentResultToUser(data) {
            var req = {
                method: 'PUT',
                url: baseUrl + '/v2/users/' + $localStorage.userId,
                data: data,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            };
            return $http(req).then(function (response) {
                return getUser(true); // do a force refresh
            }, function (response) {});
        }

        function confirmNewEmail(token, username) {
            return $http({
                method: 'POST',
                url: baseUrl + '/v2/users/confirm_new_email',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                },
                data: {
                    token: token,
                    username: username
                }
            });
        }

        function getEmailAddressForProfile() {
            return $http({
                method: 'GET',
                url: baseUrl + '/v2/users/' + $localStorage.userId + '/get_email',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            }).then(function (response) {
                return response.data;
            });
        }

        function verifyAccount(token, login) {
            return $http.post(baseUrl + '/v2/auth/confirm_account', {
                token: token,
                username: login
            });
        }

        function isUserAlreadyRegistered(username) {
            return $http({
                method: 'GET',
                url: baseUrl + '/v2/users/' + encodeURIComponent(username) + '/already_register',
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.data;
            });
        }

        function changePassword(username, newPassword) {
            return $http({
                method: 'POST',
                url: baseUrl + '/v2/users/change_password',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                },
                data: {
                    password: newPassword,
                    username: username
                }
            }).then(function (response) {
                return response.data;
            });
        }


        function pauseSubscription(subscriptionID) {
            return $http({
                method: 'POST',
                url: baseUrl + '/v2/users/' + $localStorage.userId + '/pause_user_account',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                },
                data: {
                    subscriptionID: subscriptionID
                }
            }).then(
                function success(response) {
                    return getUser(true);
                },
                function error(response) {
                    return constants.codes.ERROR;
                });
        }

        function getSocialAccountConnectedStatus(provider) {
            return $http({
                method: 'GET',
                url: baseUrl + '/v2/users/' + $localStorage.userId + '/get_social_account_connect_status?provider=' + provider,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            }).then(function (response) {
                return response.data.message;
            });
        }

        function connectSocialAccount(socialDetails) {
            var req = {
                method: 'POST',
                url: baseUrl + '/v2/users/' + $localStorage.userId + '/connect_social_account',
                data: socialDetails,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            };
            return $http(req)
                .then(
                    function success(response) {
                        return constants.codes.SUCCESS;
                    },
                    function error(response) {
                        if (response.data.message == constants.codes.USER_EXISTS) {
                            return constants.codes.USER_EXISTS;
                        } else {
                            return constants.codes.ERROR;
                        }
                    });
        }

        function disconnectSocialAccount(provider) {
            return $http({
                method: 'POST',
                url: baseUrl + '/v2/users/' + $localStorage.userId + '/disconnect_social_account?provider=' + provider,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            }).then(function (response) {
                return response.data.message;
            });
        }

        function subscribeNewUser(newUser) {
            return $http({
                method: 'POST',
                url: baseUrl + '/v2/stripe/customer/subscribe',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: newUser
            }).then(function (response) {
                if (response.data.status && response.data.status === 'SUCCESS') {
                    JWTService.setToken(response.data.token);
                    $localStorage.userId = response.data.userID;
                    $localStorage.premiumAccess = true;
                    delete $localStorage.freeTrial;
                    delete $localStorage.enabledFreeTrial;
                }
                return response;
            });
        }

        function subscribeNewUserWithCode(newUser) {
            return $http({
                method: 'POST',
                url: baseUrl + '/v2/users/subscribe',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: newUser
            }).then(function (response) {
                if (response.data.status && response.data.status === 'SUCCESS') {
                    JWTService.setToken(response.data.token);
                    $localStorage.userId = response.data.userID;
                    $localStorage.premiumAccess = true;
                    delete $localStorage.freeTrial;
                    delete $localStorage.enabledFreeTrial;
                }
                return response;
            });
        }

        function subscribeExistingUser(userID, billingEmail, token, planId, couponId, giftCardCode) {
            return $http({
                method: 'PUT',
                url: baseUrl + '/v2/stripe/customer/subscribe',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                },
                data: {
                    userID: userID,
                    billingEmail: billingEmail,
                    token: token,
                    planId: planId,
                    couponId: couponId,
                    giftCardCode: giftCardCode
                }
            }).then(function (response) {
                if (response.data.status && response.data.status === 'SUCCESS') {
                    $localStorage.premiumAccess = true;
                    delete $localStorage.freeTrial;
                    delete $localStorage.enabledFreeTrial;
                }
                return response;
            });
        }

        function createCustomer(billingEmail) {
            return $http({
                method: 'POST',
                url: baseUrl + '/v2/stripe/customer',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                },
                data: {
                    userID: $localStorage.userId,
                    billingEmail: billingEmail
                }
            }).then(function (response) {
                return "Success";
            }).catch(function (error) {
                return null;
            });
        }

        function subscribeCustomer(source, planID, couponID) {
            return $http({
                method: 'POST',
                url: baseUrl + '/v2/stripe/subscribe',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                },
                data: {
                    userID: $localStorage.userId,
                    planID: planID,
                    source: source,
                    couponID: couponID
                }
            }).then(function (response) {
                return response;
            }).catch(function (error) {
                return error;
            });
        }

        function saveCard(token) {
            return $http({
                method: 'POST',
                url: baseUrl + '/v2/stripe/card',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                },
                data: {
                    userID: $localStorage.userId,
                    token: token
                }
            }).then(function (response, headers) {
                return response;
            }).catch(function (error) {
                return error;
            });
        }

        function updateCardAsDefault(cardID) {
            return $http({
                method: 'PUT',
                url: baseUrl + '/v2/stripe/default',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                },
                data: {
                    userID: $localStorage.userId,
                    cardID: cardID
                }
            }).then(function (response) {
                return response;
            });
        }

        function chargeTheCustomer(amount) {
            return $http({
                method: 'POST',
                url: baseUrl + '/v2/charge_customer',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                },
                data: {
                    userID: $localStorage.userId,
                    amount: amount
                }
            }).then(function (response) {
                return response;
            });
        }

        function retryPayment() {

            return $http({
                method: 'POST',
                url: baseUrl + '/v2/stripe/payment/',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                },
                data: {
                    userID: $localStorage.userId
                }
            }).then(function (upcoming) {
                return upcoming;
            });
        }

        function updateSubscriptions(subscriptionID, addonsToUpdate) {
            return $http({
                method: 'POST',
                url: baseUrl + '/v2/stripe/subscriptions',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                },
                data: {
                    userID: $localStorage.userId,
                    addons: addonsToUpdate,
                    subscriptionID: subscriptionID
                }
            }).then(function (response) {
                return response;
            });
        }

        function getAccount() {
            return $http({
                method: 'GET',
                url: baseUrl + '/v2/stripe/account/' + $localStorage.userId,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            }).then(function (response) {
                return response;
            }).catch(function (error) {
                return null;
            });
        }
        // The above version should be updated to use this or removed and replaced. Talk to Sreejith
        function getAccountByUserId(userID) {
            return $http({
                method: 'GET',
                url: baseUrl + '/v2/stripe/account/' + userID,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            }).then(function (response) {
                return response;
            });
        }

        function getPlans() {
            return $http({
                method: 'GET',
                url: baseUrl + '/v2/stripe/plans',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            }).then(function (response) {
                return response;
            });
        }

        function getCoupon(couponId) {
            return $http({
                method: 'GET',
                url: baseUrl + '/v2/stripe/coupon/' + couponId,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            }).then(function (response) {
                return response;
            });
        }

        function reactivateSubscription() {

            return $http({
                method: 'POST',
                url: baseUrl + '/v2/users/' + $localStorage.userId + '/reactivate_subscription',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                },
            }).then(
                function success(response) {
                    return response;
                },
                function error(response) {
                    return constants.codes.ERROR;
                });
        }

        function disableUserAccount(selectedReason, moreDetailsForDisable) {
            return $http({
                method: 'POST',
                url: baseUrl + '/v2/users/' + $localStorage.userId + '/disable_user',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                },
                data: {
                    reasonForDisable: selectedReason,
                    moreDetailsForDisable: moreDetailsForDisable
                }
            }).then(
                function success(response) {
                    return constants.codes.SUCCESS;
                },
                function error(response) {
                    return constants.codes.ERROR;
                });
        }

        function isProUser() {
            return $localStorage.user.isProUser;
        }

        function isPausedPastBillingDate() {
            return $localStorage.user.isPausedPastBillingDate;
        }

        function conflictAgent(boolResult) {
            var agent = navigator.userAgent;
            if (agent.indexOf("CriOS") !== -1) {
                return boolResult ? true : "Intry is best experienced in Safari for iOS";
            }
            return false;
        }

        function getBundles() {
            return $http({
                method: 'GET',
                url: baseUrl + '/v2/stripe/bundles',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            });
        }

        function purchaseBundle(data) {
            return $http({
                method: 'POST',
                url: baseUrl + '/v2/stripe/bundles/purchase',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                },
                data: data
            });
        }

        function isPaidFeatureEnabled(user, feature) {
            return (
                (
                    feature &&
                        user.paid_features &&
                        (
                            !!user.paid_features[feature] ||
                                (
                                    !!user.paid_features.free_trial_expire &&
                                        new Date(user.paid_features.free_trial_expire) > new Date()
                                )
                        )
                ) ||
                    (
                        user.stripe_customerID &&
                            (user.subscriptions &&
                             user.subscriptions.data &&
                             moment(user.subscriptions.data[0].current_period_end * 1000).format('YYYY/MM/DD') >= moment(new Date()).format('YYYY/MM/DD')) &&
                            !user.disable_completed_date
                    )
            );
        }

        // return date of expiration
        function freeTrialExpires(user) {
            if (user.paid_features && user.paid_features.free_trial_expire) {
                try {
                    const expiration = new Date(user.paid_features.free_trial_expire);
                    if (expiration > new Date()) {
                        return expiration;
                    }
                }
                catch (e) {
                    // do nothing
                }
            }
            return false;
        }

        function adminDisableUser(userID) {
            return $http({
                method: 'POST',
                url: baseUrl + '/v2/admin/users/' + userID + '/soft_disable_user',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                },
                data: {}
            }).then(
                function success(response) {
                    return response;
                },
                function error(response) {
                    return response;
                });
        }

        function adminEnableUser(userID) {
            return $http({
                method: 'POST',
                url: baseUrl + '/v2/admin/users/' + userID + '/enable_user',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                },
                data: {}
            }).then(
                function success(response) {
                    return response;
                },
                function error(response) {
                    return response;
                });
        }

        function adminDeleteUser(userID) {
            return $http({
                method: 'POST',
                url: baseUrl + '/v2/admin/users/' + userID + '/disable_user',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            }).then(function success(response) {
                return response;
            }, function error(response) {
                return response;
            });
        }

        function adminGetUserAccount(userID) {
            return $http({
                method: 'GET',
                url: baseUrl + '/v2/admin/stripe/account/' + userID,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            }).then(function (response) {
                return response;
            }).catch(function (error) {
                return null;
            });
        }

        function getRefundAmount(userID) {
            return $http({
                method: 'POST',
                url: baseUrl + '/v2/admin/users/' + userID + '/get_refund_amount',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            }).then(function (response) {
                return response;
            });
        }

        function refundCancel(userID, opt, amount) {
            return $http({
                method: 'POST',
                url: baseUrl + '/v2/admin/users/' + userID + '/refund_cancel/' + opt + '/' + amount,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            }).then(function (response) {
                return response;
            });
        }

        function loginAs(userID) {
            return $http({
                method: 'GET',
                url: baseUrl + '/v2/admin/users/' + userID + '/login',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            }).then(function (response) {
                JWTService.setUserToken(response.data.token);
                $localStorage.userId = response.data.user.userID;
                $localStorage.premiumAccess = response.data.premiumAccess;
                $localStorage.freeTrial = response.data.freeTrial;
                $localStorage.enabledFreeTrial = response.data.enabledFreeTrial;
                return getUser().$promise;
            });
        }

        function requestPasswordChange(userID) {
            return $http({
                method: 'GET',
                url: baseUrl + '/v2/admin/users/' + userID + '/request_password_change/' + location.hostname,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            }).then(function (response) {
                return response;
            });
        }

        function hired(userID) {
            return $http({
                method: 'POST',
                url: baseUrl + '/v2/admin/users/' + userID + '/hired',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                },
                data: {}
            }).then(
                function success(response) {
                    return response;
                },
                function error(response) {
                    return response;
                });
        }

        function decreaseResumeCounter(userID, resumeID) {
            return $http({
                method: 'POST',
                url: baseUrl + '/v2/admin/users/' + userID + '/decrease_resume_counter/' + resumeID,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                },
                data: {}
            }).then(function success(response) {
                try {
                    if (typeof response === 'object' && typeof response.data === 'object') {
                        var rc = parseInt(response.data.resumeCounter);
                        if (!isNaN(rc)) {
                            $localStorage.user.resumeCounter = rc;
                        }
                    }
                } catch (e) {
                    // console.error("-- (Service) userService.decreaseResumeCounter() - e: ", e);
                }
                return response;
            }, function error(response) {
                return response;
            });
        }

        function backupUser(user) {
            // console.log('-- (Service) userService - user: ', user);

            $localStorage.backupUser = user;
        }

        function rollbackUser(curUser, backupUser, init) {
            // console.log('-- (Service) userService.rollbackUser() - curUser: ', curUser);
            // console.log('-- (Service) userService.rollbackUser() - backupUser: ', backupUser);
            // console.log('-- (Service) userService.rollbackUser() - init: ', init);

            init = init || false;

            try {
                var resetUser = {};
                resetUser.first_name = backupUser.first_name;
                resetUser.last_name = backupUser.last_name;
                resetUser.full_name = backupUser.full_name;
                resetUser.email = backupUser.email;
                resetUser.email_type = backupUser.email_type;
                resetUser.email_used_status = backupUser.email_used_status;

                var lists = [
                    'addresses',
                    'email_addresses',
                    'phone_numbers',
                    'education',
                    'experience',
                    'assessments',
                    'skills',
                    'achievements_awards'
                ];

                lists.forEach(function (list) {
                    resetUser[list] = rollbackList(curUser[list], backupUser[list], init);
                });

                // console.log('-- (Service) userService.rollbackUser() - resetUser: ', resetUser);

                return this.updateCurrentUser(resetUser).then(function (updatedUser) {
                    if (updatedUser && updatedUser.userID) {
                        return assessmentsService.deleteAssessmentsByUserID(updatedUser.userID).then(function (deleteAssessmentsByUserIDResponse) {
                            return updatedUser;
                        }).catch(function (error) {
                            return error;
                        });
                    }
                    return null;
                }).catch(function (error) {
                    return error;
                });
            } catch (e) {
                console.error('-- (Service) userService.rollbackUser() - e: ', e);
            }
            return null;
        };

        function rollbackList(curList, oldList, init) {
            // console.log('-- (Service) userService.rollbackList() - curList: ', curList);
            // console.log('-- (Service) userService.rollbackList() - oldList: ', oldList);
            // console.log('-- (Service) userService.rollbackList() - init: ', init);

            init = init || false;

            try {
                var newList = [];

                if (init) {
                    curList.forEach(function (curElm) {
                        if (typeof curElm._id === 'string') {
                            curElm.deleted = true;
                            newList.push(curElm);
                        }
                    });
                } else {
                    newList = angular.copy(oldList);

                    curList.forEach(function (curElm) {
                        var found = false;

                        oldList.forEach(function (oldElm) {
                            if (curElm._id === oldElm._id) {
                                found = true;
                            }
                        });

                        if (typeof curElm._id === 'string' && !found) {
                            curElm.deleted = true;
                            newList.push(curElm);
                        }
                    });
                }

                // console.log('-- (Service) userService.rollbackList() - newList: ', newList);

                var finalList = newList.map(function (elm) {
                    if (typeof elm.date_start !== 'undefined' && elm.date_start !== null) {
                        elm.startDateObj = utilsService.formatDate(elm.date_start);
                        elm.endDateObj = utilsService.formatDate(elm.date_end);
                    }

                    if (typeof elm.date_end !== 'undefined' && elm.date_end !== null) {
                        elm.endDateObj = utilsService.formatDate(elm.date_end);
                    }

                    delete elm.created;
                    delete elm.updated;
                    return elm;
                });

                // console.log('-- (Service) userService.rollbackList() - finalList: ', finalList);

                return finalList;
            } catch (e) {
                console.error('-- (Service) userService.rollbackList - e: ', e);

                return curList;
            }
        }

        function deleteAssessmentsByUserID(userID) {
            // console.log('-- (Service) userService.deleteAssessmentsByUserID() - userID: ', userID);

            return assessmentsService.deleteAssessmentsByUserID(userID).then(function (deleteAssessmentsByUserIDResponse) {
                // console.log('-- (Service) userService.deleteAssessmentsByUserID().then() - deleteAssessmentsByUserIDResponse: ', deleteAssessmentsByUserIDResponse);

                return deleteAssessmentsByUserIDResponse;
            }).catch(function (error) {
                return error;
            });
        }

        return {
            registerUser: registerUser,
            login: login,
            logOut: logOut,
            getUser: getUser,
            updateCurrentUser: updateCurrentUser,
            socialLogin: socialLogin,
            forgotPassword: forgotPassword,
            resetPassword: resetPassword,
            uploadCurrentUserAttachments: uploadCurrentUserAttachments,
            getUsers: getUsers,
            deleteUser: deleteUser,
            createUser: createUser,
            getRegisteredUser: getRegisteredUser,
            updateUser: updateUser,
            adminUpdateUser: adminUpdateUser,
            isResumeImportAllowed: isResumeImportAllowed,
            incrementSovrenParsedResumeNum: incrementSovrenParsedResumeNum,
            addAssessmentResultToUser: addAssessmentResultToUser,
            changeEmail: changeEmail,
            confirmNewEmail: confirmNewEmail,
            getEmailAddressForProfile: getEmailAddressForProfile,
            changePassword: changePassword,
            pauseSubscription: pauseSubscription,
            verifyAccount: verifyAccount,
            isUserAlreadyRegistered: isUserAlreadyRegistered,
            getSocialAccountConnectedStatus: getSocialAccountConnectedStatus,
            connectSocialAccount: connectSocialAccount,
            disconnectSocialAccount: disconnectSocialAccount,
            subscribeNewUser: subscribeNewUser,
            subscribeExistingUser: subscribeExistingUser,
            createCustomer: createCustomer,
            getAccount: getAccount,
            getAccountByUserId: getAccountByUserId,
            saveCard: saveCard,
            getPlans: getPlans,
            updateSubscriptions: updateSubscriptions,
            updateCardAsDefault: updateCardAsDefault,
            reactivateSubscription: reactivateSubscription,
            retryPayment: retryPayment,
            disableUserAccount: disableUserAccount,
            subscribeCustomer: subscribeCustomer,
            isProUser: isProUser,
            isPausedPastBillingDate: isPausedPastBillingDate,
            getCoupon: getCoupon,
            conflictAgent: conflictAgent,
            getBundles: getBundles,
            purchaseBundle: purchaseBundle,
            isPaidFeatureEnabled: isPaidFeatureEnabled,
            freeTrialExpires: freeTrialExpires,
            adminDisableUser: adminDisableUser,
            adminEnableUser: adminEnableUser,
            adminDeleteUser: adminDeleteUser,
            adminGetUserAccount: adminGetUserAccount,
            getRefundAmount: getRefundAmount,
            refundCancel: refundCancel,
            loginAs: loginAs,
            requestPasswordChange: requestPasswordChange,
            hired: hired,
            decreaseResumeCounter: decreaseResumeCounter,
            backupUser: backupUser,
            rollbackUser: rollbackUser,
            deleteAssessmentsByUserID: deleteAssessmentsByUserID,
            welcomeUser: welcomeUser
        };
    }
})();

(function () {
  'use strict';

  angular.module('intryFrontEnd').service('unemployedNotesService', unemployedNotesService);

  /** @ngInject */
  function unemployedNotesService(constants, JWTService, $http, $q) {
    var baseUrl = constants.baseUrl;

    function getUnemployedNotes(skip, limit, field, filter, ftype, sort, order, fieldFromTo, filterFrom, filterTo) {
      return $http({
        method: 'GET',
        url: baseUrl + '/v2/unemployed_note?skip=' + skip + '&limit=' + limit + '&field=' + field + '&filter=' + filter + '&ftype=' + ftype + '&sort=' + sort + '&order=' + order + '&fieldFromTo=' + fieldFromTo + '&filterFrom=' + filterFrom + '&filterTo=' + filterTo,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + JWTService.getToken()
        }
      }).then(function (response) {
        return response;
      });
    }

    function createUnemployedNote(unemployedNote) {
      var req = {
        method: 'POST',
        url: baseUrl + '/v2/unemployed_note',
        data: unemployedNote,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + JWTService.getToken()
        }
      };

      return $http(req)
        .then(function (response) {
          if (angular.isObject(response.data)) {
            if (response) {
              return response;
            } else {
              return $q.reject(response);
            }
          } else {
            return $q.reject(response);
          }
        }, function (response) {
          return (response);
        });
    }

    function updateUnemployedNote(unemployedNote) {
      var req = {
        method: 'PUT',
        url: baseUrl + '/v2/unemployed_note',
        data: unemployedNote,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + JWTService.getToken()
        }
      };

      return $http(req)
        .then(function (response) {
          return response;
        }, function (response) {
          return response;
        });
    }

    function deleteUnemployedNote(unemployedNoteID) {
      var req = {
        method: 'DELETE',
        url: baseUrl + '/v2/unemployed_note/' + unemployedNoteID,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + JWTService.getToken()
        }
      };

      return $http(req)
        .then(function (response) {
          return response;
        }, function (response) {
          return response;
        });
    }

    function downloadUnemployedNotes(field, filter, ftype, sort, order, fieldFromTo, filterFrom, filterTo) {
      return $http({
        method: 'GET',
        url: baseUrl + '/v2/unemployed_note/download?field=' + field + '&filter=' + filter + '&ftype=' + ftype + '&sort=' + sort + '&order=' + order + '&fieldFromTo=' + fieldFromTo + '&filterFrom=' + filterFrom + '&filterTo=' + filterTo,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + JWTService.getToken()
        }
      }).then(function (response) {
        return response;
      });
    }

    // Based on: https://stackoverflow.com/a/20151856
    function base64ToBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;

      try {
        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);
          var byteNumbers = new Array(slice.length);

          for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          var byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, {
          type: contentType
        });

        return blob;
      } catch (e) {
        // console.log('-- (Service) PdfService.base64ToBlob() - e', e);

        return false;
      }
    }

    return {
      getUnemployedNotes: getUnemployedNotes,
      createUnemployedNote: createUnemployedNote,
      updateUnemployedNote: updateUnemployedNote,
      deleteUnemployedNote: deleteUnemployedNote,
      downloadUnemployedNotes: downloadUnemployedNotes,
      base64ToBlob: base64ToBlob
    };
  }
})();
(function () {
    'use strict';

    angular.module('intryFrontEnd').service('tracksService', tracksService);

    /** @ngInject */
    function tracksService(constants, JWTService, $http, $q) {
        var baseUrl = constants.baseUrl;

        function getTracks(skip, limit, field, filter, ftype, sort, order, fieldFromTo, filterFrom, filterTo) {
            return $http({
                method: 'GET',
                url: baseUrl + '/v2/admin/track?skip=' + skip + '&limit=' + limit + '&field=' + field + '&filter=' + filter + '&ftype=' + ftype + '&sort=' + sort + '&order=' + order + '&fieldFromTo=' + fieldFromTo + '&filterFrom=' + filterFrom + '&filterTo=' + filterTo,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            }).then(function (response) {
                return response;
            });
        }

        function downloadTracks(field, filter, ftype, sort, order, fieldFromTo, filterFrom, filterTo) {
            return $http({
                method: 'GET',
                url: baseUrl + '/v2/admin/track/download?field=' + field + '&filter=' + filter + '&ftype=' + ftype + '&sort=' + sort + '&order=' + order + '&fieldFromTo=' + fieldFromTo + '&filterFrom=' + filterFrom + '&filterTo=' + filterTo,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            }).then(function (response) {
                return response;
            });
        }

        // Based on: https://stackoverflow.com/a/20151856
        function base64ToBlob(b64Data, contentType, sliceSize) {
            contentType = contentType || '';
            sliceSize = sliceSize || 512;

            try {
                var byteCharacters = atob(b64Data);
                var byteArrays = [];

                for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                    var slice = byteCharacters.slice(offset, offset + sliceSize);
                    var byteNumbers = new Array(slice.length);

                    for (var i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                    }

                    var byteArray = new Uint8Array(byteNumbers);
                    byteArrays.push(byteArray);
                }

                var blob = new Blob(byteArrays, {
                    type: contentType
                });

                return blob;
            } catch (e) {
                // console.log('-- (Service) PdfService.base64ToBlob() - e', e);

                return false;
            }
        }

        // >>> KSH Should maje a reports service but I am in a hurry

        // nmonths:  default 12, max 12
        // lastdate: default today
        function reportActivity(orgkey, nmonths, lastdate) {
            if (!orgkey) orgkey = '';
            // console.debug('reportActivity(' + orgkey + ')');
            return $http({
                method: 'GET',
                url: baseUrl + '/v2/admin/reports/activity/' + encodeURIComponent(orgkey) + '/?nmonths=' + encodeURIComponent(nmonths || '') + '&lastdate=' + encodeURIComponent(lastdate ? lastdate.toString() : ''),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            }).then(function (response) {
                if (!response || response.status !== 200) {
                    return { error: constants.internalError };
                }
                else {
                    return response.data;
                }
            });
        }

        function reportAssessments(orgkey, nmonths, lastdate) {
            if (!orgkey) orgkey = '';
            // console.debug('reportAssessments(' + orgkey + ')');
            return $http({
                method: 'GET',
                url: baseUrl + '/v2/admin/reports/assessments/' + encodeURIComponent(orgkey) + '/?nmonths=' + encodeURIComponent(nmonths || '') + '&lastdate=' + encodeURIComponent(lastdate ? lastdate.toString() : ''),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            }).then(function (response) {
                if (!response || response.status !== 200) {
                    return { error: constants.internalError };
                }
                else {
                    return response.data;
                }
            });
        }        
        
        function reportTracks(orgkey, nmonths, lastdate) {
            if (!orgkey) orgkey = '';
            // console.debug('reportAssessments(' + orgkey + ')');
            return $http({
                method: 'GET',
                url: baseUrl + '/v2/admin/reports/tracks/' + encodeURIComponent(orgkey) + '/?nmonths=' + encodeURIComponent(nmonths || '') + '&lastdate=' + encodeURIComponent(lastdate ? lastdate.toString() : ''),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            }).then(function (response) {
                if (!response || response.status !== 200) {
                    return { error: constants.internalError };
                }
                else {
                    return response.data;
                }
            });
        }        

        return {
            reportTracks: reportTracks,
            getTracks: getTracks,
            downloadTracks: downloadTracks,
            base64ToBlob: base64ToBlob,
            reportActivity: reportActivity,
            reportAssessments: reportAssessments
        };
    }
})();

/* global angular, Stripe */

(function () {
    'use strict';
    
    angular
        .module('intryFrontEnd')
        .provider('StripeElements', StripeElementsProvider)
        .directive('stripeElementDecorator', stripeElementDecorator)
        .component('stripeElement', getStripeElementComponent());
    
    function StripeElementsProvider () {
        this.apiKey = null;
        
        this.setAPIKey = function (apiKey) {
            this.apiKey = apiKey;
        };
        
        this.$get = function () {
            return Stripe(this.apiKey);
        };
    };
    
    function stripeElementDecorator () {
        return {
            restrict: 'A',
            link: link
        };
        
        function link ($scope, $element, $attr) {
            var $ctrl = $scope.$ctrl;
            
            $scope.$on('$destroy', function () {
                $ctrl.instance.destroy();
            });
            
            $ctrl.instance.mount($element[0]);
        }
    }
    
    function getStripeElementComponent () {
        return {
            template: '<div stripe-element-decorator></div>',
            controller: function () {},
            bindings: {
                instance: '<'
            }
        };
    }
})();

(function() {
  "use strict";

  // Need to create copy of angularjs-social-login.js file because this is core file and we cannot update this file according to our need. We need to update the field list returned by both apps
  angular
  .module('intryFrontEnd')
  .provider("social", function(){
      var fbKey, fbApiV, linkedInKey;
      return {
          setFbKey: function(obj){
              fbKey = obj.appId;
              fbApiV = obj.apiVersion;
              var d = document, fbJs, id = 'facebook-jssdk', ref = d.getElementsByTagName('script')[0];
              fbJs = d.createElement('script');
              fbJs.id = id;
              fbJs.async = true;
              fbJs.src = "//connect.facebook.net/en_US/sdk.js";
              fbJs.onload = function() {
                  FB.init({
                      appId: fbKey,
                      status: true,
                      cookie: true,
                      xfbml: true,
                      version: fbApiV
                  });
              };
              ref.parentNode.insertBefore(fbJs, ref);
          },
          setLinkedInKey: function(value){
              linkedInKey = value;
              var lIN, d = document, ref = d.getElementsByTagName('script')[0];
              lIN = d.createElement('script');
              lIN.async = false;
              // >>> KSH this no longer works.  The linkedin API changed such that in.js gets a 404
              lIN.src = "//platform.linkedin.com/in.js?async=false";
              lIN.text = ("api_key: " + linkedInKey).replace("\"", "");
              ref.parentNode.insertBefore(lIN, ref);
          },
          $get: function(){
              return{
                  fbKey: fbKey,
                  linkedInKey: linkedInKey,
                  fbApiV: fbApiV
              }
          }
      }
  })
  .factory("socialLoginService", function($window, $rootScope){
      return {
          logout: function(){
              var provider = $window.localStorage.getItem('_login_provider');
              switch(provider) {
                  case "linkedIn":
                      IN.User.logout(function(){
                          $window.localStorage.removeItem('_login_provider');
                          $rootScope.$broadcast('event:social-sign-out-success', "success");
                      }, {});
                      break;
                  case "facebook":
                      FB.logout(function(res){
                          $window.localStorage.removeItem('_login_provider');
                          $rootScope.$broadcast('event:social-sign-out-success', "success");
                      });
                      break;
              }
          },
          setProvider: function(provider){
              $window.localStorage.setItem('_login_provider', provider);
          }
      }
  })
  .factory("fbService", function($q){
      return {
          login: function(){
              var deferred = $q.defer();
              FB.login(function(res){
                  deferred.resolve(res);
              }, {scope: 'email', auth_type: 'rerequest'});
              return deferred.promise;
          },
          getUserDetails: function(){
              var deferred = $q.defer();
              // Updated URL to access education and work details
              // Facebook profile work experience field reference https://developers.facebook.com/docs/graph-api/reference/work-experience/
              // Facebook profile education experience field reference https://developers.facebook.com/docs/graph-api/reference/education-experience
              FB.api('/me?fields=id,name,email,education,work', function(res){
                  if(!res || res.error){
                      deferred.reject('Error occured while fetching user details.');
                  }else{
                      deferred.resolve(res);
                  }
              });
              return deferred.promise;
          }
      }
  })
  .directive("linkedIn", function($rootScope, social, socialLoginService, $window, $filter){
      return {
          restrict: 'EA',
          scope: {},
          link: function(scope, ele, attr){
              ele.on("click", function(){
                  if (!IN.User) {
                    return;
                  }
                  IN.User.authorize(function(){
                      // LinkedIn profile data field list reference link https://developer.linkedin.com/docs/fields/full-profile
                      IN.API.Raw("/people/~:(id,email-address,first-name,last-name,educations:(id,school-name,field-of-study,start-date,end-date,degree),three-current-positions:(id,title,summary,start-date,end-date,is-current,company),three-past-positions:(id,title,summary,start-date,end-date,is-current,company))").result(function(res){
                          socialLoginService.setProvider("linkedIn");

                          // TODO: Need to validate this properly because end-to-end testing is not done without making app changes
                          // Formatting linkedIn profile education data according to code requirement
                          // Education related data field reference link https://developer.linkedin.com/docs/fields/education
                          var educations = [];
                          if (res.educations) {
                              for (var i = 0 ; i < res.educations.length; i += 1) {
                                  educations.push({
                                      institution: res.educations[i].schoolName,
                                      field_of_study: res.educations[i].fieldOfStudy,
                                      degree: res.educations[i].degree
                                  });
                              }
                          }

                          var employments = [];
                          var employmentRawData = [];
                          if (res.threeCurrentPositions) {
                              employmentRawData = employmentRawData.concat(res.threeCurrentPositions);
                          }
                          if (res.threePastPositions) {
                              employmentRawData = employmentRawData.concat(res.threePastPositions);
                          }
                          // Formatting linkedIn profile work experience data according to code requirement
                          // Work experience related data field reference link https://developer.linkedin.com/docs/fields/positions
                          for (var i = 0 ; i < employmentRawData.length; i += 1) {
                              employments.push({
                                  title: employmentRawData[i].title,
                                  company: employmentRawData[i].company ? employmentRawData[i].company.name : '',
                                  dateStartObj: $filter('date')(employmentRawData[i].startDate, 'MMM dd, yyyy'),
                                  dateEndObj: $filter('date')(employmentRawData[i].endDate, 'MMM dd, yyyy')
                                  // Formatting date according to requirement from 2018-01-01 to Jan 1, 2018
                              });
                          }

                          var userDetails = {name: res.firstName + " " + res.lastName, email: res.emailAddress, uid: res.id, provider: "linkedIN", educations: educations, employments: employments };
                          $rootScope.$broadcast('event:social-sign-in-success', userDetails);
                      });
                  });
              })
          }
      }
  })
  .directive("fbLogin", function($rootScope, fbService, social, socialLoginService, $filter){
      return {
          restrict: 'A',
          scope: {},
          replace: true,
          link: function(scope, ele, attr){
              ele.on('click', function(){
                  fbService.login().then(function(res){
                      if(res.status == "connected"){
                          fbService.getUserDetails().then(function(user){
                              socialLoginService.setProvider("facebook");
                              // TODO: Need to validate this properly because end-to-end testing is not done without making app changes

                              // Formatting facebook profile education data according to code requirement
                              // Education related data field reference link https://developers.facebook.com/docs/graph-api/reference/education-experience
                              var educations = [];

                              var educationRawData = [];
                              if (user.education) {
                                  educationRawData = user.education;
                              }
                              for (var i = 0 ; i < educationRawData.length; i += 1){
                                  var fieldOfStudy = [];
                                  if (educationRawData[i].concentration) {
                                      for (var j = 0; j < educationRawData[i].concentration.length; j += 1) {
                                          fieldOfStudy.push(educationRawData[i].concentration[j].name);
                                      }
                                  }
                                  educations.push({
                                      institution: educationRawData[i].school ? educationRawData[i].school.name : '',
                                      field_of_study: fieldOfStudy.join(", "),
                                      degree: educationRawData[i].degree ? educationRawData[i].degree.name : ''
                                  });
                              }

                              // Formatting facebook profile work experience data according to code requirement
                              // Work experience related data field reference link https://developers.facebook.com/docs/graph-api/reference/work-experience/
                              var employments = [];
                              var employmentRawData = [];
                              if (user.work) { employmentRawData = user.work; }
                              for (var i = 0 ; i < employmentRawData.length; i += 1) {
                                  employments.push({
                                      title: employmentRawData[i].position ? employmentRawData[i].position.name : '',
                                      company: employmentRawData[i].employer ? employmentRawData[i].employer.name : '',
                                      location: employmentRawData[i].location ? employmentRawData[i].location.name : '',
                                      dateStartObj: $filter('date')(employmentRawData[i].start_date, 'MMM dd, yyyy'),
                                      dateEndObj: $filter('date')(employmentRawData[i].end_date, 'MMM dd, yyyy')
                                      // Formatting date according to requirement from 2018-01-01 to Jan 1, 2018
                                  });
                              }

                              var userDetails = {name: user.name, email: user.email, uid: user.id, provider: "facebook", educations:educations, employments:employments};
                              $rootScope.$broadcast('event:social-sign-in-success', userDetails);
                          }, function(err){
                              console.log(err);
                          })
                      }
                  }, function(err){
                      console.log(err);
                  });
              });
          }
      }
  });
} ());

(function () {
    'use strict';

    angular
        .module('intryFrontEnd')
        .service('resumeService', ResumeService);

    /** @ngInject */
    function ResumeService($http, $q, $localStorage, constants, $state, Upload, JWTService, utilsService, $window) {

        var baseUrl = constants.baseUrl;

        function updateResume(resumeId, obj, meta) {
            var content = {};

            if (obj.first_name) {
                content.first_name = obj.first_name;
            }
            if (obj.last_name) {
                content.last_name = obj.last_name;
            }

            var clearDBFields = function (obj) {
                if (obj) {
                    delete obj.created;
                    delete obj.updated;
                    delete obj.startDateObj;
                    delete obj.endDateObj;
                    delete obj.index;
                    delete obj.isVolunteer;
                    delete obj.isMilitary;
                    delete obj.isCertification;
                    delete obj.endYearObj;
                    delete obj.endMonthObj;
                    delete obj.startYearObj;
                    delete obj.startMonthObj;
                }
            };

            if (obj.address) {
                if (!obj.address.kind) {
                    obj.address.kind = 'Other';
                }
                content.address = obj.address;
                clearDBFields(obj.address);
                content.address = obj.address;
            }

            var cloneArray = function (items) {
                var val = [];
                if (items && items.length > 0) {
                    _.forEach(items, function (item) {
                        var clonedItem = _.clone(item);
                        if (clonedItem.startDateObj)
                            clonedItem.date_start = utilsService.dateStringToISOstring(clonedItem.startDateObj);
                        if (clonedItem.endDateObj)
                            clonedItem.date_end = utilsService.dateStringToISOstring(clonedItem.endDateObj);
                        clearDBFields(clonedItem);
                        val.push(clonedItem);
                    });
                }
                return val;
            };

            var cloneSkillArray = function (skills) {
                var clonedSkills = angular.copy(skills);
                _.each(clonedSkills, function (skill, key) {
                    delete skill.fullBullets;
                    delete skill.emptyBullets;
                    delete skill.updated;
                    delete skill.created;
                    delete skill.index;
                    delete skill.svgOptions; // Infographic Template
                    skill._id == null ? delete skill._id : skill._id;
                });
                return clonedSkills;
            };

            if (obj.email_address) {
                if (!obj.email_address.kind) {
                    obj.email_address.kind = constants.default_email_kind;
                }
                clearDBFields(obj.email_address);
                content.email_address = obj.email_address;
            }

            if (obj.phone_number) {
                if (!obj.phone_number.kind) {
                    obj.phone_number.kind = constants.default_phone_kind;
                }
                clearDBFields(obj.phone_number);
                content.phone_number = obj.phone_number;
            }

            content.achievements_awards = cloneArray(obj.achievements_awards);
            content.education = cloneArray(obj.education);
            content.experience = cloneArray(obj.experience);
            content.skills = cloneSkillArray(obj.skills);
            content.references = cloneArray(obj.references);
            content.about = obj.about;
            content.profile_picture_url = obj.profile_picture_url;
            content.website = obj.website;
            content.achievement = obj.achievement;
            content.resume_layout = obj.resume_layout;
            content.industry = obj.industry;

            var data = {
                usedExport: obj.usedExport,
                title: obj.title,
                content: content
            };

            if (typeof meta !== 'undefined' && meta !== null) {
                data.meta = meta;
            }

            var req = {
                method: 'PUT',
                url: baseUrl + '/v2/resumes/' + resumeId,
                data: data,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            };

            return $http(req).then(function (response) {
                return _removeNotAllowedField(response.data);
            });
        }

        function simpleUpdateResume(resumeId, obj) {
            var req = {
                method: 'PUT',
                url: baseUrl + '/v2/resumes/' + resumeId + '/simple',
                data: {
                    usedExport: obj.usedExport,
                    title: obj.title,
                    content: obj
                },
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            };

            return $http(req).then(function (response) {
                return _removeNotAllowedField(response.data);
            });
        }

        /**
         * create resume
         */
        function createResume(user, about, title, industry, resume_layout) {
            // console.log("-- (Service) resumeService.createResume() - user: ", user);

            var content = {};
            if (industry) {
                content.industry = industry;
            }
            if (resume_layout) {
                content.resume_layout = resume_layout;
            }
            if (user.first_name) {
                content.first_name = user.first_name;
            }
            if (user.last_name) {
                content.last_name = user.last_name;
            }
            if (user.maiden_name) {
                content.maiden_name = user.maiden_name;
            }
            if (user.full_name) {
                content.full_name = user.full_name;
            }
            if (about) {
                content.about = about;
            }
            if (user.profile_picture_url) {
                content.profile_picture_url = user.profile_picture_url;
            }
            if (user.achievement)
                content.achievement = user.achievement;

            var clearDBFields = function (obj) {
                if (obj) {
                    delete obj._id;
                    delete obj.deleted;
                    delete obj.created;
                    delete obj.updated;
                    delete obj.startDateObj;
                    delete obj.endDateObj;
                    /*
                      delete obj.index;
                      delete obj.isVolunteer;
                      delete obj.isMilitary;
                      delete obj.isCertification;
                    */
                    delete obj.startMonthObj;
                    delete obj.startYearObj;
                    delete obj.endMonthObj;
                    delete obj.endYearObj;
                }
            };

            if (!angular.isUndefined(user.addresses[0])) {
                content.address = _.clone(user.addresses[0]);
                clearDBFields(content.address);
            }

            // Select the last email address not deleted:
            var emailAddresses = Array.isArray(user.email_addresses) ? _.filter(user.email_addresses, {
                deleted: false
            }) : [];
            if (emailAddresses.length > 0) {
                content.email_address = _.clone(emailAddresses[emailAddresses.length - 1]);
                clearDBFields(content.email_address);
            } else if (user.username && constants.EMAIL_PATTERN.test(user.username)) {
                var email_address = {};
                email_address = {
                    address: user.username,
                    kind: constants.default_email_kind
                };
                content.email_address = email_address;
            }

            // Select the last phone number not deleted:
            var phoneNumbers = Array.isArray(user.phone_numbers) ? _.filter(user.phone_numbers, {
                deleted: false
            }) : [];
            if (phoneNumbers.length > 0) {
                content.phone_number = _.clone(phoneNumbers[phoneNumbers.length - 1]);
                clearDBFields(content.phone_number);
            } else if (user.username && constants.USA_PHONE_PATTERN.test(user.username)) {
                var phone_number = {};
                phone_number = {
                    number: user.username,
                    kind: constants.default_phone_kind
                };
                content.phone_number = phone_number;
            }

            var cloneArray = function (items) {
                var val = [];
                if (items && items.length > 0) {
                    _.forEach(items, function (item) {
                        var clonedItem = _.clone(item);
                        clearDBFields(clonedItem);
                        val.push(clonedItem);
                    });
                }

                return val;
            };
            
            var cloneExperienceArray = function (items) {
                var val = [];
                if (items && items.length > 0) {
                    _.forEach(items, function (item) {
                        var clonedItem = _.clone(item);
                        clonedItem.kind = clonedItem.kind ? clonedItem.kind : constants.default_employment_kind;
                        clearDBFields(clonedItem);
                        val.push(clonedItem);
                    });
                }
                return val;
            };

            content.social_accounts = cloneArray(user.social_accounts);
            content.associations = cloneArray(user.associations);
            content.education = cloneArray(user.education);
            content.experience = cloneExperienceArray(user.experience);
            content.interests = cloneArray(user.interests);
            content.pictures = cloneArray(user.pictures);
            content.recommendations = cloneArray(user.recommendations);
            content.skills = cloneArray(user.skills);
            content.volunteer = cloneArray(user.volunteer);
            content.attachments = cloneArray(user.attachments);
            content.achievements_awards = cloneArray(user.achievements_awards);
            content.references = cloneArray(user.references);

            // {{ Fix indexes.
            var reassignIdx = function (item, idx) {
                item.order_index = idx;
                return item;
            };

            content.experience = _.sortBy(content.experience, 'order_index').map(reassignIdx);
            content.education = _.sortBy(content.education, 'order_index').map(reassignIdx);
            // }} Fix indexes.

            // console.log("-- (Service) resumeService.createResume() - content: ", content);

            var req = {
                method: 'POST',
                url: baseUrl + '/v2/resumes/' + user.userID,
                data: {
                    title: title,
                    content: content
                },
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            };

            return $http(req);
        }

        /**
         * Delete resume
         */
        function deleteResume(userId, resumeId) {
            utilsService.deleteResumeId(userId, resumeId);
            var config = {
                headers: {
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            };
            return $http.delete(baseUrl + '/v2/resumes/' + userId + '?resumeID=' + encodeURIComponent(resumeId), config);
        }

        function getResumes(userId) {
            var req = {
                method: 'GET',
                url: baseUrl + '/v2/resumes/' + userId,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            };
            return $http(req).then(function (response) {
                return _removeNotAllowedField(response.data);;
            });
        }

        function getResume(userId, resumeId) {
            var req = {
                method: 'GET',
                url: baseUrl + '/v2/resumes/' + userId + '?resumeID=' + encodeURIComponent(resumeId),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            };
            return $http(req).then(function (response) {
                return _removeNotAllowedField(response.data)[0];
            }).catch(function (error) {
                alert(error.error);
            });
        }

        function getResumeLinks(userID) {
            var req = {
                method: 'GET',
                url: baseUrl + '/v2/resumes/export/' + userID,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            };
            return $http(req).then(function (response) {
                return response;
            });
        }

        function getResumePageCount(resumeId) {
            var req = {
                method: 'GET',
                url: baseUrl + '/v2/resumes/pages/' + (resumeId || 'all'),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            };
            return $http(req).then(function (response) {
                return response;
            });
        }

        function uploadImage(student, file) {
            return Upload.upload({
                method: 'PUT',
                url: baseUrl + '/students/' + student.id,
                file: file,
                data: {
                    firstname: student.firstname,
                    middlename: student.middlename,
                    lastname: student.lastname,
                    phone: student.phone,
                    phoneCode: student.phoneCode,
                    phoneType: student.phoneType,
                    photo: student.photo
                }
            });
        }

        function logOut() {}

        function parseResumeData(resumeData) {
            var data = {
                "DocumentAsBase64String": resumeData
            };
            var options = {
                method: 'POST',
                url: baseUrl + "/v2/resume/parse/" + $localStorage.userId,
                data: data,
                headers: {
                    "Content-Type": "application/json",
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            };
            return $http(options);
        }

        function parseJobDescription(data, resumeID) {
            var options = {
                method: 'POST',
                url: baseUrl + "/v2/resume/parseJob/" + $localStorage.userId + '/' + resumeID,
                data: {
                "DocumentAsBase64String": data
                },
                headers: {
                    "Content-Type": "application/json",
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            };
            return $http(options);
        }


        function downloadResume(hash, type, assess) {
            var req = {
                method: 'POST',
                url: baseUrl + '/v2/download/resume/' + type + '/' + hash,
                data: assess,
                dataType: 'json',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            };
            return $http(req).then(function (response) {
                return response;
            });
        }

        function downloadResumeFromS3(path, name, print, onerr) {
            if (typeof print === 'undefined' || print === null) print = false;

            $http({
                method: 'GET',
                url: path,
                responseType: 'arraybuffer'
            }).success(function (data, status, headers) {
                headers = headers();

                var filename = name; // headers['x-filename'];
                var contentType = headers['content-type'];

                if (contentType === 'application/xml') {
                    // Then its a 404, 403 or some other error which could see if we parse the data
                    if (typeof onerr === 'function') {
                        onerr(path, name, print);
                    }
                    return;
                }

                var userAgent = navigator.userAgent || navigator.vendor || window.opera;

                if (
                    (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) ||
                        (/android/i.test(userAgent)) ||
                        print
                ) {
                    contentType = 'application/pdf';
                }

                try {
                    var blob = new Blob([data], {
                        type: contentType
                    });
                    var url = window.URL.createObjectURL(blob);

                    if (print && !(/iPad|iPhone|iPod|Edge/.test(userAgent))) {
                        setTimeout(function () {
                            printJS(url);
                        }, 100);
                    } else {
                        var linkElement = document.createElement('a');
                        linkElement.setAttribute('href', url);

                        linkElement.setAttribute("download", filename);

                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                        setTimeout(function () {
                            // For Firefox it is necessary to delay revoking the ObjectURL
                            window.URL.revokeObjectURL(data);
                        }, 100);
                    }
                } catch (ex) {
                    if (typeof onerr === 'function') {
                        onerr(ex);
                    }
                    else {
                        console.error(ex);
                    }
                }
            }).error(function (data) {
                if (typeof onerr === 'function') {
                    onerr(data);
                }
                else {
                    console.error(data);
                }
            });
        }

        function _removeNotAllowedField(resumeArray) {
            if (angular.isArray(resumeArray)) {
                resumeArray.forEach(function (resume) {
                    _.forEach(resume.content, function (content, contentKey) {
                        if (contentKey === 'address' || contentKey === 'email_address' || contentKey === 'phone_number') {
                            delete content.updated;
                            delete content.created;
                        } else if (contentKey === 'social_accounts' || contentKey === 'associations' || contentKey === 'education' || contentKey === 'experience' || contentKey === 'interests' || contentKey === 'attachments' || contentKey === 'recommendations' || contentKey === 'skills' || contentKey === 'volunteer' || contentKey === 'occupations') {
                            _.forEach(content, function (contentSub) {
                                delete contentSub.updated;
                                delete contentSub.created;
                            });
                        }
                    });
                });
            }
            return resumeArray;
        }

        function updateDownloaded(resumeID) {
            var req = {
                method: 'POST',
                url: baseUrl + '/v2/resumes/updateDownloaded/' + resumeID,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            };
            return $http(req).then(function (response) {
                return response;
            });
        }

        function getTemplates(organizationKey) {
            organizationKey = organizationKey || '';

            var req = {
                method: 'GET',
                url: baseUrl + '/v2/resume/templates/' + organizationKey,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            };
            return $http(req).then(function (response) {
                return _removeNotAllowedField(response.data);
            });
        }

        return {
            deleteResume: deleteResume,
            createResume: createResume,
            updateResume: updateResume,
            simpleUpdateResume: simpleUpdateResume,
            getResumes: getResumes,
            getResume: getResume,
            getResumeLinks: getResumeLinks,
            getResumePageCount: getResumePageCount,
            logOut: logOut,
            parseResumeData: parseResumeData,
            downloadResume: downloadResume,
            downloadResumeFromS3: downloadResumeFromS3,
            parseJobDescription: parseJobDescription,
            updateDownloaded: updateDownloaded,
            getTemplates: getTemplates
        };
    }

})();

(function () {
    'use strict';

    angular.module('intryFrontEnd').service('organizationService', organizationService);

    var knownOrganizations = [
        // // #region Goodwill Southern Rivers Organizations.
        // { hostname: 'goodwillsr.intrycareers.com', organizationKey: 'goodwillsr', name: "Goodwill Southern Rivers", selfRegistration: false, codeRegistration: true},
        // { hostname: 'goodwillsr.intry.careers', organizationKey: 'goodwillsr', name: "Goodwill Southern Rivers", selfRegistration: false, codeRegistration: true},
        // // #endregion Goodwill Southern Rivers Organizations.

        // // #region Intry Organizations.
        // { hostname: 'qa.intry.careers', organizationKey: 'intry', name: "Intry (dev qa)", selfRegistration: true, codeRegistration: false},
        // { hostname: 'qa.intrycareers.com', organizationKey: 'intry', name: "Intry (dev qa)", selfRegistration: true, codeRegistration: false},

        // { hostname: 'edge.intry.careers', organizationKey: 'intry', name: "Intry (dev edge)", selfRegistration: true, codeRegistration: false},
        // { hostname: 'edge.intrycareers.com', organizationKey: 'intry', name: "Intry (dev edge)", selfRegistration: true, codeRegistration: false},

        // { hostname: 'beta.intry.careers', organizationKey: 'intry', name: "Intry (test beta)", selfRegistration: true, codeRegistration: false},
        // { hostname: 'beta.intrycareers.com', organizationKey: 'intry', name: "Intry (test beta)", selfRegistration: true, codeRegistration: false},

        // { hostname: 'demo.intry.careers', organizationKey: 'intry', name: "Intry (test demo)", selfRegistration: true, codeRegistration: false},
        // { hostname: 'demo.intrycareers.com', organizationKey: 'intry', name: "Intry (test demo)", selfRegistration: true, codeRegistration: false},

        // { hostname: 'app.intry.careers', organizationKey: 'intry', name: "Intry", selfRegistration: true, codeRegistration: false},
        // { hostname: 'app.intrycareers.com', organizationKey: 'intry', name: "Intry", selfRegistration: true, codeRegistration: false},
        // // #endregion Intry Organizations.

        // // #region Development Organizations.
        // { hostname: 'localhost', organizationKey: 'intry', name: "Intry", selfRegistration: true, codeRegistration: false},
        // // { hostname: '127.0.0.1', organizationKey: 'intry', name: "Intry", selfRegistration: true, codeRegistration: false},
        // #region Development Organizations.
    ];
    
    /** @ngInject */
    function organizationService(constants, JWTService, $http, $q) {
        var baseUrl = constants.baseUrl;
        var organizationKey = '';
        var organizationName = '';
        var organization = null;
        
        function isIntryOrg(key) {
            return (key === constants.INTRY_ORG || key === constants.INTRYOR_ORG);
        }
        
        function isOrganization(org) {
            return (angular.isObject(org) &&
                    org.hostname &&
                    typeof org.hostname === 'string' &&
                    org.organizationKey &&
                    typeof org.organizationKey === 'string' &&
                    org.name &&
                    typeof org.name === 'string' &&
                    // org.organizationID &&
                    // typeof org.organizationID === 'string' &&
                    true);
        }
        
        function explainInvalidOrganization(org) {
            if (!angular.isObject(org))
                return "not an object";
            if (typeof org.hostname !== 'string')
                return "hostname is not a string";
            if (org.hostname.length === 0)
                return "hostname is empty";
            if (typeof org.organizationKey !== 'string')
                return "organizationKey is not a string";
            if (org.organizationKey.length === 0)
                return "organizationKey is empty";
            if (typeof org.name !== 'string')
                return "name is not a string";
            if (org.name.length === 0)
                return "name is empty";
            if (typeof org.organizationID !== 'string')
                return "organizationID is not a string";
            if (org.organizationID.length === 0)
                return "organizationID is empty";
            return "";
        }

        function isOrganizationResponse(response) {
            if (angular.isObject(response) && (response.status === 200)) {
                return isOrganization(response.data);
            }
            return false;
        }

        function organizationCacheFind(hostname) {
            var org = null;
            if (organization && (organization.hostname === hostname)) {
                org = organization;
            }
            else {
                org = knownOrganizations.find(function(o) {
                    return o.hostname === hostname;
                });
            }
            if (org) {
                return Object.assign({}, org);
            }
            else {
                return null;
            }
        }

        function organizationCacheFindByID(organizationID) {
            var org = null;
            if (organization && (organization.organizationID === organizationID)) {
                org = organization;
            }
            else {
                org = knownOrganizations.find(function(o) {
                    return o.organizationID === organizationID;
                });
            }
            if (org) {
                return Object.assign({}, org);
            }
            else {
                return null;
            }
        }        

        function organizationCacheAdd(org) {
            if (isOrganization(org)) {
                org = Object.assign({}, org);
                if (isIntryOrg(org.organizationKey)) {
                    org.selfRegistration = true; // we insist for these two
                }
                else {
                    // Otherwise just make sure its a boolean
                    org.selfRegistration = !!org.selfRegistration;
                }
                for (var i = 0; i < knownOrganizations.length; i++) {
                    if (knownOrganizations[i].hostname === org.hostname) {
                        knownOrganizations[i] = org;
                        return true;
                    }
                }
                knownOrganizations.push(org);
                return true;
            }
            else {
                console.error("invalid organization cache request");
                return false;
            }
        }

        function organizationCacheDel(org) {
            if (isOrganization(org)) {
                if (isIntryOrg(org.organizationKey) || (isOrganization(organization))) {
                    throw new Error('cannot delete this organization');
                }
                for (var i = 0; i < knownOrganizations.length; i++) {
                    if (knownOrganizations[i].hostname === organization.hostname) {
                        knownOrganizations.splice(i, 1);
                        return true;
                    }
                }
            }
            return false;
        }
                
        function setState(org) {
            if (isOrganization(org)) {
                // shallow copy so we can modify
                org = Object.assign({}, org);
            }
            else {
                console.error("cannot make invalid organization be current: " + explainInvalidOrganization(org));
                return false;
            }
            if (isIntryOrg(org.organizationKey)) {
                org.selfRegistration = true;
            }
            else {
                // Make sure its a boolean
                org.selfRegistration = !!org.selfRegistration;
            }
            organization = org;
            organizationKey = org.organizationKey;
            organizationName = org.name;
            organizationCacheAdd(org);
            console.log('organization set: ' + organizationKey + ' (' + organizationName + ')');
            return organization;
        }

        // note that key is not unique.  the pair key, hostname is unique
        
        // returns unprocessed http response
        function getOrganizationKeys() {
            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: baseUrl + '/v2/admin/organization/keys',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            }).then(deferred.resolve, deferred.reject);
            return deferred.promise;
        }

        // returns unprocessed http response
        function getOrganizations(skip, limit, field, filter, ftype, sort, order) {
            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: baseUrl + '/v2/admin/organization?skip=' + skip + '&limit=' + limit + '&field=' + field + '&filter=' + filter + '&ftype=' + ftype + '&sort=' + sort + '&order=' + order,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            }).then(deferred.resolve, deferred.reject);
            return deferred.promise;
        }

        // returns unprocessed http response
        function createOrganization(organization) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: baseUrl + '/v2/admin/organization',
                data: organization,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            };
            $http(req).then(deferred.resolve, deferred.reject);
            return deferred.promise;
        }

        // Return unfiltered http response
        function adminGetOrganization(organizationID) {
            var deferred = $q.defer();
            var req = {
                method: 'GET',
                url: baseUrl + '/v2/admin/organization/' + organizationID,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            };
            $http(req).then(deferred.resolve, deferred.reject);
            return deferred.promise;
        }

        // Return unfiltered http response
        function updateOrganization(organization) {
            var deferred = $q.defer();
            var req = {
                method: 'PUT',
                url: baseUrl + '/v2/admin/organization',
                data: organization,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                }
            };
            $http(req).then(deferred.resolve, deferred.reject);
            return deferred.promise;
        }
            
        // Return unfiltered http response
        function disableOrganization(organizationID) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: baseUrl + '/v2/admin/organization/' + organizationID + '/disable',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                },
                data: {}
            };
            $http(req).then(deferred.resolve, deferred.reject);
            return deferred.promise;
        }

        // Return unfiltered http response
        function enableOrganization(organizationID) {
            var deferred = $q.defer();
            var req = {
                method: 'POST',
                url: baseUrl + '/v2/admin/organization/' + organizationID + '/enable',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                },
                data: {}
            };
            $http(req).then(deferred.resolve, deferred.reject);
            return deferred.promise;
        }

        // Return unfiltered http response
        function deleteOrganization(organizationID) {
            var deferred = $q.defer();
            var req = {
                method: 'DELETE',
                url: baseUrl + '/v2/admin/organization/' + organizationID,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken()
                },
                data: {}
            };
            $http(req).then(deferred.resolve, deferred.reject);
            return deferred.promise;
        }

        function getOrganization() {
            return getOrganizationByHostname(location.hostname);
        }

        function getOrganizationByHostname(hostname) {
            var deferred = $q.defer();
            if (!hostname) {
                hostname = location.hostname;
            }
            var req = {
                method: 'GET',
                url: baseUrl + '/v2/organization/hostname/' + hostname,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken('anonymous')
                }
            };
            $http(req).then(
                function success(response) {
                    if (isOrganizationResponse(response) && (response.data.hostname === hostname)) {
                        deferred.resolve(response.data);
                    }
                    else {
                        deferred.reject(new Error('organization not found for host: ' + hostname));
                    }
                },
                function error(e) {
                    deferred.reject(e);
                });
            return deferred.promise;
        }

        function getOrganizationKey(user) {
            if (typeof user === 'object' && typeof user.organizationKey === 'string') {
                return user.organizationKey;
            }
            return organizationKey;
        }

        function getOrganizationName(user) {
            if (typeof user === 'object') {
                if (user.organizationKey !== organizationKey) {
                    return user.organizationName;
                }
            }
            return organizationName;
        }

        function hasOrganization(user) {
            if (typeof user === 'object' && user != null) {
                return (typeof user.organizationKey === 'string' && user.organizationKey.length > 0);
            }
            return typeof organizationKey === 'string' && organizationKey.length > 0;
        }

        function getOrganizationCss(css, returnEmpty, user) {
            returnEmpty = returnEmpty || false;
            user = user || null;
            var orgKey = organizationKey;
            if (typeof user === 'object' && user != null) {
                orgKey = user.organizationKey || '';
            }
            try {
                if (orgKey.length > 0) {
                    css += ' ' + orgKey;
                } else if (returnEmpty) {
                    css = '';
                }
            } catch (e) {
                // Do nothing...
            }

            return css;
        }

        // These two should be mutually exclusive.  If you want code registration for a paid scenario
        // use a stripe coupon
        
        function isPaidRegistration(org) {
            if (!org) {
                // default to global org for this instance
                org = organization;
            }
            return (angular.isObject(org) && org.selfRegistration);
        }

        function isCodeRegistration(org) {

            // >>> KSH when we are ready remove this
            if (constants.environment.NODE_ENV === 'production') {
                return false;
            }

            if (!org) {
                // default to global org for this instance
                org = organization;
            }
            return (angular.isObject(org) && org.codeRegistration);
        }


        function organizationInit() {
            var hostname = location.hostname;
            console.log("organization init: " + hostname);
            var req = {
                method: 'GET',
                url: baseUrl + '/v2/organization/hostname/' + location.hostname,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JWTService.getToken('anonymous')
                }
            };
            $http(req).then(
                function success(response) {
                    if (isOrganizationResponse(response) && (response.data.hostname === location.hostname)) {
                        setState(response.data);
                    }
                    else {
                        console.error(new Error('organization not found for host: ' + location.hostname));
                    }
                },
                function error(e) {
                    console.error(e);
                });
        }
        organizationInit();

        return {
            getOrganizationKeys: getOrganizationKeys,
            getOrganizations: getOrganizations,
            createOrganization: createOrganization,

            adminGetOrganization: adminGetOrganization,

            updateOrganization: updateOrganization,
            disableOrganization: disableOrganization,
            enableOrganization: enableOrganization,
            deleteOrganization: deleteOrganization,

            getOrganizationByHostname: getOrganizationByHostname,
            getOrganization: getOrganization, // for the current host
            
            getOrganizationKey: getOrganizationKey,
            hasOrganization: hasOrganization,
            getOrganizationCss: getOrganizationCss,
            getOrganizationName: getOrganizationName,
            isPaidRegistration: isPaidRegistration,
            isCodeRegistration: isCodeRegistration
            
        };
    }
})();

(function () {
  'use strict';

  angular.module('intryFrontEnd').service('noteService', noteService);

  /** @ngInject */
  function noteService(constants, JWTService, $http, $q) {
    var baseUrl = constants.baseUrl;

    function getNotes(skip, limit, field, filter, ftype, sort, order) {
      return $http({
        method: 'GET',
        url: baseUrl + '/v2/admin/note?skip=' + skip + '&limit=' + limit + '&field=' + field + '&filter=' + filter + '&ftype=' + ftype + '&sort=' + sort + '&order=' + order,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + JWTService.getToken()
        }
      }).then(function (response) {
        return response;
      });
    }

    function createNote(note) {
      var req = {
        method: 'POST',
        url: baseUrl + '/v2/admin/note',
        data: note,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + JWTService.getToken()
        }
      };

      return $http(req)
        .then(function (response) {
          if (angular.isObject(response.data)) {
            if (response) {
              return response;
            } else {
              return $q.reject(response);
            }
          } else {
            return $q.reject(response);
          }
        }, function (response) {
          return (response);
        });
    }

    return {
      getNotes: getNotes,
      createNote: createNote
    };
  }
})();
(function () {
  'use strict';

  angular
  .module('intryFrontEnd')
  .service('modalService', modalService);
  
  function modalService (ngDialog, $timeout,organizationService) {
   var getOrganizationCss = function(css, returnEmpty) {
      return organizationService.getOrganizationCss(css, returnEmpty);
  };



    var openModal = function (template, controller, resolve, settings) {
      settings = settings || {};
      var dialog = {
        template: template,
        controller: controller,
        closeByDocument: settings.closeByDocument || false,
        closeByEscape: settings.closeByEscape || false,
        showClose: settings.showClose || false,
        closeByNavigation: settings.closeByNavigation || true,
        width: settings.width || '455px',
        height: settings.height || '100%',
        className:getOrganizationCss(''),
        onOpenCallback: function () {
          // Fixed scroll
          var element = $(this);
          if (element.is('.new-ngdialog')) {
            $timeout(function () {
              element.find('.modal-content').scrollTop(0);
            }, 0);
          }
        }
      };
      if (settings.className) {
        dialog.className = settings.className;
      }
      if (resolve) {
        dialog.resolve = resolve;
      }
        
      return ngDialog.openConfirm(dialog);
    };

    var closeModal = function () {
      ngDialog.close();
    };

    return {
      openModal: openModal,
      closeModal: closeModal
    }
  }
})();
(function () {
    'use strict';

    angular
        .module('intryFrontEnd')
        .service('JWTService', JWTService);

    function JWTService() {

        var key = 'auth-token';
        var adminKey = 'admin-auth-token';
        var apikey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcGlrZXkiOiJpbnRyeWFwaSIsImlhdCI6MTY5NDk4ODcxNn0.0S8ZzplrmoEmj1nreXQ3VOScavq4TQghd4WxB_JPuWQ'; // for non-secure not logged in calls
        
        // function getToken() {
        //     return localStorage.getItem(key);
        // }
        function getToken(key) {
            if (!key) {
                key = getKey();
            }
            if (key === 'anonymous') {
                return apikey;
            }
            else {
                return localStorage.getItem(key);
            }
        }

        function decodePayload() {
            var storage = localStorage.getItem(key);
            var payload = storage ? storage.split('.')[1] : '';
            return atob(payload);
        }

        // function setToken(token) {
        //     if (token) {
        //         localStorage.setItem(key, token);
        //     } else {
        //         localStorage.removeItem(key);
        //     }
        //   }
        function setToken(token) {
            if (token) {
                localStorage.setItem(getKey(), token);
            } else {
                localStorage.removeItem(getKey());
            }
        }
        
        function setUserToken(token) {
            if (token) {
                localStorage.setItem(key, token);
            } else {
                localStorage.removeItem(key);
            }
        }


        // function clearToken() {
        //     setToken(null);
        //     localStorage.removeItem(key);
        // }
        function clearToken() {
            setToken(null);
            localStorage.removeItem(getKey());
        }

        function getKey() {
            return (localStorage.getItem('userRole') === 'admin') ? adminKey : key;
        }

        function getRole() {
            var userRole = localStorage.getItem('userRole');

            if (!(typeof userRole === 'string' && userRole.length > 0)) {
                userRole = 'user';
            }

            return userRole;
        }

        return {
            setToken: setToken,
            setUserToken: setUserToken,
            getToken: getToken,
            clearToken: clearToken,
            decodePayload: decodePayload,
            getRole: getRole
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('intryFrontEnd')
        .service('jobSearchService', jobSearchService);

    function jobSearchService ($http, constants) {
        var baseUrl = constants.baseUrl;
        function getJobDescription(jobLink) {
            return $http({
                method: 'GET',
                url: baseUrl + '/v2/jobdescription/',
                params: {jobLink : jobLink},
                headers: { 'Content-Type': 'application/json' }
            }).then(function (response) {
                return response.data;
            });
        }

        function searchZip(criteria) {
            return $http({
                method: 'GET',
                url: baseUrl + '/v2/searchzip/',
                params: { criteria: criteria },
                headers: { 'Content-Type': 'application/json' }
            }).then(function (response) {
                return response.data;
            });
        }

        return {
            getJobDescription: getJobDescription,
            searchZip: searchZip
        };
    }
   
})();
/**
 * Service for check and fixing objects in base of configurations.
 * 
 * *** FOR DEBUG ***
 * Enable the debug mode calling the method fixService.debugOn();
 * 
 * How does it work:
 * you need call the main method fixObj() passing by reference the object with the elements to check and fix and the configuration with the fields to compare and extended methods to run.
 * 
 * The flow if the following:
 * fixProfile()
 *     fixObj()
 *         init()
 *         filter()
 *             beforeFn() (Optional)
 *             checkEmptyItemFn()
 *             checkRepeatedItem()
 *             afterFn() (Optional)
 *             finalItemValidationFn()
 *         orderIndexSorting()
 * 
 * Example of a configuration:
 * var cfg = [
 *   {
 *     name: '',                                   // Name of the array of objects to check and fix.
 *     validateRepeatedItemsFields: [],            // List of fields to check and compare
 *     checkEmpty: boolean,             <Optional> // If is true and the object to compare have the values of validateRepeatedItemsFields empty the object will not be returned in the result.
 *     checkEmptyItemFn: function,      <Optional> // Method to overwrite the default check of empty items business logic.
 *     beforeFn: function,              <Optional> // Method to run before the check of the item of the array of objects.
 *     afterFn: function,               <Optional> // Method to run after the check of the item of the array of objects.
 *     finalItemValidationFn: function  <Optional> // Method to overwrite the default final validation business logic.
 *   },
 *   ...
 * ]
 */
(function () {
    'use strict';

    angular.module('intryFrontEnd').service('fixService', fixService);

    /** @ngInject */
    function fixService() {
        // #region Variables.
        var debug = false;

        // >>> KSH all these should come from constants.js
        var defaultEmptyFieldMsg = '-- MISSING DATA HERE --';
        var emptyFieldMsg = undefined;
        var defaultSuccessMsg = 'Data saved successfully';
        var successMsg = undefined;
        var defaultSaveWithMissingDataMsg = 'Data Saved, but we found some required things missing or some dates on the experience that are not valid.<BR/>Please check your data and fix any thing that is not correct.';
        var saveWithMissingDataMsg = undefined;
        var defaultUrlRegex = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
        var urlRegex = undefined;
        var defaultEmailRegex = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        var emailRegex = undefined;
        var profileCfg = [
            {
                name: 'experienceList',
                validateRepeatedItemsFields: [
                    'kind', 'company', 'title',
                    {
                        name: 'startMonthObj',
                        type: 'number'
                    },
                    {
                        name: 'startYearObj',
                        type: 'number'
                    },
                    {
                        name: 'endMonthObj',
                        type: 'number'
                    },
                    {
                        name: 'endYearObj',
                        type: 'number'
                    }
                ],
                checkEmpty: true,
                beforeFn: experienceBeforeFn
            },
            {
                name: 'educationList',
                validateRepeatedItemsFields: [
                    'kind', 'degree', 'institution',
                    {
                        name: 'startMonthObj',
                        type: 'number'
                    },
                    {
                        name: 'startYearObj',
                        type: 'number'
                    },
                    {
                        name: 'endMonthObj',
                        type: 'number'
                    },
                    {
                        name: 'endYearObj',
                        type: 'number'
                    }
                ],
                checkEmpty: true,
                beforeFn: educationBeforeFn
            },
            {
                name: 'skillsList',
                validateRepeatedItemsFields: ['skill'],
                checkEmpty: true
            },
            {
                name: 'achievements_awards',
                validateRepeatedItemsFields: [
                    'summary',
                    {
                        name: 'startMonthObj',
                        type: 'number'
                    },
                    {
                        name: 'startYearObj',
                        type: 'number'
                    }
                ],
                checkEmpty: true,
                beforeFn: achievementsAwardsBeforeFn
            },
            // We don't include these types in resumes anymore
            // {
            //     name: 'linkList',
            //     validateRepeatedItemsFields: ['name', 'url'],
            //     checkEmpty: true,
            //     beforeFn: linkBeforeFn
            // }
            // // I comment the transcripts check, because generate a lot of errors after the clean of the list of transcripts.
            // , { 
            //     name: 'transcriptList',
            //     validateRepeatedItemsFields: ['name', 'file_name'],
            //     checkEmpty: true,
            //     beforeFn: transcriptBeforeFn
            // }
            // , {
            //     name: 'referenceList',
            //     validateRepeatedItemsFields: ['name', 'relation', 'email'],
            //     checkEmpty: true,
            //     beforeFn: referenceBeforeFn
            // }
        ];
        var inlineEditorResumeCfg = [
            basicInlineEditorResumeCheck,
            {
                name: 'education',
                validateRepeatedItemsFields: [
                    'kind', 'degree', 'institution',
                    {
                        name: 'startMonthObj',
                        type: 'number'
                    },
                    {
                        name: 'startYearObj',
                        type: 'number'
                    },
                    {
                        name: 'endMonthObj',
                        type: 'number'
                    },
                    {
                        name: 'endYearObj',
                        type: 'number'
                    },
                ],
                checkEmpty: true,
                beforeFn: educationBeforeFn
            },
            {
                name: 'experience',
                validateRepeatedItemsFields: [
                    'kind', 'company', 'title',
                    {
                        name: 'startMonthObj',
                        type: 'number'
                    },
                    {
                        name: 'startYearObj',
                        type: 'number'
                    },
                    {
                        name: 'endMonthObj',
                        type: 'number'
                    },
                    {
                        name: 'endYearObj',
                        type: 'number'
                    },
                ],
                checkEmpty: true,
                beforeFn: experienceBeforeFn
            },
            {
                name: 'skills',
                validateRepeatedItemsFields: ['skill'],
                checkEmpty: true
            },
            {
                name: 'achievements_awards',
                validateRepeatedItemsFields: [
                    'summary',
                    {
                        name: 'startMonthObj',
                        type: 'number'
                    },
                    {
                        name: 'startYearObj',
                        type: 'number'
                    },
                ],
                checkEmpty: true,
                beforeFn: achievementsAwardsBeforeFn
            },
        ];
        var previewEditorResumeCfg = [
            basicPreviewEditorResumeCheck,
            {
                name: 'educations',
                validateRepeatedItemsFields: ['kind', 'degree', 'institution', 'startDateObj'],
                checkEmpty: true,
                beforeFn: educationBeforePreviewEditorFn
            },
            {
                name: 'experiences',
                validateRepeatedItemsFields: ['kind', 'company', 'title', 'startDateObj'],
                checkEmpty: true,
                beforeFn: experienceBeforePreviewEditorFn
            },
            {
                name: 'skills',
                validateRepeatedItemsFields: ['skill'],
                checkEmpty: true
            },
            {
                name: 'achievements_awards',
                validateRepeatedItemsFields: [
                    'summary',
                    {
                        name: 'startMonthObj',
                        type: 'number'
                    },
                    {
                        name: 'startYearObj',
                        type: 'number'
                    },
                ],
                checkEmpty: true,
                beforeFn: achievementsAwardsBeforeFn
            },
        ];
        var messages = {
            // Profile messages:
            'experienceList-greater-than': 'Experience: End date should be greater than start date',
            'educationList-greater-than': 'Education: End date should be greater than start date',

            // Resume messages:
            'education-greater-than': 'Education: End date should be greater than start date',
            'experience-greater-than': 'Experience: End date should be greater than start date',
            'certification-greater-than': 'Certificates: End date should be greater than start date',
            'Military-greater-than': 'Military Experience: End date should be greater than start date'
        };
        var filterObjError = false;
        var resultMessages = {};
        var saveMessages = {};
        // #endregion Variables.

        // #region Getters & Setters.
        function getDebug() {
            return debug;
        }

        function setDebug(val) {
            debug = val;
        }

        function getEmptyFieldMsg() {
            return emptyFieldMsg;
        }

        function setEmptyFieldMsg(val) {
            emptyFieldMsg = val;
        }

        function getSuccessMsg() {
            return successMsg;
        }

        function setSuccessMsg(val) {
            successMsg = val;
        }

        function getSaveWithMissingDataMsg() {
            return saveWithMissingDataMsg;
        }

        function setSaveWithMissingDataMsg(val) {
            saveWithMissingDataMsg = val;
        }

        function getUrlRegex() {
            return urlRegex;
        }

        function setUrlRegex(val) {
            urlRegex = val;
        }

        function getEmailRegex() {
            return emailRegex;
        }

        function setEmailRegex(val) {
            emailRegex = val;
        }

        function getProfileCfg() {
            return profileCfg;
        }

        function setProfileCfg(val) {
            profileCfg = val;
        }

        function getInlineEditorResumeCfg() {
            return inlineEditorResumeCfg;
        }

        function setInlineEditorResumeCfg(val) {
            inlineEditorResumeCfg = val;
        }

        function getPreviewEditorResumeCfg() {
            return previewEditorResumeCfg;
        }

        function setPreviewEditorResumeCfg(val) {
            previewEditorResumeCfg = val;
        }

        function getMessages() {
            return messages;
        }

        function setMessages(val) {
            messages = val;
        }

        function getResultMessage() {
            var resultMessage = _.reduce(resultMessages, function (memo, msg) {
                return memo + '<br/>' + msg;
            });
            return (resultMessage) ? resultMessage : '';
        }

        function getSaveMessage() {
            var saveMessage = _.reduce(saveMessages, function (memo, msg) {
                return memo + '<br/>' + msg;
            });
            if (saveMessage.length == 0 && getResultMessage().length > 0) saveMessage = successMsg;
            return (saveMessage) ? saveMessage : '';
        }

        function getFinalMessage() {
            var resultMessage = getResultMessage();
            var saveMessage = getSaveMessage();
            if (resultMessage.length > 0 && saveMessage.length > 0) return resultMessage + '<br/><br/>' + saveMessage;
            else if (saveMessage.length > 0) return saveMessage;
            else return '';
        }
        // #endregion Getters & Setters.




        // #region Basic Methods.
        function debugOn() {
            debug = true;
        }

        function debugOff() {
            debug = false;
        }

        function init() {
            if (typeof emptyFieldMsg === 'undefined') emptyFieldMsg = defaultEmptyFieldMsg;
            if (typeof successMsg === 'undefined') successMsg = defaultSuccessMsg;
            if (typeof saveWithMissingDataMsg === 'undefined') saveWithMissingDataMsg = defaultSaveWithMissingDataMsg;
            if (typeof urlRegex === 'undefined') urlRegex = defaultUrlRegex;
            if (typeof urlRegex === 'undefined') urlRegex = defaultEmailRegex;
            filterObjError = false;
            resultMessages = {};
            saveMessages = {
                'generic': ''
            };
        }

        /**
         * This is the specific method for check the profile.
         * 
         * @param {*} profile Object with the items of the profile, If you working with the user profile controller use 'userProfile' object.
         * @param {*} aux Auxiliar object.
         * @param {*} cfg Custom configuration, if you don't use a custom configuration the method will use the profileCfg.
         */
        function fixProfile(profile, aux, cfg) {
            cfg = cfg || profileCfg;
            return fixObj(profile, aux, cfg);
        }

        /**
         * This is the specific method for check a resume.
         * 
         * @param {*} resume Object with the items of the resume.
         * @param {*} aux Auxiliar object.
         * @param {*} cfg Custom configuration, if you don't use a custom configuration the method will use the resumeCfg.
         */
        function fixInlineEditorResume(resume, aux, cfg) {
            cfg = cfg || inlineEditorResumeCfg;
            consoleLog('mjncjndjcndjnc',resume);
            return fixObj(resume, aux, cfg);
        }

        /**
         * This is the specific method for check a resume.
         * 
         * @param {*} resume Object with the items of the resume.
         * @param {*} aux Auxiliar object.
         * @param {*} cfg Custom configuration, if you don't use a custom configuration the method will use the resumeCfg.
         */
        function fixPreviewEditorResume(resume, aux, cfg) {
            cfg = cfg || previewEditorResumeCfg;
            return fixObj(resume, aux, cfg);
        }

        /**
         * This is the main method, this method take an object of objects and the configuration for this and fix the elements of the objects in the object.
         * 
         * @param {*} obj Object with the objects to fix.
         * @param {*} aux Auxiliar object.
         * @param {*} cfg Configuration with the fields to compare and extended methods in the case of being necessary.
         */
        function fixObj(obj, aux, cfg) {
            consoleLog('mjnbhnjm',obj);
            var objBefore;
            var auxBefore;
            try {
                objBefore = angular.copy(obj);
                auxBefore = angular.copy(aux);
            } catch (e) {
                objBefore = obj;
                auxBefore = aux;
            }
            consoleGroupCollapsed('(Service) fixService.fixObj()');
            consoleLog('fixObj() - obj (Before):', 'bold');
            consoleLog(objBefore);
            consoleLog('fixObj() - aux (Before):', 'bold');
            consoleLog(auxBefore);
            consoleLog('fixObj() - cfg:', 'bold');
            consoleLog(cfg);

            init();
            var result = {};
            try {
                _.each(cfg, function (field, idx, list) {
                    consoleLog('field:', 'bold');
                    consoleLog(field);
                    try {
                        if (typeof field === 'function') field(obj, aux, cfg);
                        else if (typeof field === 'object' && typeof field.fn === 'function') field.fn(obj, aux, cfg, field);
                        else if (typeof field === 'object' && typeof field.name === 'string' && typeof obj[field.name] !== 'undefined') {
                            var context = {
                                field: field
                            };
                            filterObjError = false;
                            var fixedObj = _.filter(obj[field.name], filter, context);
                            if (filterObjError) obj[field.name] = objBefore[field.name]; // Rollback the object in case of an error;
                            else {
                                orderIndexSorting(obj[field.name]);
                                obj[field.name] = []; // This is necessary for reset the validations of the items.
                                obj[field.name] = angular.copy(fixedObj);
                            }
                        }
                    } catch (e) {
                        consoleLog('error',field,e);
                        consoleLog('(Service) fixService.fixObj() - Exception:', false);
                        consoleError(e);
                    }
                });
                result.status = 'success';
                result.message = getResultMessage();
                result.saveMessage = getSaveMessage();
                result.finalMessage = getFinalMessage();
            } catch (e) {
                // consoleLog('(Service) fixService.fixObj() - Exception:', false);
                consoleError(e);
                result.status = 'error';
                result.message = 'An error has occurred';
            }

            var objAfter;
            var auxAfter;
            try {
                objAfter = angular.copy(obj);
                auxAfter = angular.copy(aux);
            } catch (e) {
                objAfter = obj;
                auxAfter = aux;
            }
            consoleLog('fixObj() - obj (After):', 'bold');
            consoleLog(objAfter);
            consoleLog('fixObj() - aux (After):', 'bold');
            consoleLog(auxAfter);
            consoleGroupEnd();
            consoleLog('(Service) fixService.fixObj() - result:', 'warning');
            consoleTable(result);

            return result;
        }

        function filter(elm, idx, list) {
            var field = this.field;
            consoleGroupCollapsed('filter() - Filter item ' + field.name + '[' + idx + ']');
            consoleLog('elm (Before filtered):');
            consoleTable(angular.copy(elm));
            var result = true;
            var resultMsg = '';
            try {
                // if (typeof elm === 'object' && (typeof elm.forDelete === 'undefined' || !elm.forDelete)) {
                if (typeof elm === 'object') {
                    if (typeof elm.deleted === 'undefined' || !elm.deleted) {
                        if (result) {
                            // Extended business logic before check is the item is repeated:
                            if (typeof field.beforeFn === 'function') result = field.beforeFn(elm, idx, list);

                            if (!result) resultMsg = 'The item ' + field.name + '[' + idx + '] not pass the business logic before check.\n';
                        }
                        if (result) {
                            var checkEmpty = (typeof field.checkEmpty !== 'undefined') ? field.checkEmpty : false;
                            if (checkEmpty) {
                                // Check if the item is empty (You can overwrite this in the configuration):
                                if (typeof field.checkEmptyItemFn === 'function') result = !field.checkEmptyItemFn(elm, field.validateRepeatedItemsFields);
                                else result = !checkEmptyItem(elm, field.validateRepeatedItemsFields);

                                if (!result) resultMsg = 'The item ' + field.name + '[' + idx + '] is empty.\n';
                            }
                        }
                        var found;
                        var repeated = false;
                        if (result) {
                            // Find is the item is repeated (Return the found item. You can overwrite this in the configuration):
                            found = list.find(function (elm2) {
                                return (typeof field.checkRepeatedItemFn === 'function') ?
                                    field.checkRepeatedItemFn(elm, elm2, field.validateRepeatedItemsFields, checkEmpty) :
                                    checkRepeatedItem(elm, elm2, field.validateRepeatedItemsFields, checkEmpty);
                            });
                            if (
                                typeof found === 'object' &&
                                    !checkIndexes(elm, found, list) &&
                                    (typeof found.deleted === 'undefined' || !found.deleted)
                            ) {
                                if (typeof elm._id !== 'undefined') elm.deleted = true;
                                else result = false;
                                repeated = true;
                            }

                            consoleLog('found:');
                            consoleTable(angular.copy(found));
                            if (repeated) resultMsg = 'The item ' + field.name + '[' + idx + '] is repeated.\n';
                        }
                        if (result && repeated) {
                            // Execute final validations (You can overwrite this in the configuration):
                            result = (typeof field.finalItemValidationFn === 'function') ? field.finalItemValidationFn(elm, found, list) : finalItemValidation(elm, found, list);

                            if (!result) resultMsg = 'The item ' + field.name + '[' + idx + '] not pass the final validation.\n';
                        }
                        if (result && repeated) {
                            // Extended business logic after check is the item is repeated:
                            if (typeof field.afterFn === 'function') result = field.afterFn(elm, idx, list);

                            if (!result) resultMsg = 'The item ' + field.name + '[' + idx + '] not pass the business logic after check.\n';
                        }
                    } else {
                        resultMsg = 'The item ' + field.name + '[' + idx + '] was deleted.\n';
                    }
                } else result = false;
            } catch (e) {
                consoleLog('(Service) fixService.filter() - Exception:', false);
                console.error(e);
                result = false;
            }
            consoleLog('elm (After filtered):');
            consoleTable(angular.copy(elm));
            consoleGroupEnd();
            if (result) consoleLog('########## Item ' + field.name + '[' + idx + '] pass the filter ##########\n' + resultMsg, true);
            else {
                consoleLog('########## Item ' + field.name + '[' + idx + '] did not pass the filter ##########\n' + resultMsg, false);
            }
            return result;
        }

        function checkEmptyItem(elm, fields) {
            var isEmpty = true;
            for (var i in fields) {
                var f = fields[i];
                var v;
                if (typeof f === 'string') {
                    v = elm[f];
                } else if ((f.type === 'date') && (typeof elm[f.name] === 'string') && (elm[f.name].length >= 10)) {
                    v = elm[f.name].substr(0, 10);
                } else {
                    v = elm[f.name];
                }
                if (typeof v === 'string') v = v.trim();
                if ((typeof v !== 'undefined' && typeof v !== 'string') || (typeof v === 'string' && v.length > 0)) {
                    isEmpty = false;
                    break;
                }
            }
            return isEmpty;
        }

        /**
         * Return true if the fields present on the fields array have identical values in the arrays of objects elm1 and elm2.
         * 
         * @param {*} elm1 
         * @param {*} elm2 
         * @param {*} fields 
         */
        function checkRepeatedItem(elm1, elm2, fields) {
            for (var i in fields) {
                var f = fields[i];
                var v1;
                var v2;

                if (typeof f === 'string') {
                    v1 = elm1[f];
                    v2 = elm2[f];
                } else if (f.type === 'number') {
                    v1 = isNaN(elm1[f.name]) ? -1 : elm1[f.name];
                    v2 = isNaN(elm2[f.name]) ? -1 : elm2[f.name];
                } else if ((f.type === 'isoDate') && (typeof elm1[f.name] === 'string') && (elm1[f.name].length >= 10)) {
                    v1 = elm1[f.name].substr(0, 10);
                    v2 = elm2[f.name].substr(0, 10);
                } else {
                    v1 = elm1[f.name];
                    v2 = elm2[f.name];
                }

                v1 = (typeof v1 === 'string') ? v1.trim().toLowerCase() : v1;
                v2 = (typeof v2 === 'string') ? v2.trim().toLowerCase() : v2;
                if (v1 !== v2) return false;
            }
            return true;
        }

        /**
         * Method to check if two elements have the same indexes or not. If both elements have the same indexes return true otherwise return false.
         * 
         * @param {*} elm1 Current checking element.
         * @param {*} elm2 Found element.
         * @param {*} list Parent array of the elements.
         */
        function checkIndexes(elm1, elm2, list) {
            if (typeof elm1 !== 'undefined' || typeof elm2 !== 'undefined') {
                if (
                    /*
                      (typeof elm1._id !== 'undefined' && elm1._id !== null && typeof elm2._id !== 'undefined' && elm1._id === elm2._id) ||
                      (typeof elm1._id === 'undefined' && elm1._id !== null && typeof elm2._id === 'undefined' && list.indexOf(elm1) === list.indexOf(elm2))
                    */
                    (def(elm1._id) && def(elm2._id) && elm1._id === elm2._id) ||
                        (undef(elm1._id) && undef(elm2._id) && list.indexOf(elm1) === list.indexOf(elm2))
                ) return true;
            }
            return false;
        }

        /**
         * If this method return true, the filter() method will be returned the elm1 object.
         * 
         * @param {*} elm1 Current checking element.
         * @param {*} elm2 Found element.
         * @param {*} list Parent array of the elements.
         */
        function finalItemValidation(elm1, elm2, list) {
            consoleGroupCollapsed('finalItemValidation()');
            consoleLog('elm1:');
            consoleTable(angular.copy(elm1));
            consoleLog('elm2:');
            consoleTable(angular.copy(elm2));
            consoleLog('list.length: ' + list.length);
            consoleGroupEnd();

            return true;
        }

        function orderIndexSorting(list) {
            list = _.filter(list, {
                deleted: false
            });
            _.each(list, function (item, key) {
                item.order_index = key;
            });
        }
        // #endregion Basic Methods.




        // #region Miscellaneous Methods.
        function basicInlineEditorResumeCheck(obj, aux, cfg) {
            consoleLog('basicInlineEditorResumeCheck()', 'bold');
            consoleLog('basicInlineEditorResumeCheck() - aux.resumeEditor.industry: ' + aux.resumeEditor.industry);
            consoleLog('basicInlineEditorResumeCheck() - aux.resumeEditor.user.summary: ' + aux.resumeEditor.user.summary);

            try {
                if (typeof aux.resumeEditor.title === 'undefined' || aux.resumeEditor.title === null || aux.resumeEditor.title.length == 0) {
                    // aux.resumeEditor.title = emptyFieldMsg;
                    // saveMessages['generic'] = saveWithMissingDataMsg;
                }
                if (typeof aux.resumeEditor.industry === 'undefined' || aux.resumeEditor.industry === null || aux.resumeEditor.industry.length == 0) {
                    aux.resumeEditor.industry = emptyFieldMsg;
                    saveMessages['generic'] = saveWithMissingDataMsg;
                }
                if (aux.resumeEditor.title === emptyFieldMsg || aux.resumeEditor.industry === emptyFieldMsg) {
                    // saveMessages['generic'] = saveWithMissingDataMsg;
                }
                if (typeof aux.resumeEditor.user.summary === 'undefined' || aux.resumeEditor.summary === null || aux.resumeEditor.user.summary.length == 0) {
                    // aux.resumeEditor.user.summary = emptyFieldMsg;
                }
                // hasMissingDataMsgFn(aux.resumeEditor.user.summary);
                return true;
            } catch (e) {
                return false;
            }
        }

        function basicPreviewEditorResumeCheck(obj, aux, cfg) {
            consoleLog('basicPreviewEditorResumeCheck()', 'bold');
            consoleLog('basicPreviewEditorResumeCheck() - obj:');
            consoleLog(obj);
            consoleLog('basicPreviewEditorResumeCheck() - aux:');
            consoleLog(aux);

            try {
                // Put the business logic here...
                return true;
            } catch (e) {
                return false;
            }
        }

        function def(obj) {
            return (typeof obj !== 'undefined' && obj !== null) ? true : false;
        }

        function undef(obj) {
            return !def(obj);
        }
        // #endregion Miscellaneous Methods.




        /**
         * The before methods are for prepare the objects before the filter() method check the object.
         * If the method return false the object don't will be returned for the filter() method.
         * If you wish use a before method for a list of object, first you need create the method then you need add to the configuration.
         */
        // #region Before Methods.
        /**
         * Method to run at first time when an experience item is filtering.
         * 
         * @param {*} elm 
         * @param {*} idx 
         * @param {*} list 
         * @param {*} opts Options object. Preview editor example: {editorType: 'preview-editor'}
         */
        function experienceBeforeFn(elm, idx, list, opts) {
            if (typeof elm === 'object') {
                var editorType = (typeof opts !== 'undefined' && typeof opts.editorType === 'string') ? opts.editorType : '';
                if (hasDates(elm) || (typeof elm.summary === 'string' && elm.summary.length > 0)) {
                    if (elm.company.length == 0) {
                        elm.company = emptyFieldMsg;
                    }
                    if (elm.title.length == 0) {
                        elm.title = emptyFieldMsg;
                    }
                    if (elm.company.length > 0 || elm.title.length > 0) {
                        hasMissingDataMsgFn(elm.company);
                        hasMissingDataMsgFn(elm.title);
                    }
                } else if (elm.company.length == 0 && elm.title.length == 0) return false;
                else {
                    if (elm.company.length == 0 && elm.title.length > 0) {
                        elm.company = emptyFieldMsg;
                    }
                    if (elm.company.length > 0 && elm.title.length == 0) {
                        elm.title = emptyFieldMsg;
                    }
                    if (elm.company.length > 0 || elm.title.length > 0) {
                        hasMissingDataMsgFn(elm.company);
                        hasMissingDataMsgFn(elm.title);
                    }
                }
                fixDates(elm, 'experienceList', editorType, false, true, true);
                return true;
            }
            return false;
        }

        function experienceBeforePreviewEditorFn(elm, idx, list) {
            return experienceBeforeFn(elm, idx, list, {
                editorType: 'preview-editor'
            });
        }

        /**
         * Method to run at first time when an education item is filtering.
         * 
         * @param {*} elm 
         * @param {*} idx 
         * @param {*} list 
         * @param {*} opts Options object. Preview editor example: {forceFixDates: true, editorType: 'preview-editor'}
         */
        function educationBeforeFn(elm, idx, list, opts) {
            if (typeof elm === 'object') {
                var forceFixDates = (typeof opts !== 'undefined' && typeof opts.forceFixDates === 'boolean') ? opts.forceFixDates : false;
                var editorType = (typeof opts !== 'undefined' && typeof opts.editorType === 'string') ? opts.editorType : '';
                // if (!hasDates(elm, editorType)) {
                //     elm.date_start = '';
                //     elm.date_end = '';
                // }
                if (hasDates(elm, editorType) || (typeof elm.notes === 'string' && elm.notes.length > 0)) {
                    // if we have dates or note data but no institution, mark it as missing
                    if (elm.institution.length == 0) {
                        elm.institution = emptyFieldMsg;
                        hasMissingDataMsgFn(elm.institution);
                    }
                }
                else if (elm.institution.length == 0) {
                    if (elm.degree && (elm.kind === 'certification')) {
                        elm.institution = emptyFieldMsg;
                        hasMissingDataMsgFn(elm.institution);
                    }
                    else {
                        // if all we have is a degree (that is not a certification) and/or a field of study
                        // but no dates, institution or notes, then we give up
                        return false;
                    }
                }
                else if (elm.institution.length == 0) {
                    elm.institution = emptyFieldMsg;
                    hasMissingDataMsgFn(elm.institution);
                }
                if (forceFixDates || hasDates(elm, editorType)) fixDates(elm, 'educationList', editorType);
                return true;
            }
            return false;
        }

        function educationBeforePreviewEditorFn(elm, idx, list) {
            if (typeof elm === 'object') {
                var editorType = 'preview-editor';
                if (!hasDates(elm, editorType)) {
                    elm.date_start = '';
                    elm.date_end = '';
                }
                if (hasDates(elm, editorType) || (typeof elm.notes === 'string' && elm.notes.length > 0)) {
                    if (elm.institution.length == 0) {
                        elm.institution = emptyFieldMsg;
                        saveMessages['generic'] = saveWithMissingDataMsg;
                    }
                }
                else if (elm.institution.length == 0) {
                    if (elm.degree && (elm.kind === 'certification')) {
                        elm.institution = emptyFieldMsg;
                        saveMessages['generic'] = saveWithMissingDataMsg;
                    }
                    else {
                        // if all we have is a degree (that is not a certification) and/or a field of study
                        // but no dates, institution or notes, then we give up
                        return false;
                    }
                    return false;
                }
                else if (elm.institution.length == 0) {
                    elm.institution = emptyFieldMsg;
                    saveMessages['generic'] = saveWithMissingDataMsg;
                }
                if (hasDates(elm, editorType)) fixDates(elm, 'educationList', editorType);
                return true;
            }
            return false;
        }

        function achievementsAwardsBeforeFn(elm, idx, list, opts) {
            if (typeof elm === 'object') {
                var forceFixDates = (typeof opts !== 'undefined' && typeof opts.forceFixDates === 'boolean') ? opts.forceFixDates : false;
                var editorType = (typeof opts !== 'undefined' && typeof opts.editorType === 'string') ? opts.editorType : '';
                if (!hasDates(elm, editorType)) {
                    elm.date_start = '';
                    elm.date_end = '';
                }
                if (forceFixDates || hasDates(elm, editorType)) fixDates(elm, 'achievements_awards', editorType);
                return true;
            }
            return false;
        }

        function linkBeforeFn(elm, idx, list) {
            if (typeof elm === 'object') {
                if (elm.url.length == 0) return false;
                else if (!urlRegex.test(elm.url)) return false;
                else if (elm.name.length == 0) {
                    elm.name = emptyFieldMsg;
                }
                if (elm.name.length > 0) {
                    hasMissingDataMsgFn(elm.name);
                }
                return true;
            }
            return false;
        }

        function transcriptBeforeFn(elm, idx, list) {
            if (typeof elm === 'object') {
                if (elm.type.length == 0) return false;
                if (elm.name.length == 0 && elm.file_name.length > 0) {
                    elm.name = emptyFieldMsg;
                    saveMessages['generic'] = saveWithMissingDataMsg;
                }
                return true;
            }
            return false;
        }

        function referenceBeforeFn(elm, idx, list) {
            if (typeof elm === 'object') {
                if (elm.email.length == 0) return false;
                if (elm.name.length == 0) {
                    elm.name = emptyFieldMsg;
                }
                if (elm.relation.length == 0) {
                    elm.relation = emptyFieldMsg;
                }
                if (elm.name.length > 0 || elm.relation.length > 0) {
                    hasMissingDataMsgFn(elm.name);
                    hasMissingDataMsgFn(elm.relation);
                }
                return true;
            }
            return false;
        }

        function hasMissingDataMsgFn(value) {
            if (value === emptyFieldMsg) {
                saveMessages['generic'] = saveWithMissingDataMsg;
                return true;
            } else {
                return false;
            }
        }
        // #endregion Before Methods.

        // #region Date Methods.
        function createDateObj(year, month) {
            var date = new Date();
            date.setFullYear(year, month - 1, 2);
            date.setHours(0, 0, 0, 0);
            return date;
        }

        function hasDates(elm, editorType) {
            if (editorType === 'preview-editor') {
                return ((typeof elm.startDateObj === 'string' && elm.startDateObj.length > 0)
                        || (typeof elm.endDateObj === 'string' && elm.endDateObj.length > 0)
                        || (typeof elm.endDateObj === 'string' && elm.endDateObj.toLowerCase() === 'present'));
            }
            else if (editorType === '') {
                return (isnum(elm.startMonthObj) || isnum(elm.startYearObj) || isnum(elm.endMonthObj) || isnum(elm.endYearObj));
            }
            return false;
        }

        function setCurrent(elm) {
            elm.date_end = '';
            elm.endDateObj = '';
            elm.is_current = true;
            elm.endMonthObj = '';
            elm.endYearObj = null;
        }

        function fixDates(elm, type, editorType, emptyDates, emptyEndDate, emptyMonths) {
            editorType = editorType || '';
            emptyMonths = (typeof emptyMonths === 'boolean') ? emptyMonths : true;
            emptyDates = (typeof emptyDates === 'boolean') ? emptyDates : true;
            emptyEndDate = (typeof emptyEndDate === 'boolean') ? emptyEndDate : false;

            var elmBefore = angular.copy(elm);
            generateDates(elm, editorType, emptyDates, emptyEndDate, emptyMonths);
            var date = new Date();

            var isDateAfterCurrent = function (year, month) {
           
                var dateParams = [year];
                if (month) {
                    dateParams.push(month);
                }
                var momentDate = moment(dateParams);
                var momentCurrent = moment([date.getUTCFullYear(), date.getMonth()]);
               
                return moment(momentDate).isAfter(momentCurrent);
            };

            var isStartDateAfterEndDate = function (startYear, startMonth, endYear, endMonth) {
                var startDateParams = [startYear];
                var endDateParams = [endYear];
                if (startMonth) {
                    startDateParams.push(startMonth);
                }
                if (endMonth) {
                    endDateParams.push(endMonth);
                }
                var momentStart = moment(startDateParams);
                var momentEnd = moment(endDateParams);
                return moment(momentStart).isAfter(momentEnd);
            };

            // Check if the start date is empty or greater than the current date and fix:
            if ((!emptyDates && ((!emptyMonths && !isnum(elm.startMonthObj)) || !isnum(elm.startYearObj))) ||
                (isnum(elm.startMonthObj) && isnum(elm.startYearObj) && isDateAfterCurrent(elm.startYearObj, elm.startMonthObj - 1))) {
                // Add a warning msg:
                if (isnum(elm.startMonthObj) && isnum(elm.startYearObj) && isDateAfterCurrent(elm.startYearObj, elm.startMonthObj - 1)) {
                    if (typeof elm.kind === 'string' && elm.kind === 'certification')
                        resultMessages[elm.kind + '-greater-than'] = messages[type + '-greater-than'];
                    else if (typeof elm.kind === 'string' && elm.kind === 'Military')
                        resultMessages[elm.kind + '-greater-than'] = messages[type + '-greater-than'];
                    else
                        resultMessages[type + '-greater-than'] = messages[type + '-greater-than'];
                }
                elm.date_start = date.toISOString();
                elm.startDateObj = date.toDateString().substr(4, 3) + ' ' + date.toDateString().substr(11, 4);
                elm.startMonthObj = date.getMonth() + 1;
                elm.startYearObj = date.getUTCFullYear();
            }

            // Check if the end date is current, empty or greater than the current date and fix:
            // if ((typeof elm.is_current === 'boolean' && elm.is_current && (!isnum(elm.endMonthObj) || !isnum(elm.endYearObj)))
            //     || (isnum(elm.endMonthObj) && isnum(elm.endYearObj) )) {
            //     setCurrent(elm);
            // }

            // Check if the start date is greater than the end date and fix:

            if ((typeof elm.is_current === 'undefined' || !elm.is_current)
                && isnum(elm.startMonthObj) && isnum(elm.startYearObj) && isnum(elm.endMonthObj) && isnum(elm.endYearObj)
                && isStartDateAfterEndDate(elm.startYearObj, elm.startMonthObj - 1, elm.endYearObj, elm.endMonthObj - 1)) {
                elm.date_end = elm.date_start;
                elm.endDateObj = elm.startDateObj;
                elm.endMonthObj = elm.startMonthObj;
                elm.endYearObj = elm.startYearObj;

                if (typeof elm.kind === 'string' && elm.kind === 'certification') resultMessages[elm.kind + '-greater-than'] = messages[type + '-greater-than'];
                if (typeof elm.kind === 'string' && elm.kind === 'Military') resultMessages[elm.kind + '-greater-than'] = messages[type + '-greater-than'];
                else resultMessages[type + '-greater-than'] = messages[type + '-greater-than'];
            } else if (emptyMonths && (!isnum(elm.startMonthObj) || !isnum(elm.endMonthObj)) && isnum(elm.startYearObj) && isnum(elm.endYearObj) &&
                       isStartDateAfterEndDate(elm.startYearObj, null, elm.endYearObj, null)) {
                // If there are the years, but there aren't the months
                if (!isnum(elm.endMonthObj)) {
                    elm.date_end = '' + elm.startYearObj;
                    elm.endDateObj = elm.date_end;
                    elm.endYearObj = elm.startYearObj;
                }
                else {
                    // If there is full end date (month and year) and end year, but there isn't end month
                    var tempEndDate = createDateObj(elm.startYearObj, elm.endMonthObj);
                    elm.date_end = tempEndDate.toISOString();
                    elm.endDateObj = tempEndDate.toDateString().substr(4, 3) + ' ' + tempEndDate.toDateString().substr(11, 4);
                    elm.endYearObj = elm.startYearObj;
                }
            }

            var elmAfter = angular.copy(elm);
            checkDateChanges(elmBefore, elmAfter, editorType);
        }

        /**
         * Generate the missing date properties in base of existing date properties.
         * 
         * @param {*} elm Element with the dates to check and generate.
         * @param {*} editorType Type of editor. For user profile editor and inline editor use '' or leave empty, for preview editor use 'preview-editor'.
         * @param {*} emptyDates If is true force the generation of the date fields.
         * @param {*} emptyEndDate If is true the date_end property can be are an empty string '' (Use this in the experience and military items).
         */
        function generateDates(elm, editorType, emptyDates, emptyEndDate, emptyMonths) {
            editorType = editorType || '';
            emptyMonths = (typeof emptyMonths === 'boolean') ? emptyMonths : true;
            emptyDates = (typeof emptyDates === 'boolean') ? emptyDates : true;
            emptyEndDate = (typeof emptyEndDate === 'boolean') ? emptyEndDate : false;
            var startDate;
            var endDate;
            var isEmptyStartMonth = false;
            var isEmptyEndMonth = false;

            // Try to generate the dates in case of use the preview editor:
            // IF WE WILL USE PREVIEW-EDITOR WE SHOULD REVIEW THIS CODE!
            if (editorType === 'preview-editor') {
                // Try to generate the start date:
                if (typeof elm.startDateObj === 'string' && elm.startDateObj.length > 0) {
                    startDate = new Date(elm.startDateObj);
                    if (startDate.toDateString() === 'Invalid Date') startDate = new Date();
                }

                // Try to generate the end date:
                if (typeof elm.endDateObj === 'string' && elm.endDateObj.toLowerCase() === 'present') {
                    endDate = new Date();
                    elm.date_end = '';
                    elm.endDateObj = 'Present';
                } else if (typeof elm.endDateObj === 'string' && elm.endDateObj.length > 0) {
                    endDate = new Date(elm.endDateObj);
                    if (endDate.toDateString() === 'Invalid Date') {
                        endDate = new Date();
                        elm.date_end = '';
                        elm.endDateObj = 'Present';
                    }
                }
            }
            // Try to generate the dates in case of use the user profile editor or the inline editor:
            else {
                // Try to generate the start date:
                if (isnum(elm.startMonthObj) || isnum(elm.startYearObj)) {
                    if (!isnum(elm.startMonthObj) && emptyMonths) {
                        isEmptyStartMonth = true;
                    } else {
                        startDate = new Date();
                        if (!isnum(elm.startMonthObj)) elm.startMonthObj = startDate.getMonth() + 1;
                        if (!isnum(elm.startYearObj)) elm.startYearObj = startDate.getFullYear();
                        // "date" param in setFullYear function should NOT be started from "1"
                        startDate.setFullYear(elm.startYearObj, elm.startMonthObj - 1, 2);
                        startDate.setHours(0, 0, 0, 0);
                    }
                }
                else {
                    elm.date_start = '';
                }

                // Try to generate the end date:
                if (isnum(elm.endMonthObj) || isnum(elm.endYearObj)) {
                    if (!isnum(elm.endMonthObj) && emptyMonths) {
                        isEmptyEndMonth = true;
                    }
                    else {
                        endDate = new Date();
                        endDate.setHours(0, 0, 0, 0);
                        if (!isnum(elm.endMonthObj)) elm.endMonthObj = endDate.getMonth() + 1;
                        if (!isnum(elm.endYearObj)) elm.endYearObj = endDate.getFullYear();
                        // "date" param in setFullYear function should NOT be started from "1"
                        endDate.setFullYear(elm.endYearObj, elm.endMonthObj - 1, 2);
                        elm.is_current = false;
                    }
                }
                else {
                    elm.date_end = '';
                }
            }

            // Check if the element can have empty dates
            // emptyDates === false if it's experience item, and emptyDates === true if it's education item
            if (!emptyDates) {
                if (!isEmptyStartMonth && typeof startDate === 'undefined') {
                    startDate = new Date();
                }
                if (!emptyEndDate && !isEmptyEndMonth && typeof endDate === 'undefined') {
                    endDate = new Date();
                }
            }

            // Try to fill all of start date properties in case of the start date is not empty:
            if (typeof startDate !== 'undefined') {
                elm.date_start = startDate.toISOString();
                elm.startDateObj = startDate.toDateString().substr(4, 3) + ' ' + startDate.toDateString().substr(11, 4);
                elm.startMonthObj = startDate.getMonth() + 1;
                elm.startYearObj = startDate.getUTCFullYear();
            }
            else if (isEmptyStartMonth) {
                // Try to fill start year property in case of the start year is not empty and the start month is empty:
                elm.date_start = '' + elm.startYearObj;
                elm.startDateObj = elm.date_start;
            }

            // Try to fill all of end date properties in case of the end date is not empty:
            if (typeof endDate !== 'undefined') {
                elm.date_end = endDate.toISOString();
                elm.endDateObj = endDate.toDateString().substr(4, 3) + ' ' + endDate.toDateString().substr(11, 4);
                elm.is_current = false;
                elm.endMonthObj = endDate.getMonth() + 1;
                elm.endYearObj = endDate.getUTCFullYear();
            }
            else if (isEmptyEndMonth) {
                // Try to fill end year property in case of the end year is not empty and the end month is empty:
                elm.date_end = '' + elm.endYearObj;
                elm.endDateObj = elm.date_end;
            }
            else if (!emptyDates && emptyEndDate) {
                // endMonthObj and endYearObj are empty. Set current date.
                setCurrent(elm);
            }
        }

        function checkDateChanges(elmBefore, elmAfter, editorType) {
            // The isNaN() is because NaN === NaN return false.
            var dates = {
                smb: !isNaN(elmBefore.startMonthObj) ? elmBefore.startMonthObj : -1,
                sma: !isNaN(elmAfter.startMonthObj) ? elmAfter.startMonthObj : -1,
                syb: !isNaN(elmBefore.startYearObj) ? elmBefore.startYearObj : -1,
                sya: !isNaN(elmAfter.startYearObj) ? elmAfter.startYearObj : -1,

                emb: !isNaN(elmBefore.endMonthObj) ? elmBefore.endMonthObj : -1,
                ema: !isNaN(elmAfter.endMonthObj) ? elmAfter.endMonthObj : -1,
                eyb: !isNaN(elmBefore.endYearObj) ? elmBefore.endYearObj : -1,
                eya: !isNaN(elmAfter.endYearObj) ? elmAfter.endYearObj : -1,

                sdb: elmBefore.startDateObj,
                sda: elmAfter.startDateObj,
                edb: elmBefore.endDateObj,
                eda: elmAfter.endDateObj,
            };
            
            consoleLog('checkDateChanges() - dates:', 'bold');
            consoleTable(dates);

            // For User Profile & Preview Editor:
            if (editorType === '' && (dates.sma === -1 || dates.sya === -1 || ((dates.ema === -1 || dates.eya === -1) && !elmAfter.is_current))) {
                consoleLog('checkDateChanges() - The dates have changed.');
            }
            // For Preview Editor:
            else if (editorType === 'preview-editor' && (dates.sdb !== dates.sda || dates.edb !== dates.eda)) {
                consoleLog('checkDateChanges() - The dates have changed.');
            }
        }
        
        function isnum(val) {
            if (typeof val !== 'undefined' && val !== null && !isNaN(val)) return true;
            return false;
        }
        // #endregion Date Methods.




        // #region Controller Methods.
        /**
         * Check if the text is equal to the missing data msg and if is true return an error css class.
         */
        function checkMissingText(name, type) {
            var completeCss = 'complete-data';
            var missingCss = 'missing-data';
            var finalCss = completeCss;

            if (name.indexOf('noFile_') !== -1) {
                return $("#" + name).text() === 'Select File' ? missingCss : completeCss;
            }

            try {
                var elem = $("[name='" + name + "']");
                var val = elem[0].value;
                if (typeof val === 'string') {
                    switch (type) {
                    case 'input':
                    default:
                        finalCss = getEmptyFieldMsg().trim().toLowerCase() === val.trim().toLowerCase() || !val.trim() ? missingCss : completeCss;
                        break;
                    case 'select':
                        finalCss = (val.length == 0 && !elem.is(':disabled')) ? missingCss : completeCss;
                        break;
                    }
                }
            } catch (e) {
                // Do nothing...
            }
            return finalCss;
        }

        /**
         * Remove/Add the missing data msg when the user is focus or not on an empty field.
         */
        function focusBlurMissingText(name, focus) {
            focus = (typeof focus === 'boolean' && focus) ? true : false;
            try {
                var elm = $($("[name='" + name + "']")[0]);
                if (typeof elm === 'object') {
                    if (focus && typeof elm.val() === 'string' && elm.val() === getEmptyFieldMsg()) elm.val('');
                    else if (!focus && typeof elm.val() === 'string' && elm.val().length == 0) elm.val(getEmptyFieldMsg());
                }
            } catch (e) {
                // Do nothing...
            }
        }
        // #endregion Controller Methods.

        // #region Log Methods.
        function consoleLog(msg, opt) {
            if (debug) {
                if (typeof opt === 'undefined') console.log(msg);
                else if (typeof opt === 'boolean' && opt) console.log('%c' + msg, 'color: green; font-weight: bold;');
                else if (typeof opt === 'boolean' && !opt) console.log('%c' + msg, 'color: red; font-weight: bold;');
                else if (typeof opt === 'string' && opt.length > 0) {
                    switch (opt) {
                    case 'bold':
                        console.log('%c' + msg, 'font-weight: bold;');
                        break;
                    case 'warning':
                        console.log('%c' + msg, 'color: orange; font-weight: bold;');
                        break;
                    default:
                        console.log(msg);
                        break;
                    }
                } else console.log(msg);
            }
        }

        function consoleError(msg) {
            if (debug) console.error(msg);
        }

        function consoleTable(obj) {
            if (debug) console.table(obj);
        }

        function consoleGroup(lbl) {
            if (debug) console.group(lbl);
        }

        function consoleGroupCollapsed(lbl) {
            if (debug) console.groupCollapsed(lbl);
        }

        function consoleGroupEnd() {
            if (debug) console.groupEnd();
        }
        // #endregion Log Methods.

        return {
            getDebug: getDebug,
            setDebug: setDebug,
            getEmptyFieldMsg: getEmptyFieldMsg,
            setEmptyFieldMsg: setEmptyFieldMsg,
            getSuccessMsg: getSuccessMsg,
            setSuccessMsg: setSuccessMsg,
            getSaveWithMissingDataMsg: getSaveWithMissingDataMsg,
            setSaveWithMissingDataMsg: setSaveWithMissingDataMsg,
            getUrlRegex: getUrlRegex,
            setUrlRegex: setUrlRegex,
            getEmailRegex: getEmailRegex,
            setEmailRegex: setEmailRegex,
            getProfileCfg: getProfileCfg,
            setProfileCfg: setProfileCfg,
            getInlineEditorResumeCfg: getInlineEditorResumeCfg,
            setInlineEditorResumeCfg: setInlineEditorResumeCfg,
            getPreviewEditorResumeCfg: getPreviewEditorResumeCfg,
            setPreviewEditorResumeCfg: setPreviewEditorResumeCfg,
            getMessages: getMessages,
            setMessages: setMessages,
            getResultMessage: getResultMessage,
            getSaveMessage: getSaveMessage,
            getFinalMessage: getFinalMessage,

            debugOn: debugOn,
            debugOff: debugOff,
            init: init,
            fixProfile: fixProfile,
            fixInlineEditorResume: fixInlineEditorResume,
            fixPreviewEditorResume: fixPreviewEditorResume,
            fixObj: fixObj,
            checkMissingText: checkMissingText,
            focusBlurMissingText: focusBlurMissingText
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('intryFrontEnd')
        .service('communitiesService', communitiesService);

    function communitiesService ($http, constants) {

        var baseUrl = constants.baseUrl;

        function getUniversities(university) {
            return $http({
                method: 'GET',
                url: baseUrl + '/v2/universities/?q=' + encodeURIComponent(university),
                headers: { 'Content-Type': 'application/json' }
            }).then(function (response) {
                return response.data;
            });
        }

        function getCompanies(company) {
            return $http({
                method: 'GET',
                url: baseUrl + '/v2/companies/?q=' + encodeURIComponent(company),
                headers: { 'Content-Type': 'application/json' }
            }).then(function (response) {
                return response.data;
            });
        }

        function getDegrees(degree) {
            return $http({
                method: 'GET',
                url: baseUrl + '/v2/degrees/?q=' + encodeURIComponent(degree),
                headers: { 'Content-Type': 'application/json' }
            }).then(function (response) {
                return response.data;
            });
        }

        function getPositions(position) {
            return $http({
                method: 'GET',
                url: baseUrl + '/v2/positions/?q=' + encodeURIComponent(position),
                headers: { 'Content-Type': 'application/json' }
            }).then(function (response) {
                return response.data;
            });
        }

        function getFieldOfStudy(fieldOfStudy) {
            return $http({
                method: 'GET',
                url: baseUrl + '/v2/field-of-study/?q=' + encodeURIComponent(fieldOfStudy),
                headers: { 'Content-Type': 'application/json' }
            }).then(function (response) {
                return response.data;
            });
        }

        return {
            getUniversities: getUniversities,
            getCompanies: getCompanies,
            getPositions: getPositions,
            getDegrees: getDegrees,
            getFieldOfStudy: getFieldOfStudy
        }
    }
})();
(function () {
  'use strict';

  angular.module('intryFrontEnd').service('billingService', billingService);

  /** @ngInject */
  function billingService(constants, JWTService, $http, $q) {
    var baseUrl = constants.baseUrl;

    function getProduct(productID) {
      return $http({
        method: 'GET',
        url: baseUrl + '/v2/stripe/products/' + productID,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + JWTService.getToken('anonymous')
        }
      }).then(function (response) {
        return response;
      });
    }

    function getPrices(productID) {
      return $http({
        method: 'GET',
        url: baseUrl + '/v2/stripe/products/' + productID + '/prices',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + JWTService.getToken('anonymous')
        }
      }).then(function (response) {
        return response;
      });
    }

    function getCoupon(couponID) {
        return $http({
            method: 'GET',
            url: baseUrl + '/v2/stripe/coupon/' + encodeURIComponent(couponID),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + JWTService.getToken('anonymous')
            }
        }).then(function (response) {
            return response;
        });
    }

    function getPrice(priceID) {
      return $http({
        method: 'GET',
        url: baseUrl + '/v2/stripe/prices/' + priceID,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + JWTService.getToken('anonymous')
        }
      }).then(function (response) {
        return response;
      });
    }

    function changeUserSubscription(userID, newPlanID, token) {
      return $http({
        method: 'POST',
        url: baseUrl + '/v2/stripe/change_user_subscription',
        data: {
          userID: userID,
          newPlanID: newPlanID,
          token: token
        },
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + JWTService.getToken()
        }
      }).then(function (response) {
        return response;
      });
    }

    return {
      getProduct: getProduct,
      getPrices: getPrices,
      getPrice: getPrice,
      getCoupon: getCoupon,
      changeUserSubscription: changeUserSubscription
    };
  }
})();

(function () {
  'use strict';

  angular.module('intryFrontEnd').service('assessmentsService', AssessmentsService);

  /** @ngInject */
  function AssessmentsService($http, constants, JWTService, $q) {
    var baseUrl = constants.baseUrl;

    // createAssessment method is used to create unique assessment for each user
    // Id in the response is unique identifier to continue assessment
    // Assessment is created by using deckId, deckId in our case will be "career-deck" and "big-five"
    function createAssessment(deckId) {
      return $http({
        method: 'POST',
        url: baseUrl + '/v2/traitify',
        data: {
          deck_id: deckId
        },
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + JWTService.getToken()
        }
      });
    }

    // getSlides method provides list of the slides for any assessment
    // It includes the path to each image for each slide and the position that the slides should be presented to the user.
    function getSlides(assessmentId) {
      return $http({
        method: 'GET',
        url: baseUrl + '/v2/traitify/' + assessmentId + '/slides',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + JWTService.getToken()
        }
      });
    }

    // addSlides method allows to update an assessment's slide responses in bulk.
    // params contain array of values which contain response of each slide of an assessment {id: slide_id, response: true/false("me" == true, "not me" == false ), time_taken: time(ms)}
    function addSlides(assessmentId, params) {
      return $http({
        method: 'PUT',
        url: baseUrl + '/v2/traitify/' + assessmentId + '/slides',
        data: params,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + JWTService.getToken()
        }
      });
    }

    // getResults return results including personality types and blends, personality traits, and the corresponding badge for each personality type
    // ex values for data: blend,types,traits,career_matches; blend; blend,traits; blend,career_matches; types,traits
    function getResults(assessmentId, data, imagePack) {
      var queryValues = [];
      var query = '';
      if (data) {
        queryValues.push('data=' + data.join(','));
      }
      if (imagePack) {
        queryValues.push('image_pack=' + imagePack);
      }
      if (queryValues.length > 0) {
        query = '?' + queryValues.join('&');
      }
      return $http({
        method: 'GET',
        url: baseUrl + '/v2/traitify/' + assessmentId + query,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + JWTService.getToken()
        }
      });
    }

    function deleteAssessmentsByUserID(userID) {
      var req = {
        method: 'DELETE',
        url: baseUrl + '/v2/traitify/' + userID,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + JWTService.getToken()
        }
      };

      return $http(req)
        .then(function (response) {
          if (angular.isObject(response.data)) {
            if (response) {
              return response;
            } else {
              return $q.reject(response);
            }
          } else {
            return $q.reject(response);
          }
        }, function (response) {
          return (response);
        });
    }

    return {
      createAssessment: createAssessment,
      getSlides: getSlides,
      addSlides: addSlides,
      getResults: getResults,
      deleteAssessmentsByUserID: deleteAssessmentsByUserID
    };
  }
})();
(function () {
    'use strict';

    angular.module('intryFrontEnd').service('adminService', adminService);

    /** @ngInject */
    function adminService(JWTService, $http, $q, constants, $localStorage, $state) {

        var baseUrl = constants.baseUrl;

        function register(user) {
            var req = {
                method: 'POST',
                url: baseUrl + '/v2/admin',
                data: {
                    username: user.emailPhone,
                    password: user.password,
                    first_name: user.firstname,
                    last_name: user.lastname
                },
                headers: { 'Content-Type': 'application/json' }
            };

            return $http(req)
                .then(function (response) {
                    if (angular.isObject(response.data)) {
                        if (response) {
                            return response;
                        }
                        else {
                            // invalid response
                            return $q.reject(response);
                        }
                    } else {
                        // invalid response
                        return $q.reject(response);
                    }
                }, function (response) {
                    return response;
                });
        }

        function login(username, password) {
            return $http.post(baseUrl + '/v2/admin/login', {
                username: username,
                password: password
            }).then(function success(response) {
                if (response.status === 200) {
                    JWTService.setToken(response.data.token);
                    $localStorage.adminUserID = response.data.user.userID;
                    $localStorage.registeredUserID = response.data.user.userID;
                    $localStorage.adminUser = response.data.user;
                    return getAdmin();
                }
                else {
                    delete $localStorage.adminUserID;
                    delete $localStorage.registeredUserID;
                    delete $localStorage.adminUser;
                    JWTService.clearToken();
                    return null;
                }
            });
        }

        function getAdmin(forceRefresh) {
            return getAdminById($localStorage.adminUserID, forceRefresh);
        }

        function getAdminById(adminUserID, forceRefresh) {

            if (forceRefresh ||
                !$localStorage.adminUser ||
                ($localStorage.adminUser.userID !== $localStorage.adminUserID)) {
                return $http({
                    method: 'GET',
                    url: baseUrl + '/v2/admin/admins/' + adminUserID,
                    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + JWTService.getToken() }
                }).then(function (response) {
                    if (response.status === 200) {
                        $localStorage.adminUser = response.data;
                        return $localStorage.adminUser;
                    }
                    else {
                        logOut();
                        return undefined;
                    }
                }, function (response) {
                    logOut();
                    return undefined;
                });
            } else {
                var deferred = $q.defer();
                deferred.resolve($localStorage.adminUser);
                return deferred.promise;
            }
        }

        function logOut() {
            JWTService.clearToken();
            delete $localStorage.adminUserID;
            delete $localStorage.adminUser;
            $state.go("admin-register");
        }

        function getAdmins(skip, limit, field, filter, ftype, sort, order) {
            return $http({
                method: 'GET',
                url: baseUrl + '/v2/admin/admins?skip=' + skip + '&limit=' + limit + '&field=' + field + '&filter=' + filter + '&ftype=' + ftype + '&sort=' + sort + '&order=' + order,
                headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + JWTService.getToken() }
            }).then(function (response) {
                return response;
            });
        }

        function adminGetAdmin(userID) {
            var req = {
                method: 'GET',
                url: baseUrl + '/v2/admin/admins/' + userID + '/any_status',
                headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + JWTService.getToken() }
            };
            return $http(req).then(function (response) {
                return response;
            }, function (response) {
                logOut();
            });
        }
        
        function adminCreateAdmin(admin) {
            var req = {
                method: 'POST',
                url: baseUrl + '/v2/admin',
                data: admin,
                headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer '+ JWTService.getToken() }
            };

            return $http(req)
                .then(function (response) {
                    if (angular.isObject(response.data)) {
                        if (response) {
                            return response;
                        }
                        else {
                            return $q.reject(response);
                        }
                    } else {
                        return $q.reject(response);
                    }
                }, function (response) {
                    return (response);
                });
        }
        
        function adminUpdateAdmin(userID, admin) {
            var req = {
                method: 'PUT',
                url: baseUrl + '/v2/admin/admins/' + userID,
                data: admin,
                headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + JWTService.getToken() }
            };
            return $http(req).then(function (response) {
                return response;
            }, function (response) {
                return response;
            });
        }
        
        function adminDisableAdmin(userID) {
            return $http({
                method: 'POST',
                url: baseUrl + '/v2/admin/admins/' + userID + '/disable_admin',
                headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + JWTService.getToken() },
                data: {}
            }).then(
                function success(response) {
                    return response;
                },
                function error(response) {
                    return response;
                });
        }
        
        function adminEnableAdmin(userID) {
            return $http({
                method: 'POST',
                url: baseUrl + '/v2/admin/admins/' + userID + '/enable_admin',
                headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + JWTService.getToken() },
                data: {}
            }).then(
                function success(response) {
                    return response;
                },
                function error(response) {
                    return response;
                });
        }
        
        function adminDeleteAdmin(userID) {
            return $http({
                method: 'POST',
                url: baseUrl + '/v2/admin/admins/' + userID + '/soft_delete_admin',
                headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + JWTService.getToken() },
                data: {}
            }).then(
                function success(response) {
                    return response;
                },
                function error(response) {
                    return response;
                });
        }

        function getAdminStats() {
            var req = {
                method: 'GET',
                url: baseUrl + '/v2/admin/stats',
                headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + JWTService.getToken() }
            };
            return $http(req).then(function (response) {
                return response;
            });
        }

        function getAdminList() {
            var req = {
                method: 'GET',
                url: baseUrl + '/v2/admin/list',
                headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + JWTService.getToken() }
            };
            return $http(req).then(function (response) {
                return response;
            });
        }

        // returns { signupCode: string, signupCodeExpires: date } or { error: string } for the currently logged in admin
        function getAdminSignupCode() {
            var req = {
                method: 'GET',
                url: baseUrl + '/v2/admin/signupcode',
                headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + JWTService.getToken() }
            };
            return $http(req).then(function (response) {
                var result = {
                    signupCode: '',
                    signupCodeExpires: new Date(0)
                };
                if (angular.isObject(response.data) && !response.data.error) {
                    result = {
                        signupCode: response.data.signupCode,
                        signupCodeExpires: response.data.signupCodeExpires,
                    };
                }
                // console.log("resolving: " + JSON.stringify(result));
                return $q.resolve(result);
            });
        }

        return {
            register: register,
            login: login,
            getAdmin: getAdmin,
            logOut: logOut,
            getAdmins: getAdmins,
            adminGetAdmin: adminGetAdmin,
            adminCreateAdmin: adminCreateAdmin,
            adminUpdateAdmin: adminUpdateAdmin,
            adminDisableAdmin: adminDisableAdmin,
            adminEnableAdmin: adminEnableAdmin,
            adminDeleteAdmin: adminDeleteAdmin,
            getAdminStats: getAdminStats,
            getAdminList: getAdminList,
            getAdminSignupCode: getAdminSignupCode
        };
    }
})();

(function () {
  'use strict';
  
  angular
  .module('intryFrontEnd')
  .controller('FreeTrialController', FreeTrialController);
  
  function FreeTrialController($scope) {
    $scope.closeModal = function() {
      $scope.closeThisDialog();
    };
  }
})();
(function () {
    'use strict';

    angular
        .module('intryFrontEnd')
        .controller('DashboardController', DashboardController);

    /** @ngInject */
    function DashboardController($scope, $localStorage, $stateParams, modalService, userService, user, $state, StripeElements, ngDialog, utilsService, resumeValidation, organizationService) {
        $scope.showPaywall = function () {
            $localStorage.toSubscriptionFrom = "dashboard";
            $state.go('subscription');
        };
        
        if (!$localStorage.freeTrial && !$localStorage.premiumAccess) {
            // $state.go('register');
            // $scope.showPaywall();
        }

        $scope.user = user;
        $scope.verificationStatus = $stateParams.accountVerificationStatus;
        $scope.emailVerificationStatus = $stateParams.changeEmailVerificationStatus;

        $scope.emailConfirmationMessage = function() {
            return $scope.emailVerificationStatus || "";
        };

        $scope.showEmailConfirmationMessage = function() {
            if ($scope.emailVerificationStatus) {
                return 'email-confirmation';
            } else {
                return 'email-confirmation no-show';
            }
        };

        $scope.closeEmailConfirmationMessage = function(){
            $scope.emailVerificationStatus = false;
       };

        $scope.$ctrl = this;
        var elements = StripeElements.elements();
        var element = elements.create('card', {});

        $scope.element = element;
        this.element = element;

        var showOnboardingModal = function () {
            modalService.openModal(
                'app/onboarding/template/onboarding.html',
                'OnboardingController', {
                    user: function () {
                        return userService.getUser();
                    }
                },
                {
                    className: 'new-ngdialog'
                }
            ).then(function (response) {
                $scope.user = response;
            });
        };

        var showFreeTrialModal = function () {
            $scope.scrimPageBackground = true;
            modalService.openModal(
                'app/free-trial/template/free-trial.html',
                'FreeTrialController',
                {},
                {
                    className: 'dummy-dialog'
                }
            ).then(function () {
                $scope.scrimPageBackground = false;
                $localStorage.enabledFreeTrial = false;
            }, function () {
                $scope.scrimPageBackground = false;
                $localStorage.enabledFreeTrial = false;
            });
        };

        var showResumeInvalid = function() {
            $scope.scrimPageBackground = true;
            modalService.openModal(
                'app/resumes/template/validation-error-dialog.html',
                'resumeValidationController'
            ).finally(function () {
                $scope.scrimPageBackground = false;
            });
        };

        if (!$localStorage.showOnBoarding) {
            $localStorage.showOnBoarding = {};
        }

        if ($localStorage.enabledFreeTrial) {
            showFreeTrialModal();
        }
        if ($localStorage.showOnBoarding[user.userID]) {
            $localStorage.showOnBoarding[user.userID] = false;
            showOnboardingModal();
        }
        $scope.showProfileModal = function () {
            //go to user-profile
            $state.go('user-profile');
        };

        $scope.closeWaitingDialog = function () {
            ngDialog.close();
            userService.logOut();
        };
        $scope.subscriptionAvailable = function () {
            var premiumAccess = $localStorage.premiumAccess;
            var freeTrial = $localStorage.freeTrial;
            return !premiumAccess || freeTrial;
        };
        $scope.isFreeTrial = function () {
            return $localStorage.freeTrial;
        };

        $scope.openCreateResume = function ($event) {
            if (checkResumeDownloadCounter()) {
                $event.preventDefault();
                var userProfile = utilsService.checkUserProfile(user);
                var error = resumeValidation.isValid(userProfile);
                var stateParams = {};

                if (!(error && error.errString.length)) {
                    if (checkUserPayment()) {
                        stateParams.job2resume = true;

                        if (utilsService.getResumeId(user.userID)) {
                            stateParams.resumeId = utilsService.getResumeId(user.userID);
                        } else {
                            stateParams.new = true;
                        }
                        $state.go('resume-profile', stateParams);
                    } else {
                        localStorage.setItem("toSubscriptionFrom", "dashboard");
                        $state.go('subscription');
                    }


                } else {
                    showResumeInvalid();
                }
            }
        };
        
        function checkUserPayment() {
            return userService.isPaidFeatureEnabled($scope.user, 'job2resume');
        }

        // if (($localStorage.user.subscriptions && $localStorage.user.subscriptions.data.length > 0) || $localStorage.freeTrial) {
        //     var expires = $localStorage.freeTrial ? moment($localStorage.user.paid_features.free_trial_expire) :
        //         moment($localStorage.user.subscriptions.data[0].current_period_end * 1000);
        //     $('#downleft')[0].innerText = 'Unlimited';
        //     $('#assess')[0].innerText = 'Yes';
        //     $('#job2')[0].innerText = 'Yes';
        //     $('#expiresOn')[0].innerText = expires.format('MM/DD/YYYY');
        // } else if ($localStorage.user.paid_features) {
        //     var f = $localStorage.user.paid_features;
        //     $('#downleft')[0].innerText = f.downloads;
        //     $('#assess')[0].innerText = f.assessment === true ? 'Yes' : 'No';
        //     $('#job2')[0].innerText = f.job2resume === true ? 'Yes' : 'No';
        //     $('#expiresOn')[0].innerText = moment(f.bundle_expires).format('MM/DD/YYYY');
        // }
        
        // #region LogRocket Code.
        // var logRocketIdentify = function (user) {
        //     try {
        //         if (typeof user === 'object' && typeof user.userID === 'string') {
        //             LogRocket.identify(user.userID, {
        //                 userID: user.userID,
        //                 username: user.username,
        //                 email: user.username,
        //                 first_name: user.first_name,
        //                 last_name: user.last_name,
        //                 name: user.full_name,
        //                 stripe_customerID: user.stripe_customerID,
        //                 hostname: location.hostname
        //             });
        //         }
        //     } catch (e) {
        //         console.error('-- DashboardController.logRocketIdentify() - Exception: ', e);
        //     }
        // };
        // logRocketIdentify(user);
        // #endregion LogRocket Code.
        
        // #region White Label Code.
        $scope.hasOrganization = function() {
            return organizationService.hasOrganization();
        };

        $scope.getOrganizationCss = function(css, returnEmpty) {
            return organizationService.getOrganizationCss(css, returnEmpty);
        };

        $scope.getOrganizationKey = function() {
            return organizationService.getOrganizationKey();
        };

        $scope.getOrganizationName = function() {
            return organizationService.getOrganizationName();
        };

        $scope.goToHome = function () {
            $state.go('dashboard');
        };
        // #endregion White Label Code.

        // #region Resume Download Counter.
        var checkResumeDownloadCounter = function () {
            var cv = getCounterVars();

            if (cv.resumeCounter === 0) {
                showUnavailableResumesDialog();

                return false;
            } else {
                return true;
            }
        };

        var getCounterVars = function () {
            var resumeCounter = 0;

            if (
                typeof $localStorage.user !== 'undefined' && $localStorage.user !== null &&
                    typeof $localStorage.user.resumeCounter !== 'undefined' && $localStorage.user.resumeCounter !== null
            ) {
                resumeCounter = $localStorage.user.resumeCounter;
            }

            var cv = {
                resumeCounter: resumeCounter
            };

            return cv;
        };

        var showUnavailableResumesDialog = function () {
            var dialog = {
                template: 'app/resume-builder/template/unavailable-resumes-dialog.html',
                controller: this,
                closeByDocument: false,
                closeByEscape: true,
                showClose: false,
                closeByNavigation: true,
                scope: $scope,
                width: '425px',
                height: '255px'
            };
            ngDialog.openConfirm(dialog);
        };

        $scope.closeConfirmSaveDialog = function () {
            ngDialog.close();
        };

        $scope.showPaywall = function () {
            localStorage.setItem("toSubscriptionFrom", "dashboard");
            $state.go('subscription');
        };
        // #endregion Resume Download Counter.
    }
})();

(function() {
	'use strict';

	angular
		.module('intryFrontEnd')
		.filter('capitalize', CapitalizeFilter);
	/**
	 * This filter capitalizes a given string
	 */
	function CapitalizeFilter() {
		return function(input) {
			return (!!input) ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '';
		}
	}
})();
(function() {
    angular
        .module('validation.rule', ['validation'])
        .config(config);

    function config($validationProvider) {
        var expression = {
            required: function(value) {
                return !!value;
            },
            // url: new RegExp('_^(?:(?:https?|ftp)://)(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]+-?)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]+-?)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:/[^\s]*)?$_iuS'),
            // url: /((https?:\/\/)?(?:www\.|(?!www)\/\/)?[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9]\.[^\s]{2,})/            ,
            url : /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/,
            email: /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/,
            password: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,}$/,
            number: /^\d+$/,
            phonenumber: /\D*([2-9]\d{2})(\D*)([0-9]\d{2})(\D*)(\d{4})\D*/,
            minlength: function(value, scope, element, attrs, param) {
                return value.length >= param;
            },
            maxlength: function(value, scope, element, attrs, param) {
                return value.length <= param;
            },
            requirednomsg: function(value) {
                return !!value;
            }
        };

        var defaultMsg = {
            required: {
                error: 'required'
            },
            url: {
                error: 'Please enter valid Url'
            },
            email: {
                error: 'Please enter valid Email '
            },
            password: {
                error: 'Minimum 8 characters atleast 1 Alphabet, 1 Number and 1 Special Character '
            },
            number: {
                error: 'Please enter valid Number'
            },
            phonenumber: {
                error: 'Please enter valid Phone Number'
            },
            minlength: {
                error: 'This should be longer'
            },
            maxlength: {
                error: 'This should be shorter'
            },
            requirednomsg: {
                error: ''
            }
        };
        $validationProvider.setExpression(expression).setDefaultMsg(defaultMsg);
    }
}).call(this);

(function () {
  'use strict';
  
  angular
    .module('intryFrontEnd')
    .service('resumeValidation', ResumeValidation);

    /** @ngInject */
  function ResumeValidation() {
    
      function isValid(userProfile){
        userProfile.educationListError = [];
        userProfile.experienceListError = [];
        var errString = '';
        var divId = '';
        var localEducation = _.filter(userProfile.educationList, {deleted: false});
        var localExperience = _.filter(userProfile.experienceList, {deleted: false});
        if (localEducation.length > 0 || localExperience.length > 0 || userProfile.summary) {
          return {errString : '', divId: ''};
          // Not additional validation is needed because, the fixService check all the items before save the information in the profile.
          // So this function only need to check that user have Education or Experiences or Skills with deleted false.
          /*
          localEducation.every(function (element, key) {
            if(!element.deleted){
              divId = 'eductionDiv_' + key;
              if (!element.degree || !element.degree.trim().length) {
                userProfile.educationListError[key] = { degree: true };
                errString =  "Please enter degree title in education.";
                return false;
              } else if (!element.institution || (!element.institution.trim().length)) {
                userProfile.educationListError[key] = { institution: true };
                errString =  "Please enter institution in education.";
                return false;
              } else if (!element.kind) {
                userProfile.educationListError[key] = { kind: true };
                errString =  "Please select kind in education.";
                return false;
              } else if(element.endDateObj) {
                element.is_current = false;
                errString =  element.startDateObj ? compareDate(element.startDateObj, element.endDateObj) : '';
                if(errString) {
                  userProfile.educationListError[key] = {startDateObj:true, endDateObj:true};
                  return false;
                } else  {
                  return true;
                }
              } else{
                element.is_current = !element.endDateObj || !element.endDateObj.trim().length;
                return true;
              }
            } else {
              return true;
            }
          });
          if(!errString) {
            localExperience.every(function (element, key) {
              if(!element.deleted){
                divId = 'experienceDiv_' + key;
                if (!element.title || (!element.title.trim().length)) {
                  userProfile.experienceListError[key] = {title:true};
                  errString = "Please enter job title in experience.";
                  return false;
                } else if (!element.company || !element.company.trim().length) {
                  userProfile.experienceListError[key] = { company: true };
                  errString =  "Please enter company in experience.";
                  return false;
                } else if (!element.startDateObj || (!element.startDateObj.trim().length)) {
                  userProfile.experienceListError[key] = { startDateObj: true };
                  errString =  "Please enter valid start date in experience.";
                  return false;
                } else if (!element.kind) {
                  userProfile.experienceListError[key] = { kind: true };
                  errString =  "Please select kind in experience.";
                  return false;
                } else if(element.endDateObj) {
                  element.is_current = false;
                  errString = compareDate(element.startDateObj, element.endDateObj);
                  if(errString) {
                    userProfile.experienceListError[key] = {startDateObj:true, endDateObj:true};
                    return false;
                  } else  {
                    return true;
                  }
                } else {
                  element.is_current = !element.endDateObj || !element.endDateObj.trim().length
                  return true;
                }
              } else {
                return true;
              }
            })
          }
          */
        } else {
          errString = "There is no education, experience or summary registered.";
        }
        return {errString : errString, divId:divId};
      }

      function compareDate(selectedStartDate, selectedEndDate) {
        var startDate = new Date(selectedStartDate);
        var endDate = new Date(selectedEndDate);
        if (endDate < startDate)
          return 'End Date Should be greater then start date.';
        else
          return '';
      }

      return {
        isValid: isValid
      }
  }
})();
(function () {
    'use strict';
    
    angular
      .module('intryFrontEnd')
      .service('phoneFormatter', phoneFormatter);
  
      /** @ngInject */
    function phoneFormatter() {
      
        function format(phoneVal){
          var phone = phoneVal;
          if (phone) {
            phone = flatten(phone);
            var m = phone.match(/^(\d{3})(\d{3})(\d{4})$/);
            var phn = (!m) ? null : m[1] + "." + m[2] + "." + m[3];   
            phoneVal = phn;
            return phn;
          }
          return phone;        
        }
        function flatten(phoneVal) {
          var phone = phoneVal;
          if (phone) {
            phone = phone.replace(/[\-\ \.\!\@\$\%\^\(\)\_\+\=\?\{\}\[\]\|\\]/g, "");
            phone = phone.replace(/\s/g,'');
            phoneVal = phone;
          }
          return phone;
        }
  
        return {
          format: format,
          flatten: flatten
        }
    }
  })();
(function () {
    'use strict';

    angular
        .module('intryFrontEnd')
        .controller('ChangeEmailController', ChangeEmailController);

    function ChangeEmailController($localStorage, $stateParams, modalService, userService, JWTService, $state) {
        var token = $stateParams.token;
        var username = $stateParams.username;

        if (token && username) {
            if (JWTService.getToken()) {
                userService.getUser().then(function (response) {
                    var loginUsername = response.username;
                    userService.confirmNewEmail(token, username).then(function (response) {
                        $state.go('dashboard', { changeEmailVerificationStatus: response.data.message });
                    }).catch(function (err) {
                        $state.go('dashboard', { changeEmailVerificationStatus: err.data.message });
                    });
                }).catch(function (err) {
                    $state.go('dashboard');
                });
            } else {
                userService.confirmNewEmail(token, username).then(function (response) {
                    $state.go('login', { changeEmailVerificationStatus: response.data.message });
                }).catch(function (err) {
                    $state.go('login', { changeEmailVerificationStatus: err.data.message });
                });
            }
        } else {
            $state.go('dashboard');
        }
    }
})();

(function () {
  'use strict';
  
  angular
    .module('intryFrontEnd')
    .controller('AccountVerificationController', AccountVerificationController);
  
  /** @ngInject */
  function AccountVerificationController($localStorage, $stateParams, modalService, userService, JWTService, $state) {
    
    var token = $stateParams.token;
    var username = $stateParams.login;
    if (token && username) {
      if (JWTService.getToken()) {
        userService.getUser().then(function (response){
          var loginUsername = response.username;
          if (loginUsername === username) {
            userService.verifyAccount(token, username).then(function (response) {
              // after account verification we are doing a force refresh so that user's account status get refreshed, otherwise it will show the previous account status only
              userService.getUser(true).then(function() {
                $state.go('dashboard', {accountVerificationStatus: response.data.message});
              }).catch(function() {
                $state.go('dashboard', {accountVerificationStatus: response.data.message});
              });
            }).catch(function(err) {
              $state.go('dashboard', {accountVerificationStatus: err.data.message});
            });
          } else {
            $state.go('dashboard', {accountVerificationStatus: 'The token is not valid.'});
          }
        }).catch(function(err){
          $state.go('dashboard');
        });
      } else {
        userService.verifyAccount(token, username).then(function (response) {
          $state.go('login', {accountVerificationStatus: response.data.message});
        }).catch(function (err) {
          $state.go('login', {accountVerificationStatus: err.data.message});
        });
      }
    } else {
      $state.go('dashboard');
    }
  }
})();

/* global Chart */
(function () {
    'use strict';

    angular
        .module('intryFrontEnd')
        .controller('AssessmentsController', AssessmentsController);

    /** @ngInject */

    function AssessmentsController($scope, user, organizationService, $state) {
        $scope.user = user;
    
        // #region White Label Code.
        $scope.hasOrganization = function() {
            return organizationService.hasOrganization();
        };

        $scope.getOrganizationCss = function(css, returnEmpty) {
            return organizationService.getOrganizationCss(css, returnEmpty);
        };

        $scope.getOrganizationKey = function() {
            return organizationService.getOrganizationKey();
        };

        $scope.getOrganizationName = function() {
            return organizationService.getOrganizationName();
        };

        $scope.goToHome = function () {
            $state.go('dashboard');
        };
        // #endregion White Label Code.
    }
})();

/* global Chart */
(function () {
    'use strict';

    angular
        .module('intryFrontEnd')
        .component('assessmentsResults', {
            templateUrl: 'app/assessments/template/assessments.html',
            controller: AssessmentsResultsController,
            controllerAs: 'vm',
            bindings: {
                wizard: '<',
                user: '='
            }
        });

    /** @ngInject */
    function AssessmentsResultsController($scope, $q, modalService, assessmentsService, userService, constants, ngDialog, $state, StripeElements, $translate,$location, $rootScope, organizationService) {
        var self = this;

        var ASSESSMENT_CAREER_ID = 'career-deck';
        var ASSESSMENT_BIG_FIVE_ID = 'big-five';

        $scope.user = this.user;
        $scope.startAssessment = $state.params && $state.params.startAssessment ? $state.params.startAssessment : false;
        $scope.assessmentsStatus = {};
        $scope.assessmentData = {
            archetype: '',
            description: '',
            details: {
                complement: '',
                conflict: '',
                environments: []
            },
            mainTypes: [],
            types: [
                {score: 100, name: 'Inventor', image: 'https://cdn.traitify.com/badges/44b2f6e8-62de-40cf-8510-648b49ccc210_small', color: ''},
                {score: 100, name: 'Mentor', image: 'https://cdn.traitify.com/badges/bd5e1c4f-5e26-4489-b657-684773ffa718_small', color: ''},
                {score: 100, name: 'Planner', image: 'https://cdn.traitify.com/badges/a022262f-1f57-4cf4-ad18-f181ef13e639_small', color: ''},
                {score: 100, name: 'Visionary', image: 'https://cdn.traitify.com/badges/af0ffccd-5f78-4f7a-aa4b-e630425d51cd_small', color: ''},
                {score: 100, name: 'Analyser', image: 'https://cdn.traitify.com/badges/ad738189-7a37-4e7d-a684-4bcfaa9632ea_small', color: ''},
                {score: 100, name: 'Naturalist', image: 'https://cdn.traitify.com/badges/71c77fb8-262a-4df0-a5fa-fdf95f152268_small', color: ''},
                {score: 100, name: 'Action-Taker', image: 'https://cdn.traitify.com/badges/e6a1ac7b-9576-419b-a06d-4af2b8054b70_small', color: ''}
            ],
            traits: []
        };
        $scope.getTypeBarStyle = function (type) {
            var styles = {
                width: type.score + '%'
            };
            if ($scope.assessmentsStatus.hasUserTakenBothAssessments) {
                if (!!navigator.userAgent.match(/Trident\/7\./)) {
                    styles.background = '#' + type.color + ' -ms-linear-gradient(left, rgba(255, 255, 255, .5), rgba(0, 0, 0, .2))';
                    styles.filter = 'filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\'rgba(255, 255, 255, .5)\', endColorstr=\'rgba(0, 0, 0, .2)\',GradientType=0 );'
                } else {
                    styles.background = '#' + type.color + ' -webkit-linear-gradient(left, rgba(255, 255, 255, .5), rgba(0, 0, 0, .2))';
                }
            } else {
                styles.border = '#eee 1px solid';
            }
            return styles;
        };
        var mapType = function (type) {
            return {
                score: type.score,
                name: type['personality_type'].name,
                image: type['personality_type']['badge']['image_small'],
                color: type['personality_type']['badge']['color_1']
            };
        };
        var mapTraits = function (trait) {
            return {
                score: trait.score,
                name: trait['personality_trait'].name
            };
        };
        var setRadarChart = function (elementId, data) {
            var context = document.getElementById(elementId).getContext('2d');
            var gradient = context.createLinearGradient(229, 229, 229, .4);
            gradient.addColorStop(0, "rgba(84, 189, 176, .4)");
            gradient.addColorStop(1, "rgba(84, 189, 176, .4)");
            new Chart(context, {
                type: 'radar',
                data: data.reduce(function (obj, item) {
                    obj.labels.push(item.name);
                    obj.datasets[0].data.push(item.score);
                    return obj;
                }, {
                    labels: [],
                    datasets: [{
                        data: [],
                        backgroundColor: gradient,
                        radius: 0
                    }]
                }),
                options: {
                    legend: {
                        display: false
                    },
                    tooltips: {
                        enabled: false
                    },
                    scale: {
                        angleLines: {
                            color: 'rgba(0, 0, 0, 0.10)',
                            lineWidth: 1,
                        },
                        pointLabels: {
                            fontColor: 'rgba(0, 0, 0, 0.5)',
                            fontFamily: '"Open Sans", sans-serif',
                        },
                        ticks: {
                            beginAtZero: true,
                            display: false,
                            maxTicksLimit: 5,
                        }
                    }
                }
            });
        };
        var showAssessmentResultsToUser = function () {
            $scope.assessmentData = {};
            var big5Id = getUserAssessment(ASSESSMENT_BIG_FIVE_ID).assessmentId;
            var careerId = getUserAssessment(ASSESSMENT_CAREER_ID).assessmentId;
            var big5Required = ['types', 'archetype'];
            var careerRequired = ['blend', 'types', 'traits', 'career_matches'];
            var imagePack = 'linear';
            $q.all([
                assessmentsService.getResults(big5Id, big5Required, imagePack),
                assessmentsService.getResults(careerId, careerRequired, imagePack)
            ]).then(function (traitifyData) {
                // console.log("-- (Controller) AssessmentsResultsController.showAssessmentResultsToUser() - traitifyData: ", traitifyData);
                
                if (traitifyData[0] && traitifyData[1]) {
                    var archetype = '';
                    var complement = '';
                    var conflict = '';
                    var environments = [];

                    try {
                        if ((traitifyData[0].data['archetype'])) {
                            var arch = traitifyData[0].data['archetype'];
                            archetype = arch['name'];

                            complement = (
                                arch['details'].find(function (el) {
                                    return el.title === 'Complement';
                                }) || {}
                            ).body;

                            conflict = (
                                arch['details'].find(function (el) {
                                    return el.title === 'Conflict';
                                }) || {}
                            ).body;

                            environments = arch['environments'].map(function (el) {
                                return el.name;
                            });
                        }
                    } catch (e) {
                        console.error("-- (Controller) AssessmentsResultsController.showAssessmentResultsToUser() - e: ", e);
                    }

                    // console.log("-- (Controller) AssessmentsResultsController.showAssessmentResultsToUser() - archetype: ", archetype);
                    // console.log("-- (Controller) AssessmentsResultsController.showAssessmentResultsToUser() - complement: ", complement);
                    // console.log("-- (Controller) AssessmentsResultsController.showAssessmentResultsToUser() - conflict: ", conflict);
                    // console.log("-- (Controller) AssessmentsResultsController.showAssessmentResultsToUser() - environments: ", environments);

                    $scope.assessmentData = {
                        archetype: archetype,
                        description: traitifyData[1].data['personality_blend'] ? traitifyData[1].data['personality_blend']['description'] : '',
                        details: {
                            complement: complement,
                            conflict: conflict,
                            environments: environments
                        },
                        mainTypes: traitifyData[0].data['personality_types'].map(mapType),
                        types: traitifyData[1].data['personality_types'].map(mapType),
                        traits: traitifyData[1].data['personality_traits'].slice(0, 20).map(mapTraits)
                    };

                    var ulElementsCount=0;
                    $scope.environmentsResult=[];
                    var tempEnvironmentsResult=[];
                    var filteredResults = $scope.assessmentData.details.environments;
                    angular.forEach(filteredResults, function (value, key) {
                        ulElementsCount++;
                        tempEnvironmentsResult.push(value);
                        if(ulElementsCount==Math.ceil($scope.assessmentData.details.environments.length/2)){ $scope.environmentsResult.push(tempEnvironmentsResult); tempEnvironmentsResult=[]; ulElementsCount=0;}
                        if(filteredResults.length-1==filteredResults.indexOf(value)){ $scope.environmentsResult.push(tempEnvironmentsResult); tempEnvironmentsResult=[]; ulElementsCount=0;}
                    });
                    
                    setRadarChart('assessment-radar-canvas', $scope.assessmentData.mainTypes);
                }
            }).catch(function (error) {
                console.error(error);
            });
        };

        var getUserAssessment = function (assessmentDeckId) {
            // console.log("-- (Controller) AssessmentsResultsController.getUserAssessment() - assessmentDeckId: ", assessmentDeckId);
            // console.log("-- (Controller) AssessmentsResultsController.getUserAssessment() - $scope.user.assessments: ", $scope.user.assessments);
            
            if ($scope.user && $scope.user.assessments) {
                for (var i = 0; i < $scope.user.assessments.length; i += 1) {
                    if ($scope.user.assessments[i].assessmentId && $scope.user.assessments[i].deck_id === assessmentDeckId) {
                        return $scope.user.assessments[i];
                    }
                }
            }
            return null;
        };

        var showAssessment = function (assessmentIds) {
            return modalService.openModal(
                'app/assessments/template/assessmentSlides.html',
                "AssessmentSlidesController", {
                    assessmentIds: function () {
                        return assessmentIds;
                    }
                }, {
                    width: '100%',
                    height: 'auto'
                }
            );
        };

        var saveAssessment = function (response) {
            var promises = [];
            var assessmentIds = [];
            for (var assessmentId in response) {
                if (response.hasOwnProperty(assessmentId)) {
                    assessmentIds.push(assessmentId);
                    promises.push(assessmentsService.addSlides(assessmentId, response[assessmentId]));
                }
            }

            return $q.all(promises).then(function () {

                var resultPromises = [];
                for (var i = 0; i < assessmentIds.length; i += 1) {
                    resultPromises.push(assessmentsService.getResults(assessmentIds[i]));
                }

                return $q.all(resultPromises).then(function (results) {
                    var assessments = [];
                    for (var i = 0; i < results.length; i += 1) {
                        results[i].data.assessmentId = results[i].data.id;
                        assessments.push(results[i].data);
                    }

                    return userService.addAssessmentResultToUser({
                        assessments: assessments
                    }).then(function (response) {
                        $scope.user = response;
                        setScopeAssessmentsStatusProperties();
                        if ($scope.assessmentsStatus.hasUserTakenBothAssessments) {
                            showAssessmentResultsToUser();
                        }
                    });
                }, function (err) {
                    $scope.errorMessage = err.data.message;
                    $scope.showErrorMessage = true;
                });
            }, function (err) {
                $scope.errorMessage = err.data.message;
                $scope.showErrorMessage = true;
            });
        };
        $scope.printDiv=function() {
            var canvas = document.getElementById('assessment-radar-canvas')
            var img    = canvas.toDataURL('image/png')
            var newElement = document.createElement('img');
            newElement.src = img
            canvas.replaceWith(newElement)
            var divContents = document.getElementById("assessment-results").innerHTML;
            var a = window.open('', '', 'height=500, width=500');
            a.document.write('<html><head><title></title>');
            
            
            a.document.write('<link rel="stylesheet" href="/app/assessments/template/assessments.scss" type="text/css" />');
            a.document.write('<link rel="stylesheet" href="/app/assessments/template/assessments.scss" type="text/css" />');
            a.document.write('</head><style>.col-lg-6{width:50%;}.assesment-tags{width:fit-content;font-family: "Montserrat", sans-serif;}.flex-wrap{display: flex;flex-direction: row;flex-wrap: wrap;} img{width:45vw;} p{font-family: "Montserrat", sans-serif;} .assement-section-title{font-family: "Montserrat", sans-serif;}.item-text{font-family: "Montserrat", sans-serif;}.assesment-bottom-content{display:flex;flex-direction:row;}.categort-title{font-family: "Montserrat", sans-serif;}.assesment-title{font-family: "Montserrat", sans-serif;}</style><body >');
            
            
            a.document.write(divContents);
            a.document.write('</body></html>');
            a.document.close();
            setTimeout(function () {
                a.print();
            }, 1000);
        }
        var setScopeAssessmentsStatusProperties = function () {
            $scope.assessmentsStatus.hasUserTakenCareerAssessment = getUserAssessment(ASSESSMENT_CAREER_ID) !== null;
            $scope.assessmentsStatus.hasUserTakenBig5Assessment = getUserAssessment(ASSESSMENT_BIG_FIVE_ID) !== null;
            $scope.assessmentsStatus.hasUserTakenBothAssessments = ($scope.assessmentsStatus.hasUserTakenCareerAssessment && $scope.assessmentsStatus.hasUserTakenBig5Assessment);
        };

        setScopeAssessmentsStatusProperties();

        if ($scope.assessmentsStatus.hasUserTakenBothAssessments) {
            showAssessmentResultsToUser();
        }

        $scope.checkUserPayment = function () {
            return userService.isPaidFeatureEnabled($scope.user, 'assessment');
        };
        $scope.createResume = function() {
            $state.go('resumes');
        }

        $scope.beginAssessment = function () {
            /*
              if ($scope.checkUserPayment()) {
              self.setWarningMsg();
              
              $scope.scrimPageBackground = true;
              var assessmentsDeckId = [];

              if (!$scope.assessmentsStatus.hasUserTakenCareerAssessment) {
              assessmentsDeckId.push(ASSESSMENT_CAREER_ID);
              }
              if (!$scope.assessmentsStatus.hasUserTakenBig5Assessment) {
              assessmentsDeckId.push(ASSESSMENT_BIG_FIVE_ID);
              }
              $rootScope.assessmentIds = assessmentsDeckId;

              if (self.wizard && self.wizard.isWizard) {
              self.wizard.goToAssessmentStep(2);
              } else {
              $location.path('assessmentSlides');
              }
              } else {
              localStorage.setItem("toSubscriptionFrom", "assessmentSlides");
              $location.path("subscription");
              }
            */
            self.setWarningMsg();

            $scope.scrimPageBackground = true;
            var assessmentsDeckId = [];

            if (!$scope.assessmentsStatus.hasUserTakenCareerAssessment) {
                assessmentsDeckId.push(ASSESSMENT_CAREER_ID);
            }
            if (!$scope.assessmentsStatus.hasUserTakenBig5Assessment) {
                assessmentsDeckId.push(ASSESSMENT_BIG_FIVE_ID);
            }
            $rootScope.assessmentIds = assessmentsDeckId;

            if (self.wizard && self.wizard.isWizard) {
                self.wizard.goToAssessmentStep(2);
            } else {
                $location.path('assessmentSlides');
            }
        };
        
        self.beginAssessment = $scope.beginAssessment;

        $scope.confirmationModal = function () {
            var dialog = {
                templateUrl: 'app/assessments/template/assessmentConfirmation.html',
                scope: $scope,
                showClose: false,
                width: '762px',
                height: '455px'
            };
            ngDialog.openConfirm(dialog)
        };

        $scope.paymentRequired = false;
        $scope.paymentSuccess = function (updatedUser, closed) {
            $scope.paymentRequired = false;      
            if(updatedUser != null){
                $scope.user = updatedUser;
                if(!closed)
                    $scope.beginAssessment();
            }
        };
        $scope.paymentError = function (error) {
        };

        if ($scope.startAssessment) {
            $scope.beginAssessment();
        }
        $scope.closeWaitingDialog = function () {
            ngDialog.close();
        }
        
        $scope.showEnvironments = function () {
            if (
                typeof $scope.assessmentData !== 'undefined' && $scope.assessmentData !== null &&
                    typeof $scope.assessmentData.details !== 'undefined' && $scope.assessmentData.details !== null &&
                    Array.isArray($scope.assessmentData.details.environments) &&
                    $scope.assessmentData.details.environments.length > 0
            ) {
                return true;
            } else {
                return false;
            }
        }
        
        // #region Warning Msg.
        self.setWarningMsg = function () {
            if (typeof self.wizard === 'object' && self.wizard !== null) {
                self.wizard.assessmentFinished = false;
            }
            setTimeout(function() {
                self.showWarningMsg();
            }, 300000);
        }
        
        self.showWarningMsg = function () {
            if (
                ($state.current.name === 'assesmentSlides') ||
                    ($state.current.name === 'wizard' && $state.params.step == 1 && !self.wizard.assessmentFinished)
            ) {
                $scope.scrimPageBackground = true;
                self.showWarningModal();
            }
        }
        
        self.showWarningModal = function () {
            return modalService.openModal(
                'app/assessments/template/assessment-warning-dialog.html',
                'AssessmentSlidesController'
            ).finally(function () {
                $scope.scrimPageBackground = false;
            });
        };
        // #endregion Warning Msg.

        // #region White Label Code.
        $scope.hasOrganization = function() {
            return organizationService.hasOrganization();
        };

        $scope.getOrganizationCss = function(css, returnEmpty) {
            return organizationService.getOrganizationCss(css, returnEmpty);
        };

        $scope.getOrganizationKey = function() {
            return organizationService.getOrganizationKey();
        };

        $scope.getOrganizationName = function() {
            return organizationService.getOrganizationName();
        };

        $scope.goToHome = function () {
            $state.go('dashboard');
        };
        // #endregion White Label Code.
    }
})();

(function () {
    'use strict';

    angular
        .module('intryFrontEnd')
        .controller('AssessmentSlidesController', AssessmentSlidesController);

    /** @ngInject */
    function AssessmentSlidesController($scope, $q, $timeout, userService, assessmentsService, $rootScope, $location, organizationService, $state) {
        var self = this;

        var ASSESSMENT_CAREER_ID = 'career-deck';
        var ASSESSMENT_BIG_FIVE_ID = 'big-five';
        $scope.assessmentsStatus = {};
        var assessmentIds = [];

        if ($rootScope.assessmentIds) {
            assessmentIds = $rootScope.assessmentIds;
        } else {
            if (!$scope.assessmentsStatus.hasUserTakenCareerAssessment) {
                assessmentIds.push(ASSESSMENT_CAREER_ID);
            }
            if (!$scope.assessmentsStatus.hasUserTakenBig5Assessment) {
                assessmentIds.push(ASSESSMENT_BIG_FIVE_ID);
            }
        }

        var currentAssessments = [];
        var currentAssessmentIndex = 0;

        var currentSlideIndex;
        var slideShownTimeStamp;
        var globalSlideIndex = 0;
        var totalNumSlides = 0;

        $scope.currentSlide = null;
        
        $scope.progressInPercentage = 0;
        
        var userSlideResponse = {};
        
        
        var incrementProgressBarBy1Slide = function () {
            globalSlideIndex += 1;
            if (totalNumSlides !== 0) {
                $scope.progressInPercentage = (globalSlideIndex/totalNumSlides)*100;
            }
        }
        var showSlideForCurrentAssessmentAtIndex = function(index) {
            incrementProgressBarBy1Slide();
            slideShownTimeStamp = (new Date()).getTime();
            currentSlideIndex = index;
            $scope.currentSlide = currentAssessments[currentAssessmentIndex].slides[currentSlideIndex];
            var img = $scope.currentSlide.image_desktop_retina;
            
            // Clear img src and wait for a second before we show next image
            $scope.currentSlide.image_desktop_retina = ' ';
            $timeout(function() {
                $scope.currentSlide.image_desktop_retina = img;
            }, 1);
        };
        
        var fetchAssessmentAtIndex = function (index, callback) {
            assessmentsService.createAssessment(assessmentIds[index]).then(function (assessmentResponse) {
                currentAssessments[index] = {};
                currentAssessments[index].data = assessmentResponse.data;
                assessmentsService.getSlides(currentAssessments[index].data.id).then(function (assessmentSlidesResponse) {
                    currentAssessments[index].slides = assessmentSlidesResponse.data;
                    if (currentAssessments[index].slides
                        && currentAssessments[index].slides.length > 0) {
                        totalNumSlides += currentAssessments[index].slides.length;
                    }
                    if (index < (assessmentIds.length - 1)) {
                        fetchAssessmentAtIndex((index + 1), callback);
                    } else {
                        callback(null);
                    }
                }).catch(function(err){
                    callback(err);
                });
            }).catch(function(err){
                callback(err);
            });
        };
        
        // Fetch all the assessments
        var fetchAllAssessment = function () {
            $scope.loadingAssessment = true;
            fetchAssessmentAtIndex(0, function (err)  {
                $scope.loadingAssessment = false;
                if (err) {
                    $scope.errorMessage = err.data.message;
                    $scope.showErrorMessage = true;
                } else {
                    beginAssessmentAtIndex(0);
                }
            });
        };
        
        var beginAssessmentAtIndex = function(index) {
            currentAssessmentIndex = index;
            showSlideForCurrentAssessmentAtIndex(0);
        };

        $scope.captureUserResponseForSlide = function (slide, response) {
            var userResponseTimeStamp = (new Date()).getTime();
            var userResponseTimeInMS = (userResponseTimeStamp - slideShownTimeStamp);

            var currentAssessmentId = currentAssessments[currentAssessmentIndex].data.id;
            if (!userSlideResponse[currentAssessmentId]) {
                userSlideResponse[currentAssessmentId] = [];
            }

            userSlideResponse[currentAssessmentId].push({
                id: slide.id,
                response: response,
                time_taken: userResponseTimeInMS
            });

            if (currentSlideIndex < currentAssessments[currentAssessmentIndex].slides.length - 1) {
                showSlideForCurrentAssessmentAtIndex((currentSlideIndex + 1));
            } else {
                if (currentAssessmentIndex < assessmentIds.length - 1) {
                    beginAssessmentAtIndex((currentAssessmentIndex + 1));
                } else {
                    // dismiss and pass userSlideResponse back to the caller
                    saveAssessment(userSlideResponse);
                }
            }
        };

        var saveAssessment = function (response) {
            if (typeof self.wizard === 'object' && self.wizard !== null) {
                self.wizard.assessmentFinished = true;
            }
            
            var promises = [];
            var assessmentIds = [];

            for (var assessmentId in response) {
                if (response.hasOwnProperty(assessmentId)) {
                    assessmentIds.push(assessmentId);
                    promises.push(assessmentsService.addSlides(assessmentId, response[assessmentId]));
                }
            }

            return $q.all(promises).then(function () {

                var resultPromises = [];
                for (var i = 0; i < assessmentIds.length; i += 1) {
                    resultPromises.push(assessmentsService.getResults(assessmentIds[i]));
                }

                return $q.all(resultPromises).then(function (results) {
                    var assessments = [];
                    for (var i = 0; i < results.length; i += 1) {
                        results[i].data.assessmentId = results[i].data.id;
                        assessments.push(results[i].data);
                    }

                    return userService.addAssessmentResultToUser({
                        assessments: assessments
                    }).then(function (response) {
                        $scope.user = response;
                        setScopeAssessmentsStatusProperties();

                        if ($scope.assessmentsStatus.hasUserTakenBothAssessments) {
                            showAssessmentResultsToUser();
                        }
                    });
                }, function (err) {
                    $scope.errorMessage = err.data.message;
                    $scope.showErrorMessage = true;
                });
            }, function (err) {
                $scope.errorMessage = err.data.message;
                $scope.showErrorMessage = true;
            });
        };

        var getUserAssessment = function (assessmentDeckId) {
            if ($scope.user && $scope.user.assessments) {
                for (var i = 0; i < $scope.user.assessments.length; i += 1) {
                    if ($scope.user.assessments[i].assessmentId && $scope.user.assessments[i].deck_id === assessmentDeckId) {
                        return $scope.user.assessments[i];
                    }
                }
            }
            return null;
        };

        var setScopeAssessmentsStatusProperties = function () {
            $scope.assessmentsStatus.hasUserTakenCareerAssessment = getUserAssessment(ASSESSMENT_CAREER_ID) !== null;
            $scope.assessmentsStatus.hasUserTakenBig5Assessment = getUserAssessment(ASSESSMENT_BIG_FIVE_ID) !== null;
            $scope.assessmentsStatus.hasUserTakenBothAssessments = ($scope.assessmentsStatus.hasUserTakenCareerAssessment && $scope.assessmentsStatus.hasUserTakenBig5Assessment);
        };

        var showAssessmentResultsToUser = function () {
            if (self.wizard && self.wizard.isWizard) {
                self.wizard.goToAssessmentStep(3);
            } else {
                $location.path('assessments');
            }
        };

        setScopeAssessmentsStatusProperties();
        fetchAllAssessment();

        // #region White Label Code.
        $scope.hasOrganization = function() {
            return organizationService.hasOrganization();
        };

        $scope.getOrganizationCss = function(css, returnEmpty) {
            return organizationService.getOrganizationCss(css, returnEmpty);
        };

        $scope.getOrganizationKey = function() {
            return organizationService.getOrganizationKey();
        };

        $scope.getOrganizationName = function() {
            return organizationService.getOrganizationName();
        };

        $scope.goToHome = function () {
            $state.go('dashboard');
        };
        // #endregion White Label Code.
    }
})();

(function () {
    'use strict';
    angular.module('intryFrontEnd').factory('httpJWTInjector', httpJWTInjector);
    function httpJWTInjector($q, $injector ) {
        return{
            request: function (config) {
                var JWTService = $injector.get('JWTService');
                var token = JWTService.getToken();
                if (token) {
                    config.headers['Authorization'] = token;
                    config.headers['Access-Control-Allow-Origin'] = '*';
                }
                // Return the config or wrap it in a promise if blank.
                return config || $q.when(config);
            }
        };
    }
})();

(function () {
  'use strict';

  angular
    .module('intryFrontEnd')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, $rootScope, $state, JWTService, $localStorage) {

    /**
     * On state change check if the user is authenticated, if not redirect to the login/home
     */
    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
      var redirect = function (state) {
        event.preventDefault();
        $state.go(state);
        return null;
      };
      if ($rootScope.toast != null) {
        if ($rootScope.toast.scope.close) {
          $rootScope.toast.scope.close();
        }
        $rootScope.toast = null;
      }

      // #region Set the user role in base of the state.
      var adminStates = [
        'admin-register',
        'admin-dashboard',
        'admin-users',
        'admin-create-user',
        'admin-user-details',
        'admin-admins',
        'admin-create-admin',
        'admin-profile',
        'admin-organizations',
        'admin-create-organization',
        'admin-utms',
        'admin-create-utm',
        'admin-tracks'
      ];
      if (adminStates.indexOf(toState.name) > -1) {
        localStorage.setItem('userRole', 'admin');
      } else {
        localStorage.setItem('userRole', 'user');
      }
      // #endregion Set the user role in base of the state.

      //If the user is not authenticated return him to the home
      var nonSecuredStates = [
        'login', 'reset-password', 'change-email', 'intry-agreement', 'privacy-policy', 'cookie-policy',
          'admin-register', 'confirm_email', 'confirm_account', 'register', 'job-search', 'job-alerts'
      ];
      var adminNonSecuredStates = ['admin-register'];
      if (
        JWTService.getRole() === 'user' &&
        nonSecuredStates.indexOf(toState.name) === -1 &&
        !JWTService.getToken() &&
        (
          !toState.data ||
          !toState.data.public
        )
      ) {
        return redirect('login');
      } else if (JWTService.getRole() === 'admin' && adminNonSecuredStates.indexOf(toState.name) === -1 && !JWTService.getToken()) {
        return redirect('admin-register');
      } else if (JWTService.getRole() === 'admin' && toState.name == 'admin-register' && JWTService.getToken()) {
        return redirect('admin-dashboard'); // When the url path is app/admin this redirect to  the admin dashboard.
      }

      //If already logged in then don't allow to go to the home, unless he logs out
      var onBoardingStates = ['login', 'admin-register'];
      if (
        (
          onBoardingStates.indexOf(toState.name) !== -1 &&
          JWTService.getToken()
        ) ||
        (
          toState.name === 'register' &&
          $localStorage.premiumAccess &&
          !$localStorage.freeTrial
        )
      ) {
        return redirect(fromState && fromState.name ? fromState.name : 'dashboard');
      }
    });
  }
})();

(function () {
    'use strict';

    angular
        .module('intryFrontEnd')
        .config(routerConfig);

    var maintenanceOn = false;
    
    /** @ngInject */
    function routerConfigNormal($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('login', {
                url: '/',
                templateUrl: 'app/login/template/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    showPasswordResetModal: function () {
                        return false;
                    }
                },
                params: {
                    accountVerificationStatus: '',
                    changeEmailVerificationStatus: ''
                }
            })
            .state('register', {
                url: '/register',
                templateUrl: 'app/register/template/register.html',
                controller: 'RegisterController',
                controllerAs: 'vm',
                params: {
                    shareASale: /.*(([?]|[&])sscid=.+)/.test(location.search || ''),
                    accountVerificationStatus: '',
                    changeEmailVerificationStatus: ''
                }
            })
            .state('dashboard', {
                url: '/dashboard',
                templateUrl: 'app/dashboard/template/dashboard.html',
                controller: 'DashboardController',
                resolve: {
                    user: function (userService) {
                        return userService.getUser(true);
                    }
                },
                params: {
                    accountVerificationStatus: '',
                    changeEmailVerificationStatus: ''
                }
            })
            .state('subscribed', {
                url: '/subscribed',
                templateUrl: 'app/dashboard/template/dashboard.html',
                controller: 'DashboardController',
                resolve: {
                    user: function (userService) {
                        return userService.getUser(true);
                    }
                },
                params: {
                    accountVerificationStatus: '',
                    changeEmailVerificationStatus: ''
                }
            })
            .state('resumes', {
                url: '/resumes',
                templateUrl: 'app/resumes/template/resumes.html',
                controller: 'ResumesController',
                controllerAs: 'vm',
                resolve: {
                    user: function (userService) {
                        return userService.getUser();
                    },
                    resumes: function (user, resumeService) {
                        return resumeService.getResumes(user.userID);
                    }
                }
            })
            .state('resume', {
                url: '/resume/:resumeId',
                templateUrl: 'app/resume-builder/template/resume-builder.html',
                controller: 'ResumeBuilderController',
                controllerAs: 'vm',
                resolve: {
                    user: function (userService) {
                        return userService.getUser();
                    },
                    resume: function (user, $stateParams, resumeService) {
                        if (!$stateParams.new) {
                            return resumeService.getResume(user.userID, $stateParams.resumeId);
                        } else {
                            return null;
                        }
                    },
                },
                params: {
                    resumeId: "",
                    new: false
                }
            })
            .state('notes', {
                url: '/notes',
                templateUrl: 'app/unemployed-notes/template/unemployed-notes.html',
                controller: 'UnemployedNotesController',
                controllerAs: 'vm'
            })
            .state('resume-jobdesc', {
                url: '/resume-jobdesc',
                templateUrl: 'app/resume-builder/template/resume-builder-temp.html',
                controller: 'ResumeBuilderTempController',
                controllerAs: 'userProfile',
                resolve: {
                    user: function (userService) {
                        return userService.getUser();
                    },
                },
                params: {
                    resumeId: "",
                    new: false
                }
            })
            .state('resume-profile', {
                url: '/resume-profile/:resumeId',
                template: '<resume-builder-profile user="user" resume="resume"></resume-builder-profile>',
                controller: 'ResumeBuilderProfileController',
                resolve: {
                    user: function (userService) {
                        return userService.getUser();
                    },
                    resume: function (user, $stateParams, resumeService) {
                        if (!$stateParams.new) {
                            return resumeService.getResume(user.userID, $stateParams.resumeId);
                        } else {
                            return null;
                        }
                    },
                },
                params: {
                    resumeId: "",
                    new: false,
                    job2resume: false,
                    jobLink: null,
                    processJob: false,
                    firstLoad: false,
                    resumeNotDownloaded:false
                }
            })
            .state('reset-password', {
                url: '/reset_password?token&login&invitation&firstName&lastName,',
                templateUrl: 'app/login/template/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    showPasswordResetModal: function () {
                        return true;
                    }
                }
            })
            .state('assesmentSlides', {
                url: '/assessmentSlides',
                templateUrl: 'app/assessments/template/assessmentSlides.html',
                controller: 'AssessmentSlidesController',
                controllerAs: 'vm',
            })
            .state('assessments', {
                url: '/assessments',
                template: '<assessments-results user="user"></assessments-results>',
                controller: 'AssessmentsController',
                // controllerAs: 'vm',
                resolve: {
                    user: function (userService) {
                        return userService.getUser();
                    },
                },
                params: {
                    startAssessment: false
                }
            })
            .state('resume-walkthrough', {
                url: '/resume-walkthrough',
                templateUrl: 'app/resume-walkthrough/template/resume-walkthrough.html',
                controller: 'ResumeWalkthroughController',
                controllerAs: 'vm',
                resolve: {
                    user: function (userService) {
                        return userService.getUser();
                    },
                }
            })
            .state('admin-users', {
                url: '/admin/users',
                templateUrl: 'app/admin/users/template/users.html',
                controller: 'UsersController',
                controllerAs: 'vm'
            })
            .state('admin-dashboard', {
                url: '/admin/dashboard',
                templateUrl: 'app/admin/dashboard/template/dashboard.html',
                controller: 'AdminDashboardController',
                controllerAs: 'vm'
            })
            .state('admin-register', {
                url: '/admin',
                templateUrl: 'app/admin/register/template/register.html',
                controller: 'RegisterAdminController',
                controllerAs: 'vm',
            })
            .state('admin-user-details', {
                url: '/admin/details',
                templateUrl: 'app/admin/details/template/details.html',
                controller: 'DetailsController',
                controllerAs: 'vm',
            })
            .state('admin-create-user', {
                // url: '/admin/create',
                url: '/admin/user', // Right now the create component is for Create / View / Update.
                templateUrl: 'app/admin/create/template/create.html',
                controller: 'CreateController',
                controllerAs: 'vm'
            })
            .state('admin-admins', {
                url: '/admin/admins',
                templateUrl: 'app/admin/admins/template/admins.html',
                controller: 'AdminsController',
                controllerAs: 'vm'
            })
            .state('admin-create-admin', {
                url: '/admin/create-admin', // Right now the create component is for Create / View / Update.
                templateUrl: 'app/admin/createadmin/template/create.html',
                controller: 'AdminCreateController', // this is a stupid fucking name because it does all three functions
                controllerAs: 'vm'
            })
            .state('admin-profile', {
                url: '/admin/profile', // Right now the create component is for Create / View / Update.
                templateUrl: 'app/admin/createadmin/template/create.html',
                controller: 'AdminCreateController',
                controllerAs: 'vm',
                params: {
                    isProfile: true
                }
            })
            .state('admin-organizations', {
                url: '/admin/organizations',
                templateUrl: 'app/admin/organizations/template/organizations.html',
                controller: 'OrganizationsController',
                controllerAs: 'vm'
            })
            .state('admin-create-organization', {
                url: '/admin/create-organization', // Right now the create component is for Create / View / Update.
                templateUrl: 'app/admin/createorganization/template/create.html',
                controller: 'CreateOrganizationController',
                controllerAs: 'vm'
            })
            .state('admin-utms', {
                url: '/admin/utms',
                templateUrl: 'app/admin/utms/template/utms.html',
                controller: 'UtmsController',
                controllerAs: 'vm'
            })
            .state('admin-create-utm', {
                url: '/admin/create-utm', // Right now the create component is for Create / View / Update.
                templateUrl: 'app/admin/createutm/template/create.html',
                controller: 'CreateUtmController',
                controllerAs: 'vm'
            })
            .state('admin-tracks', {
                url: '/admin/tracks',
                templateUrl: 'app/admin/tracks/template/tracks.html',
                controller: 'TracksController',
                controllerAs: 'vm'
            })
            .state('subscription', {
                url: '/subscription',
                templateUrl: 'app/common/directive/paywall/paywall.html',
                controller: 'PayWallController',
                controllerAs: 'vm',
            })
            .state('my-account', {
                url: '/account',
                templateUrl: 'app/my-account/template/my-account.html',
                controller: 'MyAccountController',
                resolve: {
                    user: function (userService) {
                        return userService.getUser(true);
                    },
                }
            })
            .state('user-profile', {
                url: '/user_profile',
                template: '<user-profile user="user"></user-profile>',
                controller: 'UserProfileController',
                // controllerAs: 'userProfile',
                resolve: {
                    user: function (userService) {
                        return userService.getUser(true);
                    },
                }
            })
            .state('change-email', {
                url: '/change-email?token&username',
                template: '',
                controller: 'ChangeEmailController'
            })
            .state('confirm_email', {
                url: '/confirm_email?token&username',
                template: '',
                controller: 'ChangeEmailController'
            })
            .state('confirm_account', {
                url: '/confirm_account?token&login',
                template: '',
                controller: 'AccountVerificationController'
            })
            .state('intry-agreement', {
                url: '/intry-agreement',
                templateUrl: 'app/intry-agreement/template/agreement.html'
            })
            .state('cookie-policy', {
                url: '/cookie-policy',
                templateUrl: 'app/cookie-policy/template/agreement.html'
            })
            .state('privacy-policy', {
                url: '/privacy-policy',
                templateUrl: 'app/privacy-policy/template/agreement.html'
            }).state('job-search', {
                url: '/job-search',
                templateUrl: 'app/job-search/template/job-search.html',
                controller: 'JobSearchController',
                controllerAs: 'vm',
                resolve: {
                    user: function (userService) {
                        return userService.getUser(true, true);
                    }
                }
            }).state('job-alerts', {
                url: '/job-alerts',
                templateUrl: 'app/job-search/template/job-alerts.html',
                controller: 'JobSearchController',
                controllerAs: 'vm',
                resolve: {
                    user: function (userService) {
                        return userService.getUser(true, true);
                    }
                }
            }).state('wizard', {
                url: '/wizard/{step:[1-4]{1}}',
                templateUrl: 'app/wizard/template/wizard.html',
                controller: 'WizardController',
                controllerAs: 'wizard',
                resolve: {
                    user: function (userService) {
                        return userService.getUser(true);
                    },
                    resume: function (user, resumeService, utilsService, $stateParams) {
                        // console.log('resumeId:', utilsService.getResumeId(user.userID));

                        if (($stateParams.step == 3 || $stateParams.step == 4) && utilsService.getResumeId(user.userID)) {
                            return resumeService.getResume(user.userID, utilsService.getResumeId(user.userID));
                        }
                        return null;
                    }
                }
            });

        $urlRouterProvider.otherwise('/dashboard');
    }

    function routerConfigMaint($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('login', {
                url: '/login',
                templateUrl: 'app/login/template/maintenance.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    showPasswordResetModal: function () {
                        return false;
                    }
                },
                params: {
                    accountVerificationStatus: '',
                    changeEmailVerificationStatus: ''
                }
            }).state('all', {
                url: '/*params',
                templateUrl: 'app/login/template/maintenance.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    showPasswordResetModal: function () {
                        return false;
                    }
                },
                params: {
                    accountVerificationStatus: '',
                    changeEmailVerificationStatus: ''
                }
            });
        $urlRouterProvider.otherwise('/login');
    }


    

    function routerConfig($stateProvider, $urlRouterProvider) {
        if (maintenanceOn)
            routerConfigMaint($stateProvider, $urlRouterProvider);
        else
            routerConfigNormal($stateProvider, $urlRouterProvider);
    }
})();

(function () {
    'use strict';

    angular
        .module('intryFrontEnd')
        .constant('constants', (function () {
            var constants = {};

            var productionHosts = [
                'app.intry.careers',  'app.intrycareers.com',
                'prod-app.intry.careers',  'prod-app.intrycareers.com',
            ];
            var stagingHosts = [
                'demo.intry.careers',  'demo.intrycareers.com',
                'beta.intry.careers',  'beta.intrycareers.com',
                'appnew.intry.careers',  'appnew.intrycareers.com',
                'demonew.intry.careers',  'demonew.intrycareers.com',
                'betanew.intry.careers',  'betanew.intrycareers.com',
                'staging.intry.careers', 'staging.intrycareers.com',
                'stagingnew.intry.careers', 'stagingnew.intrycareers.com',
            ];
            var edgeHosts = [
                'edge.intry.careers',  'edge.intrycareers.com',
                'edgenew.intry.careers', 'edgenew.intrycareers.com',
            ];
            var qaHosts = [
                'qa.intry.careers', 'qa.intrycareers.com',
                'qanew.intry.careers', 'qanew.intrycareers.com'
            ];
            var devHosts = ['localhost', '127.0.0.1'];

            constants.VALID_IPADDRESS = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

            // See http://emailregex.com/
            constants.EMAIL_PATTERN = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            // See https://www.regexplanet.com/advanced/javascript/index.html
            constants.USA_PHONE_PATTERN = /^[0-9]{10}$/;
            constants.USA_PHONE_PATTERN_2 = /\D*([2-9]\d{2})(\D*)([0-9]\d{2})(\D*)(\d{4})\D*/;
            constants.PHONE_CLEANUP_CHARACTERS = /[+.,\/#!$%^&*;:{}=\-_`~()\s]/g;
            constants.MAX_SUMMARY_LENGTH=1024;

            // Source: https://stackoverflow.com/questions/160550/zip-code-us-postal-code-validation
            constants.US_PIN_CODE = /(^\d{5}$)|(^\d{5}-\d{4}$)/;

            constants.DATE_VALIDATION = /^(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC|[0-1][0-9]|[1-9]|1[0-2]) \d{4}$/;
            constants.DATE_VALIDATION_MONTHS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
            constants.YEAR_VALIDATION = /^\d{4}$/;

            constants.ONE_MB_IN_BYTES = 1048576;
            constants.MAX_PROFILE_PIC_FILE_SIZE = constants.ONE_MB_IN_BYTES * 10;


            constants.amountToCharge = 10;

            constants.moment = moment;
            constants.linkedINKey = "78i5t21d3l5dhh";
            constants.facebook_Key = "133930797320327";
            constants.facebook_api_ver = "v2.11";

            // Number of records for pagination
            constants.recordsPerPage = 20;

            var injectedEnv = {};

            // The docker entry point shell script generates inject.js which sets the window.injectedEnv
            if (window && window.injectedEnv) {
                injectedEnv = window.injectedEnv;
                console.info("info: injected frontend environment");
            }
            
            // If we are in a container injectedEnv contains what we need.  We could use process.env
            // when running under gulp in development environment and generate the injection but we
            // just infer the development values below.  And if for some reason the injected environment
            // is missing in containerized environment, we try to do the right thing (but this should NOT
            // happen, it is a last ditch attempt to function).

            var nodeEnv = "development";
            if (!injectedEnv.FRONTEND_API_BASEURL) {
                // No environment, try to infer the correct values
                // defaults (development)
                var devHost = "localhost";
                var devPort = "8442";
                
                var apiBase = "https://" + devHost;
                var url = new URL(apiBase);

                try {
                    url = new URL(location.href);
                } catch (e) {
                    console.error(e);
                }

                if (new RegExp(constants.VALID_IPADDRESS).test(url.hostname)) {
                    if (url.hostname === "127.0.0.1") {
                        apiBase = "http://" + devHost + ":" + devPort;
                    }
                    else {
                        apiBase = "http://" + url.hostname + ":" + devPort;
                    }
                }
                else {
                    var dparts = url.hostname.split('.');
                    var basehost = (dparts.shift('.') || "app").toLowerCase();
                    var basedom = dparts.join('.').toLowerCase();

                    switch (basehost)
                    {
                        case "localhost": {
                            apiBase = "http://" + basehost + ":" + devPort;
                            break;
                        }
                        case "demo":
                        case "demonew":
                        case "beta":                                                 
                        case "betanew":
                        case "staging":
                        case "stagingnew": {
                            nodeEnv = 'production';
                            // fall through
                        }
                        case "edge": 
                        case "edgenew":
                        case "qa":
                        case "qanew": {
                            apiBase = "https://" + basehost + "." + basedom + ":" + devPort;
                            break;
                        }
                        case "prod-app": {
                            nodeEnv = "production";
                            apiBase = 'https://prod-api.' + basedom;
                            break;
                        }
                        case "app":
                        default: {
                            nodeEnv = "production";
                            apiBase = 'https://api.' + basedom;
                            break;
                        }
                    }
                }
                injectedEnv.FRONTEND_API_BASEURL = apiBase;
            }
            if (!injectedEnv.FRONTEND_NODE_ENV) {
                injectedEnv.FRONTEND_NODE_ENV = nodeEnv;
            }
            if (!injectedEnv.FRONTEND_RESUME_BASEURL) {
                if (productionHosts.indexOf(location.hostname.toLowerCase()) !== -1) {
                    injectedEnv.FRONTEND_RESUME_BASEURL = 'https://s3.amazonaws.com/static.intry.careers/templates/resumes/';
                }
                else if (stagingHosts.indexOf(location.hostname.toLowerCase()) !== -1) {
                    injectedEnv.FRONTEND_RESUME_BASEURL = 'https://s3.amazonaws.com/static.intry.careers/templates/resumes/staging/';
                }
                else if (edgeHosts.indexOf(location.hostname.toLowerCase()) !== -1) {
                    injectedEnv.FRONTEND_RESUME_BASEURL = 'https://s3.amazonaws.com/static.intry.careers/templates/resumes/edge/';
                }
                else if (devHosts.indexOf(location.hostname.toLowerCase()) !== -1) {
                    injectedEnv.FRONTEND_RESUME_BASEURL = 'http://localhost:4000/templates/';
                }
                else {
                    // qa hosts and everything else
                    injectedEnv.FRONTEND_RESUME_BASEURL = 'https://s3.amazonaws.com/static.intry.careers/templates/resumes/test/';
                }
            }
            constants.environment = injectedEnv;
            constants.resumeBucketUrl = constants.environment.FRONTEND_RESUME_BASEURL;
            console.info('resume templates: ' + constants.resumeBucketUrl);
            constants.baseUrl = constants.environment.FRONTEND_API_BASEURL;
            constants.container = constants.environment.FRONTEND_CONTAINER;
            // >>> KSH should use a different folder for production vs test/dev
            constants.resumeStorage = "https://s3.amazonaws.com/static.intry.careers/resumes/",
            
            console.info('api: ' + constants.baseUrl);
            console.info('container: ' + constants.container);
            
            // Stripe for testing
            // constants.stripeAPIKey = "pk_test_tJAeOT8tvZGVDIhaBy8Mlwrj";
            // Stripe for production
            // constants.stripeAPIKey = "pk_live_A748ZflSMkdT1U5fzfacP5L6";
            if (productionHosts.indexOf(location.hostname.toLowerCase()) !== -1) {
                constants.stripeAPIKey = "pk_live_A748ZflSMkdT1U5fzfacP5L6";
                constants.transcriptUrl = "/production/";
            } else {
                constants.stripeAPIKey = "pk_test_tJAeOT8tvZGVDIhaBy8Mlwrj";
                constants.transcriptUrl = "/test/";
            }

            constants.default_phone_kind = 'Home';
            constants.default_email_kind = 'Personal';
            constants.default_employment_kind = 'Work';
            constants.default_address_kind = 'Work';
            constants.default_proficiency = '3';
            constants.employment_kind = ['Work', 'Military', 'Volunteer'];
            constants.education_kind = ['degree', 'course', 'certification'];
            constants.default_education_kind = 'degree';
            constants.volunteer = 'Volunteer';
            constants.military = 'Military';
            constants.certification = 'certification';

            constants.kind_list = ["Personal", "Work", "Other"];
            constants.kind_phone_list = ["Home", "Work", "Mobile"];
            constants.kind_education_list = ['Degree', 'Course', 'Certification'];
            constants.kind_recommendations_list = ['Personal', 'Professional'];
            constants.kind_skills_list = ['hard', 'soft', 'language'];
            constants.subscription_types_list = ['base', 'monthly', 'pro-upgrade'];
            constants.user_types_list = ['Candidate'];
            constants.ASSESSMENT_BIG_FIVE_ID = 'big-five';
            constants.timePickerDateFormat = 'MMM d, y';
            constants.user_statuses = { PAUSED: 'paused' };
            constants.codes = { ERROR: 'error', SUCCESS: 'success', USER_EXISTS: 'A user with this username already exists' };
            constants.apiCssUrl = constants.baseUrl + "/public/css/";
            constants.userHiredStatus = [{ key: true, label: 'Yes' }, { key: false, label: 'No' }];
            constants.userStatus = [{ key: 'active', label: 'Active' }, { key: 'inactive', label: 'Inactive' }];
            constants.recordStatus = [{ key: 'active', label: 'Active' }, { key: 'inactive', label: 'Inactive' }];
            constants.recordDeleted = [{ key: true, label: 'Yes' }, { key: false, label: 'No' }];
            constants.userFilterFields = [
                { key: 'all', label: 'All Fields', ftypes: 'ftypesMultiFields' },
                { key: 'username', label: 'Username', ftypes: 'ftypesSingleFields' },
                { key: 'first_name', label: 'First Name', ftypes: 'ftypesSingleFields' },
                { key: 'maiden_name', label: 'Maiden Name', ftypes: 'ftypesSingleFields' },
                { key: 'last_name', label: 'Last Name', ftypes: 'ftypesSingleFields' },
                { key: 'full_name', label: 'Name', ftypes: 'ftypesSingleFields' },
                { key: 'status', label: 'Status', ftypes: 'ftypesSingleFields' },
                { key: 'email_addresses', label: 'Emails', ftypes: 'ftypesSingleFields' }
            ];
            constants.adminFilterFields = [
                { key: 'all', label: 'All Fields', ftypes: 'ftypesMultiFields' },
                { key: 'username', label: 'Username', ftypes: 'ftypesSingleFields' },
                { key: 'first_name', label: 'First Name', ftypes: 'ftypesSingleFields' },
                { key: 'last_name', label: 'Last Name', ftypes: 'ftypesSingleFields' },
                { key: 'status', label: 'Status', ftypes: 'ftypesSingleFields' }
            ];
            constants.organizationFilterFields = [
                { key: 'all', label: 'All Fields', ftypes: 'ftypesMultiFields' },
                { key: 'organizationKey', label: 'Org. Key', ftypes: 'ftypesSingleFields' },
                { key: 'name', label: 'Name', ftypes: 'ftypesSingleFields' },
                { key: 'hostname', label: 'Hostname', ftypes: 'ftypesSingleFields' },
                { key: 'status', label: 'Status', ftypes: 'ftypesSingleFields' }
            ];
            constants.utmFilterFields = [
                { key: 'all', label: 'All Fields', ftypes: 'ftypesMultiFields' },
                { key: 'name', label: 'Name', ftypes: 'ftypesSingleFields' },
                { key: 'utmSource', label: 'Source', ftypes: 'ftypesSingleFields' }
            ];
            constants.unemployedNotesFilterFields = [
                { key: 'all', label: 'All Fields', ftypes: 'ftypesMultiFields' },
                { key: 'companyName', label: 'Company Name', ftypes: 'ftypesSingleFields' },
                { key: 'contactName', label: 'Contact Name', ftypes: 'ftypesSingleFields' },
                { key: 'contactEmail', label: 'Contact Email', ftypes: 'ftypesSingleFields' },
                { key: 'note', label: 'Note', ftypes: 'ftypesSingleFields' }
            ];
            constants.tracksFilterFields = [
                { key: 'all', label: 'All Fields', ftypes: 'ftypesMultiFields' },
                { key: 'userID', label: 'User ID', ftypes: 'ftypesSingleFields' },
                { key: 'organizationKey', label: 'Org. Key', ftypes: 'ftypesSingleFields' }
            ];
            constants.ftypesMultiFields = [
                { key: 'c', label: 'Contains' },
                { key: 'et', label: 'Equal To' },
                { key: 'sw', label: 'Start With' },
                { key: 'ew', label: 'End With' }
            ];
            constants.ftypesSingleFields = [
                { key: 'c', label: 'Contain' },
                { key: 'et', label: 'Equal To' },
                { key: 'sw', label: 'Start With' },
                { key: 'ew', label: 'End With' },
                { key: 'dnc', label: 'Does Not Contain' },
                { key: 'net', label: 'Not Equal To' }
            ];
            constants.defaultDownloadAttempts = 5;
            constants.defaultMillisecondsBetweenDownloadAttempts = 30000;

            constants.INTRY_ORG = 'intry';
            constants.INTRYOR_ORG = 'optimized-resumes';            
            constants.INTRY_ADMIN = 'intrydevopsadmin@intry.careers';
            constants.ADMIN_ROLES = [{
                role: 'ROLE_USER_ADMIN',
                name: 'Case Manager'
            }, {
                role: 'ROLE_ORGANIZATION_ADMIN',
                name: 'Administrator'
            }, {
                role: 'ROLE_APP_ADMIN',
                name: 'Intry Administrator'
            }];

            constants.notesTimeOptions = [{
                key: '12:00 am',
                label: 'Select'
            },
            {
                key: '06:30 am',
                label: '06:30 am'
            },
            {
                key: '07:00 am',
                label: '07:00 am'
            },
            {
                key: '07:30 am',
                label: '07:30 am'
            },
            {
                key: '08:00 am',
                label: '08:00 am'
            },
            {
                key: '08:30 am',
                label: '08:30 am'
            },
            {
                key: '09:00 am',
                label: '09:00 am'
            },
            {
                key: '09:30 am',
                label: '09:30 am'
            },
            {
                key: '10:00 am',
                label: '10:00 am'
            },
            {
                key: '10:30 am',
                label: '10:30 am'
            },
            {
                key: '11:00 am',
                label: '11:00 am'
            },
            {
                key: '11:30 am',
                label: '11:30 am'
            },
            {
                key: '12:00 pm',
                label: '12:00 pm'
            },
            {
                key: '12:30 pm',
                label: '12:30 pm'
            },
            {
                key: '01:00 pm',
                label: '01:00 pm'
            },
            {
                key: '01:30 pm',
                label: '01:30 pm'
            },
            {
                key: '02:00 pm',
                label: '02:00 pm'
            },
            {
                key: '02:30 pm',
                label: '02:30 pm'
            },
            {
                key: '03:00 pm',
                label: '03:00 pm'
            },
            {
                key: '03:30 pm',
                label: '03:30 pm'
            },
            {
                key: '04:00 pm',
                label: '04:00 pm'
            },
            {
                key: '04:30 pm',
                label: '04:30 pm'
            },
            {
                key: '05:00 pm',
                label: '05:00 pm'
            },
            {
                key: '05:30 pm',
                label: '05:30 pm'
            },
            {
                key: '06:00 pm',
                label: '06:00 pm'
            },
            {
                key: '06:30 pm',
                label: '06:30 pm'
            },
            {
                key: '07:00 pm',
                label: '07:00 pm'
            },
            {
                key: '07:30 pm',
                label: '07:30 pm'
            },
            {
                key: '08:00 pm',
                label: '08:00 pm'
            },
            {
                key: '08:30 pm',
                label: '08:30 pm'
            },
            {
                key: '09:00 pm',
                label: '09:00 pm'
            },
            {
                key: '09:30 pm',
                label: '09:30 pm'
            },
            {
                key: '10:00 pm',
                label: '10:00 pm'
            },
            {
                key: '10:30 pm',
                label: '10:30 pm'
            }
            ];

            constants.stripeProductID = 'pp2b'; // default product - plan pack 2
            constants.stripeProductIDs = ['pp2b']; // valid products
            
            constants.stripePlanPrice = '39.99';
            constants.stripePlanID = 'pp2bp1'; // default price in plan pack 2

            constants.stripePlanIDs = ["pp2bp1", "pp2bp2n", "pp2bp3n"]; // in plan pack 2 - excluding pp2bp0 (free)

            constants.INTRY_FREE_TRIAL_DAYS = 7;
            constants.ORG_FREE_TRIAL_DAYS = 180;

            constants.maximumResumeSkills = 16;

            constants.internalError = "Internal Error";

            return constants;
        }()));
})();

/* global location */
(function() {
    'use strict';

    angular
        .module('intryFrontEnd')
        .factory('httpInterceptor', httpInterceptor)
        .config(config);

    function httpInterceptor($localStorage, JWTService, socialLoginService) {
        return {
            response: function (response) {
                return response;
            },
            responseError: function (response) {
                if (response && response.data && response.data.forceLogout) {
                    JWTService.clearToken();
                    socialLoginService.logout();
                    delete $localStorage.userId;
                    delete $localStorage.user;
                    delete $localStorage.premiumAccess;
                    delete $localStorage.freeTrial;
                    delete $localStorage.enabledFreeTrial;
                    location = "/";
                    return false;
                } else {
                    return response;
                }
            }
        };
    }

    /** @ngInject */
    function config($logProvider, $httpProvider, $validationProvider, $translateProvider, constants, StripeElementsProvider) {
        
        // Enable log
        $logProvider.debugEnabled(true);
        // $httpProvider.interceptors.push('httpJWTInjector');
        //disable IE ajax request caching
        $httpProvider.interceptors.push('httpInterceptor');
        $httpProvider.defaults.headers.common['Cache-Control'] = 'no-cache';
        $httpProvider.defaults.cache = false;

        if (!$httpProvider.defaults.headers.get) {
            $httpProvider.defaults.headers.get = {};
        }
        $httpProvider.defaults.headers.get['If-Modified-Since'] = '0';
        
        // Define a global validation provider - username which can be either an email or a phone number
        // This is being used while registration or login time
        // See for more reference: https://github.com/hueitan/angular-validation/blob/master/API.md
        $validationProvider.setExpression({
            username: function (value, scope, element, attrs) {
                var testingValue = value;
                if (testingValue.indexOf('@') === -1) {
                    testingValue = testingValue.replace(constants.PHONE_CLEANUP_CHARACTERS,'');
                }
                return constants.EMAIL_PATTERN.test(testingValue); // || constants.USA_PHONE_PATTERN.test(testingValue);
            }
        });

        // Provide translation service for strings
        // See https://angular-translate.github.io/docs/#/guide/07_multi-language
        $translateProvider.determinePreferredLanguage();
        
        // See https://angular-translate.github.io/docs/#/guide/12_asynchronous-loading
        $translateProvider.useStaticFilesLoader({
            prefix: './lang/intry-',
            suffix: '.json'
        });
        // TODO: Split the translate files by component and join in one translate file when generate the dist with gulp serve:dist.

        // $translateProvider.useStaticFilesLoader({files: [{
        //     prefix: './lang/intry-',
        //     suffix: '.json'
        // }, {
        //     prefix: './lang/intry-login-',
        //     suffix: '.json'
        // }]});


        // See https://angular-translate.github.io/docs/#/guide/02_getting-started
        $translateProvider.fallbackLanguage('en');
        StripeElementsProvider.setAPIKey(constants.stripeAPIKey);

        $translateProvider.useSanitizeValueStrategy('escaped');
    }

})();

angular.module("intryFrontEnd").run(["$templateCache", function($templateCache) {$templateCache.put("app/assessments/template/assessment-warning-dialog.html","<div class=\"modal-intry assessment-warning-dialog\"><button class=\"btn btn-modal-intry-dismiss\" ng-click=closeThisDialog();></button><div class=\"section section-active\"><div class=title>Warning</div><div class=subtitle>{{\'ASSESSMENTS_WARNING_MSG\' | translate}}</div><div class=footer-modal><div class=\"action double\"><a ng-click=closeThisDialog() style=\"margin-left: 25%\">Close</a></div></div></div></div>");
$templateCache.put("app/assessments/template/assessmentConfirmation.html","<div id=take-test-modal style=\"display: block\" aria-labelledby=take-test-modal-title aria-hidden=true><div class=\"modal-dialog modal-dialog-centered\" role=document><div class=modal-content><div ng-class=\"getOrganizationCss(\'modal-body\')\"><h5 translate=ASSESSMENT_CONFIRMATION_SECTION_TITLE1></h5><h6 translate=ASSESSMENT_CONFIRMATION_SECTION_TITLE2></h6><p translate=ASSESSMENT_CONFIRMATION_SECTION_SUBTITLE1></p><p translate=ASSESSMENT_CONFIRMATION_SECTION_SUBTITLE2></p><div class=take-test-btn-group><button type=button class=let-go-btn ng-click=\"beginAssessment(); closeThisDialog()\" translate=ASSESSMENT_CONFIRMATION_SECTION_LETS_GO_BUTTON_TEXT></button> <button type=button class=ass-cancel-btn ng-click=\"createResume(); closeThisDialog()\" data-dismiss=modal translate=ASSESSMENT_CONFIRMATION_SECTION_HYBRID_BUTTON_TEXT></button></div></div></div></div></div>");
$templateCache.put("app/assessments/template/assessmentSlides.html","<div ng-class=\'scrimPageBackground ? \"scrim\": \"\"\'><nav-bar ng-if=!$ctrl.wizard.isWizard user=user></nav-bar></div><section class=\"main-sec new-main-sec\"><header ng-class=\"getOrganizationCss(\'header\', true)\"><div class=container><p ng-if=!$ctrl.wizard.isWizard>{{\"ASSESSMENT_QUIZ_SECTION_TITLE\" | translate }}</p><div ng-if=$ctrl.wizard.isWizard class=wizard-part><h1>{{\'WIZARD_ASSESSMENT_TITLE\' | translate}}</h1><div class=description>{{\'WIZARD_ASSESSMENT_DESCRIPTION\' | translate}}</div></div></div></header><div class=assessment-slide-loader ng-if=showErrorMessage><button aria-label=Dismiss class=ngdialog-close style=\"right: 10px\"></button><div class=error-message><p>{{errorMessage}}</p></div></div><div class=container><div class=\"user-info-sec quiz-section\" ng-if=\"!loadingAssessment && !showErrorMessage\"><div class=row><div class=col-sm-12><div class=not-me-image><div class=\"progress slider-progress\"><div class=progress-bar ng-style=\'{width: progressInPercentage + \"%\"}\'></div></div><img ng-src={{currentSlide.image_desktop_retina}} alt=\"\" class=img-fluid id=assessmentSlideImage></div><div class=quiz-info><div class=not-me-img-text>{{currentSlide.caption}}</div><div ng-class=\"getOrganizationCss(\'quiz-btn-group\')\"><button class=\"btn btn-green new-quiz-btn\" type=button ng-click=\"captureUserResponseForSlide(currentSlide, false)\" translate=ASSESSMENT_SLIDE_SECTION_NOT_ME_BUTTON_TEXT></button> <button class=\"btn btn-green new-quiz-btn\" type=button ng-click=\"captureUserResponseForSlide(currentSlide, true)\" translate=ASSESSMENT_SLIDE_SECTION_ME_BUTTON_TEXT></button></div><p>{{\'ASSESSMENT_SECTION_SUBTITLE\' | translate}}</p><p>{{\'ASSESSMENT_CONFIRMATION_SECTION_SUBTITLE2\' | translate}}</p></div></div></div></div></div><div class=\"clearfix clear\"></div></section>");
$templateCache.put("app/assessments/template/assessments.html","<div class=wizard-assessment ng-show=\"vm.wizard.isWizard && vm.wizard.assessmentStep == 1\"><div class=starting-section><section class=\"main-sec new-main-sec\"><header ng-class=\"getOrganizationCss(\'header\', true)\"><div class=container><div class=wizard-part><h1>{{\'WIZARD_ASSESSMENT_TITLE\' | translate}}</h1><div class=description>{{\'WIZARD_ASSESSMENT_DESCRIPTION\' | translate}}</div></div></div></header><div class=container><div class=user-info-sec><div class=row><div class=section-title><p class=starting-content>{{\'WIZARD_ASSESSMENT_HINT\' | translate}}</p><div class=\"section-buttons buttons-group\"><button class=\"btn btn-green\" ng-click=vm.beginAssessment()>Start</button> <button class=\"btn btn-link btn-green-link\" ng-click=vm.wizard.goToStep(2);>Skip for Now</button></div></div></div></div></div></section></div></div><div ng-show=\"!vm.wizard.isWizard || (vm.wizard.isWizard && vm.wizard.assessmentStep == 3)\"><div ng-class=\'scrimPageBackground ? \"scrim\": \"\"\'><nav-bar ng-if=!vm.wizard.isWizard user=user></nav-bar></div><section class=\"main-sec new-main-sec\"><header ng-class=\"getOrganizationCss(\'header\', true)\"><div class=container><div class=page-name-block><div class=row><div class=section-title><p ng-show=!vm.wizard.isWizard>{{\'ASSESSMENT_SECTION_TITLE\' | translate}}</p><div ng-show=vm.wizard.isWizard class=wizard-part><h1>{{\'WIZARD_ASSESSMENT_TITLE\' | translate}}</h1><div class=description>{{\'WIZARD_ASSESSMENT_DESCRIPTION\' | translate}}</div></div></div><div class=\"section-buttons button-header\"><a type=button class=create-resume-btn style=margin-left:1vw ng-disabled=isPaused ng-click=printDiv()>Download</a> <a type=button class=create-resume-btn ng-disabled=isPaused href=#/user_profile>Back to Profile</a></div></div><div class=clearfix></div></div></div></header><div class=container ng-show=!assessmentsStatus.hasUserTakenBothAssessments><div class=\"user-info-sec user-info-sec-mod\"><div class=row><div class=col-sm-12><div class=assesment-title><span translate=BIG_FIVE_PERSONALITY ng-show=assessmentsStatus.hasUserTakenBothAssessments></span><span class=font-weight-bold>{{assessmentData.archetype}}</span></div></div></div><div class=\"row align-items-center m-0 padding-left-right-38 assesment-container\"><div class=\"col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"d-flex align-items-center graph-icon\"><img src=/media/images/radar.svg width=529 height=384 alt=\"\"></div></div><div class=\"col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"row align-items-center m-b-35\" ng-repeat=\"type in assessmentData.types\"><div class=\"col-xl-3 col-lg-3 col-md-4 col-sm-3 col-xs-12\"><div class=categort-title>{{type.name}}</div></div><div class=\"col-xl-9 col-lg-9 col-md-8 col-sm-9 col-xs-12\"><div class=category-progress><div class=progress><div class=\"progress-bar progress-bar-striped\" role=progressbar ng-style=\"\" aria-valuemin=0 aria-valuemax=100></div></div></div></div></div></div></div><div class=message-sec><h6>{{\'USER_PROFILE_TITLE_FIT\' | translate}}</h6><p>{{\'USER_PROFILE_FIND_FIT_TEXT\' | translate }}</p></div><button ng-class=\"getOrganizationCss(\'btn-test assessment-test-btn\')\" ng-click=confirmationModal()><strong>{{\'ASSESSMENT_TAKE_TEST_SUBTITLE\' | translate}}</strong></button></div></div><!-- *********************** Result Page *********************** --><div class=container ng-show=assessmentsStatus.hasUserTakenBothAssessments><div class=user-info-sec id=assessment-results><div class=row><div class=col-sm-12><div class=assesment-title><span translate=BIG_FIVE_PERSONALITY></span><span class=font-weight-bold>{{assessmentData.archetype}}</span></div></div></div><div class=\"row align-items-center m-0 padding-left-right-38\" ng-show=assessmentsStatus.hasUserTakenBothAssessments><div class=\"col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"d-flex align-items-center graph-icon\" ng-show=assessmentsStatus.hasUserTakenBothAssessments><div id=assessment-radar ng-show=assessmentsStatus.hasUserTakenBothAssessments><canvas id=assessment-radar-canvas width=529 height=384 viewbox=\"0 0 529 384\"></canvas></div></div></div><div class=\"col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"row align-items-center m-b-35\" ng-repeat=\"type in assessmentData.types\"><div class=\"col-xl-3 col-lg-3 col-md-4 col-sm-3 col-xs-12\"><div class=categort-title>{{type.name}}</div></div><div class=\"col-xl-9 col-lg-9 col-md-8 col-sm-9 col-xs-12\"><div class=\"category-progress progress-bar-line\"><div class=progress><div class=\"progress-bar progress-bar-striped\" role=progressbar ng-style=getTypeBarStyle(type) aria-valuemin=0 aria-valuemax=100></div></div></div></div></div></div></div><div class=\"row m-0 section-padding\" ng-show=assessmentsStatus.hasUserTakenBothAssessments><div class=\"col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"w-100 assesment-content\" id=assessment-description><p>{{assessmentData.description}}</p></div></div><div class=\"col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"d-flex flex-wrap\"><div class=assesment-tags ng-repeat=\"trait in assessmentData.traits\">{{trait.name}}</div></div></div></div><div class=\"row m-0 section-padding\" ng-show=assessmentsStatus.hasUserTakenBothAssessments><div class=\"col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12\" ng-show=\"(assessmentData.details.complement.length > 0)\"><div class=w-100><div class=\"assement-section-title primary-title\" translate=COMPLEMENTS></div><div class=\"w-100 assesment-content\"><p class=m-0>{{assessmentData.details.complement}}</p></div></div></div><div class=\"col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12\" ng-show=\"(assessmentData.details.conflict.length > 0)\"><div class=w-100><div class=\"assement-section-title danger-title\" translate=CONFLICTS></div><div class=\"w-100 assesment-content\"><p class=m-0>{{assessmentData.details.conflict}}</p></div></div></div></div><div class=\"row m-0 section-third-padding\" ng-show=assessmentsStatus.hasUserTakenBothAssessments><div class=\"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12\" ng-show=showEnvironments()><div class=\"row m-0\"><div class=\"assement-section-title success-title ol-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 px-0\" translate=BEST_WORK_ENVIRONMENTS></div></div><div class=\"row m-0\"><div class=\"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 px-0\" ng-repeat=\"environments in environmentsResult\"><div class=\"d-flex assesment-bottom-content\" ng-repeat=\"environment in environments\"><div><svg xmlns=http://www.w3.org/2000/svg width=8 height=13 viewBox=\"0 0 8 13\" class=align-middle><path fill=#39C654 fill-rule=evenodd d=\"M0 1.208L1.208 0 7.25 6.042l-6.042 6.041L0 10.875l4.796-4.833z\"/></svg></div><div class=item-text>{{environment}}</div></div></div></div></div></div></div><div class=\"clearfix clear\"></div></div><div class=\"clearfix clear\"></div></section></div>");
$templateCache.put("app/cookie-policy/template/agreement.html","<div id=agreement-screen><div class=header-wrapper><img src=//s3.amazonaws.com/static.intry.careers/images/webapp/navbar_beta_logo.svg></div><div class=title-bar><div class=header-company>INTRY, LLC</div><div class=header-title>INTRY USER AGREEMENT</div></div><div class=content-wrapper><div><p>COOKIE POLICY</p><p>These Cookie Policy constitute a legally binding agreement made between you, whether personally or on behalf of an entity (“you”) and INTRY, LLC (“we,” “us” or “our”) uses cookies on My Website intry.careers (the \"Service\"). By using the Service, you consent to the use of cookies.</p><p>Our Cookies Policy explains what cookies are, how we use cookies, how third-parties we may partner with may use cookies on the Service, your choices regarding cookies and further information about cookies.</p><p>WHAT ARE COOKIES</p><p>Cookies are small pieces of text sent by your web browser by a website you visit. A cookie file is stored in your web browser and allows the Service or a third-party to recognize you and make your next visit easier and the Service more useful to you.</p><p>Cookies can be \"persistent\" or \"session\" cookies.</p><p>HOW INTRY.CAREERS USES COOKIES</p><p>When you use and access the Service, we may place a number of cookies files in your web browser.</p><p>We use cookies for the following purposes: to enable certain functions of the Service, to provide analytics, to store your preferences, to enable advertisements delivery, including behavioral advertising.</p><p>We use both session and persistent cookies on the Service and we use different types of cookies to run the Service:</p><p>- Essential cookies. We may use essential cookies to authenticate users and prevent fraudulent use of user accounts.</p><p>For the full disclosure section, including all types of cookies (from essentials to advertising cookies), create your own Cookies Policy.</p><p>THIRD-PARTY COOKIES</p><p>In addition to our own cookies, we may also use various third-parties cookies to report usage statistics of the Service, deliver advertisements on and through the Service, and so on.</p><p>WHAT ARE YOUR CHOICES REGARDING COOKIES</p><p>If you\'d like to delete cookies or instruct your web browser to delete or refuse cookies, please visit the help pages of your web browser.</p><p>Please note, however, that if you delete cookies or refuse to accept them, you might not be able to use all of the features we offer, you may not be able to store your preferences, and some of our pages might not display properly.</p><p>WHERE CAN YOU FIND MORE INFORMATION ABOUT COOKIES</p><p>You can learn more about cookies and the following third-party websites:</p><p>All About Cookies: http://www.allaboutcookies.org/</p><p>Network Advertising Initiative: http://www.networkadvertising.org/</p><p>CONTACT US</p><p>In order to resolve a complaint regarding the Site or to receive further information regarding use of the Site, please contact us at:</p><p>INTRY, LLC</p><p>info@intry.careers</p></div></div></div>");
$templateCache.put("app/dashboard/template/dashboard.html","<!--<button class=\"take-tour-btn\" ng-click=\"startTour()\">Take a Tour</button>--><div class=dashboard ng-class=\'scrimPageBackground ? \"scrim\": \"\"\'><nav-bar user=user verification-status-message=verificationStatus email-verification-status-message=emailVerificationStatus></nav-bar><div ng-class=showEmailConfirmationMessage()><div class=modal><button class=\"btn btn-modal-intry-dismiss\" ng-click=closeEmailConfirmationMessage()></button><h1>{{emailConfirmationMessage()}}</h1><button class=button ng-click=closeEmailConfirmationMessage()><span>OK</span></button></div></div><div class=page-header-intry><div ng-class=\"getOrganizationCss(\'background-image\')\"><div class=video-container><div src=media/purple_background.jpg ng-class=\"getOrganizationCss(\'dashboard-image\')\"></div></div><div class=page-content-intry><div class=content-intry><div class=pull-dashboard-wrapper><div class=pull-dashboard><div class=header><div class=title>{{\'DASHBOARD_SECTION_TITLE\' | translate}} {{user.first_name}}!</div><div class=subtitle>{{\'DASHBOARD_SECTION_SUBTITLE\' | translate}}</div></div></div><div class=\"pull-dashboard pull-dashboard-j2r-btn\"><a ng-class=\"getOrganizationCss(\'btn j2r-btn\')\" ng-click=showProfileModal()>{{\'CREATE_JOB2RESUME_TITLE\' | translate}}</a></div></div></div><div class=job-alerts-dashboard ng-show=false><div class=job-alerts-header><h1 class=title>{{\'DASHBOARD_JOB_ALERTS_TITLE\' | translate}}</h1><h2 class=subtitle>{{\'DASHBOARD_JOB_ALERTS_SUBTITLE\' | translate}}</h2></div><div id=zr_alerts_widget_container class=zr_alerts_widget_container></div></div></div></div></div></div><div class=onboarding-sections><a href=/#/assessments ng-class=\"getOrganizationCss(\'section\')\"><div class=content><div class=title translate=DASHBOARD_ONBOARDING_SECTION_TITLE_ASSESSMENTS></div><div class=icon><div class=assessment src=/media/images/assessments-ico.png></div></div></div></a><a href=javascript: ng-class=\"getOrganizationCss(\'section\')\" ng-click=showProfileModal()><div class=content><div class=title translate=DASHBOARD_ONBOARDING_SECTION_TITLE_PROFILE></div><div class=icon><div class=candidate src=/media/images/candidate-profile-ico.png></div></div></div></a><a href=/#/resumes ng-class=\"getOrganizationCss(\'section\')\"><div class=content><div class=title translate=DASHBOARD_ONBOARDING_SECTION_TITLE_RESUMES></div><div class=icon><div class=resume src=/media/images/resume-ico.png></div></div></div></a></div>");
$templateCache.put("app/disabled-user/template/disabled-user.html","<div class=\"modal-intry disabled-user\"><button class=\"btn btn-modal-intry-dismiss\" ng-click=closeThisDialog()></button><div class=\"section section-active\"><div class=title><span translate=DISABLED_USER></span></div><div class=subtitle><span translate=DISABLED_USER_EXPLAIN></span></div></div></div>");
$templateCache.put("app/free-trial/template/free-trial.html","<div class=\"body free-trial\"><div class=flex-modal><div data-w-id=147fdf95-900d-cce4-2a24-df2d1d0ba9d5 class=modal-closer><img src=https://s3.amazonaws.com/static.intry.careers/images/Close.svg alt=\"\" ng-click=closeModal()></div><div data-w-id=7ddd80e9-e2c4-b16d-aa0a-463082ed8046 class=modal-wrapper><div data-w-id=75373701-b6b2-00c0-0d7b-24bc66258c60 class=modal><div class=modal-title>Great to see you back!</div><p class=paragraph-5>Since you’re already part of the Intry family, we’d like to offer you a free 7-day trial with full access to ALL features including:</p><ul class=modal-list><li><p class=paragraph-6>Unlimited Hybrid Resume™ downloads</p></li><li><p class=paragraph-6>TrueYou™ Skills Assessment</p></li><li><p class=paragraph-6>Job2Resume Creator™</p></li><li><p class=paragraph-6>Access to over 3 million job listings</p></li><li><p class=paragraph-6>Digital Profile</p></li><li><p class=paragraph-6>Intuitive dashboard</p></li></ul><button type=button ng-click=closeModal() class=\"color-btn w-button\">Get Started Now</button><div class=small-white>What do you have to lose?</div></div></div></div></div>");
$templateCache.put("app/intry-agreement/template/agreement.html","<div id=agreement-screen><div class=header-wrapper><img src=//s3.amazonaws.com/static.intry.careers/images/webapp/navbar_beta_logo.svg></div><div class=title-bar><div class=header-company>INTRY, LLC</div><div class=header-title>INTRY USER AGREEMENT</div></div><div class=content-wrapper><div><p>AGREEMENT TO TERMS</p><p>These Terms of Use constitute a legally binding agreement made between you, whether personally or on behalf of an entity (“you”) and INTRY, LLC (“we,” “us” or “our”), concerning your access to and use of thehttps://intry.careers/ website as well as any other media form, media channel, mobile website or mobile application related, linked, or otherwise connected thereto (collectively, the “Site”). You agree that by accessing the Site, you have read, understood, and agree to be bound by all of these Terms of Use. IF YOU DO NOT AGREE WITH ALL OF THESE TERMS OF USE, THEN YOU ARE EXPRESSLY PROHIBITED FROM USING THE SITE AND YOU MUST DISCONTINUE USE IMMEDIATELY.</p><p>Supplemental terms and conditions or documents that may be posted on the Site from time to time are hereby expressly incorporated herein by reference. We reserve the right, in our sole discretion, to make changes or modifications to these Terms of Use at any time and for any reason. We will alert you about any changes by updating the “Last updated” date of these Terms of Use, and you waive any right to receive specific notice of each such change. It is your responsibility to periodically review these Terms of Use to stay informed of updates. You will be subject to, and will be deemed to have been made aware of and to have accepted, the changes in any revised Terms of Use by your continued use of the Site after the date such revised Terms of Use are posted.</p><p>The information provided on the Site is not intended for distribution to or use by any person or entity in any jurisdiction or country where such distribution or use would be contrary to law or regulation or which would subject us to any registration requirement within such jurisdiction or country. Accordingly, those persons who choose to access the Site from other locations do so on their own initiative and are solely responsible for compliance with local laws, if and to the extent local laws are applicable.</p><p>The Site is intended for users who are at least 18 years old. Persons under the age of 18 are not permitted to use or register for the Site.</p><p>INTELLECTUAL PROPERTY RIGHTS</p><p>Unless otherwise indicated, the Site is our proprietary property and all source code, databases, functionality, software, website designs, audio, video, text, photographs, and graphics on the Site (collectively, the “Content”) and the trademarks, service marks, and logos contained therein (the “Marks”) are owned or controlled by us or licensed to us, and are protected by copyright and trademark laws and various other intellectual property rights and unfair competition laws of the United States, foreign jurisdictions, and international conventions. The Content and the Marks are provided on the Site “AS IS” for your information and personal use only. Except as expressly provided in these Terms of Use, no part of the Site and no Content or Marks may be copied, reproduced, aggregated, republished, uploaded, posted, publicly displayed, encoded, translated, transmitted, distributed, sold, licensed, or otherwise exploited for any commercial purpose whatsoever, without our express prior written permission.</p><p>Provided that you are eligible to use the Site, you are granted a limited license to access and use the Site and to download or print a copy of any portion of the Content to which you have properly gained access solely for your personal, non-commercial use. We reserve all rights not expressly granted to you in and to the Site, the Content and the Marks.</p><p>USER REPRESENTATIONS</p><p>By using the Site, you represent and warrant that: (1) all registration information you submit will be true, accurate, current, and complete; (2) you will maintain the accuracy of such information and promptly update such registration information as necessary; (3) you have the legal capacity and you agree to comply with these Terms of Use; (4) you are not a minor in the jurisdiction in which you reside; (5) you will not access the Site through automated or non-human means, whether through a bot, script or otherwise; (6) you will not use the Site for any illegal or unauthorized purpose; and (7) your use of the Site will not violate any applicable law or regulation.</p><p>If you provide any information that is untrue, inaccurate, not current, or incomplete, we have the right to suspend or terminate your account and refuse any and all current or future use of the Site (or any portion thereof).</p><p>USER REGISTRATION</p><p>You may be required to register with the Site. You agree to keep your password confidential and will be responsible for all use of your account and password. We reserve the right to remove, reclaim, or change a username you select if we determine, in our sole discretion, that such username is inappropriate, obscene, or otherwise objectionable.</p><p>FEES AND PAYMENT</p><p>We accept the following forms of payment:</p><p>– Visa</p><p>– Mastercard</p><p>– American Express</p><p>– Discover</p><p>– Diners Club</p><p>– Apple Pay</p><p>– ACH</p><p>You may be required to purchase or pay a fee to access some of our services. You agree to provide current, complete, and accurate purchase and account information for all purchases made via the Site. You further agree to promptly update account and payment information, including email address, payment method, and payment card expiration date, so that we can complete your transactions and contact you as needed. We bill you through an online billing account for purchases made via the Site. Sales tax will be added to the price of purchases as deemed required by us. We may change prices at any time. All payments shall be in U.S. dollars.</p><p>You agree to pay all charges or fees at the prices then in effect for your purchases, and you authorize us to charge your chosen payment provider for any such amounts upon making your purchase. If your purchase is subject to recurring charges, then you consent to our charging your payment method on a recurring basis without requiring your prior approval for each recurring charge, until you notify us of your cancellation.</p><p>We reserve the right to correct any errors or mistakes in pricing, even if we have already requested or received payment. We also reserve the right to refuse any order placed through the Site.</p><!--               \nFREE TRIAL  \nWe offer a 14-day free trial to new users who register with the Site. The account will be charged according to the user’s chosen subscription at the end of the free trial.\n--><p>CANCELLATION</p><p>You can cancel your subscription at any time by logging into your account or contacting us using the contact information provided below. Your cancellation will take effect at the end of the current paid term. If you are unsatisfied with our services, please email us at info@intry.careers.</p><p>PROHIBITED ACTIVITIES</p><p>You may not access or use the Site for any purpose other than that for which we make the Site available. The Site may not be used in connection with any commercial endeavors except those that are specifically endorsed or approved by us.</p><p>As a user of the Site, you agree not to:</p><p>1. Systematically retrieve data or other content from the Site to create or compile, directly or indirectly, a collection, compilation, database, or directory without written permission from us.</p><p>2. Make any unauthorized use of the Site, including collecting usernames and/or email addresses of users by electronic or other means for the purpose of sending unsolicited email, or creating user accounts by automated means or under false pretenses.</p><p>3. Use a buying agent or purchasing agent to make purchases on the Site.</p><p>4. Use the Site to advertise or offer to sell goods and services.</p><p>5. Circumvent, disable, or otherwise interfere with security-related features of the Site, including features that prevent or restrict the use or copying of any Content or enforce limitations on the use of the Site and/or the Content contained therein.</p><p>6. Engage in unauthorized framing of or linking to the Site.</p><p>7. Trick, defraud, or mislead us and other users, especially in any attempt to learn sensitive account information such as user passwords.</p><p>8. Make improper use of our support services or submit false reports of abuse or misconduct.</p><p>9. Engage in any automated use of the system, such as using scripts to send comments or messages, or using any data mining, robots, or similar data gathering and extraction tools.</p><p>10. Interfere with, disrupt, or create an undue burden on the Site or the networks or services connected to the Site.</p><p>11. Attempt to impersonate another user or person or use the username of another user.</p><p>12. Sell or otherwise transfer your profile.</p><p>13. Use any information obtained from the Site in order to harass, abuse, or harm another person.</p><p>14. Use the Site as part of any effort to compete with us or otherwise use the Site and/or the Content for any revenue-generating endeavor or commercial enterprise.</p><p>15. Decipher, decompile, disassemble, or reverse engineer any of the software comprising or in any way making up a part of the Site.</p><p>16. Attempt to bypass any measures of the Site designed to prevent or restrict access to the Site, or any portion of the Site.</p><p>17. Harass, annoy, intimidate, or threaten any of our employees or agents engaged in providing any portion of the Site to you.</p><p>18. Delete the copyright or other proprietary rights notice from any Content.</p><p>19. Copy or adapt the Site’s software, including but not limited to Flash, PHP, HTML, JavaScript, or other code.</p><p>20. Upload or transmit (or attempt to upload or to transmit) viruses, Trojan horses, or other material, including excessive use of capital letters and spamming (continuous posting of repetitive text), that interferes with any party’s uninterrupted use and enjoyment of the Site or modifies, impairs, disrupts, alters, or interferes with the use, features, functions, operation, or maintenance of the Site.</p><p>21. Upload or transmit (or attempt to upload or to transmit) any material that acts as a passive or active information collection or transmission mechanism, including without limitation, clear graphics interchange formats (“gifs”), 1×1 pixels, web bugs, cookies, or other similar devices (sometimes referred to as “spyware” or “passive collection mechanisms” or “pcms”).</p><p>22. Except as may be the result of standard search engine or Internet browser usage, use, launch, develop, or distribute any automated system, including without limitation, any spider, robot, cheat utility, scraper, or offline reader that accesses the Site, or using or launching any unauthorized script or other software.</p><p>23. Disparage, tarnish, or otherwise harm, in our opinion, us and/or the Site.</p><p>24. Use the Site in a manner inconsistent with any applicable laws or regulations.</p><p>USER GENERATED CONTRIBUTIONS</p><p>The Site may invite you to chat, contribute to, or participate in blogs, message boards, online forums, and other functionality, and may provide you with the opportunity to create, submit, post, display, transmit, perform, publish, distribute, or broadcast content and materials to us or on the Site, including but not limited to text, writings, video, audio, photographs, graphics, comments, suggestions, or personal information or other material (collectively, “Contributions”). Contributions may be viewable by other users of the Site and through third-party websites. As such, any Contributions you transmit may be treated as non-confidential and non-proprietary. When you create or make available any Contributions, you thereby represent and warrant that:</p><p>1. The creation, distribution, transmission, public display, or performance, and the accessing, downloading, or copying of your Contributions do not and will not infringe the proprietary rights, including but not limited to the copyright, patent, trademark, trade secret, or moral rights of any third party.</p><p>2. You are the creator and owner of or have the necessary licenses, rights, consents, releases, and permissions to use and to authorize us, the Site, and other users of the Site to use your Contributions in any manner contemplated by the Site and these Terms of Use.</p><p>3. You have the written consent, release, and/or permission of each and every identifiable individual person in your Contributions to use the name or likeness of each and every such identifiable individual person to enable inclusion and use of your Contributions in any manner contemplated by the Site and these Terms of Use.</p><p>4. Your Contributions are not false, inaccurate, or misleading.</p><p>5. Your Contributions are not unsolicited or unauthorized advertising, promotional materials, pyramid schemes, chain letters, spam, mass mailings, or other forms of solicitation.</p><p>6. Your Contributions are not obscene, lewd, lascivious, filthy, violent, harassing, libelous, slanderous, or otherwise objectionable (as determined by us).</p><p>7. Your Contributions do not ridicule, mock, disparage, intimidate, or abuse anyone.</p><p>8. Your Contributions do not advocate the violent overthrow of any government or incite, encourage, or threaten physical harm against another.</p><p>9. Your Contributions do not violate any applicable law, regulation, or rule.</p><p>10. Your Contributions do not violate the privacy or publicity rights of any third party.</p><p>11. Your Contributions do not contain any material that solicits personal information from anyone under the age of 18 or exploits people under the age of 18 in a sexual or violent manner.</p><p>12. Your Contributions do not violate any federal or state law concerning child pornography, or otherwise intended to protect the health or well-being of minors;</p><p>13. Your Contributions do not include any offensive comments that are connected to race, national origin, gender, sexual preference, or physical handicap.</p><p>14. Your Contributions do not otherwise violate, or link to material that violates, any provision of these Terms of Use, or any applicable law or regulation.</p><p>Any use of the Site in violation of the foregoing violates these Terms of Use and may result in, among other things, termination or suspension of your rights to use the Site.</p><p>CONTRIBUTION LICENSE</p><p>By posting your Contributions to any part of the Site or making Contributions accessible to the Site by linking your account from the Site to any of your social networking accounts, you automatically grant, and you represent and warrant that you have the right to grant, to us an unrestricted, unlimited, irrevocable, perpetual, non-exclusive, transferable, royalty-free, fully-paid, worldwide right, and license to host, use, copy, reproduce, disclose, sell, resell, publish, broadcast, retitle, archive, store, cache, publicly perform, publicly display, reformat, translate, transmit, excerpt (in whole or in part), and distribute such Contributions (including, without limitation, your image and voice) for any purpose, commercial, advertising, or otherwise, and to prepare derivative works of, or incorporate into other works, such Contributions, and grant and authorize sublicenses of the foregoing. The use and distribution may occur in any media formats and through any media channels.</p><p>This license will apply to any form, media, or technology now known or hereafter developed, and includes our use of your name, company name, and franchise name, as applicable, and any of the trademarks, service marks, trade names, logos, and personal and commercial images you provide. You waive all moral rights in your Contributions, and you warrant that moral rights have not otherwise been asserted in your Contributions. We do not assert any ownership over your Contributions. You retain full ownership of all of your Contributions and any intellectual property rights or other proprietary rights associated with your Contributions.</p><p>We are not liable for any statements or representations in your Contributions provided by you in any area on the Site. You are solely responsible for your Contributions to the Site and you expressly agree to exonerate us from any and all responsibility and to refrain from any legal action against us regarding your Contributions. We have the right, in our sole and absolute discretion, (1) to edit, redact, or otherwise change any Contributions; (2) to re-categorize any Contributions to place them in more appropriate locations on the Site; and (3) to pre-screen or delete any Contributions at any time and for any reason, without notice. We have no obligation to monitor your Contributions.</p><p>MOBILE APPLICATION LICENSE</p><p>Use License</p><p>If you access the Site via a mobile application, then we grant you a revocable, non-exclusive, non-transferable, limited right to install and use the mobile application on wireless electronic devices owned or controlled by you, and to access and use the mobile application on such devices strictly in accordance with the terms and conditions of this mobile application license contained in these Terms of Use. You shall not: (1) decompile, reverse engineer, disassemble, attempt to derive the source code of, or decrypt the application; (2) make any modification, adaptation, improvement, enhancement, translation, or derivative work from the application; (3) violate any applicable laws, rules, or regulations in connection with your access or use of the application; (4) remove, alter, or obscure any proprietary notice (including any notice of copyright or trademark) posted by us or the licensors of the application; (5) use the application for any revenue generating endeavor, commercial enterprise, or other purpose for which it is not designed or intended; (6) make the application available over a network or other environment permitting access or use by multiple devices or users at the same time; (7) use the application for creating a product, service, or software that is, directly or indirectly, competitive with or in any way a substitute for the application; (8) use the application to send automated queries to any website or to send any unsolicited commercial e-mail; or (9) use any proprietary information or any of our interfaces or our other intellectual property in the design, development, manufacture, licensing, or distribution of any applications, accessories, or devices for use with the application.</p><p>Apple and Android Devices</p><p>The following terms apply when you use a mobile application obtained from either the Apple Store or Google Play (each an “App Distributor”) to access the Site: (1) the license granted to you for our mobile application is limited to a non-transferable license to use the application on a device that utilizes the Apple iOS or Android operating systems, as applicable, and in accordance with the usage rules set forth in the applicable App Distributor’s terms of service; (2) we are responsible for providing any maintenance and support services with respect to the mobile application as specified in the terms and conditions of this mobile application license contained in these Terms of Use or as otherwise required under applicable law, and you acknowledge that each App Distributor has no obligation whatsoever to furnish any maintenance and support services with respect to the mobile application; (3) in the event of any failure of the mobile application to conform to any applicable warranty, you may notify the applicable App Distributor, and the App Distributor, in accordance with its terms and policies, may refund the purchase price, if any, paid for the mobile application, and to the maximum extent permitted by applicable law, the App Distributor will have no other warranty obligation whatsoever with respect to the mobile application; (4) you represent and warrant that (i) you are not located in a country that is subject to a U.S. government embargo, or that has been designated by the U.S. government as a “terrorist supporting” country and (ii) you are not listed on any U.S. government list of prohibited or restricted parties; (5) you must comply with applicable third-party terms of agreement when using the mobile application, e.g., if you have a VoIP application, then you must not be in violation of their wireless data service agreement when using the mobile application; and (6) you acknowledge and agree that the App Distributors are third-party beneficiaries of the terms and conditions in this mobile application license contained in these Terms of Use, and that each App Distributor will have the right (and will be deemed to have accepted the right) to enforce the terms and conditions in this mobile application license contained in these Terms of Use against you as a third-party beneficiary thereof.</p><p>SOCIAL MEDIA</p><p>As part of the functionality of the Site, you may link your account with online accounts you have with third-party service providers (each such account, a “Third-Party Account”) by either: (1) providing your Third-Party Account login information through the Site; or (2) allowing us to access your Third-Party Account, as is permitted under the applicable terms and conditions that govern your use of each Third-Party Account. You represent and warrant that you are entitled to disclose your Third-Party Account login information to us and/or grant us access to your Third-Party Account, without breach by you of any of the terms and conditions that govern your use of the applicable Third-Party Account, and without obligating us to pay any fees or making us subject to any usage limitations imposed by the third-party service provider of the Third-Party Account. By granting us access to any Third-Party Accounts, you understand that (1) we may access, make available, and store (if applicable) any content that you have provided to and stored in your Third-Party Account (the “Social Network Content”) so that it is available on and through the Site via your account, including without limitation any friend lists and (2) we may submit to and receive from your Third-Party Account additional information to the extent you are notified when you link your account with the Third-Party Account. Depending on the Third-Party Accounts you choose and subject to the privacy settings that you have set in such Third-Party Accounts, personally identifiable information that you post to your Third-Party Accounts may be available on and through your account on the Site. Please note that if a Third-Party Account or associated service becomes unavailable or our access to such Third-Party Account is terminated by the third-party service provider, then Social Network Content may no longer be available on and through the Site. You will have the ability to disable the connection between your account on the Site and your Third-Party Accounts at any time. PLEASE NOTE THAT YOUR RELATIONSHIP WITH THE THIRD-PARTY SERVICE PROVIDERS ASSOCIATED WITH YOUR THIRD-PARTY ACCOUNTS IS GOVERNED SOLELY BY YOUR AGREEMENT(S) WITH SUCH THIRD-PARTY SERVICE PROVIDERS. We make no effort to review any Social Network Content for any purpose, including but not limited to, for accuracy, legality, or non-infringement, and we are not responsible for any Social Network Content. You acknowledge and agree that we may access your email address book associated with a Third-Party Account and your contacts list stored on your mobile device or tablet computer solely for purposes of identifying and informing you of those contacts who have also registered to use the Site. You can deactivate the connection between the Site and your Third-Party Account by contacting us using the contact information below or through your account settings (if applicable). We will attempt to delete any information stored on our servers that was obtained through such Third-Party Account, except the username and profile picture that become associated with your account.</p><p>SUBMISSIONS</p><p>You acknowledge and agree that any questions, comments, suggestions, ideas, feedback, or other information regarding the Site (“Submissions”) provided by you to us are non-confidential and shall become our sole property. We shall own exclusive rights, including all intellectual property rights, and shall be entitled to the unrestricted use and dissemination of these Submissions for any lawful purpose, commercial or otherwise, without acknowledgment or compensation to you. You hereby waive all moral rights to any such Submissions, and you hereby warrant that any such Submissions are original with you or that you have the right to submit such Submissions. You agree there shall be no recourse against us for any alleged or actual infringement or misappropriation of any proprietary right in your Submissions.</p><p>THIRD-PARTY WEBSITES AND CONTENT</p><p>The Site may contain (or you may be sent via the Site) links to other websites (“Third-Party Websites”) as well as articles, photographs, text, graphics, pictures, designs, music, sound, video, information, applications, software, and other content or items belonging to or originating from third parties (“Third-Party Content”). Such Third-Party Websites and Third-Party Content are not investigated, monitored, or checked for accuracy, appropriateness, or completeness by us, and we are not responsible for any Third-Party Websites accessed through the Site or any Third-Party Content posted on, available through, or installed from the Site, including the content, accuracy, offensiveness, opinions, reliability, privacy practices, or other policies of or contained in the Third-Party Websites or the Third-Party Content. Inclusion of, linking to, or permitting the use or installation of any Third-Party Websites or any Third-Party Content does not imply approval or endorsement thereof by us. If you decide to leave the Site and access the Third-Party Websites or to use or install any Third-Party Content, you do so at your own risk, and you should be aware these Terms of Use no longer govern. You should review the applicable terms and policies, including privacy and data gathering practices, of any website to which you navigate from the Site or relating to any applications you use or install from the Site. Any purchases you make through Third-Party Websites will be through other websites and from other companies, and we take no responsibility whatsoever in relation to such purchases which are exclusively between you and the applicable third party. You agree and acknowledge that we do not endorse the products or services offered on Third-Party Websites and you shall hold us harmless from any harm caused by your purchase of such products or services. Additionally, you shall hold us harmless from any losses sustained by you or harm caused to you relating to or resulting in any way from any Third-Party Content or any contact with Third-Party Websites.</p><p>ADVERTISERS</p><p>We allow advertisers to display their advertisements and other information in certain areas of the Site, such as sidebar advertisements or banner advertisements. If you are an advertiser, you shall take full responsibility for any advertisements you place on the Site and any services provided on the Site or products sold through those advertisements. Further, as an advertiser, you warrant and represent that you possess all rights and authority to place advertisements on the Site, including, but not limited to, intellectual property rights, publicity rights, and contractual rights. We simply provide the space to place such advertisements, and we have no other relationship with advertisers.</p><p>U.S. GOVERNMENT RIGHTS</p><p>Our services are “commercial items” as defined in Federal Acquisition Regulation (“FAR”) 2.101. If our services are acquired by or on behalf of any agency not within the Department of Defense (“DOD”), our services are subject to the terms of these Terms of Use in accordance with FAR 12.212 (for computer software) and FAR 12.211 (for technical data). If our services are acquired by or on behalf of any agency within the Department of Defense, our services are subject to the terms of these Terms of Use in accordance with Defense Federal Acquisition Regulation (“DFARS”) 227.7202 3. In addition, DFARS 252.227 7015 applies to technical data acquired by the DOD. This U.S. Government Rights clause is in lieu of, and supersedes, any other FAR, DFARS, or other clause or provision that addresses government rights in computer software or technical data under these Terms of Use.</p><p>SITE MANAGEMENT</p><p>We reserve the right, but not the obligation, to: (1) monitor the Site for violations of these Terms of Use; (2) take appropriate legal action against anyone who, in our sole discretion, violates the law or these Terms of Use, including without limitation, reporting such user to law enforcement authorities; (3) in our sole discretion and without limitation, refuse, restrict access to, limit the availability of, or disable (to the extent technologically feasible) any of your Contributions or any portion thereof; (4) in our sole discretion and without limitation, notice, or liability, to remove from the Site or otherwise disable all files and content that are excessive in size or are in any way burdensome to our systems; and (5) otherwise manage the Site in a manner designed to protect our rights and property and to facilitate the proper functioning of the Site.</p><p>PRIVACY POLICY</p><p>We care about data privacy and security. Please review our Privacy Policy: https://intry.careers/about/privacy/. By using the Site, you agree to be bound by our Privacy Policy, which is incorporated into these Terms of Use. Please be advised the Site is hosted in the United States. If you access the Site from the European Union, Asia, or any other region of the world with laws or other requirements governing personal data collection, use, or disclosure that differ from applicable laws in the United States, then through your continued use of the Site, you are transferring your data to the United States, and you expressly consent to have your data transferred to and processed in the United States. Further, we do not knowingly accept, request, or solicit information from children or knowingly market to children. Therefore, in accordance with the U.S. Children’s Online Privacy Protection Act, if we receive actual knowledge that anyone under the age of 13 has provided personal information to us without the requisite and verifiable parental consent, we will delete that information from the Site as quickly as is reasonably practical.</p><p>COPYRIGHT INFRINGEMENTS</p><p>We respect the intellectual property rights of others. If you believe that any material available on or through the Site infringes upon any copyright you own or control, please immediately notify us using the contact information provided below (a “Notification”). A copy of your Notification will be sent to the person who posted or stored the material addressed in the Notification. Please be advised that pursuant to federal law you may be held liable for damages if you make material misrepresentations in a Notification. Thus, if you are not sure that material located on or linked to by the Site infringes your copyright, you should consider first contacting an attorney.</p><p>TERM AND TERMINATION</p><p>These Terms of Use shall remain in full force and effect while you use the Site. WITHOUT LIMITING ANY OTHER PROVISION OF THESE TERMS OF USE, WE RESERVE THE RIGHT TO, IN OUR SOLE DISCRETION AND WITHOUT NOTICE OR LIABILITY, DENY ACCESS TO AND USE OF THE SITE (INCLUDING BLOCKING CERTAIN IP ADDRESSES), TO ANY PERSON FOR ANY REASON OR FOR NO REASON, INCLUDING WITHOUT LIMITATION FOR BREACH OF ANY REPRESENTATION, WARRANTY, OR COVENANT CONTAINED IN THESE TERMS OF USE OR OF ANY APPLICABLE LAW OR REGULATION. WE MAY TERMINATE YOUR USE OR PARTICIPATION IN THE SITE OR DELETE YOUR ACCOUNT AND ANY CONTENT OR INFORMATION THAT YOU POSTED AT ANY TIME, WITHOUT WARNING, IN OUR SOLE DISCRETION. If we terminate or suspend your account for any reason, you are prohibited from registering and creating a new account under your name, a fake or borrowed name, or the name of any third party, even if you may be acting on behalf of the third party. In addition to terminating or suspending your account, we reserve the right to take appropriate legal action, including without limitation pursuing civil, criminal, and injunctive redress.</p><p>MODIFICATIONS AND INTERRUPTIONS</p>We reserve the right to change, modify, or remove the contents of the Site at any time or for any reason at our sole discretion without notice. However, we have no obligation to update any information on our Site. We also reserve the right to modify or discontinue all or part of the Site without notice at any time. We will not be liable to you or any third party for any modification, price change, suspension, or discontinuance of the Site. We cannot guarantee the Site will be available at all times. We may experience hardware, software, or other problems or need to perform maintenance related to the Site, resulting in interruptions, delays, or errors. We reserve the right to change, revise, update, suspend, discontinue, or otherwise modify the Site at any time or for any reason without notice to you. You agree that we have no liability whatsoever for any loss, damage, or inconvenience caused by your inability to access or use the Site during any downtime or discontinuance of the Site. Nothing in these Terms of Use will be construed to obligate us to maintain and support the Site or to supply any corrections, updates, or releases in connection therewith.<p>GOVERNING LAW</p><p>These Terms of Use and your use of the Site are governed by and construed in accordance with the laws of the State of Texas applicable to agreements made and to be entirely performed within the State of Texas, without regard to its conflict of law principles.</p><p>DISPUTE RESOLUTION</p><p>Binding Arbitration</p><p>If the Parties are unable to resolve a Dispute through informal negotiations, the Dispute (except those Disputes expressly excluded below) will be finally and exclusively resolved by binding arbitration. YOU UNDERSTAND THAT WITHOUT THIS PROVISION, YOU WOULD HAVE THE RIGHT TO SUE IN COURT AND HAVE A JURY TRIAL. The arbitration shall be commenced and conducted under the Commercial Arbitration Rules of the American Arbitration Association (“AAA”) and, where appropriate, the AAA’s Supplementary Procedures for Consumer Related Disputes (“AAA Consumer Rules”), both of which are available at the AAA website www.adr.org. Your arbitration fees and your share of arbitrator compensation shall be governed by the AAA Consumer Rules and, where appropriate, limited by the AAA Consumer Rules. If such costs are determined to by the arbitrator to be excessive, we will pay all arbitration fees and expenses. The arbitration may be conducted in person, through the submission of documents, by phone, or online. The arbitrator will make a decision in writing, but need not provide a statement of reasons unless requested by either Party. The arbitrator must follow applicable law, and any award may be challenged if the arbitrator fails to do so. Except where otherwise required by the applicable AAA rules or applicable law, the arbitration will take place in United States County,TX. Except as otherwise provided herein, the Parties may litigate in court to compel arbitration, stay proceedings pending arbitration, or to confirm, modify, vacate, or enter judgment on the award entered by the arbitrator.</p><p>If for any reason, a Dispute proceeds in court rather than arbitration, the Dispute shall be commenced or prosecuted in the state and federal courts located in United States County, TX, and the Parties hereby consent to, and waive all defenses of lack of personal jurisdiction, and forum non conveniens with respect to venue and jurisdiction in such state and federal courts. Application of the United Nations Convention on Contracts for the International Sale of Goods and the the Uniform Computer Information Transaction Act (UCITA) are excluded from these Terms of Use.</p><p>In no event shall any Dispute brought by either Party related in any way to the Site be commenced more than one (1) years after the cause of action arose. If this provision is found to be illegal or unenforceable, then neither Party will elect to arbitrate any Dispute falling within that portion of this provision found to be illegal or unenforceable and such Dispute shall be decided by a court of competent jurisdiction within the courts listed for jurisdiction above, and the Parties agree to submit to the personal jurisdiction of that court.</p><p>Restrictions</p><p>The Parties agree that any arbitration shall be limited to the Dispute between the Parties individually. To the full extent permitted by law, (a) no arbitration shall be joined with any other proceeding; (b) there is no right or authority for any Dispute to be arbitrated on a class-action basis or to utilize class action procedures; and (c) there is no right or authority for any Dispute to be brought in a purported representative capacity on behalf of the general public or any other persons.</p><p>Exceptions to Arbitration</p><p>The Parties agree that the following Disputes are not subject to the above provisions concerning binding arbitration: (a) any Disputes seeking to enforce or protect, or concerning the validity of, any of the intellectual property rights of a Party; (b) any Dispute related to, or arising from, allegations of theft, piracy, invasion of privacy, or unauthorized use; and (c) any claim for injunctive relief. If this provision is found to be illegal or unenforceable, then neither Party will elect to arbitrate any Dispute falling within that portion of this provision found to be illegal or unenforceable and such Dispute shall be decided by a court of competent jurisdiction within the courts listed for jurisdiction above, and the Parties agree to submit to the personal jurisdiction of that court.</p><p>CORRECTIONS</p><p>There may be information on the Site that contains typographical errors, inaccuracies, or omissions, including descriptions, pricing, availability, and various other information. We reserve the right to correct any errors, inaccuracies, or omissions and to change or update the information on the Site at any time, without prior notice.</p><p>DISCLAIMER</p><p>THE SITE IS PROVIDED ON AN AS-IS AND AS-AVAILABLE BASIS. YOU AGREE THAT YOUR USE OF THE SITE AND OUR SERVICES WILL BE AT YOUR SOLE RISK. TO THE FULLEST EXTENT PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, IN CONNECTION WITH THE SITE AND YOUR USE THEREOF, INCLUDING, WITHOUT LIMITATION, THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. WE MAKE NO WARRANTIES OR REPRESENTATIONS ABOUT THE ACCURACY OR COMPLETENESS OF THE SITE’S CONTENT OR THE CONTENT OF ANY WEBSITES LINKED TO THE SITE AND WE WILL ASSUME NO LIABILITY OR RESPONSIBILITY FOR ANY (1) ERRORS, MISTAKES, OR INACCURACIES OF CONTENT AND MATERIALS, (2) PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER, RESULTING FROM YOUR ACCESS TO AND USE OF THE SITE, (3) ANY UNAUTHORIZED ACCESS TO OR USE OF OUR SECURE SERVERS AND/OR ANY AND ALL PERSONAL INFORMATION AND/OR FINANCIAL INFORMATION STORED THEREIN, (4) ANY INTERRUPTION OR CESSATION OF TRANSMISSION TO OR FROM THE SITE, (5) ANY BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE WHICH MAY BE TRANSMITTED TO OR THROUGH THE SITE BY ANY THIRD PARTY, AND/OR (6) ANY ERRORS OR OMISSIONS IN ANY CONTENT AND MATERIALS OR FOR ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A RESULT OF THE USE OF ANY CONTENT POSTED, TRANSMITTED, OR OTHERWISE MADE AVAILABLE VIA THE SITE. WE DO NOT WARRANT, ENDORSE, GUARANTEE, OR ASSUME RESPONSIBILITY FOR ANY PRODUCT OR SERVICE ADVERTISED OR OFFERED BY A THIRD PARTY THROUGH THE SITE, ANY HYPERLINKED WEBSITE, OR ANY WEBSITE OR MOBILE APPLICATION FEATURED IN ANY BANNER OR OTHER ADVERTISING, AND WE WILL NOT BE A PARTY TO OR IN ANY WAY BE RESPONSIBLE FOR MONITORING ANY TRANSACTION BETWEEN YOU AND ANY THIRD-PARTY PROVIDERS OF PRODUCTS OR SERVICES. AS WITH THE PURCHASE OF A PRODUCT OR SERVICE THROUGH ANY MEDIUM OR IN ANY ENVIRONMENT, YOU SHOULD USE YOUR BEST JUDGMENT AND EXERCISE CAUTION WHERE APPROPRIATE.</p><p>LIMITATIONS OF LIABILITY</p><p>IN NO EVENT WILL WE OR OUR DIRECTORS, EMPLOYEES, OR AGENTS BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY DIRECT, INDIRECT, CONSEQUENTIAL, EXEMPLARY, INCIDENTAL, SPECIAL, OR PUNITIVE DAMAGES, INCLUDING LOST PROFIT, LOST REVENUE, LOSS OF DATA, OR OTHER DAMAGES ARISING FROM YOUR USE OF THE SITE, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.</p><p>INDEMNIFICATION</p><p>You agree to defend, indemnify, and hold us harmless, including our subsidiaries, affiliates, and all of our respective officers, agents, partners, and employees, from and against any loss, damage, liability, claim, or demand, including reasonable attorneys’ fees and expenses, made by any third party due to or arising out of: (1) your Contributions; (2) use of the Site; (3) breach of these Terms of Use; (4) any breach of your representations and warranties set forth in these Terms of Use; (5) your violation of the rights of a third party, including but not limited to intellectual property rights; or (6) any overt harmful act toward any other user of the Site with whom you connected via the Site. Notwithstanding the foregoing, we reserve the right, at your expense, to assume the exclusive defense and control of any matter for which you are required to indemnify us, and you agree to cooperate, at your expense, with our defense of such claims. We will use reasonable efforts to notify you of any such claim, action, or proceeding which is subject to this indemnification upon becoming aware of it.</p><p>USER DATA</p><p>We will maintain certain data that you transmit to the Site for the purpose of managing the performance of the Site, as well as data relating to your use of the Site. Although we perform regular routine backups of data, you are solely responsible for all data that you transmit or that relates to any activity you have undertaken using the Site. You agree that we shall have no liability to you for any loss or corruption of any such data, and you hereby waive any right of action against us arising from any such loss or corruption of such data.</p><p>ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES</p><p>Visiting the Site, sending us emails, and completing online forms constitute electronic communications. You consent to receive electronic communications, and you agree that all agreements, notices, disclosures, and other communications we provide to you electronically, via email and on the Site, satisfy any legal requirement that such communication be in writing. YOU HEREBY AGREE TO THE USE OF ELECTRONIC SIGNATURES, CONTRACTS, ORDERS, AND OTHER RECORDS, AND TO ELECTRONIC DELIVERY OF NOTICES, POLICIES, AND RECORDS OF TRANSACTIONS INITIATED OR COMPLETED BY US OR VIA THE SITE. You hereby waive any rights or requirements under any statutes, regulations, rules, ordinances, or other laws in any jurisdiction which require an original signature or delivery or retention of non-electronic records, or to payments or the granting of credits by any means other than electronic means.</p><p>CALIFORNIA USERS AND RESIDENTS</p><p>If any complaint with us is not satisfactorily resolved, you can contact the Complaint Assistance Unit of the Division of Consumer Services of the California Department of Consumer Affairs in writing at 1625 North Market Blvd., Suite N 112, Sacramento, California 95834 or by telephone at (800) 952-5210 or (916) 445-1254.</p><p>MISCELLANEOUS</p><p>These Terms of Use and any policies or operating rules posted by us on the Site or in respect to the Site constitute the entire agreement and understanding between you and us. Our failure to exercise or enforce any right or provision of these Terms of Use shall not operate as a waiver of such right or provision. These Terms of Use operate to the fullest extent permissible by law. We may assign any or all of our rights and obligations to others at any time. We shall not be responsible or liable for any loss, damage, delay, or failure to act caused by any cause beyond our reasonable control. If any provision or part of a provision of these Terms of Use is determined to be unlawful, void, or unenforceable, that provision or part of the provision is deemed severable from these Terms of Use and does not affect the validity and enforceability of any remaining provisions. There is no joint venture, partnership, employment or agency relationship created between you and us as a result of these Terms of Use or use of the Site. You agree that these Terms of Use will not be construed against us by virtue of having drafted them. You hereby waive any and all defenses you may have based on the electronic form of these Terms of Use and the lack of signing by the parties hereto to execute these Terms of Use.</p><p>CONTACT US</p><p>In order to resolve a complaint regarding the Site or to receive further information regarding use of the Site, please contact us at:</p><p>INTRY, LLC</p><p>info@intry.careers</p></div></div></div>");
$templateCache.put("app/job-search/template/job-alerts.html","<div ng-class=\'scrimPageBackground ? \"scrim\": \"\"\'><nav-bar ng-if=user user=user></nav-bar><div class=login-div ng-if=!user><div class=\"navbar0 navbar-2 navbar-3 w-nav\"><div class=\"container-3 w-container\"><div ng-if=vm.conflictAgent(true) class=agent-conflict><div class=recommendation>{{vm.conflictAgent()}}</div></div><a href=/ class=w-nav-brand><img src=/media/images/IntryLogo-Color.png height=35 class=logoimage></a><nav role=navigation class=\"nav-menu w-nav-menu\"><a href=https://intry.careers/features/ class=\"menu-item w-nav-link\">Features</a> <a href=https://intry.careers/pricing/ class=\"menu-item w-nav-link\">Pricing</a> <a href=/?#/register class=\"menu-item w-nav-link\">Sign up</a> <a href=/ class=\"menu-item w-nav-link\">Log in</a> <a href=/?#/job-search class=\"menu-item w-nav-link\">Job Search</a></nav><div class=\"menu-button w-nav-button\"><div class=\"menu-icon w-icon-nav-menu\"></div></div></div></div></div><section class=main-sec><header><div class=\"page-header-intry job-search-header-intry\"><div class=background-image></div></div></header><div class=container><div class=\"section-center job-search user-info-sec\"><h1 class=job-search-title>Job Alerts</h1><div id=zr_alerts_widget_container class=zr_alerts_widget_container></div></div></div></section></div>");
$templateCache.put("app/job-search/template/job-search.html","<div ng-class=\'scrimPageBackground ? \"scrim\": \"\"\'><nav-bar user=user></nav-bar></div><section class=main-sec><header ng-class=\"getOrganizationCss(\'background-image\')\"><div ng-class=\"getOrganizationCss(\'page-header-intry job-search-header-intry\')\"><div ng-class=\"getOrganizationCss(\'background-image\')\"></div></div></header><div class=container><div style=\"position: relative;top:30px\"><div class=job-search-title>Job Search</div></div><div class=\"job-section-center job-search job-search-info-sec\"><div class=job-search-sec-style><div class=inner-sec><div class=form-row><div class=\"form-group col-md-5\"><label for=search>Search Criteria</label><input type=text class=form-control id=search ng-model=searchData placeholder=\"Search job title or keyword\"></div><div class=\"form-group col-md-5\"><label for=location>Location</label><input type=text class=form-control id=location ng-model=locationData placeholder=\"City, state or zip code\"></div><div class=\"form-group col-md-2\"><button style=\"background-color:#259F9C;height:32px;width:125px;color:#fff;border-radius: .3em;margin-top:26px\" ng-click=searchJob()>Search Jobs</button></div></div></div><div class=inner-sec><div class=form-row><div class=\"form-group col-md-2\"><label for=radius>Miles Radius</label><select class=form-control style=height:35px id=radius ng-model=radiusData><option value=1>With in 1</option><option value=2>With in 2</option><option value=5>With in 5</option><option value=10>With in 10</option><option value=15>With in 15</option><option value=20>With in 20</option></select></div><div class=\"form-group col-md-2\"><label for=daysAgo>Days Ago</label><select class=form-control style=height:35px id=daysAgo ng-model=daysAgoData><option value=1>1</option><option value=7>7</option><option value=14>14</option><option value=21>21</option><option value=30>35</option><option value=45>45</option></select></div><div class=\"form-group col-md-3\"><label for=perPage>Items Per Page</label><select class=form-control style=height:35px id=perPage ng-model=perPageData><option value=5>5</option><option value=10>10</option><option value=15>15</option><option value=20>20</option><option value=50>50</option><option value=100>100</option></select></div></div></div></div><div class=job-search-sec-style style=background-color:#fff;min-height:50px;margin-bottom:15px><div class=inner-sec><div class=form-row><div class=\"form-group col-md-12\"><span>{{numJobs}}</span> <span>Jobs Found</span></div></div><div class=inner-sec></div><div class=form-row><div ng-repeat=\"job in jobData.jobs\" id=job_{{$index}} style=\"border: solid 1px #000000;margin-bottom:10px;width:100%\"><div class=job-item><div class=job-info><div>{{job.name}}</div><div>{{job.hiring_company.name}}</div><div>{{job.location}}</div></div><div class=listButtons><button class=\"btn btn-primary\" style=background-color:#259F9C ng-click=parseDescription($index)>Job 2 Resume</button> <a href={{job.url}} target=_blank class=\"btn btn-primary\" style=background-color:#259F9C>View Full Details</a></div></div><div style=margin-left:5px;margin-top:5px>Days Listed: <span ng-show=\"job.job_age == 0\" style=\"color: #ff0000\">New</span> <span ng-show=\"job.job_age > 0\">{{job.job_age}}</span></div><div style=margin-left:5px>Salary: {{job.salary_min_annual | currency:\"$\":0}} to {{job.salary_max_annual | currency:\"$\":0}}</div><div style=margin-top:5px><div ng-bind-html=job.snippet style=margin-left:5px></div></div></div></div></div></div><div class=\"form-group col-md-12\"><div class=text-center ng-show=\"jobPages.length >= 1\"><a href=javascript:void(0); style=\"color:#259F9C;font-weight: 600\" ng-click=prevPage()>Prev</a> <a href=javascript:void(0); ng-show=\"currGroup > 0\" ng-click=prevGroup() style=\"margin-left:4px;margin-right:4px;color:#259F9C;font-weight: 600\">...</a><div ng-repeat=\"page in jobPages track by $index\" style=display:inline-block id=pageLinks><a href=javascript:void(0); ng-click=pageOf(page-1) ng-class=\"{ \'job-page-underline\': page === currPage+1 }\" style=\"margin-left:4px;margin-right:4px;color:#259F9C;font-weight: 600\">{{page}}</a></div><a href=javascript:void(0); ng-show=\"totalGroups > 1 && currGroup < totalGroups\" ng-click=nextGroup() style=\"margin-left:4px;margin-right:4px;color:#259F9C;font-weight: 600\">...</a> <a href=javascript:void(0); style=\"color:#259F9C;font-weight: 600\" ng-click=nextPage()>Next</a></div></div></div><div id=footer><div><a href=https://www.ziprecruiter.com/jobs id=jobs_widget_link><span>Job Search by</span> <span id=zr_logo_container><img id=zr_logo src=https://www.ziprecruiter.com/img/logos/logo-sm-black-304px.png alt=ZipRecruiter width=120></span></a></div></div></div></section>");
$templateCache.put("app/login/template/login.html","<div ng-class=\"getOrganizationCss(\'body login\')\"><div ng-class=showLoginMessage()><div class=modal><button class=\"btn btn-modal-intry-dismiss\" ng-click=close()></button><h1>You can login as an admin to the {{redirectOrg}} organization at: {{redirectUrl}}</h1><button class=button ng-click=redirectToAdmin()><span>Login</span></button></div></div><div ng-class=showEmailConfirmationMessage()><div class=modal><button class=\"btn btn-modal-intry-dismiss\" ng-click=close()></button><h1>{{emailConfirmationMessage()}}</h1><button class=button ng-click=close()><span>OK</span></button></div></div><div ng-class=showAccountConfirmationMessage()><div class=modal><button class=\"btn btn-modal-intry-dismiss\" ng-click=close()></button><h1>{{accountConfirmationMessage()}}</h1><button class=button ng-click=close()><span>OK</span></button></div></div><div class=signup-section><div class=login-header-container><div src=/media/images/IntryLogo-Color.png height=35 alt=\"\" class=logoimage ng-class=\"getOrganizationCss(\'logoimage\')\"></div><div ng-class=\"getOrganizationCss(\'login-header\')\"><p class=purple-text translate=NEW_LOGIN_SIGN_UP_TITLE ng-if=showPaidSignup()></p><p class=purple-text translate=NEW_LOGIN_SIGN_UP_TITLE_ORGANIZATION ng-if=showCodeSignup()></p><!-- Sign up --> <button ng-click=signupButton() class=\"login-button-desktop w-button\" translate=NEW_LOGIN_SIGN_UP_BTN_TEXT ng-if=showPaidSignup()></button> <button ng-click=signupButton() class=\"login-button-desktop w-button\" translate=NEW_LOGIN_SIGN_UP_BTN_TEXT ng-if=showCodeSignup()></button></div></div><div ng-class=\"getOrganizationCss(\'signup-wrapper-2\')\"><div ng-if=hasOrganization() ng-class=\"getOrganizationCss(\'white-label-login-logo\')\"><div ng-class=\"getOrganizationCss(\'white-label-login-logo-img\')\"></div></div><div ng-class=\"getOrganizationCss(\'signup-form w-row\')\"><div ng-class=loginPanel1CssClass()><!-- <div class=\"login-header-mobile\">\n               <a href=\"#\" class=\"brand w-inline-block\">\n                 <img\n                   src=\"/media/images/IntryLogo-Color.png\"\n                   height=\"35\"\n                   alt=\"\"\n                   class=\"logoimage\"\n                   >\n               </a>\n          </div> --><div ng-class=\"getOrganizationCss(\'signup-container\')\"><h2 ng-class=\"getOrganizationCss(\'heading signup\')\" translate=NEW_LOGIN_SIGN_IN_TITLE></h2><h2 ng-class=\"getOrganizationCss(\'sub-heading signup\')\" translate=NEW_LOGIN_SIGN_IN_SUB_TITLE></h2><div class=form-wrapper-signup><div class=\"form-block-2 w-form\"><form id=email-form name=email-form ng-submit=vm.login() data-name=\"Registration Form\" class=form-2><!-- Email --><label for=Username ng-class=\"getOrganizationCss(\'para-small signup\')\" translate=NEW_LOGIN_USERNAME_LABEL></label><input ng-model=vm.email ng-change=\"vm.failLogin=false;\" type=text ng-class=\"vm.failLogin ? getOrganizationCss(\'text-field-full w-input ng-invalid\') :getOrganizationCss(\'text-field-full w-input\')\" maxlength=256 name=Username data-name=Username placeholder=\"{{\'NEW_LOGIN_USERNAME_PLACEHOLDER\' | translate}}\" id=Username required autocapitalize=none><!-- Password --><label for=Password class=\"para-small signup\" ng-class=\"getOrganizationCss(\'para-small signup\')\" translate=NEW_LOGIN_PASSWORD_LABEL></label><input ng-model=vm.password ng-change=\"vm.failLogin=false;\" ng-class=\"vm.failLogin ? getOrganizationCss(\'text-field-full w-input ng-invalid\') :getOrganizationCss(\'text-field-full w-input\')\" type=password maxlength=256 name=Password data-name=Password placeholder=\"{{\'NEW_LOGIN_PASSWORD_PLACEHOLDER\' | translate}}\" id=Password required><!-- Sign in --><div class=form-submit-wrapper-2><input type=submit value=\"{{\'NEW_LOGIN_SIGN_IN_BTN_TEXT\' | translate}}\" data-wait=\"{{\'NEW_LOGIN_SIGN_IN_BTN_DATA_WAIT\' | translate}}\" ng-class=\"getOrganizationCss(\'cta signup w-button\')\"><div ng-class=\"getOrganizationCss(\'pricing-smallest freeep\')\">{{\'NEW_LOGIN_TERMS_PREFIX\' | translate}}<a href=https://intry.careers/legal target=_blank ng-class=\"getOrganizationCss(\'register-link\')\" translate=NEW_LOGIN_TERMS_LINK></a>{{\'NEW_LOGIN_TERMS_SUFFIX\' | translate}}<br><a href=javascript: ng-class=\"getOrganizationCss(\'hint\')\" ng-click=vm.resetPassword()>Forgot password?</a></div></div></form><div class=\"success-message-2 w-form-done\"><div class=success-alert><img src=https://s3.amazonaws.com/static.intry.careers/images/check-circle_1check-circle.png alt=\"\" class=image-7><div class=\"para-small alert\">{{\'NEW_LOGIN_SUCCESS_MSG\' | translate}}<br></div></div></div><div ng-show=vm.failLogin class=\"error-message-3 w-form-fail display-block\"><div class=error-message-text-2>{{vm.loginError ? vm.loginError : (\'NEW_LOGIN_ERROR_MSG\' | translate)}}</div></div></div></div></div></div><div ng-class=\"getOrganizationCss(\'signup-content-wrapper w-col w-col-6\')\"><!-- <div class=\"login-header\">\n               <p class=\"purple-text\" translate=\"NEW_LOGIN_SIGN_UP_TITLE\"></p>\n               \n               \n               <a href=\"/?#/register\" class=\"login-button-desktop w-button\" translate=\"NEW_LOGIN_SIGN_UP_BTN_TEXT\"></a>\n          </div> --><div class=video-door-container><div ng-class=\"getOrganizationCss(\'video-container\')\"><video autoplay muted loop width=250 class=video-cont><source src=media/intry_video.mp4 type=video/mp4></video><div src=/media/images/door.png alt=\"\" ng-class=\"getOrganizationCss(\'image-door\')\"></div></div></div><!-- <div class=\"quote-heading quote\">\n               <h2 class=\"heading-white signup\"></h2>\n               <img src=\"https://s3.amazonaws.com/static.intry.careers/images/quoteRegister.svg\" width=\"40\" alt=\"\" class=\"image-8\">\n          </div> --><!-- <div class=\"signup-box\">\n               <p class=\"white-text signup-test-p\">{{ currentQuote.body }}<br></p>\n               <p class=\"white-text testimonial-person\">-Â {{ currentQuote.author }}<br></p>\n               <p class=\"white-text\">{{ currentQuote.city }}, {{ currentQuote.state }}<br></p>\n          </div> --><!-- <div class=\"wrapper-div-pricing\">\n               <p class=\"white-2\" translate=\"NEW_LOGIN_SIGN_UP_FOOTER\"></p>\n          </div> --></div></div></div></div></div>");
$templateCache.put("app/login/template/login.view.html","<nav-bar hide-side=true verification-status-message=verificationStatus email-verification-status-message=emailVerificationStatus></nav-bar><div id=register-screen><div class=background><div class=gradient></div></div><div class=content-wrapper><div class=welcome-text><div class=block1 translate=SIGN_UP_LEFT_PANEL_BLOCK_1></div><div><span class=block1-1 translate=SIGN_UP_LEFT_PANEL_BLOCK_1_1></span> <span translate=SIGN_UP_LEFT_PANEL_BLOCK_1_2></span> <span class=block1-3 translate=SIGN_UP_LEFT_PANEL_BLOCK_1_3></span></div><div class=\"block2 spacer\" translate=SIGN_UP_LEFT_PANEL_BLOCK_2></div><div class=block2 translate=SIGN_UP_LEFT_PANEL_BLOCK_2_1></div><div class=block3><span translate=SIGN_UP_LEFT_PANEL_BLOCK_3></span><!-- <span class=\'block1-3\' translate=\'SIGN_UP_LEFT_PANEL_BLOCK_3_1\'></span> --></div><div class=spacer><div translate=SIGN_UP_LEFT_PANEL_BLOCK_4></div><div class=block4 translate=SIGN_UP_LEFT_PANEL_BLOCK_4_1></div><div class=block4-1><a href=#register-footer target=_self>Learn More...</a></div></div><div class=spacer><div translate=SIGN_UP_LEFT_PANEL_BLOCK_5></div><div class=block4 translate=SIGN_UP_LEFT_PANEL_BLOCK_5_1></div><div class=block4-1><a href=https://intry.careers/pricing/ target=_blank>Pricing info</a></div></div></div><form name=registerForm><h1 translate=SIGN_UP_SECTION_TITLE></h1><h4 translate=SIGN_UP_SECTION_SUBTITLE></h4><div class=\"form-el half\"><input type=text ng-model=newUser.firstname placeholder=\"{{\'SIGN_UP_FORM_FIRST_NAME_PLACEHOLDER_TEXT\' | translate}}\" name=firstName ng-focus=\"formSetup.startedToRegister = true;\" validator=required valid-method=change required-error-message=\"<div></div>\" required-success-message=\"<i class=\'success\'></i>\"></div><div class=\"form-el half\"><input type=text ng-model=newUser.lastname placeholder=\"{{\'SIGN_UP_FORM_LAST_NAME_PLACEHOLDER_TEXT\' | translate}}\" name=lastName ng-focus=\"formSetup.startedToRegister = true\" validator=required valid-method=change required-error-message=\"<div></div>\" required-success-message=\"<i class=\'success\'></i>\"></div><div class=form-el ng-class=\"(status.isUsernameFieldBlur ? \'username-blur\': \'\')\"><input id=create-email type=text autocomplete=username name=username ng-class=\"(formSetup.alreadyRegistered ? \'already-registered\' : \'\')\" ng-model=newUser.emailPhone placeholder=\"{{\'SIGN_UP_FORM_MOBILE_OR_EMAIL_PLACEHOLDER_TEXT\' | translate}}\" ng-focus=\"formSetup.startedToRegister = true; formSetup.alreadyRegistered = false; status.isUsernameFieldBlur=false\" validator=\"required, username\" ng-blur=\"status.isUsernameFieldBlur=true; isUserAlreadyRegistered();\" valid-method=blur required-error-message=\"<div class=\'too-short username-error\' ng-if=\'!formSetup.alreadyRegistered\'>{{\'SIGN_UP_FORM_ERROR_INVALID_FORMATE\' | translate}}</div>\" required-success-message=\"<div></div>\" username-error-message=\"<div class=\'too-short username-error\' ng-if=\'!formSetup.alreadyRegistered\'>{{\'SIGN_UP_FORM_ERROR_INVALID_FORMATE\' | translate}}</div>\" username-success-message=\"<div></div>\"><div class=too-short ng-if=formSetup.alreadyRegistered translate=SIGN_UP_FORM_EMAIL_ALREADY_IN_USE_TEXT></div></div><div class=form-el><div class=password-hint ng-show=formSetup.passwordHint><p><strong translate=SIGN_UP_FORM_PASSWORD_STRENGTH_TEXT></strong> {{passwordStrength == 1 ? \'Fair\': passwordStrength == 2 ? \'Good\' : passwordStrength == 3 ? \'Excellent\' : \'\'}}</p><p></p><div class=strength-meter><div class=strength-meter-fill data-strength={{passwordStrength}}></div></div><p></p><p translate=SIGN_UP_FORM_PASSWORD_STRENGTH_MESSAGE_TEXT></p></div><input id=password name=password class=ok-password type=password autocomplete=password ng-model=newUser.password placeholder=\"{{\'SIGN_UP_FORM_NEW_PASSWORD_PLACEHOLDER_TEXT\' | translate}}\" ng-focus=\"formSetup.passwordHint = true; formSetup.startedToRegister = true; passwordFocused = false;\" ng-blur=\"formSetup.passwordHint = false; passwordFocused = true\" ng-minlength=8><div class=too-short ng-show=\"!registerForm.password.$valid && passwordFocused\" translate=SIGN_UP_FORM_PASSWORD_TOO_SHORT_TEXT></div></div><div class=form-row><div class=form-el><input id=password2 name=password2 class=ok-password type=password ng-model=newUser.password2 compare-to=newUser.password placeholder=\"{{\'SIGN_UP_FORM_RE_ENTER_PASSWORD_PLACEHOLDER_TEXT\' | translate}}\" ng-focus=\"password2focused = false;\" ng-blur=\"password2focused = true;\" ng-style=\"{\'visibility\': formSetup.startedToRegister?\'visible\':\'hidden\'}\"><div class=too-short ng-show=\"!registerForm.password2.$valid && password2focused\" translate=SIGN_UP_FORM_PASSWORD_DOSENOT_MATCH_TEXT></div></div><div class=\"form-el create-button-container\"><button type=submit class=create ng-class=\"(registerForm.$valid && !formSetup.alreadyRegistered) ? \'form-valid\' : \'\'\" ng-click=requestCreate() validation-submit=registerForm>{{\'SIGN_UP_FORM_CREATE_ACCOUNT_BUTTON_TEXT\' | translate}}</button></div><div class=terms ng-style=\"{\'visibility\': registerForm.$valid?\'visible\':\'hidden\'}\" translate=SIGN_UP_FORM_INTRY_USER_AGREEMENT_MESSAGE_TEXT></div><!--       <div class=\"terms\" ng-style=\"{\'visibility\': registerForm.$valid?\'visible\':\'hidden\'}\">\n                  By clicking Create Account, you agree to the <a ng-href=\'#/intry-agreement\' target=\"_blank\" class=\'agreementLink\'>Intry User Agreement</a>, <a ng-href=\'#/privacy-policy\' target=\"_blank\" class=\'agreementLink\'>Privacy Policy</a>, and <a ng-href=\'#/cookie-policy\' target=\"_blank\" class=\'agreementLink\'>Cookie Policy</a>.\n              </div> --></div><div class=form-row><div class=\"form-el half\" ng-class=\"!ieBrowser?\'half\':\'\'\"><button fb-login type=button class=facebook><div class=\"icon fa fa-facebook\"></div><div class=text translate=USE_FACEBOOK_TEXT></div></button></div><div class=\"form-el half\" ng-if=!ieBrowser><button linked-in type=button class=linkedin><div class=\"icon fa fa-linkedin-square\"></div><div class=text translate=USE_LINKEDIN_TEXT></div></button></div></div></form></div></div><div id=register-footer name=register-footer><div class=content-wrapper><div class=footer-title translate=SIGN_UP_FOOTER_TITLE></div><div class=\"footer-block footer-block1\"><h2 translate=SIGN_UP_FOOTER_BLOCK_1_TITLE style=padding-top:20px></h2><div translate=SIGN_UP_FOOTER_BLOCK_1_TEXT></div><div class=branded-text translate=SIGN_UP_FOOTER_BLOCK_1_1_TEXT></div></div><div class=\"footer-block footer-block2\"><h2 translate=SIGN_UP_FOOTER_BLOCK_2_TITLE></h2><div translate=SIGN_UP_FOOTER_BLOCK_2_TEXT></div><div class=branded-text translate=SIGN_UP_FOOTER_BLOCK_2_1_TEXT></div></div><div class=\"footer-block footer-block3\"><h2 translate=SIGN_UP_FOOTER_BLOCK_3_TITLE></h2><div translate=SIGN_UP_FOOTER_BLOCK_3_TEXT></div><div class=branded-text translate=SIGN_UP_FOOTER_BLOCK_3_1_TEXT></div></div></div></div><div id=register-banner><span class=title translate=SIGN_UP_BANNER_TITLE></span><span class=text translate=SIGN_UP_BANNER_TEXT></span></div><div id=trueYou-by-intry><div class=trueyoubyintry><img src=//s3.amazonaws.com/static.intry.careers/images/webapp/TrueYou-By-Intry.svg></div></div><div><div class=intryvideo><iframe width=560 height=315 src=\"https://www.youtube.com/embed/gNW3W__4EKE?rel=0&amp;showinfo=0\" frameborder=0 allow=\"autoplay; encrypted-media\" allowfullscreen></iframe></div></div><div id=footer class=footer><div class=colophon><div class=inner-wrap><div class=footer-widget><div class=footer-title>Learn More</div><div class=menu-container><ul class=menu><li><a target=_blank href=https://www.intrycareers.com>Overview</a></li><li><a target=_blank href=https://www.intrycareers.com/why-intry>Why Intry?</a></li><li><a target=_blank href=https://www.intrycareers.com/pricing-plans>Pricing</a></li></ul></div></div><div class=footer-widget><div class=footer-title>Support</div><div class=menu-container><ul class=menu><!--<li class=\"\"><a target=\"_blank\" href=\"https://intry.freshdesk.com\">Help Center &amp; FAQs</a></li>--><li><a target=_blank href=https://www.intrycareers.com/contact>Contact Support</a></li><!-- KSH - Could make this work with AWS --><!--<li class=\"\"><a target=\"_blank\" href=\"https://intry.careers/support/status/\">System Status</a></li>--></ul></div></div><div class=footer-widget><div class=footer-title>Legal</div><div class=menu-container><ul class=menu><li><a target=_blank href=https://www.intrycareers.com/legal/#terms>Terms of Use</a></li><li><a target=_blank href=https://www.intrycareers.com/legal/#privacy>Privacy Policy</a></li><li><a target=_blank href=https://www.intrycareers.com/legal/#cookie>Cookie Policy</a></li></ul></div></div><div class=footer-widget><div class=footer-title>Company</div><div class=menu-container><ul class=menu><li><a target=_blank href=https://www.intrycareers.com/about/ >About Intry</a></li><li><a target=_blank href=https://www.intrycareers.com/contact>Contact Us</a></li></ul></div></div></div></div><div class=social><div class=footer-links><div class=facebook><a target=_blank href=https://www.facebook.com/intrycareers title=Facebook>&nbps;</a></div><div class=twitter><a target=_blank href=https://twitter.com/intrycareers title=Twitter>&nbps;</a></div><div class=linkedin><a target=_blank href=https://www.linkedin.com/company/intrycareers title=LinkedIn>&nbps;</a></div><div class=instagram><a target=_blank href=https://www.instagram.com/intrycareers title=Instagram>&nbps;</a></div><div class=youtube><a target=_blank href=https://www.youtube.com/channel/UCj3Uj3Y-Tyhrh_27XyWTpWQ title=YouTube>&nbps;</a></div></div></div></div>");
$templateCache.put("app/login/template/maintenance.html","<div ng-class=\"getOrganizationCss(\'body login\')\"><div class=signup-section><div class=login-header-container><img src=/media/images/IntryLogo-Color.png height=35 alt=\"\" class=logoimage><div class=login-header><p class=purple-text translate=NEW_LOGIN_SIGN_UP_TITLE_MAINT></p></div></div><div ng-class=\"getOrganizationCss(\'signup-wrapper-2\')\"><div ng-if=hasOrganization() ng-class=\"getOrganizationCss(\'white-label-login-logo\')\"><div ng-class=\"getOrganizationCss(\'white-label-login-logo-img\')\"><h2 class=organization-name>{{getOrganizationName()}}</h2></div></div><div ng-class=\"getOrganizationCss(\'signup-form w-row\')\"><div ng-class=loginPanel1CssClass()><div class=signup-container><h2 class=\"heading signup\" translate=NEW_LOGIN_SIGN_IN_TITLE_MAINT></h2><h2 class=\"sub-heading signup\" translate=NEW_LOGIN_SIGN_IN_SUB_TITLE_MAINT></h2><div class=form-wrapper-signup><div class=\"form-block-2 w-form\"><p>Access is temporarily limited while we resolve an issue with our resume parsing service. We are working hard to fix the problem and expect to return soon. Contact support@intrycareers.com if you have questions.</p></div></div></div></div><div ng-if=!hasOrganization() class=\"signup-content-wrapper w-col w-col-6\"><div class=video-door-container><div class=video-container><video autoplay muted loop width=250 class=video-cont><source src=/media/intry_careers.mp4 type=video/mp4></video><img src=/media/images/door.png alt=\"\" class=image-door></div></div></div></div></div></div></div>");
$templateCache.put("app/my-account/template/cancel-subscription-confirmation-dialog.html","<div class=\"modal-intry cancel-subscription-confirmation-dialog\"><div class=header-container translate=USER_PROFILE_CANCEL_SUBSCRIPTION_CONFIRMATION_TITLE></div><!--\n  <div class=\"body-container\" translate=\"USER_PROFILE_CANCEL_SUBSCRIPTION_CONFIRMATION_MESSAGE\"></div>\n  --><div class=body-container></div><div class=\"row action-container\"><div class=col-6><a ng-click=closeDialog() translate=USER_PROFILE_CANCEL_SUBSCRIPTION_CANCEL></a></div><div class=col-6><a ng-click=cancelSubscription() translate=USER_PROFILE_CANCEL_SUBSCRIPTION_OK></a></div></div><div class=waiting-container ng-if=loaderModal><div class=spinner-container><i class=\"fas fa-circle-o-notch fa-spin load\"></i></div></div></div><form style=display:none><button type=submit id=barecancel-trigger>TEST ME</button></form><script>!function() {\n    if (window.barecancel && window.barecancel.created) {\n	window.console && console.error && console.error(\"Barecancel snippet included twice.\");\n    }\n    else {\n	window.barecancel = {created: !0};\n	var a = document.createElement(\"script\");\n	a.src = \"https://baremetrics-barecancel.baremetrics.com/js/application.js\",a.async = !0;\n	var b = document.getElementsByTagName(\"script\")[0];\n	b.parentNode.insertBefore(a, b);\n	window.barecancel.params = {\n	    access_token_id: \"0a14d001-d2ef-43f2-97f2-4b0823f2f42b\", // Your Cancellation API public key\n	    customer_oid: \"<example_customer_123>\" // The provider id of this customer. For example, the Stripe Customer ID\n	};\n    }\n    return true;\n}();</script>");
$templateCache.put("app/my-account/template/card-billing-confirmation-dialog.html","<div class=\"modal-intry card-billing-confirmation-dialog\"><div class=card-confirm-container ng-if=loaderModal><div class=spinner-container><i class=\"fas fa-circle-o-notch fa-spin load\"></i></div></div><div class=top-image><img src=https://s3.amazonaws.com/static.intry.careers/images/webapp/profle-color-intry-logo.png></div><div class=\"section section-active\"><div class=intry-llc>{{\'USER_PROFILE_CARD_BILLING_CONFIRMATION_TITLE\' | translate}}</div><div class=charge-notification>{{\'USER_PROFILE_CARD_BILLING_CONFIRMATION_MESSAGE\' | translate}}</div><div class=line></div><div class=action><a ng-click=closeWaitingDialog() class=back>{{\'USER_PROFILE_BACK\' | translate}}</a> <a class=pay ng-click=updateSubscriptions()><p translate=USER_PROFILE_CARD_BILLING_AMOUNT translate-values=\"{ amount_to_charge: (amountToCharge | currency: \'$\' : 2) }\"></p></a></div></div></div>");
$templateCache.put("app/my-account/template/my-account.html","<div class=my-account><div ng-class=\'scrimPageBackground ? \"scrim\": \"\"\' style=\"position: relative\"><nav-bar user=user></nav-bar><header ng-class=\"getOrganizationCss(\'header\', true)\"></header><paywall-dialog success=\"paymentSuccess(updatedUser, closed)\" error=paymentError(error) active=paymentRequired user=user></paywall-dialog><div class=container-my-account><div class=row><div class=container-myaccount><div class=row><div class=\"col-12 p-5 mb-3 mt-3 bg-light rounded no-background\"><div class=upload-user-img><div class=circle><img class=profile-pic src=/media/images/user-avatar.svg ng-if=defaultImage> <img class=profile-pic ng-src={{user.profile_picture_url}} ng-if=!defaultImage></div><div class=profile-avatar-button-container-delete-white-space ng-show=defaultImage></div><div class=profile-avatar-button-container-delete ng-show=!defaultImage><label><img class=avatar-button-img-delete src=/media/images/delete-ico.svg ng-click=showImageLoaderForDelete()></label></div><!--\n                    <div class=\"p-image\">\n                        <img class=\"upload-button\" src=\"/media/images/add-ico.svg\" />\n                        <input class=\"file-upload\" type=\"file\" accept=\"image/*\" ondrop=\"event.dataTransfer.dropEffect=\'none\';event.stopPropagation(); event.preventDefault();\" id=\"file\" class=\"upload-button\" onchange=\"angular.element(this).scope().selectProfileImage(this.files)\" autocomplete=\"off\" onclick=\"this.value = null\"/>\n                    </div>\n                    --><div class=profile-avatar-button-container><input class=profile-avatar-input-file type=file accept=image/* ondrop=\"event.dataTransfer.dropEffect=\'none\';event.stopPropagation(); event.preventDefault()\" id=file class=upload-button onchange=angular.element(this).scope().selectProfileImage(this.files) autocomplete=off onclick=\"this.value = null\"><label for=file><div ng-class=\"getOrganizationCss(\'profile-avatar-button-img\')\" src=/media/images/add-ico.svg></div></label></div></div><h1 class=text-center>{{user.first_name_current | capitalize}} <span ng-show=\"user.first_name_current && user.last_name_current\"></span> {{user.last_name_current | capitalize}}</h1><h3 class=text-center>{{user.username}}</h3><h3 ng-show=\"user.city || user.state\" class=text-center>{{user.city}}<span ng-show=\"user.city && user.state\">,</span> {{user.state}}</h3><h3 ng-show=hasOrganization() class=text-center style=font-size:100%>Organization: {{getOrganizationName()}}</h3></div></div><div class=\"row second-container\"><div class=\"col-12 p-5 col-md-6 mb-3 bg-light column-left\"><div id=billing><div ng-show=!subscriptionPaused class=next-charge ng-class=\"{ \'next-charge\':!overDue,\'next-charge-pink\':overDue }\"><table><tr><td><div id=your-next-charge class=grey-title ng-class=\"{ \'text-white\':overDue }\" translate=USER_PROFILE_NEXT_CHARGE_TITLE_TEXT></div></td><td><div ng-class=\"getOrganizationCss(\'link-button-retry\')\" ng-click=retryPayment() ng-show=overDue translate=USER_PROFILE_RETRY_PAYMENT_TITLE_TEXT></div></td></tr></table><div><div ng-show=\"!overDue && !nextBillingDate\" class=black-title-basic>No Plan</div><div ng-hide=\"overDue || !nextBillingDate\" class=black-title-basic>{{nextBillingDate * 1000 | date:\'MM/dd/yyyy\'}}</div><div id=due-now ng-show=overDue class=white-title-basic translate=USER_PROFILE_PAYMENT_DUE_TEXT></div><div class=sub-amount ng-class=\"{ \'text-pink\':!overDue,\'text-white\':overDue }\">{{total | currency: \'$\' : 2}}</div></div><div class=\"bottom-brief text-white\" ng-show=overDue translate=USER_PROFILE_OVERDUE_MESSAGE_TEXT></div></div><div class=subscription><div class=grey-title translate=USER_PROFILE_SUBSCRIPTION_TITLE_TEXT></div><div class=subscription-paused ng-show=\"subscriptionPaused && user.stripe_customerID && subscriptionEndsDate\"><p style=font-size:100% class=paused-message>{{ \'USER_PROFILE_ACCOUNT_PAUSED\' | translate }} <span>Your data will be available until {{subscriptionEndsDate * 1000 | date:\'MM/dd/yyyy\'}}.</span> <span style=font-size:100% class=\"link-button reactivate\" ng-class=\"getOrganizationCss(\'link-button reactivate\')\" ng-click=reactivateSubscription() translate=USER_PROFILE_PAUSE_LINK_BUTTON_REACTIVATE_TEXT></span></p></div><div class=subscription-paused ng-show=\"subscriptionPaused && user.stripe_customerID && !subscriptionEndsDate\"><p class=paused-message>{{ \'USER_PROFILE_ACCOUNT_PAUSED\' | translate }} <span ng-class=\"getOrganizationCss(\'link-button reactivate\')\" ng-click=reactivateSubscription() translate=USER_PROFILE_PAUSE_LINK_BUTTON_REACTIVATE_TEXT></span></p></div><div class=subscription-create ng-show=\"subscriptionPaused && !user.stripe_customerID\"><p class=create-message><span class=create></span></p></div><table ng-show=!subscriptionPaused><tr ng-show=!plansSubscribed[0]><td width=50% colspan=2><div ng-show=freeTrialExpires class=sub-title>Free Trial Expires: {{freeTrialExpires | date:\'MM/dd/yyyy\'}}</div><div ng-show=\"!user.stripe_customerID && !freeTrialExpires\" class=sub-title>Expired</div><div ng-show=\"user.stripe_customerID && !freeTrialExpires\" class=sub-title>None</div></td><td width=50%><div class=std-right>&nbsp;</div></td></tr><tr ng-hide=!plansSubscribed[0]><td width=50% colspan=2><div class=sub-title>{{plansSubscribed[0].statement_descriptor}}</div></td><td width=50%><div class=std-right>{{plansSubscribed[0].subTotal | currency: \'$\' : 2}}/{{plansSubscribed[0].interval}}</div></td></tr><!--<tr>\n                        <td>\n                          <div class=\"sub-title-right\">{{plansSubscribed[0].name}}</div>\n                        </td>\n                        <td colspan=\"2\">\n                          <div class=\"std-right\">{{plansSubscribed[0].amount | currency: \'$\' : 2}}/mo</div>\n                        </td>\n                    </tr>--><tr ng-show=showDiscount><td><div class=sub-title-right>{{discount.id}}</div></td><td><div class=std-right>-{{discount.amount | currency: \'$\' : 2}}/{{plansSubscribed[0].interval}}</div></td></tr><tr><td colspan=3><div class=hline ng-if=showAddonsManage></div></td></tr><tr ng-hide=!plansSubscribed[0]><td colspan=3><div ng-class=\"getOrganizationCss(\'highlight\')\"><div class=sub-title-highlight>Total</div><div class=std-right-highlight>{{total | currency: \'$\' : 2}}/{{plansSubscribed[0].interval}}</div></div></td></tr></table></div><div class=payment-info><table><tr><td><div class=grey-title-left translate=USER_PROFILE_PAYMENT_INFORMATION_TITLE_TEXT></div></td></tr><tr><td><div class=black-title-basic translate=USER_PROFILE_PAYMENT_METHOD_TITLE_TEXT></div></td><td><div ng-class=\"getOrganizationCss(\'link-button\')\" ng-click=processCard(element)><span ng-if=showForm>{{\'USER_PROFILE_SAVE_LINK_BUTTON_TEXT\' | translate}}</span> <span ng-if=!showForm>{{\'USER_PROFILE_CHANGE_LINK_BUTTON_TEXT\' | translate}}</span></div></td></tr><tr><td><div class=card-form ng-show=showForm><form name=payment-form><div class=customer-name><input id=card_name type=text placeholder=Name></div><stripe-element instance=$ctrl.element><!-- a Stripe Element will be inserted here. --></stripe-element><div id=card-errors class=card-errors role=alert translate=USER_PROFILE_CARD_ERROR translate-values=\"{ card_error: cardErrors }\"></div></form></div><div class=black-title-basic ng-hide=showForm><div>{{brand}}:.... .... .... {{last4}}</div></div></td></tr></table></div></div></div><div class=\"col-12 pt-3 col-md-6 mb-3 bg-light column-right\"><div id=account class=\"payment-info big-container-info\"><div class=grey-title translate=USER_PROFILE_YOUR_ACCOUNT_TITLE_TEXT></div><table><tr><td><div class=black-title-basic translate=USER_PROFILE_PERSONAL_INFO_TITLE_TEXT></div></td><td><div ng-class=\"getOrganizationCss(\'link-button\')\" ng-click=changeAddress() set-focus=first_name ng-show=disableAddressChange translate=USER_PROFILE_CHANGE_LINK_BUTTON_TEXT></div><div ng-class=\"getOrganizationCss(\'link-button\')\" ng-click=cancelChangeAddress() ng-show=!disableAddressChange translate=USER_PROFILE_CANCEL_LINK_BUTTON_TEXT></div><div ng-class=\"getOrganizationCss(\'link-button save-link-button\')\" ng-click=updatePersonalData() ng-show=!disableAddressChange translate=USER_PROFILE_SAVE_LINK_BUTTON_TEXT></div></td></tr><tr><td><p class=personal-data-error ng-if=errorMessage>{{errorMessage}}</p></td></tr><tr><td colspan=2><input type=text ng-model=user.first_name_current id=first_name name=first_name ng-readonly=disableAddressChange class=\"text-box profile-input-half\" placeholder=\"{{\'USER_PROFILE_FIRST_NAME\' | translate}}\"> <input type=text ng-model=user.last_name_current name=last_name ng-readonly=disableAddressChange class=\"text-box profile-input-half\" placeholder=\"{{\'USER_PROFILE_LAST_NAME\' | translate}}\"></td></tr><tr><td><input type=text name=street ng-model=user.street ng-readonly=disableAddressChange class=\"text-box profile-input\" placeholder=\"{{\'USER_PROFILE_STREET\' | translate}}\"></td><td><input type=text name=street_2 ng-model=user.street_2 ng-readonly=disableAddressChange class=\"text-box profile-input\" placeholder=\"{{\'USER_PROFILE_STREET_2\' | translate}}\"></td></tr><tr><td><input type=text name=city ng-model=user.city ng-readonly=disableAddressChange class=\"text-box profile-input\" placeholder=\"{{\'USER_PROFILE_CITY\' | translate}}\"></td><td><input type=text name=state ng-model=user.state ng-readonly=disableAddressChange class=\"text-box profile-input\" placeholder=\"{{\'USER_PROFILE_STATE\' | translate}}\"></td></tr><tr><td><input type=text name=country ng-model=user.country ng-readonly=disableAddressChange class=\"text-box profile-input\" placeholder=\"{{\'USER_PROFILE_COUNTRY\' | translate}}\"></td><td><input type=text name=postal_code ng-model=user.postal_code ng-readonly=disableAddressChange class=\"text-box profile-input\" placeholder=\"{{\'USER_PROFILE_POSTAL_CODE\' | translate}}\"></td></tr><tr><td><input type=text name=phone_number ng-model=user.phone_number.number ng-readonly=disableAddressChange class=\"text-box profile-input\" ng-focus=phoneFlatten() ng-blur=phoneDisplay() placeholder=\"{{\'USER_PROFILE_PHONE_NUMBER\' | translate}}\" ng-required=validatePhone ng-pattern=phonePattern></td></tr><!--<tr>\n                        <td>\n                          <div class=\"black-title-wp\" translate=\"USER_PROFILE_CONNECTED_ACCOUNTS_TITLE_TEXT\"></div>\n                        </td>\n                      </tr>\n                  <tr>\n                    <td>\n                      <div class=\"username-exists-error\" name=\"socialAccountConnectError\" ng-show=\"showSocialAccountConnectError\">{{showSocialAccountConnectError}}</div>\n                    </td>\n                  </tr>\n                  <tr>\n                    <td>\n                      <div class=\"sub-title\" translate=\"USER_PROFILE_FACEBOOK_TITLE_TEXT\"></div>\n                    </td>\n                    <td>\n                      <div class=\"link-button\" fb-login ng-show=\"!showDisconnectForFacebook\">{{\'USER_PROFILE_CONNECT_LINK_BUTTON_TEXT\' | translate}}</div>\n                      <div class=\"link-button\" ng-click=\"disconnectSocialAccount(\'facebook\')\" ng-show=\"showDisconnectForFacebook\" translate=\"USER_PROFILE_DISCONNECT_LINK_BUTTON_TEXT\"></div></td>\n                  </tr>\n                  <tr>\n                    <td>\n                      <div class=\"sub-title\" translate=\"USER_PROFILE_LINKEDIN_TITLE_TEXT\"></div>\n                    </td>\n                    <td>\n                      <div class=\"link-button\" linked-in ng-show=!showDisconnectForLinkedIN>{{\'USER_PROFILE_CONNECT_LINK_BUTTON_TEXT\' | translate}}</div>\n                      <div class=\"link-button\" ng-click=\"disconnectSocialAccount(\'linkedIN\')\" ng-show=\"showDisconnectForLinkedIN\" translate=\"USER_PROFILE_DISCONNECT_LINK_BUTTON_TEXT\"></div>\n                    </td>\n                  </tr>--><tr><td colspan=2><div class=fline></div></td></tr><tr><td colspan=2><div ng-class=\"getOrganizationCss(\'change-email-status account-confirm\')\" ng-show=showEmailConfirmationMessage><p translate=USER_PROFILE_EMAIL_STATUS_MESSAGE_TEXT></p></div></td></tr><tr><td><div class=black-title-wp translate=USER_PROFILE_EMAIL_TITLE_TEXT></div></td><td><div class=link-button ng-class=\"getOrganizationCss(\'link-button\')\" ng-click=changeEmail() set-focus=email ng-show=disableEmailChange translate=USER_PROFILE_CHANGE_LINK_BUTTON_TEXT></div><div ng-class=\"getOrganizationCss(\'link-button\')\" ng-click=confirmEmail() ng-show=\"disableEmailChange && showEmailConfirmationMessage\" translate=USER_PROFILE_CONFIRM_LINK_BUTTON_TEXT></div><div ng-class=\"getOrganizationCss(\'link-button\')\" ng-click=cancelChangeEmail() ng-show=!disableEmailChange translate=USER_PROFILE_CANCEL_LINK_BUTTON_TEXT></div><div ng-class=\"getOrganizationCss(\'link-button save-link-button\')\" ng-click=\"emailForm.email && saveEmail()\" ng-show=!disableEmailChange translate=USER_PROFILE_SAVE_LINK_BUTTON_TEXT></div></td></tr><tr><td ng-form=emailForm><input id=email type=email name=email id=email class=text-box ng-model=user.email ng-readonly=disableEmailChange placeholder=\"{{\'USER_PROFILE_EMAIL_ADDRESS\' | translate}}\" ng-pattern=emailPattern></td><td><span class=error ng-show=!emailForm.email.$valid>{{ \'USER_PROFILE_INVALID_EMAIL\' | translate }}</span></td></tr><tr><td colspan=2><div class=fline></div></td></tr><tr><td colspan=2><div class=\"change-password-message account-confirm\" ng-show=changePasswordMessage><p>{{changePasswordMessage}}</p></div></td></tr><tr><td><div class=black-title-wp translate=USER_PROFILE_PASSWORD_TITLE_TEXT></div></td><td><div ng-class=\"getOrganizationCss(\'link-button\')\" ng-click=changePassword() set-focus=password ng-show=disablePaswordChange translate=USER_PROFILE_CHANGE_LINK_BUTTON_TEXT></div><div ng-class=\"getOrganizationCss(\'link-button\')\" ng-click=cancelChangePassword() ng-show=!disablePaswordChange translate=USER_PROFILE_CANCEL_LINK_BUTTON_TEXT></div><div ng-class=\"getOrganizationCss(\'link-button save-link-button\')\" ng-click=\"passwordForm.password.$valid && savePassword()\" ng-show=!disablePaswordChange translate=USER_PROFILE_SAVE_LINK_BUTTON_TEXT></div></td></tr><tr><td><div class=password-container ng-form=passwordForm><input id=password name=password class=text-box ng-attr-type=\"{{showPassword ? \'text\' : \'password\'}}\" type=password ng-model=user.password ng-minlength=8 ng-readonly=disablePaswordChange ng-blur=\"passwordFocused = true\" placeholder=\"Enter Password\"></div></td><td><div class=too-short ng-show=\"!passwordForm.password.$valid && passwordFocused\" translate=USER_PROFILE_PASSWORD_TOO_SHORT_MESSAGE_TEXT></div><button class=\"input-button password-toggle\" ng-click=togglePasswordDisplay() ng-disabled=disablePaswordChange><i class=\"fas fa-eye\" ng-class=\"{\'eye-opacity\': disablePaswordChange}\"></i></button></td></tr><tr ng-show=user.stripe_customerID><td colspan=2><div class=fline></div></td></tr><tr ng-show=user.stripe_customerID><td colspan=2><div class=account-confirm ng-show=pauseAccountMessage><p>{{pauseAccountMessage}}</p></div></td></tr><tr ng-show=\"user.stripe_customerID && plansSubscribed[0] && subscriptionPaused\" class=subscription-paused><td><div class=\"black-title-basic subscription-paused\" translate=\"{{\'USER_PROFILE_PAUSE_YOUR_SUBSCRIPTION_TITLE_REACTIVATE_TEXT\'}}\"></div></td><td><div style=font-size:100% ng-class=\"getOrganizationCss(\'link-button\')\" ng-click=reactivateSubscription() translate=\"{{\'USER_PROFILE_PAUSE_LINK_BUTTON_REACTIVATE_TEXT\'}}\"></div></td></tr><tr ng-show=\"user.stripe_customerID && plansSubscribed[0] && !subscriptionPaused\" class=subscription-active><td><div id=reactivate-sub-title class=black-title-basic translate=\"{{\'USER_PROFILE_CANCEL_YOUR_SUBSCRIPTION_TITLE_TEXT\'}}\"></div></td><td><div ng-class=\"getOrganizationCss(\'link-button\')\" id=barecancel-trigger translate=\"{{ \'USER_PROFILE_CANCEL_LINK_BUTTON_TEXT\' }}\"></div></td></tr><!--<tr>\n                      <td colspan=\"2\">\n                        <div class=\"fline\"></div>\n                      </td>\n                  </tr>\n                  <tr ng-if=\"allowAccountDisable\">\n                    <td>\n                      <div class=\"black-title-basic\" translate=\"USER_PROFILE_DISABLE_YOUR_ACCOUNT_TITLE_TEXT\"></div>\n                    </td>\n                    <td>\n                      <div class=\"link-button\">\n                        <a ng-click=\"showDisableProfileModal()\" translate=\"USER_PROFILE_DISABLE_LINK_BUTTON_TEXT\"></a>\n                      </div>\n                    </td>\n                  </tr>--></table></div></div></div></div></div></div></div></div><!-- #region Profile Picture Modal --><div class=modal id=profile-pic-modal tabindex=-1 role=dialog aria-labelledby=take-test-modal-title aria-hidden=true ng-show=profileImgModal><div class=\"modal-dialog modal-dialog-centered\" role=document><div class=modal-content><div class=modal-header><h6 ng-show=!profileImgModalDelete>Position and size your photo</h6><h6 ng-show=profileImgModalDelete>Remove Your Photo</h6><button type=button class=close aria-label=Close ng-click=\"profileImgModal = false;\"><img src=/media/images/close.svg alt=close class=img-fluid></button></div><div class=modal-body><croppie src=cropped.source ng-model=cropped.image options=\"{boundary:{width:300,height:300},viewport:{width: 300, height: 300,type:\'circle\'}}\" ng-show=!profileImgModalDelete></croppie><div class=take-test-btn-group><div class=update-profile-picture-checkbox-container ng-show=profileImgModalDelete>Are you sure you\'d like to remove your profile picture?</div><button type=button class=\"btn btn-primary let-go-btn\" ng-click=upload_cropped_img() ng-show=!profileImgModalDelete>Apply</button> <button type=button class=\"btn btn-primary let-go-btn\" ng-click=deleteResumePicture() ng-show=profileImgModalDelete>Yes</button> <button type=button ng-click=\"profileImgModal = false;\" class=\"btn btn-secondary cancel-btn\">Cancel</button></div><!-- Preview --><!-- <img ng-src=\"{{cropped.image}}\" /> --></div></div></div></div><!-- #endregion Profile Picture Modal --><script>window.onload = function(){\n        if(window.barecancel&&window.barecancel.created)\n            window.console&&console.error&&console.error(\"Barecancel snippet included twice.\");\n        else{\n            window.barecancel={created:!0};\n\n            var a=document.createElement(\"script\");\n            a.src=\"https://baremetrics-barecancel.baremetrics.com/js/application.js\",a.async=!0;\n            var b=document.getElementsByTagName(\"script\")[0];\n            b.parentNode.insertBefore(a,b),\n\n            window.barecancel.params = {\n                access_token_id: \"0a14d001-d2ef-43f2-97f2-4b0823f2f42b\", \n                customer_oid: \'\',\n                callback_cancel: null,\n                callback_send: function(data) {\n                    window.barecancel.params.callback_cancel();\n                    var d = data;\n                },\n                callback_error: function(data) {\n                    var d = data;\n                } \n            };\n        }\n    }();</script>");
$templateCache.put("app/notDownloaded/template/notDownloaded.html","<div class=\"modal-intry resume-validation-dialog\"><button class=\"btn btn-modal-intry-dismiss\" ng-class=\"getOrganizationCss(\'btn btn-modal-intry-dismiss\')\" ng-click=closeThisDialog()></button><div class=\"section section-active\"><div class=title>You haven\'t downloaded this resume before</div><div class=subtitle><br><br><br>Are you sure you want to download it?</div><div class=footer-modal><div class=\"action double\"><a ng-click=closeThisDialog()>Cancel</a> <a ng-click=confirmDownload()>Download</a></div></div></div></div>");
$templateCache.put("app/notDownloaded/template/reset-password-email.html","<div class=\"modal-intry reset-password\" style=\"height: 640px\"><div class=\"section section-active\"><div class=title>{{changePasswordTitle}}</div><div class=subtitle style=\"margin:0 0 !important; padding:0 0 1vw 0 !important\">Enter your new password below</div><div ng-if=\"resetPasswordForm.state!==STATE_COMPLETE\"><br><label>User Name:&nbsp;&nbsp;{{forgotPasswordLogin}}</label><div style=\"height: 25px\"></div><div class=input ng-if=isAnInvitation() ng-show=!invitationHasName()><input type=text ng-model=resetPasswordForm.firstName placeholder=\"Enter your first name\" required></div><div class=input ng-if=isAnInvitation() ng-show=!invitationHasName()><input type=search ng-model=resetPasswordForm.lastName placeholder=\"Enter your last name\" required></div><div class=input><input id=password type=password ng-model=resetPasswordForm.password placeholder=\"New password\" ng-disabled=\"resetPasswordForm.state===STATE_PENDING\" required autofocus ng-focus=\"formSetup.passwordHint = true; formSetup.startedToRegister = true; passwordFocused = false;\" ng-blur=\"formSetup.passwordHint = false; passwordFocused = true; formSetup.tooShort = (resetPasswordForm.password.length < 8);\" ng-keyup=testPass(resetPasswordForm.password);></div><div class=input><input type=password ng-model=resetPasswordForm.confirmPassword placeholder=\"Re-enter password\" ng-disabled=\"resetPasswordForm.state===STATE_PENDING\" required></div><div class=password-hint ng-show=formSetup.passwordHint><p><strong translate=SIGN_UP_FORM_PASSWORD_STRENGTH_TEXT></strong>{{passwordStrengthString()}}</p><p></p><div class=strength-meter><div class=strength-meter-fill data-strength={{formSetup.passStrength}}></div></div><p></p><p translate=SIGN_UP_FORM_PASSWORD_STRENGTH_MESSAGE_TEXT></p></div><div class=\"too-short too-short2\" ng-show=\"formSetup.tooShort && passwordFocused\" translate=SIGN_UP_FORM_PASSWORD_TOO_SHORT_TEXT></div></div><div class=\"status status-error\" ng-if=resetPasswordForm.error>{{resetPasswordForm.error}}</div><div class=action-buttons><button class=\"btn btn-primary\" ng-click=resetPassword() ng-disabled=\"resetPasswordForm.state===STATE_PENDING || !validatePass(resetPasswordForm.password, resetPasswordForm.confirmPassword)\"><span ng-if=\"resetPasswordForm.state===STATE_IDLE || resetPasswordForm.state===STATE_COMPLETE\">Update Password </span><span ng-if=\"resetPasswordForm.state===STATE_PENDING\"><i class=\"fa fa-spinner fa-spin\"></i></span></button></div></div><script>$(function() $(\'#password\').focus(); });</script></div>");
$templateCache.put("app/onboarding/template/onboarding.html","<div id=onboarding-modal class=ngdialog-wrapper style=\"display: block\" aria-labelledby=onboarding-modal-title aria-hidden=true><!-- Bridge Final Confirmation Conversion Pixel --> <img height=1 width=1 style=border-style:none alt=\"\" src=\"https://insight.adsrvr.org/track/pxl/?adv=zjq23o8&ct=0:bhje2sq&fmt=3\"><div class=\"modal-dialog modal-dialog-centered\" role=document><div class=modal-content><div class=modal-body><div class=\"section section-intro section-active\"><h6 style=\"text-align: center\">{{\'ONBOARDING_SECTION_SUBTITLE\' | translate}}</h6><!--\n          <div class=\"desc\">\n            <p class=\"text\" style=\"text-align: center;\">\n              {{\'ONBOARDING_DESCRIPTION_PART_1\' | translate}}\n            </p>\n            <p class=\"text\" style=\"text-align: center;\">\n              {{\'ONBOARDING_DESCRIPTION_PART_2\' | translate}}\n            </p>\n            <p class=\"text\" style=\"text-align: center;\">\n              <span style=\"font-weight: bold;\">Get hired faster</span> with a Hybrid Resume™ from Intry.</br>\n              Watch this short video,</br>\n              then click “Let’s Get Started”\n            </p>\n\n            <div class=\"iframe-wrapper\">\n              <p class=\"text\">\n                {{\'ONBOARDING_DESCRIPTION_LEARN_MORE\' | translate}}\n              </p>\n              <iframe src=\"https://www.youtube.com/embed/LcEMDzlD_OY\" frameborder=\"0\"\n                allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\"\n                allowfullscreen></iframe>\n            </div>\n          </div>\n          --><div class=buttons-block><!--\n            <button class=\'btn btn-green btn-start\' ui-sref=\"wizard({step: 1})\" ng-show=\"showStartWizardBtn()\">\n              {{\'ONBOARDING_START_BUTTON_TITLE\' | translate}}\n            </button>\n            --> <a class=\"btn btn-green-link\" ng-click=closeModal()>{{\'Go To My Dashboard\' | translate}}</a></div><div class=desc style=\"margin-top: 30px; text-align: center\"><!--\n            <p class=\"text\">\n              If you have any questions throughout the process, click below to schedule a customer support call.\n            </p>\n            <p class=\"text\">\n              <a href=\"https://calendly.com/intrysupport\" target=\"_blank\">https://calendly.com/intrysupport</a>\n            </p>\n            --><!--\n            <p class=\"text\" style=\"text-align: center;\">\n              If you have questions at any time, click\n              <div class=\"intercom-icon\"></div></br>\n              in the lower right corner</br>\n              to chat with customer support\n            </p>\n            --></div></div></div></div></div></div>");
$templateCache.put("app/privacy-policy/template/agreement.html","<div id=agreement-screen><div class=header-wrapper><img src=//s3.amazonaws.com/static.intry.careers/images/webapp/navbar_beta_logo.svg></div><div class=title-bar><div class=header-company>INTRY, LLC</div><div class=header-title>INTRY USER AGREEMENT</div></div><div class=content-wrapper><div><p>1. Core Principles</p><p>When it comes to your personal information we believe in transparency, not surprises. So before we get into the details, we want to share with you a few of our core privacy principles. First, we don&#8217;t sell your personal information to anyone. It&#8217;s just not the type of business we&#8217;re in. Second, we don&#8217;t ask for your personal information unless we need it to provide or improve the Services for you. Third, we don&#8217;t share your personal information unless you&#8217;ve specifically allowed it, or for the very limited purposes described below. Finally, we appreciate that when you use our Services, you trust us with your information, and we take that responsibility very seriously. This Privacy Policy holds us accountable for protecting your rights and your privacy.</p><p>2. Collection</p><p>When you use the Services, we collect the following information, and use it only as described below:</p><p>2.1. Account Information. This may include your name, address, email address and phone number. We use this information in the ways you would expect, such as to set up your Account or contact you.</p><p>2.2. Third Party Account Information. If you use Third Party Services, such as social media or photo-sharing services, you may provide us with your Third Party Services account information, such as your username (note that we don&#8217;t store any passwords you use to access Third Party Services). We transmit, and may store, such account information, only as needed to provide the Services, and only in accordance with the terms and policies of the Third Party Services.</p><p>2.3. Payment Information. When you initially provide or update your payment information, we transmit it via an encrypted connection to our Payment Processor, Stripe. Stripe uses and processes your payment information in accordance with Stripe&#8217;s Privacy Policy. We don&#8217;t store your payment information, other than your zip code and country, which we require for billing and to comply with tax and other government regulations.</p><p>2.4. Communications With Us. When you send us emails or other communications, such as customer support inquiries, we maintain those communications and their contents so that we can resolve your inquiries or otherwise assist you.</p><p>2.5. Public Comments On The Services. We maintain any comments, contributions to discussions or messages submitted to users of the Services, in order to provide the Services.</p><p>2.6. Files You Provide Us. When you use the Services, we store, process and transmit your User Content (such as your photos) and information related to your User Content (such as location tags in photos). We process and store such files and information in order to provide the Services, as described in our Terms of Service.</p><p>2.7. Usage Information. This includes information about your activity on and interaction with the Services, such as your IP address, your device or browser type, the webpage you visited before coming to our sites and identifiers associated with your devices. This information enables us to analyze how the Services are being accessed and used, and to track performance of the Services.</p><p>2.8. Location Information. Your devices (depending on your settings) may transmit location information to the Services. We use this information to customize, improve and protect the Services. For example, we may use your location information to determine local language preferences, or to geotag a post.</p><p>2.9. Cookies And Other Technologies. We use these technologies to do things such as remember your preferences, keep you safe and improve and promote the Services.</p><p>3. Sharing</p><p>When you use the Services, we may share your information only as described below:</p><p>3.1. Third Parties You Authorize. You can give third parties access to your and your End Users&#8217; information on the Services. For example, you may wish to integrate Your Sites with a third party newsletter service that requires access to the email addresses you collect from your End Users, in order for that newsletter service to send emails on your behalf and at your direction. Just remember that such third party&#8217;s use of this information will be governed by the terms and privacy policies of the third party.</p><p>3.2. Following The Law. We may disclose your information to third parties if we determine that such disclosure is reasonably necessary to comply with the law, protect our rights or prevent fraud or abuse of Intry or our users. When we receive law enforcement or national security requests for information, we strongly believe in privacy and transparency. We scrutinize such requests carefully and challenge vague, overbroad or otherwise unlawful requests. And when legally permitted, we provide our users with notice that their information is being requested. This notice is provided so that you have the opportunity to challenge such requests.</p><p>3.3. Others Working For Intry. Intry uses certain trusted third parties to help us provide, improve, promote and protect the Services. For example, we may use third parties to help us provide customer support, manage our ads on other sites or assist with data storage. These third parties may access, process or store your information to perform tasks only for the purposes we&#8217;ve authorized, and we require them to provide at least the same level of protection for your information as described in this Privacy Policy. We also may share with third parties aggregated or anonymized information that does not directly identify you.</p><p>3.4. Business Transfers. If we&#8217;re involved in a reorganization, merger, acquisition or sale of our assets, your information may be transferred as part of that deal.</p><p>4. Protection</p><p>While no service is completely secure, we have a security team dedicated to keeping your information safe. We employ security measures such as using firewalls to protect against intruders, building redundancies throughout our network (so that if one server goes down, another can cover for it) and testing for and protecting against network vulnerabilities. Payment information is transmitted using HTTPS encryption.</p><p>5. Retention</p><p>We&#8217;ll retain your personal information for as long as we need it to provide you with the Services. You can ask for your personal information to be deleted at any time by deleting your Account or contacting us at info@intry.com. Please note that there may be latency in deleting your personal information from our servers and backup storage, and we may retain your personal information in order to comply with the law, protect our rights, resolve disputes or enforce our agreements.</p><p></p><p>6. Location</p><p>Information that you submit through the Services may be transferred to countries other than where you live (for example, to our servers in the US). We also may store information locally on the devices you use to access the Services. We also may transfer information to third parties outside the US for processing or to support the Services, and we require them to provide at least the same level of protection for your information as described in this Privacy Policy.</p><p>7. Access</p><p>To modify or delete the personal information you have provided to us, simply log into the Services and update your profile. We may retain certain information as required by law or for necessary business purposes. On request, we&#8217;ll provide you with a copy of your personal information that we maintain. This request may be subject to a fee not exceeding the prescribed fee permitted by law.</p><p>8. Communications</p><p>We may periodically email you service-related announcements. We&#8217;ll also send you emails related to your transactions. We may also send you marketing or promotional communications, but you can opt out of receiving subsequent marketing or promotional communications by clicking the link marked unsubscribe (or a similar phrasing) that&#8217;s included in those communications.</p><p>9. Modifications</p><p>We may modify this Privacy Policy from time to time, and will post the most current version on our site. If a modification meaningfully reduces your rights, we&#8217;ll notify you in accordance with the procedures set forth in our Terms of Service.</p><p>CONTACT US</p><p>In order to resolve a complaint regarding the Site or to receive further information regarding use of the Site, please contact us at:</p><p>INTRY, LLC</p><p>info@intry.careers</p></div></div></div>");
$templateCache.put("app/profile/template/profile.html","<div class=user-profile><div ng-class=\'scrimPageBackground ? \"scrim\": \"\"\'><nav-bar user=user></nav-bar><div class=page-header-intry-large><div class=background-image></div></div><div class=page-content-intry><div class=header-data><div class=headshot><img ng-src={{user.attachments[0].file}} class=headshot></div><div class=address><div class=user-name for=user-name>{{user.full_name}}</div><div class=city-state for=address>{{user.addresses[0].city}}, {{user.addresses[0].state}}</div></div></div><div class=clear></div><div class=profile-content><div id=billing class=left-block><div class=next-charge><div class=grey-title translate=USER_PROFILE_NEXT_CHARGE_TITLE_TEXT></div><div><div class=black-title-basic>10/3/2017</div><div class=sub-amount>$15.00</div></div></div><div class=subscription><div class=grey-title translate=USER_PROFILE_SUBSCRIPTION_TITLE_TEXT></div><table><tr><td><div class=black-title-basic translate=USER_PROFILE_INTRY_BASE_PLAN_TITLE_TEXT></div></td><td><div class=link-button translate=USER_PROFILE_MANAGE_LINK_BUTTON_TEXT></div></td></tr><tr><td><div class=sub-title translate=USER_PROFILE_STANDARD_CANDIDATE_TITLE_TEXT></div></td><td><div class=std-right>$5.00/mo</div></td></tr><tr><td><div class=sub-title-right translate=USER_PROFILE_LINE_ITEM_TITLE_TEXT></div></td><td><div class=std-right>$5.00/mo</div></td></tr><tr><td><div class=sub-title-right translate=USER_PROFILE_DISSCOUNT_TITLE_TEXT></div></td><td><div class=std-right>-$5.00/mo</div></td></tr><tr><td colspan=2><div class=hline></div></td></tr><tr><td><div class=black-title-basic translate=USER_PROFILE_ADD_ONS_TITLE_TEXT></div></td><td><div class=link-button translate=USER_PROFILE_MANAGE_LINK_BUTTON_TEXT></div></td></tr><tr><td><div class=sub-title translate=USER_PROFILE_SOME_ADD_ONS_TITLE_TEXT></div></td><td><div class=std-right>$5.00/mo</div></td></tr><tr><td colspan=2><div class=highlight><div class=sub-title-highlight translate=USER_PROFILE_MONTHLY_RECURRING_TOTAL_TITLE_TEXT></div><div class=std-right-highlight>$15.00/mo</div></div></td></tr></table></div><div class=payment-info><table><tr><td><div class=grey-title-left translate=USER_PROFILE_PAYMENT_INFORMATION_TITLE_TEXT></div></td><td><div class=link-button translate=USER_PROFILE_VIEW_BILLING_HISTORY_TITLE_TEXT></div></td></tr><tr><td><div class=black-title-basic translate=USER_PROFILE_PAYMENT_METHOD_TITLE_TEXT></div></td><td><div class=link-button translate=USER_PROFILE_UPDATE_LINK_BUTTON_TEXT></div></td></tr><tr><td><div class=black-title-basic>{{\'USER_PROFILE_VISA_TITLE_TEXT\' | translate}}: •••• •••• •••• 1234</div></td></tr></table></div></div><div id=account class=right-block><div class=grey-title translate=USER_PROFILE_YOUR_ACCOUNT_TITLE_TEXT></div><table><tr><td><div class=black-title-basic translate=USER_PROFILE_PERSONAL_INFO_TITLE_TEXT></div></td><td><div class=link-button><a ng-click=updatePersonalInfo() href=\"\" translate=USER_PROFILE_UPDATE_LINK_BUTTON_TEXT></a></div></td></tr><tr><td><div contenteditable=true editable ng-model=user.full_name class=\"editable sub-title\" data-text=\"Full Name\"></div></td></tr><tr><td colspan=2><div contenteditable=true name=street editable ng-model=user.street class=\"editable sub-title\" data-text=Street></div><div contenteditable=true editable ng-model=user.street_2 class=\"editable sub-title\" data-text=\"Street 2\"></div></td></tr><tr><td colspan=2><div contenteditable=true editable ng-model=user.city class=\"editable sub-title\" data-text=City></div><div contenteditable=true editable ng-model=user.state class=\"editable sub-title\" data-text=State></div></td></tr><tr><td colspan=2><div contenteditable=true editable ng-model=user.country class=\"editable sub-title\" data-text=Country></div><div contenteditable=true editable ng-model=user.postal_code class=\"editable sub-title\" data-text=\"Postal Code\"></div></td></tr><tr><td><div contenteditable=true editable ng-model=user.phone_number class=\"editable sub-title\" data-text=\"Phone Number\"></div></td></tr><tr><td><div class=black-title-wp translate=USER_PROFILE_CONNECTED_ACCOUNTS_TITLE_TEXT></div></td></tr><tr><td><div class=sub-title translate=USER_PROFILE_FACEBOOK_TITLE_TEXT></div></td><td><div class=link-button fb-login ng-show=!showDisconnectForFacebook>{{\'USER_PROFILE_CONNECT_LINK_BUTTON_TEXT\' | translate}}</div><div class=link-button ng-click=\"disconnectSocialAccount(\'facebook\')\" ng-show=showDisconnectForFacebook translate=USER_PROFILE_DISCONNECT_LINK_BUTTON_TEXT></div></td></tr><tr><td><div class=sub-title translate=USER_PROFILE_LINKEDIN_TITLE_TEXT></div></td><td><div class=link-button linked-in ng-show=!showDisconnectForLinkedIN>{{\'USER_PROFILE_CONNECT_LINK_BUTTON_TEXT\' | translate}}</div><div class=link-button ng-click=\"disconnectSocialAccount(\'linkedIN\')\" ng-show=showDisconnectForLinkedIN translate=USER_PROFILE_DISCONNECT_LINK_BUTTON_TEXT></div></td></tr><tr><td colspan=2><div class=fline></div></td></tr><tr><td colspan=2><div class=\"change-email-status account-confirm\" ng-show=showEmailConfirmationMessage><p translate=USER_PROFILE_EMAIL_STATUS_MESSAGE_TEXT></p></div></td></tr><tr><td><div class=black-title-wp translate=USER_PROFILE_EMAIL_TITLE_TEXT></div></td><td><div class=link-button ng-click=changeEmail() ng-show=disableEmailChange translate=USER_PROFILE_CHANGE_LINK_BUTTON_TEXT></div><div class=link-button ng-click=cancelChangeEmail() ng-show=!disableEmailChange translate=USER_PROFILE_CANCEL_LINK_BUTTON_TEXT></div><div class=link-button ng-click=\"emailForm.email && saveEmail()\" ng-show=!disableEmailChange translate=USER_PROFILE_SAVE_LINK_BUTTON_TEXT></div></td></tr><tr><td ng-form=emailForm><input id=email type=email name=email class=text-box ng-model=user.email ng-readonly=disableEmailChange></td></tr><tr><td colspan=2><div class=fline></div></td></tr><tr><td colspan=2><div class=\"change-password-message account-confirm\" ng-show=changePasswordMessage><p>{{changePasswordMessage}}</p></div></td></tr><tr><td><div class=black-title-wp translate=USER_PROFILE_PASSWORD_TITLE_TEXT></div></td><td><div class=link-button ng-click=changePassword() ng-show=disablePaswordChange translate=USER_PROFILE_CHANGE_LINK_BUTTON_TEXT></div><div class=link-button ng-click=cancelChangePassword() ng-show=!disablePaswordChange translate=USER_PROFILE_CANCEL_LINK_BUTTON_TEXT></div><div class=link-button ng-click=\"passwordForm.password.$valid && savePassword()\" ng-show=!disablePaswordChange translate=USER_PROFILE_SAVE_LINK_BUTTON_TEXT></div></td></tr><tr><td ng-form=passwordForm><input id=password name=password class=text-box type=password ng-model=user.password ng-minlength=8 ng-readonly=disablePaswordChange ng-blur=\"passwordFocused = true\"></td><td><div class=too-short ng-show=\"!passwordForm.password.$valid && passwordFocused\" translate=USER_PROFILE_PASSWORD_TOO_SHORT_MESSAGE_TEXT></div></td></tr><tr><td colspan=2><div class=fline></div></td></tr><tr><td colspan=2><div class=account-confirm ng-show=pauseAccountMessage><p>{{pauseAccountMessage}}</p></div></td></tr><tr><td><div class=black-title-basic translate=USER_PROFILE_PAUSE_YOUR_SUBSCRIPTION_TITLE_TEXT></div></td><td><div class=link-button ng-click=pauseUserAccount() translate=USER_PROFILE_PAUSE_LINK_BUTTON_TEXT></div></td></tr><tr><td colspan=2><div class=fline></div></td></tr><tr ng-if=allowAccountDisable><td><div class=black-title-basic translate=USER_PROFILE_DISABLE_YOUR_ACCOUNT_TITLE_TEXT></div></td><td><div class=link-button><a ng-click=showDisableProfileModal() translate=USER_PROFILE_DISABLE_LINK_BUTTON_TEXT></a></div></td></tr></table></div></div></div></div></div>");
$templateCache.put("app/profile-disable/template/profile-disable.html","<div class=\"modal-intry profile-disable\"><div class=\"section section-active\"><div class=title translate=USER_PROFILE_DISABLE_TITILE></div><div class=subtitle translate=USER_PROFILE_DISABLE_SUBTITILE></div><div class=profile-disable-loader-container ng-if=disableInProcess><div class=spinner-container><i class=\"fas fa-circle-o-notch fa-spin load\"></i></div></div><div ng-if=error class=errormessage>{{error}}</div><div class=disable-reason-section ng-form=disableForm><table><tr><td><div class=btn-group uib-dropdown is-open=status.isopen><button id=single-button type=button class=\"btn btn-default dropdown-toggle\" uib-dropdown-toggle ng-disabled=disabled>{{selectedReasonForDisableProfile}} <span class=select-arrow><i class=\"down fa fa-angle-down\"></i></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li role=menuitem class=disable-reason ng-repeat=\"disableReason in disableReasons\"><a ng-click=disableReasonSelected(disableReason)>{{disableReason}}</a></li></ul></div></td></tr><tr><td><textarea name=moreDetailsForDisable ng-model=moreDetailsForDisable ng-trim=false ng-show=showMoreDetailsForDisable placeholder=\"{{\'USER_PROFILE_DISABLE_TEXTAREA_PLACEHOLDER_TEXT\'|translate}}\" maxlength=500></textarea></td></tr><tr><td><span class=word-counter ng-show=showMoreDetailsForDisable>{{moreDetailsForDisable.length>0 ? moreDetailsForDisable.length : 0}}/500</span></td></tr></table></div><div class=footer-modal><div class=\"action double\"><a ng-click=closeThisDialog() ng-disabled=disableInProcess translate=USER_PROFILE_CANCEL_BUTTON_TEXT></a> <a ng-click=disableUserProfile() ng-disabled=disableInProcess translate=USER_PROFILE_DISABLE_BUTTON_TEXT></a></div></div></div></div>");
$templateCache.put("app/register/template/register.html","<div ng-class=\"getOrganizationCss(\'body register\')\"><!-- Bridge Registration Conversion Pixel --><!-- <img height=\"1\" width=\"1\" style=\"border-style:none;\" alt=\"\" src=\"https://insight.adsrvr.org/track/pxl/?adv=zjq23o8&ct=0:78n9f18&fmt=3\" /> --><!-- #region Header --><div class=signup-header><div class=padding-top style=\"width: 100%;display: flex\" ng-if=hasOrganization()><div class=\"col sm-6\"><div class=login-signup-dip><div ng-class=\"getOrganizationCss(\'white-label-register-logo-img\')\"></div></div></div><div class=\"col sm-6\" ng-show=isCurrentStep(1)><div class=login-signup-dip ng-if=!userExists() style=\"width: 100%; display:flex;justify-content: flex-end\"><a href=# class=\"login-button-desktop w-button\" style=\"width: 100%; display:flex\">Login</a></div><div class=login-signup-dip ng-if=userExists()><a href=# ng-click=logOut() class=\"login-button-desktop w-button\" style=\"width: 100%\">Logout</a></div></div></div><div class=padding-top style=\"width: 100%;display: flex\" ng-if=!hasOrganization()><div class=\"col sm-6\"><div class=login-signup-dip><div ng-class=\"getOrganizationCss(\'white-label-register-logo-img\')\"></div></div></div><div class=\"col sm-6\"><div class=login-signup-dip ng-if=!userExists() style=\"width: 100%; display:flex;justify-content: flex-end\"><a href=# class=\"login-button-desktop w-button\" style=\"width: 100%; display:flex\">Login</a></div><div class=login-signup-dip ng-if=userExists()><a href=# ng-click=logOut() class=\"login-button-desktop w-button\" style=\"width: 100%\">Logout</a></div></div></div></div><!-- #endregion Header --><div class=signup-section><div class=signup-wrapper-2><div class=\"signup-form w-row\"><!-- #region Features Panel --><div class=\"signup-content-wrapper w-col w-col-6 order-md-1\"><div class=box-pricing ng-show=\"isCurrentStep(1) && pricesLoaded && showOnePrice\"><h2 class=title-h1 ng-show=\"subscriptionAmount > 0\">${{subscriptionAmount}} {{subscriptionDescription}}</h2><h2 class=title-h1 style=\"text-transform: capitalize\" ng-show=\"subscriptionAmount <= 0\">{{subscriptionDescription}}</h2><p class=title-p style=\"text-transform: capitalize\" ng-show=\"subscriptionAmount > 0\">{{newUser.price.metadata.downloadsLabel}}&nbsp;&nbsp;Resumes&nbsp;(cancel anytime)</p></div><!-- <div ng-show=\"isCurrentStep(2)\"><h2 class=\"heading\">{{getCaption(0)}}</h2><h2 class=\"sub-heading\">{{getCaption(1)}}</h2></div> --><div class=form-wrapper-signup><div class=\"form-block-2 w-form\"><!-- STEP 1 --><div id=registrationFormStep1 class=form-2 ng-class=\"{processing: processing}\" ng-show=isCurrentStep(1)><div class=signup-title><h1 class=signup-h1>Sign up to Get Interviewed Fast</h1><p class=signup-p>Patented resume software guaranteed to help you get more job interviews.</p></div><!-- #region List Of Prices --><div style=\"margin-top: -25px\" ng-show=\"pricesLoaded && showStripeFields\"><h1 class=title-uppercase>Select a Plan</h1><!-- <p class=\"title-p\">\n                    More resumes. More jobs.<br />\n                    (cancel anytime)\n                  </p> --><div class=prices-container><div ng-repeat=\"row in prices\"><input type=radio name=planID ng-model=planID value={{row.id}} class=input-radio ng-click=updatePlanId(row.id)><label for=male>{{row.label ? row.label + \': \' : \'\'}} {{row.metadata.downloadsLabel}}&nbsp;Resumes&nbsp;for&nbsp;${{row.amount}}&nbsp;{{row.metadata.priceDescription2}}</label><br></div></div></div><!-- #endregion List Of Prices --><div class=\"row in-signup\" ng-show=showStripeFields><div class=\"col sm-12\"><label for=card-number-stripe id=w-node-c47dc9a3f59e-bfd445ac class=\"para-small signup\">Card Number</label><div id=card-number-stripe class=\"text-field-half w-node-0c156e728162-bfd445ac w-input cc-field\" style=\"color:pink !important\"></div></div></div><div class=\"row in-signup\"><div class=\"col sm-6\"><label for=First-Name id=w-node-c47dc9a3f591-bfd445ac class=\"para-small signup\">First Name</label><input type=text class=\"text-field-half w-node-c47dc9a3f593-bfd445ac w-input\" maxlength=256 name=First-Name data-name=\"First Name\" placeholder=\"Enter your first name here\" id=First-Name required ng-model=newUser.firstname></div><div class=\"col sm-6\"><label for=Last-Name id=w-node-c47dc9a3f594-bfd445ac class=\"para-small signup\">Last Name</label><input type=text class=\"text-field-half w-node-c47dc9a3f596-bfd445ac w-input\" maxlength=256 name=Last-Name data-name=\"Last Name\" placeholder=\"Enter your last name here\" id=Last-Name required ng-model=newUser.lastname></div></div><div class=\"row in-signup\" ng-show=showStripeFields><div class=\"col sm-6\"><label for=card-expiry-stripe id=w-node-c47dc9a3f59e-bfd445ac class=\"para-small signup\">Expiration Date</label><div id=card-expiry-stripe class=\"text-field-half w-node-c47dc9a3f5a0-bfd445ac w-input cc-field\"></div></div><div class=\"col sm-6\"><label for=card-cvv-stripe id=w-node-c47dc9a3f5a1-bfd445ac class=\"para-small signup\">CVV</label><div id=card-cvv-stripe class=\"text-field-half w-node-c47dc9a3f5a3-bfd445ac w-input cc-field\"></div></div></div><div class=\"row in-signup\"><div class=\"col sm-12\"><label for=Email class=\"para-small signup\">Email</label><input type=email class=\"text-field-half w-node-c47dc9a3f596-bfd445ac w-input\" maxlength=256 name=Email id=Email data-name=Email placeholder=\"Enter your email address here\" required ng-model=newUser.emailPhone></div></div><div class=\"row in-signup\" ng-show=!showStripeFields><div class=\"col sm-12\"><label for=Email class=\"para-small signup\">Code</label><input type=text class=\"text-field-half w-node-c47dc9a3f596-bfd445ac w-input\" maxlength=256 name=Code id=Code data-name=Code placeholder=\"Enter the code provided\" required ng-model=newUser.code></div></div><div class=\"row in-signup\" ng-show=showStripeFields><div class=\"col sm-6\"><label for=card-promocode id=w-node-c47dc9a3f5a1-bfd445ac class=\"para-small signup\">Promo Code</label><div id=card-promocode class=\"text-field-half w-node-c47dc9a3f5a3-bfd445ac w-input cc-field\"><input type=text class=\"text-field-half w-node-0c156e728165-bfd445ac w-input\" style=\"width: 100%; vertical-align: top; margin-top: 0; border: none; height: 20px;margin-left:-15px\" maxlength=25 name=Promo data-name=Promo placeholder=\"Discount Code\" id=Promo ng-model=newUser.promoCode></div><div id=promocode-note class=\"promocode-note {{promoCodeClass}}\">{{promoCodeNote}}</div></div><div class=col-sm-6><label for=card-giftcode class=\"para-small signup\">Gift Card Code</label><div id=card-giftcode class=\"text-field-half w-node-c47dc9a3f5a3-bfd445ac w-input cc-field\"><input type=text class=\"text-field-half w-node-0c156e728165-bfd445ac w-input\" style=\"width: 100%; vertical-align: top; margin-top: 0; border: none; height: 20px; margin-left:-15px\" maxlength=25 placeholder=\"Gift Card Code\" id=Gift ng-model=newUser.giftCardCode></div><div id=giftcode-note class=\"giftcode-note {{giftCodeClass}}\">{{giftCodeNote}}</div></div></div></div><!-- STEP 2 --><div id=registrationFormStep2 class=\"form-2 form-step-2\" ng-class=\"{processing: processing}\" ng-show=isCurrentStep(2)><h1 class=title-h1-2></h1><div class=signup-title><h1 class=\"signup-h1 password-title\">Complete your account setup to get hired fast!</h1></div><div class=\"row in-signup\"><label for=Password class=\"para-small signup\">Password</label><input type=password class=\"text-field-half w-input\" maxlength=256 name=Password data-name=Password placeholder=\"Enter your password\" id=Password required ng-model=newUser.password ng-focus=\"formSetup.passwordHint = true; formSetup.startedToRegister = true; passwordFocused = false;\" ng-blur=\"formSetup.passwordHint = false; passwordFocused = true; formSetup.tooShort = (newUser.password.length < 8);\" ng-keyup=testPass(newUser.password);><div class=password-hint ng-show=formSetup.passwordHint><p><strong translate=SIGN_UP_FORM_PASSWORD_STRENGTH_TEXT></strong> {{passwordStrengthString()}}</p><p></p><div class=strength-meter><div class=strength-meter-fill data-strength={{formSetup.passStrength}}></div></div><p></p><p translate=SIGN_UP_FORM_PASSWORD_STRENGTH_MESSAGE_TEXT></p></div><div class=too-short ng-show=\"formSetup.tooShort && passwordFocused\" translate=SIGN_UP_FORM_PASSWORD_TOO_SHORT_TEXT></div></div><div class=\"row in-signup confirm-password\"><label for=ConfirmPassword class=\"para-small signup\">Confirm password</label><input type=password class=\"text-field-half w-input\" maxlength=256 name=ConfirmPassword data-name=Password placeholder=\"Confirm your password\" id=ConfirmPassword required ng-model=newUser.confirmPassword></div></div></div><!-- Submit Button --><div class=\"row in-signup\"><div class=\"col col-12 col-lg-6 text-align-center full-width-row\"><div class=row ng-show=!isCurrentStep(2)><div class=\"col col-sm-12\"><button type=submit ng-disabled=processing data-wait=\"Please wait...\" ng-class=\"getOrganizationCss(\'cta signup w-button\')\" ng-click=validateStep()>{{getCaption(2)}}</button></div></div><div class=row ng-show=isCurrentStep(2)><div class=\"col col-sm-6\"><button type=button ng-disabled=processing ng-class=\"getOrganizationCss(\'cta signup w-button\')\" ng-click=goToStep(1)>Back</button></div><div class=\"col col-sm-6\"><button type=submit ng-disabled=processing data-wait=\"Please wait...\" ng-class=\"getOrganizationCss(\'cta signup w-button\')\" ng-click=validateStep()>{{getCaption(2)}}</button></div></div><div class=\"pricing-smallest freeep\"><span style=\"white-space: nowrap\">By clicking {{getCaption(2)}},</span> <span style=\"white-space: nowrap\">you agree to our <a href=https://intry.careers/legal target=_blank class=register-link>Terms of Use</a></span></div></div></div></div></div><!-- #endregion Features Panel --><!-- #region Form Panel --><div class=\"signup-image-wrapper w-col w-col-6 order-md-12\"><div class=signup-box-step-1 ng-show=isCurrentStep(1)><div class=features-title><h1 class=title-h1>Be seen with Intry</h1><p class=\"title-p subtitle-p\">Customize your professional resume in just a few minutes, and get more interviews.</p></div><ul class=features ng-show=\"showPlanFeatures() && !hasOrganization()\"><li class=\"d-flex sub-condition-list\">Build and download custom professional resumes proven to get through Applicant Tracking Systems!</li><li class=\"d-flex sub-condition-list\">Copy and paste a job description from any job board into our ATS Resume Generator and Intry will create a custom resume that gets you hired faster.</li><li class=\"d-flex sub-condition-list\">Take the TrueYou™ Career Assessment to learn your strongest work traits and prepare for job interviews!</li><li class=\"d-flex sub-condition-list\">Choose from an assortment of professional resume design templates to download and apply to jobs!</li><li class=\"d-flex sub-condition-list\">Track and log your job applications, and download your work search log to apply for unemployment benefits!</li><li class=\"d-flex sub-condition-list\">Upload your current resume to automatically sync your details to your Digital Profile or manually create one!</li></ul><!-- Organization Self Registration Features --><ul class=features ng-show=hasOrganization()><li>Download <span style=\"font-weight: bold; text-transform: uppercase\">Unlimited</span> professional resumes proven to get you through applicant tracking systems</li><li>Copy and paste any job description to optimize your resumes with our ATS Resume Generator</li><li>Take the TrueYou™ Career Assessment to find the perfect job that&#39;s just right for you</li><li>Automatically sync your personal details to your resumes with a Digital Profile</li><li>Navigate from an Intuitive Dashboard, get notified for new jobs and more!</li></ul></div><div class=signup-box-step-2 ng-show=isCurrentStep(2)><fieldset><legend><img src=https://s3.amazonaws.com/static.intry.careers/images/quoteRegister.svg width=40 alt=\"\" class=image-8></legend><div class=fieldset-content><p class=\"white-text signup-test-p\">I&#x27;ve been applying for jobs over the last three months and had no responses. After signing up with Intry, I got two job interviews in less than a week!<br></p><p class=\"white-text testimonial-person\">- Lisa N.<br></p><p class=white-text>Minneapolis, MN<br></p></div></fieldset><div class=wrapper-div-pricing><!--\n            <p>Unlock. Connect. Succeed.</p>\n          --></div></div></div><!-- #endregion Form Panel --></div></div></div></div>");
$templateCache.put("app/reset-password/template/reset-password-email.html","<div class=\"modal-intry reset-password\" style=\"height: 640px\"><div class=\"section section-active\"><div class=title>{{changePasswordTitle}}</div><div class=subtitle style=\"margin:0 0 !important; padding:0 0 1vw 0 !important\">Enter your new password below</div><div ng-if=\"resetPasswordForm.state!==STATE_COMPLETE\"><br><label>User Name:&nbsp;&nbsp;{{forgotPasswordLogin}}</label><div style=\"height: 25px\"></div><div class=input ng-if=isAnInvitation() ng-show=!invitationHasName()><input type=text ng-model=resetPasswordForm.firstName placeholder=\"Enter your first name\" required></div><div class=input ng-if=isAnInvitation() ng-show=!invitationHasName()><input type=search ng-model=resetPasswordForm.lastName placeholder=\"Enter your last name\" required></div><div class=input><input id=password type=password ng-model=resetPasswordForm.password placeholder=\"New password\" ng-disabled=\"resetPasswordForm.state===STATE_PENDING\" required autofocus ng-focus=\"formSetup.passwordHint = true; formSetup.startedToRegister = true; passwordFocused = false;\" ng-blur=\"formSetup.passwordHint = false; passwordFocused = true; formSetup.tooShort = (resetPasswordForm.password.length < 8);\" ng-keyup=testPass(resetPasswordForm.password);></div><div class=input><input type=password ng-model=resetPasswordForm.confirmPassword placeholder=\"Re-enter password\" ng-disabled=\"resetPasswordForm.state===STATE_PENDING\" required></div><div class=password-hint ng-show=formSetup.passwordHint><p><strong translate=SIGN_UP_FORM_PASSWORD_STRENGTH_TEXT></strong>{{passwordStrengthString()}}</p><p></p><div class=strength-meter><div class=strength-meter-fill data-strength={{formSetup.passStrength}}></div></div><p></p><p translate=SIGN_UP_FORM_PASSWORD_STRENGTH_MESSAGE_TEXT></p></div><div class=\"too-short too-short2\" ng-show=\"formSetup.tooShort && passwordFocused\" translate=SIGN_UP_FORM_PASSWORD_TOO_SHORT_TEXT></div></div><div class=\"status status-error\" ng-if=resetPasswordForm.error>{{resetPasswordForm.error}}</div><div class=action-buttons><button class=\"btn btn-primary\" ng-click=resetPassword() ng-disabled=\"resetPasswordForm.state===STATE_PENDING || !validatePass(resetPasswordForm.password, resetPasswordForm.confirmPassword)\"><span ng-if=\"resetPasswordForm.state===STATE_IDLE || resetPasswordForm.state===STATE_COMPLETE\">Update Password </span><span ng-if=\"resetPasswordForm.state===STATE_PENDING\"><i class=\"fa fa-spinner fa-spin\"></i></span></button></div></div><script>$(function() $(\'#password\').focus(); });</script></div>");
$templateCache.put("app/reset-password/template/reset-password.html","<div class=\"modal-intry reset-password\"><button class=\"btn btn-modal-intry-dismiss\" ng-click=closeThisDialog()></button><div class=\"section section-active\"><div class=title>Reset Password</div><div class=subtitle ng-if=\"forgotPasswordForm.state!==STATE_COMPLETE\">Forgot your password? Enter the username or email or the phone number for your account:</div><div class=subtitle style=text-align:left ng-if=\"forgotPasswordForm.state==STATE_COMPLETE\"><p>If {{forgotPasswordForm.username ? forgotPasswordForm.username : forgotPasswordForm.phone ? forgotPasswordForm.phone : \"the information you provided\"}} belongs to a registered user, then we sent a link via email which you can use to reset your password.</p><p>If you don\'t receive the email in a couple of minutes, please check your spam folder.</p><p>Contact support@intrycareers.com if you can no longer access your account email.</p></div><div class=\"input input-flex input-first\" ng-if=\"forgotPasswordForm.state!==STATE_COMPLETE\"><input type=text ng-model=forgotPasswordForm.login placeholder=\"Username or email\" ng-disabled=\"forgotPasswordForm.state===STATE_PENDING\" ng-focus=\"forgotPasswordForm.isValid=true\" ng-class=\"forgotPasswordForm.isValid?\'full-width\':\'half-width\'\"> <span ng-if=!forgotPasswordForm.isValid required>Sure that\'s right?</span></div><div class=\"input input-flex input-first\" ng-if=\"forgotPasswordForm.state!==STATE_COMPLETE\"><input type=number ng-model=forgotPasswordForm.phone placeholder=\"Phone number\" ng-disabled=\"forgotPasswordForm.state===STATE_PENDING\" ng-class=\"forgotPasswordForm.isValid?\'full-width\':\'half-width\'\"> <span ng-if=!forgotPasswordForm.isValid required>Sure that\'s right?</span></div><div class=subtitle ng-if=forgotPasswordForm.error>{{forgotPasswordForm.error}}</div><!-- <div class=\'status status-success\' ng-if=\'forgotPasswordForm.state===STATE_COMPLETE\'>We found you!<br/><br/>Help is on the way. We’ll wait here.</div> --><div class=action-buttons ng-if=\"forgotPasswordForm.state!==STATE_COMPLETE\"><button class=\"btn btn-primary\" ng-click=forgotPassword() ng-disabled=\"forgotPasswordForm.state===STATE_PENDING || (forgotPasswordForm.login.length == 0 && forgotPasswordForm.phone.length == 0)\"><span ng-if=\"forgotPasswordForm.state===STATE_IDLE || forgotPasswordForm.state===STATE_COMPLETE\">Retrieve My Login</span> <span ng-if=\"forgotPasswordForm.state===STATE_PENDING\"><i class=\"fa fa-spinner fa-spin\"></i></span></button></div><div class=action-buttons ng-if=\"forgotPasswordForm.state===STATE_COMPLETE\"><button class=\"btn btn-primary\" ng-click=closeThisDialog()>OK</button></div></div><div class=\"section section-reset-password\"><div class=title>Reset Password</div><div class=subtitle>Enter the security code and your new password below:</div><div ng-if=\"resetPasswordForm.state!==STATE_COMPLETE\"><div class=\"input input-first\"><input type=text ng-model=resetPasswordForm.securityCode placeholder=\"Security code\" ng-disabled=\"resetPasswordForm.state===STATE_PENDING\" required></div><div class=input><input type=password ng-model=resetPasswordForm.password placeholder=\"New password\" ng-disabled=\"resetPasswordForm.state===STATE_PENDING\" required></div><div class=input><input type=password ng-model=resetPasswordForm.confirmPassword placeholder=\"Re-enter password\" ng-disabled=\"resetPasswordForm.state===STATE_PENDING\" required></div></div><div class=\"status status-error\" ng-if=resetPasswordForm.error>{{resetPasswordForm.error}}</div><div class=action-buttons><button class=\"btn btn-primary\" ng-click=resetPassword() ng-disabled=\"resetPasswordForm.state===STATE_PENDING\"><span ng-if=\"resetPasswordForm.state===STATE_IDLE || resetPasswordForm.state===STATE_COMPLETE\">Update Password</span> <span ng-if=\"resetPasswordForm.state===STATE_PENDING\"><i class=\"fa fa-spinner fa-spin\"></i></span></button></div></div></div>");
$templateCache.put("app/resume-builder/directive/resume-builder-profile-buttons.html","<div class=page-buttons-block ng-class=\"{ \'page-buttons-block-bottom\': isBottom }\"><button class=btn ng-class=buttonClass ng-click=resumeEditor.closeJobDesc() ng-if=\"resumeEditor.showButton(\'process\')\">{{\'RESUME_PROFILE_BACK_BUTTON\' | translate }}</button> <button class=btn ng-class=buttonClass ng-disabled=\"!resumeEditor.hasText() || resumeEditor.hasProcessed\" ng-click=resumeEditor.parseJob(20000) ng-if=\"resumeEditor.showButton(\'process\')\">{{\'RESUME_PROFILE_PROCESS_BUTTON\' | translate }}</button> <button class=\"btn btn-j2r\" ng-click=resumeEditor.showJobDesc() ng-if=\"resumeEditor.showButton(\'j2r\')\">{{\'RESUME_PROFILE_JOB2RESUME_BUTTON\' | translate }}</button> <button class=btn ng-class=buttonClass ng-click=\"resumeEditor.goToPage(\'edit_resume\')\" ng-if=\"resumeEditor.showButton(\'edit\')\">{{\'RESUME_PROFILE_EDIT_BUTTON\' | translate }}</button> <button class=btn ng-class=buttonClass ng-click=resumeEditor.previewEditor($event) ng-if=\"resumeEditor.showButton(\'preview_edit\') && false\">{{\'RESUME_PROFILE_PREVIEW_EDIT_BUTTON\' | translate }}</button> <button class=\"btn js-submit-validation\" ng-class=buttonClass ng-click=\"resumeEditor.validateTheResume({downloaded: false})\" ng-if=\"resumeEditor.showButton(\'save\')\">{{\'RESUME_PROFILE_SAVE_BUTTON\' | translate }}</button> <button class=btn ng-class=buttonClass ng-click=\"resumeEditor.goToPage(\'preview_resume\')\" ng-if=\"resumeEditor.showButton(\'preview\')\">{{\'RESUME_PROFILE_PREVIEW_BUTTON\' | translate }}</button> <button class=btn ng-class=buttonClass ng-click=\"resumeEditor.downloadResume($event, true)\" ng-if=\"resumeEditor.showButton(\'download\')\">{{\'RESUME_PROFILE_DOWNLOAD_BUTTON\' | translate }}</button> <button class=btn ng-class=buttonClass ng-click=\"resumeEditor.print($event, true)\" ng-if=\"resumeEditor.showButton(\'print\')\">{{\'RESUME_PROFILE_PRINT_BUTTON\' | translate }}</button></div>");
$templateCache.put("app/resume-builder/directive/ui-section.html","<!--About Me--><div ng-show=\"vm.section.sectionType === \'about_me\' \"><div class=title>About Me</div><div class=record><div class=actions><div class=\"edit fa fa-pencil-square-o\" ng-click=vmp.openSectionModal(vm.section.sectionType)></div><div class=\"delete fa fa-trash\" ng-click=vmp.deleteSectionModal(vm.section.sectionType)></div></div><div class=content ng-bind-html=vm.section.records[0].description></div></div></div><!-- Languages --><div ng-show=\"vm.section.sectionType === \'languages\' \"><div class=title>Languages</div><div class=content><div ng-repeat=\"(key, record) in vm.section.records\" class=record><div class=actions><div class=\"edit fa fa-pencil-square-o\" ng-click=\"vmp.openSectionModal(vm.section.sectionType, key)\"></div><div class=\"delete fa fa-trash\" ng-click=\"vmp.deleteSectionModal(vm.section.sectionType, key)\"></div></div><div class=languageTitle>{{record.language}}</div><div class=languageProficiency><div class=proficiencyTitle>Written</div><div class=proficiencyBarContainer><div class=proficencyBar><div class=barFill style=width:{{record.written*10*2}}%></div></div><div class=proficencyName>{{vm.proficiencyNames[record.written]}}</div></div></div><div class=languageProficiency><div class=proficiencyTitle>Verbal</div><div class=proficiencyBarContainer><div class=proficencyBar><div class=barFill style=width:{{record.verbal*10*2}}%></div></div><div class=proficencyName>{{vm.proficiencyNames[record.verbal]}}</div></div></div></div></div></div><!-- Skills --><div ng-show=\"vm.section.sectionType === \'skills\' \"><div class=title>SKILLS</div><div class=content><div ng-repeat=\"(key, record) in vm.section.records\" class=record><div class=actions><div class=\"edit fa fa-pencil-square-o\" ng-click=\"vmp.openSectionModal(vm.section.sectionType, key)\"></div><div class=\"delete fa fa-trash\" ng-click=\"vmp.deleteSectionModal(vm.section.sectionType, key)\"></div></div><div class=skillProficiency><div class=skillTitle>{{record.skill}}</div><div class=proficiencyBarContainer><div class=proficencyBar><div class=barFill style=width:{{record.proficiency*10*2}}%></div></div></div></div></div></div></div><!-- Education --><div ng-show=\"vm.section.sectionType === \'education\' \"><div class=title>Education</div><div class=content><div ng-repeat=\"(key, record) in vm.section.records\" class=record><div class=actions><div class=\"edit fa fa-pencil-square-o\" ng-click=\"vmp.openSectionModal(vm.section.sectionType, key)\"></div><div class=\"delete fa fa-trash\" ng-click=\"vmp.deleteSectionModal(vm.section.sectionType, key)\"></div></div><div class=educationRecord><div class=educationHeader><div class=circle></div><div class=educationTime>{{record.startDate.month + \" \" +record.startDate.year}} - {{ record.endDate ? record.endDate.month + \" \" +record.endDate.year: \'Present\' }}</div><div class=educationMiddle><div class=educationTitle>Major: {{record.major}}</div><div class=educationCompany>{{record.school}}</div><div class=educationDescription ng-bind-html=record.description></div></div><div class=educationLocation><div class=gpaBox>{{record.gpa}}</div><div class=gpaBoxTitle>GPA</div></div></div></div></div></div></div><!-- Experience --><div ng-show=\"vm.section.sectionType === \'experience\' \"><div class=title>Experience</div><div class=content><div ng-repeat=\"(key, record) in vm.section.records\" class=record><div class=actions><div class=\"edit fa fa-pencil-square-o\" ng-click=\"vmp.openSectionModal(vm.section.sectionType, key)\"></div><div class=\"delete fa fa-trash\" ng-click=\"vmp.deleteSectionModal(vm.section.sectionType, key)\"></div></div><div class=experienceRecord><div class=experienceHeader><div class=circle></div><div class=experienceTime>{{record.startDate.month + \" \" +record.startDate.year}} - {{ record.endDate ? record.endDate.month + \" \" +record.endDate.year: \'Present\' }}</div><div class=experienceMiddle><div class=experienceTitle>{{record.position}}</div><div class=experienceCompany>{{record.company}}</div><div class=experienceDescription ng-bind-html=record.description></div></div><div class=experienceLocation>{{record.location}}</div></div></div></div></div></div>");
$templateCache.put("app/resume-delete/template/resume-delete.html","<!-- <div class=\'resume-delete\'>\n  <button class=\"btn btn-modal-intry-dismiss\" ng-click=\"closeThisDialog()\"></button>\n  <div class=\'section section-active\'>\n    <div class=\'title\' translate=\"RESUME_DELETE_TITLE\"></div>\n    <div class=\'subtitle\'>\n        {{\'RESUME_DELETE_SUBTITLE\' | translate}} {{resume.title}}\n    </div>\n    <div class=\'action-buttons\'>\n      <div class=\'separator\'></div>\n      <button class=\'btn-action btn-action-half\' ng-click=\'closeThisDialog()\' translate=\"RESUME_DELETE_CANCEL_BUTTON_TEXT\"></button>\n      <button class=\'btn-action btn-action-half\' ng-click=\'confirm(resume)\' translate=\"RESUME_DELETE_DELETE_BUTTON_TEXT\"></button>\n    </div>\n  </div>\n</div> --><div class=\"modal-intry user-profile-resume-upload-dialog resume-delete\"><div class=\"section section-active\"><div class=title translate=RESUME_DELETE_TITLE></div><div class=subtitle>{{\'RESUME_DELETE_SUBTITLE\' | translate}} {{resume.title}}</div><div class=footer-modal><div class=\"action double\"><a ng-click=closeThisDialog();>{{\'RESUME_DELETE_CANCEL_BUTTON_TEXT\' | translate}}</a> <a ng-click=confirm(resume)>{{\'RESUME_DELETE_DELETE_BUTTON_TEXT\' | translate}}</a></div></div></div></div>");
$templateCache.put("app/resume-walkthrough/template/resume-walkthrough.html","<div ng-class=\'scrimPageBackground ? \"scrim\": \"\"\'><nav-bar user=user></nav-bar></div><section class=main-sec><header><div class=container><p>{{\"CREATE_RESUME_SECTION_TITLE\" | translate}}</p></div></header><!-- ********************* Banner Start ********************* --><div class=container ng-class=\"isResumeTemplateSectionSelected ? \'resume-template-modal\' : \'\'\"><div class=\"user-info-sec create-resume-section\" ng-show=step1><div class=\"row justify-content-center\"><div class=\"col-sm-8 col-md-8 col-lg-5\"><h6 class=p-15>{{\'RESUME_WALKTHROUGH_START_SECTION_TITlE_TEXT\' | translate}}<sup>TM</sup> <span>Resume</span></h6><p class=p-15 ng-if=!withProfileData translate=RESUME_WALKTHROUGH_START_SECTION_SUBTITlE_TEXT></p><p class=p-15 ng-if=withProfileData translate=RESUME_WALKTHROUGH_START_SECTION_SUBTITlE_TEXT_PULLED></p><h5 class=p-15 translate=RESUME_WALKTHROUGH_START_SECTION_POSITION_SUBTITlE_TEXT_PRE></h5><form class=post-apply-form><div class=form-group><label translate=RESUME_WALKTHROUGH_START_SECTION_POSITION_SUBTITlE_TEXT></label><input type=text class=form-control placeholder=\"E.g. sales\" ng-model=model.title><div class=content><div ng-if=title_required_error style=\"margin-top: 15px;color: red\" translate=RESUME_WALKTHROUGH_TITLE_REQUIRED_ERROR></div></div><button type=button ng-click=goToSelectResumeLayout()>{{\'START_BUTTON_TEXT\' | translate}}</button> <button type=button ng-click=goBack() class=\"ng-binding cancel-btn\">Cancel</button><div class=clearfix></div></div></form></div></div></div><!--********************--><div class=\"user-info-sec create-resume-section search-job-sec\" ng-show=step2><div class=\"row justify-content-center\"><div class=\"col-sm-8 col-md-8 col-lg-5\"><h6 class=p-15><span>{{\'RESUME_WALKTHROUGH_INDUSTRY_SECTION_TITLE\' | translate }}</span></h6><form class=\"post-apply-form search-job-form\"><div class=form-group><label>{{\'RESUME_WALKTHROUGH_INDUSTRY_SECTION_SUBTITLE\' | translate }}</label><input type=text class=form-control placeholder=\"Search industry\" ng-keyup=filterIndustries() ng-model=industriesFilter><div class=clearfix></div></div></form></div></div><div class=\"row justify-content-center\"><div class=col-sm-12><div class=\"designation-blocks row\"><ul class=\"designtion-cat col-sm-6 col-lg-3\" ng-repeat=\"industries in industriesEdited\"><li ng-repeat=\"industry in industries\" ng-class=\"(selectedIndustry==industry.title) ? \'isSelected\' : \'\'\" ng-click=setIndustry(industry.title)>{{industry.title}}</li></ul><div class=clearfix></div></div><div ng-if=industry_required_error class=industry-required-error style=\"margin-top: 15px;color: red\" translate=RESUME_WALKTHROUGH_INDUSTRY_REQUIRED_ERROR></div></div></div><div class=\"row justify-content-center\"><div class=\"col-sm-12 col-md-8 col-lg-6\"><button type=button class=resume-btn ng-click=goBackToStart() translate=PREV_BUTTON_TEXT></button> <button type=button class=resume-btn ng-click=goToChooseResumeTemplate() translate=NEXT_BUTTON_TEXT></button><div class=clearfix></div></div></div></div><!--********************--><div class=\"user-info-sec create-resume-section select-resume-temp-sec\" ng-show=step3><div class=\"row justify-content-center\"><div class=\"col-sm-8 col-md-8 col-lg-6\"><h6 class=p-15><span>{{\'RESUME_WALKTHROUGH_DESIGN_SECTION_TITLE\' | translate }}</span></h6><p class=p-15>{{\'RESUME_WALKTHROUGH_DESIGN_SECTION_SUBTITLE\' | translate }}</p></div></div><div class=\"row justify-content-center\"><div class=col-sm-12><ul class=select-resume-temp><li ng-repeat=\"resume_template_option in resume_template_options\" ng-class=\"(resume_template_option.isSelected) ? \'active\' : \'\'\" ng-click=setResumeTemplate($index)><img ng-src={{THUMBNAIL_STATIC_URL}}{{resume_template_option.image_url}} alt=resume-1 class=img-fluid ng-model=model.resumeTemplate value={{resume_template_option.value}}> <span class=green-overlay><a></a></span></li></ul><div class=\"row justify-content-center\"><div class=\"col-sm-12 col-md-8 col-lg-6\"><button type=button class=resume-btn ng-click=goBackToSelectResumeLayout() translate=PREV_BUTTON_TEXT></button> <button type=button class=resume-btn ng-click=goToResumeTitle() translate=NEXT_BUTTON_TEXT></button><div class=clearfix></div></div></div></div><div ng-if=TemplateSelected_error class=industry-required-error style=\"margin-top: 15px;color: red\" translate=RESUME_WALKTHROUGH_RESUME_REQUIRED_ERROR></div></div></div><!--********************--><div class=\"user-info-sec create-resume-section select-resume-temp-sec\" ng-show=step4><div class=\"row justify-content-center\"><div class=\"col-sm-8 col-md-8 col-lg-6\"><h6 class=p-15><span>{{\'RESUME_WALKTHROUGH_TITLE_SECTION_TITLE\' | translate }}</span></h6><p class=p-15>{{\'RESUME_WALKTHROUGH_TITLE_SECTION_SUBTITLE\' | translate }}</p></div></div><div class=\"row justify-content-center\"><div class=col-sm-7><div name=walkthrough-about id=walkthrough-about></div><div ng-if=aboutme_required_error class=aboutme-error-message style=\"margin-top: 15px;color: red\" translate=RESUME_WALKTHROUGH_TITLE_SECTION_REQUIRED_ERROR></div><div class=clearfix></div></div></div><div class=\"row justify-content-center\"><div class=\"col-sm-12 col-md-12 col-lg-12\"><div class=button-block></div></div><div class=\"col-sm-12 col-md-8 col-lg-6\"><button type=button class=resume-btn ng-click=goBackToChooseResumeTemplate() translate=PREV_BUTTON_TEXT></button> <button type=button class=resume-btn ng-click=createResume() translate=NEXT_BUTTON_TEXT></button><div class=clearfix></div></div></div></div></div><div class=\"clearfix clear\"></div></section><div class=\"clearfix clear\"></div>");
$templateCache.put("app/resumes/template/add-note.html","<div id=onboarding-modal class=ngdialog-wrapper style=\"display: block\" aria-labelledby=onboarding-modal-title aria-hidden=true><div class=\"modal-dialog modal-dialog-centered\" role=document><div class=modal-content><div class=modal-body><form name=unemployedNoteForm id=unemployedNoteForm><div class=\"section section-intro section-active\"><div class=desc><p class=text></p><h3 style=\"margin-top: 0px\" ng-show=!unemployedNote.unemployedNoteID>Add Unemployment Verification</h3><h3 style=\"margin-top: 0px\" ng-show=unemployedNote.unemployedNoteID>Update Unemployment Verification</h3><div class=\"user-exp-sec form-styles\"><!-- Common Fields --><hr><div><div class=form-row><div class=\"form-group col-lg-12\"><div class=form-section-title><label>Job Information</label></div></div></div><div class=form-row><div class=\"form-group col-lg-12\"><label>Job Link</label><input type=text class=form-control name=jobUrl ng-model=unemployedNote.jobUrl id=jobUrl placeholder=\"\" required></div></div><div class=form-row><div class=\"form-group col-lg-6\"><label>Job Type</label><input type=text class=form-control name=jobType ng-model=unemployedNote.jobType id=jobType placeholder=\"\"></div><div class=\"form-group col-lg-4\"><label>Send Date</label><br><div class=input-group moment-picker=unemployedNote.sendDateDate format=MM/DD/YYYY min-view=month max-view=month max-date=maxDate today=true change=updateSendDate()><span class=input-group-addon><i class=material-icons style=\"cursor: pointer\">calendar_today</i> </span><input ng-model=unemployedNote.sendDateDate class=form-control placeholder=\"Select a date\" ng-model-options=\"{ updateOn: \'blur\' }\" required></div></div><div class=\"form-group col-lg-2\"><label>Time</label><div class=select-style><select ng-model=unemployedNote.sendDateTime ng-options=\"x.key as x.label for x in time\" class=\"form-control form-select\" ng-change=updateSendDate()></select></div></div></div></div><!-- Company Fields --><hr><div><div class=form-row><div class=\"form-group col-lg-12\"><div class=form-section-title><label>Employer/Service/Agency</label></div></div></div><div class=form-row><div class=\"form-group col-lg-6\"><label>Name</label><input type=text class=form-control name=companyName ng-model=unemployedNote.companyName id=companyName placeholder=\"\"></div><div class=\"form-group col-lg-6\"><label>Address</label><input type=text class=form-control name=companyAddress ng-model=unemployedNote.companyAddress id=companyAddress placeholder=\"\"></div></div><div class=form-row><div class=\"form-group col-lg-3\"><label>City</label><input type=text class=form-control name=companyCity ng-model=unemployedNote.companyCity id=companyCity placeholder=\"\"></div><div class=\"form-group col-lg-3\"><label>State</label><input type=text class=form-control name=companyState ng-model=unemployedNote.companyState id=companyState placeholder=\"\"></div><div class=\"form-group col-lg-3\"><label>Zip Code</label><input type=text class=form-control name=companyZipCode ng-model=unemployedNote.companyZipCode id=companyZipCode placeholder=\"\"></div><div class=\"form-group col-lg-3\"><label>Phone</label><input type=text class=form-control name=companyPhone ng-model=unemployedNote.companyPhone id=companyPhone placeholder=\"\"></div></div></div><!-- Contact Fields --><hr><div><div class=form-row><div class=\"form-group col-lg-12\"><div class=form-section-title><label>Contact</label></div></div></div><div class=form-row><div class=\"form-group col-lg-6\"><label>Name</label><input type=text class=form-control name=contactName ng-model=unemployedNote.contactName id=contactName placeholder=\"\"></div><div class=\"form-group col-lg-6\"><label>Email</label><input type=text class=form-control name=contactEmail ng-model=unemployedNote.contactEmail id=contactEmail placeholder=\"\"></div></div><div class=form-row><div class=\"form-group col-lg-6\"><label>Mail Address</label><input type=text class=form-control name=contactMailAddress ng-model=unemployedNote.contactMailAddress id=contactMailAddress placeholder=\"\"></div><div class=\"form-group col-lg-3\"><label>Contact Phone</label><input type=text class=form-control name=contactPhone ng-model=unemployedNote.contactPhone id=contactPhone placeholder=\"\"></div></div></div><!-- Result Fields --><hr><div><div class=form-row><div class=\"form-group col-lg-12\"><div class=form-section-title><label>Result</label></div></div></div><div class=form-row><div class=\"form-group col-lg-4\"><label>Interview Date</label><br><div class=input-group moment-picker=unemployedNote.interviewDateDate format=MM/DD/YYYY min-view=month max-view=month today=true change=updateInterviewDate()><span class=input-group-addon><i class=material-icons style=\"cursor: pointer\">calendar_today</i> </span><input ng-model=unemployedNote.interviewDateDate class=form-control placeholder=Select ng-model-options=\"{ updateOn: \'blur\' }\"></div></div><div class=\"form-group col-lg-2\"><label>Time</label><div class=select-style><select ng-model=unemployedNote.interviewDateTime ng-options=\"x.key as x.label for x in time\" class=\"form-control form-select\" ng-change=updateInterviewDate()></select></div></div><div class=\"form-group col-lg-2\"><label class=checkbox-label>Hired</label><div class=checkbox-container><input type=checkbox class=form-control name=hired ng-model=unemployedNote.hired id=hired></div></div><div class=\"form-group col-lg-4\"><label>Job Start Date</label><br><div class=input-group moment-picker=unemployedNote.jobStartDateDate format=MM/DD/YYYY min-view=month max-view=month today=true change=updateJobStartDate()><span class=input-group-addon><i class=material-icons style=\"cursor: pointer\">calendar_today</i> </span><input ng-model=unemployedNote.jobStartDateDate class=form-control placeholder=Select ng-model-options=\"{ updateOn: \'blur\' }\"></div></div></div></div><!-- Notes Fields --><hr><div><div class=form-row><div class=\"form-group col-lg-11\"><div class=form-section-title><label>Notes</label></div></div><div class=\"form-group col-lg-1\"><div class=form-element-btn-container><i class=material-icons style=\"cursor: pointer\" ng-click=addNoteNote(note) ng-show=showAddNoteNote()>add_circle</i></div></div></div><div ng-repeat=\"note in unemployedNote.notes track by $index\"><div class=form-row ng-if=showNoteNote(note)><div class=\"form-group col-lg-4\"><label>Date</label><br><div class=input-group moment-picker=note.noteDateDate format=MM/DD/YYYY min-view=month max-view=month max-date=maxDate today=true change=updateNoteNoteDate(note)><span class=input-group-addon><i class=material-icons style=\"cursor: pointer\">calendar_today</i> </span><input ng-model=note.noteDateDate class=form-control placeholder=Select ng-model-options=\"{ updateOn: \'blur\' }\" required></div></div><div class=\"form-group col-lg-2\"><label>Time</label><div class=select-style><select ng-model=note.noteDateTime ng-options=\"x.key as x.label for x in time\" class=\"form-control form-select\" placeholder=Select ng-change=updateNoteNoteDate(note)></select></div></div><div class=\"form-group col-lg-5\"><label>Note</label><input type=text class=form-control ng-model=note.note placeholder=\"Enter a Note\" required></div><div class=\"form-group col-lg-1\"><label>&nbsp;</label><br><div class=form-element-btn-container><i class=material-icons style=\"cursor: pointer\" ng-click=deleteNoteNote(note) ng-show=showDeleteNoteNote()>delete</i></div></div></div><hr ng-if=showNoteNote(note)></div></div></div><p></p></div><div class=buttons-block><div class=form-row><div class=col-lg-12><button ng-class=\"getOrganizationCss(\'pagination-search-btn add-record-btn\')\" ng-click=closeAddNoteModal()>Cancel</button> <button ng-class=\"getOrganizationCss(\'pagination-search-btn add-record-btn\')\" ng-click=saveNote() ng-disabled=!validateUnemployedNoteFields()>Save</button></div></div></div></div></form></div></div></div></div>");
$templateCache.put("app/resumes/template/resumes.html","<div ng-class=\'scrimPageBackground ? \"scrim\": \"\"\'><nav-bar user=user></nav-bar></div><section class=main-sec><header ng-class=\"getOrganizationCss(\'header\', true)\"><div class=container><div class=page-name-block><div class=row><div class=section-title><p ng-show=!vm.wizard.isWizard>{{\'RESUME_SECTION_TITLE\' | translate }}</p><div class=header-subtitle>{{\'Work Search Log Capable\' | translate}}</div></div><div class=\"section-buttons button-header\"><button type=button class=create-resume-btn ng-disabled=isPaused ng-click=openCreateProfileResume()>{{\'CREATE_PROFILE_RESUME_BUTTON_TEXT\' | translate }}</button></div></div><div class=clearfix></div></div></div></header><div class=container><div class=\"user-info-sec my-resume-sec user-info-sec-mod\"><div class=col-sm-12><div class=\"row justify-content-center\"><div class=\"col-sm-8 col-md-6 col-lg-4 col-xl-3 paddinglr-20\" ng-repeat=\"resume in resumes\"><!-- <a ui-sref=\"resume-profile({ resumeId: resume.resumeID, new: false })\"> --><div class=myresume-block><a ng-class=\"getOrganizationCss(\'myresume-delete\')\" context-menu=menuOptions context-menu-on=click context-menu-class=resumes-context-menu id=dropdown-resume-{{resume.resumeID}}><img src=/media/images/dropdown-white.png alt=resume class=dropdown></a><div class=myresume-img><img ng-src={{resume.meta.export.thumbnail}} org={{resume.meta.export.thumbnail}} on-error-src={{resume.content.resume_layout}} alt=resume class=img-fluid></div></div><!-- </a> --><div class=myresume-detail><div class=row><div><p class=myresume-cat>{{resume.title}}</p></div></div><div class=row><div><p class=myresume-create-date>Last Updated {{resume.updated | date : \"MM/dd/y\" }}</p></div></div></div></div></div></div><div class=col-sm-12><div class=\"row justify-content-center\"><div class=no-resume ng-if=!resumes.length><div class=resume-sample-text>Sample Resume</div><div class=resume-sample-img><img src=//s3.amazonaws.com/static.intry.careers/images/webapp/resume-template-thumbnail/default.png class=img-fluid></div></div></div></div><div class=clearfix></div></div><div class=\"clearfix clear\"></div></div><div class=\"clearfix clear\"></div></section>");
$templateCache.put("app/resumes/template/validation-error-dialog.html","<div class=\"modal-intry resume-validation-dialog\"><button class=\"btn btn-modal-intry-dismiss\" ng-click=closeThisDialog();></button><div class=\"section section-active\"><div class=title>Complete Your Profile</div><div class=subtitle>We just need a few more details…</div><div class=subtitle>We\'re not mind readers, and as you know<br>...neither are job recruiters.</div><div class=subtitle>Please complete all required fields and include at least one Experience or Education before moving forward.</div><div class=footer-modal><div class=\"action double\"><!--<a ng-click=\"closeThisDialog()\">Back</a>--> <a ng-click=gotoProfile();>Edit my data</a></div></div></div></div>");
$templateCache.put("app/unemployed-notes/template/unemployed-notes.html","<div ng-class=\'scrimPageBackground ? \"scrim\": \"\"\'><nav-bar user=user></nav-bar></div><section class=main-sec><header ng-class=\"getOrganizationCss(\'header\', true)\"><div class=\"container container-job\"><div class=page-name-block><div class=row><div class=section-title><p>{{\'UNEMPLOYED_NOTES_TITLE\' | translate }}</p></div><div class=section-buttons><button type=button class=\"create-resume-btn top-btn\" ng-click=openAddUnemployedNote()>Add</button> <button type=button class=\"create-resume-btn top-btn\" ng-click=download()>{{\'UNEMPLOYED_NOTES_DOWNLOAD_TEXT\' | translate }}</button></div><div class=clearfix></div></div></div></div></header><div class=container><div class=\"user-info-sec my-resume-sec notes-sec user-info-sec-mod\"><div class=\"col-sm-12 job-search-container\"><div class=\"row form-styles margin-bottom\"><div class=\"col-lg-2 col-md-3 padding-right-zero\" ng-show=false><div class=select-style><select ng-model=filterField ng-options=\"x.key as x.label for x in unemployedNotesFilterFields\" class=\"form-control form-select\" ng-change=checkFtypes()></select></div></div><div class=\"col-lg-2 col-md-3 padding-right-zero\" ng-show=false><div class=select-style><select ng-model=ftype ng-options=\"x.key as x.label for x in ftypes\" class=\"form-control form-select\"></select></div></div><div class=\"col-lg-10 col-md-10 padding-right-zero\"><input ng-model=paginationFilter type=text placeholder=Search class=form-control></div><div class=\"col-lg-2 col-md-2\"><button ng-click=search() ng-class=\"getOrganizationCss(\'pagination-search-btn search-record-btn\')\"><i class=\"material-icons search-record-icon\">search</i></button></div></div><div class=\"row form-styles margin-bottom\"><div class=\"col-lg-4 col-md-5 padding-right-zero\"><div class=input-group moment-picker=paginationFilterFrom format=MM/DD/YYYY min-view=month max-view=month max-date=maxDate today=true change=\"checkFilterDate(\'from\')\"><span class=input-group-addon><label style=\"margin-bottom: 0px; width: 60px\">From</label></span><input ng-model=paginationFilterFrom class=form-control placeholder=\"Select a date\" ng-model-options=\"{ updateOn: \'blur\' }\"></div></div><div class=\"col-lg-4 col-md-5 padding-right-zero\"><div class=input-group moment-picker=paginationFilterTo format=MM/DD/YYYY min-view=month max-view=month max-date=maxDate today=true change=\"checkFilterDate(\'to\')\"><span class=input-group-addon><label style=\"margin-bottom: 0px; width: 60px\">To</label></span><input ng-model=paginationFilterTo class=form-control placeholder=\"Select a date\" ng-model-options=\"{ updateOn: \'blur\' }\"></div></div><div class=\"col-lg-2 col-md-2 offset-lg-2\"><button ng-click=clear() ng-class=\"getOrganizationCss(\'pagination-clear-btn search-record-btn\')\"><label>Clear</label></button></div></div><div class=row><div class=\"col-md-12 overflow-x-auto\"><table st-table=unemployedNotes st-pipe=getUnemployedNotes ng-class=\"getOrganizationCss(\'table table-striped intry-table notes-table\')\"><thead><tr><th st-sort=resumeTitle ng-click=setResetSkip(true) class=sort-button translate=UNEMPLOYED_NOTES_RESUME_HEAD_TEXT></th><th st-sort=companyName ng-click=setResetSkip(true) class=sort-button translate=UNEMPLOYED_NOTES_JOB_COMPANY_HEAD_TEXT></th><th translate=UNEMPLOYED_NOTES_CONTACT_NAME_HEAD_TEXT></th><th st-sort=contactEmail ng-click=setResetSkip(true) class=sort-button translate=UNEMPLOYED_NOTES_JOB_EMAIL_HEAD_TEXT></th><th st-sort=sendDate ng-click=setResetSkip(true) class=\"padding-left sort-button\" translate=UNEMPLOYED_NOTES_SEND_DATE_HEAD_TEXT></th><th translate=UNEMPLOYED_NOTES_NOTE_HEAD_TEXT></th><th class=\"text-align-right padding-right\" translate=ADMIN_SECTION_ACTIONS_HEAD_TEXT></th></tr></thead><tbody ng-show=!isLoading><tr ng-repeat=\"row in unemployedNotes\"><td class=\"capitalize account-details\" data-title=\"{{\'UNEMPLOYED_NOTES_RESUME_HEAD_TEXT\' | translate}}\">{{row.resumeTitle}}</td><td class=\"capitalize account-details\" data-title=\"{{\'UNEMPLOYED_NOTES_JOB_COMPANY_HEAD_TEXT\' | translate}}\">{{row.companyName}}</td><td class=\"capitalize account-details\" data-title=\"{{\'UNEMPLOYED_NOTES_CONTACT_NAME_HEAD_TEXT\' | translate}}\">{{row.contactName}}</td><td class=\"capitalize account-details\" data-title=\"{{\'UNEMPLOYED_NOTES_JOB_EMAIL_HEAD_TEXT\' | translate}}\">{{row.contactEmail}}</td><td class=\"capitalize account-details\" data-title=\"{{\'UNEMPLOYED_NOTES_SEND_DATE_HEAD_TEXT\' | translate}}\">{{row.sendDate | date:\'MM/dd/yyyy\'}}</td><td class=\"capitalize account-details\" data-title=\"{{\'UNEMPLOYED_NOTES_NOTE_HEAD_TEXT\' | translate}}\">{{row.lastNote}}</td><td class=action-td><a ng-click=openUpdateUnemployedNote(row) uib-tooltip=\"{{\'ADMIN_UPDATE_BUTTON_TEXT\' | translate}}\" tooltip-placement=bottom><i class=material-icons>edit</i> </a><a ng-click=deleteNoteModal(row) uib-tooltip=\"{{\'PAGINATION_RECORD_DROPDOWN_DELETE_TEXT\' | translate}}\" tooltip-placement=bottom ng-show=(!row.deleted)><i class=material-icons>delete</i></a></td></tr></tbody><tbody ng-show=isLoading><tr><td colspan=10><div ng-class=\"getOrganizationCss(\'simple-loader\')\"></div></td></tr></tbody><tfoot><tr><td colspan=12 class=\"padding-left padding-right\"><div class=row><div class=col-md-4><div class=admin-users><div class=\"pagination padding-left-zero\"><a ng-click=getPrevPage() ng-class={disabled:disablePrev} translate=ADMIN_SECTION_ADMINS_PREV_PAGINATION_TEXT></a></div><div class=\"pagination padding-left-zero\"><a ng-click=getNextPage() ng-class={disabled:disableNext} translate=ADMIN_SECTION_ADMINS_NEXT_PAGINATION_TEXT></a></div></div></div><div class=col-md-4><div class=admin-users><div class=\"pagination center width-100\">{{\'ADMIN_SECTION_ADMINS_RESULT_NUMBER_TEXT\' | translate}}&nbsp;{{totalUnemployedNotes}}</div></div></div><div class=\"col-md-4 text-align-right\"><div class=admin-users><div class=\"pagination padding-right-zero right width-100\">{{\'ADMIN_SECTION_ADMINS_PAGE_TEXT\' | translate}}&nbsp;{{currentPage}}&nbsp;{{\'ADMIN_SECTION_ADMINS_PAGE_OF\' | translate}}&nbsp;{{totalPages}}</div></div></div></div></td></tr></tfoot></table></div></div></div><div class=clearfix></div></div><div class=\"clearfix clear\"></div></div><div class=\"clearfix clear\"></div></section>");
$templateCache.put("app/user-profile/template/assessment-next-step.html","<div id=assessment-nextstep-modal style=\"display: block\" aria-labelledby=assessment-nextstep-modal-title aria-hidden=true><div class=\"modal-dialog modal-dialog-centered\" role=document><div class=modal-content><div ng-class=\"getOrganizationCss(\'modal-body\')\"><h5 translate=USER_PROFILE_NEXTSTEP_TIITE></h5><h6 ng-show=!assessments translate=USER_PROFILE_NEXTSTEP_TITLE2></h6><h6 ng-show=assessments translate=USER_PROFILE_NEXTSTEP_TITLE3></h6><p ng-show=!assessments translate=USER_PROFILE_NEXTSTEP_CONTENT></p><p ng-show=assessments translate=USER_PROFILE_NEXTSTEP_ASSESSMENT></p><div class=take-test-btn-group><button ng-show=!assessments type=button class=\"btn btn-primary take-test-btn\" ng-click=\"gotoAssesment(); closeThisDialog()\" translate=ASSESSMENT_TAKE_TEST_SUBTITLE></button> <button ng-show=assessments type=button class=\"btn btn-primary take-test-btn\" ng-click=\"gotoAssesment(); closeThisDialog()\" translate=USER_PROFILE_FIND_FIT_VIEW_RESULT></button><p>Or</p><button type=button class=next-cancel-btn ng-click=closeThisDialog() data-dismiss=modal translate=USER_PROFILE_NEXTSTEP_SEEPROFILE></button></div></div></div></div></div>");
$templateCache.put("app/user-profile/template/modal.html","<div id=take-test-modal tabindex=-1 role=dialog aria-labelledby=take-test-modal-title aria-hidden=true><div class=\"modal-dialog modal-dialog-centered\" role=document><div class=modal-content><div ng-class=\"getOrganizationCss(\'modal-body\')\"><h5>{{\'ASSESSMENT_CONFIRMATION_SECTION_TITLE1\' | translate }}</h5><h6>{{\'ASSESSMENT_CONFIRMATION_SECTION_TITLE2\' | translate }}</h6><p>{{\'ASSESSMENT_CONFIRMATION_SECTION_SUBTITLE1\' | translate }}</p><p>{{\'ASSESSMENT_CONFIRMATION_SECTION_SUBTITLE2\' | translate }}</p><div class=take-test-btn-group><button type=button class=\"btn btn-primary let-go-btn\" ng-click=gotoAssesment() translate=ASSESSMENT_CONFIRMATION_SECTION_LETS_GO_BUTTON_TEXT></button> <button type=button ng-click=closeModal() class=\"btn btn-secondary cancel-btn\" data-dismiss=modal translate=ASSESSMENT_CONFIRMATION_SECTION_CANCEL_BUTTON_TEXT></button></div></div></div></div></div>");
$templateCache.put("app/user-profile/template/user-profile-resume-upload-dialog-pro-user.html","<!-- <div class=\"user-profile user-profile-resume-upload-dialog-pro-use \">\n    <div class=\'section section-resume-loader\' ng-if=\"!showModalError && !userProfile.showModalWarning\">\n      <div class=\"resume-loader\">\n        <div class=\"row-loader-image\">\n          <div class=\"loader-container\"></div> --><!-- <img src=\"//s3.amazonaws.com/static.intry.careers/images/webapp/onboarding_resume_loader.png\" class=\'loader-img loader-img-progress\'\n          />\n          <img src=\"//s3.amazonaws.com/static.intry.careers/images/webapp/onboarding_resume_loader.png\" class=\'loader-img\' /> --><!-- <img src=\"media/icons/Intry-Door-Transparent.png\" class=\'loader-img loader-img-progress\'/>\n          <img src=\"media/icons/Intry-Door-Transparent.png\" class=\'loader-img\'/>\n        </div>\n      </div>\n       <div class=\"resume-loading-status\">{{\'USER_RESUME_UPLOAD_MODAL_READING_RESUME_STATUS\' | translate}}</div> --><!--      </div>\n        <div class=\'section section-active\' ng-if=\"showModalError\">\n          <div class=\'title\'>\n              {{\'USER_RESUME_UPLOAD_MODAL_ERROR_TITLE\' | translate}}\n          </div>\n          <div class=\'subtitle\'>\n              {{\'USER_RESUME_UPLOAD_MODAL_ERROR_MESSAGE_LINE_1\' | translate}}\n            <br>\n            <br> {{\'USER_RESUME_UPLOAD_MODAL_ERROR_MESSAGE_LINE_2\' | translate}}\n          </div>\n          <div class=\"action\">\n            <a ng-click=\"closeLoaderModal()\" class=\"back\">{{\'USER_RESUME_UPLOAD_MODAL_ERROR_BUTTON\' | translate}}</a>\n          </div>\n        </div>\n      <div class=\'section section-active\' ng-if=\"userProfile.showModalWarning\">\n        <div class=\'title\'>\n            {{\'USER_RESUME_UPLOAD_MODAL_WARNING_TITLE_PRO\' | translate}}\n        </div>\n        <div class=\'subtitle\'>\n            {{\'USER_RESUME_UPLOAD_MODAL_WARNING_MESSAGE_LINE_2\' | translate}}\n        </div>\n        <div class=\"footer\">\n          <p class=\"resume_upload_error\">{{userProfile.resumeUploadErorr ? userProfile.resumeUploadErorr : \'\'}}</p>\n        <div class=\"action double\">\n          <a ng-click=\"loader.close()\" class=\"back\">{{\'USER_RESUME_UPLOAD_MODAL_WARNING_BUTTON_CANCEL\' | translate}}</a>\n          <a ng-click=\"userProfile.openFileSelector()\" class=\"back\">{{\'USER_RESUME_UPLOAD_MODAL_WARNING_BUTTON_UPLOAD\' | translate}}</a>\n        </div>\n        </div>\n      </div> --> <!-- </div>\n</div> -->");
$templateCache.put("app/user-profile/template/user-profile.html","<script>$(document).ready(function () {\n        var readURL = function (input) {\n            if (input.files && input.files[0]) {\n                var reader = new FileReader();\n                reader.onload = function (e) {\n                    // $(\'.profile-pic\').attr(\'src\', e.target.result);\n                };\n                reader.readAsDataURL(input.files[0]);\n            }\n        };\n\n        $(\".file-upload\").on(\'change\', function () {\n            readURL(this);\n        });\n\n        $(\".upload-button\").on(\'click\', function () {\n            $(\".file-upload\").click();\n        });\n\n        /*\n        $(\'form\').keypress( function( e ) {\n            var code = e.keyCode || e.which;\n    \n            if( code === 13 && (e.target.id != \'submit_validation\' && e.target.id != \'submit_validation_sidebar\'  && e.target.id != \'take_assessment\' && e.target.id != \'upload_image_file\' )) {\n                e.preventDefault();\n                return false; \n            }\n        });\n        */\n    });</script><section class=\"main-sec new-main-sec\"><resume-upload-dialog upload=uploadResume() success=uploadSuccess() active=showUploadResume></resume-upload-dialog><div ng-class=\'scrimPageBackground ? \"scrim\": \"\"\'><nav-bar ng-if=!userProfile.wizard.isWizard user=user></nav-bar></div><header ng-class=\"getOrganizationCss(\'header\')\"><!--<div class=\"progress\">\n                    <div class=\"progress-bar progress-bar-info progress-bar-striped\" role=\"progressbar\" aria-valuenow=\"80\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{\'width\': percentage+\'%\'}\">\n                    </div>\n                </div>--><div class=container><div class=page-name-block><div class=row><div class=section-title><p ng-if=!userProfile.wizard.isWizard>{{\'USER_PROFILE_TITLE_TEXT\' | translate}}</p></div><div class=section-buttons></div></div><div class=clearfix></div></div><div ng-if=userProfile.wizard.isWizard class=wizard-part><div ng-switch on=userProfile.resumeUploadingStatus><div ng-switch-when=success><h1>Resume Uploaded!</h1><div class=description>See what we were able to autofill below and complete anything we missed.</div></div><div ng-switch-default><h1>Create Your Profile</h1><div class=description><!--\n                            Using your profile, you’ll be able to create unlimited ATS friendly resumes.\n                            You’ll also be able to generate a resume for each specific job you apply to.\n                            --> Your profile information will be used in the ATS-friendly Hybrid Resumes™ you create.<br>You’ll be able to generate a Hybrid Resume(TM) tailored to specifically to each job you apply to.</div></div></div></div></div></header><div class=container><form name=forms.userForm id=userForm novalidate><div class=\"user-info-sec user-info-sec-mod\"><!-- #region Profile --><div class=user-pic-sec><div class=upload-user-img><div class=circle><img class=profile-pic src=/media/images/user-avatar.svg ng-if=defaultImage> <img class=profile-pic ng-src={{user.profile_picture_url}} ng-if=!defaultImage></div><div class=profile-avatar-button-container-delete-white-space ng-show=defaultImage></div><div class=profile-avatar-button-container-delete ng-show=!defaultImage><label><img class=avatar-button-img-delete src=/media/images/delete-ico.svg ng-click=showImageLoaderForDelete()></label></div><!--\n                            <div class=\"p-image\">\n                                <img class=\"upload-button\" src=\"/media/images/add-ico.svg\" />\n                                <input class=\"file-upload\" type=\"file\" accept=\"image/*\" ondrop=\"event.dataTransfer.dropEffect=\'none\';event.stopPropagation(); event.preventDefault();\" id=\"file\" class=\"upload-button\" onchange=\"angular.element(this).scope().selectProfileImage(this.files)\" autocomplete=\"off\" onclick=\"this.value = null\"/>\n                            </div>\n                            --><div class=profile-avatar-button-container><input class=profile-avatar-input-file type=file accept=image/* ondrop=\"event.dataTransfer.dropEffect=\'none\';event.stopPropagation(); event.preventDefault()\" id=file class=upload-button onchange=angular.element(this).scope().selectProfileImage(this.files) autocomplete=off onclick=\"this.value = null\"><label for=file><div ng-class=\"getOrganizationCss(\'profile-avatar-button-img\')\" src=/media/images/add-ico.svg></div></label></div></div><h1 class=user-name>{{user.first_name | capitalize}} {{user.last_name | capitalize}}</h1><div class=upload-resume-text><div class=upload-resume-wrapper><button ng-class=getOrganizationCss(userProfile.getUploadButtonClasses()) ng-click=userProfile.openWarning() id=upload_image_file><b ng-if=!userProfile.wizard.isWizard>Upload </b><span ng-if=userProfile.wizard.isWizard><span ng-switch on=userProfile.resumeUploadingStatus><span ng-if=userProfile.isFirstTimeResumeUploading><span class=btn-main-text>Upload a Different Resume</span> </span><span ng-if=!userProfile.isFirstTimeResumeUploading><span class=btn-main-text>Upload My Existing Resume</span> <span class=note>(We can read .DOC, .DOCX and .PDF files.)</span></span></span></span></button></div><div ng-if=!userProfile.wizard.isWizard class=text>a resume to autofill your profile.</div><div ng-if=\"userProfile.wizard.isWizard && userProfile.resumeUploadingStatus == \'success\'\" class=note>(This will overwrite everything below)</div></div><input ondrop=\"event.dataTransfer.dropEffect=\'none\';event.stopPropagation(); event.preventDefault()\" type=file id=upload_resume class=upload-resume-button style=display:none name=upload_resume onclick=\"this.value = null\" onchange=angular.element(this).scope().parseResumeData(this.files)></div><!-- #endregion Profile --><!-- #region Personal Information --><div class=sec-style><div class=inner-sec><h6 class=sec-heading>{{\'CREATE_RESUME_TITLE_PERSONAL_INFORMATION\' | translate}}<span id=personal_information-hotspot></span></h6><div class=\"user-exp-sec form-styles\"><div class=form-row><div class=\"form-group col-md-6\"><label for=firstname>First Name<span>&nbsp;<span class=required>*</span></span></label><input type=text class=form-control valid-method=submitted validator=requirednomsg name=firstname ng-model=user.first_name id=firstname placeholder=\"First Name\" ng-class=\"(user.first_name.length > 0) ? \'\' : \'ng-invalid\'\"></div><div class=\"form-group col-md-6\"><label for=lastname>Last Name<span>&nbsp;<span class=required>*</span></span></label><input type=text class=form-control valid-method=submitted validator=requirednomsg id=lastname name=lastname ng-model=user.last_name placeholder=\"Last Name\" ng-class=\"(user.last_name.length > 0) ? \'\' : \'ng-invalid\'\"></div></div><div class=form-row><div class=\"form-group col-md-6\"><label for=city>City</label><input type=text class=form-control name=city ng-model=userProfile.address.city id=city placeholder=City></div><div class=\"form-group col-md-4 col-xl-3\"><label for=state>State</label><input type=text class=form-control id=state name=state ng-model=userProfile.address.state placeholder=State></div></div><div class=form-row><div class=\"form-group col-md-4\"><label for=phonenumber>Phone Number<span>&nbsp;<span class=required>*</span></span></label><input type=text class=form-control id=phonenumber name=phonenumber ng-model=userProfile.phoneNumber.number placeholder=\"Phone Number 10 Digits Only\" ng-focus=userProfile.phoneFlatten() ng-blur=userProfile.phoneDisplay() ng-required=validatePhone ng-pattern=phonePattern></div></div><div class=form-row><div class=\"form-group col-md-6\"><label for=email>E-Mail<span>&nbsp;<span class=required>*</span></span></label><input type=text class=form-control valid-method=submitted validator=requirednomsg id=email name=email ng-model=user.email placeholder=E-Mail></div><div class=\"form-group col-md-6\"><label>Industry</label><md-autocomplete md-selected-item=industrySelectedTemp md-search-text=industrySearchText md-selected-item-change=saveIndustries(industry) md-items=\"industry in industrySearch(industrySearchText)\" md-item-text=industry.title md-min-length=0 placeholder=\"Type Industry and/or Search (Required)\" class=\"user-industry form-control-autocomplete\" ng-focus=fixOverflow()><md-item-template><span md-highlight-text=industrySearchText md-highlight-flags=^i class=form-control-autocomplete-item>{{industry.title}}</span></md-item-template><md-not-found>No states matching \"{{industrySearchText}}\" were found.</md-not-found><i class=\"fas fa-search industry-arrow-down\"></i></md-autocomplete></div></div></div></div></div><!-- #endregion Personal Information --><!-- #region Summary --><div class=sec-style><div class=inner-sec><div class=row-container><h6 class=sec-heading>{{\'USER_PROFILE_SUMMARY\' | translate}}<span id=summary-hotspot></span></h6><div class=show-info><img src=media/icons/question.png></div><div class=helper><h5>A resume summary statement is a two- to three-sentence professional introduction that you add at the top of your resume. Include key experiences, top skills, top achievements and professional title if relevant. You have 7 seconds to get their attention, make it count!</h5></div></div><div class=\"user-exp-sec form-styles\"><div><div class=form-row><div class=\"form-group col-md-12\"><textarea class=\"form-control summary-textarea\" id=short-desc name=short-desc rows=10 placeholder=\"{{\'USER_PROFILE_PLACEHOLDER_SUMMARY\' | translate}}\" ng-bind-html=summary ng-model=summary ng-pattern=summaryPattern></textarea></div></div><h6 class=\"summary-error job-info-title\" style=\"color:rgb(221, 44, 0)\" ng-if=checkSummary()>Provide a brief professional summary, no longer than {{summaryMaxLength}} characters, describing yourself using a few strong statements and keywords that clearly demonstrate the value you bring to the table.</h6></div></div></div></div><!-- #endregion Summary --><!-- #region Experience --><div class=sec-style><div class=inner-sec><h6 class=sec-heading>{{\'USER_PROFILE_TITLE_EXPERIENCE\' | translate}}<span id=experience-hotspot></span></h6><div class=\"user-exp-sec form-styles\"><div ng-repeat=\"experience in userProfile.experienceList\" ng-if=\"experience.deleted == false && experience.kind != \'Military\'\" ng-mouseover=\"userProfile.showAddExperienceBar[$index] = true\" ng-mouseleave=\"userProfile.showAddExperienceBar[$index] = false\" id=experienceDiv_{{$index}} class=m-30><div class=\"exp-form form-styles\"><div class=form-row><div class=\"form-group col-md-6\"><label for=exp-position>Position<span>&nbsp;<span class=required>*</span></span></label><input type=text class=form-control id=exp-position ng-model=experience.title valid-method=blur validator=required name=title_{{$index}} placeholder=\"{{\'USER_PROFILE_PLACEHOLDER_JOB_TITLE\' | translate}}\" ng-class=\"checkMissingText(\'title_\' + $index)\" ng-focus=\"focusBlurMissingText(\'title_\' + $index, true)\" ng-blur=\"focusBlurMissingText(\'title_\' + $index)\"></div><div class=\"form-group col-md-6\"><label for=exp-company>Company<span>&nbsp;<span class=required>*</span></span></label><input type=text class=form-control name=company_{{$index}} id=exp-company valid-method=blur ng-model=experience.company validator=required placeholder=\"{{\'USER_PROFILE_PLACEHOLDER_COMPANY\' | translate}}\" ng-class=\"checkMissingText(\'company_\' + $index)\" ng-focus=\"focusBlurMissingText(\'company_\' + $index, true)\" ng-blur=\"focusBlurMissingText(\'company_\' + $index)\"></div></div><div class=form-row><div class=\"form-group col-md-6\"><label for=exp-position>Location</label><input type=text class=form-control id=exp-position ng-model=experience.location name=experience_location_{{$index}} placeholder=Location></div></div><div class=form-row><div class=\"form-group col-md-6\"><label>Start Date<span>&nbsp;<span class=required>*</span></span></label><div class=form-row><div class=\"col-sm-6 paddingr-15\"><div class=\"select-style exp-month\"><select class=form-control name=exp_start_mon_{{$index}} ng-options=\"item.monthNumber as item.fullmonthName  for item in months\" ng-model=experience.startMonthObj><option value=\"\">Select</option></select></div></div><div class=\"col-sm-6 paddingl-15\"><div class=select-style><select class=form-control validator=required name=exp_start_year_{{$index}} ng-options=\"year for year in years\" ng-model=experience.startYearObj ng-class=\"checkMissingText(\'exp_start_year_\' + $index, \'select\')\"><option value=\"\">Select</option></select></div></div></div></div><div class=\"form-group col-md-6\"><label>End Date<span>&nbsp;<span class=required>*</span></span></label><div class=form-row><div class=\"col-sm-6 paddingr-15\"><div class=\"select-style exp-month\"><select class=form-control ng-model=experience.endMonthObj ng-options=\"item.monthNumber as item.fullmonthName  for item in months\" ng-disabled=experience.is_current><option value=\"\">Select</option></select></div></div><div class=\"col-sm-6 paddingl-15\"><div class=select-style><select class=form-control ng-model=experience.endYearObj name=exp_end_year_{{$index}} ng-options=\"year for year in years\" ng-class=\"checkMissingText(\'exp_end_year_\' + $index, \'select\')\" ng-disabled=experience.is_current><option value=\"\">Select</option></select></div></div><div class=current-checkbox-wrapper><label class=checkbox-btn><input type=checkbox ng-model=experience.is_current ng-change=setCurrentItem(experience)> <span>Present</span></label></div></div></div></div><div class=form-row><div class=\"form-group col-md-12\"><label for=exp-short-desc>Description</label><div class=\"add-info editable-inline\" placeholder=Summary id=experience_{{$index}} ng-bind-html=experience.summary ng-model=experience.summary ng-focus=\"isEditable(\'experience_\' + $index)\" ng-click=\"isEditable(\'experience_\' + $index)\"></div></div></div><button class=\"delete-new-sec profile-delete-btn\" ng-show=\"userProfile.experienceList.length > 0\" ng-click=\"userProfile.removeExperience(experience, \'exp_short_desc_\'+$index)\"><img src=/media/images/delete.svg alt=\"delete icon\" class=img-fluid></button></div></div><button ng-class=\"getOrganizationCss(\'add-new-sec\')\" ng-click=\"userProfile.addNewExperience(0, true)\">Add New Experience</button></div></div></div><!-- #endregion Experience --><!-- #region Education --><div class=sec-style><div class=inner-sec><h6 class=sec-heading>Education<span id=education-hotspot></span></h6><div class=user-edu-sec><div ng-repeat=\"education in userProfile.educationList\" ng-if=\"education.deleted == false && education.kind != \'certification\'\" ng-mouseover=\"userProfile.showAddEducationBar[$index] = true\" ng-mouseleave=\"userProfile.showAddEducationBar[$index] = false\" id=eductionDiv_{{$index}} class=m-30><div class=\"edu-form form-styles\"><div class=form-row><div class=\"form-group col-md-6\"><div class=form-row><div class=\"col-sm-6 paddingr-15\"><label for=degree-major>Degree<span>&nbsp;<span>*</span></span></label><input type=text class=form-control name=degree_{{$index}} ng-model=education.degree id=degree-major placeholder=\"Enter Degree\"></div><div class=\"col-sm-6 paddingr-15\"><label for=major>Major</label><input type=text class=form-control name=major_{{$index}} ng-model=education.major id=major placeholder=\"Enter Major\"></div></div></div><div class=\"form-group col-md-6\"><label for=uni-name>University<span>&nbsp;<span class=required>*</span></span></label><input type=text class=form-control validator=required id=uni-name name=university__{{$index}} ng-model=education.institution placeholder=\"University Name\" ng-class=\"checkMissingText(\'university__\' + $index)\" ng-focus=\"focusBlurMissingText(\'university__\' + $index, true)\" ng-blur=\"focusBlurMissingText(\'university__\' + $index)\"></div></div><div class=form-row><div class=\"form-group col-md-6\"><label>Start Date (Optional)</label><div class=form-row><div class=\"col-sm-6 paddingr-15\"><div class=\"select-style exp-month\"><select class=form-control name=edu_start_mon__{{$index}} ng-options=\"item.monthNumber as item.fullmonthName  for item in months\" ng-model=education.startMonthObj><option value=\"\">Select</option></select></div></div><div class=\"col-sm-6 paddingl-15\"><div class=select-style><select class=form-control name=edu_start_year__{{$index}} ng-options=\"year for year in years\" ng-model=education.startYearObj><option value=\"\">Select</option></select></div></div></div></div><div class=\"form-group col-md-6\"><label>End Date (Optional)</label><div class=form-row><div class=\"col-sm-6 paddingr-15\"><div class=\"select-style exp-month\"><select class=form-control name=edu_end_mon__{{$index}} ng-options=\"item.monthNumber as item.fullmonthName  for item in months\" ng-model=education.endMonthObj><option value=\"\">Select</option></select></div></div><div class=\"col-sm-6 paddingl-15\"><div class=select-style><select class=form-control ng-options=\"year for year in years2\" name=educ_end_year_{{$index}} ng-model=education.endYearObj><option value=\"\">Select</option></select></div></div></div></div></div><div class=form-row><div class=\"form-group col-md-12\"><label for=edu-short-desc>Description</label><div class=\"add-info editable-inline\" placeholder=Education id=education_{{$index}} ng-bind-html=education.notes ng-model=education.notes ng-focus=\"isEditable(\'education_\' + $index)\" ng-click=\"isEditable(\'education_\' + $index)\"></div></div></div><button class=\"delete-new-sec profile-delete-btn\" ng-show=\"userProfile.educationList.length > 0\" ng-click=\"userProfile.removeEducation(education, \'edu_short_desc_\'+$index)\" role=button tabindex=0><img src=/media/images/delete.svg alt=\"delete icon\" class=img-fluid></button></div></div><button ng-class=\"getOrganizationCss(\'add-new-sec\')\" ng-click=\"userProfile.addNewEducation(0, true)\">Add New Education</button></div></div></div><!-- #endregion Education --><!-- #region Skills --><div class=sec-style><div class=inner-sec><div class=row-container><h6 class=sec-heading>{{\'USER_PROFILE_TITLE_SKILLS\' | translate}}<span id=summary-hotspot></span></h6><div class=show-info><img src=media/icons/question.png></div><div class=helper><h5>When selecting your key skills, be sure to list them in order of importance to the job you are applying for. Try not to list more than 16 skills in a resume and make sure your skills match the specific job you are interested in.</h5></div></div><div class=user-skill-sec dragula=\"\'skills-bag\'\" dragula-model=userProfile.skillsList><div ng-class=\"{\'error-feild\': userProfile.skillsListError && userProfile.skillsListError[$index]}\" ng-repeat=\"skill in userProfile.skillsList  | filter: {\'deleted\': false}\" ng-mouseover=\"userProfile.showAddSkillBar[$index] = true\" ng-mouseleave=\"userProfile.showAddSkillBar[$index] = false\" id=skillDiv_{{$index}} class=skill-item><div class=\"skill-form form-styles\"><div class=form-row><div class=\"form-group col-md-6\"><label for=skill-name>Name<span>&nbsp;<span class=required>*</span></span></label><input type=text class=form-control id=skill-name ng-model=skill.skill name=skillName_{{$index}} validator=required placeholder=\'{{\"USER_PROFILE_ADD_SKILL\" | translate}}\' ng-class=\"checkMissingText(\'skillName_\' + $index)\"></div><div class=\"form-group col-md-6\"><label>Level (optional)</label><table class=skill-level-table><tr><td><input class=enable-skill-level-checkbox type=checkbox ng-checked=\"skill.proficiency > 0\" ng-click=enableSkillLevel(skill)></td><td><div class=\"rating-bar clearfix\" ng-show=\"skill.proficiency > 0\"><span class=rating-control id=skill_{{$index}} ndx={{$index}} data-rating={{skill.proficiency}}><span aria-hidden=true>&#11035;&#11035;&#11035;&#11035;&#11035;</span></span><p>{{skill.proficiency}} {{proficiencyList[skill.proficiency]}}</p></div></td></tr></table></div></div><button class=\"delete-new-sec profile-delete-btn\" ng-click=userProfile.removeSkill(skill) role=button tabindex=0><img src=/media/images/delete.svg alt=\"delete icon\" class=img-fluid></button> <span class=\"material-icons reorder-btn skills-bag-draggable\" title=\'{{\"USER_PROFILE_MOVE_SKILL\" | translate}}\'>reorder</span></div></div></div><button ng-class=\"getOrganizationCss(\'add-new-sec\')\" ng-click=\"userProfile.addNewSkill(0, true)\">Add New Skill</button></div></div><!-- #endregion Skills --><!-- #region Achievements and Awards --><div class=sec-style><div class=inner-sec><h6 class=sec-heading>{{\'USER_PROFILE_TITLE_ACHIEVEMENTS_AND_AWARDS\' | translate}}<span id=achievements-hotspot></span></h6><div class=user-award-sec><div ng-class=\"{\'error-feild\': userProfile.awardListError && userProfile.awardListError[$index]} \" ng-repeat=\"award in userProfile.achievements_awards  | filter: {\'deleted\': false}\" ng-mouseover=\"userProfile.showAddAwardBar[$index] = true\" ng-mouseleave=\"userProfile.showAddAwardBar[$index] = false\" id=awardDiv_{{$index}} class=m-30><div class=\"award-form form-styles\"><div class=form-row><div class=\"form-group col-md-6 paddingl-15\"><label for=award-name>Name<span>&nbsp;<span class=required>*</span></span></label><input type=text class=form-control validator=required id=award-name placeholder=\'{{\"USER_PROFILE_ADD_ACHIEVEMENTS_&_AWARDS\" | translate}}\' name=award_{{$index}} ng-model=award.summary ng-class=\"checkMissingText(\'award_\' + $index)\"></div><button class=\"delete-new-sec profile-delete-btn\" ng-show=userProfile.achievements_awards.length ng-click=userProfile.removeAward(award) role=button tabindex=0><img src=/media/images/delete.svg alt=\"delete icon\" class=img-fluid></button></div><div class=form-row><div class=\"form-group col-md-6 paddingl-15\"><label>Date (Optional)</label><div class=form-row><div class=col-sm-6><div class=\"select-style exp-month\"><select class=form-control name=award_month_{{$index}} ng-options=\"item.monthNumber as item.fullmonthName for item in months\" ng-model=award.startMonthObj><option value=\"\">Select</option></select></div></div><div class=col-sm-6><div class=select-style><select class=form-control name=award_year_{{$index}} ng-options=\"year for year in years\" ng-model=award.startYearObj><option value=\"\">Select</option></select></div></div></div></div></div></div></div><button ng-class=\"getOrganizationCss(\'add-new-sec\')\" ng-click=\"userProfile.addNewAward(0, true)\">Add New Achievement</button></div></div></div><!-- #endregion Achievements and Awards --><!-- #region Certifications --><div class=sec-style><div class=inner-sec><h6 class=sec-heading>{{\'CREATE_RESUME_TITLE_CERTIFICATES\' | translate}}<span id=certifications-hotspot></span></h6><div class=user-edu-sec><div ng-repeat=\"education in userProfile.educationList\" ng-if=\"education.deleted == false && education.kind == \'certification\'\" ng-mouseover=\"userProfile.showAddEducationBar[$index] = true\" ng-mouseleave=\"userProfile.showAddEducationBar[$index] = false\" id=certificationDiv_{{$index}} class=m-30><div class=\"edu-form form-styles\"><div class=form-row><div class=\"form-group col-md-6\"><div class=form-row><div class=\"col-sm-12 paddingr-15\"><label for=certification-degree-major>Name of Certification<span>&nbsp;<span class=required>*</span></span></label><input type=text class=form-control validator=required name=certification_degree_{{$index}} ng-model=education.degree id=certification-degree-major placeholder=\"Enter Name of Certification\" ng-class=\"checkMissingText(\'certification_degree_\' + $index)\" ng-focus=\"focusBlurMissingText(\'certification_degree_\' + $index, true)\" ng-blur=\"focusBlurMissingText(\'certification_degree_\' + $index)\"></div><div class=\"col-sm-6 paddingr-15\" ng-show=false><label for=certification-major>Major</label><input type=text class=form-control name=certification_major_{{$index}} ng-model=education.major id=certification-major placeholder=\"Enter Major\"></div></div></div><div class=\"form-group col-md-6\"><label for=certification-uni-name>Name of Organization<span>&nbsp;<span class=required>*</span></span></label><input type=text class=form-control validator=required id=certification-uni-name name=certification_university__{{$index}} ng-model=education.institution placeholder=\"Enter Name of Organization\" ng-class=\"checkMissingText(\'certification_university__\' + $index)\" ng-focus=\"focusBlurMissingText(\'certification_university__\' + $index, true)\" ng-blur=\"focusBlurMissingText(\'certification_university__\' + $index)\"></div></div><div class=form-row><div class=\"form-group col-md-6\"><label>Start Date (Optional)</label><div class=form-row><div class=\"col-sm-6 paddingr-15\"><div class=\"select-style exp-month\"><select class=form-control name=certification_edu_start_mon__{{$index}} ng-options=\"item.monthNumber as item.fullmonthName  for item in months\" ng-model=education.startMonthObj><option value=\"\">Select</option></select></div></div><div class=\"col-sm-6 paddingl-15\"><div class=select-style><select class=form-control name=certification_edu_start_year__{{$index}} ng-options=\"year for year in years\" ng-model=education.startYearObj><option value=\"\">Select</option></select></div></div></div></div><div class=\"form-group col-md-6\"><label>End Date (Optional)</label><div class=form-row><div class=\"col-sm-6 paddingr-15\"><div class=\"select-style exp-month\"><select class=form-control name=certification_edu_end_mon__{{$index}} ng-options=\"item.monthNumber as item.fullmonthName  for item in months\" ng-model=education.endMonthObj><option value=\"\">Select</option></select></div></div><div class=\"col-sm-6 paddingl-15\"><div class=select-style><select class=form-control ng-options=\"year for year in years\" name=certification_educ_end_year_{{$index}} ng-model=education.endYearObj><option value=\"\">Select</option></select></div></div></div></div></div><div class=form-row><div class=\"form-group col-md-12\"><label for=edu-short-desc>Description</label><div class=\"add-info editable-inline\" placeholder=Education id=certification_education_{{$index}} ng-bind-html=education.notes ng-model=education.notes ng-focus=\"isEditable(\'certification_education_\' + $index)\" ng-click=\"isEditable(\'certification_education_\' + $index)\"></div></div></div><button class=\"delete-new-sec profile-delete-btn\" ng-show=\"userProfile.educationList.length > 0\" ng-click=\"userProfile.removeEducation(education, \'edu_short_desc_\'+$index)\" role=button tabindex=0><img src=/media/images/delete.svg alt=\"delete icon\" class=img-fluid></button></div></div><button ng-class=\"getOrganizationCss(\'add-new-sec\')\" ng-click=\"userProfile.addNewEducation(0, true, true)\">Add New Certification</button></div></div></div><!-- #endregion Certifications --><!-- #region Military Experience --><div class=sec-style><div class=inner-sec><h6 class=sec-heading>{{\'CREATE_RESUME_TITLE_MILITARY_EXPERIENCE\' | translate}}<span id=military-hotspot></span></h6><div class=\"user-exp-sec form-styles\"><div ng-repeat=\"experience in userProfile.experienceList\" ng-if=\"experience.deleted == false && experience.kind == \'Military\'\" ng-mouseover=\"userProfile.showAddExperienceBar[$index] = true\" ng-mouseleave=\"userProfile.showAddExperienceBar[$index] = false\" id=militaryExperienceDiv_{{$index}} class=m-30><div class=\"exp-form form-styles\"><div class=form-row><div class=\"form-group col-md-6\"><label for=military-exp-position>Position<span>&nbsp;<span class=required>*</span></span></label><input type=text class=form-control id=military-exp-position ng-model=experience.title valid-method=blur validator=required name=military_title_{{$index}} placeholder=\"{{\'USER_PROFILE_PLACEHOLDER_JOB_TITLE\' | translate}}\" ng-class=\"checkMissingText(\'military_title_\' + $index)\" ng-focus=\"focusBlurMissingText(\'military_title_\' + $index, true)\" ng-blur=\"focusBlurMissingText(\'military_title_\' + $index)\"></div><div class=\"form-group col-md-6\"><label for=military-military-exp-company>Company<span>&nbsp;<span class=required>*</span></span></label><input type=text class=form-control name=military_company_{{$index}} id=military-exp-company valid-method=blur ng-model=experience.company validator=required placeholder=\"{{\'USER_PROFILE_PLACEHOLDER_COMPANY\' | translate}}\" ng-class=\"checkMissingText(\'military_company_\' + $index)\" ng-focus=\"focusBlurMissingText(\'military_company_\' + $index, true)\" ng-blur=\"focusBlurMissingText(\'military_company_\' + $index)\"></div></div><div class=form-row><div class=\"form-group col-md-6\"><label for=military-exp-position>Location</label><input type=text class=form-control id=military-exp-position ng-model=experience.location name=military_experience_location_{{$index}} placeholder=Location></div></div><div class=form-row><div class=\"form-group col-md-6\"><label>Start Date<span>&nbsp;<span class=required>*</span></span></label><div class=form-row><div class=\"col-sm-6 paddingr-15\"><div class=\"select-style exp-month\"><select class=form-control name=military_exp_start_mon_{{$index}} ng-options=\"item.monthNumber as item.fullmonthName  for item in months\" ng-model=experience.startMonthObj><option value=\"\">Select</option></select></div></div><div class=\"col-sm-6 paddingl-15\"><div class=select-style><select class=form-control validator=required name=military_exp_start_year_{{$index}} ng-options=\"year for year in years\" ng-model=experience.startYearObj ng-class=\"checkMissingText(\'military_exp_start_year_\' + $index, \'select\')\"><option value=\"\">Select</option></select></div></div></div></div><div class=\"form-group col-md-6\"><label>End Date<span>&nbsp;<span class=required>*</span></span></label><div class=form-row><div class=\"col-sm-6 paddingr-15\"><div class=\"select-style exp-month\"><select class=form-control ng-model=experience.endMonthObj ng-options=\"item.monthNumber as item.fullmonthName  for item in months\" ng-disabled=experience.is_current><option value=\"\">Select</option></select></div></div><div class=\"col-sm-6 paddingl-15\"><div class=select-style><select class=form-control ng-model=experience.endYearObj name=military_exp_end_year_{{$index}} ng-options=\"year for year in years\" ng-class=\"checkMissingText(\'military_exp_end_year_\' + $index, \'select\')\" ng-disabled=experience.is_current><option value=\"\">Select</option></select></div></div><div class=current-checkbox-wrapper><label class=checkbox-btn><input type=checkbox ng-model=experience.is_current ng-change=setCurrentItem(experience)> <span>Present</span></label></div></div></div></div><div class=form-row><div class=\"form-group col-md-12\"><label for=military-exp-short-desc>Description</label><div class=\"add-info editable-inline\" placeholder=Summary id=military_experience_{{$index}} ng-bind-html=experience.summary ng-model=experience.summary ng-focus=\"isEditable(\'military_experience_\' + $index)\" ng-click=\"isEditable(\'military_experience_\' + $index)\"></div></div></div><button class=\"delete-new-sec profile-delete-btn\" ng-show=\"userProfile.experienceList.length > 0\" ng-click=\"userProfile.removeExperience(experience, \'exp_short_desc_\'+$index)\"><img src=/media/images/delete.svg alt=\"delete icon\" class=img-fluid></button></div></div><button ng-class=\"getOrganizationCss(\'add-new-sec\')\" ng-click=\"userProfile.addNewExperience(0, true, true)\">Add New Military</button></div></div></div><!-- #endregion Military Experience --><!-- #region Links --><div class=sec-style style=\"display: none\"><div class=inner-sec><h6 class=sec-heading>Links</h6><div class=user-links-sec><div ng-class=\"{\'error-feild\': userProfile.linkListError && userProfile.linkListError[$index]} \" ng-repeat=\"link in userProfile.linkList  | filter: {\'deleted\': false}\" ng-mouseover=\"userProfile.showAddLinkBar[$index] = true\" ng-mouseleave=\"userProfile.showAddLinkBar[$index] = false\" id=linkDiv_{{$index}} class=m-30><div class=\"links-form form-styles\"><div class=form-row><div class=\"form-group col-md-4 paddingr-15\"><label for=link-name>Name<span>&nbsp;<span class=required>*</span></span></label><input type=text class=form-control id=link-name placeholder=\"{{ \'USER_PROFILE_PLACEHOLDER_LINK_NAME\' | translate }}\" validator=required name=linksName_{{$index}} ng-model=link.name ng-class=\"checkMissingText(\'linksName_\' + $index)\" ng-focus=\"focusBlurMissingText(\'linksName_\' + $index, true)\" ng-blur=\"focusBlurMissingText(\'linksName_\' + $index)\"></div><div class=\"form-group col-md-8 paddingl-15\"><label for=url>Link<span>&nbsp;<span class=required>*</span></span></label><input type=text autocapitalize=none class=form-control id=url placeholder=\"E.g. https://occasionaljunk.com\" name=links_{{$index}} validator=required,url ng-model=link.url ng-class=\"checkMissingText(\'links_\' + $index)\"></div></div><button class=\"delete-new-sec profile-delete-btn\" ng-show=userProfile.linkList.length ng-click=userProfile.removeLink(link) role=button tabindex=0><img src=/media/images/delete.svg alt=\"delete icon\" class=img-fluid></button></div></div><button ng-class=\"getOrganizationCss(\'add-new-sec\')\" ng-click=\"userProfile.addNewLink(0, true)\">Add New Link</button></div></div></div><!-- #endregion Links --><!-- #region Transcripts --><div class=sec-style style=\"display: none\"><div class=inner-sec><h6 class=sec-heading>Transcripts</h6><div class=user-transcript-sec><div ng-class=\"{\'error-feild\': userProfile.transcriptListError && userProfile.transcriptListError[$index]} \" ng-repeat=\"transcript in userProfile.transcriptList  | filter: {\'deleted\': false}\" ng-mouseover=\"userProfile.showAddTranscriptBar[$index] = true\" ng-mouseleave=\"userProfile.showAddTranscriptBar[$index] = false\" id=transcriptDiv_{{transcript.order_index}} class=m-30><div class=\"transcript-form form-styles\"><div class=form-row><div class=\"form-group col-md-4 paddingr-15\"><label for=transcript-name>Name<span>&nbsp;<span class=required>*</span></span></label><input type=text class=form-control id=transcript-name placeholder=\"E.g. Result\" validator=required name=transcript_{{transcript.order_index}} ng-model=transcript.name ng-class=\"checkMissingText(\'transcript_\' + transcript.order_index)\"></div><div class=\"form-group col-md-8 paddingl-15\"><label for=noFile_{{transcript.order_index}}>File Upload<span>&nbsp;<span class=required>*</span></span></label><div class=file-select ng-class=\"checkMissingText(\'noFile_\' + transcript.order_index, \'file\')\"><div class=file-select-name id=noFile_{{transcript.order_index}}>{{transcript.file_name}}</div><input ondrop=\"event.dataTransfer.dropEffect=\'none\';event.stopPropagation(); event.preventDefault()\" type=file id=transcriptFile_{{transcript.order_index}} class=upload-button name=file onchange=angular.element(this).scope().selectTranscriptFile(this) autocomplete=off><div class=file-select-button id=fileName><img src=/media/images/add-btn-gray.svg></div></div></div></div><button class=\"delete-new-sec profile-delete-btn\" ng-show=userProfile.transcriptList.length ng-click=userProfile.removeTranscript(transcript) role=button tabindex=0><img src=/media/images/delete.svg alt=\"delete icon\" class=img-fluid></button></div></div><button ng-class=\"getOrganizationCss(\'add-new-sec\')\" ng-click=\"userProfile.addNewTranscript(0, true)\">Add New Transcript</button></div></div></div><!-- #endregion Transcripts --><!-- #region References --><div class=sec-style style=\"display: none\"><div class=inner-sec><h6 class=sec-heading>References</h6><div class=user-ref-sec><div ng-class=\"{\'error-feild\': userProfile.referenceListError && userProfile.referenceListError[$index]} \" ng-repeat=\"reference in userProfile.referenceList  | filter: {\'deleted\': false}\" ng-mouseover=\"userProfile.showAddReferenceBar[$index] = true\" ng-mouseleave=\"userProfile.showAddReferenceBar[$index] = false\" id=referenceDiv_{{$index}} class=m-30><div class=\"ref-form form-styles\"><div class=form-row><div class=\"form-group col-md-4 paddingr-15\"><label for=ref-person-name>Name</label><input type=text class=form-control id=ref-person-name placeholder=\"E.g. Justin\" validator=required name=reference_name_{{$index}} ng-model=reference.name ng-class=\"checkMissingText(\'reference_name_\' + $index)\" ng-focus=\"focusBlurMissingText(\'reference_name_\' + $index, true)\" ng-blur=\"focusBlurMissingText(\'reference_name_\' + $index)\"></div><div class=\"form-group col-md-4 paddingl-15 paddingr-15\"><label for=ref-relation>Relation</label><input type=text class=form-control id=ref-relation placeholder=\"E.g. Manager at Google\" validator=required name=reference_rel_{{$index}} ng-model=reference.relation ng-class=\"checkMissingText(\'reference_rel_\' + $index)\" ng-focus=\"focusBlurMissingText(\'reference_rel_\' + $index, true)\" ng-blur=\"focusBlurMissingText(\'reference_rel_\' + $index)\"></div><div class=\"form-group col-md-4 paddingl-15\"><label for=ref-email>Email</label><input type=text autocapitalize=none class=form-control id=ref-email placeholder=\"E.g. j.mit@google.com\" validator=required name=reference_email_{{$index}} ng-model=reference.email ng-class=\"checkMissingText(\'reference_email_\' + $index)\"></div></div><button class=\"delete-new-sec profile-delete-btn\" ng-show=userProfile.referenceList.length ng-click=userProfile.removeReference(reference) role=button tabindex=0><img src=/media/images/delete.svg alt=\"delete icon\" class=img-fluid></button></div></div><button ng-class=\"getOrganizationCss(\'add-new-sec\')\" ng-click=\"userProfile.addNewReference(0, true)\">Add New Reference</button></div></div></div><!-- #endregion References --><!-- #region Save Button --> <button ng-class=\"getOrganizationCss(\'sidebar-save-btn\')\" ng-click=validatePersonalData() id=submit_validation_sidebar class=btn-default ng-disabled=isDisable>SAVE MY PROFILE DATA</button><div ng-class=\"getOrganizationCss(\'find-fit-btn profile-cta-btn\')\"><button ng-click=validatePersonalData() id=submit_validation class=btn-default ng-disabled=isDisable><strong>{{\'USER_PROFILE_SAVE_BUTTON\' | translate}}</strong></button></div><!-- #endregion Save Button --></div><!-- #region Your Fit --><div class=\"user-info-sec find-fit-sec\" style=\"display: none !important\"><div class=\"row align-middle\"><div class=\"col-sm-5 my-auto\"><div ng-show=!userProfile.assessments><h6>{{\'USER_PROFILE_TITLE_FIT\' | translate}}</h6><p>{{\'USER_PROFILE_FIND_FIT_TEXT\' | translate }}</p></div><div ng-show=userProfile.assessments><div ng-show=userProfile.isSubscriber style=font-size:24px;margin-bottom:5px><span translate=BIG_FIVE_PERSONALITY></span> <strong class=archetype>{{assessmentData.archetype}}</strong></div><div ng-show=userProfile.isSubscriber style=font-size:12pt><p>Review the full test results of your Big 5 traits that<br>many employers are look for.</p></div></div><button data-toggle=modal data-target=#take-test-modal ng-click=userProfile.gotoAssessment() id=take_assessment><strong ng-show=!userProfile.assessments>{{\'ASSESSMENT_TAKE_TEST_SUBTITLE_PROFILE\' | translate}}</strong> <strong ng-show=userProfile.assessments>{{\'USER_PROFILE_FIND_FIT_VIEW_RESULT\' | translate }}</strong></button><div class=view-result ng-show=!userProfile.assessments>{{\"USER_PROFILE_FIND_FIT_SAMPLE_RESULT\" | translate }}</div></div><div class=\"col-sm-7 text-right find-fit-img\" ng-show=!userProfile.assessments><img src=//s3.amazonaws.com/static.intry.careers/images/webapp/big-five-assessment.svg alt=find-fit-img class=big-five></div><div class=\"col-sm-7 text-right find-fit-img\" ng-show=userProfile.assessments><div id=assessment-radar ng-show=userProfile.assessments><canvas id=assessment-radar-canvas style=width:550px;height:375px></canvas></div></div></div></div><div class=\"clearfix clear\"></div><!-- #endregion Your Fit --></form></div></section><div class=\"last-content row margin-horizontal-0\" ng-class=\"{\'error-feild\': userProfile.experienceListError && userProfile.experienceListError[$index]} \"></div><div class=error-message-container ng-if=userProfile.showErrorMsg><p class=error-message id=errorMessage>{{userProfile.showErrorMsg}}</p></div><!-- #region Profile Picture Modal --><div class=modal id=profile-pic-modal tabindex=-1 role=dialog aria-labelledby=take-test-modal-title aria-hidden=true ng-show=profileImgModal><div class=\"modal-dialog modal-dialog-centered\" role=document><div class=modal-content><div class=modal-header><h6 ng-show=!profileImgModalDelete>Position and size your photo</h6><h6 ng-show=profileImgModalDelete>Remove Your Photo</h6><button type=button class=close aria-label=Close ng-click=\"profileImgModal = false;\"><img src=/media/images/close.svg alt=close class=img-fluid></button></div><div class=modal-body><croppie src=cropped.source ng-model=cropped.image options=\"{boundary:{width:300,height:300},viewport:{width: 300, height: 300,type:\'circle\'}}\" ng-show=!profileImgModalDelete></croppie><div class=take-test-btn-group><div class=update-profile-picture-checkbox-container ng-show=profileImgModalDelete>Are you sure you\'d like to remove your profile picture?</div><button type=button class=\"btn btn-primary let-go-btn\" ng-click=upload_cropped_img() ng-show=!profileImgModalDelete>Apply</button> <button type=button class=\"btn btn-primary let-go-btn\" ng-click=deleteResumePicture() ng-show=profileImgModalDelete>Yes</button> <button type=button ng-click=\"profileImgModal = false;\" class=\"btn btn-secondary cancel-btn\">Cancel</button></div><!-- Preview --><!-- <img ng-src=\"{{cropped.image}}\" /> --></div></div></div></div><!-- #endregion Profile Picture Modal -->");
$templateCache.put("app/wizard/template/leaving-wizard-modal.html","<div id=wizard-leaving-modal class=ngdialog-wrapper aria-labelledby=wizard-modal-title aria-hidden=true><div class=\"modal-dialog modal-dialog-centered\" role=document><div class=modal-content><div class=modal-body><h6>{{\'LEAVING_WIZARD_TITLE\' | translate}}</h6><div class=desc><p class=text>{{\'LEAVING_WIZARD_DESCRIPTION\' | translate}}</p></div><div class=buttons-block><button class=\"btn btn-green\" ng-click=closeThisDialog()>{{\'LEAVING_WIZARD_CONTINUE_BUTTON\' | translate}}</button> <a class=\"btn btn-green-link\" ng-click=goToDashboard()>{{\'LEAVING_WIZARD_LEAVING_BUTTON\' | translate}}</a></div></div></div></div></div>");
$templateCache.put("app/wizard/template/wizard-assessment.html","<div class=wizard-assessment><div class=assessment-section ng-if=\"$ctrl.wizard.assessmentStep === 2\"><ng-include src=\"\'app/assessments/template/assessmentSlides.html\'\"></ng-include></div></div>");
$templateCache.put("app/wizard/template/wizard-buttons.html","<div class=wizard-buttons ng-class=\"{ \'wizard-buttons-mobile\': $ctrl.type == \'mobile\' }\"><div ng-if=$ctrl.wizard.isCurrentStep(1)><button class=\"btn btn-green\" ng-disabled=$ctrl.wizard.isDisabledNextBtn() ng-click=$ctrl.wizard.showResetModal()>Restart</button><!--\n		<button class=\"btn btn-green\" ng-disabled=\"$ctrl.wizard.isDisabledNextBtn()\" ng-click=\"$ctrl.wizard.goToStep(1)\">\n			Back\n		</button>\n		--> <button class=\"btn btn-green\" ng-disabled=$ctrl.wizard.isDisabledNextBtn() ng-click=$ctrl.wizard.goToStep(2)>Next</button></div><div ng-if=$ctrl.wizard.isCurrentStep(2)><button class=\"btn btn-green-link\" ng-if=$ctrl.wizard.isCurrentStep(2) ng-click=$ctrl.wizard.saveUserProfile()>Save</button> <button class=\"btn btn-green\" ng-disabled=$ctrl.wizard.isDisabledNextBtn() ng-click=$ctrl.wizard.finishWizard()>Finish</button></div><div ng-if=$ctrl.wizard.isCurrentStep(3)><button class=\"btn btn-green-link\" ng-if=\"$ctrl.wizard.resumeEditor.isCurrentPage(\'edit_resume\')\" ng-click=$ctrl.wizard.resumeEditor.validateTheResume()>Save</button> <button class=\"btn btn-green\" ng-if=\"$ctrl.wizard.resumeEditor.isCurrentPage(\'edit_resume\')\" ng-click=$ctrl.wizard.goToStep(4)>Next</button> <button class=\"btn btn-green\" ng-if=\"$ctrl.wizard.resumeEditor.isCurrentPage(\'j2r\')\" ng-disabled=$ctrl.wizard.isParseJobDisabled() ng-click=$ctrl.wizard.resumeEditor.parseJob(20000)>Next</button></div><div ng-if=$ctrl.wizard.isCurrentStep(4) class=last-step-buttons><button class=\"btn btn-green-link\" ng-click=$ctrl.wizard.backToStep(3)>Back</button> <button class=\"btn btn-green\" ng-click=$ctrl.wizard.saveAndDownloadResume()>Save & Download Resume</button></div></div>");
$templateCache.put("app/wizard/template/wizard-final-modal.html","<div id=wizard-final-modal class=ngdialog-wrapper aria-labelledby=wizard-modal-title aria-hidden=true><div class=\"modal-dialog modal-dialog-centered\" role=document><div class=modal-content><div class=modal-body><h6>{{\'WIZARD_FINAL_TITLE\' | translate}}</h6><!--\n				<div class=\"desc\">\n					<p class=\"text\">{{\'WIZARD_FINAL_DESCRIPTION\' | translate}}</p>\n				</div>\n				--><div class=buttons-block><button class=\"btn btn-green\" ng-click=goToDashboard()>{{\'DASHBOARD_TITLE\' | translate}}</button></div></div></div></div></div>");
$templateCache.put("app/wizard/template/wizard-reset-modal.html","<div id=wizard-final-modal class=ngdialog-wrapper aria-labelledby=wizard-modal-title aria-hidden=true><div class=\"modal-dialog modal-dialog-centered\" role=document><div class=modal-content><div class=modal-body><h6 style=\"margin-bottom: 5px\">Restart the New User Orientation?</h6><h4 style=\"margin-bottom: 20px; margin-top: 5px\">You will be asked to retake the TrueYou Assessment.</h4><div class=buttons-block><div class=form-row><div class=col-md-6><button class=\"btn btn-green\" ng-click=restartAssessments()>Yes</button></div><div class=col-md-6><button class=\"btn btn-green\" ng-click=close()>No</button></div></div></div></div></div></div></div>");
$templateCache.put("app/wizard/template/wizard.html","<div class=wizard ng-class=\"{ \'wizard-step-4\': wizard.isCurrentStep(4) }\"><div class=wizard-header><div class=wizard-progress><div class=wizard-progress-bar ng-style=\"{ width: wizard.getProgress() + \'%\' }\"></div></div><div class=container><div class=first-group><a class=close-icon ng-click=wizard.quit()></a></div><div class=step><div class=number>Step {{wizard.currentStep}} of {{wizard.stepsCount}}</div><div class=name><span ng-if=wizard.isCurrentStep(1)>Assessment </span><span ng-if=wizard.isCurrentStep(2)>Create Your Profile </span><span ng-if=wizard.isCurrentStep(3)>Optimize Resume </span><span ng-if=wizard.isCurrentStep(4)>Pick Resume Style</span></div></div><wizard-buttons wizard=wizard type=desktop></wizard-buttons></div></div><div class=wizard-content><assessments-results ng-if=\"wizard.isCurrentStep(1) && (wizard.assessmentStep == 1 || wizard.assessmentStep == 3)\" wizard=wizard user=wizard.user></assessments-results><wizard-assessment ng-show=\"wizard.isCurrentStep(1) && wizard.assessmentStep == 2\" wizard=wizard></wizard-assessment><user-profile ng-if=wizard.isCurrentStep(2) wizard=wizard user=wizard.user></user-profile><resume-builder-profile ng-if=\"wizard.isCurrentStep(3) || wizard.isCurrentStep(4)\" wizard=wizard user=wizard.user resume=wizard.resume></resume-builder-profile></div><div class=wizard-footer><wizard-buttons wizard=wizard type=mobile></wizard-buttons></div></div>");
$templateCache.put("app/resume-builder/template/resume-builder-profile.html","<div id=resume-styles-wrapper></div><div style=\"position:fixed;width:100%;height:100%;background: #3b3b3b; opacity: 0.3; z-index:9000\" id=overLay ng-show=\"showIndustry || showSkillsReq\"></div><paywall-dialog success=\"paymentSuccess(updatedUser, closed)\" error=paymentError(error) active=paymentRequired user=user finishtext=\"Continue downloading resume\"></paywall-dialog><div ng-class=\'scrimPageBackground ? \"scrim\": \"\"\'><nav-bar ng-if=!resumeEditor.wizard.isWizard user=user></nav-bar></div><section class=\"main-sec new-main-sec resume-editor\"><header ng-class=\"getOrganizationCss(\'header\', true)\"><div class=container ng-class=\"getOrganizationCss(\'container\')\"><div class=page-name-block><div class=row><div class=section-title><p class=heading-block ng-show=\"resumeEditor.isCurrentPage(\'edit_resume\')\">{{\'RESUME_PROFILE_EDIT_RESUME_SECTION_TITLE\' | translate }}</p><p class=heading-block ng-show=\"resumeEditor.isCurrentPage(\'preview_resume\')\">{{\'RESUME_PROFILE_PREVIEW_RESUME_SECTION_TITLE\' | translate }}</p><p ng-show=showJobDesc>{{\'RESUME_PROFILE_J2R_SECTION_TITLE\' | translate }}</p><div class=heading-desc ng-show=showJobDesc>Copy and paste a job description into the box below, then click <b>Process</b>. Intry will identify missing skills and keywords for you to add to your existing resume, and then generate an ATS-friendly Hybrid Resume™ that gets you hired faster.</div></div><div class=section-buttons><resume-builder-profile-buttons resume-editor=resumeEditor button-class=btn-white></resume-builder-profile-buttons></div></div></div></div></header><div class=container><form name=forms.userForm id=userForm novalidate><div class=\"user-info-section user-info-sec-mod\" ng-class=\"{ \'preview-mode\': resumeEditor.isCurrentPage(\'preview_resume\'), \'j2r-mode\': resumeEditor.isCurrentPage(\'j2r\') }\"><div class=user-resume-profile ng-show=\"resumeEditor.isCurrentPage(\'edit_resume\')\"><button ng-class=\"getOrganizationCss(\'sidebar-save-btn\')\" ng-click=\"resumeEditor.validateTheResume({downloaded: false})\" id=submit_validation>{{\'RESUME_PROFILE_SAVE_MY_RESUME_DATA_BUTTON\' | translate }}</button><div class=\"job-industry-group form-row\" style=margin-bottom:20px><!-- #region Job Title --><div class=\"col-lg-6 title-control\"><div class=form-group><label>Desired Job Title for This Position<span>&nbsp;</span></label><input type=text class=\"form-control resume-edit val-ctrl prompt\" ng-model=resumeEditor.title placeholder=\"Enter Desired Job Title Here\" name=title ng-focus=\"focusBlurMissingText(\'title\' + $index, true)\" ng-blur=\"focusBlurMissingText(\'title\' + $index)\"></div></div><!-- #endregion Job Title --><!-- #region Industry --><div class=\"col-lg-6 title-control\"><div class=form-group><label>Industry</label><md-autocomplete md-selected-item=selectedIndustry md-search-text=industrySearchText md-selected-item-change=saveIndustries(industry) md-items=\"industry in industrySearch(industrySearchText)\" md-item-text=industry.title md-min-length=0 placeholder=\"Type Industry and/or Search (Required)\" class=form-control-autocomplete ng-focus=fixOverflow()><md-item-template><span md-highlight-text=industrySearchText md-highlight-flags=^i class=form-control-autocomplete-item>{{industry.title}}</span></md-item-template><md-not-found>No states matching \"{{industrySearchText}}\" were found.</md-not-found><i class=\"fas fa-search industry-arrow-down\"></i></md-autocomplete></div></div><!-- #endregion Industry --></div><div><uib-accordion close-others=oneAtATime><!-- #region Personal Information --><uib-accordion-group><uib-accordion-heading><div class=\"panel-heading collapsed\" data-toggle=collapse data-target=#name><i class=\"fas fa-angle-up\" style=color:#919497></i> <i class=\"fas fa-angle-down\" style=color:#919497></i><div class=\"section-heading d-inline\">{{\'CREATE_RESUME_TITLE_PERSONAL_INFORMATION\' | translate}}</div><div class=\"section-error-message-header d-inline\" ng-show=infoNotValid>Incomplete</div></div></uib-accordion-heading><div><div class=inner-section><div class=user-exp-sec id=name><div class=\"form-row row-item\"><div class=col-md-6><label for=firstname>First Name<span>&nbsp;<span class=required>*</span></span></label><input type=text class=\"form-control resume-edit\" valid-method=submitted validator=requirednomsg name=firstname ng-model=resumeEditor.user.first_name id=firstname placeholder=\"First Name\" ng-class=\"(resumeEditor.user.first_name.length > 0) ? \'\' : \'ng-invalid\'\"></div><div class=col-md-6><label for=lastname>Last Name<span>&nbsp;<span class=required>*</span></span></label><input type=text class=\"form-control resume-edit\" valid-method=submitted validator=requirednomsg id=lastname name=lastname ng-model=resumeEditor.user.last_name placeholder=\"Last Name\" ng-class=\"(resumeEditor.user.last_name.length > 0) ? \'\' : \'ng-invalid\'\"></div></div><div class=\"form-row row-item\"><div class=col-md-6><label for=city>City</label><input type=text class=\"form-control resume-edit\" name=city ng-model=resumeEditor.address.city id=city placeholder=City></div><div class=col-md-2><label for=state>State</label><input type=text class=\"form-control resume-edit\" id=state name=state ng-model=resumeEditor.address.state placeholder=State></div></div><div class=\"form-row row-item\"><div class=col-md-4><label for=phonenumber>Phone Number<span>&nbsp;<span class=required>*</span></span></label><input type=text class=\"form-control resume-edit\" id=phonenumber name=phonenumber ng-model=resumeEditor.phonenumber.number placeholder=\"Phone Number 10 Digits Only\" ng-focus=resumeEditor.phoneFlatten() ng-blur=resumeEditor.phoneDisplay() ng-required=validatePhone ng-pattern=phonePattern></div></div><div class=\"form-row row-item\"><div class=col-md-6><label for=website>Website</label><input type=text class=\"form-control resume-edit\" name=website ng-model=resumeEditor.website id=website placeholder=Website></div><div class=col-md-6><label for=email>E-Mail<span>&nbsp;<span class=required>*</span></span></label><input type=text class=\"form-control resume-edit\" valid-method=submitted validator=requirednomsg id=email name=email ng-model=resumeEditor.user.email_address.address placeholder=E-Mail ng-class=\"(resumeEditor.user.email_address.address.length > 0) ? \'\' : \'ng-invalid\'\"></div></div></div></div></div></uib-accordion-group><!-- #endregion Personal Information --><!-- #region Summary --><uib-accordion-group><uib-accordion-heading><div class=\"panel-heading collapsed\" data-toggle=collapse data-target=#demographics><i class=\"fas fa-angle-up\" style=color:#919497></i> <i class=\"fas fa-angle-down\" style=color:#919497></i><div class=\"section-heading d-inline\">{{\'CREATE_RESUME_TITLE_SUMMARY\' | translate}}</div><div class=\"section-error-message-header d-inline\" ng-show=summaryNotValid>INCOMPLETE</div><!--\n                                        <div class=\"section-warning-message d-inline\" ng-show=\"summaryNeedsAttent\"> -\n                                            Missing some keywords from job description</div>\n                                        --><div class=\"section-warning-message-header d-inline\" ng-show=summaryNeedsAttent>ADD KEYWORDS</div><div class=\"section-info-message-header d-inline\" ng-show=summaryNeedsReview>LOOKS GOOD, TAKE A PEEK</div></div></uib-accordion-heading><div><div class=inner-section><div class=user-exp-sec id=demographics><div class=\"form-row row-item\" ng-show=resumeEditor.hasJobDesc><div class=col-md-12 style=margin-top:10px ng-show=\"summaryMissing !== \'\'\"><div class=\"job-info-title section-warning-message\">Optimize your resume by adding the keywords found in the job description that represent who you are</div><!--\n                                                    <div class=\"section-warning-message\"\n                                                        style=\"margin-left:20px; margin-bottom: 15px;\" ng-show=\"false\">\n                                                        {{summaryMissing}}</div>\n                                                    --><div class=section-warning-message style=\"margin-left:20px; margin-bottom: 15px\" ng-show=false>{{summaryMissing}}</div></div><div class=col-md-12 style=\"padding-bottom: 20px; padding-top: 20px; text-align: center\" ng-show=\"summaryMissing !== \'\'\"><button class=\"btn btn-j2r pull-center\" ng-click=resumeEditor.openSummaryMissingModal()>Add Keywords</button></div></div></div><div class=\"form-row row-item\"><div class=col-md-12><textarea class=\"form-control resume-edit\" id=summary ng-keyup=resumeEditor.setParseDelay() ng-blur=resumeEditor.parseSummaryKeyWords() name=summary rows=10 placeholder=\"{{\'USER_PROFILE_PLACEHOLDER_SUMMARY\' | translate}}\" ng-bind-html=resumeEditor.user.summary ng-model=resumeEditor.user.summary ng-class=\"checkMissingText(\'summary\')\" ng-focus=\"focusBlurMissingText(\'summary\', true)\" ng-pattern=summaryPattern></textarea><h6 class=\"summary-error job-info-title\" style=\"color:rgb(221, 44, 0)\" ng-if=checkSummary()>Provide a brief professional summary, no longer than {{summaryMaxLength}} characters, describing yourself using a few strong statements and keywords that clearly demonstrate the value you bring to the table.</h6></div></div><div class=user-exp-sec id=demographics><div class=\"form-row row-item\" ng-show=resumeEditor.hasJobDesc><div class=col-md-12 style=margin-top:10px ng-show=\"summaryKeywordsAdded.length > 0\"><div class=job-info-title>Add the keywords below to your summary above:</div><div class=keyword-container ng-repeat=\"keyword in summaryKeywordsAdded\"><img ng-show=keyword.show class=unselectable src=/media/icons/close.png> <img ng-show=!keyword.show class=unselectable src=/media/icons/check.png><div ng-show=keyword.show class=keyword-missing>{{keyword.keyword}}</div><div ng-show=!keyword.show class=keyword-show>{{keyword.keyword}}</div></div></div></div></div></div></div></uib-accordion-group><!-- #endregion Summary --><!-- #region Experience --><uib-accordion-group><uib-accordion-heading><div class=\"panel-heading collapsed\" data-toggle=collapse data-target=#experience><i class=\"fas fa-angle-up\" style=color:#919497></i> <i class=\"fas fa-angle-down\" style=color:#919497></i><div class=\"section-heading d-inline\">{{\'CREATE_RESUME_TITLE_EXPERIENCE\' | translate}}</div><div class=\"section-error-message-header d-inline\" ng-show=expNotValid>- INCOMPLETE</div><!--\n                                        <div class=\"section-warning-message d-inline\" ng-show=\"expNeedsAttent\"> -\n                                            {{resumeEditor.numExpUpdates}} Item<span\n                                                ng-show=\"resumeEditor.numExpUpdates > 1\">s</span> Missing Keywords\n                                        </div>\n                                        --><div class=\"section-warning-message-header d-inline\" ng-show=expNeedsAttent>ADD KEYWORDS</div><div class=\"section-info-message-header d-inline\" ng-show=expNeedsReview>LOOKS GOOD, TAKE A PEEK</div></div></uib-accordion-heading><div><div class=inner-section><div class=user-exp-sec id=experience><!--\n                                            <div class=\"form-row row-item job-info-title\" ng-show=\"resumeEditor.hasJobDesc\"\n                                                style=\"margin-bottom: 30px;\">\n                                                Additional Information areas that have a red background are items that\n                                                do not contain any information regarding the skills section of the job\n                                                description.<br />\n                                                When ever possible, always try to reference at least 1 or more skills in\n                                                your additional information areas for each experience entry.\n                                            </div>\n                                            --><div class=\"form-row row-item job-info-title section-warning-message\" ng-show=resumeEditor.hasJobDesc style=\"margin-bottom: 30px\">Descriptions with a red border are missing skill keywords. Always try to include relevant skills keywords in each experience description.</div><div class=col-sm-12 style=\"text-align: center\" ng-show=resumeEditor.hasJobDesc><!--\n                                                <button class=\"show-req-skills pull-right section-warning-message\"\n                                                    ng-click=\"resumeEditor.showExperienceSkills()\">\n                                                    Show Skills List\n                                                </button>\n                                                --><!--\n                                                <button class=\"btn btn-j2r pull-center\"\n                                                    ng-click=\"resumeEditor.showRequiredSkills()\">\n                                                    Show Skills List\n                                                </button>\n                                                --></div><div ng-repeat=\"experience in resumeEditor.user.experience\" ng-if=\"experience.deleted == false && experience.kind != \'Military\'\" ng-mouseover=\"resumeEditor.showAddExperienceBar[$index] = true\" ng-mouseleave=\"resumeEditor.showAddExperienceBar[$index] = false\" id=experienceDiv_{{$index}} class=m-10><div class=exp-form><button class=delete-new-section ng-show=\"resumeEditor.user.experience.length > 0\" ng-click=\"resumeEditor.removeExperience(experience, \'exp_short_desc_\'+$index)\"><img src=/media/images/delete.svg alt=\"delete icon\" class=img-fluid></button><div class=\"form-row row-item-minus\"><div class=col-md-6><label for=title_{{$index}}>Position<span>&nbsp;<span class=required>*</span></span></label><input type=text class=\"form-control resume-edit\" id=title_{{$index}} ng-model=experience.title valid-method=submitted validator=requirednomsg name=title_{{$index}} placeholder=\"{{\'USER_PROFILE_PLACEHOLDER_JOB_TITLE\' | translate}}\" ng-class=\"checkMissingText(\'title_\' + $index)\" ng-focus=\"focusBlurMissingText(\'title_\' + $index, true)\" ng-blur=\"focusBlurMissingText(\'title_\' + $index)\"></div><div class=col-md-6><label for=company_{{$index}}>Company<span>&nbsp;<span class=required>*</span></span></label><input type=text class=\"form-control resume-edit\" name=company_{{$index}} id=company_{{$index}} valid-method=submitted validator=requirednomsg ng-model=experience.company placeholder=\"{{\'USER_PROFILE_PLACEHOLDER_COMPANY\' | translate}}\" ng-class=\"checkMissingText(\'company_\' + $index)\" ng-focus=\"focusBlurMissingText(\'company_\' + $index, true)\" ng-blur=\"focusBlurMissingText(\'company_\' + $index)\"></div></div><div class=\"form-row row-item\"><div class=col-md-6><label for=exp_location_{{$index}}>Location</label><input type=text class=\"form-control resume-edit\" id=exp_location_{{$index}} ng-model=experience.location valid-method=submitted name=exp_location_{{$index}} placeholder=Location></div></div><div class=\"form-row row-item\"><div class=col-md-6><label>Start Date<span>&nbsp;<span class=required>*</span></span></label><div class=\"form-row row-item\"><div class=\"col-sm-6 paddingr-15 responsive-padding-r\"><div class=\"select-style exp-month\"><select class=\"form-control resume-edit val-ctrl\" id=exp_start_mon_{{$index}} name=exp_start_mon_{{$index}} ng-options=\"item.monthNumber as item.fullmonthName  for item in months\" ng-model=experience.startMonthObj><option value=\"\">Select</option></select></div></div><div class=\"col-sm-6 paddingl-15 responsive-padding-l\"><div class=select-style><select class=\"form-control resume-edit val-ctrl\" valid-method=submitted validator=requirednomsg id=exp_start_year_{{$index}} name=exp_start_year_{{$index}} ng-options=\"year for year in years\" ng-model=experience.startYearObj ng-class=\"checkMissingText(\'exp_start_year_\' + $index, \'select\')\"><option value=\"\">Select</option></select></div></div></div></div><div class=col-md-6><label>End Date<span>&nbsp;<span class=required>*</span></span></label><div class=\"form-row row-item\"><div class=\"col-sm-6 paddingr-15 responsive-padding-r\"><div class=\"select-style exp-month\"><select class=\"form-control resume-edit\" ng-model=experience.endMonthObj ng-options=\"item.monthNumber as item.fullmonthName  for item in months\" ng-disabled=experience.is_current><option value=\"\">Select</option></select></div></div><div class=\"col-sm-6 paddingl-15 responsive-padding-l\"><div class=select-style><select class=\"form-control resume-edit val-ctrl\" ng-model=experience.endYearObj name=exp_end_year_{{$index}} ng-options=\"year for year in years\" ng-class=\"checkMissingText(\'exp_end_year_\' + $index, \'select\')\" ng-disabled=experience.is_current><option value=\"\">Select</option></select></div></div><div class=current-checkbox-wrapper><label class=checkbox-btn><input type=checkbox ng-model=experience.is_current ng-change=resumeEditor.setCurrentItem(experience)> <span>Present</span></label></div></div></div></div><div class=\"form-row row-item\"><div class=col-md-12 style=\"text-align: center\"><button class=\"btn btn-j2r\" ng-click=resumeEditor.showExperienceRequiredSkills($index) ng-show=resumeEditor.hasJobDesc>Show Skills List</button></div></div><div class=\"form-row row-item\"><div class=col-md-12><label for=exp-short-desc>Description</label><div class=\"add-info resume-edit editable-inline\" placeholder=Summary id=experience_{{$index}} ng-bind-html=experience.summary ng-model=experience.summary ng-focus=\"resumeEditor.isEditable(\'experience_\' + $index)\" ng-click=\"resumeEditor.isEditable(\'experience_\' + $index)\"></div></div></div><div ng-show=\"experienceKeywordsAddedCount[$index] > 0\" class=job-info-title>Add the keywords below to your job experience description above:</div><div class=keyword-container ng-repeat=\"(key, value) in experienceKeywordsAdded[$index]\"><img ng-show=value src=/media/icons/close.png> <img ng-show=!value src=/media/icons/check.png><div ng-show=value class=keyword-missing>{{key}}</div><div ng-show=!value class=keyword-show>{{key}}</div></div></div></div><button ng-class=\"getOrganizationCss(\'add-new-sec\')\" ng-click=\"resumeEditor.addNewExperience(0, true, \'Work\')\">Add New Experience</button></div></div></div></uib-accordion-group><!-- #endregion Experience --><!-- #region Education --><uib-accordion-group><uib-accordion-heading><div class=\"panel-heading collapsed\" data-toggle=collapse data-target=#education><i class=\"fas fa-angle-up\" style=color:#919497></i> <i class=\"fas fa-angle-down\" style=color:#919497></i><div class=\"section-heading d-inline\">{{\'CREATE_RESUME_TITLE_EDUCATION\' | translate}}</div><div class=\"section-error-message-header d-inline\" ng-show=edNotValid>Incomplete</div><div class=\"section-warning-message-header d-inline\" ng-show=eduNeedsAttent>Degree Missing</div><div class=\"section-info-message-header d-inline\" ng-show=eduNeedsReview>Looks Good, Take a Peek</div></div></uib-accordion-heading><div><div class=inner-section><div class=user-edu-sec id=education><div class=\"form-row row-item job-info-title\" ng-show=resumeEditor.hasJobDesc>Any educational areas that have a green background shows where your education matches the job description.</div><div ng-repeat=\"education in resumeEditor.user.education\" ng-if=\"education.deleted == false && education.kind != \'certification\'\" ng-mouseover=\"resumeEditor.showAddEducationBar[$index] = true\" ng-mouseleave=\"resumeEditor.showAddEducationBar[$index] = false\" id=eductionDiv_{{$index}} class=m-10><div class=edu-form><button class=delete-new-section ng-show=\"resumeEditor.user.education.length > 0\" ng-click=\"resumeEditor.removeEducation(education, \'edu_short_desc_\'+$index)\" role=button tabindex=0><img src=/media/images/delete.svg alt=\"delete icon\" class=img-fluid></button><div class=\"form-row row-item\"><div class=col-md-3><label for=degree_{{$index}}>Degree <span>&nbsp;<span class=required>*</span></span></label><input type=text class=\"form-control resume-edit\" valid-method=submitted name=degree_{{$index}} ng-model=education.degree id=degree_{{$index}} placeholder=\"Enter Degree\"></div><div class=col-md-3><label for=major_{{$index}}>Major</label><input type=text class=\"form-control resume-edit\" valid-method=submitted name=major_{{$index}} ng-model=education.major id=major_{{$index}} placeholder=\"Enter Major\"></div><div class=col-md-6><label for=university_{{$index}}>University<span>&nbsp;<span class=required>*</span></span></label><input type=text class=\"form-control resume-edit\" valid-method=submitted validator=requirednomsg id=university_{{$index}} name=university_{{$index}} ng-model=education.institution placeholder=\"University Name\" ng-class=\"checkMissingText(\'university_\' + $index)\" ng-focus=\"focusBlurMissingText(\'university_\' + $index, true)\" ng-blur=\"focusBlurMissingText(\'university_\' + $index)\"></div></div><div class=\"form-row row-item\"><div class=col-md-6><label>Start Date (Optional)</label><div class=\"form-row row-item\"><div class=\"col-sm-6 paddingr-15 responsive-padding-r\"><div class=\"select-style exp-month\"><select class=\"form-control resume-edit\" name=edu_start_mon__{{$index}} ng-options=\"item.monthNumber as item.fullmonthName  for item in months\" ng-model=education.startMonthObj><option value=\"\">Select</option></select></div></div><div class=\"col-sm-6 paddingl-15 responsive-padding-l\"><div class=select-style><select class=\"form-control resume-edit\" name=edu_start_year__{{$index}} ng-options=\"year for year in years\" ng-model=education.startYearObj><option value=\"\">Select</option></select></div></div></div></div><div class=col-md-6><label>End Date (Optional)</label><div class=\"form-row row-item\"><div class=\"col-sm-6 paddingr-15 responsive-padding-r\"><div class=\"select-style exp-month\"><select class=\"form-control resume-edit\" name=edu_end_mon__{{$index}} ng-options=\"item.monthNumber as item.fullmonthName  for item in months\" ng-model=education.endMonthObj><option value=\"\">Select</option></select></div></div><div class=\"col-sm-6 paddingl-15 responsive-padding-l\"><div class=select-style><select class=\"form-control resume-edit\" ng-options=\"year for year in years2\" name=educ_end_year_{{$index}} ng-change=\"changeDateEndEducation(\'education\',$index,education.endYearObj)\" ng-model=education.endYearObj><option value=\"\">Select</option></select></div></div></div></div></div><div class=\"form-row row-item\"><div class=col-md-12><label for=edu-short-desc>Description</label><div class=\"add-info resume-edit editable-inline\" placeholder=Education id=education_{{$index}} ng-bind-html=education.notes ng-model=education.notes ng-focus=\"resumeEditor.isEditable(\'education_\' + $index)\" ng-click=\"resumeEditor.isEditable(\'education_\' + $index)\"></div></div></div></div></div><button ng-class=\"getOrganizationCss(\'add-new-sec\')\" ng-click=\"resumeEditor.addNewEducation(0, true, \'Degree\')\">Add New Education</button></div></div></div></uib-accordion-group><!-- #endregion Education --><!-- #region Skills --><uib-accordion-group><uib-accordion-heading><div class=\"panel-heading collapsed\" data-toggle=collapse data-target=#skills><i class=\"fas fa-angle-up\" style=color:#919497></i> <i class=\"fas fa-angle-down\" style=color:#919497></i><div class=\"section-heading d-inline\">{{\'CREATE_RESUME_TITLE_SKILLS\' | translate}}</div><div class=\"section-error-message-header d-inline\" ng-show=skillsNotValid>- INCOMPLETE</div><!--\n                                        div class=\"section-warning-message d-inline\" ng-show=\"skillNeedsAttent\">\n                                            &nbsp;- Missing some skills from job description</div>\n                                        --><div class=\"section-warning-message-header d-inline\" ng-show=skillNeedsAttent>ADD SKILLS</div><div class=\"section-info-message-header d-inline\" ng-show=skillNeedsReview>- Looks GOOD, TAKE A PEEK</div></div></uib-accordion-heading><div><div class=inner-section><div class=user-skill-sec id=skills><div class=\"form-row row-item job-info-title section-warning-message\" ng-show=resumeEditor.hasJobDesc style=\"margin-bottom: 30px\"><!--\n                                                We suggest that you match at least {{resumeEditor.skillsLevel1}} to {{resumeEditor.skillsLevel2}} or more skills from the job descriptions.<br />\n                                                Those skills with a green background are ones that match the required skills from the job description.<br />\n                                                Click on the Skills List Editor link to see the remaining list and see if there are others you can add.\n                                                --><!--\n                                                We recommend adding at least one of the missing skills found in the job\n                                                description provided. Skills with a green background are skills already\n                                                found in the job description. Click below to view the missing skills and\n                                                add them to your list.\n                                                --> Be fully optimized by adding at least one more skill found in the job description! Skills with a green background are skills already found in the job description. Click below to view the missing skills and add them to your list.</div><div class=\"form-row row-item job-info-title section-warning-message\" style=\"display: block; text-align: center\" ng-show=resumeEditor.hasJobDesc><!--\n                                                <button class=\"show-req-skills section-warning-message\"\n                                                    style=\"padding-left: 0px; padding-right: 0px;\"\n                                                    ng-click=\"resumeEditor.showRequiredSkills()\">\n                                                    View Missing Skills\n                                                </button>\n                                                --> <button class=\"btn btn-j2r\" ng-click=resumeEditor.showRequiredSkills()>View Missing Skills</button></div><div class=clearfix dragula=\"\'skills-bag\'\" dragula-model=resumeEditor.user.skills><div ng-class=\"{\'error-feild\': resumeEditor.skillsListError && resumeEditor.skillsListError[$index]} \" ng-repeat=\"skill in resumeEditor.user.skills  | filter: {\'deleted\': false}\" ng-mouseover=\"resumeEditor.showAddSkillBar[$index] = true\" ng-mouseleave=\"resumeEditor.showAddSkillBar[$index] = false\" id=skillDiv_{{$index}} class=\"skill-item resume-skill-item\"><div class=skill-form><button class=delete-new-section ng-click=resumeEditor.removeSkill(skill) role=button tabindex=0><img src=/media/images/delete.svg alt=\"delete icon\" class=img-fluid></button><div class=\"form-row row-item\"><div class=col-md-6><label for=skillName_{{$index}}>Name<span>&nbsp;<span class=required>*</span></span></label><input type=text class=\"form-control resume-edit\" valid-method=submitted validator=requirednomsg id=skillName_{{$index}} ng-model=skill.skill name=skillName_{{$index}} placeholder=\'{{\"USER_PROFILE_ADD_SKILL\" | translate}}\' ng-class=\"checkMissingText(\'skillName_\' + $index)\"></div><div class=\"form-group col-md-6\"><label>Level (optional)</label><table class=skill-level-table><tr><td><input class=resume-builder-enable-skill-level-checkbox type=checkbox ng-checked=\"skill.proficiency > 0\" ng-click=enableSkillLevel(skill)></td><td><div class=\"rating-bar clearfix\" ng-show=\"skill.proficiency > 0\"><span class=rating-control id=skill_{{$index}} ndx={{$index}} data-rating={{skill.proficiency}}><span aria-hidden=true>&#11035;&#11035;&#11035;&#11035;&#11035;</span></span><p>{{skill.proficiency}} {{proficiencyList[skill.proficiency]}}</p></div></td></tr></table></div></div><span class=\"material-icons reorder-btn skills-bag-draggable\" title=\'{{\"USER_PROFILE_MOVE_SKILL\" | translate}}\'>reorder</span></div></div></div><button ng-class=\"getOrganizationCss(\'add-new-sec\')\" ng-click=\"resumeEditor.addNewSkill(0, true)\">Add New Skill</button></div></div></div></uib-accordion-group><!-- #endregion Skills --><!-- #region Achievements and Awards --><uib-accordion-group><uib-accordion-heading><div class=\"panel-heading collapsed\" data-toggle=collapse data-target=#awards><i class=\"fas fa-angle-up\" style=color:#919497></i> <i class=\"fas fa-angle-down\" style=color:#919497></i><div class=\"section-heading d-inline\">{{\'CREATE_RESUME_TITLE_ACHIEVEMENTS_AND_AWARDS\' | translate}}</div><div class=\"section-error-message d-inline\" ng-show=awardsNotValid>- INCOMPLETE</div></div></uib-accordion-heading><div><div class=inner-section><div class=user-award-sec id=awards><div ng-class=\"{\'error-feild\': resumeEditor.awardListError && resumeEditor.awardListError[$index]} \" ng-repeat=\"award in resumeEditor.user.achievements_awards  | filter: {\'deleted\': false}\" ng-mouseover=\"resumeEditor.showAddAwardBar[$index] = true\" ng-mouseleave=\"resumeEditor.showAddAwardBar[$index] = false\" id=awardDiv_{{$index}} class=m-10><div class=award-form><button class=delete-new-section ng-show=resumeEditor.user.achievements_awards.length ng-click=resumeEditor.removeAward(award) role=button tabindex=0><img src=/media/images/delete.svg alt=\"delete icon\" class=img-fluid></button><div class=\"form-row row-item\"><div class=\"col-md-6 paddingl-15\"><label for=award_{{$index}}>Name<span>&nbsp;<span class=required>*</span></span></label><input type=text class=\"form-control resume-edit\" id=award_{{$index}} valid-method=submitted validator=requirednomsg placeholder=\'{{\"USER_PROFILE_ADD_ACHIEVEMENTS_&_AWARDS\" | translate}}\' name=award_{{$index}} ng-model=award.summary ng-class=\"checkMissingText(\'award_\' + $index)\"></div></div><div class=\"form-row row-item\"><div class=\"col-md-6 paddingl-15\"><label>Date (Optional)</label><div class=\"form-row row-item\"><div class=col-sm-6><div class=\"select-style exp-month\"><select class=\"form-control resume-edit\" name=award_month_{{$index}} ng-options=\"item.monthNumber as item.fullmonthName for item in months\" ng-model=award.startMonthObj><option value=\"\">Select</option></select></div></div><div class=col-sm-6><div class=select-style><select class=\"form-control resume-edit\" name=award_year_{{$index}} ng-options=\"year for year in years\" ng-model=award.startYearObj><option value=\"\">Select</option></select></div></div></div></div></div></div></div><button ng-class=\"getOrganizationCss(\'add-new-sec\')\" ng-click=\"resumeEditor.addNewAward(0, true)\">Add New Achievement</button></div></div></div></uib-accordion-group><!-- #endregion Achievements and Awards --><!-- #region Certifications --><uib-accordion-group><uib-accordion-heading><div class=\"panel-heading collapsed\" data-toggle=collapse data-target=#certificates><i class=\"fas fa-angle-up\" style=color:#919497></i> <i class=\"fas fa-angle-down\" style=color:#919497></i><div class=\"section-heading d-inline\">{{\'CREATE_RESUME_TITLE_CERTIFICATES\' | translate}}</div><div class=\"section-error-message d-inline\" ng-show=certNotValid>- Incomplete</div></div></uib-accordion-heading><div><div class=inner-section><div class=user-edu-sec id=certificates><div ng-repeat=\"education in resumeEditor.user.education\" ng-if=\"education.deleted == false && education.kind == \'certification\'\" ng-mouseover=\"resumeEditor.showAddEducationBar[$index] = true\" ng-mouseleave=\"resumeEditor.showAddEducationBar[$index] = false\" id=eductionDiv_{{$index}} class=m-10><div class=edu-form><button class=delete-new-section ng-show=\"resumeEditor.user.education.length > 0\" ng-click=\"resumeEditor.removeEducation(education, \'edu_short_desc_\'+$index)\" role=button tabindex=0><img src=/media/images/delete.svg alt=\"delete icon\" class=img-fluid></button><div class=\"form-row row-item\"><div class=col-md-6><label for=cert_{{$index}}>Name of Certification<span>&nbsp;<span class=required>*</span></span></label><input type=text class=\"form-control resume-edit\" valid-method=submitted validator=requirednomsg id=cert_{{$index}} name=cert_{{$index}} ng-model=education.degree id=degree-major placeholder=\"Enter Name of Certification\" ng-class=\"checkMissingText(\'cert_\' + $index)\" ng-focus=\"focusBlurMissingText(\'cert_\' + $index, true)\" ng-blur=\"focusBlurMissingText(\'cert_\' + $index)\"></div><div class=col-md-3 ng-show=false><label for=cert_major_{{$index}}>Major<span>&nbsp;<span class=required>*</span></span></label><input type=text class=\"form-control resume-edit\" valid-method=submitted validator=requirednomsg id=cert_major_{{$index}} name=cert_major_{{$index}} ng-model=education.major placeholder=\"Enter Major\" ng-class=\"checkMissingText(\'cert_major_\' + $index)\" ng-focus=\"focusBlurMissingText(\'cert_major_\' + $index, true)\" ng-blur=\"focusBlurMissingText(\'cert_major_\' + $index)\"></div><div class=col-md-6><label for=school_{{$index}}>Name of Organization<span>&nbsp;<span class=required>*</span></span></label><input type=text class=\"form-control resume-edit\" valid-method=submitted validator=requirednomsg id=school_{{$index}} name=school_{{$index}} ng-model=education.institution placeholder=\"Enter Name of Organization\" ng-class=\"checkMissingText(\'school_\' + $index)\" ng-focus=\"focusBlurMissingText(\'school_\' + $index, true)\" ng-blur=\"focusBlurMissingText(\'school_\' + $index)\"></div></div><div class=\"form-row row-item\"><div class=col-md-6><label>Start Date (Optional)</label><div class=\"form-row row-item\"><div class=\"col-sm-6 paddingr-15 responsive-padding-r\"><div class=\"select-style exp-month\"><select class=\"form-control resume-edit\" name=cert_start_mon__{{$index}} ng-options=\"item.monthNumber as item.fullmonthName  for item in months\" ng-model=education.startMonthObj><option value=\"\">Select</option></select></div></div><div class=\"col-sm-6 paddingl-15 responsive-padding-l\"><div class=select-style><select class=\"form-control resume-edit\" name=cert_start_year__{{$index}} ng-options=\"year for year in years\" ng-model=education.startYearObj><option value=\"\">Select</option></select></div></div></div></div><div class=col-md-6><label>End Date (Optional)</label><div class=\"form-row row-item\"><div class=\"col-sm-6 paddingr-15 responsive-padding-r\"><div class=\"select-style exp-month\"><select class=\"form-control resume-edit\" name=cert_end_mon__{{$index}} ng-options=\"item.monthNumber as item.fullmonthName  for item in months\" ng-model=education.endMonthObj><option value=\"\">Select</option></select></div></div><div class=\"col-sm-6 paddingl-15 responsive-padding-l\"><div class=select-style><select class=\"form-control resume-edit\" ng-options=\"year for year in years\" name=cert_end_year_{{$index}} ng-model=education.endYearObj><option value=\"\">Select</option></select></div></div></div></div></div><div class=\"form-row row-item\"><div class=col-md-12><label for=edu-short-desc>Description</label><div class=\"add-info resume-edit editable-inline\" placeholder=Education id=education_{{$index}} ng-bind-html=education.notes ng-model=education.notes ng-focus=\"resumeEditor.isEditable(\'education_\' + $index)\" ng-click=\"resumeEditor.isEditable(\'education_\' + $index)\"></div></div></div></div></div><button ng-class=\"getOrganizationCss(\'add-new-sec\')\" ng-click=\"resumeEditor.addNewEducation(0, true, \'certification\')\">Add New Certification</button></div></div></div></uib-accordion-group><!-- #endregion Certifications --><!-- #region Military Experience --><uib-accordion-group><uib-accordion-heading><div class=\"panel-heading collapsed\" data-toggle=collapse data-target=#military><i class=\"fas fa-angle-up\" style=color:#919497></i> <i class=\"fas fa-angle-down\" style=color:#919497></i><div class=\"section-heading d-inline\">{{\'CREATE_RESUME_TITLE_MILITARY_EXPERIENCE\' | translate}}</div><div class=\"section-error-message d-inline\" ng-show=miliNotValid>- Incomplete</div></div></uib-accordion-heading><div><div class=inner-section><div class=user-exp-sec id=military><div ng-repeat=\"experience in resumeEditor.user.experience\" ng-if=\"experience.deleted == false && experience.kind == \'Military\'\" ng-mouseover=\"resumeEditor.showAddExperienceBar[$index] = true\" ng-mouseleave=\"resumeEditor.showAddExperienceBar[$index] = false\" id=experienceDiv_{{$index}} class=m-10><div class=exp-form><button class=delete-new-section ng-show=\"resumeEditor.user.experience.length > 0\" ng-click=\"resumeEditor.removeExperience(experience, \'exp_short_desc_\'+$index)\"><img src=/media/images/delete.svg alt=\"delete icon\" class=img-fluid></button><div class=\"form-row row-item\"><div class=col-md-6><label for=position_{{$index}}>Position<span>&nbsp;<span class=required>*</span></span></label><input type=text class=\"form-control resume-edit\" ng-model=experience.title valid-method=submitted validator=requirednomsg id=position_{{$index}} name=position_{{$index}} placeholder=\"{{\'USER_PROFILE_PLACEHOLDER_JOB_TITLE\' | translate}}\" ng-class=\"checkMissingText(\'position_\' + $index)\" ng-focus=\"focusBlurMissingText(\'position_\' + $index, true)\" ng-blur=\"focusBlurMissingText(\'position_\' + $index)\"></div><div class=col-md-6><label for=branch_{{$index}}>Company<span>&nbsp;<span class=required>*</span></span></label><input type=text class=\"form-control resume-edit\" id=branch_{{$index}} name=branch_{{$index}} valid-method=submitted validator=requirednomsg ng-model=experience.company placeholder=\"{{\'USER_PROFILE_PLACEHOLDER_COMPANY\' | translate}}\" ng-class=\"checkMissingText(\'branch_\' + $index)\" ng-focus=\"focusBlurMissingText(\'branch_\' + $index, true)\" ng-blur=\"focusBlurMissingText(\'branch_\' + $index)\"></div></div><div class=\"form-row row-item\"><div class=col-md-6><label for=position_{{$index}}>Location</label><input type=text class=\"form-control resume-edit\" ng-model=experience.location valid-method=submitted id=military_location_{{$index}} name=military_location_{{$index}} placeholder=Location ng-class=\"checkMissingText(\'military_location_\' + $index)\" ng-focus=\"focusBlurMissingText(\'military_location_\' + $index, true)\" ng-blur=\"focusBlurMissingText(\'military_location_\' + $index)\"></div></div><div class=\"form-row row-item\"><div class=col-md-6><label>Start Date<span>&nbsp;<span class=required>*</span></span></label><div class=\"form-row row-item\"><div class=\"col-sm-6 paddingr-15 responsive-padding-r\"><div class=\"select-style exp-month\"><select class=\"form-control resume-edit val-ctrl\" id=mili_start_mon_{{$index}} name=mili_start_mon_{{$index}} ng-options=\"item.monthNumber as item.fullmonthName  for item in months\" ng-model=experience.startMonthObj><option value=\"\">Select</option></select></div></div><div class=\"col-sm-6 paddingl-15 responsive-padding-l\"><div class=select-style><select class=\"form-control resume-edit val-ctrl\" name=mili_start_year_{{$index}} valid-method=submitted validator=requirednomsg ng-options=\"year for year in years\" ng-model=experience.startYearObj ng-class=\"checkMissingText(\'mili_start_year_\' + $index, \'select\')\"><option value=\"\">Select</option></select></div></div></div></div><div class=col-md-6><label>End Date<span>&nbsp;<span class=required>*</span></span></label><div class=\"form-row row-item\"><div class=\"col-sm-6 paddingr-15 responsive-padding-r\"><div class=\"select-style exp-month\"><select class=\"form-control resume-edit\" ng-model=experience.endMonthObj ng-options=\"item.monthNumber as item.fullmonthName  for item in months\" ng-disabled=experience.is_current><option value=\"\">Select</option></select></div></div><div class=\"col-sm-6 paddingl-15 responsive-padding-l\"><div class=select-style><select class=\"form-control resume-edit val-ctrl\" ng-model=experience.endYearObj name=exp_end_year_{{$index}} ng-options=\"year for year in years\" ng-class=\"checkMissingText(\'exp_end_year_\' + $index, \'select\')\" ng-disabled=experience.is_current><option value=\"\">Select</option></select></div></div><div class=current-checkbox-wrapper><label class=checkbox-btn><input type=checkbox ng-model=experience.is_current ng-change=resumeEditor.setCurrentItem(experience)> <span>Present</span></label></div></div></div></div><div class=\"form-row row-item\"><div class=col-md-12><label for=exp-short-desc>Description</label><div class=\"add-info resume-edit editable-inline\" placeholder=Summary id=experience_{{$index}} ng-bind-html=experience.summary ng-model=experience.summary ng-focus=\"resumeEditor.isEditable(\'experience_\' + $index)\" ng-click=\"resumeEditor.isEditable(\'experience_\' + $index)\"></div></div></div></div></div><button ng-class=\"getOrganizationCss(\'add-new-sec\')\" ng-click=\"resumeEditor.addNewExperience(0, true, \'Military\')\">Add New Military</button></div></div></div></uib-accordion-group><!-- #endregion Military Experience --></uib-accordion></div></div><!-- #region Resume Preview --><div class=user-preview-profile ng-show=\"resumeEditor.isCurrentPage(\'preview_resume\')\"><div class=topnav id=miniNav><div class=mini-nav-buttons-container><div ng-class=\"getOrganizationCss(\'mini-nav-buttons\')\" ng-click=resumeEditor.movePrev() ng-class=\"{\'disabled\': prevDisabled}\"><i class=\"fas fa-angle-left\"></i></div><div class=curr-template><div class=template-style>Style {{selectedTemplateIndex}} of {{templatesCount}}</div><!-- <div class=\"template-name\">{{selectedTemplate.title}}</div> --><select class=template-name ng-model=resumeselected ng-options=\"resume.title for resume in resume_template_options\" ng-change=resumeEditor.changeResume()></select></div><div ng-class=\"getOrganizationCss(\'mini-nav-buttons\')\" ng-click=resumeEditor.moveNext() ng-class=\"{\'disabled\': nextDisabled}\"><i class=\"fas fa-angle-right\"></i></div></div></div><div class=assessment-form-group><div class=form-group><div class=form-check><input class=form-check-input type=checkbox id=assesment-checkbox><label class=form-check-label for=assesment-checkbox>Include Assesment</label></div></div></div><div class=resume-col><div class=resume-template id=resume-template><div class=resume-mask ng-show=isResumeLoading><div class=simple-loader></div></div><div resize-resume-preview=selectedTemplate is-show=\"resumeEditor.isCurrentPage(\'preview_resume\')\" is-template-loaded=!isResumeLoading id=mini-template-display class=\"mini-template-display resume-container-container\"><div class=\"resume-container clearfix\"></div></div></div></div></div><!-- #endregion Resume Preview --><!-- #region Job2Resume --><div class=user-j2r-section ng-show=showJobDesc><div class=\"row resume-modal-row\" style=\"display: none\"><div class=\"col-md-12 resume-modal-col zero-sides\"><div class=\"row resume-modal-row padding-up-down-zero zero-sides\"><label class=resume-modal-subtitle>{{\'RESUME_PROFILE_JOB_DESCRIPTION_SECTION_SUMMARY\' | translate }}</label></div><div class=\"padding-up-down-zero zero-sides\"><div class=\"col-md-6 resume-modal-sub-content\"><div>Employers Name: {{resumeEditor.employersName}}</div><div>Job Title: {{resumeEditor.jobTitle}}</div><div>Location: {{resumeEditor.location}}</div><div>Preferred Years: {{resumeEditor.minimumYears}} <span>{{resumeEditor.minimumYears > 0 && resumeEditor.maximumYears > 0 ? \'-\' : \'\'}}</span> {{resumeEditor.maximumYears}}</div><div>Your Years Experience: {{resumeEditor.yearsExperience}}</div></div><div class=\"col-md-6 resume-modal-sub-content\"><div># Listed Required Skills: {{resumeEditor.requiredSkillsList.length + resumeEditor.matchingSkillsList.length}}</div><div># Matching Required Skills: {{resumeEditor.matchingSkillsList.length}}</div><div># Missing Required Skills: {{(resumeEditor.requiredSkillsList.length > resumeEditor.matchingSkillsList.length) ? resumeEditor.requiredSkillsList.length - resumeEditor.matchingSkillsList.length : 0}}</div><div># Missing All Skills: {{resumeEditor.missingAllSkills}}</div><div>Match on Degree: <span>{{resumeEditor.matchedDegrees.length > 0 ? \'Yes\' : (resumeEditor.hasDegreesListed) ? \'No\' : \'N/A\'}}</span></div></div></div></div></div><div ng-model=jobHTML ng-keyup=descChanged() id=jobDesc class=div-textarea contenteditable=true></div><div class=wizard-buttons-group ng-if=resumeEditor.wizard.isWizard><button class=\"btn btn-link btn-green-link\" ng-click=resumeEditor.wizard.skipJ2R();>Skip for Now</button></div></div><!-- #endregion Job2Resume --></div></form><!-- #region Industry Modal --><div class=\"industry-info-section resume-industry-section col-xs-11 col-sm-10 col-md-10 col-lg-10\" ng-show=showIndustry style=z-index:9001><div class=\"row justify-content-center\"><div class=\"col-xs-10 col-sm-9 col-md-9 col-lg-6\"><div class=\"form-group industry-title-section\"><label>{{\'RESUME_WALKTHROUGH_INDUSTRY_SECTION_SUBTITLE\' | translate }}</label><input type=text id=searchIndustries class=\"form-control resume-edit\" validator=requirednomsg placeholder=\"Search industry\" ng-keyup=filterIndustries() ng-model=industriesFilter><div class=clearfix></div></div></div></div><div class=\"row justify-content-center\"><div class=col-sm-12><div class=\"designation-blocks row\"><ul class=\"designtion-cat col-sm-6 col-lg-3\" ng-repeat=\"industries in industriesEdited\"><li ng-repeat=\"industry in industries\" ng-class=\"(selectedIndustry==industry.title) ? \'isSelected\' : \'\'\" ng-click=resumeEditor.setIndustry(industry.title)>{{industry.title}}</li></ul><div class=clearfix></div></div><div ng-if=industry_required_error class=industry-required-error style=\"margin-top: 15px;color: red\" translate=RESUME_WALKTHROUGH_INDUSTRY_REQUIRED_ERROR></div></div></div><div class=\"row justify-content-center\"><div class=\"col-sm-12 col-md-8 col-lg-6\"><button type=button class=resume-btn ng-click=resumeEditor.closeIndustries()>Close</button> <button type=button class=resume-btn ng-click=resumeEditor.saveIndustries()>Update</button><div class=clearfix></div></div></div></div><!-- #endregion Industry Modal --><!-- #region Summary Keywords Modal --><div class=\"industry-info-section resume-industry-section col-xs-11 col-sm-10 col-md-10 col-lg-10\" ng-show=showSummaryMissingModal style=z-index:9001><div class=\"row justify-content-center\"><div class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10\"><div class=\"form-group industry-title-section\"><label>Review the lists below and click the (+) button to add any keyword from the job description you wish to include.</label><div class=clearfix></div></div></div></div><div class=\"row justify-content-center\"><div class=col-sm-12><div class=\"designation-blocks row\"><div class=\"col-sm-6 offset-sm-3\"><div ng-repeat=\"keyword in summaryMissingArr\"><div class=add-keyword-container><div type=text class=keyword style=color:#2d5c2d>{{keyword}}</div><button class=add-keyword-button ng-click=resumeEditor.addSummaryMissingKeyword(keyword)><img class=unselectable src=/media/images/add-btn.svg></button></div></div></div></div></div></div><div class=\"row justify-content-center\"><div class=\"col-sm-12 col-md-8 col-lg-6\"><button type=button class=resume-btn ng-click=resumeEditor.closeSummaryMissingModal()>Done</button><div class=clearfix></div></div></div></div><!-- #endregion Summary Keywords Modal --><!-- #region Experience Skills Modal --><div class=\"industry-info-section resume-industry-section col-xs-11 col-sm-10 col-md-10 col-lg-10\" ng-show=showExpSkills style=z-index:9001><div class=\"row justify-content-center\"><div class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10\"><div class=\"form-group industry-title-section\"><label>{{\'RESUME_PROFILE_JOB_DESCRIPTION_EXPERIENCE_SKILLS_TITLE\' | translate }}</label><div class=clearfix></div></div></div></div><div class=\"row justify-content-center\"><div class=col-sm-12><div class=\"designation-blocks row\"><div class=\"col-sm-6 offset-sm-3\"><div ng-repeat=\"skill in resumeEditor.experienceMissingSkillList\"><div class=add-keyword-container><div type=text class=keyword style=color:#2d5c2d>{{skill}}</div><button class=add-keyword-button ng-click=\"resumeEditor.addExperienceMissingSkill(resumeEditor.experienceRequiredSkillsSelected, skill)\"><img class=unselectable src=/media/images/add-btn.svg></button></div></div></div></div></div></div><div class=\"row justify-content-center\"><div class=\"col-sm-12 col-md-8 col-lg-6\"><button type=button class=resume-btn ng-click=resumeEditor.closeExperienceRequiredSkills()>Done</button><div class=clearfix></div></div></div></div><!-- #endregion Experience Skills Modal --><!-- #region Required Skills Modal --><div class=\"industry-info-section resume-industry-section col-xs-11 col-sm-10 col-md-10 col-lg-10\" ng-show=showSkillsReq style=z-index:9001><div class=\"row justify-content-center\"><div class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10\"><div class=\"form-group industry-title-section\"><label>{{\'RESUME_PROFILE_JOB_DESCRIPTION_SKILLS_TITLE\' | translate }}</label><div class=clearfix></div></div></div></div><div class=\"row justify-content-center\"><div class=col-sm-12><div class=\"designation-blocks row\"><div class=col-sm-12><div class=\"col-sm-4 button-header\" style=\"display: none\"><div>{{\'RESUME_PROFILE_JOB_DESCRIPTION_MISSING_SKILLS_INSTRUCTIONS\' | translate }}</div><div ng-repeat=\"skill in resumeEditor.missingSkillsList \" id=missingSkillDiv_{{$index}}><div class=add-keyword-container><div type=text class=keyword style=color:#2d5c2d>{{skill}}</div></div></div></div><div class=col-sm-6><div>{{\'RESUME_PROFILE_JOB_DESCRIPTION_REQUIRED_SKILLS_INSTRUCTIONS\' | translate }}</div><br><div ng-repeat=\"skill in resumeEditor.requiredSkillsList \" id=requiredSkillDiv_{{$index}}><div class=add-keyword-container><div type=text class=keyword style=color:#2d5c2d>{{skill}}</div><button class=add-keyword-button ng-click=\"resumeEditor.moveSkill($index, 1)\"><img class=unselectable src=/media/images/add-btn.svg></button></div></div></div><div class=col-sm-6><div>{{\'RESUME_PROFILE_JOB_DESCRIPTION_OPTIONAL_SKILLS_INSTRUCTIONS\' | translate }}</div><br><div ng-repeat=\"skill in resumeEditor.otherSkillsList \" id=otherSkillDiv_{{$index}}><div class=add-keyword-container><div type=text class=keyword style=color:#2d5c2d>{{skill}}</div><button class=add-keyword-button ng-click=\"resumeEditor.moveSkill($index, 2)\"><img class=unselectable src=/media/images/add-btn.svg></button></div></div></div></div></div></div></div><div class=\"row justify-content-center\"><div class=\"col-sm-12 col-md-8 col-lg-6\"><button type=button class=resume-btn ng-click=resumeEditor.closeRequiredSkills()>Done</button><div class=clearfix></div></div></div></div><!-- #endregion Required Skills Modal --></div><!-- #region Wizard --><div class=container ng-class=\"getOrganizationCss(\'container\')\" ng-show=!resumeEditor.wizard.isWizard><resume-builder-profile-buttons resume-editor=resumeEditor button-class=btn-green is-bottom=true></resume-builder-profile-buttons></div><!-- #endregion Wizard --></section><div id=waitDiv style=\"background-color:#4b4444;opacity: .5;position: fixed;top:0px;left:0px;width:100%;height:100%;display:none;z-index:10000\"></div><!-- #region Profile Picture Modal --><div class=modal id=profile-pic-modal tabindex=-1 role=dialog aria-labelledby=take-test-modal-title aria-hidden=true ng-show=profileImgModal><div class=\"modal-dialog modal-dialog-centered\" role=document><div class=modal-content><div class=modal-header><h6 ng-show=!profileImgModalDelete>Position and size your photo</h6><h6 ng-show=profileImgModalDelete>Remove Your Photo</h6><button type=button class=close aria-label=Close ng-click=\"profileImgModal = false;\"><img src=/media/images/close.svg alt=close class=img-fluid></button></div><div class=modal-body><croppie src=cropped.source ng-model=cropped.image options=\"{boundary:{width:300,height:300},viewport:{width: 300, height: 300,type:\'circle\'}}\" ng-show=!profileImgModalDelete></croppie><div class=take-test-btn-group><div class=update-profile-picture-checkbox-container ng-show=!profileImgModalDelete><input type=checkbox name=updateProfilePicture ng-model=updateProfilePicture> &nbsp;Update Profile Picture</div><div class=update-profile-picture-checkbox-container ng-show=profileImgModalDelete>Are you sure you\'d like to remove your profile picture from this resume?</div><div class=update-profile-picture-checkbox-container ng-show=profileImgModalDelete><input type=checkbox name=updateProfilePicture ng-model=updateProfilePicture> &nbsp;Would you like to remove your picture from your profile as well?</div><button type=button class=\"btn btn-primary let-go-btn\" ng-click=uploadCroppedImg() ng-show=!profileImgModalDelete>Save</button> <button type=button class=\"btn btn-primary let-go-btn\" ng-click=deleteResumePicture() ng-show=profileImgModalDelete>Yes</button> <button type=button ng-click=\"profileImgModal = false;\" class=\"btn btn-secondary cancel-btn\">Cancel</button></div><!-- Preview --><!-- <img ng-src=\"{{cropped.image}}\" /> --></div></div></div></div><!-- #endregion Profile Picture Modal -->");
$templateCache.put("app/resume-builder/template/resume-builder.html","<link rel=stylesheet type=text/css href={{apiCssUrl}}><div ng-class=\"scrimPageBackground? \'scrim\':\'\'\"><nav-bar user=user></nav-bar><div class=page-header-intry><div class=background-image></div></div><paywall-dialog success=\"paymentSuccess(updatedUser, closed)\" error=paymentError(error) active=paymentRequired user=user finishtext=\"Continue downloading resume\"></paywall-dialog><div class=\"page-content-intry page-content-intry-preview-editor\"><div class=\"section-center preview-section-shadow\"><div class=preview-resume-container><img class=resume-loader src=//s3.amazonaws.com/static.intry.careers/images/webapp/dashboard-icon.svg></div></div><div class=\"preview-section-right resume-sidebar\" ng-class=\'!loadingData ? \"resumeEditingEnabled\": \"\"\'><div class=resume-editing ng-if=!loadingData><div class=menu-container><div class=resume-editing-options ng-if=!editResume><a class=button-edit-cancel-resume ng-disabled=isPaused title={{toolTip}} ng-click=resumeEditingEnabled()>Edit Here</a></div><div class=resume-editing-options ng-if=editResume><a class=button-save-resume ng-click=validateTheResume()>Save</a><div class=edit-menu-spacer></div><a class=button-edit-cancel-resume ng-click=cancelResumeEditing()>Cancel</a></div><hr style=\"width:100px;height:1px;margin:4px 0px 4px 5px;border-color:#afafaf;opacity: .5\"><div class=resume-editing-options><a class=button-edit-cancel-resume title={{toolTip}} ng-click=profileEditor()>Inline Editor</a></div><!--<hr style=\"width:100px;height:1px;margin:4px 0px 4px 5px;border-color:#afafaf;opacity: .5;\">\n          <div class=\"export-type\">\n            <a ng-if=\"editResume\" ng-click=\"toggleAts()\" title=\"Toggle export type\">{{getAtsButtonLabel()}}</a>\n            <div ng-if=\"!editResume\">{{getAtsButtonLabel()}}</div>\n          </div>--><hr style=\"width:100px;height:1px;margin:4px 0px 4px 5px;border-color:#afafaf;opacity: .5\"><div class=hints-tips><span><a ng-click=showTips()>Resume Tips</a></span></div><hr style=\"width:100px;height:1px;margin:6px 0px 4px 5px;border-color:#afafaf;opacity: .5\"><div class=download-resume ng-show=downloadResumeLink><div><div style=display:inline-block><span><a ng-click=downloadResume($event) ng-show=\"resumeDownloading == false\"><span ng-if=\"validSubscription === false\" translate=DOWNLOAD_RESUME_NO_SUBSCRIPTION style=\'font-family:\"Open Sans\"\'></span> <span ng-if=\"validSubscription === true\" translate=DOWNLOAD_RESUME style=\'font-family:\"Open Sans\"\'></span> <span class=download-icon style=margin-left:12px></span> </a></span><span ng-show=\"resumeDownloading == true\" style=\'font-family:\"Open Sans\";margin-left:5px;font-weight:600;font-size:11pt\'><span style=\'margin:0;width:84px;font-family:\"Open Sans\"\'>Download...</span><span class=download-icon style=margin-left:3px></span></span></div></div></div></div></div><div class=\"menu-container page-count\" ng-if=\"resume && resume.resumeID && !loadingData && !hidePageCount\"><div class=current-count>{{getPageCount()}}</div></div><div id=tipshints style=display:none class=allhintandtips><div style=\'font-family:\"Open Sans\";width:95%;margin-top:20px\' class=hintsandtips><ul><li style=\'font-family:\"Open Sans\"\'>Create a unique resume that fits the position for which you are applying.</li><li style=\'font-family:\"Open Sans\"\'>Phrase the wording of your summaries to match the job description as much as possible.</li><li style=\'font-family:\"Open Sans\"\'>Do not over use the same keywords.</li><!-- <li style=\'font-family:\"Open Sans\";\'>If you use abbreviations, make sure to write out the full text description also. The reader may not understand all abbreviations.</li>             --><li style=\'font-family:\"Open Sans\"\'>Spell check everything.<!-- Readers will notice mistakes.<BR /><strong>Note:</strong> The WYSISYG editor requires pressing the CTRL key to enable spelling corrections --> .</li><li style=\'font-family:\"Open Sans\"\'>Describe your performance, not just your previous job descriptions.</li><!-- <li style=\'font-family:\"Open Sans\";\'>Be sure to user proper grammar.</li> --><!-- <li style=\'font-family:\"Open Sans\";\'>Avoid cliche words such as \'Rock Star\' or using hashtags.</li>\n              <li style=\'font-family:\"Open Sans\";\'>Make your profile about you, not the job. Tell them why they should hire you. Sell yourself.</li> --><li style=\'font-family:\"Open Sans\"\'>List both your soft and technical skills. Hiring managers could be looking for both</li><!-- <li style=\'font-family:\"Open Sans\";\'>Be concise in your narratives.</li>  --></ul></div><div class=hints-tips-text>Remember, a resume is your first impression. Make sure they see the<span class=tm>TrueYou</span>, This is your time to shine above the rest.</div><div class=hints-tips-text>NOTE: Hold down the CTRL key to enable spell check (right click does not work in this editor by itself.) Also, the resume format during editing may be slightly different than when printed if you have any optional fields (like contact information) left blank. Save your work and inspect it for printing format.</div></div></div></div></div>");
$templateCache.put("app/resume-builder/template/resume-download-validation-dialog.html","<div class=\"modal-intry resume-download-validation-dialog\"><div class=\"section section-active\"><div class=title>Something is not right!</div><div class=subtitle>We\'ve notice that your page content is larger than the printable area.<br><br>You\'ll need to edit your content so it will fit within the resume page layout.<br><br></div><div class=line></div><div><div style=width:325px;text-align:right><a ng-click=closeConfirmSaveDialog()>Ok</a></div></div></div></div>");
$templateCache.put("app/resume-builder/template/resume-generation-waiting-dialog.html","<div class=\"modal-intry resume_generation-waiting-dialog\"><button class=\"btn btn-modal-intry-dismiss\" data-status=\"{{ downloadAvailable ? \'finish\' : \'close\' }}\" ng-click=closeWaitingDialog($event);></button><div class=\"section section-active\"><div ng-if=!downloadAvailable class=title>That looks great!</div><div ng-if=downloadAvailable class=title>Your resume is ready...</div><div class=subtitle><span ng-if=\"!downloadAvailable && !currentlyDownloadingResume\">Prepping your resume for download.<br>This might take a minute.</span></div><div class=\"subtitle section-resume-loader\"><div class=resume-loader><div class=row-loader-image><div class=loader-container></div><div src=media/icons/Intry-Door-Transparent.png class=\"loader-img loader-img-progress\"></div><div src=media/icons/Intry-Door-Transparent.png class=loader-img></div><!-- <img src=\"//s3.amazonaws.com/static.intry.careers/images/webapp/onboarding_resume_loader.png\" class=\'loader-img loader-img-progress\'/>\n                        <img src=\"//s3.amazonaws.com/static.intry.careers/images/webapp/onboarding_resume_loader.png\" class=\'loader-img\'/> --></div></div></div><div class=footer-modal><div class=\"action double\"><a ng-click=closeWaitingDialog($event) ng-show=!downloadAvailable>Back</a> <a ng-click=closeWaitingDialog($event) data-status=finish ng-show=downloadAvailable>Finish</a><!-- <a ng-click=\"\"  class=\"download\" ng-show=\"downloadAvailable\" ng-href=\"{{resumeFilePath}}\" download=\"crap.pdf\">Download</a> --><!--<a ng-click=\"downloadResumeFromS3()\" class=\"download\" ng-show=\"downloadAvailable\" download>Download</a>--> <a ng-click=closeWaitingDialog($event) data-status=cancel ng-show=!downloadAvailable>Cancel</a></div></div></div></div>");
$templateCache.put("app/resume-builder/template/resume-save-confirm-dialog.html","<div class=\"modal-intry resume-save-confirm-dialog\"><div class=\"section section-active\"><div class=title>You sure ‘about that?</div><div class=subtitle>You haven’t saved yet and your changes are about to be discarded. Are you sure you want to continue?</div><div class=line></div><div class=action><table><tr><td><a ng-click=closeConfirmSaveDialog() class=no>No</a></td><td class=vertical-line></td><td><a ng-click=cancelAndDownload() class=yes>Yes</a></td></tr></table></div></div></div>");
$templateCache.put("app/resume-builder/template/resume-save-validation-dialog.html","<div class=\"modal-intry resume-save-validation-dialog\"><div class=\"section section-active\"><div class=title>Your resume may be too long.</div><div class=subtitle>Your resume may be too long to generate and download.<br><br>You may need to edit your resume to fit within the resume page before<br><br>clicking the Download My Resume botton.</div><div class=line></div><div class=action><table><tr><td><a ng-click=closeConfirmSaveDialog() class=no>Go Back</a></td><td class=vertical-line></td><td><a ng-click=continueToSaveResume() class=yes>Continue to save</a></td></tr></table></div></div></div>");
$templateCache.put("app/resume-builder/template/unavailable-resumes-dialog.html","<div class=\"modal-intry resume-save-confirm-dialog max-resumes-dialog\"><div class=\"section section-active\"><div class=title>Sorry</div><div>You do not have any more resumes available based on your current subscription.</div><div>&nbsp;</div><div>Please click below to create more resumes by upgrading your subscription.</div><div class=line></div><div class=action><table><tr><td><a ng-click=closeConfirmSaveDialog() class=no>Close</a></td><td><a ng-click=showPaywall() class=no>Upgrade</a></td></tr></table></div></div></div>");
$templateCache.put("app/admin/admins/template/admins.html","<nav-bar-admin></nav-bar-admin><section class=\"main-sec full-height-content\"><div class=header-data><div class=\"container pagination-container big-margin-bottom\"><div ng-class=\"getOrganizationCss(\'admin-user-info-sec\')\"><div class=not-border-bottom><div class=\"inner-sec pagination-inner-sec\"><div class=\"row2 admin-users-title-container\"><div><button ng-click=requestCreate() ng-class=\"getOrganizationCss(\'add-btn\')\"><h2>Add Admin</h2></button></div></div><div class=\"row2 form-styles admin-search-form margin-bottom\"><div class=\"col-lg-2 col-md-2 padding-right-zero\" ng-show=false><div class=select-style><select ng-model=filterField ng-options=\"x.key as x.label for x in adminFilterFields\" class=\"form-control form-select\" ng-change=checkFtypes()></select></div></div><div class=\"col-lg-2 col-md-2 padding-right-zero\" ng-show=false><div class=select-style><select ng-model=ftype ng-options=\"x.key as x.label for x in ftypes\" class=\"form-control form-select\"></select></div></div><div class=search><img src=media/icons/search.png><div class=padding-right-zero><input ng-model=paginationFilter type=text placeholder=\"{{getTitle(\'ADMIN_SECTION_ADMINS_FILTER_PLACEHOLDER_TEXT\')}}\" class=search-bar></div></div><div><button ng-click=search() ng-class=\"getOrganizationCss(\'search-btn\')\">Search</button></div></div><div class=row2><div class=\"col-md-12 overflow-x-auto\" style=\"padding: 0 !important\"><table st-table=admins st-pipe=getAdmins ng-class=\"getOrganizationCss(\'table table-striped intry-table\')\"><thead><tr><th st-sort=first_name ng-click=setResetSkip(true) class=sort-button translate=ADMIN_SECTION_ADMINS_FIRST_NAME_HEAD_TEXT></th><th st-sort=last_name ng-click=setResetSkip(true) class=sort-button translate=ADMIN_SECTION_ADMINS_LAST_NAME_HEAD_TEXT></th><th st-sort=username ng-click=setResetSkip(true) class=\"padding-left sort-button\" translate=ADMIN_SECTION_ADMINS_USERNAME_HEAD_TEXT></th><th st-sort=organizationKey ng-click=setResetSkip(true) class=sort-button translate=ADMIN_SECTION_ADMINS_ORGANIZATION_KEY_HEAD_TEXT ng-show=\"checkRole([\'ROLE_APP_ADMIN\'])\"></th><th st-sort=location ng-click=setResetSkip(true) class=sort-button translate=ADMIN_SECTION_ADMINS_LOCATION_KEY_HEAD_TEXT ng-show=\"checkRole([\'ROLE_APP_ADMIN\'])\"></th><th st-sort=belongsToObj.username ng-click=setResetSkip(true) class=sort-button translate=ADMIN_SECTION_ADMINS_BELONGS_TO_HEAD_TEXT></th><th st-sort=role ng-click=setResetSkip(true) class=sort-button translate=ADMIN_SECTION_ADMINS_ROLE_HEAD_TEXT></th><!-- (((NOT YET)))\n		      <th st-sort=\"assigned-cases\" ng-click=\"setResetSkip(true)\" class=\"sort-button\"\n			  translate=\"ADMIN_SECTION_ADMINS_ASSIGNED_CASES_HEAD_TEXT\"></th>\n		      <th st-sort=\"jobs-placed\" ng-click=\"setResetSkip(true)\" class=\"sort-button\"\n			  translate=\"ADMIN_SECTION_ADMINS_JOBS_PLACED_HEAD_TEXT\"></th>\n		      <th st-sort=\"last-log\" ng-click=\"setResetSkip(true)\" class=\"sort-button\"\n			  translate=\"ADMIN_SECTION_ADMINS_LAST_LOG_HEAD_TEXT\" ng-show=\"checkRole([\'ROLE_APP_ADMIN\'])\"></th>\n(((END NOT YET))) --><th class=\"text-align-right padding-right\" translate=ADMIN_SECTION_ADMINS_ACTIONS_HEAD_TEXT></th></tr></thead><tbody ng-show=!isLoading><tr ng-repeat=\"row in admins\"><td class=\"capitalize account-details\" data-title=\"{{\'ADMIN_SECTION_ADMINS_FIRST_NAME_HEAD_TEXT\' | translate}}\">{{row.first_name}}</td><td class=\"capitalize account-details\" data-title=\"{{\'ADMIN_SECTION_ADMINS_LAST_NAME_HEAD_TEXT\' | translate}}\">{{row.last_name}}</td><td class=\"capitalize account-details padding-left\" data-title=\"{{\'ADMIN_SECTION_ADMINS_USERNAME_HEAD_TEXT\' | translate}}\">{{row.username}}</td><td class=\"capitalize account-details\" ng-show=\"checkRole([\'ROLE_APP_ADMIN\'])\" data-title=\"{{\'ADMIN_SECTION_ADMINS_ORGANIZATION_KEY_HEAD_TEXT\' | translate}}\">{{row.organizationKey}}</td><td class=\"capitalize account-details\" ng-show=\"checkRole([\'ROLE_APP_ADMIN\'])\" data-title=\"{{\'ADMIN_SECTION_ADMINS_LOCATION_KEY_HEAD_TEXT\' | translate}}\">LOCATION</td><td class=\"capitalize account-details\" data-title=\"{{\'ADMIN_SECTION_ADMINS_BELONGS_TO_HEAD_TEXT\' | translate}}\">{{row.belongsToObj.username}}</td><td class=\"capitalize account-details\" data-title=\"{{\'ADMIN_SECTION_ADMINS_ROLE_HEAD_TEXT\' | translate}}\">{{row.role | translate}}</td><!-- (((NOT YET)))\n		      <td class=\"capitalize account-details\"\n			  data-title=\"{{\'ADMIN_SECTION_ADMINS_ASSIGNED_CASES_HEAD_TEXT\' | translate}}\">\n			ASSIGNED CASES</td>\n		      <td class=\"capitalize account-details\"\n			  data-title=\"{{\'ADMIN_SECTION_ADMINS_JOBS_PLACED_HEAD_TEXT\' | translate}}\">\n			JOBS PLACED</td>\n		      <td class=\"capitalize account-details\"\n			  data-title=\"{{\'ADMIN_SECTION_ADMINS_LAST_LOG_HEAD_TEXT\' | translate}}\">\n			LAST LOG</td>\n(((END NOT YET))) --><td class=action-td><a ng-click=viewAdmin(row.userID) uib-tooltip=\"{{\'ADMIN_SECTION_ADMINS_DROPDOWN_VIEW_TEXT\' | translate}}\" ng-show=canViewAdmin(row) tooltip-placement=bottom><i ng-class=\"getOrganizationCss(\'material-icons\')\">search</i> </a><a ng-click=disableAdminModal(row) uib-tooltip=\"{{\'ADMIN_SECTION_ADMINS_DROPDOWN_DISABLE_TEXT\' | translate}}\" ng-show=\"(row.status === \'active\') && canDisableAdmin(row)\" tooltip-placement=bottom><i ng-class=\"getOrganizationCss(\'material-icons\')\">block</i> </a><a ng-click=enableAdminModal(row) uib-tooltip=\"{{\'ADMIN_SECTION_ADMINS_DROPDOWN_ENABLE_TEXT\' | translate}}\" ng-show=\"(row.status === \'inactive\') && canDisableAdmin(row)\" tooltip-placement=bottom><i ng-class=\"getOrganizationCss(\'material-icons\')\">check</i> </a><a ng-click=deleteAdminModal(row) uib-tooltip=\"{{\'ADMIN_SECTION_ADMINS_DROPDOWN_DELETE_TEXT\' | translate}}\" 2 ng-show=canDeleteAdmin(row.username) tooltip-placement=bottom><i ng-class=\"getOrganizationCss(\'material-icons\')\">delete</i> </a><i class=empty-icon ng-show=\"(row.username.indexOf(\'_deleted_\') >= 0)\"></i> <i class=empty-icon ng-show=\"(row.username.indexOf(\'_deleted_\') >= 0) && checkRole([\'ROLE_APP_ADMIN\'])\"></i></td></tr></tbody><tbody ng-show=isLoading class=loader-tbody><tr><td colspan=10><div ng-class=\"getOrganizationCss(\'simple-loader\')\"></div></td></tr></tbody><tfoot><tr><td colspan=12 class=\"padding-left padding-right\"><div class=row><div class=col-md-4><div class=admin-users><div class=\"pagination padding-left-zero\"><a ng-click=getPrevPage() ng-class={disabled:disablePrev} translate=ADMIN_SECTION_ADMINS_PREV_PAGINATION_TEXT></a></div><div class=\"pagination padding-left-zero\"><a ng-click=getNextPage() ng-class={disabled:disableNext} translate=ADMIN_SECTION_ADMINS_NEXT_PAGINATION_TEXT></a></div></div></div><div class=col-md-4><div class=admin-users><div class=\"pagination center width-100\">{{\'ADMIN_SECTION_ADMINS_RESULT_NUMBER_TEXT\' | translate}}&nbsp;{{totalAdmins}}</div></div></div><div class=\"col-md-4 text-align-right\"><div class=admin-users><div class=\"pagination padding-right-zero right width-100\">{{\'ADMIN_SECTION_ADMINS_PAGE_TEXT\' | translate}}&nbsp;{{currentPage}}&nbsp;{{\'ADMIN_SECTION_ADMINS_PAGE_OF\' | translate}}&nbsp;{{totalPages}}</div></div></div></div></td></tr></tfoot></table></div></div></div></div></div></div></div></section>");
$templateCache.put("app/admin/create/template/create.html","<nav-bar-admin></nav-bar-admin><section class=\"main-sec full-height-content admin-form-sec admin-create\"><div class=header-data><div class=\"container big-margin-bottom\"><div class=\"user-info-sec admin-info-sec\"><!-- #region Personal Data --><div class=sec-style><div class=inner-sec><div class=form-row><div class=\"form-group col-md-8\"><!--<h6 class=\"sec-heading\" translate=\"ADMIN_CREATE_USER_TEXT\" ng-show=\"(action === \'create\')\"></h6>--><h6 class=sec-heading translate=ADMIN_VIEW_USER_TEXT ng-show=\"(action === \'view\')\"></h6><h6 class=sec-heading translate=ADMIN_UPDATE_USER_TEXT ng-show=\"(action === \'update\') && checkRole([\'ROLE_APP_ADMIN\'])\"></h6></div><div class=\"form-group col-md-4 force-right\"><button ng-click=loginAs() class=\"btn-default btn-transparent nowrap\" ng-show=\"(action === \'view\' && checkRole([\'ROLE_APP_ADMIN\']))\"><strong translate=Login></strong></button> <button ng-click=update() class=\"btn-default btn-transparent nowrap\" ng-show=\"(action === \'view\')\"><strong translate=ADMIN_EDIT_BUTTON_TEXT></strong></button></div></div><div id=personalDataContainer class=\"user-exp-sec form-styles\" ng-form=personalDataForm><div class=\"exp-form form-styles\"><div class=form-row ng-show=\"(action === \'create\')\"><div class=\"form-group col-md-12\"><h6 class=sec-heading>Send An Invitation</h6></div></div><div class=form-row><div class=\"form-group col-md-6\"><label translate=ADMIN_CREATE_FIRST_NAME_LABEL_TEXT></label><input ng-model=model.first_name type=text class=form-control></div><div class=\"form-group col-md-6\"><label translate=ADMIN_CREATE_LAST_NAME_LABEL_TEXT></label><input ng-model=model.last_name type=text class=form-control></div></div><div class=form-row ng-show=\"(action === \'view\')\"><div class=\"form-group col-md-6\"><label translate=City></label><input ng-model=modelAux.city type=text class=form-control></div><div class=\"form-group col-md-6\"><label translate=State></label><input ng-model=modelAux.state type=text class=form-control></div></div><div class=form-row><div class=\"form-group col-md-6\" ng-show=\"(action === \'view\')\"><label translate=Phone></label><input ng-model=modelAux.number class=form-control></div><div class=\"form-group col-md-6\"><label translate=ADMIN_CREATE_USER_NAME_LABEL_TEXT></label><input ng-model=model.username required type=email name=username class=form-control></div></div><div class=form-row ng-show=\"(action === \'create\') && (showSignupCode === true)\"><div class=\"form-group col-md-12\"><hr></div></div><div class=row-container ng-show=\"(action === \'create\') && (showSignupCode === true)\"><h6 class=sec-heading>Sign Up Code</h6><div class=show-info><img src=media/icons/question.png></div><div class=helper><p>You can invite multiple users one at time using the <i>Sign Up Code</i>. Users can create an account by using the code while they register.</p></div></div><div class=\"form-group col-md-6\" ng-show=\"(action === \'create\') && (showSignupCode === true)\"><div class=signupCodeInfo><span class=signupcode_code>{{signupCodeInfo.code}}</span>&nbsp;&nbsp;<span class=signupcode_expiration>({{signupCodeInfo.expiration}})</span></div></div><div class=form-row ng-show=\"(action === \'create\') && false\"><div class=\"form-group col-md-12\"><label translate=Emails></label><textarea class=form-control rows=4 ng-model=model.usernames></textarea></div></div><div class=form-row ng-show=\"(action === \'update\')\"><div class=\"form-group col-md-6\"><label for=exp-position translate=ADMIN_CREATE_PASSWORD_LABEL_TEXT></label><input ng-model=model.password required type=password class=form-control></div><div class=\"form-group col-md-6\"><label for=exp-position translate=ADMIN_CREATE_RETYPE_PASSWORD_LABEL_TEXT></label><input ng-model=retypepwd required type=password class=form-control></div></div><div class=form-row><div class=\"form-group col-md-6\" ng-show=\"!hasOrganization() && checkRole([\'ROLE_APP_ADMIN\'])\"><label translate=ADMIN_CREATE_ORGANIZATION_KEY_LABEL_TEXT></label><div class=select-style><select ng-model=model.organizationKey ng-options=\"x for x in organizationKeys\" class=\"form-control form-select\" required><option value=\"\">Without Organization</option></select></div></div><div class=\"form-group col-md-6\" ng-show=\"(action === \'view\')\"><label translate=Owner></label><div class=select-style><input ng-model=model.belongsToObj.username type=text class=form-control></div></div><!--- (((NOT YET))) LOCATION\n\n		  <div class=\"form-group col-md-6\" ng-show=\"(action === \'view\')\">\n		    <label translate=\"Location\"></label>\n		    <div class=\"select-style\">\n		      <input ng-model=\"model.location\" type=\"text\" class=\"form-control\">\n		    </div>\n		  </div>\n\n(((END NOT YET))) --><div class=\"form-group col-md-6\" ng-show=\"(action === \'update\')\"><label translate=Owner></label><div class=select-style><select ng-model=model.belongsTo ng-options=\"x.userID as x.username for x in adminList\" class=\"form-control form-select\"><option value=\"\">Without Owner</option></select></div></div><!-- (((NOT YET))) LOCATION\n\n		  <div class=\"form-group col-md-6\" ng-show=\"(action === \'update\')\">\n		    <label translate=\"Location\"></label>\n		    <div class=\"select-style\">\n		      <select ng-show=\"model.role !== \'ROLE_APP_ADMIN\'\"\n                              ng-model=\"model.location\"\n                              ng-options=\"x.id as x.location for x in locationKeys\"\n                              class=\"form-control form-select\" required>\n                        <option value=\"\">Without Location</option>\n                      </select>\n		    </div>\n		  </div>\n\n(((END NOT YET))) --></div><div class=form-row ng-show=\"(action === \'view\') || (action === \'update\')\"><div class=\"form-group col-md-6\" ng-show=\"(action === \'view\')\"><label translate=Hired></label><div class=select-style><select ng-model=model.hired ng-options=\"x.key as x.label for x in userHiredStatus\" class=\"form-control form-select\"><option value=\"\">Select</option></select></div></div><div class=\"form-group col-md-6\"><label translate=ADMIN_CREATE_STATUS_LABEL_TEXT></label><div class=select-style><select ng-model=model.status ng-options=\"x.key as x.label for x in userStatus\" class=\"form-control form-select\"><option value=\"\">Select</option></select></div></div></div></div><div class=form-row ng-show=\"(action === \'view\')\"><div class=\"form-group col-md-6\" ng-show=\"(action === \'view\')\"><label translate=\"License Expiration\">License Expiration</label><div><span>{{license_expires}}</span></div></div></div></div></div></div><!-- #endregion Personal Data --><!-- #region Stats Data --><div id=statsDataContainer ng-show=\"action === \'view\'\"><div class=sec-style><div class=inner-sec><div class=\"user-exp-sec form-styles\"><div class=\"exp-form form-styles\"><h3 class=sec-heading translate=Stats></h3><br><div class=form-row><div class=\"form-group col-md-6\"><label translate=\"Created Resumes\"></label><input ng-model=model.createdResumes type=text class=form-control></div><div class=\"form-group col-md-6\"><label translate=\"Created J2R\"></label><input ng-model=model.createdJ2R type=text class=form-control></div></div><div class=form-row><div class=\"form-group col-md-6\"><label translate=\"Downloaded Resumes\"></label><input ng-model=model.downloadedResumes type=text class=form-control></div><div class=\"form-group col-md-6\"><label translate=\"Downloaded WSL Reports\"></label><input ng-model=model.downloadedUnemployedReports type=text class=form-control></div></div><div class=form-row><div class=\"form-group col-md-6\"><label translate=\"Last Login\"></label><input value=\"{{additionalStats.lastUserLogin | date:\'MM/dd/yyyy hh:mm:ss a\'}}\" type=text class=form-control></div><div class=\"form-group col-md-6\"><label translate=\"Last J2R\"></label><input value=\"{{additionalStats.lastResumeJ2r | date:\'MM/dd/yyyy hh:mm:ss a\'}}\" type=text class=form-control></div></div><div class=form-row><div class=\"form-group col-md-6\"><label translate=\"Last Created Resume\"></label><input value=\"{{additionalStats.lastResumeCreate | date:\'MM/dd/yyyy hh:mm:ss a\'}}\" type=text class=form-control></div><div class=\"form-group col-md-6\"><label translate=\"last Downloaded Resume\"></label><input value=\"{{additionalStats.lastResumeDownloaded | date:\'MM/dd/yyyy hh:mm:ss a\'}}\" type=text class=form-control></div></div><div class=form-row><div class=\"form-group col-md-6\"><label translate=\"Last Created WSL Note\"></label><input value=\"{{additionalStats.lastUnemployedNoteCreate | date:\'MM/dd/yyyy hh:mm:ss a\'}}\" type=text class=form-control></div><div class=\"form-group col-md-6\"><label translate=\"Last Downloaded WSL Report\"></label><input value=\"{{additionalStats.lastUnemployedReportDownloaded | date:\'MM/dd/yyyy hh:mm:ss a\'}}\" type=text class=form-control></div></div></div></div></div></div></div><!-- #endregion Stats Data --><!-- #region Summary Data --><div id=summaryDataContainer class=sec-style ng-if=\"action === \'view\'\"><div class=inner-sec><h3 class=sec-heading translate=Summary></h3><br><div class=form-row><div class=\"form-group col-md-12\"><div class=text-container>{{model.summary}}</div></div></div></div></div><!-- #endregion Summary Data --><!-- #region Experience Data --><div id=experienceDataContainer class=sec-style ng-if=\"action === \'view\'\"><div class=inner-sec><h3 class=sec-heading translate=Experience></h3><br><div class=\"user-exp-sec form-styles\" ng-repeat=\"experience in modelAux.experience track by $index\"><div class=form-row><div class=\"form-group col-md-6\"><label>Position</label><div text-container>{{experience.title}}</div></div><div class=\"form-group col-md-6\"><label>Company</label><div text-container>{{experience.company}}</div></div></div><div class=form-row><div class=\"form-group col-md-6\"><label>Start Date</label><div text-container>{{experience.startMonthObj + \"/\" + experience.startYearObj}}</div></div><div class=\"form-group col-md-6\"><label>End Date</label><div text-container>{{experience.endMonthObj + \"/\" + experience.endYearObj}}</div></div></div><div class=form-row ng-show=!$last><div class=\"form-group col-md-12\"><hr></div></div></div></div></div><!-- #endregion Experience Data --><!-- #region Education Data --><div id=educationDataContainer class=sec-style ng-if=\"action === \'view\'\"><div class=inner-sec><h3 class=sec-heading translate=Education></h3><br><div class=\"user-exp-sec form-styles\" ng-repeat=\"education in modelAux.education track by $index\"><div class=form-row><div class=\"form-group col-md-6\"><label>Degree & Major</label><div text-container>{{education.degree}}</div></div><div class=\"form-group col-md-6\"><label>University</label><div text-container>{{education.institution}}</div></div></div><div class=form-row><div class=\"form-group col-md-6\"><label>Start Date</label><div text-container>{{education.startMonthObj + \"/\" + education.startYearObj}}</div></div><div class=\"form-group col-md-6\"><label>End Date</label><div text-container>{{education.endMonthObj + \"/\" + education.endYearObj}}</div></div></div><div class=form-row ng-show=!$last><div class=\"form-group col-md-12\"><hr></div></div></div></div></div><!-- #endregion Education Data --><!-- #region Skills Data --><div id=skillsDataContainer class=sec-style ng-if=\"action === \'view\'\"><div class=inner-sec><h3 class=sec-heading translate=Skills></h3><br><div class=form-row><div class=\"form-group col-md-12\"><div class=text-container><span class=\"user-exp-sec form-styles\" ng-repeat=\"skill in model.skills track by $index\">{{skill.skill + \" (\" + skill.proficiency + \")\" + ((!$last) ? \", \" : \".\")}}</span></div></div></div></div></div><!-- #endregion Skills Data --><!-- #region Address Data --><div id=addressDataContainer class=sec-style ng-show=\"!hasOrganization() && (action === \'update\')\"><div class=inner-sec><h3 class=sec-heading translate=ADMIN_CREATE_ADDRESSES_HEAD_TEXT></h3><br><div class=\"user-exp-sec form-styles\" ng-repeat=\"address in model.addresses track by $index\"><label><strong><span translate=ADMIN_CREATE_ADDRESS_ITEM_TEXT></span>&nbsp;{{$index + 1}}</strong></label><div class=\"exp-form form-styles\"><div class=form-row><div class=\"form-group col-md-6\"><label translate=ADMIN_CREATE_COUNTRY_LABEL_TEXT></label><input ng-model=address.country required type=text class=form-control></div><div class=\"form-group col-md-6\"><label translate=ADMIN_CREATE_STATE_LABEL_TEXT></label><input ng-model=address.state required type=text class=form-control></div></div><div class=form-row><div class=\"form-group col-md-6\"><label translate=ADMIN_CREATE_CITY_LABEL_TEXT></label><input ng-model=address.city required type=text class=form-control></div><div class=\"form-group col-md-6\"><label translate=ADMIN_CREATE_POSTAL_CODE_LABEL_TEXT></label><input ng-model=address.postal_code type=text class=form-control></div></div><div class=form-row><div class=\"form-group col-md-12\"><label for=exp-position translate=ADMIN_CREATE_STREET_LABEL_TEXT></label><input ng-model=address.street required type=text class=form-control></div></div><div class=form-row><div class=\"form-group col-md-6\"><label translate=\"{{\'ADMIN_CREATE_STREET_LABEL_TEXT\' | translate}} 2\"></label><input ng-model=address.street_2 type=text class=form-control></div><div class=\"form-group col-md-6\"><label translate=ADMIN_CREATE_KIND_LABEL_TEXT></label><div class=select-style><select ng-model=address.kind ng-options=\"x for x in kind\" class=\"form-control form-select\" required><option value=\"\">Select</option></select></div></div></div><div class=form-row><div class=\"form-group col-md-12\"><hr></div></div></div><button ng-click=\"delete(\'addresses\',$index)\" ng-show=\"model.addresses.length > 0\" class=\"delete-new-sec delete-item-button\" role=button tabindex=0 ng-show=\"(action !== \'view\')\"><img src=/media/images/delete.svg alt=\"delete icon\" class=img-fluid ng-show=\"(action !== \'view\')\"></button></div><button ng-class=\"getOrganizationCss(\'add-new-sec\')\" ng-click=addNewAddress() translate=ADMIN_CREATE_ADDRESS_ADD_ITEM_TEXT ng-show=\"(action !== \'view\')\"></button></div></div><!-- #endregion Address Data --><!-- #region Phone Numbers Data --><div id=phoneNumberDataContainer class=sec-style ng-if=\"!hasOrganization() && (action === \'update\')\"><div class=inner-sec><h3 class=sec-heading translate=ADMIN_CREATE_PHONE_NUMBERS_HEAD_TEXT></h3><br><div class=\"user-exp-sec form-styles\" ng-repeat=\"phone in model.phone_numbers track by $index\"><label><strong><span translate=ADMIN_CREATE_NUMBER_ITEM_TEXT></span>&nbsp;{{$index + 1}}</strong></label><div class=\"exp-form form-styles\"><div class=form-row><div class=\"form-group col-md-6\"><label translate=ADMIN_CREATE_NUMBER_LABEL_TEXT></label><input ng-model=phone.number required type=text class=form-control></div><div class=\"form-group col-md-6\"><label translate=ADMIN_CREATE_KIND_LABEL_TEXT></label><div class=select-style><select ng-model=phone.kind ng-options=\"x for x in kind_phone\" class=\"form-control form-select\" required><option value=\"\">Select</option></select></div></div></div><div class=form-row><div class=\"form-group col-md-12\"><hr></div></div></div><button ng-click=\"delete(\'phone_numbers\',$index)\" ng-show=\"model.phone_numbers.length > 0\" class=\"delete-new-sec delete-item-button\" role=button tabindex=0><img src=/media/images/delete.svg alt=\"delete icon\" class=img-fluid ng-show=\"(action !== \'view\')\"></button></div><button ng-class=\"getOrganizationCss(\'add-new-sec\')\" ng-click=addNewPhoneNumber() translate=ADMIN_CREATE_NUMBER_ADD_ITEM_TEXT ng-show=\"(action !== \'view\')\"></button></div></div><!-- #endregion Phone Numbers Data --><!-- #region Email Address Data --><div id=emailAddressDataContainer class=sec-style ng-if=\"!hasOrganization() && (action === \'update\')\"><div class=inner-sec><h3 class=sec-heading translate=ADMIN_CREATE_EMAIL_ADDRESSES_HEAD_TEXT></h3><br><div class=\"user-exp-sec form-styles\" ng-repeat=\"email in model.email_addresses track by $index\"><label><strong><span translate=ADMIN_CREATE_EMAIL_ADDRESS_ITEM_TEXT></span>&nbsp;{{$index + 1}}</strong></label><div class=\"exp-form form-styles\"><div class=form-row><div class=\"form-group col-md-6\"><label translate=ADMIN_CREATE_ADDRESS_LABEL_TEXT></label><input ng-model=email.address required type=text class=form-control></div><div class=\"form-group col-md-6\"><label translate=ADMIN_CREATE_KIND_LABEL_TEXT></label><div class=select-style><select ng-model=email.kind ng-options=\"x for x in kind\" class=\"form-control form-select\" required><option value=\"\">Select</option></select></div></div></div><div class=form-row><div class=\"form-group col-md-12\"><hr></div></div></div><button ng-click=\"delete(\'email_addresses\',$index)\" ng-show=\"model.email_addresses.length > 0\" class=\"delete-new-sec delete-item-button\" role=button tabindex=0 ng-show=\"(action !== \'view\')\"><img src=/media/images/delete.svg alt=\"delete icon\" class=img-fluid ng-show=\"(action !== \'view\')\"></button></div><button ng-class=\"getOrganizationCss(\'add-new-sec\')\" ng-click=addNewEmailAddress() translate=ADMIN_CREATE_EMAIL_ADDRESS_ADD_ITEM_TEXT ng-show=\"(action !== \'view\')\"></button></div></div><!-- #endregion Email Address Data --><!-- #region Subscription --><div class=sec-style ng-show=\"(action === \'view\') && checkRole([\'ROLE_APP_ADMIN\'])\"><div class=inner-sec><h3 class=sec-heading translate=ADMIN_VIEW_USER_SUBSCRIPTION_LABEL></h3><div class=\"user-exp-sec form-styles\"><div class=\"exp-form form-styles\" ng-show=subscriptionPaused><div class=form-row><div class=\"form-group col-md-12\"><label translate=ADMIN_VIEW_USER_SUBSCRIPTION_CANCELLED_TEXT></label></div></div></div><div class=\"exp-form form-styles\"><div class=form-row ng-show=!subscriptionCancelAtPeriodEnd><div class=\"form-group col-md-4\"><label translate=ADMIN_VIEW_USER_SUBSCRIPTION_PLAN_NAME_LABEL></label><div class=div-field>{{plansSubscribed[0].name}}</div></div><div class=\"form-group col-md-4\"><label translate=ADMIN_VIEW_USER_SUBSCRIPTION_PLAN_AMOUNT_LABEL></label><div class=div-field>{{plansSubscribed[0].amount | currency: \'$\' : 2}}/mo</div></div><div class=\"form-group col-md-4 right\"><button ng-click=cancelSubscriptionModal() class=\"btn-default btn-transparent nowrap\" ng-show=!subscriptionCancelAtPeriodEnd><strong translate=ADMIN_VIEW_USER_SUBSCRIPTION_CANCEL_BTN_LABEL></strong></button></div></div><div class=form-row ng-show=!subscriptionCancelAtPeriodEnd><div class=\"form-group col-md-4\"><label translate=ADMIN_VIEW_USER_SUBSCRIPTION_NEXT_CHARGE_LABEL></label><div class=div-field>{{nextBillingDate * 1000 | date:\'MM/dd/yyyy\'}}</div></div><div class=\"form-group col-md-4\"><label translate=ADMIN_VIEW_USER_SUBSCRIPTION_NEXT_CHARGE_AMOUNT_LABEL></label><div class=div-field>{{total | currency: \'$\' : 2}}</div></div></div><div class=form-row ng-show=\"!subscriptionPaused && subscriptionCancelAtPeriodEnd\"><div class=\"form-group col-md-12 center\"><h3 translate=ADMIN_VIEW_USER_SUBSCRIPTION_CANCEL_AT_PERIOD_END_TEXT></h3></div></div><div class=form-row ng-show=\"invoiceList.length > 0\"><div class=\"form-group col-md-12\"><h3 class=sec-heading translate=ADMIN_VIEW_USER_INVOICES_TITLE></h3><table st-table=invoiceListDisplayed st-safe-src=invoiceList ng-class=\"getOrganizationCss(\'table table-striped intry-table\')\"><thead><tr><th st-sort=number class=\"sort-button center\" translate=ADMIN_VIEW_USER_INVOICE_NUMBER_LABEL></th><th st-sort=amount_due class=\"sort-button right\" translate=ADMIN_VIEW_USER_INVOICE_DUE_LABEL></th><th st-sort=amount_paid class=\"sort-button right\" translate=ADMIN_VIEW_USER_INVOICE_PAID_LABEL></th><th st-sort=amount_remaining class=\"sort-button right\" translate=ADMIN_VIEW_USER_INVOICE_REMAINING_LABEL></th><th st-sort=date class=\"sort-button center\" translate=ADMIN_VIEW_USER_INVOICE_DATE_LABEL></th><th st-sort=period_start class=\"sort-button center\" translate=ADMIN_VIEW_USER_INVOICE_PERIOD_START_LABEL></th><th st-sort=period_end class=\"sort-button center\" translate=ADMIN_VIEW_USER_INVOICE_PERIOD_END_LABEL></th><th st-sort=charge class=\"sort-button center\" translate=ADMIN_VIEW_USER_INVOICE_CHARGE_LABEL></th><th st-sort=status class=\"sort-button center\" translate=ADMIN_VIEW_USER_INVOICE_STATUS_LABEL></th></tr></thead><tbody><tr ng-repeat=\"row in invoiceListDisplayed\"><td class=\"capitalize account-details center\" data-title=\"{{\'ADMIN_VIEW_USER_INVOICE_NUMBER_LABEL\' | translate}}\">{{row.number}}</td><td class=\"capitalize account-details right\" data-title=\"{{\'ADMIN_VIEW_USER_INVOICE_DUE_LABEL\' | translate}}\">{{row.amount_due / 100 | currency: \'$\' : 2}}</td><td class=\"capitalize account-details right\" data-title=\"{{\'ADMIN_VIEW_USER_INVOICE_PAID_LABEL\' | translate}}\">{{row.amount_paid / 100 | currency: \'$\' : 2}}</td><td class=\"capitalize account-details right\" data-title=\"{{\'ADMIN_VIEW_USER_INVOICE_REMAINING_LABEL\' | translate}}\">{{row.amount_remaining / 100 | currency: \'$\' : 2}}</td><td class=\"capitalize account-details center\" data-title=\"{{\'ADMIN_VIEW_USER_INVOICE_DATE_LABEL\' | translate}}\">{{row.date * 1000 | date:\'MM/dd/yyyy\'}}</td><td class=\"capitalize account-details center\" data-title=\"{{\'ADMIN_VIEW_USER_INVOICE_PERIOD_START_LABEL\' | translate}}\">{{row.period_start * 1000 | date:\'MM/dd/yyyy\'}}</td><td class=\"capitalize account-details center\" data-title=\"{{\'ADMIN_VIEW_USER_INVOICE_PERIOD_END_LABEL\' | translate}}\">{{row.period_end * 1000 | date:\'MM/dd/yyyy\'}}</td><td class=\"capitalize account-details center\" data-title=\"{{\'ADMIN_VIEW_USER_INVOICE_CHARGE_LABEL\' | translate}}\">{{row.charge}}</td><td class=\"capitalize account-details center\" data-title=\"{{\'ADMIN_VIEW_USER_INVOICE_STATUS_LABEL\' | translate}}\">{{row.status}}</td></tr></tbody></table></div></div><div class=form-row ng-show=\"refundList.length > 0\"><div class=\"form-group col-md-12\"><h3 class=sec-heading translate=ADMIN_VIEW_USER_REFUND_TITLE></h3><table st-table=refundListDisplayed st-safe-src=refundList ng-class=\"getOrganizationCss(\'table table-striped intry-table\')\"><thead><tr><th st-sort=id class=\"sort-button center\" translate=ADMIN_VIEW_USER_REFUND_ID_LABEL></th><th st-sort=amount class=\"sort-button right\" translate=ADMIN_VIEW_USER_REFUND_AMOUNT_LABEL></th><th st-sort=created class=\"sort-button center\" translate=ADMIN_VIEW_USER_REFUND_CREATED_LABEL></th><th st-sort=refund_reason class=\"sort-button left\" translate=ADMIN_VIEW_USER_REFUND_REASON_LABEL></th><th st-sort=receipt_number class=\"sort-button center\" translate=ADMIN_VIEW_USER_REFUND_RECEIPT_NUMBER_LABEL></th><th st-sort=charge class=\"sort-button center\" translate=ADMIN_VIEW_USER_REFUND_CHARGE_LABEL></th><th st-sort=status class=\"sort-button center\" translate=ADMIN_VIEW_USER_REFUND_STATUS_LABEL></th></tr></thead><tbody><tr ng-repeat=\"row in refundListDisplayed\"><td class=\"capitalize account-details center\" data-title=\"{{\'ADMIN_VIEW_USER_REFUND_ID_LABEL\' | translate}}\">{{row.id}}</td><td class=\"capitalize account-details right\" data-title=\"{{\'ADMIN_VIEW_USER_REFUND_AMOUNT_LABEL\' | translate}}\">{{row.amount / 100 | currency: \'$\' : 2}}</td><td class=\"capitalize account-details center\" data-title=\"{{\'ADMIN_VIEW_USER_REFUND_CREATED_LABEL\' | translate}}\">{{row.created * 1000 | date:\'MM/dd/yyyy\'}}</td><td class=\"capitalize account-details left\" data-title=\"{{\'ADMIN_VIEW_USER_REFUND_REASON_LABEL\' | translate}}\">{{refund_reason}}</td><td class=\"capitalize account-details center\" data-title=\"{{\'ADMIN_VIEW_USER_REFUND_RECEIPT_NUMBER_LABEL\' | translate}}\">{{receipt_number}}</td><td class=\"capitalize account-details center\" data-title=\"{{\'ADMIN_VIEW_USER_REFUND_CHARGE_LABEL\' | translate}}\">{{row.charge}}</td><td class=\"capitalize account-details center\" data-title=\"{{\'ADMIN_VIEW_USER_REFUND_STATUS_LABEL\' | translate}}\">{{row.status}}</td></tr></tbody></table></div></div></div></div></div></div><!-- #endregion Subscription --><!-- #region Jobs Data --><div id=jobsDataContainer class=sec-style ng-if=false><div class=inner-sec><h3 class=sec-heading translate=\"Jobs Suggestions\"></h3><br><div class=row><div class=\"col-md-3 job-list-container\"><div class=row ng-repeat=\"job in modelAux.jobs track by $index\"><div class=\"col-md-12 job-title\" ng-class=\"(job.jobID === modelAux.selectedJob.jobID) ? \'job-title-selected\' : \'\';\" ng-click=selectJob($index)>{{job.name}}<br>{{job.percent}}% match</div></div></div><div class=\"col-md-9 job-selected-container\"><div class=row><div class=\"col-md-12 job-description-container\">{{modelAux.selectedJob.description}}<br><br><div class=job-description-subtitle>Company</div>{{modelAux.selectedJob.hiringCompany.name}}<br><br><div class=job-description-subtitle>Location</div>{{modelAux.selectedJob.location.city}}/{{modelAux.selectedJob.location.state}}/{{modelAux.selectedJob.location.country}}<br><br><div class=job-description-subtitle>Posted Date</div>{{modelAux.selectedJob.postedDate | date:\'MM/dd/yyyy hh:mm:ss a\'}}<br></div></div><div class=row><div class=\"col-md-12 job-skills-container\"><div class=row><div class=\"col-md-12 job-skills-title\">Missing Skills</div></div><div class=row><div class=\"col-md-12 job-skills-body\"><div class=row ng-repeat=\"row in modelAux.selectedJob.suggestedSkillsRows\"><div class=col-md-3 ng-repeat=\"skill in row\"><div class=current-checkbox-wrapper><label class=checkbox-btn><input type=checkbox> <span>{{skill}}</span></label></div></div></div></div></div><div class=row><div class=\"col-md-12 job-skills-footer\"><button ng-click=generateResume() class=\"btn-default btn-transparent nowrap\" ng-show=\"(action === \'view\')\"><strong translate=\"Genererate Resume\"></strong></button></div></div></div></div></div></div></div></div><!-- #endregion Jobs Data --><!-- #region Notes Data --><div id=notesDataContainer class=sec-style ng-if=\"action === \'view\'\"><div class=inner-sec><h3 class=sec-heading translate=\"Admin Notes (Latest 10 records)\"></h3><table st-table=notesDisplayed st-safe-src=notes ng-class=\"getOrganizationCss(\'table table-striped intry-table\')\"><thead><tr><th style=\"width: 1px; white-space: nowrap\" translate=Date></th><th translate=Note></th></tr></thead><tbody><tr ng-repeat=\"row in notesDisplayed\"><td style=\"width: 1px; white-space: nowrap\">{{row.created | date:\'MM/dd/yyyy hh:mm:ss a\'}}</td><td>{{row.note}}</td></tr></tbody></table></div></div><!-- #endregion Notes Data --><!-- #region Unemployed Notes Data --><div id=unemployedNotesDataContainer class=sec-style ng-if=\"action === \'view\'\"><div class=inner-sec><h3 class=sec-heading translate=\"Work Log (Latest 10 records)\"></h3><table st-table=unemployedNotesDisplayed st-safe-src=unemployedNotes ng-class=\"getOrganizationCss(\'table table-striped intry-table\')\"><thead><tr><th translate=Created></th><th translate=UNEMPLOYED_NOTES_RESUME_HEAD_TEXT></th><th translate=UNEMPLOYED_NOTES_JOB_COMPANY_HEAD_TEXT></th><th translate=UNEMPLOYED_NOTES_CONTACT_NAME_HEAD_TEXT></th><th translate=UNEMPLOYED_NOTES_JOB_EMAIL_HEAD_TEXT></th><th translate=UNEMPLOYED_NOTES_SEND_DATE_HEAD_TEXT></th><th translate=UNEMPLOYED_NOTES_NOTE_HEAD_TEXT></th></tr></thead><tbody><tr ng-repeat=\"row in unemployedNotesDisplayed\"><td class=\"capitalize account-details\">{{row.created | date:\'MM/dd/yyyy hh:mm:ss a\'}}</td><td class=\"capitalize account-details\">{{row.resumeTitle}}</td><td class=\"capitalize account-details\">{{row.companyName}}</td><td class=\"capitalize account-details\">{{row.contactName}}</td><td class=\"capitalize account-details\">{{row.contactEmail}}</td><td class=\"capitalize account-details\">{{row.sendDate | date:\'MM/dd/yyyy\'}}</td><td class=\"capitalize account-details\">{{row.lastNote}}</td></tr></tbody></table></div></div><!-- #endregion Unemployed Notes Data --><!-- #region Tracks Data --><div id=tracksDataContainer class=sec-style ng-if=\"action === \'view\'\"><div class=inner-sec><h3 class=sec-heading translate=\"Log (Latest 10 records)\"></h3><table st-table=tracksDisplayed st-safe-src=tracks ng-class=\"getOrganizationCss(\'table table-striped intry-table\')\"><thead><tr><th style=\"width: 1px; white-space: nowrap\" translate=Date></th><th translate=Event></th></tr></thead><tbody><tr ng-repeat=\"row in tracksDisplayed\"><td style=\"width: 1px; white-space: nowrap\">{{row.created | date:\'MM/dd/yyyy hh:mm:ss a\'}}</td><td class=\"capitalize account-details trackActionKey {{row.actionKey}}\"><span class=trackActionKeyError uib-tooltip={{row.msg}} ng-show=row.error>(ERROR) </span>{{row.actionName}}</td></tr></tbody></table></div></div><!-- #endregion Tracks Data --><!-- #region Submit Button --><div ng-class=\"getOrganizationCss(\'find-fit-btn profile-cta-btn submit-buttons-container force-right find-fit-btn-left\')\" ng-show=\"(action !== \'view\')\"><button ng-click=save() ng-class=\"getOrganizationCss(\'btn-default\')\"><strong translate=ADMIN_INVITE_USER_BUTTON_TEXT ng-show=\"(action === \'create\')\"></strong> <strong translate=ADMIN_CREATE_BUTTON_TEXT ng-show=\"(action === \'update\')\"></strong></button> <button ng-click=updateCancel() style=\"margin-top: 0; margin-left: 2vw\" ng-class=\"getOrganizationCss(\'btn-default\')\" ng-show=\"(action === \'update\')\"><strong translate=ADMIN_CANCEL_BUTTON_TEXT></strong></button></div><!--\n	    <div class=\"find-fit-btn profile-cta-btn submit-buttons-container\" ng-show=\"(action === \'view\')\">\n	      <button ng-click=\"update()\" class=\"btn-default\">\n		<strong translate=\"ADMIN_EDIT_BUTTON_TEXT\"></strong>\n	      </button>\n	    </div>\n	    --> <button id=submit_validation_sidebar ng-click=save() ng-class=\"getOrganizationCss(\'sidebar-save-btn\')\" ng-show=\"(action !== \'view\')\"><span translate=ADMIN_INVITE_USER_BUTTON_TEXT ng-show=\"(action === \'create\')\"></span> <span translate=ADMIN_CREATE_SIDEBAR_BUTTON_TEXT ng-show=\"(action === \'update\')\"></span></button><!-- #endregion Submit Button --><!-- #region Validation Data --><div class=\"inner-sec validation-container\" ng-show=\"errors.length > 0\"><div class=\"exp-form form-styles\"><div class=form-row ng-repeat=\"error in errors track by $index\"><div class=\"form-group col-md-12 validation-col\"><i class=material-icons>error</i><label>{{error}}</label></div></div></div></div><!-- #endregion Validation Data --></div></div></div></section><!-- Refund Modal --><div id=refundModal class=\"modal modal-wide refund-modal\" tabindex=-1 role=dialog ng-show=showRefundModal><div class=\"modal-dialog modal-dialog-centered\" role=document><div class=modal-content><div class=modal-header><h3 translate=ADMIN_VIEW_USER_CANCEL_SUBSCRIPTION_MODAL_TITLE></h3><button type=button class=close aria-label=Close ng-click=\"showRefundModal = false;\"><img src=/media/images/close.svg alt=close class=img-fluid></button></div><div class=modal-body><div class=\"exp-form form-styles\"><div class=form-row><div class=\"form-group col-sm-6 div-field\"><input name=refundOption type=radio ng-click=updateRefundOption(0) checked><label translate=ADMIN_VIEW_USER_CANCEL_SUBSCRIPTION_MODAL_CALCULATED_REFUND_LABEL></label></div><div class=\"form-group col-sm-6\"><div class=div-field>{{refundAmountCalculated | currency: \'$\' : 2}}</div></div></div><div class=form-row><div class=\"form-group col-sm-6 div-field\"><input name=refundOption type=radio ng-click=updateRefundOption(1)><label translate=ADMIN_VIEW_USER_CANCEL_SUBSCRIPTION_MODAL_CUSTOM_REFUND_LABEL></label></div><div class=\"form-group col-sm-6\"><input ng-model=refundAmount required type=text class=form-control ng-disabled=\"refundOption !== 1\"></div></div><div class=\"form-row form-row-buttons\"><div class=\"form-group col-md-6 padding-right-10\"><button ng-click=refundCancel(0) class=\"btn-default btn-transparent nowrap width-100\" ng-disabled=!validateRefund()><strong translate=ADMIN_VIEW_USER_CANCEL_SUBSCRIPTION_MODAL_REFUND_CANCEL_BTN_LABEL></strong></button></div><div class=\"form-group col-md-6 padding-left-10\"><button ng-click=refundCancel(1) class=\"btn-default btn-transparent nowrap width-100\"><strong translate=ADMIN_VIEW_USER_CANCEL_SUBSCRIPTION_MODAL_CANCEL_BTN_LABEL></strong></button></div></div></div></div></div></div></div><div id=waitDiv style=\"background-color:#4b4444; display: none; left: 0px; height: 100%; position: fixed; opacity: .5; top: 0px; width: 100%; z-index: 10000\"></div>");
$templateCache.put("app/admin/createadmin/template/create.html","<nav-bar-admin></nav-bar-admin><section class=\"main-sec full-height-content admin-form-sec\"><div class=header-data><div class=\"container big-margin-bottom\"><div class=\"user-info-sec admin-info-sec\"><!-- Personal Data --><div class=sec-style><div class=inner-sec><div class=form-row><div class=\"form-group col-md-8\"><h6 class=sec-heading ng-show=\"(action === \'create\')\">{{getTitle(\'ADMIN_CREATE_ADMIN_TEXT\')}}</h6><h6 class=sec-heading ng-show=\"(action === \'view\')\">{{getTitle(\'ADMIN_VIEW_ADMIN_TEXT\')}}</h6><h6 class=sec-heading ng-show=\"(action === \'update\')\">{{getTitle(\'ADMIN_UPDATE_ADMIN_TEXT\')}}</h6></div><div class=\"form-group col-md-4 right\"><button ng-click=update() class=\"btn-default btn-transparent nowrap\" ng-show=\"(action === \'view\')\" style=\"float: right\"><strong translate=ADMIN_EDIT_BUTTON_TEXT></strong></button></div></div><div id=personalDataContainer class=\"user-exp-sec form-styles\"><div class=\"exp-form form-styles\"><div class=form-row><div class=\"form-group col-md-6\"><label translate=ADMIN_CREATE_ADMIN_FIRST_NAME_LABEL_TEXT></label><input ng-model=model.first_name type=text class=form-control></div><div class=\"form-group col-md-6\"><label translate=ADMIN_CREATE_ADMIN_LAST_NAME_LABEL_TEXT></label><input ng-model=model.last_name type=text class=form-control></div></div><div class=form-row ng-show=!isProfile><div class=\"form-group col-md-6\"><label translate=ADMIN_CREATE_ADMIN_USERNAME_LABEL_TEXT></label><input ng-model=model.username type=text class=form-control></div><div class=\"form-group col-md-6\" ng-show=\"(action === \'view\') || (action === \'update\')\"><label translate=ADMIN_CREATE_ADMIN_STATUS_LABEL_TEXT></label><div class=select-style><select ng-model=model.status ng-disabled=!canEditRole(model.username) ng-options=\"x.key as x.label for x in userStatus\" class=\"form-control form-select\" required></select></div></div></div><div class=form-row ng-show=\"(action === \'create\') || (action === \'update\')\"><div class=\"form-group col-md-6\"><label for=exp-position translate=ADMIN_CREATE_ADMIN_PASSWORD_LABEL_TEXT></label><input ng-model=model.password required type=password class=form-control></div><div class=\"form-group col-md-6\"><label for=exp-position translate=ADMIN_CREATE_ADMIN_RETYPE_PASSWORD_LABEL_TEXT></label><input ng-model=retypepwd required type=password class=form-control></div></div><div class=form-row ng-show=\"(action === \'view\') && checkRole([\'ROLE_USER_ADMIN\'])\"><div class=\"form-group col-md-6\" ng-show=\"(action === \'view\') && (showSignupCode === true)\"><label>SIGNUP CODE</label><div>xd <span class=signupcode_code>{{signupCodeInfo.code}}</span>&nbsp;&nbsp;<span class=signupcode_expiration>({{signupCodeInfo.expiration}})</span></div></div></div><div class=form-row ng-show=\"checkRole([\'ROLE_APP_ADMIN\', \'ROLE_ORGANIZATION_ADMIN\'])\"><div class=\"form-group col-md-6\" ng-show=\"checkRole([\'ROLE_APP_ADMIN\'])\"><label translate=ADMIN_CREATE_ORGANIZATION_KEY_LABEL_TEXT></label><div class=select-style><select ng-show=\"model.role !== \'ROLE_APP_ADMIN\'\" ng-model=model.organizationKey ng-options=\"x for x in organizationKeys\" class=\"form-control form-select\" required><option value=\"\">Without Organization</option></select></div></div><div class=\"form-group col-md-6\" ng-show=\"(action === \'view\')\"><label translate=ADMIN_CREATE_ROLE_LABEL_TEXT></label><div class=select-style><input value=\"{{model.role | translate}}\" type=text class=form-control></div></div><div class=\"form-group col-md-6\" ng-show=\"(action === \'view\') && (showSignupCode === true)\"><label>SIGNUP CODE</label><div><span class=signupcode_code>{{signupCodeInfo.code}}</span>&nbsp;&nbsp;<span class=signupcode_expiration>({{signupCodeInfo.expiration}})</span></div></div><div class=\"form-group col-md-6\" ng-show=\"(action === \'update\') || (action === \'create\')\"><label translate=ADMIN_CREATE_ROLE_LABEL_TEXT></label><div class=select-style><select ng-disabled=\"(action === \'update\') && !canEditRole()\" ng-model=selectedRole ng-options=\"role.name for role in availableRoles() track by role.role\" class=\"form-control form-select\" required></select></div></div></div><!-- <div class=\"form-row\" ng-show=\"model.role !== \'ROLE_APP_ADMIN\'\">\n                  <div class=\"form-group col-md-6\"\n                  ng-show=\"(action === \'view\') && checkRole([\'ROLE_APP_ADMIN\'])\">\n               <label translate=\"ADMIN_SECTION_ADMINS_LOCATION_KEY_HEAD_TEXT\"></label>\n               <div class=\"select-style\">\n                 <input ng-model=\"model.location\" type=\"text\"\n                        class=\"form-control\">\n               </div>\n             </div>\n             <div class=\"form-group col-md-6\"\n                  ng-show=\"(action === \'update\') && checkRole([\'ROLE_APP_ADMIN\'])\"\n                  ng-disabled=\"model.role === \'ROLE_APP_ADMIN\'\">\n               <label translate=\"ADMIN_SECTION_ADMINS_LOCATION_KEY_HEAD_TEXT\"></label>\n               <div class=\"select-style\">\n                <select ng-show=\"model.role !== \'ROLE_APP_ADMIN\'\"\n                ng-model=\"model.location\"\n                ng-options=\"x.id as x.location for x in locationKeys\"\n                class=\"form-control form-select\" required>\n          <option value=\"\">Without Location</option>\n          \n        </select>\n               </div>\n             </div>\n                  <div class=\"form-group col-md-6\"\n                       ng-show=\"(action === \'view\') && checkRole([\'ROLE_APP_ADMIN\'])\">\n                    <label translate=\"Owner\"></label>\n                    <div class=\"select-style\">\n                      <input ng-model=\"model.belongsToObj.username\" type=\"text\"\n                             class=\"form-control\">\n                    </div>\n                  </div>\n                  <div class=\"form-group col-md-6\"\n                       ng-show=\"(action === \'update\') && checkRole([\'ROLE_APP_ADMIN\'])\"\n                       ng-disabled=\"model.role === \'ROLE_APP_ADMIN\'\">\n                    <label translate=\"ADMIN_CREATE_BELONGS_TO_LABEL_TEXT\"></label>\n                    <div class=\"select-style\">\n                      <input ng-model=\"model.belongsTo\" type=\"text\" class=\"form-control\">\n                    </div>\n                  </div>\n          \n                </div> --></div></div></div></div><!-- Submit Button --><div ng-class=\"getOrganizationCss(\'find-fit-btn profile-cta-btn submit-buttons-container\')\" ng-show=\"(action !== \'view\')\"><button ng-click=save() ng-class=\"getOrganizationCss(\'btn-default\')\"><strong translate=ADMIN_CREATE_BUTTON_TEXT></strong></button> <button ng-click=updateCancel() ng-class=\"getOrganizationCss(\'btn-default\')\" ng-show=\"(action === \'update\')\"><strong translate=ADMIN_CANCEL_BUTTON_TEXT></strong></button> <button ng-click=createCancel() ng-class=\"getOrganizationCss(\'btn-default\')\" ng-show=\"(action === \'create\')\"><strong translate=ADMIN_CANCEL_BUTTON_TEXT></strong></button></div><button id=submit_validation_sidebar ng-click=save() ng-class=\"getOrganizationCss(\'sidebar-save-btn\')\" ng-show=\"(action !== \'view\')\" translate=ADMIN_ADMIN_CREATE_SIDEBAR_BUTTON_TEXT></button><!-- Validation Data --><div class=\"inner-sec validation-container\" ng-show=\"errors.length > 0\"><div class=\"exp-form form-styles\"><div class=form-row ng-repeat=\"error in errors track by $index\"><div class=\"form-group col-md-12 validation-col\"><i class=material-icons>error</i><label>{{error}}</label></div></div></div></div></div></div></div></section>");
$templateCache.put("app/admin/createorganization/template/create.html","<nav-bar-admin></nav-bar-admin><section class=\"main-sec full-height-content admin-form-sec\"><div class=header-data><div class=\"container big-margin-bottom\"><div class=\"user-info-sec admin-info-sec\"><div class=sec-style><div class=inner-sec><div class=form-row><div class=\"form-group col-md-8\"><h6 class=sec-heading translate=ADMIN_CREATE_ORGANIZATION_TEXT ng-show=\"(action === \'create\')\"></h6><h6 class=sec-heading translate=ADMIN_VIEW_ORGANIZATION_TEXT ng-show=\"(action === \'view\')\"></h6><h6 class=sec-heading translate=ADMIN_UPDATE_ORGANIZATION_TEXT ng-show=\"(action === \'update\')\"></h6></div><div class=\"form-group col-md-4 right\"><button ng-click=update() class=\"btn-default btn-transparent nowrap\" ng-show=\"(action === \'view\')\" style=\"float: right\"><strong translate=ADMIN_EDIT_BUTTON_TEXT></strong></button></div></div><div id=personalDataContainer class=\"user-exp-sec form-styles\"><div class=\"exp-form form-styles\"><div class=form-row><div class=\"form-group col-md-6\"><label translate=ORGANIZATION_CREATE_ORGANIZATION_KEY_LABEL_TEXT></label><input ng-model=model.organizationKey type=text class=form-control></div><div class=\"form-group col-md-6\"><label translate=ORGANIZATION_CREATE_ORGANIZATION_NAME_LABEL_TEXT></label><input ng-model=model.name type=text class=form-control></div></div><div class=form-row><div class=\"form-group col-md-6\"><label translate=ORGANIZATION_CREATE_ORGANIZATION_HOSTNAME_LABEL_TEXT></label><input ng-model=model.hostname type=text class=form-control></div><div class=\"form-group col-md-6\"><label translate=ORGANIZATION_CREATE_ORGANIZATION_SEND_EMAIL_BASE_PATH_LABEL_TEXT></label><input ng-model=model.sendEmailBasePath type=text class=form-control></div></div><div class=form-row><div class=\"form-group col-md-6\"><label translate=ORGANIZATION_CREATE_ORGANIZATION_DEFAULT_USER_COUPON_LABEL_TEXT></label><input ng-model=model.defaultUserCoupon type=text class=form-control></div><div class=\"form-group col-md-6\"><label translate=ORGANIZATION_CREATE_ORGANIZATION_SELF_REGISTRATION_LABEL_TEXT></label><div class=select-style><select ng-model=model.selfRegistration ng-options=\"x.key as x.label for x in recordDeleted\" class=\"form-control form-select\"></select></div></div></div><div class=form-row><div class=\"form-group col-md-6\" ng-show=\"(action === \'view\') || (action === \'update\')\"><label translate=ORGANIZATION_CREATE_ORGANIZATION_STATUS_LABEL_TEXT></label><div class=select-style><select ng-model=model.status ng-options=\"x.key as x.label for x in recordStatus\" class=\"form-control form-select\"><option value=\"\">Select</option></select></div></div><div class=\"form-group col-md-6\" ng-show=\"(action === \'view\') || (action === \'update\')\"><label translate=ORGANIZATION_CREATE_ORGANIZATION_DELETED_LABEL_TEXT></label><div class=select-style><select ng-model=model.deleted ng-options=\"x.key as x.label for x in recordDeleted\" class=\"form-control form-select\"></select></div></div></div></div></div></div></div><!-- <div id=\"locations\" class=\"sec-style\" ng-if=\"action === \'view\'\">\n          <div class=\"inner-sec\">\n            <h3 class=\"sec-heading\" translate=\"Locations\"></h3>\n            <br />\n            <div class=\"form-row\">\n              <div class=\"form-group col-md-12\">\n          <div class=\"text-container\">\n            <span class=\"user-exp-sec form-styles location\"\n            ng-repeat=\"location in locationKeys\">\n              {{location.location}}\n            </span>\n          </div>\n              </div>\n              \n              <button ng-class=\"getOrganizationCss(\'add-new-sec\')\" ng-show=\"!addLocation\" ng-click=\"addNewLocationButton()\">Add\n                                                New Location</button>\n            </div>\n            <div class=\"exp-form form-styles\" ng-show=\"addLocation\">\n              <div class=\"form-row\">\n                <div class=\"form-group col-md-6\">\n                  <label translate=\"Location\"></label>\n                  <input ng-model=\"newLocation\" type=\"text\" class=\"form-control\">\n                </div>\n              \n              </div>\n              <div class=\"find-fit-btn profile-cta-btn submit-buttons-container\" >\n                <button  ng-class=\"getOrganizationCss(\'btn-default\')\">\n                  <strong translate=\"Add\"></strong>\n                </button>\n                <button ng-click=\"closeNewLocationButton()\" ng-class=\"getOrganizationCss(\'btn-default\')\"\n                        >\n                  <strong translate=\"ADMIN_CANCEL_BUTTON_TEXT\"></strong>\n                </button>\n              </div>\n             \n          \n         \n            </div>\n          </div>\n        </div> --><!-- Submit Button --><div class=\"find-fit-btn profile-cta-btn submit-buttons-container\" ng-show=\"(action !== \'view\')\"><button ng-click=save() ng-class=\"getOrganizationCss(\'btn-default\')\"><strong translate={{saveButtonLabel}}></strong></button> <button ng-click=updateCancel() ng-class=\"getOrganizationCss(\'btn-default\')\" ng-show=\"(action === \'update\')\"><strong translate=ADMIN_CANCEL_BUTTON_TEXT></strong></button></div><button id=submit_validation_sidebar ng-click=save() ng-class=\"getOrganizationCss(\'sidebar-save-btn\')\" ng-show=\"(action !== \'view\')\" translate={{sidenavButtonLabel}}></button><!-- Validation Data --><div class=\"inner-sec validation-container\" ng-show=\"errors.length > 0\"><div class=\"exp-form form-styles\"><div class=form-row ng-repeat=\"error in errors track by $index\"><div class=\"form-group col-md-12 validation-col\"><i class=material-icons>error</i><label>{{error}}</label></div></div></div></div></div></div></div></section>");
$templateCache.put("app/admin/createutm/template/create.html","<nav-bar-admin></nav-bar-admin><section class=\"main-sec full-height-content admin-form-sec\"><div class=header-data><div class=\"container big-margin-bottom\"><div class=\"user-info-sec admin-info-sec\"><div class=sec-style><div class=inner-sec><div class=form-row><div class=\"form-group col-md-8\"><h6 class=sec-heading translate=ADMIN_CREATE_UTM_TEXT ng-show=\"(action === \'create\')\"></h6><h6 class=sec-heading translate=ADMIN_VIEW_UTM_TEXT ng-show=\"(action === \'view\')\"></h6><h6 class=sec-heading translate=ADMIN_UPDATE_UTM_TEXT ng-show=\"(action === \'update\')\"></h6></div><div class=\"form-group col-md-4 right\"><button ng-click=update() class=\"btn-default btn-transparent nowrap\" ng-show=\"(action === \'view\')\"><strong translate=ADMIN_EDIT_BUTTON_TEXT></strong></button></div></div><div id=personalDataContainer class=\"user-exp-sec form-styles\"><div class=\"exp-form form-styles\"><div class=form-row><div class=\"form-group col-md-6\"><label translate=UTM_CREATE_UTM_NAME_LABEL_TEXT></label><input ng-model=model.name type=text class=form-control></div><div class=\"form-group col-md-6\"><label translate=UTM_CREATE_UTM_SOURCE_LABEL_TEXT></label><input ng-model=model.utmSource type=text class=form-control></div></div><div class=form-row><div class=\"form-group col-md-6\"><label translate=UTM_CREATE_UTM_MEDIUM_LABEL_TEXT></label><input ng-model=model.utmMedium type=text class=form-control></div><div class=\"form-group col-md-6\"><label translate=UTM_CREATE_UTM_CAMPAIGN_LABEL_TEXT></label><input ng-model=model.utmCampaign type=text class=form-control></div></div><div class=form-row><div class=\"form-group col-md-6\"><label translate=UTM_CREATE_POSTBACK_METHOD_LABEL_TEXT></label><input ng-model=model.postbackMethod type=text class=form-control></div><div class=\"form-group col-md-6\"><label translate=UTM_CREATE_POSTBACK_PATH_LABEL_TEXT></label><input ng-model=model.postbackPath type=text class=form-control></div></div><div class=form-row><div class=\"form-group col-md-6\"><label translate=UTM_CREATE_DESCRIPTION_LABEL_TEXT></label><textarea ng-model=model.description class=form-control></textarea></div></div><div class=form-row><div class=\"form-group col-md-6\" ng-show=\"(action === \'view\') || (action === \'update\')\"><label translate=UTM_CREATE_UTM_STATUS_LABEL_TEXT></label><div class=select-style><select ng-model=model.status ng-options=\"x.key as x.label for x in recordStatus\" class=\"form-control form-select\"><option value=\"\">Select</option></select></div></div><div class=\"form-group col-md-6\" ng-show=\"(action === \'view\') || (action === \'update\')\"><label translate=UTM_CREATE_UTM_DELETED_LABEL_TEXT></label><div class=select-style><select ng-model=model.deleted ng-options=\"x.key as x.label for x in recordDeleted\" class=\"form-control form-select\"></select></div></div></div></div></div></div></div><!-- Submit Button --><div ng-class=\"getOrganizationCss(\'find-fit-btn profile-cta-btn submit-buttons-container\')\" ng-show=\"(action !== \'view\')\"><button ng-click=save() ng-class=\"getOrganizationCss(\'btn-default\')\"><strong translate={{saveButtonLabel}}></strong></button> <button ng-click=updateCancel() ng-class=\"getOrganizationCss(\'btn-default\')\" ng-show=\"(action === \'update\')\"><strong translate=ADMIN_CANCEL_BUTTON_TEXT></strong></button></div><button id=submit_validation_sidebar ng-click=save() ng-class=\"getOrganizationCss(\'sidebar-save-btn\')\" ng-show=\"(action !== \'view\')\" translate={{sidenavButtonLabel}}></button><!-- Validation Data --><div class=\"inner-sec validation-container\" ng-show=\"errors.length > 0\"><div class=\"exp-form form-styles\"><div class=form-row ng-repeat=\"error in errors track by $index\"><div class=\"form-group col-md-12 validation-col\"><i class=material-icons>error</i><label>{{error}}</label></div></div></div></div></div></div></div></section>");
$templateCache.put("app/admin/dashboard/template/dashboard.html","<nav-bar-admin></nav-bar-admin><section class=main-sec><div class=\"container pagination-container big-margin-bottom\"><div><div ng-class=\"getOrganizationCss(\'buttons-container-stats\')\"><button class=refresh onclick=location.reload()><img src=media/icons/refresh.png></button><select class=template-name ng-model=smallStatSelected ng-options=\"statObj.title for statObj in stats\" ng-change=changeSmallStat()></select></div><div class=stats-container-small><div class=stat-small><h2>{{smallStatSelected.stats[\'user-subscribe-invitation-org\'].actionName}}</h2><h3>{{smallStatSelected.stats[\'user-subscribe-invitation-org\'].count}}</h3></div><div class=stat-small><h2>{{smallStatSelected.stats[\'assessment-create\'].actionName}}</h2><h3>{{smallStatSelected.stats[\'assessment-create\'].count}}</h3></div><div class=stat-small><h2>{{smallStatSelected.stats[\'resume-parse\'].actionName}}</h2><h3>{{smallStatSelected.stats[\'resume-parse\'].count}}</h3></div><div class=stat-small><h2>{{smallStatSelected.stats[\'resume-j2r\'].actionName}}</h2><h3>{{smallStatSelected.stats[\'resume-j2r\'].count}}</h3></div><div class=stat-small><h2>{{smallStatSelected.stats[\'resume-downloaded\'].actionName}}</h2><h3>{{smallStatSelected.stats[\'resume-downloaded\'].count}}</h3></div><div class=stat-small><h2>{{smallStatSelected.stats[\'unemployed-report-downloaded\'].actionName}}</h2><h3>{{smallStatSelected.stats[\'unemployed-report-downloaded\'].count}}</h3></div></div><div class=stats-container-small><div class=stat-big><div ng-class=\"getOrganizationCss(\'buttons-container-stats\')\"><h2>{{getOrganizationName()}} Activity</h2><select class=template-name ng-model=statActivityChart ng-options=\"statObj.title for statObj in statsCharts\" ng-change=changeActivityChart()></select></div><div class=chart><canvas id=activity-mix-chart></canvas></div></div><div class=stat-medium><h2>Since {{boxScore.periodStart}}</h2><div class=row2><h3>Users Created</h3><h4>{{boxScore.totalUsersCreated}}</h4></div><div class=row2><h3>Users Active Now</h3><h4>{{boxScore.usersActiveNow}}</h4></div><div class=row2><h3>Users Marked Inactive</h3><h4>{{boxScore.usersMarkedInactive}}</h4></div><div class=row2><h3>Users Inactive Now</h3><h4>{{boxScore.usersInactiveNow}}</h4></div><div class=row2><h3>Total Assessments</h3><h4>{{boxScore.totalAssessments}}</h4></div><div class=row2><h3>Users With Assessments</h3><h4>{{boxScore.usersWithAssessments}}</h4></div><div class=row2><h3>Average Assessments/User</h3><h4>{{boxScore.averageAssessmentsPerUser}}</h4></div><div class=row2><h3>Average Assessments/User With Assessment</h3><h4>{{boxScore.averageAssessmentsPerAssessedUser}}</h4></div><div class=row2><h3>Average Days Active</h3><h4>{{boxScore.averageDaysActive}}</h4></div></div></div><div class=stats-container-small><div class=stat-big><div ng-class=\"getOrganizationCss(\'buttons-container-stats\')\"><h2>Assessments</h2><select class=template-name ng-model=statAssessmentChart ng-options=\"statObj.title for statObj in statsCharts\" ng-change=changeAssessmentChart()></select></div><div class=chart><canvas id=assessment-mix-chart></canvas></div></div><!-- (((NOT YET)))\n        <div class=\"stat-medium\">\n          <h2>Users by Location</h2>\n          <canvas id=\"pie-chart\" ></canvas>\n        </div>\n      </div>\n(((END NOT YET))) --><!-- (((NOT YET)))\n      <div class=\"stats-container-small\">\n        <div class=\"stat-big\" style=\"width: 100%;\">\n          <div ng-class=\"getOrganizationCss(\'buttons-container-stats\')\">\n            <h2>Case Managers</h2>\n            <select class=\"template-name\" ng-model=\"statCaseManagerChart\" ng-options=\"statObj for statObj in months\" ng-change=\"changeActivityChart()\" >\n            </select>\n          </div>\n          <div class=\"chart\">\n            <canvas id=\"case-managers-chart\" ></canvas>\n          </div>\n        </div>\n      </div>\n(((END NOT YET))) --></div></div></div></section>");
$templateCache.put("app/admin/details/template/details.html","<div class=admin-details><div ng-class=\'scrimPageBackground ? \"scrim\": \"\"\'><nav-bar-admin user=user></nav-bar-admin><div class=page-header-intry><div class=background-image></div></div><div class=page-content-intry><div class=navigation-links><a href=javascript: ng-click=toUsers() translate=ADMIN_DETAILS_NAVIGATION_USERS_TEXT></a> <span>></span> <a href=javascript: ng-click=toDetails() class=current translate=ADMIN_DETAILS_NAVIGATION_DETAILS_TEXT></a></div><div class=clear></div><div class=top-div><div class=account-basics><div class=\"account capitalize\"><div><img ng-src={{vm.profilePicture}} class=head-shot ng-if=vm.profilePicture></div><div class=\"align-center horizontal-border-bottom padding-bottom-10\"><span class=account-values>{{vm.user.account.account_type}}</span> <span class=account-heading translate=ADMIN_DETAILS_ACCOUNT_HEADING_TEXT></span></div><div class=\"align-center account-status\"><span class=account-values>{{vm.user.status}}</span> <span class=account-heading translate=ADMIN_DETAILS_ACCOUNT_STATUS_TEXT></span></div></div><form name=createUserForm class=form-data></form><table class=parent-table><tr><td><div class=basics><div class=\"basics-data padding-top-20\"><div contenteditable=true admineditable ng-model=model.first_name ng-class=\"{\'control-error\': controlError[0]}\" class=name id=first_name></div>&nbsp;<div contenteditable=true admineditable ng-model=model.last_name ng-class=\"{\'control-error\': controlError[1]}\" class=name id=last_name></div><div class=\"padding-top-10 padding-right-10 pull-right\" ng-show=dataSaved>User has been updated</div></div><div class=\"basics-data padding-top-20 user-account uppercase\"><div admineditable ng-model=model.account_name class=\"other-data-values account-name\"></div></div><div class=\"basics-data padding-bottom-20 uppercase\"><div ng-repeat=\"addy in vm.user.addresses\"><span class=address-display>{{addy.street}},&nbsp;<span ng-if=\"addy.street_2 != \'\'\">{{addy.street_2}},&nbsp;</span>{{addy.city}},&nbsp;{{addy.state}},&nbsp;{{addy.postal_code}}</span></div></div><div class=horizontal-border-bottom></div><div class=basics-data><table id=user-details><tr><td class=other-data translate=ADMIN_DETAILS_EMAIL_TEXT></td><td class=other-data-values><div ng-class=\"{\'control-error\': controlError[2]}\" contenteditable=true admineditable ng-model=model.email_address class=\"other-data-values email\" id=email_address></div></td><td class=other-data translate=ADMIN_DETAILS_TYPE_TEXT></td><td class=other-data-values><div admineditable ng-model=model.user_type></div></td></tr><tr><td class=other-data translate=ADMIN_DETAILS_PHONE_NUMBERS_TEXT></td><td class=other-data-values><div ng-class=\"{\'control-error\': controlError[3]}\" id=phone_number contenteditable=true admineditable ng-model=model.phone_number class=phone-number></div></td><td class=other-data translate=ADMIN_DETAILS_SUBSCRIPTIONS_TEXT></td><td><select ng-model=model.subscription_type ng-options=\"x for x in subscription_types\" class=\"subscription-type capitalize\"></select></td></tr><tr><td class=other-data translate=ADMIN_DETAILS_LAST_LOGIN_TEXT></td><td class=other-data-values translate=ADMIN_DETAILS_NOT_APPLICABLE_TEXT></td><td class=other-data translate=ADMIN_DETAILS_CREATED_TEXT></td><td class=other-data-values>{{created_date * 1000 | date:\'MM/dd/yyyy\'}}</td></tr><tr><td class=other-data translate=ADMIN_DETAILS_TIME_ZONE_TEXT></td><td class=other-data-values translate=ADMIN_DETAILS_NOT_APPLICABLE_TEXT></td><td class=other-data translate=ADMIN_DETAILS_SOURCE_TEXT></td><td class=other-data-values><div admineditable ng-model=model.source class=source></div></td></tr><tr><td class=other-data translate=ADMIN_DETAILS_NEXT_BILLING_DATE_TEXT></td><td class=other-data-values>{{next_billing_date * 1000 | date:\'MM/dd/yyyy\'}}</td><td class=other-data translate=ADMIN_DETAILS_PROFILE_SCORE_TEXT></td><td class=other-data-values translate=ADMIN_DETAILS_NOT_APPLICABLE_TEXT></td></tr></table></div></div></td></tr></table></div></div><div class=save-button-div><button class=\"btn btn-default pull-right\" ng-click=save() translate=ADMIN_CREATE_SAVE_BUTTON_TEXT></button></div></div></div></div>");
$templateCache.put("app/admin/organizations/template/organizations.html","<nav-bar-admin></nav-bar-admin><section class=\"main-sec full-height-content\"><div class=header-data><div class=\"container pagination-container big-margin-bottom\"><!--\n	  <div class=\"user-info-sec\">\n	    --><div ng-class=\"getOrganizationCss(\'admin-user-info-sec\')\"><div class=not-border-bottom><div class=\"inner-sec pagination-inner-sec\"><div class=\"row2 admin-users-title-container\"><div><button ng-click=requestCreate() ng-class=\"getOrganizationCss(\'add-btn\')\"><h2>Add Org.</h2></button></div></div><div class=\"row2 form-styles admin-search-form margin-bottom\"><div class=\"col-lg-2 col-md-2 padding-right-zero\" ng-show=false><div class=select-style><select ng-model=filterField ng-options=\"x.key as x.label for x in recordFilterFields\" class=\"form-control form-select\" ng-change=checkFtypes()></select></div></div><div class=\"col-lg-2 col-md-2 padding-right-zero\" ng-show=false><div class=select-style><select ng-model=ftype ng-options=\"x.key as x.label for x in ftypes\" class=\"form-control form-select\"></select></div></div><div class=search><img src=media/icons/search.png><div class=padding-right-zero><input ng-model=paginationFilter type=text placeholder=\"{{\'ADMIN_SECTION_ORGANIZATION_FILTER_PLACEHOLDER_TEXT\' | translate}}\" class=search-bar></div></div><div><button ng-click=search() ng-class=\"getOrganizationCss(\'search-btn\')\">Search</button></div></div><div class=row2><div class=\"col-md-12 overflow-x-auto\" style=\"padding: 0 !important\"><table st-table=records st-pipe=getRecords ng-class=\"getOrganizationCss(\'table table-striped intry-table\')\"><thead><tr><th ng-repeat=\"field in rawRecordsFields\" ng-show={{field.show}} st-sort={{field.key}} class=\"padding-left sort-button\" translate={{field.translate}}></th><th class=\"text-align-right padding-right\" translate={{ADMIN_SECTION_ADMINS_ACTIONS_HEAD_TEXT}}></th></tr></thead><tbody ng-show=!isLoading><tr ng-repeat=\"row in records\"><td ng-repeat=\"field in rawRecordsFields\" ng-show={{field.show}} class=\"capitalize account-details padding-left\" ng-class=\"{ \'first-record\': field.key === \'organizationKey\' }\" data-title=\"{{ field.translate | translate}}\">{{getVal(row[field.key], field)}}</td><td class=action-td><a ng-click=viewRecord(row[recordIDFieldName]) uib-tooltip=\"{{\'PAGINATION_RECORD_DROPDOWN_VIEW_TEXT\' | translate}}\" tooltip-placement=bottom><i class=material-icons>search</i> </a><a ng-click=disableRecordModal(row) uib-tooltip=\"{{\'PAGINATION_RECORD_DROPDOWN_DISABLE_TEXT\' | translate}}\" tooltip-placement=bottom ng-show=\"(row.status === \'active\') && (!row.deleted)\"><i class=material-icons>block</i> </a><a ng-click=enableRecordModal(row) uib-tooltip=\"{{\'PAGINATION_RECORD_DROPDOWN_ENABLE_TEXT\' | translate}}\" tooltip-placement=bottom ng-show=\"(row.status === \'inactive\') && (!row.deleted)\"><i class=material-icons>check</i> </a><a ng-click=deleteRecordModal(row) uib-tooltip=\"{{\'PAGINATION_RECORD_DROPDOWN_DELETE_TEXT\' | translate}}\" tooltip-placement=bottom ng-show=(!row.deleted)><i class=material-icons>delete</i> </a><i class=empty-icon ng-show=(row.deleted)></i> <i class=empty-icon ng-show=(row.deleted)></i></td></tr></tbody><tbody ng-show=isLoading class=loader-tbody><tr><td colspan=10><div ng-class=\"getOrganizationCss(\'simple-loader\')\"></div></td></tr></tbody><tfoot><tr><td colspan=2 class=\"padding-left padding-right\"><div class=admin-users><div class=\"pagination padding-left-zero\"><a ng-click=getPrevPage() ng-class={disabled:disablePrev} translate=ADMIN_SECTION_ADMINS_PREV_PAGINATION_TEXT></a></div><div class=\"pagination padding-left-zero\"><a ng-click=getNextPage() ng-class={disabled:disableNext} translate=ADMIN_SECTION_ADMINS_NEXT_PAGINATION_TEXT></a></div></div></td><td colspan={{calcFooterColSpan()}} class=\"padding-left padding-right\"><div class=admin-users><div class=\"pagination center width-100\">{{\'ADMIN_SECTION_ADMINS_RESULT_NUMBER_TEXT\' | translate}}&nbsp;{{totalRecords}}</div></div></td><td colspan=2 class=\"padding-left padding-right text-align-right\"><div class=admin-users><div class=\"pagination padding-right-zero right width-100\">{{\'ADMIN_SECTION_ADMINS_PAGE_TEXT\' | translate}}&nbsp;{{currentPage}}&nbsp;{{\'ADMIN_SECTION_ADMINS_PAGE_OF\' | translate}}&nbsp;{{totalPages}}</div></div></td></tr></tfoot></table></div></div></div></div></div></div></div></section>");
$templateCache.put("app/admin/register/template/create_admin.html","<div class=admin-register><div id=register-screen><div class=background><div class=gradient></div></div><div class=content-wrapper><form name=registerForm><h1 translate=ADMIN_SIGN_UP_SECTION_TITLE></h1><label>{{labelText}}</label><div class=\"form-el half\"><input type=text class=first-name name=firstname ng-model=newUser.firstname placeholder=\"{{\'SIGN_UP_FORM_FIRST_NAME_PLACEHOLDER_TEXT\' | translate}}\" ng-focus=\"formSetup.startedToRegister = true\" validator=required valid-method=change required-error-message=\"<div></div>\" required-success-message=\"<i class=\'success\'></i>\"></div><div class=\"form-el half\"><input type=text ng-model=newUser.lastname placeholder=\"{{\'SIGN_UP_FORM_LAST_NAME_PLACEHOLDER_TEXT\' | translate}}\" ng-focus=\"formSetup.startedToRegister = true\" validator=required valid-method=change required-error-message=\"<div></div>\" required-success-message=\"<i class=\'success\'></i>\"></div><div class=form-el ng-class=\"(status.isUsernameFieldBlur ? \'username-blur\': \'\')\"><input id=create-email type=text ng-class=\"(formSetup.alreadyRegistered ? \'already-registered\' : \'\')\" ng-model=newUser.emailPhone placeholder=\"{{\'SIGN_UP_FORM_MOBILE_OR_EMAIL_PLACEHOLDER_TEXT\' | translate}}\" ng-focus=\"formSetup.startedToRegister = true; formSetup.alreadyRegistered = false; status.isUsernameFieldBlur=false\" validator=\"required, username\" ng-blur=\"status.isUsernameFieldBlur=true\" valid-method=blur required-error-message=\"<div class=\'too-short username-error\'>{{\'SIGN_UP_FORM_ERROR_INVALID_FORMATE\' | translate}}</div>\" required-success-message=\"<div></div>\" username-error-message=\"<div class=\'too-short username-error\'>{{\'SIGN_UP_FORM_ERROR_INVALID_FORMATE\' | translate}}</div>\" username-success-message=\"<div></div>\"><div class=too-short ng-if=formSetup.alreadyRegistered translate=SIGN_UP_FORM_EMAIL_ALREADY_IN_USE_TEXT></div></div><div class=form-el><div class=password-hint ng-show=formSetup.passwordHint><p><strong translate=SIGN_UP_FORM_PASSWORD_STRENGTH_TEXT></strong> {{passwordStrength == 1 ? \'Fair\': passwordStrength == 2 ? \'Good\' : passwordStrength == 3 ? \'Excellent\' : \'\'}}</p><p></p><div class=strength-meter><div class=strength-meter-fill data-strength={{passwordStrength}}></div></div><p></p><p translate=SIGN_UP_FORM_PASSWORD_STRENGTH_MESSAGE_TEXT></p></div><input id=password class=ok-password type=password name=password ng-model=newUser.password placeholder=\"{{\'SIGN_UP_FORM_NEW_PASSWORD_PLACEHOLDER_TEXT\' | translate}}\" ng-focus=\"formSetup.passwordHint = true; formSetup.startedToRegister = true; focused = true\" ng-blur=\"formSetup.passwordHint = false\" validator=required ng-minlength=8 valid-method=change required-error-message=\"<div></div>\" required-success-message=\"<i class=\'success\'></i>\"><div class=too-short ng-show=\"!registerForm.password.$valid && focused\" translate=SIGN_UP_FORM_PASSWORD_TOO_SHORT_TEXT></div></div><div class=form-row ng-show=formSetup.startedToRegister><div class=form-el><input id=password-repeat type=password name=password2 class=ok-password ng-model=newUser.password2 compare-to=newUser.password placeholder=\"{{\'SIGN_UP_FORM_RE_ENTER_PASSWORD_PLACEHOLDER_TEXT\' | translate}}\" ng-focus=\"password2focused = true;\" ng-blur=\"password2focused = false;\"><div class=too-short ng-show=\"!registerForm.password2.$valid && !password2focused\" translate=SIGN_UP_FORM_PASSWORD_DOSENOT_MATCH_TEXT></div></div><div class=terms translate=SIGN_UP_FORM_INTRY_USER_AGREEMENT_MESSAGE_TEXT></div><div class=form-el><button type=submit class=create ng-class=\"formSetup.formReady ? \'form-valid\' : \'\'\" ng-click=requestCreate() validation-submit=registerForm>{{\'SIGN_UP_FORM_CREATE_ACCOUNT_BUTTON_TEXT\' | translate}}</button></div></div><div class=form-row ng-show=!formSetup.startedToRegister><div class=form-el><button type=button class=create ng-click=requestCreate() validation-submit=registerForm>{{\'SIGN_UP_FORM_CREATE_ACCOUNT_BUTTON_TEXT\' | translate}}</button></div></div></form></div></div></div>");
$templateCache.put("app/admin/register/template/register.html","<div ng-class=\"getOrganizationCss(\'body admin-register\')\"><div class=video-container><video autoplay muted loop class=video><source src=media/intry_video.mp4 type=video/mp4></video></div><div class=signup-section style=\"max-width:960px; z-index: 100\"><div ng-class=\"getOrganizationCss(\'signup-wrapper-2\')\"><div ng-if=hasOrganization() ng-class=\"getOrganizationCss(\'white-label-login-logo\')\"><div ng-class=\"getOrganizationCss(\'white-label-login-logo-img\')\"></div></div><div ng-class=\"getOrganizationCss(\'signup-form w-row\')\"><div ng-class=loginPanel1CssClass()><div class=login-header-mobile><a href=# class=\"brand w-inline-block\"><img src=/media/images/IntryLogo-Color.png height=35 alt=\"\" class=logoimage></a></div><h2><div ng-show=\"organizationKey && organizationName\" class=\"heading signup\">Organization: {{organizationKey}} - {{organizationName}}</div><div ng-show=\"organizationKey && !organizationName\" class=\"heading signup\">Organization: {{organizationKey}}</div><span ng-class=\"getOrganizationCss(\'heading signup\')\" translate=NEW_LOGIN_SIGN_IN_TITLE></span> <span ng-class=\"getOrganizationCss(\'sub-heading signup\')\" translate=NEW_LOGIN_SIGN_IN_SUB_TITLE></span></h2><div class=form-wrapper-signup><div class=\"form-block-2 w-form\"><form id=email-form name=email-form ng-submit=vm.login() data-name=\"Registration Form\" class=form-2><!-- Email --><label for=Username ng-class=\"getOrganizationCss(\'para-small signup\')\" translate=NEW_LOGIN_USERNAME_LABEL></label><input ng-model=vm.email ng-change=\"vm.failLogin=false;\" ng-class=\"vm.failLogin ? getOrganizationCss(\'text-field-full w-input ng-invalid\') : getOrganizationCss(\'text-field-full w-input\')\" type=text placeholder=\"{{\'NEW_LOGIN_USERNAME_PLACEHOLDER\' | translate}}\" id=Username required autocapitalize=none><!-- Password --><label for=Password ng-class=\"getOrganizationCss(\'para-small signup\')\" translate=NEW_LOGIN_PASSWORD_LABEL></label><input ng-model=vm.password ng-change=\"vm.failLogin=false;\" ng-class=\"vm.failLogin ? getOrganizationCss(\'text-field-full w-input ng-invalid\') : getOrganizationCss(\'text-field-full w-input\')\" type=password class=\"text-field-full w-input\" maxlength=256 name=Password data-name=Password placeholder=\"{{\'NEW_LOGIN_PASSWORD_PLACEHOLDER\' | translate}}\" id=Password required><!-- Sign in --><div class=form-submit-wrapper-2><input type=submit value=\"{{\'NEW_LOGIN_SIGN_IN_BTN_TEXT\' | translate}}\" data-wait=\"{{\'NEW_LOGIN_SIGN_IN_BTN_DATA_WAIT\' | translate}}\" ng-class=\"getOrganizationCss(\'cta signup w-button\')\"><div ng-class=\"getOrganizationCss(\'pricing-smallest freeep\')\">{{\'NEW_LOGIN_TERMS_PREFIX\' | translate}}<a href=https://intrycareers.com/legal target=_blank ng-class=\"getOrganizationCss(\'register-link\')\" translate=NEW_LOGIN_TERMS_LINK></a>{{\'NEW_LOGIN_TERMS_SUFFIX\' | translate}}<br><a href=javascript: ng-class=\"getOrganizationCss(\'hint\')\">Forgot password?</a><div class=forgot-hover><h2>Forgot Your Password? Contact an Admin!<br>If you\'ve forgotten your password, don\'t worry! Reach out to an admin of your organization. They will promptly assist you in resetting your password and regaining access to your account.</h2></div></div></div></form><div class=\"success-message-2 w-form-done\"><div class=success-alert><img src=https://s3.amazonaws.com/static.intry.careers/images/check-circle_1check-circle.png alt=\"\" class=image-7><div ng-class=\"getOrganizationCss(\'para-small alert\')\">{{\'NEW_LOGIN_SUCCESS_MSG\' | translate}}<br></div></div></div><div ng-show=vm.failLogin class=\"error-message-3 w-form-fail display-block\"><div class=error-message-text-2>{{vm.loginError ? vm.loginError : (\'NEW_LOGIN_ERROR_MSG\' | translate)}}</div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/admin/tracks/template/tracks.html","<nav-bar-admin></nav-bar-admin><section class=main-sec><div class=\"container pagination-container big-margin-bottom\"><div ng-class=\"getOrganizationCss(\'admin-user-info-sec\')\"><div class=not-border-bottom><div class=\"inner-sec pagination-inner-sec\"><div class=\"row2 admin-users-title-container\"><div><button ng-click=download() ng-class=\"getOrganizationCss(\'add-btn download-btn\')\"><h2>{{\'ADMIN_SECTION_TRACKS_DOWNLOAD_TEXT\' | translate }}</h2></button></div></div><!-- Filter --><div class=\"row2 form-styles margin-bottom\"><div class=\"col-lg-2 col-md-2 padding-right-zero\" ng-show=false><div class=select-style><select ng-model=filterField ng-options=\"x.key as x.label for x in tracksFilterFields\" class=\"form-control form-select\" ng-change=checkFtypes()></select></div></div><div class=\"col-lg-2 col-md-2 padding-right-zero\" ng-show=false><div class=select-style><select ng-model=ftype ng-options=\"x.key as x.label for x in ftypes\" class=\"form-control form-select\"></select></div></div><div class=search><img src=media/icons/search.png><div class=padding-right-zero><input ng-model=paginationFilter type=text placeholder=Search class=search-bar></div></div><div><button ng-click=search() ng-class=\"getOrganizationCss(\'search-btn\')\">Search</button></div></div><!-- Date Filter --><div class=\"row2 form-styles margin-bottom-big\"><div class=input-dates-container><div class=\"input-group calendar-input\" moment-picker=paginationFilterFrom format=MM/DD/YYYY min-view=month max-view=month max-date=maxDate today=true change=\"checkFilterDate(\'from\')\"><span class=input-group-addon><label style=\"margin-bottom: 0px; width: 60px\">From</label></span><input ng-model=paginationFilterFrom class=form-control placeholder=\"Select a date\" ng-model-options=\"{ updateOn: \'blur\' }\"></div><div class=\"input-group calendar-input\" moment-picker=paginationFilterTo format=MM/DD/YYYY min-view=month max-view=month max-date=maxDate today=true change=\"checkFilterDate(\'to\')\"><span class=input-group-addon><label style=\"margin-bottom: 0px; width: 60px\">To</label></span><input ng-model=paginationFilterTo class=form-control placeholder=\"Select a date\" ng-model-options=\"{ updateOn: \'blur\' }\"></div></div><div><button ng-click=clear() ng-class=\"getOrganizationCss(\'search-btn clear-button\')\">Clear</button></div></div><!-- Stats --><div class=stats-container-small><div class=stat-small><h2>{{stats[\'user-subscribe-invitation-org\'].actionName}}</h2><h3>{{stats[\'user-subscribe-invitation-org\'].count}}</h3></div><div class=stat-small><h2>{{stats[\'assessment-create\'].actionName}}</h2><h3>{{stats[\'assessment-create\'].count}}</h3></div><div class=stat-small><h2>{{stats[\'resume-parse\'].actionName}}</h2><h3>{{stats[\'resume-parse\'].count}}</h3></div><div class=stat-small><h2>{{stats[\'resume-j2r\'].actionName}}</h2><h3>{{stats[\'resume-j2r\'].count}}</h3></div><div class=stat-small><h2>{{stats[\'resume-downloaded\'].actionName}}</h2><h3>{{stats[\'resume-downloaded\'].count}}</h3></div><div class=stat-small><h2>{{stats[\'unemployed-report-downloaded\'].actionName}}</h2><h3>{{stats[\'unemployed-report-downloaded\'].count}}</h3></div></div><!-- Pagination --><div class=row-table><div class=\"col-md-12 overflow-x-auto\"><table st-table=tracks st-pipe=getTracks ng-class=\"getOrganizationCss(\'table table-striped intry-table notes-table\')\"><thead><tr><th st-sort=created ng-click=setResetSkip(true) class=sort-button translate=Date></th><th st-sort=organizationKey ng-click=setResetSkip(true) class=sort-button translate=\"Org. Key\"></th><th st-sort=User ng-click=setResetSkip(true) class=sort-button translate=User></th><th st-sort=username ng-click=setResetSkip(true) class=sort-button translate=Username></th><th st-sort=actionKey ng-click=setResetSkip(true) class=sort-button translate=Event></th></tr></thead><tbody ng-show=!isLoading><tr ng-repeat=\"row in tracks\"><td class=\"capitalize account-details\">{{row.created | date:\'MM/dd/yyyy hh:mm:ss a\'}}</td><td class=\"capitalize account-details\">{{row.organizationKey}}</td><td class=\"capitalize account-details\">{{row.full_name}}</td><td class=\"capitalize account-details\"><span ng-click=viewUser(row.userID) style=\"cursor: pointer\">{{row.username}}</span></td><td class=\"capitalize account-details trackActionKey {{row.actionKey}}\"><span class=trackActionKeyError uib-tooltip={{row.msg}} ng-show=row.error>(ERROR) </span>{{row.actionName}}</td></tr></tbody><tbody ng-show=isLoading><tr><td colspan=10><div ng-class=\"getOrganizationCss(\'simple-loader\')\"></div></td></tr></tbody><tfoot><tr><td colspan=12 class=\"padding-left padding-right\"><div class=row><div class=col-md-4><div class=admin-users><div class=\"pagination padding-left-zero\"><a ng-click=getPrevPage() ng-class={disabled:disablePrev} translate=ADMIN_SECTION_ADMINS_PREV_PAGINATION_TEXT></a></div><div class=\"pagination padding-left-zero\"><a ng-click=getNextPage() ng-class={disabled:disableNext} translate=ADMIN_SECTION_ADMINS_NEXT_PAGINATION_TEXT></a></div></div></div><div class=col-md-4><div class=admin-users><div class=\"pagination center width-100\">{{\'ADMIN_SECTION_ADMINS_RESULT_NUMBER_TEXT\' | translate}}&nbsp;{{totalTracks}}</div></div></div><div class=\"col-md-4 text-align-right\"><div class=admin-users><div class=\"pagination padding-right-zero right width-100\">{{\'ADMIN_SECTION_ADMINS_PAGE_TEXT\' | translate}}&nbsp;{{currentPage}}&nbsp;{{\'ADMIN_SECTION_ADMINS_PAGE_OF\' | translate}}&nbsp;{{totalPages}}</div></div></div></div></td></tr></tfoot></table></div></div></div></div></div></div></section>");
$templateCache.put("app/admin/users/template/add-note.html","<div id=onboarding-modal class=ngdialog-wrapper style=\"display: block\" aria-labelledby=onboarding-modal-title aria-hidden=true><div class=\"modal-dialog modal-dialog-centered\" role=document><div class=modal-content><div class=modal-body><div class=\"section section-intro section-active\"><div class=desc><p class=text></p><h4>Add Note</h4><div class=\"user-exp-sec form-styles\"><div><div class=form-row><div class=\"form-group col-md-12\"><textarea class=form-control id=short-desc name=short-desc rows=4 ng-model=model.userNote></textarea></div></div></div></div><p></p></div><div class=buttons-block><div class=form-row><div class=col-6><button ng-class=\"getOrganizationCss(\'pagination-search-btn add-record-btn\')\" ng-click=closeAddNoteModal()>Cancel</button></div><div class=col-6><button ng-class=\"getOrganizationCss(\'pagination-search-btn add-record-btn\')\" ng-click=addNote()>Save</button></div></div></div></div></div></div></div></div>");
$templateCache.put("app/admin/users/template/users.html","<nav-bar-admin></nav-bar-admin><section class=\"main-sec full-height-content\"><div class=header-data><div class=\"container pagination-container big-margin-bottom\"><div ng-class=\"getOrganizationCss(\'admin-user-info-sec\')\"><div class=not-border-bottom><div class=\"inner-sec pagination-inner-sec\"><div class=\"row2 admin-users-title-container\"><div><button ng-click=requestCreate() ng-class=\"getOrganizationCss(\'add-btn\')\"><h2>Invite User</h2></button></div></div><div class=stats-container-big><div class=stat-small><h2>Assigned Cases</h2><h3>{{numberOfUsers}}</h3></div><div class=stat-small><h2>Resumes Created</h2><h3>{{numberOfResumes}}</h3></div><div class=stat-small><h2>Jobs Placed</h2><h3>{{numberOfHired}}</h3></div></div><div class=\"row2 form-styles admin-search-form\"><div class=\"col-lg-2 col-md-2 padding-right-zero\" ng-show=false><div class=select-style><select ng-model=filterField ng-options=\"x.key as x.label for x in userFilterFields\" class=\"form-control form-select\" ng-change=checkFtypes()></select></div></div><div class=\"col-lg-2 col-md-2 padding-right-zero\" ng-show=false><div class=select-style><select ng-model=ftype ng-options=\"x.key as x.label for x in ftypes\" class=\"form-control form-select\"></select></div></div><div class=search><img src=media/icons/search.png><div class=padding-right-zero><input id=admin-search-bar ng-model=paginationFilter type=text placeholder=\"{{\'ADMIN_SECTION_USERS_FILTER_PLACEHOLDER_TEXT\' | translate}}\" class=\"search-bar form-control\"></div></div><div><button ng-click=search() ng-class=\"getOrganizationCss(\'search-btn\')\">Search</button> <button ng-click=toggleInactive() ng-class=\"getOrganizationCss(\'search-btn\')\">{{inactiveToggleText}}</button></div></div><div class=row2><div class=\"col-md-12 overflow-x-auto\" style=\"padding: 0 !important\"><table class=admin-users-table st-table=users st-pipe=getUsers ng-class=\"getOrganizationCss(\'table table-striped intry-table\')\"><thead><tr><th st-sort=full_name ng-click=setResetSkip(true) class=sort-button translate=ADMIN_SECTION_FULL_NAME_HEAD_TEXT></th><th st-sort=username ng-click=setResetSkip(true) class=\"padding-left sort-button\" translate=ADMIN_SECTION_USERNAME_HEAD_TEXT></th><th translate=Emails></th><th translate=Resumes st-sort=resumes class=sort-button ng-click=setResetSkip(true)></th><th st-sort=created-resumes ng-click=setResetSkip(true) class=sort-button translate=\"Created Resumes\"></th><th st-sort=uploaded-resumes ng-click=setResetSkip(true) class=sort-button translate=\"Uploaded Resumes\"></th><th st-sort=downloaded-resumes ng-click=setResetSkip(true) class=sort-button translate=\"Resumes Downloaded\"></th><th st-sort=organizationKey ng-click=setResetSkip(true) class=sort-button translate=ADMIN_SECTION_ADMINS_ORGANIZATION_KEY_HEAD_TEXT ng-show=\"checkRole([\'ROLE_APP_ADMIN\'])\"></th><!-- <th st-sort=\"location\" ng-click=\"setResetSkip(true)\"\n			   class=\"sort-button\"\n			   translate=\"ADMIN_SECTION_ADMINS_LOCATION_KEY_HEAD_TEXT\"\n			   ng-show=\"checkRole([\'ROLE_APP_ADMIN\'])\"></th> --><th st-sort=belongsToObj.username ng-click=setResetSkip(true) class=sort-button translate=ADMIN_SECTION_ADMINS_BELONGS_TO_HEAD_TEXT ng-show=\"!checkRole([\'ROLE_USER_ADMIN\'])\"></th><th st-sort=hired ng-click=setResetSkip(true) class=sort-button translate=Hired></th><!--\n			  <th st-sort=\"subscription_begin\" class=\"sort-button\" translate=\"ADMIN_SECTION_PURCHASE_DATE_TEXT\"></th>\n		      <th st-sort=\"subscription_end\" class=\"sort-button\" translate=\"ADMIN_SECTION_BUNDLE_EXPIRES_TEXT\"></th>\n		      <th st-sort=\"status\" class=\"sort-button\" translate=\"ADMIN_SECTION_ACCOUNT_STATUS_HEAD_TEXT\"></th>\n		      --><th class=\"text-align-right padding-right\" translate=ADMIN_SECTION_ACTIONS_HEAD_TEXT></th></tr></thead><tbody ng-show=!isLoading><tr ng-repeat=\"row in users\"><td class=capitalize><div class=\"full-name {{row.status}}\">{{row.full_name}}</div><div ng-show=row.company>{{row.company}}</div><div ng-show=!row.company>&nbsp;</div></td><td class=\"capitalize account-details padding-left\" data-title=\"{{\'ADMIN_SECTION_USERNAME_HEAD_TEXT\' | translate}}\">{{row.username}}</td><td class=\"capitalize account-details\" data-title=\"{{\'Emails\' | translate}}\"><div><div ng-repeat=\"email in row.email_addresses\">{{email.address}}</div></div></td><td class=\"capitalize account-details padding-left\" data-title=\"{{\'Resumes\' | translate}}\">{{row.numberOfResumes}}</td><td class=\"capitalize account-details padding-left\" data-title=\"{{\'Created Resumes\' | translate}}\">{{row.createdResumes}}</td><td class=\"capitalize account-details padding-left\" data-title=\"{{\'Uploaded Resumes\' | translate}}\">{{row.uploadedResumes}}</td><td class=\"capitalize account-details padding-left\" data-title=\"{{\'Resumes Downloaded\' | translate}}\">{{row.downloadedResumes}}</td><td class=\"capitalize account-details\" ng-show=\"checkRole([\'ROLE_APP_ADMIN\'])\" data-title=\"{{\'ADMIN_SECTION_ADMINS_ORGANIZATION_KEY_HEAD_TEXT\' | translate}}\">{{row.organizationKey}}</td><!-- <td class=\"capitalize account-details\"\n			   ng-show=\"checkRole([\'ROLE_APP_ADMIN\'])\"\n			   data-title=\"{{\'ADMIN_SECTION_ADMINS_LOCATION_KEY_HEAD_TEXT\' | translate}}\">\n			   LOCATION\n		           </td> --><td class=\"capitalize account-details\" ng-show=\"!checkRole([\'ROLE_USER_ADMIN\'])\" data-title=\"{{\'ADMIN_SECTION_ADMINS_BELONGS_TO_HEAD_TEXT\' | translate}}\">{{row.belongsToObj.username}}</td><!--\n                          <td class=\"capitalize account-details\">{{row.subscription_begin}}</td>\n                      <td class=\"capitalize account-details\">{{row.subscription_end}}</td>\n                      <td class=\"capitalize account-details\">{{row.status}}</td>\n                      --><td class=\"capitalize account-details padding-left\" data-title=\"{{\'Hired\' | translate}}\">{{(row.hired) ? \'Yes\' : \'No\'}}</td><td class=action-td><a ng-click=viewUser(row.userID) uib-tooltip=\"{{\'ADMIN_SECTION_DROPDOWN_VIEW_TEXT\' | translate}}\" tooltip-placement=bottom><i ng-class=\"getOrganizationCss(\'material-icons\')\">search</i> </a><a ng-click=openAddNoteModal(row.userID) uib-tooltip-html=row.htmlNotes tooltip-placement=bottom><i ng-class=\"getOrganizationCss(\'material-icons\')\">comment</i> </a><a ng-click=hiredModal(row) uib-tooltip=\"{{\'ADMIN_SECTION_DROPDOWN_HIRED_TEXT\' | translate}}\" tooltip-placement=bottom ng-show=\"(row.status === \'active\') && !row.deleted\"><i ng-class=\"getOrganizationCss(\'material-icons\')\">{{(row.hired) ? \'work_off\' : \'work\'}}</i> </a><i class=empty-icon ng-show=\"(row.status === \'inactive\') || row.deleted\"></i> <a ng-click=disableUserModal(row) uib-tooltip=\"{{\'ADMIN_SECTION_DROPDOWN_DISABLE_TEXT\' | translate}}\" tooltip-placement=bottom ng-show=\"(row.status === \'active\') && !row.deleted\"><i ng-class=\"getOrganizationCss(\'material-icons\')\">block</i> </a><a ng-click=enableUserModal(row) uib-tooltip=\"{{\'ADMIN_SECTION_DROPDOWN_ENABLE_TEXT\' | translate}}\" tooltip-placement=bottom ng-show=\"(row.status === \'inactive\') && !row.deleted\"><i ng-class=\"getOrganizationCss(\'material-icons\')\">check</i> </a><a ng-click=deleteUserModal(row) uib-tooltip=\"{{\'ADMIN_SECTION_DROPDOWN_DELETE_TEXT\' | translate}}\" tooltip-placement=bottom ng-show=\"!row.deleted && checkRole([\'ROLE_APP_ADMIN\'])\"><i ng-class=\"getOrganizationCss(\'material-icons\')\">delete</i> </a><a ng-click=loginAs(row.userID) uib-tooltip=\"{{\'ADMIN_SECTION_DROPDOWN_LOGIN_AS_TEXT\' | translate}}\" tooltip-placement=bottom ng-show=\"(row.status === \'active\') && !row.deleted\"><i ng-class=\"getOrganizationCss(\'material-icons\')\">input</i> </a><i class=empty-icon ng-show=\"(row.status === \'inactive\') || row.deleted\"></i></td></tr></tbody><tbody class=loader-tbody ng-show=isLoading><tr><td colspan=10><div ng-class=\"getOrganizationCss(\'simple-loader\')\"></div></td></tr></tbody><tfoot><tr><td colspan=12 class=\"padding-left padding-right\"><div class=row><div class=col-md-4><div class=admin-users><div class=\"pagination padding-left-zero\"><a ng-click=getPrevPage() ng-class={disabled:disablePrev} translate=ADMIN_SECTION_ADMINS_PREV_PAGINATION_TEXT></a></div><div class=\"pagination padding-left-zero\"><a ng-click=getNextPage() ng-class={disabled:disableNext} translate=ADMIN_SECTION_ADMINS_NEXT_PAGINATION_TEXT></a></div></div></div><div class=col-md-4><div class=admin-users><div class=\"pagination center width-100\">{{\'ADMIN_SECTION_ADMINS_RESULT_NUMBER_TEXT\' | translate}}&nbsp;{{totalUsers}}</div></div></div><div class=\"col-md-4 text-align-right\"><div class=admin-users><div class=\"pagination padding-right-zero right width-100\">{{\'ADMIN_SECTION_ADMINS_PAGE_TEXT\' | translate}}&nbsp;{{currentPage}}&nbsp;{{\'ADMIN_SECTION_ADMINS_PAGE_OF\' | translate}}&nbsp;{{totalPages}}</div></div></div></div></td><!--\n	                  <td colspan=\"2\" class=\"padding-left padding-right\">\n	                    <div class=\"admin-users\">\n	                      <div class=\"pagination padding-left-zero\">\n	                        <a ng-click=\"getPrevPage()\" ng-class=\"{disabled:disablePrev}\" translate=\"ADMIN_SECTION_ADMINS_PREV_PAGINATION_TEXT\"></a>\n	                      </div>\n	                      <div class=\"pagination padding-left-zero\">\n	                        <a ng-click=\"getNextPage()\" ng-class=\"{disabled:disableNext}\" translate=\"ADMIN_SECTION_ADMINS_NEXT_PAGINATION_TEXT\"></a>\n	                      </div>\n	                    </div>\n	                  </td>\n                      <td colspan=\"3\" class=\"padding-left padding-right\">\n                        <div class=\"admin-users\">\n	                  <div class=\"pagination center width-100\">\n	                    {{\'ADMIN_SECTION_ADMINS_RESULT_NUMBER_TEXT\' | translate}}&nbsp;{{totalUsers}}\n	                  </div>\n                        </div>\n                      </td>\n                      <td colspan=\"2\" class=\"padding-left padding-right text-align-right\">\n                        <div class=\"admin-users\">\n	                  <div class=\"pagination padding-right-zero right width-100\">\n	                    {{\'ADMIN_SECTION_ADMINS_PAGE_TEXT\' | translate}}&nbsp;{{currentPage}}&nbsp;{{\'ADMIN_SECTION_ADMINS_PAGE_OF\' | translate}}&nbsp;{{totalPages}}\n	                  </div>\n                        </div>\n                      </td>\n                      --></tr></tfoot></table></div></div></div></div></div></div></div></section>");
$templateCache.put("app/admin/utms/template/utms.html","<nav-bar-admin></nav-bar-admin><section class=\"main-sec full-height-content\"><div class=header-data><div class=\"container pagination-container big-margin-bottom\"><div ng-class=\"getOrganizationCss(\'admin-user-info-sec\')\"><div class=not-border-bottom><div class=\"inner-sec pagination-inner-sec\"><div class=\"row2 admin-users-title-container\"><div><button ng-click=createRecord() ng-class=\"getOrganizationCss(\'add-btn\')\"><h2>Add</h2></button></div></div></div><div class=\"row2 form-styles admin-search-form margin-bottom\"><div class=\"col-lg-2 col-md-2 padding-right-zero\" ng-show=false><div class=select-style><select ng-model=filterField ng-options=\"x.key as x.label for x in recordFilterFields\" class=\"form-control form-select\" ng-change=checkFtypes()></select></div></div><div class=\"col-lg-2 col-md-2 padding-right-zero\" ng-show=false><div class=select-style><select ng-model=ftype ng-options=\"x.key as x.label for x in ftypes\" class=\"form-control form-select\"></select></div></div><div class=search><img src=media/icons/search.png><div class=padding-right-zero><input ng-model=paginationFilter type=text placeholder=\"{{\'ADMIN_SECTION_UTM_FILTER_PLACEHOLDER_TEXT\' | translate}}\" class=search-bar></div></div><div><button ng-click=search() ng-class=\"getOrganizationCss(\'search-btn\')\">Search</button></div></div><div class=row2><div class=\"col-md-12 overflow-x-auto\" style=\"padding: 0 !important\"><table st-table=records st-pipe=getRecords ng-class=\"getOrganizationCss(\'table table-striped intry-table\')\"><thead><tr><th ng-repeat=\"field in rawRecordsFields\" ng-show={{field.show}} st-sort={{field.key}} class=\"padding-left sort-button\" translate={{field.translate}}></th><th class=\"text-align-right padding-right\" translate={{ADMIN_SECTION_ADMINS_ACTIONS_HEAD_TEXT}}></th></tr></thead><tbody ng-show=!isLoading><tr ng-repeat=\"row in records\"><td ng-repeat=\"field in rawRecordsFields\" ng-show={{field.show}} class=\"capitalize account-details padding-left\" ng-class=\"{ \'first-record\': field.key === \'name\' }\" data-title=\"{{ field.translate | translate}}\"><div ng-class=\"{ \'postback-path\': field.key === \'postbackPath\' }\">{{row[field.key]}}</div></td><td class=action-td><a ng-click=viewRecord(row[recordIDFieldName]) uib-tooltip=\"{{\'PAGINATION_RECORD_DROPDOWN_VIEW_TEXT\' | translate}}\" tooltip-placement=bottom><i class=material-icons>search</i> </a><a ng-click=disableRecordModal(row) uib-tooltip=\"{{\'PAGINATION_RECORD_DROPDOWN_DISABLE_TEXT\' | translate}}\" tooltip-placement=bottom ng-show=\"(row.status === \'active\') && (!row.deleted)\"><i class=material-icons>block</i> </a><a ng-click=enableRecordModal(row) uib-tooltip=\"{{\'PAGINATION_RECORD_DROPDOWN_ENABLE_TEXT\' | translate}}\" tooltip-placement=bottom ng-show=\"(row.status === \'inactive\') && (!row.deleted)\"><i class=material-icons>check</i> </a><a ng-click=deleteRecordModal(row) uib-tooltip=\"{{\'PAGINATION_RECORD_DROPDOWN_DELETE_TEXT\' | translate}}\" tooltip-placement=bottom ng-show=(!row.deleted)><i class=material-icons>delete</i> </a><i class=empty-icon ng-show=(row.deleted)></i> <i class=empty-icon ng-show=(row.deleted)></i></td></tr></tbody><tbody ng-show=isLoading class=loader-tbody><tr><td colspan=10><div class=simple-loader></div></td></tr></tbody><tfoot><tr><td colspan=1 class=\"padding-left padding-right\"><div class=admin-users><div class=\"pagination padding-left-zero\"><a ng-click=getPrevPage() ng-class={disabled:disablePrev} translate=ADMIN_SECTION_ADMINS_PREV_PAGINATION_TEXT></a></div><div class=\"pagination padding-left-zero\"><a ng-click=getNextPage() ng-class={disabled:disableNext} translate=ADMIN_SECTION_ADMINS_NEXT_PAGINATION_TEXT></a></div></div></td><td colspan={{calcFooterColSpan()}} class=\"padding-left padding-right\"><div class=admin-users><div class=\"pagination center width-100\">{{\'ADMIN_SECTION_ADMINS_RESULT_NUMBER_TEXT\' | translate}}&nbsp;{{totalRecords}}</div></div></td><td colspan=1 class=\"padding-left padding-right text-align-right\"><div class=admin-users><div class=\"pagination padding-right-zero right width-100\">{{\'ADMIN_SECTION_ADMINS_PAGE_TEXT\' | translate}}&nbsp;{{currentPage}}&nbsp;{{\'ADMIN_SECTION_ADMINS_PAGE_OF\' | translate}}&nbsp;{{totalPages}}</div></div></td></tr></tfoot></table></div></div></div></div></div></div></section>");
$templateCache.put("app/common/directive/footer/footer.html","");
$templateCache.put("app/common/directive/navBar/navbar.html","<div ng-if=vm.conflictAgent(true) class=agent-conflict><div class=recommendation>{{vm.conflictAgent()}}</div></div><nav ng-class=\"getOrganizationCss(\'navbar navbar-user navbar-expand-md\')\"><div class=container><a class=navbar-brand href=/ ng-show=!hasOrganization()><img src=/media/images/IntryLogo-Color.png id=home height=35 style=\"opacity: 0.75\"></a><div ng-click=goToHome() ng-class=\"getOrganizationCss(\'white-label-navbar-logo-img\')\" ng-show=hasOrganization()></div><div ng-click=goToHome() ng-class=white-label-navbar-logo-img ng-show=!hasOrganization()></div><button class=navbar-toggler type=button ng-click=vm.toggleMobileMenu($event) data-toggle=collapse><span class=navbar-toggler-icon></span></button><div class=\"collapse navbar-collapse\" id=top-navbar-collapse><ul class=\"navbar-nav ml-auto\" ng-if=!vm.hideSide><li class=nav-item ui-sref-active=active ng-show=vm.checkAdminSession()><a ui-sref=admin-create-user class=nav-link>{{\'MENU_ADMIN\' | translate}}</a></li><li class=nav-item ui-sref-active=active><a ui-sref=dashboard class=nav-link>{{\'MENU_HOME\' | translate}}</a></li><li class=nav-item id=assesment ui-sref-active=active ng-show=showAssessmentsMenu()><a class=nav-link ui-sref=assessments>{{\'MENU_ASSESSMENTS\' | translate}}</a></li><li class=nav-item id=profile ui-sref-active=active><a class=nav-link ui-sref=user-profile>{{\'MENU_MY_PROFILE\' | translate}}</a></li><li class=nav-item id=resume ui-sref-active=active><a class=nav-link ui-sref=resumes>{{\'MENU_RESUMES\' | translate}}</a></li><li class=nav-item id=notes ui-sref-active=active><a class=nav-link ui-sref=notes>{{\'MENU_UNEMPLOYED_NOTES\' | translate}}</a></li><li class=\"nav-item dropdown\"><a class=\"nav-link dropdown-toggle\" id=navbarDropdown role=button data-toggle=dropdown aria-haspopup=true aria-expanded=false ng-show=\"getResumeCounter().length == 0\"><span>{{vm.user.first_name | capitalize}}</span> <i class=material-icons>expand_more</i> </a><a class=\"nav-link dropdown-toggle\" id=navbarDropdown role=button data-toggle=dropdown aria-haspopup=true aria-expanded=false ng-show=\"getResumeCounter().length > 0\" uib-tooltip={{getResumeCounterTooltip()}} tooltip-placement=bottom><span>{{vm.user.first_name | capitalize}}</span> <span>&nbsp;({{getResumeCounter()}})</span> <i class=material-icons>expand_more</i></a><div ng-class=\"getOrganizationCss(\'dropdown-menu\')\" aria-labelledby=navbarDropdown><a class=dropdown-item ui-sref=my-account ui-sref-active=active>{{\'PROFILE_TEXT\' | translate}}</a> <a class=dropdown-item target=_blank ng-href=https://www.intry.careers/faq-help>FAQ</a> <a class=dropdown-item target=_blank ng-href=https://www.intry.careers/legal/#terms>Terms of Service</a> <a class=dropdown-item ng-click=vm.logOut() translate=LOGOUT_BUTTON_TEXT></a></div></li></ul></div></div></nav>");
$templateCache.put("app/common/directive/navBarAdmin/navbarAdmin.html","<link href=\"https://fonts.googleapis.com/icon?family=Material+Icons\" rel=stylesheet><nav ng-class=\"getOrganizationCss(\'navbar navbar-expand-md admin-nav\')\"><div class=container><a class=navbar-brand ng-click=goToHome() ng-show=!hasOrganization()><img src=/media/images/IntryLogo-Color.png id=home height=35 style=\"opacity: 0.75\"></a><div ng-click=goToHome() ng-class=\"getOrganizationCss(\'white-label-navbar-admin-logo-img\')\" ng-show=hasOrganization()></div><button class=navbar-toggler type=button ng-click=vm.toggleMobileMenu($event) data-toggle=collapse><span class=navbar-toggler-icon></span></button><div class=\"collapse navbar-collapse\" id=top-navbar-collapse><ul class=\"navbar-nav ml-auto\" ng-if=!vm.hideSide><li class=nav-item><a ui-sref=admin-users ui-sref-active=active uib-tooltip=\"{{\'ADMIN_SECTION_USERS_TITLE\' | translate}}\" tooltip-placement=bottom class=\"nav-link navbar-a navbar-admin-link\">{{\'ADMIN_SECTION_USERS_TITLE\' | translate}}</a></li><li class=nav-item ng-show=\"!checkRole([\'ROLE_USER_ADMIN\'])\"><a ui-sref=admin-admins ui-sref-active=active uib-tooltip=\"{{getTitle(\'ADMIN_SECTION_ADMINS_TITLE\')}}\" tooltip-placement=bottom class=\"nav-link navbar-a navbar-admin-link\">{{getTitle(\'ADMIN_SECTION_ADMINS_TITLE\')}}</a></li><li class=nav-item ng-show=\"checkRole([\'ROLE_APP_ADMIN\'])\"><a ui-sref=admin-organizations ui-sref-active=active uib-tooltip=\"{{\'ADMIN_SECTION_ORGANIZATIONS_TITLE\' | translate}}\" tooltip-placement=bottom class=\"nav-link navbar-a navbar-admin-link\">{{\'ADMIN_SECTION_ORGANIZATIONS_TITLE\' | translate}}</a></li><li class=nav-item ng-show=\"checkRole([\'ROLE_APP_ADMIN\'])\"><a ui-sref=admin-utms ui-sref-active=active uib-tooltip=\"{{\'ADMIN_SECTION_UTMS_TITLE\' | translate}}\" tooltip-placement=bottom class=\"nav-link navbar-a navbar-admin-link\">{{\'ADMIN_SECTION_UTMS_TITLE\' | translate}}</a></li><li class=nav-item><a ui-sref=admin-tracks ui-sref-active=active uib-tooltip=\"{{\'ADMIN_SECTION_TRACKS_TITLE\' | translate}}\" tooltip-placement=bottom class=\"nav-link navbar-a navbar-admin-link\">{{\'ADMIN_SECTION_TRACKS_TITLE\' | translate}}</a></li><li class=nav-item><a ng-click=vm.viewProfile() uib-tooltip=\"{{\'My Account\' | translate}}\" tooltip-placement=bottom class=\"nav-link navbar-a navbar-admin-link\">{{\'My Account\' | translate}}</a></li><li class=nav-item><a ng-click=vm.logOut() uib-tooltip=\"{{\'LOGOUT_BUTTON_TEXT\' | translate}}\" tooltip-placement=bottom class=\"nav-link navbar-a navbar-admin-link\">{{\'LOGOUT_BUTTON_TEXT\' | translate}}</a></li></ul></div></div></nav>");
$templateCache.put("app/common/directive/paywall/paywall.html","<div ng-class=\'scrimPageBackground ? \"scrim\": \"\"\'><nav-bar user=user></nav-bar></div><section class=main-sec><header ng-class=\"getOrganizationCss(\'\')\"><div class=container><p>{{\'PAYWALL_SECTION_TITLE\' | translate}}</p></div></header><div class=container><!-- #region Step 1 --><div class=\"user-info-sec subscription-section\" ng-show=step1><div class=\"row justify-content-center subscription-plan-full-container\"><div class=col-sm-12><h6 class=p-15><span>{{\"USER_PROFILE_CARD_BILLING_UNLOCK_TITLE\" | translate}}</span></h6><p class=p-15 translate=USER_PROFILE_CARD_BILLING_PAID_FEATURES_TITLE></p><div class=\"row m-0 justify-content-center p-15\"><div class=subscription-plans><div class=\"col-md-12 col-sm-12\"><div class=\"row row-plans\"><div class=subscribe-plan-container ng-repeat=\"bundle in bundles\" ng-class=getOrganizationCss2(bundle.name)><h5 class=subscribe-plan-head2 ng-bind-html=bundle.name></h5><div class=subscription-title-container><h6 style=\"white-space: nowrap\">${{bundle.monthPrice}}<span>/{{bundle.monthDescription}}</span></h6><div class=item-text style=\"text-align: left; width: 100%\">${{bundle.price}}&nbsp;{{bundle.description}}</div></div><div class=subscription-content-container><div class=\"d-flex sub-condition-list\" ng-repeat=\"feature in bundle.features\"><div class=list-item-arrow><img src=/media/images/green-arrow.svg></div><div class=item-text>{{feature}}</div><div class=clearfix></div></div></div><div class=subscription-button-container><button ng-if=!bundle.disabled type=button ng-disabled=loadingInProcess ng-click=gotoStep2(bundle.id);>{{\'ASSESSMENT_CONFIRMATION_SECTION_LETS_GO_BUTTON_TEXT\' | translate }}</button></div></div></div></div></div></div><div class=\"row mb-10 justify-content-center p-15\"><button type=button class=goback-btn ng-class=\"getOrganizationCss(\'goback-btn\')\" ng-click=completePayment()>Cancel</button></div><p class=\"subscribe-cancel-text p-15\"><span translate=USER_PROFILE_BILLING_DETAILS_BUNDLE_MESSAGE></span></p></div></div></div><!-- #endregion Step 1 --><!-- #region Step 2 --><div class=\"user-info-sec subscription-section payment-section\" ng-show=step2><div class=\"row justify-content-center\"><div class=col-sm-9><h6 class=p-15><span>{{\"USER_PROFILE_CARD_BILLING_UNLOCK_TITLE\" | translate}}</span></h6><p class=p-15 translate=USER_PROFILE_CARD_BILLING_PAID_FEATURES_SUBTITLE></p></div><div class=col-sm-12><div class=payment-desc-block><div class=payment-container><div class=payment-left><div class=\"subscribe-plan-container selected-plan\"><h5 class=subscribe-plan-head2 ng-bind-html=selectedBundle.name></h5><div class=subscription-title-container><h6 style=\"white-space: nowrap\">${{selectedBundle.monthPrice}}<span>/{{selectedBundle.monthDescription}}</span></h6><div class=item-text style=\"text-align: left; width: 100%\">${{selectedBundle.price}}&nbsp;{{selectedBundle.description}}</div></div><div class=subscription-content-container><div class=\"d-flex sub-condition-list\" ng-repeat=\"feature in selectedBundle.features\"><div class=list-item-arrow><img src=/media/images/green-arrow.svg></div><div class=item-text>{{feature}}</div><div class=clearfix></div></div></div></div></div><div class=payment-right><form class=\"exp-form form-styles\" name=userForm><div class=form-row><div class=\"form-group col-md-6\"><label for=card_name>Your Name</label><input class=form-control id=card_name placeholder=\"Enter Your Name\" type=text ng-model=yourName validator=required name=yourName></div><div class=\"form-group col-md-6\"><label for=billing_email>Billing Email</label><input class=form-control id=billing_email placeholder=\"Enter billing email address\" type=text ng-model=billingEmail validator=required ng-pattern=/^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$/ name=billingEmail></div></div><div class=form-row><div class=\"form-group col-md-6\"><label>Card Number</label><div id=card-number-stripe class=stripe-field></div></div><div class=\"form-group col-md-6\"><label for=card_name>Promo Code</label><input class=form-control id=Promo placeholder=\"Enter discount code\" type=text ng-model=promoCode name=promoCode></div></div><div class=form-row><div class=\"form-group col-md-6\"><label>Expiration Date</label><div id=card-expiry-stripe class=stripe-field></div></div><div class=\"form-group col-md-6\"><label for=cvv-number>CVV</label><div id=card-cvv-stripe class=stripe-field></div></div></div><div class=\"form-row payment-container-buttons\"><button type=button ng-click=processCard(cardNumber) ng-disabled=processingCard ng-class=\"getOrganizationCss(\'btn btn-primary pay-now-btn\')\" validation-submit=userForm>Pay Now</button> <button type=button ng-click=gotoStep1() class=\"btn btn-secondary pay-cancel-btn\">Cancel</button></div></form><p class=\"subscribe-cancel-text payment-subscribe-cancel-text\" translate=USER_PROFILE_BILLING_DETAILS_MESSAGE></p></div><div class=clearfix></div></div></div></div></div></div><!-- #endregion Step 2 --><!-- #region Step 3 --><div class=\"user-info-sec payment-success-sec\" ng-show=step3><div class=\"row justify-content-center\"><div><img src=/media/images/success-badge.svg alt=success-badge class=\"img-fluid success-badge-img\"><h6>{{\"PAYWALL_PAYMENT_SUCCESS\" | translate}}</h6><p>{{\"PAYWALL_PAYMENT_MEMBERSHIP\" | translate}}</p><table class=\"amount-table table\"><thead><tr><th class=text-left>{{\"PAYWALL_PAYMENT_AMOUNT_PAID\" | translate}}</th><th class=text-right></th></tr></thead><tbody><tr><td class=text-left>${{selectedBundle.price}}</td><td class=text-right></td></tr></tbody></table><table class=plan-table><thead><tr><th class=text-left>{{\"PAYWALL_PAYMENT_SUMMARY\" | translate}}</th><th></th></tr></thead><tbody><tr><td class=\"text-left bold-text\">{{selectedBundle.name}}</td><td class=text-right>${{selectedBundle.price}}</td></tr><tr ng-show=!!couponName><td class=\"text-left bold-text\">{{\"PAYWALL_PAYMENT_DISCOUNT\" | translate}}</td><td class=text-right>-${{savingsAmount}}</td></tr></tbody></table><div class=seperator></div><button ng-class=\"getOrganizationCss(\'continue-btn\')\" ng-click=completePayment() type=submit>{{backButtonText}}</button></div></div></div><!-- #endregion Step 3 --></div><div class=\"clearfix clear\"></div></section><div class=\"clearfix clear\"></div>");
$templateCache.put("app/common/directive/resumeUpload/user-profile-resume-upload-dialog.html","<div class=\"modal-intry user-profile-resume-upload-dialog\"><div class=\"section section-active\"><div class=title>{{\'USER_RESUME_UPLOAD_MODAL_WARNING_TITLE\' | translate}}</div><div class=subtitle>{{\'USER_RESUME_UPLOAD_MODAL_WARNING_MESSAGE_LINE_1\' | translate}}<br><div ng-if=\"userProfile.skills.length|| userProfile.educationList.length || userProfile.experienceList.length\">{{\'USER_RESUME_UPLOAD_MODAL_WARNING_MESSAGE_LINE_2\' | translate}}</div><br>{{\'USER_RESUME_UPLOAD_MODAL_WARNING_MESSAGE_LINE_4\' | translate}}<br><br>{{\'USER_RESUME_UPLOAD_MODAL_WARNING_MESSAGE_LINE_3_2\' | translate}}<br><br><span class=warning-text><span class=material-icons>warning</span><br>{{\'USER_RESUME_UPLOAD_MODAL_WARNING_MESSAGE_LINE_3\' | translate}}<br>{{\'USER_RESUME_UPLOAD_MODAL_WARNING_MESSAGE_LINE_2\' | translate}} </span><!-- <br /><br />{{\'USER_RESUME_UPLOAD_MODAL_WARNING_MESSAGE_LINE_3_1\' | translate}} --></div><div class=footer-modal><div class=\"action double\"><a ng-click=closeResumeDialog();>{{\'USER_RESUME_UPLOAD_MODAL_WARNING_BUTTON_CANCEL\' | translate}}</a> <a ng-click=uploadResume()>{{\'USER_RESUME_UPLOAD_MODAL_WARNING_BUTTON_UPLOAD\' | translate}}</a></div></div></div></div>");
$templateCache.put("app/common/service/unsave.service/unsave-confirm-modal.html","<div class=\"modal-intry resume-validation-dialog\"><button class=\"btn btn-modal-intry-dismiss\" ng-class=\"getOrganizationCss(\'btn btn-modal-intry-dismiss\')\" ng-click=closeThisDialog()></button><div class=\"section section-active\"><div class=title>{{\'UNSAVE_DATA_TITLE\' | translate}}</div><div class=subtitle>{{\'UNSAVE_DATA_MESSAGE\' | translate}}<br><br><br>{{\'UNSAVE_DATA_MESSAGE2\' | translate}}</div><div class=footer-modal><div class=\"action double\"><a ng-click=confirm()>{{\'UNSAVE_DATA_OK_BUTTON\' | translate}}</a> <a ng-click=closeThisDialog()>{{\'UNSAVE_DATA_CANCEL_BUTTON\' | translate}}</a></div></div></div></div>");
$templateCache.put("app/common/directive/widgets/ad/ad.html","<div class=\"ad-widget text-center\"><a href=https://intry.careers/experience-survey/ target=_blank></a></div>");
$templateCache.put("app/common/directive/widgets/assessments/assessments.html","<div class=widget><div class=title><div class=icon><img src=//s3.amazonaws.com/static.intry.careers/images/webapp/assessments-icon.svg></div><h4>Assessments</h4></div><div class=space-filler></div></div>");
$templateCache.put("app/common/directive/widgets/myProfile/myprofile.html","<div class=widget><div class=title><div class=icon><img src=//s3.amazonaws.com/static.intry.careers/images/webapp/profile-icon.svg></div><h4>My Profile</h4></div><div class=stats-wrapper><div class=stat><div class=graphic><div class=circle><div class=\"pie spinner\" style=\"transform: rotate(290deg)\"></div><div class=\"pie filler\" style=\"opacity: 1\"></div><div class=mask style=\"opacity: 0\"></div></div><div class=inner-text>16</div></div><div class=name>SUBMITTED RESUMES</div></div><div class=stat><div class=graphic><div class=circle><div class=\"pie spinner\" style=\"transform: rotate(360deg)\"></div><div class=\"pie filler\" style=\"opacity: 1\"></div><div class=mask style=\"opacity: 0\"></div></div><div class=inner-text>11</div></div><div class=name>COMPLETED INTERVIEWS</div></div><div class=stat><div class=graphic><div class=circle><div class=\"pie spinner\" style=\"transform: rotate(360deg)\"></div><div class=\"pie filler\" style=\"opacity: 1\"></div><div class=mask style=\"opacity: 0\"></div></div><div class=inner-text>2</div></div><div class=name>SCHEDULED INTERVIEWS</div></div><div class=stat><div class=graphic><div class=circle><div class=\"pie spinner\" style=\"transform: rotate(331deg)\"></div><div class=\"pie filler\" style=\"opacity: 1\"></div><div class=mask style=\"opacity: 0\"></div></div><div class=inner-text>92%</div></div><div class=name>PROFILE STRENGTH</div></div></div><div class=profile-cta><button><div id=rotator-text>+ What did you do at USDOD?, + What is your French speaking level?</div></button></div></div>");
$templateCache.put("app/common/directive/widgets/opportunities/opportunities.html","<div class=widget><div class=title><div class=icon><img src=//s3.amazonaws.com/static.intry.careers/images/webapp/opportunities-icon.svg></div><h4>Opportunities</h4></div><h5>Top for You</h5><div class=resumes-list><a class=resume href=javascript:;><div class=preview></div><div class=title>First resume</div><div class=status>Active</div><div class=date>Submitted</div><div class=circle></div></a><a class=resume href=javascript:;><div class=preview></div><div class=title>Resume Test</div><div class=status>Active</div><div class=date>Submitted</div><div class=circle></div></a><a class=resume href=javascript:;><div class=preview></div><div class=title>Test Item</div><div class=status>Active</div><div class=date>Submitted</div><div class=circle></div></a></div><h5>New for You</h5><div class=resumes-list><a class=resume href=javascript:;><div class=preview></div><div class=title>First resume</div><div class=status>Active</div><div class=date>Submitted</div><div class=circle></div></a><a class=resume href=javascript:;><div class=preview></div><div class=title>Resume Test</div><div class=status>Active</div><div class=date>Submitted</div><div class=circle></div></a><a class=resume href=javascript:;><div class=preview></div><div class=title>Test Item</div><div class=status>Active</div><div class=date>Submitted</div><div class=circle></div></a></div><button class=view-all>View All</button></div>");
$templateCache.put("app/common/directive/widgets/resumes/resumes.html","<div class=widget><div class=title><div class=icon><img src=//s3.amazonaws.com/static.intry.careers/images/webapp/resume-icon.svg></div><h4>Resumes</h4></div><div class=resumes-list><a class=resume href=javascript:;><div class=preview></div><div class=title>First resume</div><div class=status>Active</div><div class=date>Submitted</div><div class=circle></div></a><a class=resume href=javascript:;><div class=preview></div><div class=title>Resume Test</div><div class=status>Active</div><div class=date>Submitted</div><div class=circle></div></a><a class=resume href=javascript:;><div class=preview></div><div class=title>Test Item</div><div class=status>Active</div><div class=date>Submitted</div><div class=circle></div></a></div><button class=view-all>View All</button></div>");}]);